{
  "schemaVersion": 1,
  "sources": [
    {
      "provider": "openai",
      "repository": "openai/plugins",
      "revision": "d416fd5a43426019986b1e489506db3db66dee3d",
      "indexUrl": "https://raw.githubusercontent.com/openai/plugins/d416fd5a43426019986b1e489506db3db66dee3d/.agents/plugins/marketplace.json",
      "entries": [
        {
          "id": "openai:linear",
          "name": "linear",
          "displayName": "Linear",
          "description": "Plan and build products",
          "longDescription": "Manage issues, projects, and team workflows in Linear from Codex.",
          "category": "Productivity",
          "keywords": [],
          "author": {
            "name": "Linear Orbit, Inc",
            "url": "https://linear.app/"
          },
          "version": "5.0.1",
          "license": "MIT",
          "logoUrl": "https://raw.githubusercontent.com/openai/plugins/d416fd5a43426019986b1e489506db3db66dee3d/plugins/linear/assets/logo.png",
          "darkLogoUrl": null,
          "homepage": "https://linear.app/",
          "sourceUrl": "https://github.com/openai/plugins/tree/d416fd5a43426019986b1e489506db3db66dee3d/plugins/linear",
          "skills": [],
          "mcpServers": [
            {
              "requiresConfiguration": false,
              "name": "linear",
              "transport": "http",
              "endpoint": "https://mcp.linear.app/mcp"
            }
          ],
          "components": ["mcp", "apps"],
          "componentInspection": "repository",
          "inspectionError": null,
          "installation": "requires_adapter",
          "upstream": {
            "source": {
              "source": "local",
              "path": "./plugins/linear"
            },
            "policy": {
              "installation": "AVAILABLE",
              "authentication": "ON_INSTALL"
            }
          }
        },
        {
          "id": "openai:atlassian-rovo",
          "name": "atlassian-rovo",
          "displayName": "Atlassian Rovo",
          "description": "Manage Jira and Confluence",
          "longDescription": "Manage Jira and Confluence fast",
          "category": "Productivity",
          "keywords": [
            "atlassian",
            "rovo",
            "jira",
            "confluence",
            "issue tracking",
            "project management",
            "knowledge base"
          ],
          "author": {
            "name": "Atlassian",
            "url": "https://www.atlassian.com"
          },
          "version": "1.0.6",
          "license": "MIT",
          "logoUrl": "https://raw.githubusercontent.com/openai/plugins/d416fd5a43426019986b1e489506db3db66dee3d/plugins/atlassian-rovo/assets/logo.png",
          "darkLogoUrl": "https://raw.githubusercontent.com/openai/plugins/d416fd5a43426019986b1e489506db3db66dee3d/plugins/atlassian-rovo/assets/logo-dark.png",
          "homepage": "https://www.atlassian.com",
          "sourceUrl": "https://github.com/openai/plugins/tree/d416fd5a43426019986b1e489506db3db66dee3d/plugins/atlassian-rovo",
          "skills": [],
          "mcpServers": [
            {
              "requiresConfiguration": false,
              "name": "atlassian-rovo",
              "transport": "http",
              "endpoint": "https://mcp.atlassian.com/v1/mcp/authv2"
            }
          ],
          "components": ["mcp", "apps", "agents"],
          "componentInspection": "repository",
          "inspectionError": null,
          "installation": "requires_adapter",
          "upstream": {
            "source": {
              "source": "local",
              "path": "./plugins/atlassian-rovo"
            },
            "policy": {
              "installation": "AVAILABLE",
              "authentication": "ON_INSTALL"
            }
          }
        },
        {
          "id": "openai:google-calendar",
          "name": "google-calendar",
          "displayName": "Google Calendar",
          "description": "Manage Google Calendar events",
          "longDescription": "Use Google Calendar to summarize a day, check availability, list calendars, and create, update, or delete events directly from task prompts.",
          "category": "Productivity",
          "keywords": [
            "google-calendar",
            "google",
            "google workspace",
            "calendar",
            "events",
            "meetings",
            "availability",
            "agenda",
            "daily-brief",
            "scheduling",
            "productivity"
          ],
          "author": {
            "name": "OpenAI",
            "email": "support@openai.com",
            "url": "https://openai.com/"
          },
          "version": "1.2.6",
          "license": "MIT",
          "logoUrl": "https://raw.githubusercontent.com/openai/plugins/d416fd5a43426019986b1e489506db3db66dee3d/plugins/google-calendar/assets/logo.png",
          "darkLogoUrl": null,
          "homepage": "https://workspace.google.com/products/calendar/",
          "sourceUrl": "https://github.com/openai/plugins/tree/d416fd5a43426019986b1e489506db3db66dee3d/plugins/google-calendar",
          "skills": [],
          "mcpServers": [
            {
              "requiresConfiguration": false,
              "name": "google-calendar",
              "transport": "http",
              "endpoint": "https://calendarmcp.googleapis.com/mcp/v1"
            }
          ],
          "components": ["mcp", "apps"],
          "componentInspection": "repository",
          "inspectionError": null,
          "installation": "requires_adapter",
          "upstream": {
            "source": {
              "source": "local",
              "path": "./plugins/google-calendar"
            },
            "policy": {
              "installation": "AVAILABLE",
              "authentication": "ON_INSTALL"
            }
          }
        },
        {
          "id": "openai:gmail",
          "name": "gmail",
          "displayName": "Gmail",
          "description": "Read and manage Gmail",
          "longDescription": "Use Gmail to summarize inbox activity, draft replies, and organize email threads through the connected Gmail app.",
          "category": "Communication",
          "keywords": [
            "gmail",
            "email",
            "google",
            "google workspace",
            "mail",
            "inbox",
            "threads",
            "drafts"
          ],
          "author": {
            "name": "OpenAI",
            "email": "support@openai.com",
            "url": "https://openai.com/"
          },
          "version": "0.1.9",
          "license": "MIT",
          "logoUrl": "https://raw.githubusercontent.com/openai/plugins/d416fd5a43426019986b1e489506db3db66dee3d/plugins/gmail/assets/gmail.png",
          "darkLogoUrl": null,
          "homepage": "https://workspace.google.com/products/gmail/",
          "sourceUrl": "https://github.com/openai/plugins/tree/d416fd5a43426019986b1e489506db3db66dee3d/plugins/gmail",
          "skills": [],
          "mcpServers": [
            {
              "requiresConfiguration": false,
              "name": "gmail",
              "transport": "http",
              "endpoint": "https://gmailmcp.googleapis.com/mcp/v1"
            }
          ],
          "components": ["mcp", "apps"],
          "componentInspection": "repository",
          "inspectionError": null,
          "installation": "requires_adapter",
          "upstream": {
            "source": {
              "source": "local",
              "path": "./plugins/gmail"
            },
            "policy": {
              "installation": "AVAILABLE",
              "authentication": "ON_INSTALL"
            }
          }
        },
        {
          "id": "openai:slack",
          "name": "slack",
          "displayName": "Slack",
          "description": "Read and manage Slack",
          "longDescription": "Use Slack to summarize channels, draft messages, and organize team conversations through the connected Slack integration.",
          "category": "Communication",
          "keywords": [
            "slack",
            "salesforce",
            "chat",
            "collaboration",
            "messaging",
            "channels",
            "threads",
            "workplace chat"
          ],
          "author": {
            "email": "support@openai.com",
            "name": "Slack",
            "url": "https://openai.com/"
          },
          "version": "0.1.7",
          "license": "MIT",
          "logoUrl": "https://raw.githubusercontent.com/openai/plugins/d416fd5a43426019986b1e489506db3db66dee3d/plugins/slack/assets/logo.png",
          "darkLogoUrl": null,
          "homepage": "https://slack.com/",
          "sourceUrl": "https://github.com/openai/plugins/tree/d416fd5a43426019986b1e489506db3db66dee3d/plugins/slack",
          "skills": [],
          "mcpServers": [
            {
              "requiresConfiguration": false,
              "name": "slack",
              "transport": "http",
              "endpoint": "https://mcp.slack.com/mcp"
            }
          ],
          "components": ["mcp", "apps"],
          "componentInspection": "repository",
          "inspectionError": null,
          "installation": "requires_adapter",
          "upstream": {
            "source": {
              "source": "local",
              "path": "./plugins/slack"
            },
            "policy": {
              "installation": "AVAILABLE",
              "authentication": "ON_INSTALL"
            }
          }
        },
        {
          "id": "openai:teams",
          "name": "teams",
          "displayName": "Teams",
          "description": "Summarize Teams and follow up",
          "longDescription": "Use Teams to summarize chats, extract actions, and draft channel or meeting follow-ups through the connected Microsoft Teams app.",
          "category": "Communication",
          "keywords": [
            "teams",
            "microsoft teams",
            "chat",
            "microsoft",
            "microsoft 365",
            "office 365",
            "meetings",
            "messages",
            "channels",
            "video conferencing"
          ],
          "author": {
            "name": "OpenAI",
            "email": "support@openai.com",
            "url": "https://openai.com/"
          },
          "version": "0.1.8",
          "license": "MIT",
          "logoUrl": "https://raw.githubusercontent.com/openai/plugins/d416fd5a43426019986b1e489506db3db66dee3d/plugins/teams/assets/logo.png",
          "darkLogoUrl": null,
          "homepage": "https://www.microsoft.com/en-us/microsoft-teams/group-chat-software",
          "sourceUrl": "https://github.com/openai/plugins/tree/d416fd5a43426019986b1e489506db3db66dee3d/plugins/teams",
          "skills": [],
          "mcpServers": [],
          "components": ["apps"],
          "componentInspection": "repository",
          "inspectionError": null,
          "installation": "requires_adapter",
          "upstream": {
            "source": {
              "source": "local",
              "path": "./plugins/teams"
            },
            "policy": {
              "installation": "AVAILABLE",
              "authentication": "ON_INSTALL"
            }
          }
        },
        {
          "id": "openai:sharepoint",
          "name": "sharepoint",
          "displayName": "SharePoint",
          "description": "Summarize SharePoint content",
          "longDescription": "Use SharePoint to summarize sites, pages, and files, extract owners and status, and plan safe content updates through the connected Microsoft SharePoint app.",
          "category": "Productivity",
          "keywords": [
            "sharepoint",
            "documents",
            "microsoft",
            "microsoft 365",
            "office 365",
            "onedrive",
            "files",
            "intranet",
            "collaboration"
          ],
          "author": {
            "name": "OpenAI",
            "email": "support@openai.com",
            "url": "https://openai.com/"
          },
          "version": "0.1.7",
          "license": "MIT",
          "logoUrl": "https://raw.githubusercontent.com/openai/plugins/d416fd5a43426019986b1e489506db3db66dee3d/plugins/sharepoint/assets/logo.png",
          "darkLogoUrl": null,
          "homepage": "https://www.microsoft.com/en-us/microsoft-365/sharepoint/collaboration",
          "sourceUrl": "https://github.com/openai/plugins/tree/d416fd5a43426019986b1e489506db3db66dee3d/plugins/sharepoint",
          "skills": [],
          "mcpServers": [],
          "components": ["apps"],
          "componentInspection": "repository",
          "inspectionError": null,
          "installation": "requires_adapter",
          "upstream": {
            "source": {
              "source": "local",
              "path": "./plugins/sharepoint"
            },
            "policy": {
              "installation": "AVAILABLE",
              "authentication": "ON_INSTALL"
            }
          }
        },
        {
          "id": "openai:outlook-email",
          "name": "outlook-email",
          "displayName": "Outlook Email",
          "description": "Triage Outlook inboxes",
          "longDescription": "Use Outlook Email to triage inboxes, summarize threads, extract actions, and draft replies or forwards through the connected Microsoft Outlook app.",
          "category": "Communication",
          "keywords": [
            "outlook-email",
            "outlook",
            "email",
            "microsoft",
            "microsoft 365",
            "office 365",
            "exchange",
            "mail",
            "inbox"
          ],
          "author": {
            "name": "OpenAI",
            "email": "support@openai.com",
            "url": "https://openai.com/"
          },
          "version": "0.1.7",
          "license": "MIT",
          "logoUrl": "https://raw.githubusercontent.com/openai/plugins/d416fd5a43426019986b1e489506db3db66dee3d/plugins/outlook-email/assets/logo.png",
          "darkLogoUrl": null,
          "homepage": "https://www.microsoft.com/en-us/microsoft-365/outlook/email-and-calendar-software-microsoft-outlook",
          "sourceUrl": "https://github.com/openai/plugins/tree/d416fd5a43426019986b1e489506db3db66dee3d/plugins/outlook-email",
          "skills": [],
          "mcpServers": [],
          "components": ["apps"],
          "componentInspection": "repository",
          "inspectionError": null,
          "installation": "requires_adapter",
          "upstream": {
            "source": {
              "source": "local",
              "path": "./plugins/outlook-email"
            },
            "policy": {
              "installation": "AVAILABLE",
              "authentication": "ON_INSTALL"
            }
          }
        },
        {
          "id": "openai:outlook-calendar",
          "name": "outlook-calendar",
          "displayName": "Outlook Calendar",
          "description": "Manage Outlook schedules",
          "longDescription": "Use Outlook Calendar to summarize a day, compare availability, prepare for meetings, explain Outlook status semantics, and schedule, reschedule, or cancel events through the connected Microsoft Outlook app.",
          "category": "Productivity",
          "keywords": [
            "outlook-calendar",
            "outlook",
            "calendar",
            "microsoft",
            "microsoft 365",
            "office 365",
            "exchange",
            "events",
            "meetings",
            "availability",
            "scheduling",
            "teams",
            "daily-brief",
            "meeting-prep"
          ],
          "author": {
            "name": "OpenAI",
            "email": "support@openai.com",
            "url": "https://openai.com/"
          },
          "version": "0.1.8",
          "license": "MIT",
          "logoUrl": "https://raw.githubusercontent.com/openai/plugins/d416fd5a43426019986b1e489506db3db66dee3d/plugins/outlook-calendar/assets/logo.png",
          "darkLogoUrl": null,
          "homepage": "https://www.microsoft.com/en-us/microsoft-365/outlook/calendar-app",
          "sourceUrl": "https://github.com/openai/plugins/tree/d416fd5a43426019986b1e489506db3db66dee3d/plugins/outlook-calendar",
          "skills": [],
          "mcpServers": [],
          "components": ["apps"],
          "componentInspection": "repository",
          "inspectionError": null,
          "installation": "requires_adapter",
          "upstream": {
            "source": {
              "source": "local",
              "path": "./plugins/outlook-calendar"
            },
            "policy": {
              "installation": "AVAILABLE",
              "authentication": "ON_INSTALL"
            }
          }
        },
        {
          "id": "openai:canva",
          "name": "canva",
          "displayName": "Canva",
          "description": "Create, review, edit designs",
          "longDescription": "Bring your Canva design workflow into Codex and create, refine, and review designs through natural conversation.\nAvailable skills:\nResize for social media: Adapt a design for Facebook, Instagram, and LinkedIn in one step.\nBulk create: Generate multiple designs from spreadsheet data using a brand template.\nEdit designs: Update text, media, and formatting, or reposition and resize elements.\nGet design feedback: Receive structured feedback on visual hierarchy, layout, readability, consistency, and accessibility.\nImplement feedback: Review comment threads and apply clear, actionable changes.\nBrand check: Check colors, fonts, logo usage, and copy against your Brand Kit.\nOnce installed, describe what you want in plain language or invoke Canva directly with @Canva.\nTry prompts like:\n- @Canva, resize this design for social media.\n- @Canva, create designs from this spreadsheet using my brand template.\n- @Canva, update the headline in this design.\n- @Canva, review this design’s visual hierarchy and readability.\n- @Canva, implement the feedback in the comment threads.\n- @Canva, check this design against my Brand Kit.\n\nRequirements: Connect your Canva account to use the plugin. Bulk Create requires an eligible Canva Enterprise plan.\n\nWant to take a more hands-on approach? Instantly open your design in Canva’s powerful editor for the final touches.",
          "category": "Creativity",
          "keywords": [],
          "author": {
            "name": "Canva Pty Ltd."
          },
          "version": "14.0.0",
          "license": null,
          "logoUrl": "https://raw.githubusercontent.com/openai/plugins/d416fd5a43426019986b1e489506db3db66dee3d/plugins/canva/assets/logo.png",
          "darkLogoUrl": null,
          "homepage": null,
          "sourceUrl": "https://github.com/openai/plugins/tree/d416fd5a43426019986b1e489506db3db66dee3d/plugins/canva",
          "skills": [
            {
              "name": "canva-brand-check",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/canva/skills/canva-brand-check/SKILL.md"
            },
            {
              "name": "canva-branded-presentation",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/canva/skills/canva-branded-presentation/SKILL.md"
            },
            {
              "name": "canva-bulk-create",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/canva/skills/canva-bulk-create/SKILL.md"
            },
            {
              "name": "canva-design-feedback",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/canva/skills/canva-design-feedback/SKILL.md"
            },
            {
              "name": "canva-edit-design",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/canva/skills/canva-edit-design/SKILL.md"
            },
            {
              "name": "canva-implement-feedback",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/canva/skills/canva-implement-feedback/SKILL.md"
            },
            {
              "name": "canva-resize-for-social-media",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/canva/skills/canva-resize-for-social-media/SKILL.md"
            },
            {
              "name": "canva-translate-design",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/canva/skills/canva-translate-design/SKILL.md"
            }
          ],
          "mcpServers": [
            {
              "requiresConfiguration": false,
              "name": "canva",
              "transport": "http",
              "endpoint": "https://mcp.canva.com/mcp"
            }
          ],
          "components": ["skills", "mcp", "apps"],
          "componentInspection": "repository",
          "inspectionError": null,
          "installation": "requires_adapter",
          "upstream": {
            "source": {
              "source": "local",
              "path": "./plugins/canva"
            },
            "policy": {
              "installation": "AVAILABLE",
              "authentication": "ON_INSTALL"
            }
          }
        },
        {
          "id": "openai:figma",
          "name": "figma",
          "displayName": "Figma",
          "description": "Figma design-to-code workflows",
          "longDescription": "Figma workflows for implementing designs in code, creating Code Connect templates for published Figma components, and generating project-specific design system rules for repeatable Figma-to-code work.",
          "category": "Creativity",
          "keywords": [
            "figma",
            "design",
            "prototyping",
            "collaboration",
            "developer handoff",
            "design systems",
            "design-to-code",
            "ui-implementation",
            "code-connect",
            "design-system"
          ],
          "author": {
            "name": "Figma",
            "url": "https://www.figma.com"
          },
          "version": "2.0.20",
          "license": "LicenseRef-Figma-Developer-Terms",
          "logoUrl": "https://raw.githubusercontent.com/openai/plugins/d416fd5a43426019986b1e489506db3db66dee3d/plugins/figma/assets/logo-padded.png",
          "darkLogoUrl": "https://raw.githubusercontent.com/openai/plugins/d416fd5a43426019986b1e489506db3db66dee3d/plugins/figma/assets/logo-padded.png",
          "homepage": "https://www.figma.com",
          "sourceUrl": "https://github.com/openai/plugins/tree/d416fd5a43426019986b1e489506db3db66dee3d/plugins/figma",
          "skills": [
            {
              "name": "figma-code-connect",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/figma/skills/figma-code-connect/SKILL.md"
            },
            {
              "name": "figma-create-new-file",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/figma/skills/figma-create-new-file/SKILL.md"
            },
            {
              "name": "figma-design-to-code",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/figma/skills/figma-design-to-code/SKILL.md"
            },
            {
              "name": "figma-generate-design",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/figma/skills/figma-generate-design/SKILL.md"
            },
            {
              "name": "figma-generate-diagram",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/figma/skills/figma-generate-diagram/SKILL.md"
            },
            {
              "name": "figma-generate-library",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/figma/skills/figma-generate-library/SKILL.md"
            },
            {
              "name": "figma-implement-motion",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/figma/skills/figma-implement-motion/SKILL.md"
            },
            {
              "name": "figma-swiftui",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/figma/skills/figma-swiftui/SKILL.md"
            },
            {
              "name": "figma-use-figjam",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/figma/skills/figma-use-figjam/SKILL.md"
            },
            {
              "name": "figma-use-motion",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/figma/skills/figma-use-motion/SKILL.md"
            },
            {
              "name": "figma-use-slides",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/figma/skills/figma-use-slides/SKILL.md"
            },
            {
              "name": "figma-use",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/figma/skills/figma-use/SKILL.md"
            }
          ],
          "mcpServers": [
            {
              "requiresConfiguration": false,
              "name": "figma",
              "transport": "http",
              "endpoint": "https://mcp.figma.com/mcp"
            }
          ],
          "components": ["skills", "mcp", "apps", "agents", "commands"],
          "componentInspection": "repository",
          "inspectionError": null,
          "installation": "requires_adapter",
          "upstream": {
            "source": {
              "source": "local",
              "path": "./plugins/figma"
            },
            "policy": {
              "installation": "AVAILABLE",
              "authentication": "ON_INSTALL"
            }
          }
        },
        {
          "id": "openai:stripe",
          "name": "stripe",
          "displayName": "Stripe",
          "description": "Accept payments. Grow revenue.",
          "longDescription": "Develop your payments integration faster with the ability to create products, prices, and payment links directly in ChatGPT. Run your business from ChatGPT with the ability to retrieve and manage payments, subscriptions, invoices, refunds, disputes, and customers. Build and debug your payment integration quicker than ever by searching the Stripe documentation and getting integration recommendations without needing to leave ChatGPT.",
          "category": "Finance",
          "keywords": [],
          "author": {
            "name": "Stripe"
          },
          "version": "7.0.0",
          "license": null,
          "logoUrl": "https://raw.githubusercontent.com/openai/plugins/d416fd5a43426019986b1e489506db3db66dee3d/plugins/stripe/assets/logo.png",
          "darkLogoUrl": null,
          "homepage": null,
          "sourceUrl": "https://github.com/openai/plugins/tree/d416fd5a43426019986b1e489506db3db66dee3d/plugins/stripe",
          "skills": [
            {
              "name": "connect-recommend",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/stripe/skills/connect-recommend/SKILL.md"
            },
            {
              "name": "stripe-apps",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/stripe/skills/stripe-apps/SKILL.md"
            },
            {
              "name": "stripe-best-practices",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/stripe/skills/stripe-best-practices/SKILL.md"
            },
            {
              "name": "stripe-directory",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/stripe/skills/stripe-directory/SKILL.md"
            },
            {
              "name": "stripe-docs",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/stripe/skills/stripe-docs/SKILL.md"
            },
            {
              "name": "stripe-projects",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/stripe/skills/stripe-projects/SKILL.md"
            },
            {
              "name": "upgrade-stripe",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/stripe/skills/upgrade-stripe/SKILL.md"
            }
          ],
          "mcpServers": [
            {
              "requiresConfiguration": false,
              "name": "stripe",
              "transport": "http",
              "endpoint": "https://mcp.stripe.com"
            }
          ],
          "components": ["skills", "mcp", "apps"],
          "componentInspection": "repository",
          "inspectionError": null,
          "installation": "requires_adapter",
          "upstream": {
            "source": {
              "source": "local",
              "path": "./plugins/stripe"
            },
            "policy": {
              "installation": "AVAILABLE",
              "authentication": "ON_INSTALL"
            }
          }
        },
        {
          "id": "openai:vercel",
          "name": "vercel",
          "displayName": "Vercel",
          "description": "Build and deploy web apps and agents",
          "longDescription": "Bring Vercel ecosystem guidance into Codex with curated skills and the connected Vercel app. Packages the upstream vercel/vercel-plugin skills, agents, and commands under the local `vercel` plugin identity for the Codex plugin marketplace.",
          "category": "Developer Tools",
          "keywords": [
            "vercel",
            "nextjs",
            "ai-sdk",
            "turborepo",
            "turbopack",
            "workflow",
            "deployment",
            "edge-functions",
            "serverless",
            "ai-gateway",
            "chat-sdk",
            "chat-bot",
            "slack-bot",
            "discord-bot"
          ],
          "author": {
            "name": "Vercel Labs",
            "url": "https://github.com/vercel"
          },
          "version": "0.21.4",
          "license": "Apache-2.0",
          "logoUrl": "https://raw.githubusercontent.com/openai/plugins/d416fd5a43426019986b1e489506db3db66dee3d/plugins/vercel/assets/logo.png",
          "darkLogoUrl": null,
          "homepage": "https://vercel.com/",
          "sourceUrl": "https://github.com/openai/plugins/tree/d416fd5a43426019986b1e489506db3db66dee3d/plugins/vercel",
          "skills": [
            {
              "name": "agent-browser-verify",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/vercel/skills/agent-browser-verify/SKILL.md"
            },
            {
              "name": "agent-browser",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/vercel/skills/agent-browser/SKILL.md"
            },
            {
              "name": "ai-elements",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/vercel/skills/ai-elements/SKILL.md"
            },
            {
              "name": "ai-gateway",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/vercel/skills/ai-gateway/SKILL.md"
            },
            {
              "name": "ai-generation-persistence",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/vercel/skills/ai-generation-persistence/SKILL.md"
            },
            {
              "name": "ai-sdk",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/vercel/skills/ai-sdk/SKILL.md"
            },
            {
              "name": "auth",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/vercel/skills/auth/SKILL.md"
            },
            {
              "name": "bootstrap",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/vercel/skills/bootstrap/SKILL.md"
            },
            {
              "name": "cdn-caching",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/vercel/skills/cdn-caching/SKILL.md"
            },
            {
              "name": "chat-sdk",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/vercel/skills/chat-sdk/SKILL.md"
            },
            {
              "name": "cms",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/vercel/skills/cms/SKILL.md"
            },
            {
              "name": "cron-jobs",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/vercel/skills/cron-jobs/SKILL.md"
            },
            {
              "name": "deployments-cicd",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/vercel/skills/deployments-cicd/SKILL.md"
            },
            {
              "name": "email",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/vercel/skills/email/SKILL.md"
            },
            {
              "name": "env-vars",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/vercel/skills/env-vars/SKILL.md"
            },
            {
              "name": "eve",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/vercel/skills/eve/SKILL.md"
            },
            {
              "name": "geist",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/vercel/skills/geist/SKILL.md"
            },
            {
              "name": "geistdocs",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/vercel/skills/geistdocs/SKILL.md"
            },
            {
              "name": "investigation-mode",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/vercel/skills/investigation-mode/SKILL.md"
            },
            {
              "name": "json-render",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/vercel/skills/json-render/SKILL.md"
            },
            {
              "name": "knowledge-update",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/vercel/skills/knowledge-update/SKILL.md"
            },
            {
              "name": "marketplace",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/vercel/skills/marketplace/SKILL.md"
            },
            {
              "name": "micro",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/vercel/skills/micro/SKILL.md"
            },
            {
              "name": "microfrontends",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/vercel/skills/microfrontends/SKILL.md"
            },
            {
              "name": "ncc",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/vercel/skills/ncc/SKILL.md"
            },
            {
              "name": "next-cache-components",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/vercel/skills/next-cache-components/SKILL.md"
            },
            {
              "name": "next-forge",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/vercel/skills/next-forge/SKILL.md"
            },
            {
              "name": "next-upgrade",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/vercel/skills/next-upgrade/SKILL.md"
            },
            {
              "name": "nextjs",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/vercel/skills/nextjs/SKILL.md"
            },
            {
              "name": "observability",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/vercel/skills/observability/SKILL.md"
            },
            {
              "name": "payments",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/vercel/skills/payments/SKILL.md"
            },
            {
              "name": "react-best-practices",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/vercel/skills/react-best-practices/SKILL.md"
            },
            {
              "name": "routing-middleware",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/vercel/skills/routing-middleware/SKILL.md"
            },
            {
              "name": "runtime-cache",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/vercel/skills/runtime-cache/SKILL.md"
            },
            {
              "name": "satori",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/vercel/skills/satori/SKILL.md"
            },
            {
              "name": "shadcn",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/vercel/skills/shadcn/SKILL.md"
            },
            {
              "name": "sign-in-with-vercel",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/vercel/skills/sign-in-with-vercel/SKILL.md"
            },
            {
              "name": "swr",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/vercel/skills/swr/SKILL.md"
            },
            {
              "name": "turbopack",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/vercel/skills/turbopack/SKILL.md"
            },
            {
              "name": "turborepo",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/vercel/skills/turborepo/SKILL.md"
            },
            {
              "name": "v0-dev",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/vercel/skills/v0-dev/SKILL.md"
            },
            {
              "name": "vercel-agent",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/vercel/skills/vercel-agent/SKILL.md"
            },
            {
              "name": "vercel-api",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/vercel/skills/vercel-api/SKILL.md"
            },
            {
              "name": "vercel-cli",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/vercel/skills/vercel-cli/SKILL.md"
            },
            {
              "name": "vercel-connect",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/vercel/skills/vercel-connect/SKILL.md"
            },
            {
              "name": "vercel-firewall",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/vercel/skills/vercel-firewall/SKILL.md"
            },
            {
              "name": "vercel-flags",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/vercel/skills/vercel-flags/SKILL.md"
            },
            {
              "name": "vercel-functions",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/vercel/skills/vercel-functions/SKILL.md"
            },
            {
              "name": "vercel-queues",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/vercel/skills/vercel-queues/SKILL.md"
            },
            {
              "name": "vercel-sandbox",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/vercel/skills/vercel-sandbox/SKILL.md"
            },
            {
              "name": "vercel-services",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/vercel/skills/vercel-services/SKILL.md"
            },
            {
              "name": "vercel-storage",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/vercel/skills/vercel-storage/SKILL.md"
            },
            {
              "name": "verification",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/vercel/skills/verification/SKILL.md"
            },
            {
              "name": "workflow",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/vercel/skills/workflow/SKILL.md"
            }
          ],
          "mcpServers": [
            {
              "requiresConfiguration": false,
              "name": "vercel",
              "transport": "http",
              "endpoint": "https://mcp.vercel.com"
            }
          ],
          "components": ["skills", "mcp", "apps", "agents", "commands"],
          "componentInspection": "repository",
          "inspectionError": null,
          "installation": "requires_adapter",
          "upstream": {
            "source": {
              "source": "local",
              "path": "./plugins/vercel"
            },
            "policy": {
              "installation": "AVAILABLE",
              "authentication": "ON_INSTALL"
            }
          }
        },
        {
          "id": "openai:game-studio",
          "name": "game-studio",
          "displayName": "Game Studio",
          "description": "Design, prototype, and ship browser games",
          "longDescription": "Plan, prototype, and build browser games with guided workflows for gameplay systems, UI, asset pipelines, and playtesting across 2D and 3D projects.",
          "category": "Developer Tools",
          "keywords": [
            "games",
            "phaser",
            "threejs",
            "react-three-fiber",
            "gltf",
            "rapier",
            "webgl",
            "sprites",
            "playtest"
          ],
          "author": {
            "name": "OpenAI",
            "email": "support@openai.com",
            "url": "https://openai.com/"
          },
          "version": "0.1.2",
          "license": "MIT",
          "logoUrl": "https://raw.githubusercontent.com/openai/plugins/d416fd5a43426019986b1e489506db3db66dee3d/plugins/game-studio/assets/app-icon.png",
          "darkLogoUrl": null,
          "homepage": "https://openai.com/",
          "sourceUrl": "https://github.com/openai/plugins/tree/d416fd5a43426019986b1e489506db3db66dee3d/plugins/game-studio",
          "skills": [
            {
              "name": "game-playtest",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/game-studio/skills/game-playtest/SKILL.md"
            },
            {
              "name": "game-studio",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/game-studio/skills/game-studio/SKILL.md"
            },
            {
              "name": "game-ui-frontend",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/game-studio/skills/game-ui-frontend/SKILL.md"
            },
            {
              "name": "phaser-2d-game",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/game-studio/skills/phaser-2d-game/SKILL.md"
            },
            {
              "name": "react-three-fiber-game",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/game-studio/skills/react-three-fiber-game/SKILL.md"
            },
            {
              "name": "sprite-pipeline",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/game-studio/skills/sprite-pipeline/SKILL.md"
            },
            {
              "name": "three-webgl-game",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/game-studio/skills/three-webgl-game/SKILL.md"
            },
            {
              "name": "web-3d-asset-pipeline",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/game-studio/skills/web-3d-asset-pipeline/SKILL.md"
            },
            {
              "name": "web-game-foundations",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/game-studio/skills/web-game-foundations/SKILL.md"
            }
          ],
          "mcpServers": [],
          "components": ["skills"],
          "componentInspection": "repository",
          "inspectionError": null,
          "installation": "requires_adapter",
          "upstream": {
            "source": {
              "source": "local",
              "path": "./plugins/game-studio"
            },
            "policy": {
              "installation": "AVAILABLE",
              "authentication": "ON_INSTALL",
              "products": ["CODEX"]
            }
          }
        },
        {
          "id": "openai:superpowers",
          "name": "superpowers",
          "displayName": "Superpowers",
          "description": "Plan, develop, and debug code",
          "longDescription": "Use Superpowers to guide agent work through brainstorming, implementation planning, test-driven development, systematic debugging, parallel execution, code review, and finish-the-branch workflows.",
          "category": "Developer Tools",
          "keywords": [
            "brainstorming",
            "subagent-driven-development",
            "skills",
            "planning",
            "tdd",
            "debugging",
            "code-review",
            "workflow"
          ],
          "author": {
            "email": "jesse@fsck.com",
            "name": "Jesse Vincent",
            "url": "https://github.com/obra"
          },
          "version": "6.3.0",
          "license": "MIT",
          "logoUrl": "https://raw.githubusercontent.com/openai/plugins/d416fd5a43426019986b1e489506db3db66dee3d/plugins/superpowers/.codex-plugin/assets/logo.png",
          "darkLogoUrl": null,
          "homepage": "https://github.com/obra/superpowers",
          "sourceUrl": "https://github.com/openai/plugins/tree/d416fd5a43426019986b1e489506db3db66dee3d/plugins/superpowers",
          "skills": [
            {
              "name": "brainstorming",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/superpowers/skills/brainstorming/SKILL.md"
            },
            {
              "name": "dispatching-parallel-agents",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/superpowers/skills/dispatching-parallel-agents/SKILL.md"
            },
            {
              "name": "executing-plans",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/superpowers/skills/executing-plans/SKILL.md"
            },
            {
              "name": "finishing-a-development-branch",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/superpowers/skills/finishing-a-development-branch/SKILL.md"
            },
            {
              "name": "receiving-code-review",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/superpowers/skills/receiving-code-review/SKILL.md"
            },
            {
              "name": "requesting-code-review",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/superpowers/skills/requesting-code-review/SKILL.md"
            },
            {
              "name": "subagent-driven-development",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/superpowers/skills/subagent-driven-development/SKILL.md"
            },
            {
              "name": "systematic-debugging",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/superpowers/skills/systematic-debugging/SKILL.md"
            },
            {
              "name": "test-driven-development",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/superpowers/skills/test-driven-development/SKILL.md"
            },
            {
              "name": "using-git-worktrees",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/superpowers/skills/using-git-worktrees/SKILL.md"
            },
            {
              "name": "using-superpowers",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/superpowers/skills/using-superpowers/SKILL.md"
            },
            {
              "name": "verification-before-completion",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/superpowers/skills/verification-before-completion/SKILL.md"
            },
            {
              "name": "writing-plans",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/superpowers/skills/writing-plans/SKILL.md"
            },
            {
              "name": "writing-skills",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/superpowers/skills/writing-skills/SKILL.md"
            }
          ],
          "mcpServers": [],
          "components": ["skills"],
          "componentInspection": "repository",
          "inspectionError": null,
          "installation": "requires_adapter",
          "upstream": {
            "source": {
              "source": "local",
              "path": "./plugins/superpowers"
            },
            "policy": {
              "installation": "AVAILABLE",
              "authentication": "ON_INSTALL",
              "products": ["CODEX"]
            }
          }
        },
        {
          "id": "openai:github",
          "name": "github",
          "displayName": "GitHub",
          "description": "Triage PRs, issues, CI, and publish flows",
          "longDescription": "Use GitHub to inspect repositories, review pull requests, address feedback, debug failing Actions checks, and prepare code changes for review through a connector-first workflow with targeted CLI fallbacks.",
          "category": "Developer Tools",
          "keywords": [
            "github",
            "microsoft",
            "git",
            "repositories",
            "source control",
            "pull requests",
            "github actions",
            "ci/cd",
            "pull-request",
            "code-review",
            "issues",
            "ci",
            "actions"
          ],
          "author": {
            "name": "OpenAI",
            "email": "support@openai.com",
            "url": "https://openai.com/"
          },
          "version": "0.1.11",
          "license": "MIT",
          "logoUrl": "https://raw.githubusercontent.com/openai/plugins/d416fd5a43426019986b1e489506db3db66dee3d/plugins/github/assets/github.png",
          "darkLogoUrl": "https://raw.githubusercontent.com/openai/plugins/d416fd5a43426019986b1e489506db3db66dee3d/plugins/github/assets/github-dark.png",
          "homepage": "https://github.com/",
          "sourceUrl": "https://github.com/openai/plugins/tree/d416fd5a43426019986b1e489506db3db66dee3d/plugins/github",
          "skills": [],
          "mcpServers": [
            {
              "requiresConfiguration": false,
              "name": "github",
              "transport": "http",
              "endpoint": "https://api.githubcopilot.com/mcp/"
            }
          ],
          "components": ["mcp", "apps"],
          "componentInspection": "repository",
          "inspectionError": null,
          "installation": "requires_adapter",
          "upstream": {
            "source": {
              "source": "local",
              "path": "./plugins/github"
            },
            "policy": {
              "installation": "AVAILABLE",
              "authentication": "ON_INSTALL"
            }
          }
        },
        {
          "id": "openai:circleci",
          "name": "circleci",
          "displayName": "CircleCI",
          "description": "Build, test, and deploy any application",
          "longDescription": "Bring testing, deployment, and CI best practices into Codex",
          "category": "Developer Tools",
          "keywords": ["circleci", "ci/cd", "ci"],
          "author": {
            "name": "CircleCI",
            "url": "https://circleci.com"
          },
          "version": "1.0.4",
          "license": "MIT",
          "logoUrl": "https://raw.githubusercontent.com/openai/plugins/d416fd5a43426019986b1e489506db3db66dee3d/plugins/circleci/assets/logo.png",
          "darkLogoUrl": "https://raw.githubusercontent.com/openai/plugins/d416fd5a43426019986b1e489506db3db66dee3d/plugins/circleci/assets/logo-dark.png",
          "homepage": "https://circleci.com",
          "sourceUrl": "https://github.com/openai/plugins/tree/d416fd5a43426019986b1e489506db3db66dee3d/plugins/circleci",
          "skills": [
            {
              "name": "builds",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/circleci/skills/builds/SKILL.md"
            },
            {
              "name": "chunk",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/circleci/skills/chunk/SKILL.md"
            },
            {
              "name": "cli",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/circleci/skills/cli/SKILL.md"
            },
            {
              "name": "config",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/circleci/skills/config/SKILL.md"
            }
          ],
          "mcpServers": [],
          "components": ["skills"],
          "componentInspection": "repository",
          "inspectionError": null,
          "installation": "requires_adapter",
          "upstream": {
            "source": {
              "source": "local",
              "path": "./plugins/circleci"
            },
            "policy": {
              "installation": "AVAILABLE",
              "authentication": "ON_INSTALL"
            }
          }
        },
        {
          "id": "openai:google-drive",
          "name": "google-drive",
          "displayName": "Google Drive",
          "description": "Drive, Docs, Sheets or Slides",
          "longDescription": "Use Google Drive as one unified Google file plugin for search, file organization, sharing, and Google Docs, Google Sheets, and Google Slides workflows.",
          "category": "Productivity",
          "keywords": [
            "google-drive",
            "google",
            "google workspace",
            "drive",
            "docs",
            "sheets",
            "slides",
            "files",
            "google-docs",
            "google-sheets",
            "google-slides",
            "productivity"
          ],
          "author": {
            "name": "OpenAI",
            "email": "support@openai.com",
            "url": "https://openai.com/"
          },
          "version": "0.1.15",
          "license": "MIT",
          "logoUrl": "https://raw.githubusercontent.com/openai/plugins/d416fd5a43426019986b1e489506db3db66dee3d/plugins/google-drive/assets/logo.png",
          "darkLogoUrl": null,
          "homepage": "https://workspace.google.com/products/drive/",
          "sourceUrl": "https://github.com/openai/plugins/tree/d416fd5a43426019986b1e489506db3db66dee3d/plugins/google-drive",
          "skills": [
            {
              "name": "google-docs",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/google-drive/skills/google-docs/SKILL.md"
            },
            {
              "name": "google-drive-comments",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/google-drive/skills/google-drive-comments/SKILL.md"
            },
            {
              "name": "google-drive",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/google-drive/skills/google-drive/SKILL.md"
            },
            {
              "name": "google-sheets",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/google-drive/skills/google-sheets/SKILL.md"
            },
            {
              "name": "google-slides",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/google-drive/skills/google-slides/SKILL.md"
            }
          ],
          "mcpServers": [
            {
              "requiresConfiguration": false,
              "name": "google-drive",
              "transport": "http",
              "endpoint": "https://drivemcp.googleapis.com/mcp/v1"
            }
          ],
          "components": ["skills", "mcp", "apps"],
          "componentInspection": "repository",
          "inspectionError": null,
          "installation": "requires_adapter",
          "upstream": {
            "source": {
              "source": "local",
              "path": "./plugins/google-drive"
            },
            "policy": {
              "installation": "AVAILABLE",
              "authentication": "ON_INSTALL"
            }
          }
        },
        {
          "id": "openai:notion",
          "name": "notion",
          "displayName": "Notion",
          "description": "Notion workflows for specs, research, meetings, and knowledge capture",
          "longDescription": "Notion workflows for turning specs into implementation plans, synthesizing research into structured documentation, preparing meeting materials with workspace context, and capturing decisions or conversations into durable knowledge pages.",
          "category": "Productivity",
          "keywords": [
            "notion",
            "wiki",
            "notes",
            "docs",
            "projects",
            "databases",
            "documentation",
            "research",
            "meeting-prep",
            "knowledge-management",
            "planning"
          ],
          "author": {
            "email": "support@openai.com",
            "name": "Notion",
            "url": "https://openai.com/"
          },
          "version": "0.1.7",
          "license": "MIT",
          "logoUrl": "https://raw.githubusercontent.com/openai/plugins/d416fd5a43426019986b1e489506db3db66dee3d/plugins/notion/assets/notion.png",
          "darkLogoUrl": "https://raw.githubusercontent.com/openai/plugins/d416fd5a43426019986b1e489506db3db66dee3d/plugins/notion/assets/notion-dark.png",
          "homepage": "https://www.notion.so/",
          "sourceUrl": "https://github.com/openai/plugins/tree/d416fd5a43426019986b1e489506db3db66dee3d/plugins/notion",
          "skills": [
            {
              "name": "notion-knowledge-capture",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/notion/skills/notion-knowledge-capture/SKILL.md"
            },
            {
              "name": "notion-meeting-intelligence",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/notion/skills/notion-meeting-intelligence/SKILL.md"
            },
            {
              "name": "notion-research-documentation",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/notion/skills/notion-research-documentation/SKILL.md"
            },
            {
              "name": "notion-spec-to-implementation",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/notion/skills/notion-spec-to-implementation/SKILL.md"
            }
          ],
          "mcpServers": [
            {
              "requiresConfiguration": false,
              "name": "notion",
              "transport": "http",
              "endpoint": "https://mcp.notion.com/mcp"
            }
          ],
          "components": ["skills", "mcp", "apps", "agents"],
          "componentInspection": "repository",
          "inspectionError": null,
          "installation": "requires_adapter",
          "upstream": {
            "source": {
              "source": "local",
              "path": "./plugins/notion"
            },
            "policy": {
              "installation": "AVAILABLE",
              "authentication": "ON_INSTALL"
            }
          }
        },
        {
          "id": "openai:cloudflare",
          "name": "cloudflare",
          "displayName": "Cloudflare",
          "description": "Cloudflare platform guidance with official MCP",
          "longDescription": "Bring Cloudflare platform guidance into Codex with curated skills for the broader platform, Wrangler CLI, and the Agents SDK, plus the official Cloudflare API MCP server for authenticated access to live account data and workflows across Workers, Pages, storage, AI, networking, security, and analytics services.",
          "category": "Developer Tools",
          "keywords": [
            "cloudflare",
            "workflow",
            "deployment",
            "edge-functions",
            "edge",
            "analytics",
            "wrangler",
            "agents-sdk",
            "serverless",
            "ai-gateway"
          ],
          "author": {
            "name": "Cloudflare",
            "url": "https://workers.cloudflare.com/"
          },
          "version": "0.1.2",
          "license": "MIT",
          "logoUrl": "https://raw.githubusercontent.com/openai/plugins/d416fd5a43426019986b1e489506db3db66dee3d/plugins/cloudflare/assets/cloudflare.png",
          "darkLogoUrl": null,
          "homepage": "https://workers.cloudflare.com/",
          "sourceUrl": "https://github.com/openai/plugins/tree/d416fd5a43426019986b1e489506db3db66dee3d/plugins/cloudflare",
          "skills": [
            {
              "name": "agents-sdk",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/cloudflare/skills/agents-sdk/SKILL.md"
            },
            {
              "name": "building-ai-agent-on-cloudflare",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/cloudflare/skills/building-ai-agent-on-cloudflare/SKILL.md"
            },
            {
              "name": "building-mcp-server-on-cloudflare",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/cloudflare/skills/building-mcp-server-on-cloudflare/SKILL.md"
            },
            {
              "name": "cloudflare",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/cloudflare/skills/cloudflare/SKILL.md"
            },
            {
              "name": "durable-objects",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/cloudflare/skills/durable-objects/SKILL.md"
            },
            {
              "name": "sandbox-sdk",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/cloudflare/skills/sandbox-sdk/SKILL.md"
            },
            {
              "name": "web-perf",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/cloudflare/skills/web-perf/SKILL.md"
            },
            {
              "name": "workers-best-practices",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/cloudflare/skills/workers-best-practices/SKILL.md"
            },
            {
              "name": "wrangler",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/cloudflare/skills/wrangler/SKILL.md"
            }
          ],
          "mcpServers": [
            {
              "requiresConfiguration": false,
              "name": "cloudflare-api",
              "transport": "http",
              "endpoint": "https://mcp.cloudflare.com/mcp"
            }
          ],
          "components": ["skills", "mcp", "commands"],
          "componentInspection": "repository",
          "inspectionError": null,
          "installation": "requires_adapter",
          "upstream": {
            "source": {
              "source": "local",
              "path": "./plugins/cloudflare"
            },
            "policy": {
              "installation": "AVAILABLE",
              "authentication": "ON_INSTALL"
            }
          }
        },
        {
          "id": "openai:sentry",
          "name": "sentry",
          "displayName": "Sentry",
          "description": "Inspect recent Sentry issues and events",
          "longDescription": "Use Sentry skills to inspect recent issues, review events, and summarize production errors with a read-only workflow.",
          "category": "Developer Tools",
          "keywords": ["sentry", "observability", "triage"],
          "author": {
            "name": "OpenAI",
            "email": "support@openai.com",
            "url": "https://openai.com/"
          },
          "version": "0.1.2",
          "license": "MIT",
          "logoUrl": "https://raw.githubusercontent.com/openai/plugins/d416fd5a43426019986b1e489506db3db66dee3d/plugins/sentry/assets/sentry.png",
          "darkLogoUrl": null,
          "homepage": "https://sentry.io/",
          "sourceUrl": "https://github.com/openai/plugins/tree/d416fd5a43426019986b1e489506db3db66dee3d/plugins/sentry",
          "skills": [
            {
              "name": "sentry",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/sentry/skills/sentry/SKILL.md"
            }
          ],
          "mcpServers": [
            {
              "requiresConfiguration": false,
              "name": "sentry",
              "transport": "http",
              "endpoint": "https://mcp.sentry.dev/mcp"
            }
          ],
          "components": ["skills", "mcp"],
          "componentInspection": "repository",
          "inspectionError": null,
          "installation": "requires_adapter",
          "upstream": {
            "source": {
              "source": "local",
              "path": "./plugins/sentry"
            },
            "policy": {
              "installation": "AVAILABLE",
              "authentication": "ON_INSTALL"
            }
          }
        },
        {
          "id": "openai:build-ios-apps",
          "name": "build-ios-apps",
          "displayName": "Build iOS Apps",
          "description": "Build, refine, and debug iOS apps with App Intents, SwiftUI, and Xcode workflows",
          "longDescription": "Use Build iOS Apps to design App Intents and App Shortcuts, build or refactor SwiftUI UI, render SwiftUI previews in the Codex in-app browser, adopt modern iOS patterns such as Liquid Glass, audit runtime performance, capture ETTrace profiles, investigate memory leaks, and debug apps on simulators with XcodeBuildMCP-backed workflows.",
          "category": "Developer Tools",
          "keywords": [
            "ios",
            "swift",
            "swiftui",
            "app-intents",
            "shortcuts",
            "siri",
            "spotlight",
            "xcode",
            "performance",
            "debugging",
            "previews"
          ],
          "author": {
            "name": "OpenAI",
            "email": "support@openai.com",
            "url": "https://openai.com/"
          },
          "version": "0.1.2",
          "license": "MIT",
          "logoUrl": "https://raw.githubusercontent.com/openai/plugins/d416fd5a43426019986b1e489506db3db66dee3d/plugins/build-ios-apps/assets/app-icon.png",
          "darkLogoUrl": null,
          "homepage": "https://openai.com/",
          "sourceUrl": "https://github.com/openai/plugins/tree/d416fd5a43426019986b1e489506db3db66dee3d/plugins/build-ios-apps",
          "skills": [
            {
              "name": "ios-app-intents",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/build-ios-apps/skills/ios-app-intents/SKILL.md"
            },
            {
              "name": "ios-debugger-agent",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/build-ios-apps/skills/ios-debugger-agent/SKILL.md"
            },
            {
              "name": "ios-ettrace-performance",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/build-ios-apps/skills/ios-ettrace-performance/SKILL.md"
            },
            {
              "name": "ios-memgraph-leaks",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/build-ios-apps/skills/ios-memgraph-leaks/SKILL.md"
            },
            {
              "name": "ios-simulator-browser",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/build-ios-apps/skills/ios-simulator-browser/SKILL.md"
            },
            {
              "name": "swiftui-liquid-glass",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/build-ios-apps/skills/swiftui-liquid-glass/SKILL.md"
            },
            {
              "name": "swiftui-performance-audit",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/build-ios-apps/skills/swiftui-performance-audit/SKILL.md"
            },
            {
              "name": "swiftui-ui-patterns",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/build-ios-apps/skills/swiftui-ui-patterns/SKILL.md"
            },
            {
              "name": "swiftui-view-refactor",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/build-ios-apps/skills/swiftui-view-refactor/SKILL.md"
            }
          ],
          "mcpServers": [
            {
              "requiresConfiguration": false,
              "name": "xcodebuildmcp",
              "transport": "stdio",
              "endpoint": null
            }
          ],
          "components": ["skills", "mcp", "agents"],
          "componentInspection": "repository",
          "inspectionError": null,
          "installation": "requires_adapter",
          "upstream": {
            "source": {
              "source": "local",
              "path": "./plugins/build-ios-apps"
            },
            "policy": {
              "installation": "AVAILABLE",
              "authentication": "ON_INSTALL",
              "products": ["CODEX"]
            }
          }
        },
        {
          "id": "openai:build-macos-apps",
          "name": "build-macos-apps",
          "displayName": "Build macOS Apps",
          "description": "Build, debug, instrument, and implement macOS apps with SwiftUI and AppKit guidance",
          "longDescription": "macOS development workflows for discovering local projects, building and running desktop apps, implementing native SwiftUI scenes, bridging into AppKit when necessary, adding lightweight Logger telemetry, triaging test failures, inspecting signing and entitlements, and debugging desktop-specific build or runtime errors.",
          "category": "Developer Tools",
          "keywords": [
            "macos",
            "swift",
            "swiftui",
            "appkit",
            "xcode",
            "swiftpm",
            "debugging",
            "codesign",
            "logging",
            "telemetry",
            "oslog"
          ],
          "author": {
            "name": "OpenAI",
            "email": "support@openai.com",
            "url": "https://openai.com/"
          },
          "version": "0.1.4",
          "license": "MIT",
          "logoUrl": "https://raw.githubusercontent.com/openai/plugins/d416fd5a43426019986b1e489506db3db66dee3d/plugins/build-macos-apps/assets/app-icon.png",
          "darkLogoUrl": null,
          "homepage": "https://openai.com/",
          "sourceUrl": "https://github.com/openai/plugins/tree/d416fd5a43426019986b1e489506db3db66dee3d/plugins/build-macos-apps",
          "skills": [
            {
              "name": "appkit-interop",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/build-macos-apps/skills/appkit-interop/SKILL.md"
            },
            {
              "name": "build-run-debug",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/build-macos-apps/skills/build-run-debug/SKILL.md"
            },
            {
              "name": "liquid-glass",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/build-macos-apps/skills/liquid-glass/SKILL.md"
            },
            {
              "name": "packaging-notarization",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/build-macos-apps/skills/packaging-notarization/SKILL.md"
            },
            {
              "name": "signing-entitlements",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/build-macos-apps/skills/signing-entitlements/SKILL.md"
            },
            {
              "name": "swiftpm-macos",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/build-macos-apps/skills/swiftpm-macos/SKILL.md"
            },
            {
              "name": "swiftui-patterns",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/build-macos-apps/skills/swiftui-patterns/SKILL.md"
            },
            {
              "name": "telemetry",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/build-macos-apps/skills/telemetry/SKILL.md"
            },
            {
              "name": "test-triage",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/build-macos-apps/skills/test-triage/SKILL.md"
            },
            {
              "name": "view-refactor",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/build-macos-apps/skills/view-refactor/SKILL.md"
            },
            {
              "name": "window-management",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/build-macos-apps/skills/window-management/SKILL.md"
            }
          ],
          "mcpServers": [],
          "components": ["skills", "agents", "commands"],
          "componentInspection": "repository",
          "inspectionError": null,
          "installation": "requires_adapter",
          "upstream": {
            "source": {
              "source": "local",
              "path": "./plugins/build-macos-apps"
            },
            "policy": {
              "installation": "AVAILABLE",
              "authentication": "ON_INSTALL",
              "products": ["CODEX"]
            }
          }
        },
        {
          "id": "openai:build-web-apps",
          "name": "build-web-apps",
          "displayName": "Build Web Apps",
          "description": "Build frontend-focused web apps with generated assets, browser testing, payments, and databases",
          "longDescription": "Use Build Web Apps to create frontend application surfaces with Codex-generated visual assets, verify them with the Browser plugin and built-in app browser, compose shadcn/ui, wire Stripe payments, and design or tune Supabase/Postgres data flows.",
          "category": "Developer Tools",
          "keywords": [
            "build-web-apps",
            "build",
            "product-apps",
            "frontend",
            "image-generation",
            "browser-testing",
            "frontend-debugging",
            "stripe",
            "supabase",
            "shadcn",
            "full-stack",
            "frontend-qa"
          ],
          "author": {
            "name": "OpenAI",
            "email": "support@openai.com",
            "url": "https://openai.com/"
          },
          "version": "0.1.2",
          "license": "MIT",
          "logoUrl": "https://raw.githubusercontent.com/openai/plugins/d416fd5a43426019986b1e489506db3db66dee3d/plugins/build-web-apps/assets/app-icon.png",
          "darkLogoUrl": null,
          "homepage": "https://openai.com/",
          "sourceUrl": "https://github.com/openai/plugins/tree/d416fd5a43426019986b1e489506db3db66dee3d/plugins/build-web-apps",
          "skills": [
            {
              "name": "frontend-app-builder",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/build-web-apps/skills/frontend-app-builder/SKILL.md"
            },
            {
              "name": "frontend-testing-debugging",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/build-web-apps/skills/frontend-testing-debugging/SKILL.md"
            },
            {
              "name": "react-best-practices",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/build-web-apps/skills/react-best-practices/SKILL.md"
            },
            {
              "name": "shadcn-best-practices",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/build-web-apps/skills/shadcn-best-practices/SKILL.md"
            },
            {
              "name": "stripe-best-practices",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/build-web-apps/skills/stripe-best-practices/SKILL.md"
            },
            {
              "name": "supabase-best-practices",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/build-web-apps/skills/supabase-best-practices/SKILL.md"
            }
          ],
          "mcpServers": [],
          "components": ["skills", "agents"],
          "componentInspection": "repository",
          "inspectionError": null,
          "installation": "requires_adapter",
          "upstream": {
            "source": {
              "source": "local",
              "path": "./plugins/build-web-apps"
            },
            "policy": {
              "installation": "AVAILABLE",
              "authentication": "ON_USE",
              "products": ["CODEX"]
            }
          }
        },
        {
          "id": "openai:build-web-data-visualization",
          "name": "build-web-data-visualization",
          "displayName": "Build Web Data Visualization",
          "description": "Design, build, test, and export web data visualizations",
          "longDescription": "Use Build Web Data Visualization to choose, design, implement, test, and export browser charts, dashboards, maps, WebGL/Three.js scenes, Canvas/D3 visuals, Gantt charts, UML/software diagrams, scrollytelling, reports, PDFs, and slide decks. It emphasizes source-backed data, accessible responsive layouts, URL-shareable analysis state, and concept-first design for advanced visual stories.",
          "category": "Developer Tools",
          "keywords": [
            "build-web-data-visualization",
            "web-data-visualization",
            "data-visualization",
            "charts",
            "dashboards",
            "maps",
            "geospatial",
            "vega-lite",
            "observable-plot",
            "d3",
            "canvas",
            "webgl",
            "threejs",
            "react",
            "nextjs",
            "typescript",
            "svg",
            "accessibility",
            "testing",
            "visual-regression",
            "reports",
            "slides",
            "infographics",
            "scrollytelling",
            "parallax",
            "gantt",
            "uml",
            "software-architecture",
            "graph-layout",
            "node-link",
            "mobile",
            "responsive",
            "shareable-state",
            "visual-design",
            "visual-design-contract",
            "color-contrast",
            "uncertainty",
            "export",
            "diagrams",
            "operational-workspaces",
            "humanitarian",
            "geopolitical"
          ],
          "author": {
            "name": "OpenAI"
          },
          "version": "0.1.21",
          "license": "MIT",
          "logoUrl": "https://raw.githubusercontent.com/openai/plugins/d416fd5a43426019986b1e489506db3db66dee3d/plugins/build-web-data-visualization/assets/app-icon.svg",
          "darkLogoUrl": null,
          "homepage": "https://openai.com/",
          "sourceUrl": "https://github.com/openai/plugins/tree/d416fd5a43426019986b1e489506db3db66dee3d/plugins/build-web-data-visualization",
          "skills": [
            {
              "name": "accessibility-and-inclusive-visualization",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/build-web-data-visualization/skills/accessibility-and-inclusive-visualization/SKILL.md"
            },
            {
              "name": "canvas2d-data-visualization",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/build-web-data-visualization/skills/canvas2d-data-visualization/SKILL.md"
            },
            {
              "name": "d3-data-visualization",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/build-web-data-visualization/skills/d3-data-visualization/SKILL.md"
            },
            {
              "name": "dashboards-and-real-time-visualization",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/build-web-data-visualization/skills/dashboards-and-real-time-visualization/SKILL.md"
            },
            {
              "name": "data-visualization",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/build-web-data-visualization/skills/data-visualization/SKILL.md"
            },
            {
              "name": "gantt-chart-visualization",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/build-web-data-visualization/skills/gantt-chart-visualization/SKILL.md"
            },
            {
              "name": "geospatial-and-cartographic-visualization",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/build-web-data-visualization/skills/geospatial-and-cartographic-visualization/SKILL.md"
            },
            {
              "name": "grammar-of-graphics-and-declarative-visualization",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/build-web-data-visualization/skills/grammar-of-graphics-and-declarative-visualization/SKILL.md"
            },
            {
              "name": "node-link-and-diagram-layout",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/build-web-data-visualization/skills/node-link-and-diagram-layout/SKILL.md"
            },
            {
              "name": "react-and-nextjs-data-visualization",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/build-web-data-visualization/skills/react-and-nextjs-data-visualization/SKILL.md"
            },
            {
              "name": "reports-pdfs-and-slide-automation",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/build-web-data-visualization/skills/reports-pdfs-and-slide-automation/SKILL.md"
            },
            {
              "name": "scrollytelling-and-parallax-data-visualization",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/build-web-data-visualization/skills/scrollytelling-and-parallax-data-visualization/SKILL.md"
            },
            {
              "name": "statistical-and-uncertainty-visualization",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/build-web-data-visualization/skills/statistical-and-uncertainty-visualization/SKILL.md"
            },
            {
              "name": "testing-data-visualizations",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/build-web-data-visualization/skills/testing-data-visualizations/SKILL.md"
            },
            {
              "name": "threejs-data-visualization",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/build-web-data-visualization/skills/threejs-data-visualization/SKILL.md"
            },
            {
              "name": "typescript-data-visualization-engineering",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/build-web-data-visualization/skills/typescript-data-visualization-engineering/SKILL.md"
            },
            {
              "name": "uml-and-software-architecture-visualization",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/build-web-data-visualization/skills/uml-and-software-architecture-visualization/SKILL.md"
            },
            {
              "name": "visualization-strategy-and-critique",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/build-web-data-visualization/skills/visualization-strategy-and-critique/SKILL.md"
            }
          ],
          "mcpServers": [],
          "components": ["skills", "agents"],
          "componentInspection": "repository",
          "inspectionError": null,
          "installation": "requires_adapter",
          "upstream": {
            "source": {
              "source": "local",
              "path": "./plugins/build-web-data-visualization"
            },
            "policy": {
              "installation": "AVAILABLE",
              "authentication": "ON_USE",
              "products": ["CODEX"]
            }
          }
        },
        {
          "id": "openai:test-android-apps",
          "name": "test-android-apps",
          "displayName": "Test Android Apps",
          "description": "Reproduce issues, inspect UI, and capture performance evidence from Android emulators",
          "longDescription": "Use Test Android Apps to build and install app variants, drive a booted Android emulator with adb input events, inspect UI trees, capture screenshots, collect logcat output, and gather Simpleperf, Perfetto, gfxinfo, or memory/leak evidence while reproducing issues.",
          "category": "Developer Tools",
          "keywords": [
            "android",
            "adb",
            "emulator",
            "qa",
            "logcat",
            "uiautomator",
            "performance",
            "simpleperf",
            "perfetto",
            "memory",
            "leaks",
            "heap"
          ],
          "author": {
            "name": "OpenAI",
            "email": "support@openai.com",
            "url": "https://openai.com/"
          },
          "version": "0.1.2",
          "license": "MIT",
          "logoUrl": "https://raw.githubusercontent.com/openai/plugins/d416fd5a43426019986b1e489506db3db66dee3d/plugins/test-android-apps/assets/app-icon.png",
          "darkLogoUrl": null,
          "homepage": "https://openai.com/",
          "sourceUrl": "https://github.com/openai/plugins/tree/d416fd5a43426019986b1e489506db3db66dee3d/plugins/test-android-apps",
          "skills": [
            {
              "name": "android-emulator-qa",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/test-android-apps/skills/android-emulator-qa/SKILL.md"
            },
            {
              "name": "android-performance",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/test-android-apps/skills/android-performance/SKILL.md"
            }
          ],
          "mcpServers": [],
          "components": ["skills", "agents"],
          "componentInspection": "repository",
          "inspectionError": null,
          "installation": "requires_adapter",
          "upstream": {
            "source": {
              "source": "local",
              "path": "./plugins/test-android-apps"
            },
            "policy": {
              "installation": "AVAILABLE",
              "authentication": "ON_INSTALL",
              "products": ["CODEX"]
            }
          }
        },
        {
          "id": "openai:life-science-research",
          "name": "life-science-research",
          "displayName": "Life Science Research",
          "description": "General life-sciences research with routing, evidence synthesis, and optional parallel subagent analysis",
          "longDescription": "Internal life-science research workflows that help Codex interpret a user's research question, normalize the relevant entities, choose the right skills, and synthesize evidence-backed answers across public resources. The plugin spans human genetics, functional genomics, expression, pathways, protein structure, chemistry, pharmacology, literature, clinical evidence, and public study discovery, with a research-router entrypoint for broad tasks and optional subagent-assisted parallel work when evidence lanes are independent.",
          "category": "Education & Research",
          "keywords": [
            "life-science",
            "research",
            "bioinformatics",
            "human-genetics",
            "functional-genomics",
            "transcriptomics",
            "proteomics",
            "metabolomics",
            "clinical-research",
            "drug-discovery",
            "skill-routing",
            "evidence-synthesis",
            "parallel-analysis",
            "gwas",
            "variant-interpretation",
            "pathway-biology",
            "protein-structure"
          ],
          "author": {
            "name": "OpenAI"
          },
          "version": "1.0.3",
          "license": "Proprietary",
          "logoUrl": "https://raw.githubusercontent.com/openai/plugins/d416fd5a43426019986b1e489506db3db66dee3d/plugins/life-science-research/assets/app-icon.png",
          "darkLogoUrl": null,
          "homepage": "https://github.com/openai/openai/tree/master/plugins/life-science-research",
          "sourceUrl": "https://github.com/openai/plugins/tree/d416fd5a43426019986b1e489506db3db66dee3d/plugins/life-science-research",
          "skills": [
            {
              "name": "alphafold-skill",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/life-science-research/skills/alphafold-skill/SKILL.md"
            },
            {
              "name": "bgee-skill",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/life-science-research/skills/bgee-skill/SKILL.md"
            },
            {
              "name": "bindingdb-skill",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/life-science-research/skills/bindingdb-skill/SKILL.md"
            },
            {
              "name": "biobankjapan-phewas-skill",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/life-science-research/skills/biobankjapan-phewas-skill/SKILL.md"
            },
            {
              "name": "biorxiv-skill",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/life-science-research/skills/biorxiv-skill/SKILL.md"
            },
            {
              "name": "biostudies-arrayexpress-skill",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/life-science-research/skills/biostudies-arrayexpress-skill/SKILL.md"
            },
            {
              "name": "cbioportal-skill",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/life-science-research/skills/cbioportal-skill/SKILL.md"
            },
            {
              "name": "cellxgene-skill",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/life-science-research/skills/cellxgene-skill/SKILL.md"
            },
            {
              "name": "chebi-skill",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/life-science-research/skills/chebi-skill/SKILL.md"
            },
            {
              "name": "chembl-skill",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/life-science-research/skills/chembl-skill/SKILL.md"
            },
            {
              "name": "civic-skill",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/life-science-research/skills/civic-skill/SKILL.md"
            },
            {
              "name": "clinicaltrials-skill",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/life-science-research/skills/clinicaltrials-skill/SKILL.md"
            },
            {
              "name": "clinvar-variation-skill",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/life-science-research/skills/clinvar-variation-skill/SKILL.md"
            },
            {
              "name": "efo-ontology-skill",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/life-science-research/skills/efo-ontology-skill/SKILL.md"
            },
            {
              "name": "encode-skill",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/life-science-research/skills/encode-skill/SKILL.md"
            },
            {
              "name": "ensembl-skill",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/life-science-research/skills/ensembl-skill/SKILL.md"
            },
            {
              "name": "epigraphdb-skill",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/life-science-research/skills/epigraphdb-skill/SKILL.md"
            },
            {
              "name": "eqtl-catalogue-skill",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/life-science-research/skills/eqtl-catalogue-skill/SKILL.md"
            },
            {
              "name": "eva-skill",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/life-science-research/skills/eva-skill/SKILL.md"
            },
            {
              "name": "finngen-phewas-skill",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/life-science-research/skills/finngen-phewas-skill/SKILL.md"
            },
            {
              "name": "genebass-gene-burden-skill",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/life-science-research/skills/genebass-gene-burden-skill/SKILL.md"
            },
            {
              "name": "gnomad-graphql-skill",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/life-science-research/skills/gnomad-graphql-skill/SKILL.md"
            },
            {
              "name": "gtex-eqtl-skill",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/life-science-research/skills/gtex-eqtl-skill/SKILL.md"
            },
            {
              "name": "gwas-catalog-skill",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/life-science-research/skills/gwas-catalog-skill/SKILL.md"
            },
            {
              "name": "hmdb-skill",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/life-science-research/skills/hmdb-skill/SKILL.md"
            },
            {
              "name": "human-protein-atlas-skill",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/life-science-research/skills/human-protein-atlas-skill/SKILL.md"
            },
            {
              "name": "ipd-skill",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/life-science-research/skills/ipd-skill/SKILL.md"
            },
            {
              "name": "locus-to-gene-mapper-skill",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/life-science-research/skills/locus-to-gene-mapper-skill/SKILL.md"
            },
            {
              "name": "metabolights-skill",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/life-science-research/skills/metabolights-skill/SKILL.md"
            },
            {
              "name": "mgnify-skill",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/life-science-research/skills/mgnify-skill/SKILL.md"
            },
            {
              "name": "ncbi-blast-skill",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/life-science-research/skills/ncbi-blast-skill/SKILL.md"
            },
            {
              "name": "ncbi-clinicaltables-skill",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/life-science-research/skills/ncbi-clinicaltables-skill/SKILL.md"
            },
            {
              "name": "ncbi-datasets-skill",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/life-science-research/skills/ncbi-datasets-skill/SKILL.md"
            },
            {
              "name": "ncbi-entrez-skill",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/life-science-research/skills/ncbi-entrez-skill/SKILL.md"
            },
            {
              "name": "ncbi-pmc-skill",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/life-science-research/skills/ncbi-pmc-skill/SKILL.md"
            },
            {
              "name": "opentargets-skill",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/life-science-research/skills/opentargets-skill/SKILL.md"
            },
            {
              "name": "pharmgkb-skill",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/life-science-research/skills/pharmgkb-skill/SKILL.md"
            },
            {
              "name": "pride-skill",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/life-science-research/skills/pride-skill/SKILL.md"
            },
            {
              "name": "proteomexchange-skill",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/life-science-research/skills/proteomexchange-skill/SKILL.md"
            },
            {
              "name": "pubchem-pug-skill",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/life-science-research/skills/pubchem-pug-skill/SKILL.md"
            },
            {
              "name": "quickgo-skill",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/life-science-research/skills/quickgo-skill/SKILL.md"
            },
            {
              "name": "rcsb-pdb-skill",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/life-science-research/skills/rcsb-pdb-skill/SKILL.md"
            },
            {
              "name": "reactome-skill",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/life-science-research/skills/reactome-skill/SKILL.md"
            },
            {
              "name": "research-router-skill",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/life-science-research/skills/research-router-skill/SKILL.md"
            },
            {
              "name": "rhea-skill",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/life-science-research/skills/rhea-skill/SKILL.md"
            },
            {
              "name": "rnacentral-skill",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/life-science-research/skills/rnacentral-skill/SKILL.md"
            },
            {
              "name": "string-skill",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/life-science-research/skills/string-skill/SKILL.md"
            },
            {
              "name": "tpmi-phewas-skill",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/life-science-research/skills/tpmi-phewas-skill/SKILL.md"
            },
            {
              "name": "ukb-topmed-phewas-skill",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/life-science-research/skills/ukb-topmed-phewas-skill/SKILL.md"
            },
            {
              "name": "uniprot-skill",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/life-science-research/skills/uniprot-skill/SKILL.md"
            }
          ],
          "mcpServers": [],
          "components": ["skills"],
          "componentInspection": "repository",
          "inspectionError": null,
          "installation": "requires_adapter",
          "upstream": {
            "source": {
              "source": "local",
              "path": "./plugins/life-science-research"
            },
            "policy": {
              "installation": "AVAILABLE",
              "authentication": "ON_INSTALL"
            }
          }
        },
        {
          "id": "openai:zotero",
          "name": "zotero",
          "displayName": "Zotero",
          "description": "Find papers and add citations from Zotero",
          "longDescription": "Connect Codex to your Zotero desktop library so it can find saved papers, export BibTeX, add citation keys to drafts, read indexed attachment text when you ask, and import new reference records into Zotero with your approval.",
          "category": "Education & Research",
          "keywords": [
            "zotero",
            "citations",
            "bibliography",
            "bibtex",
            "references",
            "research",
            "papers",
            "latex"
          ],
          "author": {
            "name": "OpenAI",
            "email": "support@openai.com",
            "url": "https://openai.com/"
          },
          "version": "0.1.2",
          "license": "MIT",
          "logoUrl": "https://raw.githubusercontent.com/openai/plugins/d416fd5a43426019986b1e489506db3db66dee3d/plugins/zotero/assets/icon.png",
          "darkLogoUrl": null,
          "homepage": "https://openai.com/",
          "sourceUrl": "https://github.com/openai/plugins/tree/d416fd5a43426019986b1e489506db3db66dee3d/plugins/zotero",
          "skills": [
            {
              "name": "zotero",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/zotero/skills/zotero/SKILL.md"
            }
          ],
          "mcpServers": [],
          "components": ["skills"],
          "componentInspection": "repository",
          "inspectionError": null,
          "installation": "requires_adapter",
          "upstream": {
            "source": {
              "source": "local",
              "path": "./plugins/zotero"
            },
            "policy": {
              "installation": "AVAILABLE",
              "authentication": "ON_INSTALL",
              "products": ["CODEX"]
            }
          }
        },
        {
          "id": "openai:expo",
          "name": "expo",
          "displayName": "Expo",
          "description": "Build, deploy, upgrade, and debug Expo and React Native apps",
          "longDescription": "Official Expo-authored skills for building Expo Router UI, authoring API routes, configuring data fetching and styling, writing Expo native modules, creating dev clients, upgrading Expo SDKs, wiring Codex app Run actions, and deploying Expo apps with EAS workflows, builds, hosting, TestFlight, App Store, and Play Store guidance.",
          "category": "Developer Tools",
          "keywords": [
            "expo",
            "react-native",
            "expo-router",
            "codex-run-actions",
            "eas",
            "mobile",
            "ios",
            "android",
            "deployment",
            "upgrades",
            "native-modules"
          ],
          "author": {
            "name": "Expo Team",
            "email": "support@expo.dev",
            "url": "https://expo.dev"
          },
          "version": "1.0.2",
          "license": "MIT",
          "logoUrl": "https://raw.githubusercontent.com/openai/plugins/d416fd5a43426019986b1e489506db3db66dee3d/plugins/expo/assets/expo.png",
          "darkLogoUrl": null,
          "homepage": "https://docs.expo.dev/skills/",
          "sourceUrl": "https://github.com/openai/plugins/tree/d416fd5a43426019986b1e489506db3db66dee3d/plugins/expo",
          "skills": [
            {
              "name": "building-native-ui",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/expo/skills/building-native-ui/SKILL.md"
            },
            {
              "name": "codex-expo-run-actions",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/expo/skills/codex-expo-run-actions/SKILL.md"
            },
            {
              "name": "expo-api-routes",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/expo/skills/expo-api-routes/SKILL.md"
            },
            {
              "name": "expo-cicd-workflows",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/expo/skills/expo-cicd-workflows/SKILL.md"
            },
            {
              "name": "expo-deployment",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/expo/skills/expo-deployment/SKILL.md"
            },
            {
              "name": "expo-dev-client",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/expo/skills/expo-dev-client/SKILL.md"
            },
            {
              "name": "expo-module",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/expo/skills/expo-module/SKILL.md"
            },
            {
              "name": "expo-tailwind-setup",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/expo/skills/expo-tailwind-setup/SKILL.md"
            },
            {
              "name": "expo-ui-jetpack-compose",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/expo/skills/expo-ui-jetpack-compose/SKILL.md"
            },
            {
              "name": "expo-ui-swift-ui",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/expo/skills/expo-ui-swift-ui/SKILL.md"
            },
            {
              "name": "native-data-fetching",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/expo/skills/native-data-fetching/SKILL.md"
            },
            {
              "name": "upgrading-expo",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/expo/skills/upgrading-expo/SKILL.md"
            },
            {
              "name": "use-dom",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/expo/skills/use-dom/SKILL.md"
            }
          ],
          "mcpServers": [],
          "components": ["skills", "agents", "commands"],
          "componentInspection": "repository",
          "inspectionError": null,
          "installation": "requires_adapter",
          "upstream": {
            "source": {
              "source": "local",
              "path": "./plugins/expo"
            },
            "policy": {
              "installation": "AVAILABLE",
              "authentication": "ON_INSTALL",
              "products": ["CODEX"]
            }
          }
        },
        {
          "id": "openai:coderabbit",
          "name": "coderabbit",
          "displayName": "CodeRabbit",
          "description": "Run AI-powered code review for your current changes",
          "longDescription": "Run CodeRabbit review workflows in Codex to inspect diffs, surface actionable findings, and turn review output into follow-up fixes.",
          "category": "Developer Tools",
          "keywords": ["code-review", "ai", "coderabbit", "codex"],
          "author": {
            "name": "CodeRabbit AI",
            "email": "support@coderabbit.ai",
            "url": "https://coderabbit.ai"
          },
          "version": "1.1.4",
          "license": "MIT",
          "logoUrl": "https://raw.githubusercontent.com/openai/plugins/d416fd5a43426019986b1e489506db3db66dee3d/plugins/coderabbit/assets/logo.png",
          "darkLogoUrl": "https://raw.githubusercontent.com/openai/plugins/d416fd5a43426019986b1e489506db3db66dee3d/plugins/coderabbit/assets/logo-dark.png",
          "homepage": "https://docs.coderabbit.ai/cli/overview",
          "sourceUrl": "https://github.com/openai/plugins/tree/d416fd5a43426019986b1e489506db3db66dee3d/plugins/coderabbit",
          "skills": [
            {
              "name": "coderabbit-review",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/coderabbit/skills/coderabbit-review/SKILL.md"
            }
          ],
          "mcpServers": [],
          "components": ["skills"],
          "componentInspection": "repository",
          "inspectionError": null,
          "installation": "requires_adapter",
          "upstream": {
            "source": {
              "source": "local",
              "path": "./plugins/coderabbit"
            },
            "policy": {
              "installation": "AVAILABLE",
              "authentication": "ON_INSTALL",
              "products": ["CODEX"]
            }
          }
        },
        {
          "id": "openai:remotion",
          "name": "remotion",
          "displayName": "Remotion",
          "description": "Make videos agentically",
          "longDescription": "Build videos programmatically with Remotion and React. Covers animations, timing, audio, captions, 3D, transitions, charts, text effects, and more.",
          "category": "Creativity",
          "keywords": [
            "remotion",
            "video",
            "react",
            "animation",
            "composition",
            "rendering",
            "ffmpeg",
            "captions",
            "audio"
          ],
          "author": {
            "email": "hi@remotion.dev",
            "name": "Remotion",
            "url": "https://remotion.dev"
          },
          "version": "1.0.7",
          "license": "MIT",
          "logoUrl": "https://raw.githubusercontent.com/openai/plugins/d416fd5a43426019986b1e489506db3db66dee3d/plugins/remotion/.codex-plugin/assets/logo.png",
          "darkLogoUrl": "https://raw.githubusercontent.com/openai/plugins/d416fd5a43426019986b1e489506db3db66dee3d/plugins/remotion/.codex-plugin/assets/logo-dark.png",
          "homepage": "https://remotion.dev",
          "sourceUrl": "https://github.com/openai/plugins/tree/d416fd5a43426019986b1e489506db3db66dee3d/plugins/remotion",
          "skills": [
            {
              "name": "remotion-best-practices",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/remotion/skills/remotion-best-practices/SKILL.md"
            },
            {
              "name": "remotion-captions",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/remotion/skills/remotion-captions/SKILL.md"
            },
            {
              "name": "remotion-create",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/remotion/skills/remotion-create/SKILL.md"
            },
            {
              "name": "remotion-docs",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/remotion/skills/remotion-docs/SKILL.md"
            },
            {
              "name": "remotion-interactivity",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/remotion/skills/remotion-interactivity/SKILL.md"
            },
            {
              "name": "remotion-maps",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/remotion/skills/remotion-maps/SKILL.md"
            },
            {
              "name": "remotion-markup",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/remotion/skills/remotion-markup/SKILL.md"
            },
            {
              "name": "remotion-multimedia",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/remotion/skills/remotion-multimedia/SKILL.md"
            },
            {
              "name": "remotion-render",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/remotion/skills/remotion-render/SKILL.md"
            },
            {
              "name": "remotion-saas",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/remotion/skills/remotion-saas/SKILL.md"
            },
            {
              "name": "remotion-studio",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/remotion/skills/remotion-studio/SKILL.md"
            },
            {
              "name": "remotion-upgrade",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/remotion/skills/remotion-upgrade/SKILL.md"
            }
          ],
          "mcpServers": [],
          "components": ["skills"],
          "componentInspection": "repository",
          "inspectionError": null,
          "installation": "requires_adapter",
          "upstream": {
            "source": {
              "source": "local",
              "path": "./plugins/remotion"
            },
            "policy": {
              "installation": "AVAILABLE",
              "authentication": "ON_INSTALL",
              "products": ["CODEX"]
            }
          }
        },
        {
          "id": "openai:plugin-eval",
          "name": "plugin-eval",
          "displayName": "Plugin Eval",
          "description": "Start from chat, then evaluate or benchmark locally",
          "longDescription": "Ask Codex to evaluate a plugin or skill, give you a full analysis of a named plugin such as game-studio, explain why it scored that way, show what to fix first, explain its token budget, measure real token usage, benchmark a plugin, or tell you what to run next. Plugin Eval keeps the path engineer-friendly: start with a natural chat request, then use the local `plugin-eval start` entrypoint or the routed workflow command it recommends.",
          "category": "Developer Tools",
          "keywords": ["codex", "plugin", "skill", "evaluation", "quality", "budget"],
          "author": {
            "name": "OpenAI Codex",
            "email": "support@openai.com",
            "url": "https://openai.com/"
          },
          "version": "0.1.2",
          "license": "MIT",
          "logoUrl": "https://raw.githubusercontent.com/openai/plugins/d416fd5a43426019986b1e489506db3db66dee3d/plugins/plugin-eval/assets/plugin-eval.svg",
          "darkLogoUrl": null,
          "homepage": "https://openai.com/",
          "sourceUrl": "https://github.com/openai/plugins/tree/d416fd5a43426019986b1e489506db3db66dee3d/plugins/plugin-eval",
          "skills": [
            {
              "name": "minimal-plugin-skill",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/plugin-eval/fixtures/minimal-plugin/skills/minimal-plugin-skill/SKILL.md"
            },
            {
              "name": "minimal-skill",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/plugin-eval/fixtures/minimal-skill/SKILL.md"
            },
            {
              "name": "alpha",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/plugin-eval/fixtures/multi-skill-plugin/skills/alpha/SKILL.md"
            },
            {
              "name": "beta",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/plugin-eval/fixtures/multi-skill-plugin/skills/beta/SKILL.md"
            },
            {
              "name": "evaluate-plugin",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/plugin-eval/skills/evaluate-plugin/SKILL.md"
            },
            {
              "name": "evaluate-skill",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/plugin-eval/skills/evaluate-skill/SKILL.md"
            },
            {
              "name": "improve-skill",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/plugin-eval/skills/improve-skill/SKILL.md"
            },
            {
              "name": "metric-pack-designer",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/plugin-eval/skills/metric-pack-designer/SKILL.md"
            },
            {
              "name": "plugin-eval",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/plugin-eval/skills/plugin-eval/SKILL.md"
            }
          ],
          "mcpServers": [],
          "components": ["skills"],
          "componentInspection": "repository",
          "inspectionError": null,
          "installation": "requires_adapter",
          "upstream": {
            "source": {
              "source": "local",
              "path": "./plugins/plugin-eval"
            },
            "policy": {
              "installation": "AVAILABLE",
              "authentication": "ON_INSTALL",
              "products": ["CODEX"]
            }
          }
        },
        {
          "id": "openai:granola",
          "name": "granola",
          "displayName": "Granola",
          "description": "Add your meeting context",
          "longDescription": "Granola MCP connects your meeting history to Codex so your assistant can pull real context from past conversations while you work.\n\nUse MCP when you're already working on something bigger:\n\n-   Writing PRDs or proposals: Pull customer feedback, stakeholder input, and decisions from relevant meetings directly into your draft\n    \n-   Building presentations or reports: Combine insights from multiple conversations with your other research and data\n    \n-   Coding with context: Give your AI the project background, requirements, and technical decisions discussed in planning meetings\n    \n-   Strategic analysis: Merge meeting insights with documents, data, and other sources for comprehensive analysis\n    \nHow it works:\n\nYour AI assistant can search your Granola meetings by topic, person, company, or timeframe - then cite specific conversations in its responses. No more switching tabs to find \"what the customer said\" or \"when we decided that.\"\n\nThe difference:\n\nInstead of copy-pasting meeting notes into prompts, your AI pulls exactly what it needs from your meeting history automatically. You stay focused on the work, not the research or context.",
          "category": "Productivity",
          "keywords": [],
          "author": {
            "name": "Granola",
            "url": "https://www.granola.ai"
          },
          "version": "1.0.0",
          "license": "MIT",
          "logoUrl": "https://raw.githubusercontent.com/openai/plugins/d416fd5a43426019986b1e489506db3db66dee3d/plugins/granola/assets/logo.png",
          "darkLogoUrl": null,
          "homepage": "https://www.granola.ai",
          "sourceUrl": "https://github.com/openai/plugins/tree/d416fd5a43426019986b1e489506db3db66dee3d/plugins/granola",
          "skills": [],
          "mcpServers": [
            {
              "requiresConfiguration": false,
              "name": "granola",
              "transport": "http",
              "endpoint": "https://mcp.granola.ai/mcp"
            }
          ],
          "components": ["mcp", "apps"],
          "componentInspection": "repository",
          "inspectionError": null,
          "installation": "requires_adapter",
          "upstream": {
            "source": {
              "source": "local",
              "path": "./plugins/granola"
            },
            "policy": {
              "installation": "AVAILABLE",
              "authentication": "ON_INSTALL"
            }
          }
        },
        {
          "id": "openai:monday-com",
          "name": "monday-com",
          "displayName": "monday.com",
          "description": "Manage projects, tasks & CRM",
          "longDescription": "The monday.com AI Connector brings core platform capabilities directly to agents and AI assistants. It supports searching boards, creating and updating items and columns, assigning owners, setting timelines, and posting updates — enabling a wide range of work management and CRM use cases across teams and departments.\n\nTeams of people and agents use monday.com as a task tracker and project tracking hub: planning campaigns and events, tracking milestones, dependencies, and workload, managing approval workflows and request intake, and sharing status updates across projects and portfolios — as well as a CRM for managing leads, contacts, and deals.\n\nBeyond day-to-day work management, the connector lets agents answer questions using monday.com's official knowledge base, plan and build automations and multi-step workflows, run and save reusable code actions, and configure other monday.com agents .",
          "category": "Productivity",
          "keywords": [],
          "author": {
            "name": "monday.com"
          },
          "version": "2.0.0",
          "license": null,
          "logoUrl": "https://raw.githubusercontent.com/openai/plugins/d416fd5a43426019986b1e489506db3db66dee3d/plugins/monday-com/assets/logo.png",
          "darkLogoUrl": null,
          "homepage": null,
          "sourceUrl": "https://github.com/openai/plugins/tree/d416fd5a43426019986b1e489506db3db66dee3d/plugins/monday-com",
          "skills": [],
          "mcpServers": [
            {
              "requiresConfiguration": false,
              "name": "monday-com",
              "transport": "http",
              "endpoint": "https://mcp.monday.com/mcp"
            }
          ],
          "components": ["mcp", "apps"],
          "componentInspection": "repository",
          "inspectionError": null,
          "installation": "requires_adapter",
          "upstream": {
            "source": {
              "source": "local",
              "path": "./plugins/monday-com"
            },
            "policy": {
              "installation": "AVAILABLE",
              "authentication": "ON_INSTALL"
            }
          }
        },
        {
          "id": "openai:temporal",
          "name": "temporal",
          "displayName": "Temporal",
          "description": "Develop with Temporal",
          "longDescription": "Comprehensive guidance for working with Temporal — developing workflows, activities, and workers across Python, TypeScript, Go, and Java SDKs; using the Temporal CLI for local development and operations; running and managing self-hosted Temporal Server; and working with Temporal Cloud for production deployments.",
          "category": "Developer Tools",
          "keywords": [
            "temporal",
            "workflow",
            "durable-execution",
            "python",
            "typescript",
            "go",
            "java",
            "microservices",
            "distributed-systems"
          ],
          "author": {
            "name": "Temporal",
            "url": "https://temporal.io/"
          },
          "version": "0.4.0",
          "license": "MIT",
          "logoUrl": "https://raw.githubusercontent.com/openai/plugins/d416fd5a43426019986b1e489506db3db66dee3d/plugins/temporal/.codex-plugin/assets/logo.svg",
          "darkLogoUrl": null,
          "homepage": "https://temporal.io/",
          "sourceUrl": "https://github.com/openai/plugins/tree/d416fd5a43426019986b1e489506db3db66dee3d/plugins/temporal",
          "skills": [
            {
              "name": "temporal-cloud-setup",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/temporal/skills/temporal-cloud-setup/SKILL.md"
            },
            {
              "name": "temporal-developer",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/temporal/skills/temporal-developer/SKILL.md"
            },
            {
              "name": "temporal-ops",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/temporal/skills/temporal-ops/SKILL.md"
            },
            {
              "name": "temporal-serverless",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/temporal/skills/temporal-serverless/SKILL.md"
            }
          ],
          "mcpServers": [],
          "components": ["skills"],
          "componentInspection": "repository",
          "inspectionError": null,
          "installation": "requires_adapter",
          "upstream": {
            "source": {
              "source": "local",
              "path": "./plugins/temporal"
            },
            "policy": {
              "installation": "AVAILABLE",
              "authentication": "ON_INSTALL"
            }
          }
        },
        {
          "id": "openai:hyperframes",
          "name": "hyperframes",
          "displayName": "HyperFrames by HeyGen",
          "description": "Write HTML, render video",
          "longDescription": "Build videos from HTML with HyperFrames. Author compositions with HTML + CSS + GSAP, use the CLI for init/preview/render/transcribe/tts, install reusable registry blocks and components, follow the GSAP animation reference, and turn any website into a video with the 7-step capture-to-video pipeline.",
          "category": "Creativity",
          "keywords": [
            "hyperframes",
            "video",
            "html",
            "gsap",
            "animation",
            "composition",
            "rendering",
            "captions",
            "tts",
            "audio-reactive"
          ],
          "author": {
            "name": "HeyGen",
            "email": "hyperframes@heygen.com",
            "url": "https://hyperframes.heygen.com"
          },
          "version": "0.1.2",
          "license": "Apache-2.0",
          "logoUrl": "https://raw.githubusercontent.com/openai/plugins/d416fd5a43426019986b1e489506db3db66dee3d/plugins/hyperframes/assets/logo.png",
          "darkLogoUrl": null,
          "homepage": "https://hyperframes.heygen.com",
          "sourceUrl": "https://github.com/openai/plugins/tree/d416fd5a43426019986b1e489506db3db66dee3d/plugins/hyperframes",
          "skills": [
            {
              "name": "gsap",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/hyperframes/skills/gsap/SKILL.md"
            },
            {
              "name": "hyperframes-cli",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/hyperframes/skills/hyperframes-cli/SKILL.md"
            },
            {
              "name": "hyperframes-registry",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/hyperframes/skills/hyperframes-registry/SKILL.md"
            },
            {
              "name": "hyperframes",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/hyperframes/skills/hyperframes/SKILL.md"
            },
            {
              "name": "website-to-hyperframes",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/hyperframes/skills/website-to-hyperframes/SKILL.md"
            }
          ],
          "mcpServers": [],
          "components": ["skills"],
          "componentInspection": "repository",
          "inspectionError": null,
          "installation": "requires_adapter",
          "upstream": {
            "source": {
              "source": "local",
              "path": "./plugins/hyperframes"
            },
            "policy": {
              "installation": "AVAILABLE",
              "authentication": "ON_INSTALL",
              "products": ["CODEX"]
            }
          }
        },
        {
          "id": "openai:supabase",
          "name": "supabase",
          "displayName": "Supabase",
          "description": "Manage and query databases",
          "longDescription": "Official Supabase plugin for Codex. Includes agent skills for Supabase development and Postgres best practices, plus MCP server integration for managing your Supabase projects directly from Codex.",
          "category": "Developer Tools",
          "keywords": ["supabase", "postgres", "database", "backend", "mcp"],
          "author": {
            "email": "support@supabase.io",
            "name": "Supabase",
            "url": "https://supabase.com"
          },
          "version": "1.0.0",
          "license": "MIT",
          "logoUrl": "https://raw.githubusercontent.com/openai/plugins/d416fd5a43426019986b1e489506db3db66dee3d/plugins/supabase/assets/logo.png",
          "darkLogoUrl": null,
          "homepage": "https://supabase.com",
          "sourceUrl": "https://github.com/openai/plugins/tree/d416fd5a43426019986b1e489506db3db66dee3d/plugins/supabase",
          "skills": [
            {
              "name": "supabase-postgres-best-practices",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/supabase/skills/supabase-postgres-best-practices/SKILL.md"
            },
            {
              "name": "supabase",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/supabase/skills/supabase/SKILL.md"
            }
          ],
          "mcpServers": [
            {
              "requiresConfiguration": false,
              "name": "supabase",
              "transport": "http",
              "endpoint": "https://mcp.supabase.com/mcp"
            }
          ],
          "components": ["skills", "mcp", "apps"],
          "componentInspection": "repository",
          "inspectionError": null,
          "installation": "requires_adapter",
          "upstream": {
            "source": {
              "source": "local",
              "path": "./plugins/supabase"
            },
            "policy": {
              "installation": "AVAILABLE",
              "authentication": "ON_INSTALL"
            }
          }
        },
        {
          "id": "openai:codex-security",
          "name": "codex-security",
          "displayName": "Codex Security",
          "description": "Scan your codebase for risks",
          "longDescription": "Codex Security packages reusable workflows for security scans, analysis, validation, and investigation across code, diffs, and related artifacts.",
          "category": "Security",
          "keywords": ["security", "code-review", "diff-review", "appsec", "threat-modeling"],
          "author": {
            "name": "OpenAI"
          },
          "version": "0.1.22",
          "license": "Proprietary",
          "logoUrl": "https://raw.githubusercontent.com/openai/plugins/d416fd5a43426019986b1e489506db3db66dee3d/plugins/codex-security/assets/logo.png",
          "darkLogoUrl": null,
          "homepage": "https://developers.openai.com/codex/security",
          "sourceUrl": "https://github.com/openai/plugins/tree/d416fd5a43426019986b1e489506db3db66dee3d/plugins/codex-security",
          "skills": [
            {
              "name": "attack-path-analysis",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/codex-security/skills/attack-path-analysis/SKILL.md"
            },
            {
              "name": "deep-security-scan",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/codex-security/skills/deep-security-scan/SKILL.md"
            },
            {
              "name": "define-security-policy",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/codex-security/skills/define-security-policy/SKILL.md"
            },
            {
              "name": "finding-discovery",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/codex-security/skills/finding-discovery/SKILL.md"
            },
            {
              "name": "fix-finding",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/codex-security/skills/fix-finding/SKILL.md"
            },
            {
              "name": "propose-security-hardening",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/codex-security/skills/propose-security-hardening/SKILL.md"
            },
            {
              "name": "security-diff-scan",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/codex-security/skills/security-diff-scan/SKILL.md"
            },
            {
              "name": "security-scan",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/codex-security/skills/security-scan/SKILL.md"
            },
            {
              "name": "threat-model",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/codex-security/skills/threat-model/SKILL.md"
            },
            {
              "name": "track-findings",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/codex-security/skills/track-findings/SKILL.md"
            },
            {
              "name": "triage-finding",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/codex-security/skills/triage-finding/SKILL.md"
            },
            {
              "name": "validation",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/codex-security/skills/validation/SKILL.md"
            },
            {
              "name": "verify-fix",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/codex-security/skills/verify-fix/SKILL.md"
            },
            {
              "name": "vulnerability-writeup",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/codex-security/skills/vulnerability-writeup/SKILL.md"
            }
          ],
          "mcpServers": [
            {
              "requiresConfiguration": false,
              "name": "codex-security",
              "transport": "stdio",
              "endpoint": null
            }
          ],
          "components": ["skills", "mcp", "apps"],
          "componentInspection": "repository",
          "inspectionError": null,
          "installation": "requires_adapter",
          "upstream": {
            "source": {
              "source": "local",
              "path": "./plugins/codex-security"
            },
            "policy": {
              "installation": "AVAILABLE",
              "authentication": "ON_USE",
              "products": ["CODEX"]
            }
          }
        },
        {
          "id": "openai:twilio-developer-kit",
          "name": "twilio-developer-kit",
          "displayName": "Twilio Developer Kit",
          "description": "Twilio Skills for building, debugging, and shipping on Twilio",
          "longDescription": "Procedural knowledge that guides AI coding agents to the right Twilio APIs for any use case. Covers channel selection, production best practices, compliance requirements, and common pitfalls across Messaging, Voice, Verify, SendGrid, and 30+ products. Skills follow a progressive disclosure architecture — your agent sees lightweight metadata at startup and loads full guidance only when a task matches.",
          "category": "Developer Tools",
          "keywords": [
            "twilio",
            "sms",
            "voice",
            "whatsapp",
            "rcs",
            "messaging",
            "verify",
            "sendgrid",
            "email",
            "compliance",
            "conversation-relay",
            "conversation-memory",
            "conversation-intelligence",
            "conversation-orchestrator",
            "agent-connect",
            "enterprise-knowledge",
            "apple-messages-for-business",
            "api"
          ],
          "author": {
            "name": "Twilio",
            "url": "https://www.twilio.com"
          },
          "version": "0.2.2",
          "license": "MIT",
          "logoUrl": "https://raw.githubusercontent.com/openai/plugins/d416fd5a43426019986b1e489506db3db66dee3d/plugins/twilio-developer-kit/assets/logo.svg",
          "darkLogoUrl": null,
          "homepage": "https://www.twilio.com/docs",
          "sourceUrl": "https://github.com/openai/plugins/tree/d416fd5a43426019986b1e489506db3db66dee3d/plugins/twilio-developer-kit",
          "skills": [
            {
              "name": "twilio-account-setup",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/twilio-developer-kit/skills/twilio-account-setup/SKILL.md"
            },
            {
              "name": "twilio-agent-augmentation-architect",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/twilio-developer-kit/skills/twilio-agent-augmentation-architect/SKILL.md"
            },
            {
              "name": "twilio-agent-connect",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/twilio-developer-kit/skills/twilio-agent-connect/SKILL.md"
            },
            {
              "name": "twilio-ai-agent-architect",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/twilio-developer-kit/skills/twilio-ai-agent-architect/SKILL.md"
            },
            {
              "name": "twilio-call-recordings",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/twilio-developer-kit/skills/twilio-call-recordings/SKILL.md"
            },
            {
              "name": "twilio-cli-reference",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/twilio-developer-kit/skills/twilio-cli-reference/SKILL.md"
            },
            {
              "name": "twilio-compliance-onboarding",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/twilio-developer-kit/skills/twilio-compliance-onboarding/SKILL.md"
            },
            {
              "name": "twilio-compliance-traffic",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/twilio-developer-kit/skills/twilio-compliance-traffic/SKILL.md"
            },
            {
              "name": "twilio-conference-calls",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/twilio-developer-kit/skills/twilio-conference-calls/SKILL.md"
            },
            {
              "name": "twilio-content-template-builder",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/twilio-developer-kit/skills/twilio-content-template-builder/SKILL.md"
            },
            {
              "name": "twilio-conversation-intelligence",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/twilio-developer-kit/skills/twilio-conversation-intelligence/SKILL.md"
            },
            {
              "name": "twilio-conversation-orchestrator",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/twilio-developer-kit/skills/twilio-conversation-orchestrator/SKILL.md"
            },
            {
              "name": "twilio-conversations-classic-api",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/twilio-developer-kit/skills/twilio-conversations-classic-api/SKILL.md"
            },
            {
              "name": "twilio-customer-memory",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/twilio-developer-kit/skills/twilio-customer-memory/SKILL.md"
            },
            {
              "name": "twilio-customer-support-architect",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/twilio-developer-kit/skills/twilio-customer-support-architect/SKILL.md"
            },
            {
              "name": "twilio-debugging-observability",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/twilio-developer-kit/skills/twilio-debugging-observability/SKILL.md"
            },
            {
              "name": "twilio-email-deliverability-advisor",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/twilio-developer-kit/skills/twilio-email-deliverability-advisor/SKILL.md"
            },
            {
              "name": "twilio-email-send",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/twilio-developer-kit/skills/twilio-email-send/SKILL.md"
            },
            {
              "name": "twilio-enterprise-knowledge",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/twilio-developer-kit/skills/twilio-enterprise-knowledge/SKILL.md"
            },
            {
              "name": "twilio-iam-auth-setup",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/twilio-developer-kit/skills/twilio-iam-auth-setup/SKILL.md"
            },
            {
              "name": "twilio-identity-verification-advisor",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/twilio-developer-kit/skills/twilio-identity-verification-advisor/SKILL.md"
            },
            {
              "name": "twilio-lookup-phone-intelligence",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/twilio-developer-kit/skills/twilio-lookup-phone-intelligence/SKILL.md"
            },
            {
              "name": "twilio-marketing-promotions-advisor",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/twilio-developer-kit/skills/twilio-marketing-promotions-advisor/SKILL.md"
            },
            {
              "name": "twilio-messaging-channel-advisor",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/twilio-developer-kit/skills/twilio-messaging-channel-advisor/SKILL.md"
            },
            {
              "name": "twilio-messaging-overview",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/twilio-developer-kit/skills/twilio-messaging-overview/SKILL.md"
            },
            {
              "name": "twilio-messaging-services",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/twilio-developer-kit/skills/twilio-messaging-services/SKILL.md"
            },
            {
              "name": "twilio-messaging-webhooks",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/twilio-developer-kit/skills/twilio-messaging-webhooks/SKILL.md"
            },
            {
              "name": "twilio-notifications-alerts-advisor",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/twilio-developer-kit/skills/twilio-notifications-alerts-advisor/SKILL.md"
            },
            {
              "name": "twilio-numbers-senders",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/twilio-developer-kit/skills/twilio-numbers-senders/SKILL.md"
            },
            {
              "name": "twilio-organizations-setup",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/twilio-developer-kit/skills/twilio-organizations-setup/SKILL.md"
            },
            {
              "name": "twilio-rcs-messaging",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/twilio-developer-kit/skills/twilio-rcs-messaging/SKILL.md"
            },
            {
              "name": "twilio-regulatory-compliance-bundles",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/twilio-developer-kit/skills/twilio-regulatory-compliance-bundles/SKILL.md"
            },
            {
              "name": "twilio-reliability-patterns",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/twilio-developer-kit/skills/twilio-reliability-patterns/SKILL.md"
            },
            {
              "name": "twilio-security-api-auth",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/twilio-developer-kit/skills/twilio-security-api-auth/SKILL.md"
            },
            {
              "name": "twilio-security-compliance-hipaa",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/twilio-developer-kit/skills/twilio-security-compliance-hipaa/SKILL.md"
            },
            {
              "name": "twilio-security-hardening",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/twilio-developer-kit/skills/twilio-security-hardening/SKILL.md"
            },
            {
              "name": "twilio-send-message",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/twilio-developer-kit/skills/twilio-send-message/SKILL.md"
            },
            {
              "name": "twilio-sendgrid-account-setup",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/twilio-developer-kit/skills/twilio-sendgrid-account-setup/SKILL.md"
            },
            {
              "name": "twilio-sendgrid-deliverability-advisor",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/twilio-developer-kit/skills/twilio-sendgrid-deliverability-advisor/SKILL.md"
            },
            {
              "name": "twilio-sendgrid-email-send",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/twilio-developer-kit/skills/twilio-sendgrid-email-send/SKILL.md"
            },
            {
              "name": "twilio-sendgrid-email-settings",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/twilio-developer-kit/skills/twilio-sendgrid-email-settings/SKILL.md"
            },
            {
              "name": "twilio-sendgrid-engagement-quality",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/twilio-developer-kit/skills/twilio-sendgrid-engagement-quality/SKILL.md"
            },
            {
              "name": "twilio-sendgrid-inbound-parse",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/twilio-developer-kit/skills/twilio-sendgrid-inbound-parse/SKILL.md"
            },
            {
              "name": "twilio-sendgrid-suppressions",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/twilio-developer-kit/skills/twilio-sendgrid-suppressions/SKILL.md"
            },
            {
              "name": "twilio-sendgrid-webhooks",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/twilio-developer-kit/skills/twilio-sendgrid-webhooks/SKILL.md"
            },
            {
              "name": "twilio-sms-isv-setup",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/twilio-developer-kit/skills/twilio-sms-isv-setup/SKILL.md"
            },
            {
              "name": "twilio-sms-send-message",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/twilio-developer-kit/skills/twilio-sms-send-message/SKILL.md"
            },
            {
              "name": "twilio-taskrouter-routing",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/twilio-developer-kit/skills/twilio-taskrouter-routing/SKILL.md"
            },
            {
              "name": "twilio-verify-send-otp",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/twilio-developer-kit/skills/twilio-verify-send-otp/SKILL.md"
            },
            {
              "name": "twilio-voice-conversation-relay",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/twilio-developer-kit/skills/twilio-voice-conversation-relay/SKILL.md"
            },
            {
              "name": "twilio-voice-outbound-calls",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/twilio-developer-kit/skills/twilio-voice-outbound-calls/SKILL.md"
            },
            {
              "name": "twilio-voice-twiml",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/twilio-developer-kit/skills/twilio-voice-twiml/SKILL.md"
            },
            {
              "name": "twilio-webhook-architecture",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/twilio-developer-kit/skills/twilio-webhook-architecture/SKILL.md"
            },
            {
              "name": "twilio-whatsapp-manage-senders",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/twilio-developer-kit/skills/twilio-whatsapp-manage-senders/SKILL.md"
            },
            {
              "name": "twilio-whatsapp-send-message",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/twilio-developer-kit/skills/twilio-whatsapp-send-message/SKILL.md"
            }
          ],
          "mcpServers": [],
          "components": ["skills"],
          "componentInspection": "repository",
          "inspectionError": null,
          "installation": "requires_adapter",
          "upstream": {
            "source": {
              "source": "local",
              "path": "./plugins/twilio-developer-kit"
            },
            "policy": {
              "installation": "AVAILABLE",
              "authentication": "ON_INSTALL"
            }
          }
        },
        {
          "id": "openai:openai-developers",
          "name": "openai-developers",
          "displayName": "OpenAI Developers",
          "description": "Develop AI apps, agents, and ChatGPT Apps with OpenAI best practices",
          "longDescription": "Use OpenAI Developers in Codex to build AI applications, agents, and ChatGPT Apps with OpenAI docs, the OpenAI API, Apps SDK, and Agents SDK. Connect to the OpenAI Platform (platform.openai.com) and see your Codex-built apps work right out of the box with real OpenAI API keys. Run and locally deploy Agents SDK projects through the Deployment Manager, scaffold ChatGPT Apps, and prepare ChatGPT Apps submission artifacts.",
          "category": "Developer Tools",
          "keywords": [
            "openai-platform",
            "api-key",
            "agents-sdk",
            "agents",
            "chatgpt-apps",
            "apps-sdk",
            "mcp",
            "submissions",
            "codex"
          ],
          "author": {
            "name": "OpenAI",
            "email": "support@openai.com",
            "url": "https://openai.com/"
          },
          "version": "1.2.3",
          "license": "Proprietary",
          "logoUrl": "https://raw.githubusercontent.com/openai/plugins/d416fd5a43426019986b1e489506db3db66dee3d/plugins/openai-developers/assets/logo.png",
          "darkLogoUrl": null,
          "homepage": "https://platform.openai.com/",
          "sourceUrl": "https://github.com/openai/plugins/tree/d416fd5a43426019986b1e489506db3db66dee3d/plugins/openai-developers",
          "skills": [
            {
              "name": "agents-sdk",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/openai-developers/skills/agents-sdk/SKILL.md"
            },
            {
              "name": "build-chatgpt-app",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/openai-developers/skills/build-chatgpt-app/SKILL.md"
            },
            {
              "name": "chatgpt-app-submission",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/openai-developers/skills/chatgpt-app-submission/SKILL.md"
            },
            {
              "name": "openai-api-troubleshooting",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/openai-developers/skills/openai-api-troubleshooting/SKILL.md"
            },
            {
              "name": "openai-platform-api-key",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/openai-developers/skills/openai-platform-api-key/SKILL.md"
            }
          ],
          "mcpServers": [
            {
              "requiresConfiguration": false,
              "name": "openai-api-key-local-confirmation",
              "transport": "stdio",
              "endpoint": null
            }
          ],
          "components": ["skills", "mcp", "apps"],
          "componentInspection": "repository",
          "inspectionError": null,
          "installation": "requires_adapter",
          "upstream": {
            "source": {
              "source": "local",
              "path": "./plugins/openai-developers"
            },
            "policy": {
              "installation": "AVAILABLE",
              "authentication": "ON_INSTALL",
              "products": ["CODEX"]
            }
          }
        },
        {
          "id": "openai:datadog",
          "name": "datadog",
          "displayName": "Datadog (Preview)",
          "description": "Search and act on your data",
          "longDescription": "Available for US1 customers only. Analyze, investigate, and act on your Datadog telemetry directly from ChatGPT using natural language. Ask questions about your production applications, identify, visualize, and remediate issues in your critical services. Run agentic loops to ensure you continue to maintain good observability and service management posture.",
          "category": "Developer Tools",
          "keywords": [],
          "author": {
            "name": "Datadog"
          },
          "version": "10.0.0",
          "license": null,
          "logoUrl": "https://raw.githubusercontent.com/openai/plugins/d416fd5a43426019986b1e489506db3db66dee3d/plugins/datadog/assets/logo.png",
          "darkLogoUrl": null,
          "homepage": null,
          "sourceUrl": "https://github.com/openai/plugins/tree/d416fd5a43426019986b1e489506db3db66dee3d/plugins/datadog",
          "skills": [],
          "mcpServers": [
            {
              "requiresConfiguration": false,
              "name": "datadog",
              "transport": "http",
              "endpoint": "https://mcp.datadoghq.com/v1/mcp"
            }
          ],
          "components": ["mcp", "apps"],
          "componentInspection": "repository",
          "inspectionError": null,
          "installation": "requires_adapter",
          "upstream": {
            "source": {
              "source": "local",
              "path": "./plugins/datadog"
            },
            "policy": {
              "installation": "AVAILABLE",
              "authentication": "ON_INSTALL"
            }
          }
        },
        {
          "id": "openai:zoom",
          "name": "zoom",
          "displayName": "Zoom",
          "description": "Smart meeting insights from Zoom",
          "longDescription": "Zoom connects Codex to Zoom meeting context through the Zoom app connector and provides developer workflows for planning, building, debugging, and reviewing Zoom integrations across APIs, SDKs, webhooks, WebSockets, bots, and automation use cases.",
          "category": "Communication",
          "keywords": [
            "zoom",
            "codex-plugin",
            "connector",
            "meetings",
            "transcripts",
            "recordings",
            "docs",
            "developers",
            "rest-api",
            "meeting-sdk",
            "video-sdk",
            "webhooks",
            "oauth"
          ],
          "author": {
            "name": "Zoom",
            "url": "https://github.com/zoom"
          },
          "version": "1.0.0",
          "license": "MIT",
          "logoUrl": "https://raw.githubusercontent.com/openai/plugins/d416fd5a43426019986b1e489506db3db66dee3d/plugins/zoom/assets/logo.jpg",
          "darkLogoUrl": "https://raw.githubusercontent.com/openai/plugins/d416fd5a43426019986b1e489506db3db66dee3d/plugins/zoom/assets/logo-dark.jpg",
          "homepage": "https://developers.zoom.us/",
          "sourceUrl": "https://github.com/openai/plugins/tree/d416fd5a43426019986b1e489506db3db66dee3d/plugins/zoom",
          "skills": [
            {
              "name": "build-zoom-bot",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/zoom/skills/build-zoom-bot/SKILL.md"
            },
            {
              "name": "build-zoom-meeting-app",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/zoom/skills/build-zoom-meeting-app/SKILL.md"
            },
            {
              "name": "choose-zoom-approach",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/zoom/skills/choose-zoom-approach/SKILL.md"
            },
            {
              "name": "cobrowse-sdk",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/zoom/skills/cobrowse-sdk/SKILL.md"
            },
            {
              "name": "contact-center",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/zoom/skills/contact-center/SKILL.md"
            },
            {
              "name": "android",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/zoom/skills/contact-center/android/SKILL.md"
            },
            {
              "name": "ios",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/zoom/skills/contact-center/ios/SKILL.md"
            },
            {
              "name": "web",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/zoom/skills/contact-center/web/SKILL.md"
            },
            {
              "name": "debug-zoom-integration",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/zoom/skills/debug-zoom-integration/SKILL.md"
            },
            {
              "name": "debug-zoom",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/zoom/skills/debug-zoom/SKILL.md"
            },
            {
              "name": "general",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/zoom/skills/general/SKILL.md"
            },
            {
              "name": "meeting-sdk",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/zoom/skills/meeting-sdk/SKILL.md"
            },
            {
              "name": "android",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/zoom/skills/meeting-sdk/android/SKILL.md"
            },
            {
              "name": "electron",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/zoom/skills/meeting-sdk/electron/SKILL.md"
            },
            {
              "name": "ios",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/zoom/skills/meeting-sdk/ios/SKILL.md"
            },
            {
              "name": "linux",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/zoom/skills/meeting-sdk/linux/SKILL.md"
            },
            {
              "name": "macos",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/zoom/skills/meeting-sdk/macos/SKILL.md"
            },
            {
              "name": "react-native",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/zoom/skills/meeting-sdk/react-native/SKILL.md"
            },
            {
              "name": "unreal",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/zoom/skills/meeting-sdk/unreal/SKILL.md"
            },
            {
              "name": "web",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/zoom/skills/meeting-sdk/web/SKILL.md"
            },
            {
              "name": "client-view",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/zoom/skills/meeting-sdk/web/client-view/SKILL.md"
            },
            {
              "name": "component-view",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/zoom/skills/meeting-sdk/web/component-view/SKILL.md"
            },
            {
              "name": "windows",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/zoom/skills/meeting-sdk/windows/SKILL.md"
            },
            {
              "name": "oauth",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/zoom/skills/oauth/SKILL.md"
            },
            {
              "name": "phone",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/zoom/skills/phone/SKILL.md"
            },
            {
              "name": "plan-zoom-integration",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/zoom/skills/plan-zoom-integration/SKILL.md"
            },
            {
              "name": "plan-zoom-product",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/zoom/skills/plan-zoom-product/SKILL.md"
            },
            {
              "name": "probe-sdk",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/zoom/skills/probe-sdk/SKILL.md"
            },
            {
              "name": "rest-api",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/zoom/skills/rest-api/SKILL.md"
            },
            {
              "name": "rivet-sdk",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/zoom/skills/rivet-sdk/SKILL.md"
            },
            {
              "name": "rtms",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/zoom/skills/rtms/SKILL.md"
            },
            {
              "name": "scribe",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/zoom/skills/scribe/SKILL.md"
            },
            {
              "name": "setup-zoom-oauth",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/zoom/skills/setup-zoom-oauth/SKILL.md"
            },
            {
              "name": "start",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/zoom/skills/start/SKILL.md"
            },
            {
              "name": "team-chat",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/zoom/skills/team-chat/SKILL.md"
            },
            {
              "name": "ui-toolkit",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/zoom/skills/ui-toolkit/SKILL.md"
            },
            {
              "name": "video-sdk",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/zoom/skills/video-sdk/SKILL.md"
            },
            {
              "name": "android",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/zoom/skills/video-sdk/android/SKILL.md"
            },
            {
              "name": "flutter",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/zoom/skills/video-sdk/flutter/SKILL.md"
            },
            {
              "name": "ios",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/zoom/skills/video-sdk/ios/SKILL.md"
            },
            {
              "name": "linux",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/zoom/skills/video-sdk/linux/SKILL.md"
            },
            {
              "name": "macos",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/zoom/skills/video-sdk/macos/SKILL.md"
            },
            {
              "name": "react-native",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/zoom/skills/video-sdk/react-native/SKILL.md"
            },
            {
              "name": "unity",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/zoom/skills/video-sdk/unity/SKILL.md"
            },
            {
              "name": "web",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/zoom/skills/video-sdk/web/SKILL.md"
            },
            {
              "name": "windows",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/zoom/skills/video-sdk/windows/SKILL.md"
            },
            {
              "name": "virtual-agent",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/zoom/skills/virtual-agent/SKILL.md"
            },
            {
              "name": "android",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/zoom/skills/virtual-agent/android/SKILL.md"
            },
            {
              "name": "ios",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/zoom/skills/virtual-agent/ios/SKILL.md"
            },
            {
              "name": "web",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/zoom/skills/virtual-agent/web/SKILL.md"
            },
            {
              "name": "webhooks",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/zoom/skills/webhooks/SKILL.md"
            },
            {
              "name": "websockets",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/zoom/skills/websockets/SKILL.md"
            },
            {
              "name": "zoom-apps-sdk",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/zoom/skills/zoom-apps-sdk/SKILL.md"
            }
          ],
          "mcpServers": [
            {
              "requiresConfiguration": false,
              "name": "zoom",
              "transport": "http",
              "endpoint": "https://mcp.zoom.us/mcp/meeting/streamable"
            }
          ],
          "components": ["skills", "mcp", "apps", "agents", "commands"],
          "componentInspection": "repository",
          "inspectionError": null,
          "installation": "requires_adapter",
          "upstream": {
            "source": {
              "source": "local",
              "path": "./plugins/zoom"
            },
            "policy": {
              "installation": "AVAILABLE",
              "authentication": "ON_INSTALL"
            }
          }
        },
        {
          "id": "openai:mixpanel-headless",
          "name": "mixpanel-headless",
          "displayName": "Mixpanel Headless",
          "description": "Analyze Mixpanel data with Python",
          "longDescription": "Use Mixpanel Headless skills to install and authenticate the mixpanel_headless Python SDK, discover Mixpanel schemas, run segmentation, funnel, retention, flow, and user-profile analyses, and build or inspect Mixpanel dashboards from Codex.",
          "category": "Data & Analytics",
          "keywords": [
            "mixpanel",
            "analytics",
            "product-analytics",
            "python",
            "data-science",
            "funnels",
            "retention",
            "flows",
            "dashboards"
          ],
          "author": {
            "name": "Mixpanel",
            "url": "https://mixpanel.com/home"
          },
          "version": "0.1.2",
          "license": "MIT",
          "logoUrl": "https://raw.githubusercontent.com/openai/plugins/d416fd5a43426019986b1e489506db3db66dee3d/plugins/mixpanel-headless/assets/logo.png",
          "darkLogoUrl": null,
          "homepage": "https://mixpanel.github.io/mixpanel-headless/",
          "sourceUrl": "https://github.com/openai/plugins/tree/d416fd5a43426019986b1e489506db3db66dee3d/plugins/mixpanel-headless",
          "skills": [
            {
              "name": "dashboard-expert",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/mixpanel-headless/skills/dashboard-expert/SKILL.md"
            },
            {
              "name": "mixpanel-auth",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/mixpanel-headless/skills/mixpanel-auth/SKILL.md"
            },
            {
              "name": "mixpanelyst",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/mixpanel-headless/skills/mixpanelyst/SKILL.md"
            },
            {
              "name": "setup",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/mixpanel-headless/skills/setup/SKILL.md"
            }
          ],
          "mcpServers": [],
          "components": ["skills"],
          "componentInspection": "repository",
          "inspectionError": null,
          "installation": "requires_adapter",
          "upstream": {
            "source": {
              "source": "local",
              "path": "./plugins/mixpanel-headless"
            },
            "policy": {
              "installation": "AVAILABLE",
              "authentication": "ON_INSTALL"
            }
          }
        },
        {
          "id": "openai:airtable",
          "name": "airtable",
          "displayName": "Airtable",
          "description": "Add structured data to ChatGPT",
          "longDescription": "Bring operational data and context into the flow of your ChatGPT conversations. You can ask questions, create and update records, and analyze your data—all through conversation. Use the data in Airtable as input to the work you’re doing in ChatGPT, like building a landing page using content you’ve organized in Airtable. Make quick updates to Airtable without leaving the chat. Airtable for ChatGPT is ideal anytime you need quick access to structured internal data to inform your conversation.\n\nAirtable's App connects ChatGPT directly to your Airtable bases, so you can ask questions, create and update records, and analyze your data—all through conversation",
          "category": "Productivity",
          "keywords": [],
          "author": {
            "name": "Airtable"
          },
          "version": "6.0.1",
          "license": null,
          "logoUrl": "https://raw.githubusercontent.com/openai/plugins/d416fd5a43426019986b1e489506db3db66dee3d/plugins/airtable/assets/logo.png",
          "darkLogoUrl": null,
          "homepage": null,
          "sourceUrl": "https://github.com/openai/plugins/tree/d416fd5a43426019986b1e489506db3db66dee3d/plugins/airtable",
          "skills": [
            {
              "name": "airtable-cli",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/airtable/skills/airtable-cli/SKILL.md"
            },
            {
              "name": "airtable-filters",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/airtable/skills/airtable-filters/SKILL.md"
            },
            {
              "name": "airtable-overview",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/airtable/skills/airtable-overview/SKILL.md"
            }
          ],
          "mcpServers": [
            {
              "requiresConfiguration": false,
              "name": "airtable",
              "transport": "http",
              "endpoint": "https://mcp.airtable.com/mcp"
            }
          ],
          "components": ["skills", "mcp", "apps"],
          "componentInspection": "repository",
          "inspectionError": null,
          "installation": "requires_adapter",
          "upstream": {
            "source": {
              "source": "local",
              "path": "./plugins/airtable"
            },
            "policy": {
              "installation": "AVAILABLE",
              "authentication": "ON_INSTALL"
            }
          }
        },
        {
          "id": "openai:nvidia",
          "name": "nvidia",
          "displayName": "NVIDIA",
          "description": "Guided help for NVIDIA AI, GPU, robotics, simulation, and 3D workflows.",
          "longDescription": "NVIDIAs ecosystem spans GPU acceleration, CUDA, AI agents, inference, robotics, Physical AI, Omniverse, and simulation. This plugin helps you understand the pieces, choose a path, validate your setup, and build practical NVIDIA-powered workflows.",
          "category": "Developer Tools",
          "keywords": [
            "nvidia",
            "gpu",
            "cuda",
            "ai-agents",
            "inference",
            "llm-serving",
            "robotics",
            "simulation",
            "omniverse",
            "openusd",
            "digital-twin",
            "physical-ai",
            "cad"
          ],
          "author": {
            "name": "NVIDIA",
            "url": "https://github.com/NVIDIA/skills"
          },
          "version": "1.0.4",
          "license": "Apache-2.0 AND CC-BY-4.0",
          "logoUrl": "https://raw.githubusercontent.com/openai/plugins/d416fd5a43426019986b1e489506db3db66dee3d/plugins/nvidia/assets/nvidia.png",
          "darkLogoUrl": null,
          "homepage": "https://build.nvidia.com/skills/",
          "sourceUrl": "https://github.com/openai/plugins/tree/d416fd5a43426019986b1e489506db3db66dee3d/plugins/nvidia",
          "skills": [
            {
              "name": "aiq-deploy",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/nvidia/skills/aiq-deploy/SKILL.md"
            },
            {
              "name": "aiq-research",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/nvidia/skills/aiq-research/SKILL.md"
            },
            {
              "name": "cuopt-user-rules",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/nvidia/skills/cuopt-user-rules/SKILL.md"
            },
            {
              "name": "dynamo-interconnect-check",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/nvidia/skills/dynamo-interconnect-check/SKILL.md"
            },
            {
              "name": "dynamo-router-starter",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/nvidia/skills/dynamo-router-starter/SKILL.md"
            },
            {
              "name": "nemoclaw-user-get-started",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/nvidia/skills/nemoclaw-user-get-started/SKILL.md"
            },
            {
              "name": "nvidia-skill-finder",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/nvidia/skills/nvidia-skill-finder/SKILL.md"
            },
            {
              "name": "omniverse-cad-to-simready",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/nvidia/skills/omniverse-cad-to-simready/SKILL.md"
            },
            {
              "name": "omniverse-realtime-viewer",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/nvidia/skills/omniverse-realtime-viewer/SKILL.md"
            },
            {
              "name": "omniverse-usd-performance-tuning",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/nvidia/skills/omniverse-usd-performance-tuning/SKILL.md"
            },
            {
              "name": "physical-ai-infrastructure-setup-and-resilient-scaling",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/nvidia/skills/physical-ai-infrastructure-setup-and-resilient-scaling/SKILL.md"
            },
            {
              "name": "physical-ai-neural-reconstruction",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/nvidia/skills/physical-ai-neural-reconstruction/SKILL.md"
            }
          ],
          "mcpServers": [],
          "components": ["skills"],
          "componentInspection": "repository",
          "inspectionError": null,
          "installation": "requires_adapter",
          "upstream": {
            "source": {
              "source": "local",
              "path": "./plugins/nvidia"
            },
            "policy": {
              "installation": "AVAILABLE",
              "authentication": "ON_INSTALL"
            }
          }
        },
        {
          "id": "openai:posthog",
          "name": "posthog",
          "displayName": "PostHog",
          "description": "Analyze your product data",
          "longDescription": "PostHog gives your AI agent direct access to your product analytics, feature flags, experiments, error tracking, surveys, logs, and LLM analytics. Ask questions about your data, create insights, toggle feature flags, analyze errors, search docs, and more — all from chat.",
          "category": "Data & Analytics",
          "keywords": [
            "posthog",
            "analytics",
            "product-analytics",
            "feature-flags",
            "experiments",
            "error-tracking",
            "session-replay",
            "surveys",
            "llm-analytics",
            "hogql",
            "developer-tools"
          ],
          "author": {
            "name": "PostHog Inc.",
            "url": "https://posthog.com"
          },
          "version": "1.0.0",
          "license": "MIT",
          "logoUrl": "https://raw.githubusercontent.com/openai/plugins/d416fd5a43426019986b1e489506db3db66dee3d/plugins/posthog/assets/logo.png",
          "darkLogoUrl": "https://raw.githubusercontent.com/openai/plugins/d416fd5a43426019986b1e489506db3db66dee3d/plugins/posthog/assets/logo-dark.png",
          "homepage": "https://posthog.com/docs",
          "sourceUrl": "https://github.com/openai/plugins/tree/d416fd5a43426019986b1e489506db3db66dee3d/plugins/posthog",
          "skills": [
            {
              "name": "posthog",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/posthog/skills/posthog/SKILL.md"
            }
          ],
          "mcpServers": [
            {
              "requiresConfiguration": false,
              "name": "posthog",
              "transport": "http",
              "endpoint": "https://mcp.posthog.com/mcp"
            }
          ],
          "components": ["skills", "mcp", "apps"],
          "componentInspection": "repository",
          "inspectionError": null,
          "installation": "requires_adapter",
          "upstream": {
            "source": {
              "source": "local",
              "path": "./plugins/posthog"
            },
            "policy": {
              "installation": "AVAILABLE",
              "authentication": "ON_INSTALL"
            }
          }
        },
        {
          "id": "openai:ngs-analysis",
          "name": "ngs-analysis",
          "displayName": "Life Sciences NGS Analysis",
          "description": "Guided NGS routing and local execution for sequencing analysis",
          "longDescription": "A guided intake, routing, and execution plugin for next-generation sequencing workflows. It helps Codex inspect local sequencing inputs, ask only the missing assay-specific questions, choose public or freely accessible runtime-installable packages where possible, check existing tool availability before any install, and execute supported local workflows with validation, logs, manifests, QC reports, and artifact indexes. It includes deeper decision skills for BCL demultiplexing, FASTQ QC execution and interpretation, germline, somatic and UMI-panel DNA variants, bulk RNA-seq count generation and differential expression, ATAC-seq, ChIP-seq/CUT&RUN/CUT&Tag, and embedded post-count scRNA-seq QC.",
          "category": "Education & Research",
          "keywords": [
            "ngs",
            "sequencing",
            "bioinformatics",
            "fastq",
            "bcl",
            "rnaseq",
            "scrnaseq",
            "variant-calling",
            "atacseq",
            "chipseq",
            "microbiome",
            "metagenomics",
            "pipeline-routing",
            "nextflow",
            "nf-core"
          ],
          "author": {
            "name": "OpenAI",
            "email": "support@openai.com",
            "url": "https://openai.com/"
          },
          "version": "1.0.3",
          "license": "MIT",
          "logoUrl": "https://raw.githubusercontent.com/openai/plugins/d416fd5a43426019986b1e489506db3db66dee3d/plugins/ngs-analysis/assets/app-icon.png",
          "darkLogoUrl": null,
          "homepage": "https://openai.com/",
          "sourceUrl": "https://github.com/openai/plugins/tree/d416fd5a43426019986b1e489506db3db66dee3d/plugins/ngs-analysis",
          "skills": [
            {
              "name": "ngs-amplicon-microbiome",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/ngs-analysis/skills/ngs-amplicon-microbiome/SKILL.md"
            },
            {
              "name": "ngs-analysis-router",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/ngs-analysis/skills/ngs-analysis-router/SKILL.md"
            },
            {
              "name": "ngs-atacseq-peaks-qc",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/ngs-analysis/skills/ngs-atacseq-peaks-qc/SKILL.md"
            },
            {
              "name": "ngs-bcl-to-fastq",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/ngs-analysis/skills/ngs-bcl-to-fastq/SKILL.md"
            },
            {
              "name": "ngs-bulk-rnaseq-counts-qc",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/ngs-analysis/skills/ngs-bulk-rnaseq-counts-qc/SKILL.md"
            },
            {
              "name": "ngs-bulk-rnaseq-differential-expression",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/ngs-analysis/skills/ngs-bulk-rnaseq-differential-expression/SKILL.md"
            },
            {
              "name": "ngs-bulk-rnaseq",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/ngs-analysis/skills/ngs-bulk-rnaseq/SKILL.md"
            },
            {
              "name": "ngs-chip-cutrun-peaks-qc",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/ngs-analysis/skills/ngs-chip-cutrun-peaks-qc/SKILL.md"
            },
            {
              "name": "ngs-dna-germline-variants",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/ngs-analysis/skills/ngs-dna-germline-variants/SKILL.md"
            },
            {
              "name": "ngs-dna-somatic-variants",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/ngs-analysis/skills/ngs-dna-somatic-variants/SKILL.md"
            },
            {
              "name": "ngs-dna-umi-panel-variants",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/ngs-analysis/skills/ngs-dna-umi-panel-variants/SKILL.md"
            },
            {
              "name": "ngs-dna-variant-calling",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/ngs-analysis/skills/ngs-dna-variant-calling/SKILL.md"
            },
            {
              "name": "ngs-epigenomics-peaks",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/ngs-analysis/skills/ngs-epigenomics-peaks/SKILL.md"
            },
            {
              "name": "ngs-fastq-qc",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/ngs-analysis/skills/ngs-fastq-qc/SKILL.md"
            },
            {
              "name": "ngs-runtime-env",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/ngs-analysis/skills/ngs-runtime-env/SKILL.md"
            },
            {
              "name": "ngs-scrna-seq",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/ngs-analysis/skills/ngs-scrna-seq/SKILL.md"
            },
            {
              "name": "ngs-shotgun-metagenomics",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/ngs-analysis/skills/ngs-shotgun-metagenomics/SKILL.md"
            },
            {
              "name": "scrna-seq-qc",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/ngs-analysis/skills/scrna-seq-qc/SKILL.md"
            }
          ],
          "mcpServers": [],
          "components": ["skills"],
          "componentInspection": "repository",
          "inspectionError": null,
          "installation": "requires_adapter",
          "upstream": {
            "source": {
              "source": "local",
              "path": "./plugins/ngs-analysis"
            },
            "policy": {
              "installation": "AVAILABLE",
              "authentication": "ON_INSTALL"
            }
          }
        },
        {
          "id": "openai:shopify",
          "name": "shopify",
          "displayName": "Shopify",
          "description": "Build and manage your store",
          "longDescription": "Shopify for ChatGPT makes store building and management as easy as having a conversation. Effortlessly connect your existing store or create a new online store by describing your business. Simply chat to add products, adjust inventory across locations, create discount codes, browse recent orders, view customer details, or pull analytics on your store’s performance.",
          "category": "Business & Operations",
          "keywords": [],
          "author": {
            "name": "Shopify"
          },
          "version": "3.0.0",
          "license": null,
          "logoUrl": "https://raw.githubusercontent.com/openai/plugins/d416fd5a43426019986b1e489506db3db66dee3d/plugins/shopify/assets/logo.png",
          "darkLogoUrl": null,
          "homepage": null,
          "sourceUrl": "https://github.com/openai/plugins/tree/d416fd5a43426019986b1e489506db3db66dee3d/plugins/shopify",
          "skills": [
            {
              "name": "shopify-admin",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/shopify/skills/shopify-admin/SKILL.md"
            },
            {
              "name": "shopify-app-store-review",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/shopify/skills/shopify-app-store-review/SKILL.md"
            },
            {
              "name": "shopify-custom-data",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/shopify/skills/shopify-custom-data/SKILL.md"
            },
            {
              "name": "shopify-customer",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/shopify/skills/shopify-customer/SKILL.md"
            },
            {
              "name": "shopify-dev",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/shopify/skills/shopify-dev/SKILL.md"
            },
            {
              "name": "shopify-functions",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/shopify/skills/shopify-functions/SKILL.md"
            },
            {
              "name": "shopify-hydrogen",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/shopify/skills/shopify-hydrogen/SKILL.md"
            },
            {
              "name": "shopify-liquid",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/shopify/skills/shopify-liquid/SKILL.md"
            },
            {
              "name": "shopify-onboarding-dev",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/shopify/skills/shopify-onboarding-dev/SKILL.md"
            },
            {
              "name": "shopify-onboarding-merchant",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/shopify/skills/shopify-onboarding-merchant/SKILL.md"
            },
            {
              "name": "shopify-partner",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/shopify/skills/shopify-partner/SKILL.md"
            },
            {
              "name": "shopify-payments-apps",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/shopify/skills/shopify-payments-apps/SKILL.md"
            },
            {
              "name": "shopify-polaris-admin-extensions",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/shopify/skills/shopify-polaris-admin-extensions/SKILL.md"
            },
            {
              "name": "shopify-polaris-app-home",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/shopify/skills/shopify-polaris-app-home/SKILL.md"
            },
            {
              "name": "shopify-polaris-checkout-extensions",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/shopify/skills/shopify-polaris-checkout-extensions/SKILL.md"
            },
            {
              "name": "shopify-polaris-customer-account-extensions",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/shopify/skills/shopify-polaris-customer-account-extensions/SKILL.md"
            },
            {
              "name": "shopify-pos-ui",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/shopify/skills/shopify-pos-ui/SKILL.md"
            },
            {
              "name": "shopify-storefront-graphql",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/shopify/skills/shopify-storefront-graphql/SKILL.md"
            },
            {
              "name": "shopify-use-shopify-cli",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/shopify/skills/shopify-use-shopify-cli/SKILL.md"
            },
            {
              "name": "ucp",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/shopify/skills/ucp/SKILL.md"
            }
          ],
          "mcpServers": [
            {
              "requiresConfiguration": false,
              "name": "shopify",
              "transport": "http",
              "endpoint": "https://setup.shopify.com/mcp"
            }
          ],
          "components": ["skills", "mcp", "apps"],
          "componentInspection": "repository",
          "inspectionError": null,
          "installation": "requires_adapter",
          "upstream": {
            "source": {
              "source": "local",
              "path": "./plugins/shopify"
            },
            "policy": {
              "installation": "AVAILABLE",
              "authentication": "ON_INSTALL"
            }
          }
        },
        {
          "id": "openai:magicpath",
          "name": "magicpath",
          "displayName": "MagicPath",
          "description": "Find, install, and author MagicPath UI components from Codex",
          "longDescription": "Use MagicPath through the magicpath-ai CLI to search UI components, inspect source, install React and TypeScript components into applications, work with team projects and themes, and create or edit canvas components from local code.",
          "category": "Developer Tools",
          "keywords": ["magicpath", "codex", "ui-components", "design", "react", "tailwind"],
          "author": {
            "name": "MagicPathAI",
            "url": "https://github.com/MagicPathAI"
          },
          "version": "0.1.2",
          "license": "UNLICENSED",
          "logoUrl": "https://raw.githubusercontent.com/openai/plugins/d416fd5a43426019986b1e489506db3db66dee3d/plugins/magicpath/assets/magicpath.png",
          "darkLogoUrl": null,
          "homepage": "https://github.com/MagicPathAI/agent-skills",
          "sourceUrl": "https://github.com/openai/plugins/tree/d416fd5a43426019986b1e489506db3db66dee3d/plugins/magicpath",
          "skills": [
            {
              "name": "magicpath",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/magicpath/skills/magicpath/SKILL.md"
            }
          ],
          "mcpServers": [],
          "components": ["skills"],
          "componentInspection": "repository",
          "inspectionError": null,
          "installation": "requires_adapter",
          "upstream": {
            "source": {
              "source": "local",
              "path": "./plugins/magicpath"
            },
            "policy": {
              "installation": "AVAILABLE",
              "authentication": "ON_INSTALL"
            }
          }
        },
        {
          "id": "openai:openai-ads-conversions",
          "name": "openai-ads-conversions",
          "displayName": "OpenAI Ads Conversions",
          "description": "Set up OpenAI Ads Pixel and CAPI tracking",
          "longDescription": "Use OpenAI Ads Conversions to guide Codex through adding or extending Measurement Pixel and optional Conversions API instrumentation in a repository, with local verification helpers and guidance for safe secret handling, deduplication, attribution context, and setup reporting.",
          "category": "Developer Tools",
          "keywords": ["openai-ads", "ads", "conversions", "measurement-pixel", "capi"],
          "author": {
            "name": "OpenAI",
            "email": "support@openai.com",
            "url": "https://openai.com/"
          },
          "version": "0.1.2",
          "license": "Proprietary",
          "logoUrl": "https://raw.githubusercontent.com/openai/plugins/d416fd5a43426019986b1e489506db3db66dee3d/plugins/openai-ads-conversions/assets/icon.svg",
          "darkLogoUrl": null,
          "homepage": "https://developers.openai.com/ads/",
          "sourceUrl": "https://github.com/openai/plugins/tree/d416fd5a43426019986b1e489506db3db66dee3d/plugins/openai-ads-conversions",
          "skills": [
            {
              "name": "openai-ads-conversions-setup",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/openai-ads-conversions/skills/openai-ads-conversions-setup/SKILL.md"
            }
          ],
          "mcpServers": [],
          "components": ["skills"],
          "componentInspection": "repository",
          "inspectionError": null,
          "installation": "requires_adapter",
          "upstream": {
            "source": {
              "source": "local",
              "path": "./plugins/openai-ads-conversions"
            },
            "policy": {
              "installation": "AVAILABLE",
              "authentication": "ON_INSTALL"
            }
          }
        },
        {
          "id": "openai:boltz-api-cli",
          "name": "boltz-api-cli",
          "displayName": "Boltz",
          "description": "Predict structures, screen molecules and proteins, and design binders",
          "longDescription": "Use Boltz from Codex for biomolecular modeling workflows: predict structure and binding for protein, RNA, DNA, and ligand complexes; rank small-molecule or protein libraries against targets; and design novel small molecules, peptides, antibodies, nanobodies, or custom protein binders with structures and confidence metrics.",
          "category": "Scientific Research",
          "keywords": [
            "boltz",
            "boltz-api",
            "go-cli",
            "computational-biology",
            "protein-design",
            "protein-screening",
            "small-molecule-design",
            "virtual-screening",
            "structure-prediction",
            "molecular-modeling",
            "drug-discovery",
            "biotech"
          ],
          "author": {
            "email": "support@boltz.bio",
            "name": "Boltz",
            "url": "https://boltz.bio"
          },
          "version": "0.1.1",
          "license": "MIT",
          "logoUrl": "https://raw.githubusercontent.com/openai/plugins/d416fd5a43426019986b1e489506db3db66dee3d/plugins/boltz-api-cli/assets/app-icon.png",
          "darkLogoUrl": null,
          "homepage": "https://boltz.bio",
          "sourceUrl": "https://github.com/openai/plugins/tree/d416fd5a43426019986b1e489506db3db66dee3d/plugins/boltz-api-cli",
          "skills": [
            {
              "name": "boltz-check-status",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/boltz-api-cli/skills/boltz-check-status/SKILL.md"
            },
            {
              "name": "boltz-cli-setup",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/boltz-api-cli/skills/boltz-cli-setup/SKILL.md"
            },
            {
              "name": "boltz-protein-design",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/boltz-api-cli/skills/boltz-protein-design/SKILL.md"
            },
            {
              "name": "boltz-protein-screen",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/boltz-api-cli/skills/boltz-protein-screen/SKILL.md"
            },
            {
              "name": "boltz-small-molecule-adme",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/boltz-api-cli/skills/boltz-small-molecule-adme/SKILL.md"
            },
            {
              "name": "boltz-small-molecule-design",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/boltz-api-cli/skills/boltz-small-molecule-design/SKILL.md"
            },
            {
              "name": "boltz-small-molecule-screen",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/boltz-api-cli/skills/boltz-small-molecule-screen/SKILL.md"
            },
            {
              "name": "boltz-structure-and-binding",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/boltz-api-cli/skills/boltz-structure-and-binding/SKILL.md"
            }
          ],
          "mcpServers": [],
          "components": ["skills"],
          "componentInspection": "repository",
          "inspectionError": null,
          "installation": "requires_adapter",
          "upstream": {
            "source": {
              "source": "local",
              "path": "./plugins/boltz-api-cli"
            },
            "policy": {
              "installation": "AVAILABLE",
              "authentication": "ON_INSTALL"
            }
          }
        },
        {
          "id": "openai:dropbox",
          "name": "dropbox",
          "displayName": "Dropbox",
          "description": "Access, save and share files",
          "longDescription": "The Dropbox plugin for ChatGPT connects your Dropbox files directly to ChatGPT. You can access files, save ChatGPT-generated content to Dropbox, and create sharing links without switching tools. Everything respects your existing Dropbox permissions, and ChatGPT only works with files you already have access to.",
          "category": "Productivity",
          "keywords": [],
          "author": {
            "name": "Dropbox"
          },
          "version": "5.0.1",
          "license": null,
          "logoUrl": "https://raw.githubusercontent.com/openai/plugins/d416fd5a43426019986b1e489506db3db66dee3d/plugins/dropbox/assets/logo.png",
          "darkLogoUrl": "https://raw.githubusercontent.com/openai/plugins/d416fd5a43426019986b1e489506db3db66dee3d/plugins/dropbox/assets/logo-dark.png",
          "homepage": null,
          "sourceUrl": "https://github.com/openai/plugins/tree/d416fd5a43426019986b1e489506db3db66dee3d/plugins/dropbox",
          "skills": [
            {
              "name": "clean-up-dropbox-content",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/dropbox/skills/clean-up-dropbox-content/SKILL.md"
            },
            {
              "name": "collect-files-with-request",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/dropbox/skills/collect-files-with-request/SKILL.md"
            },
            {
              "name": "find-dropbox-content",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/dropbox/skills/find-dropbox-content/SKILL.md"
            },
            {
              "name": "inspect-dropbox-file",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/dropbox/skills/inspect-dropbox-file/SKILL.md"
            },
            {
              "name": "organize-dropbox-folder",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/dropbox/skills/organize-dropbox-folder/SKILL.md"
            },
            {
              "name": "share-dropbox-content",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/dropbox/skills/share-dropbox-content/SKILL.md"
            }
          ],
          "mcpServers": [
            {
              "requiresConfiguration": false,
              "name": "dropbox",
              "transport": "http",
              "endpoint": "https://mcp.dropbox.com/mcp"
            }
          ],
          "components": ["skills", "mcp", "apps"],
          "componentInspection": "repository",
          "inspectionError": null,
          "installation": "requires_adapter",
          "upstream": {
            "source": {
              "source": "local",
              "path": "./plugins/dropbox"
            },
            "policy": {
              "installation": "AVAILABLE",
              "authentication": "ON_INSTALL"
            }
          }
        },
        {
          "id": "openai:product-design",
          "name": "product-design",
          "displayName": "Product Design",
          "description": "Explore and prototype ideas",
          "longDescription": "Turn early ideas into prototypes teams can review. Explore product directions, audit user flows, research user friction, prototype from a live URL, and make static screenshots interactive. Start with a written brief, URL, screenshot, or existing design, then compare visual directions before building.\n\nUse available browser, Figma, Canva, image generation, and hosting tools to gather references, create concepts, review the result, and carry the work forward with your team.",
          "category": "Creativity",
          "keywords": [
            "prototype",
            "product design",
            "prototyping",
            "user experience",
            "wireframes",
            "design systems",
            "figma",
            "frontend",
            "ux-research",
            "ux-audit",
            "accessibility-audit",
            "research",
            "context-gathering",
            "ideation",
            "image-generation"
          ],
          "author": {
            "name": "OpenAI",
            "email": "support@openai.com",
            "url": "https://openai.com/"
          },
          "version": "0.1.52",
          "license": "Proprietary",
          "logoUrl": "https://raw.githubusercontent.com/openai/plugins/d416fd5a43426019986b1e489506db3db66dee3d/plugins/product-design/assets/logo.png",
          "darkLogoUrl": null,
          "homepage": "https://openai.com/",
          "sourceUrl": "https://github.com/openai/plugins/tree/d416fd5a43426019986b1e489506db3db66dee3d/plugins/product-design",
          "skills": [
            {
              "name": "audit",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/product-design/skills/audit/SKILL.md"
            },
            {
              "name": "design-qa",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/product-design/skills/design-qa/SKILL.md"
            },
            {
              "name": "get-context",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/product-design/skills/get-context/SKILL.md"
            },
            {
              "name": "ideate",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/product-design/skills/ideate/SKILL.md"
            },
            {
              "name": "image-to-code",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/product-design/skills/image-to-code/SKILL.md"
            },
            {
              "name": "index",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/product-design/skills/index/SKILL.md"
            },
            {
              "name": "research",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/product-design/skills/research/SKILL.md"
            },
            {
              "name": "share",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/product-design/skills/share/SKILL.md"
            },
            {
              "name": "url-to-code",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/product-design/skills/url-to-code/SKILL.md"
            },
            {
              "name": "user-context",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/product-design/skills/user-context/SKILL.md"
            }
          ],
          "mcpServers": [],
          "components": ["skills", "agents"],
          "componentInspection": "repository",
          "inspectionError": null,
          "installation": "requires_adapter",
          "upstream": {
            "source": {
              "source": "local",
              "path": "./plugins/product-design"
            },
            "policy": {
              "installation": "AVAILABLE",
              "authentication": "ON_USE"
            }
          }
        },
        {
          "id": "openai:data-analytics",
          "name": "data-analytics",
          "displayName": "Data Analytics",
          "description": "Answer product and business questions with data",
          "longDescription": "Data Analytics helps you turn questions about your product or business into answers you can trust. Ask why a metric changed, what the data shows about where a team should focus next, how to define KPIs, whether a dataset is reliable, or how large an opportunity might be, and it can help you investigate the data and turn the findings into shareable reports, charts, dashboards, notebooks, and recommendations.\n\nStart with the data you already have: connected warehouses, BI or product analytics tools, docs, chats, spreadsheets, uploaded files, pasted results, or clearly labeled sample data. The plugin guides you through the right workflow, checks sources where possible, and keeps the evidence visible in reviewable tables, charts, dashboards, and report apps you can share.",
          "category": "Data & Analytics",
          "keywords": [
            "data-analytics",
            "analytics",
            "business intelligence",
            "sql",
            "business-context",
            "dashboards",
            "funnel-analysis",
            "kpi-reporting",
            "market-sizing",
            "metric-diagnostics",
            "post-launch-updates",
            "product-analysis",
            "retention",
            "root-cause-analysis",
            "scorecards",
            "validation",
            "visualization",
            "jupyter-notebooks",
            "databricks",
            "bigquery",
            "snowflake",
            "deepnote",
            "mixpanel",
            "mixpanel-headless",
            "metabase",
            "thoughtspot",
            "guided-flow",
            "semantic-layer"
          ],
          "author": {
            "name": "Data Analytics Maintainers"
          },
          "version": "0.2.8",
          "license": "Proprietary",
          "logoUrl": "https://raw.githubusercontent.com/openai/plugins/d416fd5a43426019986b1e489506db3db66dee3d/plugins/data-analytics/assets/datascience.png",
          "darkLogoUrl": null,
          "homepage": "https://openai.com/",
          "sourceUrl": "https://github.com/openai/plugins/tree/d416fd5a43426019986b1e489506db3db66dee3d/plugins/data-analytics",
          "skills": [
            {
              "name": "analyze-data-quality",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/data-analytics/skills/analyze-data-quality/SKILL.md"
            },
            {
              "name": "build-dashboard",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/data-analytics/skills/build-dashboard/SKILL.md"
            },
            {
              "name": "build-report",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/data-analytics/skills/build-report/SKILL.md"
            },
            {
              "name": "report-to-google-doc",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/data-analytics/skills/build-report/report-to-google-doc/SKILL.md"
            },
            {
              "name": "report-to-google-slides",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/data-analytics/skills/build-report/report-to-google-slides/SKILL.md"
            },
            {
              "name": "report-to-pdf",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/data-analytics/skills/build-report/report-to-pdf/SKILL.md"
            },
            {
              "name": "create-data-context",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/data-analytics/skills/create-data-context/SKILL.md"
            },
            {
              "name": "design-kpis",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/data-analytics/skills/design-kpis/SKILL.md"
            },
            {
              "name": "gather-business-context",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/data-analytics/skills/gather-business-context/SKILL.md"
            },
            {
              "name": "index",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/data-analytics/skills/index/SKILL.md"
            },
            {
              "name": "jupyter-notebooks",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/data-analytics/skills/jupyter-notebooks/SKILL.md"
            },
            {
              "name": "kpi-reporting",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/data-analytics/skills/kpi-reporting/SKILL.md"
            },
            {
              "name": "market-sizing",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/data-analytics/skills/market-sizing/SKILL.md"
            },
            {
              "name": "metric-diagnostics",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/data-analytics/skills/metric-diagnostics/SKILL.md"
            },
            {
              "name": "product-business-analysis",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/data-analytics/skills/product-business-analysis/SKILL.md"
            },
            {
              "name": "publish-artifact-to-sites",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/data-analytics/skills/publish-artifact-to-sites/SKILL.md"
            },
            {
              "name": "validate-data",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/data-analytics/skills/validate-data/SKILL.md"
            },
            {
              "name": "visualize-data",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/data-analytics/skills/visualize-data/SKILL.md"
            }
          ],
          "mcpServers": [
            {
              "requiresConfiguration": false,
              "name": "dataAnalyticsWidgets",
              "transport": "stdio",
              "endpoint": null
            }
          ],
          "components": ["skills", "mcp", "apps"],
          "componentInspection": "repository",
          "inspectionError": null,
          "installation": "requires_adapter",
          "upstream": {
            "source": {
              "source": "local",
              "path": "./plugins/data-analytics"
            },
            "policy": {
              "installation": "AVAILABLE",
              "authentication": "ON_USE"
            }
          }
        },
        {
          "id": "openai:creative-production",
          "name": "creative-production",
          "displayName": "Creative Production",
          "description": "Create marketing visuals from a brief or product image.",
          "longDescription": "Creative Production helps marketers turn a brief, product image, offer, or existing asset into visual options the team can review. Use it to explore campaign ideas, concept images, mood boards, product placements, ad directions, listing images, social posts, and reusable styles. Start with a brief or image, compare the strongest options, then adapt the chosen direction for the channels you need.",
          "category": "Creativity",
          "keywords": [
            "creative-production",
            "marketing",
            "creative",
            "visuals",
            "images",
            "image-generation",
            "mood-board",
            "campaigns",
            "ads",
            "social-posts",
            "product-photos",
            "brand",
            "design",
            "marketing-assets",
            "visual-exploration",
            "asset-production"
          ],
          "author": {
            "name": "Creative Production",
            "email": "adrianmasson@openai.com, storus@openai.com"
          },
          "version": "0.1.25",
          "license": "Proprietary",
          "logoUrl": "https://raw.githubusercontent.com/openai/plugins/d416fd5a43426019986b1e489506db3db66dee3d/plugins/creative-production/assets/logo.png",
          "darkLogoUrl": null,
          "homepage": "https://github.com/openai/oai-maintained-plugins/tree/main/plugins/creative-production",
          "sourceUrl": "https://github.com/openai/plugins/tree/d416fd5a43426019986b1e489506db3db66dee3d/plugins/creative-production",
          "skills": [
            {
              "name": "intake",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/creative-production/skills/intake/SKILL.md"
            },
            {
              "name": "produce",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/creative-production/skills/produce/SKILL.md"
            }
          ],
          "mcpServers": [
            {
              "requiresConfiguration": false,
              "name": "creative_production_mcp",
              "transport": "stdio",
              "endpoint": null
            }
          ],
          "components": ["skills", "mcp", "apps"],
          "componentInspection": "repository",
          "inspectionError": null,
          "installation": "requires_adapter",
          "upstream": {
            "source": {
              "source": "local",
              "path": "./plugins/creative-production"
            },
            "policy": {
              "installation": "AVAILABLE",
              "authentication": "ON_USE"
            }
          }
        },
        {
          "id": "openai:public-equity-investing",
          "name": "public-equity-investing",
          "displayName": "Public Equity Investing",
          "description": "Public equity PM research, long/short, earnings, ETF/index diligence, and memos",
          "longDescription": "Public equity investing workflows for long-only investors, long/short hedge funds, sell-side equity research teams, ETF/index and constituent diligence, event-driven equity investors, and sector/thematic listed-equity research teams. Outputs should surface what is mispriced, what is priced in, what proves or kills the thesis, what to do next, and what evidence is missing. Use Credit Markets for credit instruments, creditworthiness, restructuring, distressed, recovery, spreads, yields, covenants, and debt security analysis.",
          "category": "Finance",
          "keywords": [
            "public-equity-investing",
            "factset",
            "morningstar",
            "lseg",
            "s&p global",
            "pitchbook",
            "quartr",
            "alpaca",
            "daloopa",
            "public-equity",
            "listed-equities",
            "equity-research",
            "long-only",
            "hedge-fund",
            "long-short",
            "earnings",
            "valuation",
            "catalysts",
            "investment-memo",
            "etf-index-diligence",
            "benchmark-relative-equity",
            "sell-side-research",
            "public-equity-diligence",
            "portfolio-manager"
          ],
          "author": {
            "name": "OpenAI"
          },
          "version": "0.1.31",
          "license": "Proprietary",
          "logoUrl": "https://raw.githubusercontent.com/openai/plugins/d416fd5a43426019986b1e489506db3db66dee3d/plugins/public-equity-investing/assets/logo.png",
          "darkLogoUrl": null,
          "homepage": "https://github.com/openai/oai-maintained-plugins/tree/main/plugins/public-equity-investing",
          "sourceUrl": "https://github.com/openai/plugins/tree/d416fd5a43426019986b1e489506db3db66dee3d/plugins/public-equity-investing",
          "skills": [
            {
              "name": "catalyst-calendar",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/public-equity-investing/skills/catalyst-calendar/SKILL.md"
            },
            {
              "name": "company-tearsheet",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/public-equity-investing/skills/company-tearsheet/SKILL.md"
            },
            {
              "name": "comps-valuation",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/public-equity-investing/skills/comps-valuation/SKILL.md"
            },
            {
              "name": "dcf-model-builder",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/public-equity-investing/skills/dcf-model-builder/SKILL.md"
            },
            {
              "name": "deck-report-qc",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/public-equity-investing/skills/deck-report-qc/SKILL.md"
            },
            {
              "name": "earnings-deep-dive",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/public-equity-investing/skills/earnings-deep-dive/SKILL.md"
            },
            {
              "name": "earnings-preview",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/public-equity-investing/skills/earnings-preview/SKILL.md"
            },
            {
              "name": "economic-impact-report",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/public-equity-investing/skills/economic-impact-report/SKILL.md"
            },
            {
              "name": "equity-model-update",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/public-equity-investing/skills/equity-model-update/SKILL.md"
            },
            {
              "name": "event-driven-analyzer",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/public-equity-investing/skills/event-driven-analyzer/SKILL.md"
            },
            {
              "name": "financials-normalizer",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/public-equity-investing/skills/financials-normalizer/SKILL.md"
            },
            {
              "name": "idea-generation",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/public-equity-investing/skills/idea-generation/SKILL.md"
            },
            {
              "name": "initiating-coverage",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/public-equity-investing/skills/initiating-coverage/SKILL.md"
            },
            {
              "name": "long-short-pitch",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/public-equity-investing/skills/long-short-pitch/SKILL.md"
            },
            {
              "name": "meeting-prep",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/public-equity-investing/skills/meeting-prep/SKILL.md"
            },
            {
              "name": "memo-builder",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/public-equity-investing/skills/memo-builder/SKILL.md"
            },
            {
              "name": "model-audit-tieout",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/public-equity-investing/skills/model-audit-tieout/SKILL.md"
            },
            {
              "name": "portfolio-risk-management",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/public-equity-investing/skills/portfolio-risk-management/SKILL.md"
            },
            {
              "name": "public-equity-investing",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/public-equity-investing/skills/public-equity-investing/SKILL.md"
            },
            {
              "name": "scenario-sensitivity-generator",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/public-equity-investing/skills/scenario-sensitivity-generator/SKILL.md"
            },
            {
              "name": "thesis-tracker",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/public-equity-investing/skills/thesis-tracker/SKILL.md"
            },
            {
              "name": "three-statement-model-builder",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/public-equity-investing/skills/three-statement-model-builder/SKILL.md"
            },
            {
              "name": "user-context",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/public-equity-investing/skills/user-context/SKILL.md"
            }
          ],
          "mcpServers": [],
          "components": ["skills", "apps"],
          "componentInspection": "repository",
          "inspectionError": null,
          "installation": "requires_adapter",
          "upstream": {
            "source": {
              "source": "local",
              "path": "./plugins/public-equity-investing"
            },
            "policy": {
              "installation": "AVAILABLE",
              "authentication": "ON_USE"
            }
          }
        },
        {
          "id": "openai:adobe",
          "name": "adobe",
          "displayName": "Adobe",
          "description": "Design, combine, and edit",
          "longDescription": "Adobe unlocks more ways to create and get work done from the conversation. Previously available as Photoshop, the Adobe connector now brings creativity and productivity capabilities across Creative Cloud and Acrobat. Describe what you want to make or change, and Adobe can help turn ideas, images, videos, and documents into polished outputs — from editing photos and creating PDFs to designing social assets, resizing videos, searching Creative Cloud assets, and generating data-driven documents.\nKey capabilities:\n\n* Retouch portraits or edit photos in bulk: Drop in photos and describe the look you want — adjust color, lighting, and tone; remove distractions and generate new elements; apply Lightroom presets; remove backgrounds; blur, crop, resize, and expand images.\n* Design from template: Start from an Express template, update text and colors, and then animate for social media or convert to PDF.\n* Refine video for any platform: Upload a horizontal clip and ask to reformat it for YouTube Shorts, Instagram Reels, or any platform. You can also stitch clips into a single sequence.\n* Search and organize creative work: Describe what you're looking for and surface assets from your Creative Cloud library — by subject, style, mood, or content — without browsing folders.\n* Work with PDFs and documents: Create and convert polished PDFs and documents.\n* Create data-driven documents: Describe your output and provide your data — the connector turns raw data or content into formatted, shareable PDFs, including badges, cards, catalogs, and more.\n\nYou can get started as a guest, and sign in with your Adobe account for more capabilities and tools, Creative Cloud storage, and saved work across sessions.",
          "category": "Creativity",
          "keywords": [],
          "author": {
            "name": "Adobe Inc"
          },
          "version": "8.0.0",
          "license": null,
          "logoUrl": null,
          "darkLogoUrl": null,
          "homepage": null,
          "sourceUrl": "https://github.com/openai/plugins/tree/d416fd5a43426019986b1e489506db3db66dee3d/plugins/adobe",
          "skills": [
            {
              "name": "adobe-batch-edit-photos",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/adobe/skills/adobe-batch-edit-photos/SKILL.md"
            },
            {
              "name": "adobe-create-mockups",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/adobe/skills/adobe-create-mockups/SKILL.md"
            },
            {
              "name": "adobe-create-social-variations",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/adobe/skills/adobe-create-social-variations/SKILL.md"
            },
            {
              "name": "adobe-design-from-template",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/adobe/skills/adobe-design-from-template/SKILL.md"
            },
            {
              "name": "adobe-edit-quick-cut",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/adobe/skills/adobe-edit-quick-cut/SKILL.md"
            },
            {
              "name": "adobe-retouch-portraits",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/adobe/skills/adobe-retouch-portraits/SKILL.md"
            }
          ],
          "mcpServers": [],
          "components": ["skills", "apps"],
          "componentInspection": "repository",
          "inspectionError": null,
          "installation": "requires_adapter",
          "upstream": {
            "source": {
              "source": "local",
              "path": "./plugins/adobe"
            },
            "policy": {
              "installation": "AVAILABLE",
              "authentication": "ON_INSTALL"
            }
          }
        },
        {
          "id": "openai:lovable",
          "name": "lovable",
          "displayName": "Lovable",
          "description": "Build apps and websites",
          "longDescription": "Build apps and websites",
          "category": "Developer Tools",
          "keywords": [],
          "author": {
            "name": "Lovable Labs"
          },
          "version": "2.0.1",
          "license": null,
          "logoUrl": null,
          "darkLogoUrl": null,
          "homepage": null,
          "sourceUrl": "https://github.com/openai/plugins/tree/d416fd5a43426019986b1e489506db3db66dee3d/plugins/lovable",
          "skills": [],
          "mcpServers": [],
          "components": ["apps"],
          "componentInspection": "repository",
          "inspectionError": null,
          "installation": "requires_adapter",
          "upstream": {
            "source": {
              "source": "local",
              "path": "./plugins/lovable"
            },
            "policy": {
              "installation": "AVAILABLE",
              "authentication": "ON_INSTALL"
            }
          }
        },
        {
          "id": "openai:clickup",
          "name": "clickup",
          "displayName": "ClickUp",
          "description": "Turn Codex into your ClickUp command center.",
          "longDescription": "Turn Codex into your ClickUp command center. Ask anything, find everything, take action - without breaking your flow.\n• Deep workspace search:  Ask questions naturally, get precise answers from across all your work\n• Action in the same breath: Find, create, update, and manage work in Codex\n• Zero context switching:  Go from question to answer to action without leaving the conversation",
          "category": "Productivity",
          "keywords": [],
          "author": {
            "name": "ClickUp"
          },
          "version": "1.0.3",
          "license": "MIT",
          "logoUrl": "https://raw.githubusercontent.com/openai/plugins/d416fd5a43426019986b1e489506db3db66dee3d/plugins/clickup/assets/logo.png",
          "darkLogoUrl": null,
          "homepage": null,
          "sourceUrl": "https://github.com/openai/plugins/tree/d416fd5a43426019986b1e489506db3db66dee3d/plugins/clickup",
          "skills": [],
          "mcpServers": [
            {
              "requiresConfiguration": false,
              "name": "clickup",
              "transport": "http",
              "endpoint": "https://mcp.clickup.com/mcp"
            }
          ],
          "components": ["mcp", "apps"],
          "componentInspection": "repository",
          "inspectionError": null,
          "installation": "requires_adapter",
          "upstream": {
            "source": {
              "source": "local",
              "path": "./plugins/clickup"
            },
            "policy": {
              "installation": "AVAILABLE",
              "authentication": "ON_INSTALL"
            }
          }
        },
        {
          "id": "openai:consensus",
          "name": "consensus",
          "displayName": "Consensus",
          "description": "Explore scientific research",
          "longDescription": "Consensus is the go-to MCP for academic research. Connect directly to 220M+ peer-reviewed papers to search, synthesize, and build structured research outputs from within your conversation.\n\nRun literature reviews, build boolean search strategies, generate bibliographies, identify research gaps, and draft cited content — grounded in studies from PubMed, Semantic Scholar, and ArXiv. Pre-built workflows handle complex tasks in minutes: systematic reviews, curriculum reading lists, grant research with novelty analysis, and clinical evidence synthesis.\n\nBuilt for researchers, students, faculty, and clinicians across biomedical, social science, STEM, and all academic disciplines.",
          "category": "Education & Research",
          "keywords": [],
          "author": {
            "name": "Consensus"
          },
          "version": "4.0.0",
          "license": null,
          "logoUrl": null,
          "darkLogoUrl": null,
          "homepage": null,
          "sourceUrl": "https://github.com/openai/plugins/tree/d416fd5a43426019986b1e489506db3db66dee3d/plugins/consensus",
          "skills": [],
          "mcpServers": [
            {
              "requiresConfiguration": false,
              "name": "consensus",
              "transport": "http",
              "endpoint": "https://mcp.consensus.app/mcp"
            }
          ],
          "components": ["mcp", "apps"],
          "componentInspection": "repository",
          "inspectionError": null,
          "installation": "requires_adapter",
          "upstream": {
            "source": {
              "source": "local",
              "path": "./plugins/consensus"
            },
            "policy": {
              "installation": "AVAILABLE",
              "authentication": "ON_INSTALL"
            }
          }
        },
        {
          "id": "openai:chatcut",
          "name": "chatcut",
          "displayName": "ChatCut",
          "description": "Install and connect ChatCut",
          "longDescription": "Download, install, open, connect, or repair the signed production ChatCut Desktop app so Codex can use its local video-editing tools and skills.",
          "category": "Creativity",
          "keywords": [
            "chatcut",
            "desktop",
            "video",
            "video-editing",
            "codex",
            "mcp",
            "apple-silicon",
            "intel-mac",
            "windows"
          ],
          "author": {
            "email": "dev@chatcut.io",
            "name": "ChatCut",
            "url": "https://chatcut.io"
          },
          "version": "1.0.4",
          "license": "GPL-3.0-only",
          "logoUrl": "https://raw.githubusercontent.com/openai/plugins/d416fd5a43426019986b1e489506db3db66dee3d/plugins/chatcut/.codex-plugin/assets/logo.png",
          "darkLogoUrl": null,
          "homepage": "https://chatcut.io",
          "sourceUrl": "https://github.com/openai/plugins/tree/d416fd5a43426019986b1e489506db3db66dee3d/plugins/chatcut",
          "skills": [
            {
              "name": "connect-chatcut-desktop",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/chatcut/skills/connect-chatcut-desktop/SKILL.md"
            }
          ],
          "mcpServers": [],
          "components": ["skills", "apps"],
          "componentInspection": "repository",
          "inspectionError": null,
          "installation": "requires_adapter",
          "upstream": {
            "source": {
              "source": "local",
              "path": "./plugins/chatcut"
            },
            "policy": {
              "installation": "AVAILABLE",
              "authentication": "ON_INSTALL"
            }
          }
        },
        {
          "id": "openai:higgsfield",
          "name": "higgsfield",
          "displayName": "Higgsfield",
          "description": "Every image and video model",
          "longDescription": "Generate images and videos from a text prompt or your own photo. Turn a product shot into a video ad, restyle a photo, animate a still, or build a two-minute narrated explainer. Every major image and video model in one place.",
          "category": "Creativity",
          "keywords": [],
          "author": {
            "name": "Higgsfield AI, Inc."
          },
          "version": "1.2.1",
          "license": null,
          "logoUrl": null,
          "darkLogoUrl": null,
          "homepage": null,
          "sourceUrl": "https://github.com/openai/plugins/tree/d416fd5a43426019986b1e489506db3db66dee3d/plugins/higgsfield",
          "skills": [
            {
              "name": "faceless-channel",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/higgsfield/skills/faceless-channel/SKILL.md"
            },
            {
              "name": "narrator",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/higgsfield/skills/narrator/SKILL.md"
            },
            {
              "name": "subtitles",
              "sourceUrl": "https://github.com/openai/plugins/blob/d416fd5a43426019986b1e489506db3db66dee3d/plugins/higgsfield/skills/subtitles/SKILL.md"
            }
          ],
          "mcpServers": [
            {
              "requiresConfiguration": false,
              "name": "higgsfield",
              "transport": "http",
              "endpoint": "https://mcp.higgsfield.ai/mcp"
            }
          ],
          "components": ["skills", "mcp", "apps"],
          "componentInspection": "repository",
          "inspectionError": null,
          "installation": "requires_adapter",
          "upstream": {
            "source": {
              "source": "local",
              "path": "./plugins/higgsfield"
            },
            "policy": {
              "installation": "AVAILABLE",
              "authentication": "ON_INSTALL"
            }
          }
        },
        {
          "id": "openai:crowdstrike-falcon-foundry",
          "name": "crowdstrike-falcon-foundry",
          "displayName": "crowdstrike-falcon-foundry",
          "description": "",
          "longDescription": "",
          "category": "Developer Tools",
          "keywords": [],
          "author": null,
          "version": null,
          "license": null,
          "logoUrl": null,
          "darkLogoUrl": null,
          "homepage": null,
          "sourceUrl": "https://github.com/CrowdStrike/foundry-skills.git",
          "skills": null,
          "mcpServers": null,
          "components": null,
          "componentInspection": "not_inspected",
          "inspectionError": "Source has no supported repository and pinned commit",
          "installation": "requires_adapter",
          "upstream": {
            "source": {
              "source": "url",
              "url": "https://github.com/CrowdStrike/foundry-skills.git"
            },
            "policy": {
              "installation": "AVAILABLE",
              "authentication": "ON_INSTALL"
            }
          }
        },
        {
          "id": "openai:crowdstrike-falcon-fusion",
          "name": "crowdstrike-falcon-fusion",
          "displayName": "crowdstrike-falcon-fusion",
          "description": "",
          "longDescription": "",
          "category": "Developer Tools",
          "keywords": [],
          "author": null,
          "version": null,
          "license": null,
          "logoUrl": null,
          "darkLogoUrl": null,
          "homepage": null,
          "sourceUrl": "https://github.com/CrowdStrike/fusion-skills.git",
          "skills": null,
          "mcpServers": null,
          "components": null,
          "componentInspection": "not_inspected",
          "inspectionError": "Source has no supported repository and pinned commit",
          "installation": "requires_adapter",
          "upstream": {
            "source": {
              "source": "url",
              "url": "https://github.com/CrowdStrike/fusion-skills.git"
            },
            "policy": {
              "installation": "AVAILABLE",
              "authentication": "ON_INSTALL"
            }
          }
        },
        {
          "id": "openai:qodo",
          "name": "qodo",
          "displayName": "qodo",
          "description": "",
          "longDescription": "",
          "category": "Developer Tools",
          "keywords": [],
          "author": null,
          "version": null,
          "license": null,
          "logoUrl": null,
          "darkLogoUrl": null,
          "homepage": null,
          "sourceUrl": "https://github.com/qodo-ai/qodo-skills.git",
          "skills": null,
          "mcpServers": null,
          "components": null,
          "componentInspection": "not_inspected",
          "inspectionError": "Source has no supported repository and pinned commit",
          "installation": "requires_adapter",
          "upstream": {
            "source": {
              "source": "git-subdir",
              "url": "https://github.com/qodo-ai/qodo-skills.git",
              "path": "codex-packages/qodo"
            },
            "policy": {
              "installation": "AVAILABLE",
              "authentication": "ON_INSTALL"
            }
          }
        }
      ]
    },
    {
      "provider": "anthropic",
      "repository": "anthropics/claude-plugins-official",
      "revision": "3b600518a637492d37c9877aeb49c2a55d939c04",
      "indexUrl": "https://raw.githubusercontent.com/anthropics/claude-plugins-official/3b600518a637492d37c9877aeb49c2a55d939c04/.claude-plugin/marketplace.json",
      "entries": [
        {
          "id": "anthropic:42crunch-api-security-testing",
          "name": "42crunch-api-security-testing",
          "displayName": "42crunch-api-security-testing",
          "description": "Catch API security issues during development: audit, scan, remediate, validate with AI guardrails in Claude Code.",
          "longDescription": "Catch API security issues during development: audit, scan, remediate, validate with AI guardrails in Claude Code.",
          "category": "security",
          "keywords": [
            "openapi",
            "api-security",
            "audit",
            "scan",
            "remediation",
            "vulnerability",
            "compliance",
            "owasp",
            "bola",
            "bfla",
            "ai",
            "devsecops",
            "42crunch"
          ],
          "author": {
            "name": "42Crunch",
            "email": "support@42crunch.com",
            "url": "https://github.com/42Crunch"
          },
          "version": "1.15.0",
          "license": "Apache 2.0",
          "logoUrl": null,
          "darkLogoUrl": null,
          "homepage": "https://42crunch.com",
          "sourceUrl": "https://github.com/42Crunch-AI/claude-plugins/tree/30287f5e3f122a646d1ac5ca3ab96e130c52a3ad/plugins/api-security-testing",
          "skills": [
            {
              "name": "42crunch-api-security-testing",
              "sourceUrl": "https://github.com/42Crunch-AI/claude-plugins/blob/30287f5e3f122a646d1ac5ca3ab96e130c52a3ad/plugins/api-security-testing/skills/42crunch-api-security-testing/SKILL.md"
            },
            {
              "name": "42crunch-audit",
              "sourceUrl": "https://github.com/42Crunch-AI/claude-plugins/blob/30287f5e3f122a646d1ac5ca3ab96e130c52a3ad/plugins/api-security-testing/skills/42crunch-audit/SKILL.md"
            },
            {
              "name": "42crunch-scan",
              "sourceUrl": "https://github.com/42Crunch-AI/claude-plugins/blob/30287f5e3f122a646d1ac5ca3ab96e130c52a3ad/plugins/api-security-testing/skills/42crunch-scan/SKILL.md"
            },
            {
              "name": "42crunch-setup",
              "sourceUrl": "https://github.com/42Crunch-AI/claude-plugins/blob/30287f5e3f122a646d1ac5ca3ab96e130c52a3ad/plugins/api-security-testing/skills/42crunch-setup/SKILL.md"
            },
            {
              "name": "generate-oas",
              "sourceUrl": "https://github.com/42Crunch-AI/claude-plugins/blob/30287f5e3f122a646d1ac5ca3ab96e130c52a3ad/plugins/api-security-testing/skills/generate-oas/SKILL.md"
            }
          ],
          "mcpServers": [],
          "components": ["skills"],
          "componentInspection": "repository",
          "inspectionError": null,
          "installation": "requires_adapter",
          "upstream": {
            "source": {
              "source": "git-subdir",
              "url": "https://github.com/42Crunch-AI/claude-plugins.git",
              "path": "plugins/api-security-testing",
              "ref": "v1.5.5",
              "sha": "30287f5e3f122a646d1ac5ca3ab96e130c52a3ad"
            },
            "policy": null
          }
        },
        {
          "id": "anthropic:adobe-for-creativity",
          "name": "adobe-for-creativity",
          "displayName": "adobe-for-creativity",
          "description": "Brings together Adobe Creative Cloud tools for images, vectors, design, and video. Edit multiple assets at once, adapt for different platforms, and complete multi-step creative workflows for polished results.",
          "longDescription": "Brings together Adobe Creative Cloud tools for images, vectors, design, and video. Edit multiple assets at once, adapt for different platforms, and complete multi-step creative workflows for polished results.",
          "category": "design",
          "keywords": ["adobe", "creative-cloud", "image-editing", "design"],
          "author": {
            "name": "Adobe"
          },
          "version": "2.1.0",
          "license": "Apache-2.0",
          "logoUrl": null,
          "darkLogoUrl": null,
          "homepage": "https://github.com/adobe/skills/tree/main/plugins/creative-cloud/adobe-for-creativity",
          "sourceUrl": "https://github.com/adobe/skills/tree/1307e2c03b9cd20c49872be8cbdfda7ee9aa8c7e/plugins/creative-cloud/adobe-for-creativity",
          "skills": [
            {
              "name": "adobe-batch-edit-photos",
              "sourceUrl": "https://github.com/adobe/skills/blob/1307e2c03b9cd20c49872be8cbdfda7ee9aa8c7e/plugins/creative-cloud/adobe-for-creativity/skills/adobe-batch-edit-photos/SKILL.md"
            },
            {
              "name": "adobe-create-pdfs-from-data",
              "sourceUrl": "https://github.com/adobe/skills/blob/1307e2c03b9cd20c49872be8cbdfda7ee9aa8c7e/plugins/creative-cloud/adobe-for-creativity/skills/adobe-create-pdfs-from-data/SKILL.md"
            },
            {
              "name": "adobe-create-social-variations",
              "sourceUrl": "https://github.com/adobe/skills/blob/1307e2c03b9cd20c49872be8cbdfda7ee9aa8c7e/plugins/creative-cloud/adobe-for-creativity/skills/adobe-create-social-variations/SKILL.md"
            },
            {
              "name": "adobe-design-from-template",
              "sourceUrl": "https://github.com/adobe/skills/blob/1307e2c03b9cd20c49872be8cbdfda7ee9aa8c7e/plugins/creative-cloud/adobe-for-creativity/skills/adobe-design-from-template/SKILL.md"
            },
            {
              "name": "adobe-edit-quick-cut",
              "sourceUrl": "https://github.com/adobe/skills/blob/1307e2c03b9cd20c49872be8cbdfda7ee9aa8c7e/plugins/creative-cloud/adobe-for-creativity/skills/adobe-edit-quick-cut/SKILL.md"
            },
            {
              "name": "adobe-resize-photos-and-videos",
              "sourceUrl": "https://github.com/adobe/skills/blob/1307e2c03b9cd20c49872be8cbdfda7ee9aa8c7e/plugins/creative-cloud/adobe-for-creativity/skills/adobe-resize-photos-and-videos/SKILL.md"
            },
            {
              "name": "adobe-retouch-portraits",
              "sourceUrl": "https://github.com/adobe/skills/blob/1307e2c03b9cd20c49872be8cbdfda7ee9aa8c7e/plugins/creative-cloud/adobe-for-creativity/skills/adobe-retouch-portraits/SKILL.md"
            },
            {
              "name": "adobe",
              "sourceUrl": "https://github.com/adobe/skills/blob/1307e2c03b9cd20c49872be8cbdfda7ee9aa8c7e/plugins/creative-cloud/adobe-for-creativity/skills/adobe/SKILL.md"
            }
          ],
          "mcpServers": [
            {
              "requiresConfiguration": false,
              "name": "Adobe for creativity",
              "transport": "http",
              "endpoint": "https://adobe-creativity.adobe.io/mcp"
            }
          ],
          "components": ["skills", "mcp"],
          "componentInspection": "repository",
          "inspectionError": null,
          "installation": "requires_adapter",
          "upstream": {
            "source": {
              "source": "git-subdir",
              "url": "https://github.com/adobe/skills.git",
              "path": "plugins/creative-cloud/adobe-for-creativity",
              "ref": "main",
              "sha": "1307e2c03b9cd20c49872be8cbdfda7ee9aa8c7e"
            },
            "policy": null
          }
        },
        {
          "id": "anthropic:agent-sdk-dev",
          "name": "agent-sdk-dev",
          "displayName": "agent-sdk-dev",
          "description": "Claude Agent SDK Development Plugin",
          "longDescription": "Claude Agent SDK Development Plugin",
          "category": "development",
          "keywords": [],
          "author": {
            "name": "Anthropic",
            "email": "support@anthropic.com"
          },
          "version": null,
          "license": null,
          "logoUrl": null,
          "darkLogoUrl": null,
          "homepage": "https://github.com/anthropics/claude-plugins-public/tree/main/plugins/agent-sdk-dev",
          "sourceUrl": "https://github.com/anthropics/claude-plugins-official/tree/3b600518a637492d37c9877aeb49c2a55d939c04/plugins/agent-sdk-dev",
          "skills": [],
          "mcpServers": [],
          "components": ["agents", "commands"],
          "componentInspection": "repository",
          "inspectionError": null,
          "installation": "requires_adapter",
          "upstream": {
            "source": "./plugins/agent-sdk-dev",
            "policy": null
          }
        },
        {
          "id": "anthropic:agentforce-adlc",
          "name": "agentforce-adlc",
          "displayName": "agentforce-adlc",
          "description": "Agentforce Agent Development Life Cycle — author, discover, scaffold, deploy, test, secure, and optimize .agent files",
          "longDescription": "Agentforce Agent Development Life Cycle — author, discover, scaffold, deploy, test, secure, and optimize .agent files",
          "category": "development",
          "keywords": ["agentforce", "agent-script", "salesforce", "adlc"],
          "author": {
            "name": "SalesforceAIResearch"
          },
          "version": "0.11.0",
          "license": null,
          "logoUrl": null,
          "darkLogoUrl": null,
          "homepage": "https://github.com/SalesforceAIResearch/agentforce-adlc",
          "sourceUrl": "https://github.com/SalesforceAIResearch/agentforce-adlc/tree/d16d14ac7f817336e21bf9392cf51b6cac6194d8/",
          "skills": [
            {
              "name": "agentforce-generate",
              "sourceUrl": "https://github.com/SalesforceAIResearch/agentforce-adlc/blob/d16d14ac7f817336e21bf9392cf51b6cac6194d8/skills/agentforce-generate/SKILL.md"
            },
            {
              "name": "agentforce-observe",
              "sourceUrl": "https://github.com/SalesforceAIResearch/agentforce-adlc/blob/d16d14ac7f817336e21bf9392cf51b6cac6194d8/skills/agentforce-observe/SKILL.md"
            },
            {
              "name": "agentforce-test",
              "sourceUrl": "https://github.com/SalesforceAIResearch/agentforce-adlc/blob/d16d14ac7f817336e21bf9392cf51b6cac6194d8/skills/agentforce-test/SKILL.md"
            }
          ],
          "mcpServers": [],
          "components": ["skills", "hooks", "agents"],
          "componentInspection": "repository",
          "inspectionError": null,
          "installation": "requires_adapter",
          "upstream": {
            "source": {
              "source": "url",
              "url": "https://github.com/SalesforceAIResearch/agentforce-adlc.git",
              "sha": "d16d14ac7f817336e21bf9392cf51b6cac6194d8"
            },
            "policy": null
          }
        },
        {
          "id": "anthropic:ai-plugins",
          "name": "ai-plugins",
          "displayName": "ai-plugins",
          "description": "Endor Labs workflow agents and setup for Claude Code.",
          "longDescription": "Endor Labs workflow agents and setup for Claude Code.",
          "category": null,
          "keywords": [
            "endor-labs",
            "security",
            "sca",
            "sast",
            "claude-code",
            "agentic remediation",
            "SAST remediation",
            "agentic AppSec",
            "AppSec",
            "OSS Upgrade Investigator"
          ],
          "author": {
            "name": "Endor Labs",
            "url": "https://www.endorlabs.com/"
          },
          "version": null,
          "license": null,
          "logoUrl": null,
          "darkLogoUrl": null,
          "homepage": "https://github.com/endorlabs/ai-plugins",
          "sourceUrl": "https://github.com/endorlabs/ai-plugins/tree/2de00883bd2be8b8578b46ab09baf2c8731376de/",
          "skills": [
            {
              "name": "ai-sast-remediation",
              "sourceUrl": "https://github.com/endorlabs/ai-plugins/blob/2de00883bd2be8b8578b46ab09baf2c8731376de/plugins/antigravity/endor-labs-agent-kit/skills/ai-sast-remediation/SKILL.md"
            },
            {
              "name": "cicd-posture",
              "sourceUrl": "https://github.com/endorlabs/ai-plugins/blob/2de00883bd2be8b8578b46ab09baf2c8731376de/plugins/antigravity/endor-labs-agent-kit/skills/cicd-posture/SKILL.md"
            },
            {
              "name": "configuration-automation",
              "sourceUrl": "https://github.com/endorlabs/ai-plugins/blob/2de00883bd2be8b8578b46ab09baf2c8731376de/plugins/antigravity/endor-labs-agent-kit/skills/configuration-automation/SKILL.md"
            },
            {
              "name": "dependency-reviewer",
              "sourceUrl": "https://github.com/endorlabs/ai-plugins/blob/2de00883bd2be8b8578b46ab09baf2c8731376de/plugins/antigravity/endor-labs-agent-kit/skills/dependency-reviewer/SKILL.md"
            },
            {
              "name": "endor-agent-kit-setup",
              "sourceUrl": "https://github.com/endorlabs/ai-plugins/blob/2de00883bd2be8b8578b46ab09baf2c8731376de/plugins/antigravity/endor-labs-agent-kit/skills/endor-agent-kit-setup/SKILL.md"
            },
            {
              "name": "findings-browser",
              "sourceUrl": "https://github.com/endorlabs/ai-plugins/blob/2de00883bd2be8b8578b46ab09baf2c8731376de/plugins/antigravity/endor-labs-agent-kit/skills/findings-browser/SKILL.md"
            },
            {
              "name": "malware-responder",
              "sourceUrl": "https://github.com/endorlabs/ai-plugins/blob/2de00883bd2be8b8578b46ab09baf2c8731376de/plugins/antigravity/endor-labs-agent-kit/skills/malware-responder/SKILL.md"
            },
            {
              "name": "oss-upgrade-investigator",
              "sourceUrl": "https://github.com/endorlabs/ai-plugins/blob/2de00883bd2be8b8578b46ab09baf2c8731376de/plugins/antigravity/endor-labs-agent-kit/skills/oss-upgrade-investigator/SKILL.md"
            },
            {
              "name": "remediation-planning",
              "sourceUrl": "https://github.com/endorlabs/ai-plugins/blob/2de00883bd2be8b8578b46ab09baf2c8731376de/plugins/antigravity/endor-labs-agent-kit/skills/remediation-planning/SKILL.md"
            },
            {
              "name": "sca-remediation",
              "sourceUrl": "https://github.com/endorlabs/ai-plugins/blob/2de00883bd2be8b8578b46ab09baf2c8731376de/plugins/antigravity/endor-labs-agent-kit/skills/sca-remediation/SKILL.md"
            },
            {
              "name": "troubleshooting",
              "sourceUrl": "https://github.com/endorlabs/ai-plugins/blob/2de00883bd2be8b8578b46ab09baf2c8731376de/plugins/antigravity/endor-labs-agent-kit/skills/troubleshooting/SKILL.md"
            },
            {
              "name": "vulnerability-explainer",
              "sourceUrl": "https://github.com/endorlabs/ai-plugins/blob/2de00883bd2be8b8578b46ab09baf2c8731376de/plugins/antigravity/endor-labs-agent-kit/skills/vulnerability-explainer/SKILL.md"
            },
            {
              "name": "endor-agent-kit-setup",
              "sourceUrl": "https://github.com/endorlabs/ai-plugins/blob/2de00883bd2be8b8578b46ab09baf2c8731376de/plugins/claude/ai-plugins/skills/endor-agent-kit-setup/SKILL.md"
            },
            {
              "name": "endor-agent-kit-setup",
              "sourceUrl": "https://github.com/endorlabs/ai-plugins/blob/2de00883bd2be8b8578b46ab09baf2c8731376de/plugins/claude/endor-labs-agent-kit/skills/endor-agent-kit-setup/SKILL.md"
            },
            {
              "name": "ai-sast-remediation",
              "sourceUrl": "https://github.com/endorlabs/ai-plugins/blob/2de00883bd2be8b8578b46ab09baf2c8731376de/plugins/codex-directory/endor-labs-agent-kit/skills/ai-sast-remediation/SKILL.md"
            },
            {
              "name": "cicd-posture",
              "sourceUrl": "https://github.com/endorlabs/ai-plugins/blob/2de00883bd2be8b8578b46ab09baf2c8731376de/plugins/codex-directory/endor-labs-agent-kit/skills/cicd-posture/SKILL.md"
            },
            {
              "name": "configuration-automation",
              "sourceUrl": "https://github.com/endorlabs/ai-plugins/blob/2de00883bd2be8b8578b46ab09baf2c8731376de/plugins/codex-directory/endor-labs-agent-kit/skills/configuration-automation/SKILL.md"
            },
            {
              "name": "dependency-reviewer",
              "sourceUrl": "https://github.com/endorlabs/ai-plugins/blob/2de00883bd2be8b8578b46ab09baf2c8731376de/plugins/codex-directory/endor-labs-agent-kit/skills/dependency-reviewer/SKILL.md"
            },
            {
              "name": "endor-agent-kit-setup",
              "sourceUrl": "https://github.com/endorlabs/ai-plugins/blob/2de00883bd2be8b8578b46ab09baf2c8731376de/plugins/codex-directory/endor-labs-agent-kit/skills/endor-agent-kit-setup/SKILL.md"
            },
            {
              "name": "findings-browser",
              "sourceUrl": "https://github.com/endorlabs/ai-plugins/blob/2de00883bd2be8b8578b46ab09baf2c8731376de/plugins/codex-directory/endor-labs-agent-kit/skills/findings-browser/SKILL.md"
            },
            {
              "name": "malware-responder",
              "sourceUrl": "https://github.com/endorlabs/ai-plugins/blob/2de00883bd2be8b8578b46ab09baf2c8731376de/plugins/codex-directory/endor-labs-agent-kit/skills/malware-responder/SKILL.md"
            },
            {
              "name": "oss-upgrade-investigator",
              "sourceUrl": "https://github.com/endorlabs/ai-plugins/blob/2de00883bd2be8b8578b46ab09baf2c8731376de/plugins/codex-directory/endor-labs-agent-kit/skills/oss-upgrade-investigator/SKILL.md"
            },
            {
              "name": "remediation-planning",
              "sourceUrl": "https://github.com/endorlabs/ai-plugins/blob/2de00883bd2be8b8578b46ab09baf2c8731376de/plugins/codex-directory/endor-labs-agent-kit/skills/remediation-planning/SKILL.md"
            },
            {
              "name": "sca-remediation",
              "sourceUrl": "https://github.com/endorlabs/ai-plugins/blob/2de00883bd2be8b8578b46ab09baf2c8731376de/plugins/codex-directory/endor-labs-agent-kit/skills/sca-remediation/SKILL.md"
            },
            {
              "name": "troubleshooting",
              "sourceUrl": "https://github.com/endorlabs/ai-plugins/blob/2de00883bd2be8b8578b46ab09baf2c8731376de/plugins/codex-directory/endor-labs-agent-kit/skills/troubleshooting/SKILL.md"
            },
            {
              "name": "vulnerability-explainer",
              "sourceUrl": "https://github.com/endorlabs/ai-plugins/blob/2de00883bd2be8b8578b46ab09baf2c8731376de/plugins/codex-directory/endor-labs-agent-kit/skills/vulnerability-explainer/SKILL.md"
            },
            {
              "name": "ai-sast-remediation",
              "sourceUrl": "https://github.com/endorlabs/ai-plugins/blob/2de00883bd2be8b8578b46ab09baf2c8731376de/plugins/codex/endor-labs-agent-kit/bundled-skills/ai-sast-remediation/SKILL.md"
            },
            {
              "name": "cicd-posture",
              "sourceUrl": "https://github.com/endorlabs/ai-plugins/blob/2de00883bd2be8b8578b46ab09baf2c8731376de/plugins/codex/endor-labs-agent-kit/bundled-skills/cicd-posture/SKILL.md"
            },
            {
              "name": "configuration-automation",
              "sourceUrl": "https://github.com/endorlabs/ai-plugins/blob/2de00883bd2be8b8578b46ab09baf2c8731376de/plugins/codex/endor-labs-agent-kit/bundled-skills/configuration-automation/SKILL.md"
            },
            {
              "name": "dependency-reviewer",
              "sourceUrl": "https://github.com/endorlabs/ai-plugins/blob/2de00883bd2be8b8578b46ab09baf2c8731376de/plugins/codex/endor-labs-agent-kit/bundled-skills/dependency-reviewer/SKILL.md"
            },
            {
              "name": "findings-browser",
              "sourceUrl": "https://github.com/endorlabs/ai-plugins/blob/2de00883bd2be8b8578b46ab09baf2c8731376de/plugins/codex/endor-labs-agent-kit/bundled-skills/findings-browser/SKILL.md"
            },
            {
              "name": "malware-responder",
              "sourceUrl": "https://github.com/endorlabs/ai-plugins/blob/2de00883bd2be8b8578b46ab09baf2c8731376de/plugins/codex/endor-labs-agent-kit/bundled-skills/malware-responder/SKILL.md"
            },
            {
              "name": "oss-upgrade-investigator",
              "sourceUrl": "https://github.com/endorlabs/ai-plugins/blob/2de00883bd2be8b8578b46ab09baf2c8731376de/plugins/codex/endor-labs-agent-kit/bundled-skills/oss-upgrade-investigator/SKILL.md"
            },
            {
              "name": "remediation-planning",
              "sourceUrl": "https://github.com/endorlabs/ai-plugins/blob/2de00883bd2be8b8578b46ab09baf2c8731376de/plugins/codex/endor-labs-agent-kit/bundled-skills/remediation-planning/SKILL.md"
            },
            {
              "name": "sca-remediation",
              "sourceUrl": "https://github.com/endorlabs/ai-plugins/blob/2de00883bd2be8b8578b46ab09baf2c8731376de/plugins/codex/endor-labs-agent-kit/bundled-skills/sca-remediation/SKILL.md"
            },
            {
              "name": "troubleshooting",
              "sourceUrl": "https://github.com/endorlabs/ai-plugins/blob/2de00883bd2be8b8578b46ab09baf2c8731376de/plugins/codex/endor-labs-agent-kit/bundled-skills/troubleshooting/SKILL.md"
            },
            {
              "name": "vulnerability-explainer",
              "sourceUrl": "https://github.com/endorlabs/ai-plugins/blob/2de00883bd2be8b8578b46ab09baf2c8731376de/plugins/codex/endor-labs-agent-kit/bundled-skills/vulnerability-explainer/SKILL.md"
            },
            {
              "name": "endor-agent-kit-setup",
              "sourceUrl": "https://github.com/endorlabs/ai-plugins/blob/2de00883bd2be8b8578b46ab09baf2c8731376de/plugins/codex/endor-labs-agent-kit/skills/endor-agent-kit-setup/SKILL.md"
            },
            {
              "name": "ai-sast-remediation",
              "sourceUrl": "https://github.com/endorlabs/ai-plugins/blob/2de00883bd2be8b8578b46ab09baf2c8731376de/plugins/cursor/endor-labs-agent-kit/skills/ai-sast-remediation/SKILL.md"
            },
            {
              "name": "cicd-posture",
              "sourceUrl": "https://github.com/endorlabs/ai-plugins/blob/2de00883bd2be8b8578b46ab09baf2c8731376de/plugins/cursor/endor-labs-agent-kit/skills/cicd-posture/SKILL.md"
            },
            {
              "name": "configuration-automation",
              "sourceUrl": "https://github.com/endorlabs/ai-plugins/blob/2de00883bd2be8b8578b46ab09baf2c8731376de/plugins/cursor/endor-labs-agent-kit/skills/configuration-automation/SKILL.md"
            },
            {
              "name": "dependency-reviewer",
              "sourceUrl": "https://github.com/endorlabs/ai-plugins/blob/2de00883bd2be8b8578b46ab09baf2c8731376de/plugins/cursor/endor-labs-agent-kit/skills/dependency-reviewer/SKILL.md"
            },
            {
              "name": "endor-agent-kit-setup",
              "sourceUrl": "https://github.com/endorlabs/ai-plugins/blob/2de00883bd2be8b8578b46ab09baf2c8731376de/plugins/cursor/endor-labs-agent-kit/skills/endor-agent-kit-setup/SKILL.md"
            },
            {
              "name": "findings-browser",
              "sourceUrl": "https://github.com/endorlabs/ai-plugins/blob/2de00883bd2be8b8578b46ab09baf2c8731376de/plugins/cursor/endor-labs-agent-kit/skills/findings-browser/SKILL.md"
            },
            {
              "name": "malware-responder",
              "sourceUrl": "https://github.com/endorlabs/ai-plugins/blob/2de00883bd2be8b8578b46ab09baf2c8731376de/plugins/cursor/endor-labs-agent-kit/skills/malware-responder/SKILL.md"
            },
            {
              "name": "oss-upgrade-investigator",
              "sourceUrl": "https://github.com/endorlabs/ai-plugins/blob/2de00883bd2be8b8578b46ab09baf2c8731376de/plugins/cursor/endor-labs-agent-kit/skills/oss-upgrade-investigator/SKILL.md"
            },
            {
              "name": "remediation-planning",
              "sourceUrl": "https://github.com/endorlabs/ai-plugins/blob/2de00883bd2be8b8578b46ab09baf2c8731376de/plugins/cursor/endor-labs-agent-kit/skills/remediation-planning/SKILL.md"
            },
            {
              "name": "sca-remediation",
              "sourceUrl": "https://github.com/endorlabs/ai-plugins/blob/2de00883bd2be8b8578b46ab09baf2c8731376de/plugins/cursor/endor-labs-agent-kit/skills/sca-remediation/SKILL.md"
            },
            {
              "name": "troubleshooting",
              "sourceUrl": "https://github.com/endorlabs/ai-plugins/blob/2de00883bd2be8b8578b46ab09baf2c8731376de/plugins/cursor/endor-labs-agent-kit/skills/troubleshooting/SKILL.md"
            },
            {
              "name": "vulnerability-explainer",
              "sourceUrl": "https://github.com/endorlabs/ai-plugins/blob/2de00883bd2be8b8578b46ab09baf2c8731376de/plugins/cursor/endor-labs-agent-kit/skills/vulnerability-explainer/SKILL.md"
            },
            {
              "name": "ai-sast-remediation",
              "sourceUrl": "https://github.com/endorlabs/ai-plugins/blob/2de00883bd2be8b8578b46ab09baf2c8731376de/plugins/gemini/endor-labs-agent-kit/skills/ai-sast-remediation/SKILL.md"
            },
            {
              "name": "cicd-posture",
              "sourceUrl": "https://github.com/endorlabs/ai-plugins/blob/2de00883bd2be8b8578b46ab09baf2c8731376de/plugins/gemini/endor-labs-agent-kit/skills/cicd-posture/SKILL.md"
            },
            {
              "name": "configuration-automation",
              "sourceUrl": "https://github.com/endorlabs/ai-plugins/blob/2de00883bd2be8b8578b46ab09baf2c8731376de/plugins/gemini/endor-labs-agent-kit/skills/configuration-automation/SKILL.md"
            },
            {
              "name": "dependency-reviewer",
              "sourceUrl": "https://github.com/endorlabs/ai-plugins/blob/2de00883bd2be8b8578b46ab09baf2c8731376de/plugins/gemini/endor-labs-agent-kit/skills/dependency-reviewer/SKILL.md"
            },
            {
              "name": "endor-agent-kit-setup",
              "sourceUrl": "https://github.com/endorlabs/ai-plugins/blob/2de00883bd2be8b8578b46ab09baf2c8731376de/plugins/gemini/endor-labs-agent-kit/skills/endor-agent-kit-setup/SKILL.md"
            },
            {
              "name": "findings-browser",
              "sourceUrl": "https://github.com/endorlabs/ai-plugins/blob/2de00883bd2be8b8578b46ab09baf2c8731376de/plugins/gemini/endor-labs-agent-kit/skills/findings-browser/SKILL.md"
            },
            {
              "name": "malware-responder",
              "sourceUrl": "https://github.com/endorlabs/ai-plugins/blob/2de00883bd2be8b8578b46ab09baf2c8731376de/plugins/gemini/endor-labs-agent-kit/skills/malware-responder/SKILL.md"
            },
            {
              "name": "oss-upgrade-investigator",
              "sourceUrl": "https://github.com/endorlabs/ai-plugins/blob/2de00883bd2be8b8578b46ab09baf2c8731376de/plugins/gemini/endor-labs-agent-kit/skills/oss-upgrade-investigator/SKILL.md"
            },
            {
              "name": "remediation-planning",
              "sourceUrl": "https://github.com/endorlabs/ai-plugins/blob/2de00883bd2be8b8578b46ab09baf2c8731376de/plugins/gemini/endor-labs-agent-kit/skills/remediation-planning/SKILL.md"
            },
            {
              "name": "sca-remediation",
              "sourceUrl": "https://github.com/endorlabs/ai-plugins/blob/2de00883bd2be8b8578b46ab09baf2c8731376de/plugins/gemini/endor-labs-agent-kit/skills/sca-remediation/SKILL.md"
            },
            {
              "name": "troubleshooting",
              "sourceUrl": "https://github.com/endorlabs/ai-plugins/blob/2de00883bd2be8b8578b46ab09baf2c8731376de/plugins/gemini/endor-labs-agent-kit/skills/troubleshooting/SKILL.md"
            },
            {
              "name": "vulnerability-explainer",
              "sourceUrl": "https://github.com/endorlabs/ai-plugins/blob/2de00883bd2be8b8578b46ab09baf2c8731376de/plugins/gemini/endor-labs-agent-kit/skills/vulnerability-explainer/SKILL.md"
            },
            {
              "name": "endor-agent-kit-setup",
              "sourceUrl": "https://github.com/endorlabs/ai-plugins/blob/2de00883bd2be8b8578b46ab09baf2c8731376de/skills/endor-agent-kit-setup/SKILL.md"
            }
          ],
          "mcpServers": [],
          "components": ["skills", "hooks", "agents"],
          "componentInspection": "repository",
          "inspectionError": null,
          "installation": "requires_adapter",
          "upstream": {
            "source": {
              "source": "url",
              "url": "https://github.com/endorlabs/ai-plugins.git",
              "sha": "2de00883bd2be8b8578b46ab09baf2c8731376de"
            },
            "policy": null
          }
        },
        {
          "id": "anthropic:aikido",
          "name": "aikido",
          "displayName": "aikido",
          "description": "Aikido Security for Claude Code: scan code (SAST, secrets, IaC) and list all issues from your Aikido feed powered by the Aikido MCP server.",
          "longDescription": "Aikido Security for Claude Code: scan code (SAST, secrets, IaC) and list all issues from your Aikido feed powered by the Aikido MCP server.",
          "category": null,
          "keywords": [
            "aikido",
            "security",
            "sast",
            "secrets",
            "iac",
            "sca",
            "scanning",
            "vulnerability"
          ],
          "author": {
            "name": "Aikido Security",
            "url": "https://aikido.dev"
          },
          "version": "1.2.8",
          "license": "MIT",
          "logoUrl": null,
          "darkLogoUrl": null,
          "homepage": "https://help.aikido.dev/ide-plugins/aikido-mcp",
          "sourceUrl": "https://github.com/AikidoSec/aikido-claude-plugin/tree/5db259bac62bf0c3a37bfd0fee6e22cc25bdb704/",
          "skills": [
            {
              "name": "issues",
              "sourceUrl": "https://github.com/AikidoSec/aikido-claude-plugin/blob/5db259bac62bf0c3a37bfd0fee6e22cc25bdb704/skills/issues/SKILL.md"
            },
            {
              "name": "scan",
              "sourceUrl": "https://github.com/AikidoSec/aikido-claude-plugin/blob/5db259bac62bf0c3a37bfd0fee6e22cc25bdb704/skills/scan/SKILL.md"
            },
            {
              "name": "setup",
              "sourceUrl": "https://github.com/AikidoSec/aikido-claude-plugin/blob/5db259bac62bf0c3a37bfd0fee6e22cc25bdb704/skills/setup/SKILL.md"
            }
          ],
          "mcpServers": [
            {
              "requiresConfiguration": false,
              "name": "aikido-mcp",
              "transport": "stdio",
              "endpoint": null
            }
          ],
          "components": ["skills", "mcp"],
          "componentInspection": "repository",
          "inspectionError": null,
          "installation": "requires_adapter",
          "upstream": {
            "source": {
              "source": "url",
              "url": "https://github.com/AikidoSec/aikido-claude-plugin.git",
              "sha": "5db259bac62bf0c3a37bfd0fee6e22cc25bdb704"
            },
            "policy": null
          }
        },
        {
          "id": "anthropic:airtable",
          "name": "airtable",
          "displayName": "airtable",
          "description": "Airtable is the database and operations layer for your agents — whether running product, marketing, sales, ops, HR, or a custom business app. It combines structured data with multiplayer visual surfaces (grid, kanban, calendar, gallery, timeline) humans and agents share — plus sync integrations to Jira, Salesforce, Zendesk, Google Drive, and Databricks. Makes Claude fluent in Airtable: bases and schema, records, and collaboration UI. Bundles the official Airtable MCP server.",
          "longDescription": "Airtable is the database and operations layer for your agents — whether running product, marketing, sales, ops, HR, or a custom business app. It combines structured data with multiplayer visual surfaces (grid, kanban, calendar, gallery, timeline) humans and agents share — plus sync integrations to Jira, Salesforce, Zendesk, Google Drive, and Databricks. Makes Claude fluent in Airtable: bases and schema, records, and collaboration UI. Bundles the official Airtable MCP server.",
          "category": "productivity",
          "keywords": [
            "airtable",
            "database",
            "relational-database",
            "application-database",
            "data-store",
            "persistence",
            "crud",
            "product",
            "product-ops",
            "crm",
            "sales",
            "marketing",
            "operations",
            "hr",
            "hiring",
            "project-management",
            "roadmap",
            "customer-success",
            "nocode",
            "low-code",
            "spreadsheet",
            "collaboration",
            "real-time",
            "governance",
            "workflow",
            "automation",
            "internal-tools",
            "mcp",
            "content"
          ],
          "author": {
            "name": "Airtable",
            "url": "https://www.airtable.com"
          },
          "version": "0.1.0",
          "license": "MIT",
          "logoUrl": null,
          "darkLogoUrl": null,
          "homepage": "https://www.airtable.com",
          "sourceUrl": "https://github.com/Airtable/skills/tree/812ee67f1fd3d76fb45ff8df40afaa0448602ba8/plugins/airtable",
          "skills": [
            {
              "name": "agent-activity-log",
              "sourceUrl": "https://github.com/Airtable/skills/blob/812ee67f1fd3d76fb45ff8df40afaa0448602ba8/plugins/airtable/skills/agent-activity-log/SKILL.md"
            },
            {
              "name": "airtable-cli",
              "sourceUrl": "https://github.com/Airtable/skills/blob/812ee67f1fd3d76fb45ff8df40afaa0448602ba8/plugins/airtable/skills/airtable-cli/SKILL.md"
            },
            {
              "name": "airtable-filters",
              "sourceUrl": "https://github.com/Airtable/skills/blob/812ee67f1fd3d76fb45ff8df40afaa0448602ba8/plugins/airtable/skills/airtable-filters/SKILL.md"
            },
            {
              "name": "airtable-overview",
              "sourceUrl": "https://github.com/Airtable/skills/blob/812ee67f1fd3d76fb45ff8df40afaa0448602ba8/plugins/airtable/skills/airtable-overview/SKILL.md"
            },
            {
              "name": "marketing-ops",
              "sourceUrl": "https://github.com/Airtable/skills/blob/812ee67f1fd3d76fb45ff8df40afaa0448602ba8/plugins/airtable/skills/marketing-ops/SKILL.md"
            },
            {
              "name": "product-ops",
              "sourceUrl": "https://github.com/Airtable/skills/blob/812ee67f1fd3d76fb45ff8df40afaa0448602ba8/plugins/airtable/skills/product-ops/SKILL.md"
            },
            {
              "name": "sales-ops",
              "sourceUrl": "https://github.com/Airtable/skills/blob/812ee67f1fd3d76fb45ff8df40afaa0448602ba8/plugins/airtable/skills/sales-ops/SKILL.md"
            },
            {
              "name": "show-airtable-link",
              "sourceUrl": "https://github.com/Airtable/skills/blob/812ee67f1fd3d76fb45ff8df40afaa0448602ba8/plugins/airtable/skills/show-airtable-link/SKILL.md"
            }
          ],
          "mcpServers": [
            {
              "requiresConfiguration": false,
              "name": "airtable",
              "transport": "http",
              "endpoint": "https://mcp.airtable.com/mcp"
            }
          ],
          "components": ["skills", "mcp"],
          "componentInspection": "repository",
          "inspectionError": null,
          "installation": "requires_adapter",
          "upstream": {
            "source": {
              "source": "git-subdir",
              "url": "https://github.com/Airtable/skills.git",
              "path": "plugins/airtable",
              "ref": "main",
              "sha": "812ee67f1fd3d76fb45ff8df40afaa0448602ba8"
            },
            "policy": null
          }
        },
        {
          "id": "anthropic:airwallex-agentos",
          "name": "airwallex-agentos",
          "displayName": "airwallex-agentos",
          "description": "Bring Airwallex's global financial infrastructure to Claude. Orchestrate actions across your account in plain language, e.g., set up invoices from a PO, onboard suppliers from invoices, and check current cash position across currencies. AgentOS bundles pre-built finance Skills with MCP servers. A public CLI connects your agent to Airwallex's capabilities.",
          "longDescription": "Bring Airwallex's global financial infrastructure to Claude. Orchestrate actions across your account in plain language, e.g., set up invoices from a PO, onboard suppliers from invoices, and check current cash position across currencies. AgentOS bundles pre-built finance Skills with MCP servers. A public CLI connects your agent to Airwallex's capabilities.",
          "category": "productivity",
          "keywords": [
            "airwallex",
            "business accounts",
            "billing",
            "invoices",
            "payments",
            "issuing",
            "treasury",
            "cli",
            "mcp"
          ],
          "author": {
            "name": "Airwallex",
            "url": "https://www.airwallex.com"
          },
          "version": "0.2.4",
          "license": "Apache-2.0",
          "logoUrl": null,
          "darkLogoUrl": null,
          "homepage": "https://www.airwallex.com/docs",
          "sourceUrl": "https://github.com/airwallex/airwallex-marketplace/tree/d4593e33a9e1177a44b895ca0a1d6e015215736f/plugins/airwallex-agentos",
          "skills": [
            {
              "name": "awx-best-practices",
              "sourceUrl": "https://github.com/airwallex/airwallex-marketplace/blob/d4593e33a9e1177a44b895ca0a1d6e015215736f/plugins/airwallex-agentos/skills/awx-best-practices/SKILL.md"
            },
            {
              "name": "beneficiary-creation",
              "sourceUrl": "https://github.com/airwallex/airwallex-marketplace/blob/d4593e33a9e1177a44b895ca0a1d6e015215736f/plugins/airwallex-agentos/skills/beneficiary-creation/SKILL.md"
            },
            {
              "name": "card-provisioning",
              "sourceUrl": "https://github.com/airwallex/airwallex-marketplace/blob/d4593e33a9e1177a44b895ca0a1d6e015215736f/plugins/airwallex-agentos/skills/card-provisioning/SKILL.md"
            },
            {
              "name": "contract-to-billing",
              "sourceUrl": "https://github.com/airwallex/airwallex-marketplace/blob/d4593e33a9e1177a44b895ca0a1d6e015215736f/plugins/airwallex-agentos/skills/contract-to-billing/SKILL.md"
            },
            {
              "name": "manage-cashflow",
              "sourceUrl": "https://github.com/airwallex/airwallex-marketplace/blob/d4593e33a9e1177a44b895ca0a1d6e015215736f/plugins/airwallex-agentos/skills/manage-cashflow/SKILL.md"
            }
          ],
          "mcpServers": [
            {
              "requiresConfiguration": false,
              "name": "airwallex-dev",
              "transport": "http",
              "endpoint": "https://mcp.sandbox.airwallex.com/developer"
            },
            {
              "requiresConfiguration": false,
              "name": "airwallex-agentos",
              "transport": "http",
              "endpoint": "https://mcp.airwallex.com/mcp"
            }
          ],
          "components": ["skills", "mcp"],
          "componentInspection": "repository",
          "inspectionError": null,
          "installation": "requires_adapter",
          "upstream": {
            "source": {
              "source": "git-subdir",
              "url": "https://github.com/airwallex/airwallex-marketplace.git",
              "path": "plugins/airwallex-agentos",
              "ref": "master",
              "sha": "d4593e33a9e1177a44b895ca0a1d6e015215736f"
            },
            "policy": null
          }
        },
        {
          "id": "anthropic:airwallex-dev",
          "name": "airwallex-dev",
          "displayName": "airwallex-dev",
          "description": "Airwallex integration skills for Claude. Code-generation workflows that scaffold, configure, and wire Airwallex APIs into your project.",
          "longDescription": "Airwallex integration skills for Claude. Code-generation workflows that scaffold, configure, and wire Airwallex APIs into your project.",
          "category": "development",
          "keywords": [
            "airwallex",
            "integration",
            "developer",
            "sdk",
            "code-generation",
            "payments",
            "checkout"
          ],
          "author": {
            "name": "Airwallex",
            "url": "https://www.airwallex.com"
          },
          "version": "0.1.0",
          "license": "Apache-2.0",
          "logoUrl": null,
          "darkLogoUrl": null,
          "homepage": "https://www.airwallex.com/docs",
          "sourceUrl": "https://github.com/airwallex/airwallex-marketplace/tree/d4593e33a9e1177a44b895ca0a1d6e015215736f/plugins/airwallex-dev",
          "skills": [
            {
              "name": "airwallex-ai-provider-card-mit",
              "sourceUrl": "https://github.com/airwallex/airwallex-marketplace/blob/d4593e33a9e1177a44b895ca0a1d6e015215736f/plugins/airwallex-dev/skills/airwallex-ai-provider-card-mit/SKILL.md"
            },
            {
              "name": "airwallex-billing-checkout",
              "sourceUrl": "https://github.com/airwallex/airwallex-marketplace/blob/d4593e33a9e1177a44b895ca0a1d6e015215736f/plugins/airwallex-dev/skills/airwallex-billing-checkout/SKILL.md"
            },
            {
              "name": "airwallex-dropin",
              "sourceUrl": "https://github.com/airwallex/airwallex-marketplace/blob/d4593e33a9e1177a44b895ca0a1d6e015215736f/plugins/airwallex-dev/skills/airwallex-dropin/SKILL.md"
            },
            {
              "name": "airwallex-hpp",
              "sourceUrl": "https://github.com/airwallex/airwallex-marketplace/blob/d4593e33a9e1177a44b895ca0a1d6e015215736f/plugins/airwallex-dev/skills/airwallex-hpp/SKILL.md"
            },
            {
              "name": "airwallex-kyc",
              "sourceUrl": "https://github.com/airwallex/airwallex-marketplace/blob/d4593e33a9e1177a44b895ca0a1d6e015215736f/plugins/airwallex-dev/skills/airwallex-kyc/SKILL.md"
            },
            {
              "name": "airwallex-split-card",
              "sourceUrl": "https://github.com/airwallex/airwallex-marketplace/blob/d4593e33a9e1177a44b895ca0a1d6e015215736f/plugins/airwallex-dev/skills/airwallex-split-card/SKILL.md"
            }
          ],
          "mcpServers": [
            {
              "requiresConfiguration": false,
              "name": "airwallex-dev",
              "transport": "http",
              "endpoint": "https://mcp.sandbox.airwallex.com/developer"
            }
          ],
          "components": ["skills", "mcp"],
          "componentInspection": "repository",
          "inspectionError": null,
          "installation": "requires_adapter",
          "upstream": {
            "source": {
              "source": "git-subdir",
              "url": "https://github.com/airwallex/airwallex-marketplace.git",
              "path": "plugins/airwallex-dev",
              "ref": "master",
              "sha": "d4593e33a9e1177a44b895ca0a1d6e015215736f"
            },
            "policy": null
          }
        },
        {
          "id": "anthropic:aiven",
          "name": "aiven",
          "displayName": "aiven",
          "description": "Easily deploy managed PostgreSQL (pg), Kafka, OpenSearch, Clickhouse and other databases, streaming and apps. Free tier available, up and running in minutes.",
          "longDescription": "Easily deploy managed PostgreSQL (pg), Kafka, OpenSearch, Clickhouse and other databases, streaming and apps. Free tier available, up and running in minutes.",
          "category": "database",
          "keywords": [
            "aiven",
            "postgres",
            "pg",
            "kafka",
            "database",
            "streaming",
            "cloud",
            "opensearch",
            "clickhouse",
            "valkey",
            "kafka-connect",
            "apps"
          ],
          "author": {
            "name": "Aiven",
            "url": "https://aiven.io"
          },
          "version": "1.0.6",
          "license": "Apache-2.0",
          "logoUrl": null,
          "darkLogoUrl": null,
          "homepage": "https://aiven.io",
          "sourceUrl": "https://github.com/aiven/aiven-ai-plugins/tree/634f41d6852957cb9280e9245f2ea6f74645b4f1/",
          "skills": [
            {
              "name": "aiven-getting-started",
              "sourceUrl": "https://github.com/aiven/aiven-ai-plugins/blob/634f41d6852957cb9280e9245f2ea6f74645b4f1/skills/aiven-getting-started/SKILL.md"
            }
          ],
          "mcpServers": [
            {
              "requiresConfiguration": false,
              "name": "aiven",
              "transport": "http",
              "endpoint": "https://mcp.aiven.live/mcp"
            }
          ],
          "components": ["skills", "mcp"],
          "componentInspection": "repository",
          "inspectionError": null,
          "installation": "requires_adapter",
          "upstream": {
            "source": {
              "source": "url",
              "url": "https://github.com/aiven/aiven-ai-plugins.git",
              "sha": "634f41d6852957cb9280e9245f2ea6f74645b4f1"
            },
            "policy": null
          }
        },
        {
          "id": "anthropic:alloydb",
          "name": "alloydb",
          "displayName": "alloydb",
          "description": "Create, connect, and interact with an AlloyDB for PostgreSQL database and data.",
          "longDescription": "Create, connect, and interact with an AlloyDB for PostgreSQL database and data.",
          "category": "database",
          "keywords": [],
          "author": {
            "name": "Google LLC",
            "email": "data-cloud-ai-integrations@google.com"
          },
          "version": "0.2.0",
          "license": "Apache-2.0",
          "logoUrl": null,
          "darkLogoUrl": null,
          "homepage": "https://cloud.google.com/alloydb",
          "sourceUrl": "https://github.com/gemini-cli-extensions/alloydb/tree/00ee6ce2bcf88b46da4bf298a3ad8c0ad85877c8/",
          "skills": [],
          "mcpServers": [
            {
              "requiresConfiguration": false,
              "name": "alloydb-postgres",
              "transport": "stdio",
              "endpoint": null
            }
          ],
          "components": ["mcp"],
          "componentInspection": "repository",
          "inspectionError": null,
          "installation": "requires_adapter",
          "upstream": {
            "source": {
              "source": "url",
              "url": "https://github.com/gemini-cli-extensions/alloydb.git",
              "sha": "00ee6ce2bcf88b46da4bf298a3ad8c0ad85877c8"
            },
            "policy": null
          }
        },
        {
          "id": "anthropic:alloydb-omni",
          "name": "alloydb-omni",
          "displayName": "alloydb-omni",
          "description": "Create, connect, and interact with an AlloyDB Omni database and data.",
          "longDescription": "Create, connect, and interact with an AlloyDB Omni database and data.",
          "category": "database",
          "keywords": [],
          "author": {
            "name": "Google LLC",
            "email": "data-cloud-ai-integrations@google.com"
          },
          "version": "0.2.1",
          "license": "Apache-2.0",
          "logoUrl": null,
          "darkLogoUrl": null,
          "homepage": "https://cloud.google.com/alloydb/omni",
          "sourceUrl": "https://github.com/gemini-cli-extensions/alloydb-omni/tree/ae7e42c4e428e303adcc96942f4fc35cb6b27d61/",
          "skills": [
            {
              "name": "alloydb-omni-container",
              "sourceUrl": "https://github.com/gemini-cli-extensions/alloydb-omni/blob/ae7e42c4e428e303adcc96942f4fc35cb6b27d61/skills/alloydb-omni-container/SKILL.md"
            },
            {
              "name": "alloydb-omni-kubernetes",
              "sourceUrl": "https://github.com/gemini-cli-extensions/alloydb-omni/blob/ae7e42c4e428e303adcc96942f4fc35cb6b27d61/skills/alloydb-omni-kubernetes/SKILL.md"
            }
          ],
          "mcpServers": [
            {
              "requiresConfiguration": false,
              "name": "alloydb-omni",
              "transport": "stdio",
              "endpoint": null
            }
          ],
          "components": ["skills", "mcp"],
          "componentInspection": "repository",
          "inspectionError": null,
          "installation": "requires_adapter",
          "upstream": {
            "source": {
              "source": "url",
              "url": "https://github.com/gemini-cli-extensions/alloydb-omni.git",
              "sha": "ae7e42c4e428e303adcc96942f4fc35cb6b27d61"
            },
            "policy": null
          }
        },
        {
          "id": "anthropic:altimate-code",
          "name": "altimate-code",
          "displayName": "altimate-code",
          "description": "Delegates dbt and warehouse work to altimate-code, a specialized CLI agent with 100+ purpose-built data tools (SQL analysis, column-level lineage, dbt build/test/run, warehouse profiling, FinOps, connectivity to Snowflake, BigQuery, Redshift, Databricks, Postgres, MySQL, DuckDB).",
          "longDescription": "Delegates dbt and warehouse work to altimate-code, a specialized CLI agent with 100+ purpose-built data tools (SQL analysis, column-level lineage, dbt build/test/run, warehouse profiling, FinOps, connectivity to Snowflake, BigQuery, Redshift, Databricks, Postgres, MySQL, DuckDB).",
          "category": "database",
          "keywords": [
            "dbt",
            "sql",
            "data-engineering",
            "warehouse",
            "snowflake",
            "bigquery",
            "databricks",
            "column-lineage"
          ],
          "author": {
            "name": "AltimateAI",
            "url": "https://altimate.ai"
          },
          "version": "1.0.0",
          "license": "MIT",
          "logoUrl": null,
          "darkLogoUrl": null,
          "homepage": "https://github.com/AltimateAI/altimate-claude-plugin",
          "sourceUrl": "https://github.com/AltimateAI/altimate-claude-plugin/tree/b7c8f68b3dfd303ab3ccf2f43934098811dfe2aa/plugins/altimate-code",
          "skills": [
            {
              "name": "altimate-code",
              "sourceUrl": "https://github.com/AltimateAI/altimate-claude-plugin/blob/b7c8f68b3dfd303ab3ccf2f43934098811dfe2aa/plugins/altimate-code/skills/altimate-code/SKILL.md"
            },
            {
              "name": "review",
              "sourceUrl": "https://github.com/AltimateAI/altimate-claude-plugin/blob/b7c8f68b3dfd303ab3ccf2f43934098811dfe2aa/plugins/altimate-code/skills/review/SKILL.md"
            }
          ],
          "mcpServers": [],
          "components": ["skills", "hooks", "commands"],
          "componentInspection": "repository",
          "inspectionError": null,
          "installation": "requires_adapter",
          "upstream": {
            "source": {
              "source": "git-subdir",
              "url": "https://github.com/AltimateAI/altimate-claude-plugin.git",
              "path": "plugins/altimate-code",
              "ref": "main",
              "sha": "b7c8f68b3dfd303ab3ccf2f43934098811dfe2aa"
            },
            "policy": null
          }
        },
        {
          "id": "anthropic:amazon-location-service",
          "name": "amazon-location-service",
          "displayName": "amazon-location-service",
          "description": "Guide developers through adding maps, places search, geocoding, routing, and other geospatial features with Amazon Location Service, including authentication setup, SDK integration, and best practices.",
          "longDescription": "Guide developers through adding maps, places search, geocoding, routing, and other geospatial features with Amazon Location Service, including authentication setup, SDK integration, and best practices.",
          "category": "location",
          "keywords": [
            "location",
            "maps",
            "geocoding",
            "routing",
            "places",
            "geofencing",
            "tracking",
            "amazon-location",
            "maplibre",
            "address",
            "coordinates"
          ],
          "author": {
            "name": "Amazon Web Services"
          },
          "version": "1.0.0",
          "license": "Apache-2.0",
          "logoUrl": null,
          "darkLogoUrl": null,
          "homepage": "https://github.com/awslabs/agent-plugins",
          "sourceUrl": "https://github.com/awslabs/agent-plugins/tree/c65ee436b0db77bb75d380aef6fbdc9b114edf2a/plugins/amazon-location-service",
          "skills": [
            {
              "name": "amazon-location-service",
              "sourceUrl": "https://github.com/awslabs/agent-plugins/blob/c65ee436b0db77bb75d380aef6fbdc9b114edf2a/plugins/amazon-location-service/skills/amazon-location-service/SKILL.md"
            }
          ],
          "mcpServers": [
            {
              "requiresConfiguration": false,
              "name": "aws-mcp",
              "transport": "stdio",
              "endpoint": null
            }
          ],
          "components": ["skills", "mcp"],
          "componentInspection": "repository",
          "inspectionError": null,
          "installation": "requires_adapter",
          "upstream": {
            "source": {
              "source": "git-subdir",
              "url": "https://github.com/awslabs/agent-plugins.git",
              "path": "plugins/amazon-location-service",
              "ref": "main",
              "sha": "c65ee436b0db77bb75d380aef6fbdc9b114edf2a"
            },
            "policy": null
          }
        },
        {
          "id": "anthropic:amd-skills",
          "name": "amd-skills",
          "displayName": "amd-skills",
          "description": "AMD's verified Agent Skills in one plugin: route image/audio through local AI on Ryzen AI, serve LLMs on AMD Instinct GPUs with vLLM, and analyze GPU kernel and PyTorch trace performance.",
          "longDescription": "AMD's verified Agent Skills in one plugin: route image/audio through local AI on Ryzen AI, serve LLMs on AMD Instinct GPUs with vLLM, and analyze GPU kernel and PyTorch trace performance.",
          "category": "development",
          "keywords": [],
          "author": {
            "name": "AMD"
          },
          "version": null,
          "license": null,
          "logoUrl": null,
          "darkLogoUrl": null,
          "homepage": "https://developer.amd.com/",
          "sourceUrl": "https://github.com/amd/skills/tree/e867fa4ae4516f644221cb04dcdf24008a43cb99/skills",
          "skills": [
            {
              "name": "hyperloom-workload-optimizer",
              "sourceUrl": "https://github.com/amd/skills/blob/e867fa4ae4516f644221cb04dcdf24008a43cb99/skills/hyperloom-workload-optimizer/SKILL.md"
            },
            {
              "name": "lemonade-router-builder",
              "sourceUrl": "https://github.com/amd/skills/blob/e867fa4ae4516f644221cb04dcdf24008a43cb99/skills/lemonade-router-builder/SKILL.md"
            },
            {
              "name": "local-ai-app-integration",
              "sourceUrl": "https://github.com/amd/skills/blob/e867fa4ae4516f644221cb04dcdf24008a43cb99/skills/local-ai-app-integration/SKILL.md"
            },
            {
              "name": "local-ai-use",
              "sourceUrl": "https://github.com/amd/skills/blob/e867fa4ae4516f644221cb04dcdf24008a43cb99/skills/local-ai-use/SKILL.md"
            },
            {
              "name": "magpie-kernel-evaluator",
              "sourceUrl": "https://github.com/amd/skills/blob/e867fa4ae4516f644221cb04dcdf24008a43cb99/skills/magpie-kernel-evaluator/SKILL.md"
            },
            {
              "name": "serving-llms-on-epyc",
              "sourceUrl": "https://github.com/amd/skills/blob/e867fa4ae4516f644221cb04dcdf24008a43cb99/skills/serving-llms-on-epyc/SKILL.md"
            },
            {
              "name": "serving-llms-on-instinct",
              "sourceUrl": "https://github.com/amd/skills/blob/e867fa4ae4516f644221cb04dcdf24008a43cb99/skills/serving-llms-on-instinct/SKILL.md"
            },
            {
              "name": "tracelens-analysis-orchestrator",
              "sourceUrl": "https://github.com/amd/skills/blob/e867fa4ae4516f644221cb04dcdf24008a43cb99/skills/tracelens-analysis-orchestrator/SKILL.md"
            }
          ],
          "mcpServers": [],
          "components": ["skills"],
          "componentInspection": "repository",
          "inspectionError": null,
          "installation": "requires_adapter",
          "upstream": {
            "source": {
              "source": "git-subdir",
              "url": "https://github.com/amd/skills.git",
              "path": "skills",
              "ref": "main",
              "sha": "e867fa4ae4516f644221cb04dcdf24008a43cb99"
            },
            "policy": null
          }
        },
        {
          "id": "anthropic:amplitude",
          "name": "amplitude",
          "displayName": "amplitude",
          "description": "Use Amplitude like an expert - instrument analytics, discover product opportunities, analyze charts, create dashboards, manage experiments, and understand users and accounts",
          "longDescription": "Use Amplitude like an expert - instrument analytics, discover product opportunities, analyze charts, create dashboards, manage experiments, and understand users and accounts",
          "category": "monitoring",
          "keywords": [],
          "author": {
            "name": "Amplitude",
            "email": "support@amplitude.com",
            "url": "https://amplitude.com"
          },
          "version": null,
          "license": null,
          "logoUrl": null,
          "darkLogoUrl": null,
          "homepage": "https://github.com/amplitude/mcp-marketplace",
          "sourceUrl": "https://github.com/amplitude/mcp-marketplace/tree/2d3074021410fcb8a6d9c6833bd054f2ce228ed5/plugins/amplitude",
          "skills": [
            {
              "name": "add-analytics-instrumentation",
              "sourceUrl": "https://github.com/amplitude/mcp-marketplace/blob/2d3074021410fcb8a6d9c6833bd054f2ce228ed5/plugins/amplitude/skills/add-analytics-instrumentation/SKILL.md"
            },
            {
              "name": "analyze-account-health",
              "sourceUrl": "https://github.com/amplitude/mcp-marketplace/blob/2d3074021410fcb8a6d9c6833bd054f2ce228ed5/plugins/amplitude/skills/analyze-account-health/SKILL.md"
            },
            {
              "name": "analyze-ai-topics",
              "sourceUrl": "https://github.com/amplitude/mcp-marketplace/blob/2d3074021410fcb8a6d9c6833bd054f2ce228ed5/plugins/amplitude/skills/analyze-ai-topics/SKILL.md"
            },
            {
              "name": "analyze-chart",
              "sourceUrl": "https://github.com/amplitude/mcp-marketplace/blob/2d3074021410fcb8a6d9c6833bd054f2ce228ed5/plugins/amplitude/skills/analyze-chart/SKILL.md"
            },
            {
              "name": "analyze-dashboard",
              "sourceUrl": "https://github.com/amplitude/mcp-marketplace/blob/2d3074021410fcb8a6d9c6833bd054f2ce228ed5/plugins/amplitude/skills/analyze-dashboard/SKILL.md"
            },
            {
              "name": "analyze-experiment-consolidated",
              "sourceUrl": "https://github.com/amplitude/mcp-marketplace/blob/2d3074021410fcb8a6d9c6833bd054f2ce228ed5/plugins/amplitude/skills/analyze-experiment-consolidated/SKILL.md"
            },
            {
              "name": "analyze-experiment",
              "sourceUrl": "https://github.com/amplitude/mcp-marketplace/blob/2d3074021410fcb8a6d9c6833bd054f2ce228ed5/plugins/amplitude/skills/analyze-experiment/SKILL.md"
            },
            {
              "name": "analyze-feedback",
              "sourceUrl": "https://github.com/amplitude/mcp-marketplace/blob/2d3074021410fcb8a6d9c6833bd054f2ce228ed5/plugins/amplitude/skills/analyze-feedback/SKILL.md"
            },
            {
              "name": "build-charts-with-typed-params",
              "sourceUrl": "https://github.com/amplitude/mcp-marketplace/blob/2d3074021410fcb8a6d9c6833bd054f2ce228ed5/plugins/amplitude/skills/build-charts-with-typed-params/SKILL.md"
            },
            {
              "name": "chart-link-analysis",
              "sourceUrl": "https://github.com/amplitude/mcp-marketplace/blob/2d3074021410fcb8a6d9c6833bd054f2ce228ed5/plugins/amplitude/skills/chart-link-analysis/SKILL.md"
            },
            {
              "name": "compare-user-journeys",
              "sourceUrl": "https://github.com/amplitude/mcp-marketplace/blob/2d3074021410fcb8a6d9c6833bd054f2ce228ed5/plugins/amplitude/skills/compare-user-journeys/SKILL.md"
            },
            {
              "name": "create-chart",
              "sourceUrl": "https://github.com/amplitude/mcp-marketplace/blob/2d3074021410fcb8a6d9c6833bd054f2ce228ed5/plugins/amplitude/skills/create-chart/SKILL.md"
            },
            {
              "name": "create-dashboard",
              "sourceUrl": "https://github.com/amplitude/mcp-marketplace/blob/2d3074021410fcb8a6d9c6833bd054f2ce228ed5/plugins/amplitude/skills/create-dashboard/SKILL.md"
            },
            {
              "name": "daily-brief",
              "sourceUrl": "https://github.com/amplitude/mcp-marketplace/blob/2d3074021410fcb8a6d9c6833bd054f2ce228ed5/plugins/amplitude/skills/daily-brief/SKILL.md"
            },
            {
              "name": "debug-replay",
              "sourceUrl": "https://github.com/amplitude/mcp-marketplace/blob/2d3074021410fcb8a6d9c6833bd054f2ce228ed5/plugins/amplitude/skills/debug-replay/SKILL.md"
            },
            {
              "name": "diagnose-errors",
              "sourceUrl": "https://github.com/amplitude/mcp-marketplace/blob/2d3074021410fcb8a6d9c6833bd054f2ce228ed5/plugins/amplitude/skills/diagnose-errors/SKILL.md"
            },
            {
              "name": "diff-intake",
              "sourceUrl": "https://github.com/amplitude/mcp-marketplace/blob/2d3074021410fcb8a6d9c6833bd054f2ce228ed5/plugins/amplitude/skills/diff-intake/SKILL.md"
            },
            {
              "name": "discover-analytics-patterns",
              "sourceUrl": "https://github.com/amplitude/mcp-marketplace/blob/2d3074021410fcb8a6d9c6833bd054f2ce228ed5/plugins/amplitude/skills/discover-analytics-patterns/SKILL.md"
            },
            {
              "name": "discover-event-surfaces",
              "sourceUrl": "https://github.com/amplitude/mcp-marketplace/blob/2d3074021410fcb8a6d9c6833bd054f2ce228ed5/plugins/amplitude/skills/discover-event-surfaces/SKILL.md"
            },
            {
              "name": "discover-opportunities",
              "sourceUrl": "https://github.com/amplitude/mcp-marketplace/blob/2d3074021410fcb8a6d9c6833bd054f2ce228ed5/plugins/amplitude/skills/discover-opportunities/SKILL.md"
            },
            {
              "name": "instrument-events",
              "sourceUrl": "https://github.com/amplitude/mcp-marketplace/blob/2d3074021410fcb8a6d9c6833bd054f2ce228ed5/plugins/amplitude/skills/instrument-events/SKILL.md"
            },
            {
              "name": "investigate-ai-session",
              "sourceUrl": "https://github.com/amplitude/mcp-marketplace/blob/2d3074021410fcb8a6d9c6833bd054f2ce228ed5/plugins/amplitude/skills/investigate-ai-session/SKILL.md"
            },
            {
              "name": "live-data-forensics",
              "sourceUrl": "https://github.com/amplitude/mcp-marketplace/blob/2d3074021410fcb8a6d9c6833bd054f2ce228ed5/plugins/amplitude/skills/live-data-forensics/SKILL.md"
            },
            {
              "name": "manage-amp-context",
              "sourceUrl": "https://github.com/amplitude/mcp-marketplace/blob/2d3074021410fcb8a6d9c6833bd054f2ce228ed5/plugins/amplitude/skills/manage-amp-context/SKILL.md"
            },
            {
              "name": "monitor-ai-quality",
              "sourceUrl": "https://github.com/amplitude/mcp-marketplace/blob/2d3074021410fcb8a6d9c6833bd054f2ce228ed5/plugins/amplitude/skills/monitor-ai-quality/SKILL.md"
            },
            {
              "name": "monitor-experiments-consolidated",
              "sourceUrl": "https://github.com/amplitude/mcp-marketplace/blob/2d3074021410fcb8a6d9c6833bd054f2ce228ed5/plugins/amplitude/skills/monitor-experiments-consolidated/SKILL.md"
            },
            {
              "name": "monitor-experiments",
              "sourceUrl": "https://github.com/amplitude/mcp-marketplace/blob/2d3074021410fcb8a6d9c6833bd054f2ce228ed5/plugins/amplitude/skills/monitor-experiments/SKILL.md"
            },
            {
              "name": "monitor-reliability",
              "sourceUrl": "https://github.com/amplitude/mcp-marketplace/blob/2d3074021410fcb8a6d9c6833bd054f2ce228ed5/plugins/amplitude/skills/monitor-reliability/SKILL.md"
            },
            {
              "name": "replay-ux-audit",
              "sourceUrl": "https://github.com/amplitude/mcp-marketplace/blob/2d3074021410fcb8a6d9c6833bd054f2ce228ed5/plugins/amplitude/skills/replay-ux-audit/SKILL.md"
            },
            {
              "name": "review-agent-insights",
              "sourceUrl": "https://github.com/amplitude/mcp-marketplace/blob/2d3074021410fcb8a6d9c6833bd054f2ce228ed5/plugins/amplitude/skills/review-agent-insights/SKILL.md"
            },
            {
              "name": "scheduled-report-refresh",
              "sourceUrl": "https://github.com/amplitude/mcp-marketplace/blob/2d3074021410fcb8a6d9c6833bd054f2ce228ed5/plugins/amplitude/skills/scheduled-report-refresh/SKILL.md"
            },
            {
              "name": "taxonomy",
              "sourceUrl": "https://github.com/amplitude/mcp-marketplace/blob/2d3074021410fcb8a6d9c6833bd054f2ce228ed5/plugins/amplitude/skills/taxonomy/SKILL.md"
            },
            {
              "name": "use-amp-guides-surveys",
              "sourceUrl": "https://github.com/amplitude/mcp-marketplace/blob/2d3074021410fcb8a6d9c6833bd054f2ce228ed5/plugins/amplitude/skills/use-amp-guides-surveys/SKILL.md"
            },
            {
              "name": "user-cohort-forensics",
              "sourceUrl": "https://github.com/amplitude/mcp-marketplace/blob/2d3074021410fcb8a6d9c6833bd054f2ce228ed5/plugins/amplitude/skills/user-cohort-forensics/SKILL.md"
            },
            {
              "name": "weekly-brief",
              "sourceUrl": "https://github.com/amplitude/mcp-marketplace/blob/2d3074021410fcb8a6d9c6833bd054f2ce228ed5/plugins/amplitude/skills/weekly-brief/SKILL.md"
            },
            {
              "name": "what-would-lenny-do",
              "sourceUrl": "https://github.com/amplitude/mcp-marketplace/blob/2d3074021410fcb8a6d9c6833bd054f2ce228ed5/plugins/amplitude/skills/what-would-lenny-do/SKILL.md"
            }
          ],
          "mcpServers": [
            {
              "requiresConfiguration": false,
              "name": "amplitude",
              "transport": "http",
              "endpoint": "https://mcp.amplitude.com/mcp"
            }
          ],
          "components": ["skills", "mcp"],
          "componentInspection": "repository",
          "inspectionError": null,
          "installation": "requires_adapter",
          "upstream": {
            "source": {
              "source": "git-subdir",
              "url": "https://github.com/amplitude/mcp-marketplace.git",
              "path": "plugins/amplitude",
              "ref": "main",
              "sha": "2d3074021410fcb8a6d9c6833bd054f2ce228ed5"
            },
            "policy": null
          }
        },
        {
          "id": "anthropic:apollo",
          "name": "apollo",
          "displayName": "apollo",
          "description": "Prospect, enrich leads, load outreach sequences, and query sales analytics with Apollo.io — one-click MCP server integration for Claude Code and Cowork.",
          "longDescription": "Prospect, enrich leads, load outreach sequences, and query sales analytics with Apollo.io — one-click MCP server integration for Claude Code and Cowork.",
          "category": "productivity",
          "keywords": [
            "apollo",
            "sales",
            "prospecting",
            "icp",
            "enrichment",
            "sequences",
            "analytics",
            "mcp"
          ],
          "author": {
            "name": "Apollo.io",
            "url": "https://www.apollo.io/"
          },
          "version": "0.1.1",
          "license": "MIT",
          "logoUrl": null,
          "darkLogoUrl": null,
          "homepage": "https://www.apollo.io/",
          "sourceUrl": "https://github.com/apolloio/apollo-mcp-plugin/tree/2adde980e45f421b7e9383d92870455627936bce/",
          "skills": [
            {
              "name": "analytics",
              "sourceUrl": "https://github.com/apolloio/apollo-mcp-plugin/blob/2adde980e45f421b7e9383d92870455627936bce/skills/analytics/SKILL.md"
            },
            {
              "name": "enrich-lead",
              "sourceUrl": "https://github.com/apolloio/apollo-mcp-plugin/blob/2adde980e45f421b7e9383d92870455627936bce/skills/enrich-lead/SKILL.md"
            },
            {
              "name": "prospect",
              "sourceUrl": "https://github.com/apolloio/apollo-mcp-plugin/blob/2adde980e45f421b7e9383d92870455627936bce/skills/prospect/SKILL.md"
            },
            {
              "name": "sequence-load",
              "sourceUrl": "https://github.com/apolloio/apollo-mcp-plugin/blob/2adde980e45f421b7e9383d92870455627936bce/skills/sequence-load/SKILL.md"
            }
          ],
          "mcpServers": [
            {
              "requiresConfiguration": false,
              "name": "apollo",
              "transport": "http",
              "endpoint": "https://mcp.apollo.io/mcp"
            }
          ],
          "components": ["skills", "mcp"],
          "componentInspection": "repository",
          "inspectionError": null,
          "installation": "requires_adapter",
          "upstream": {
            "source": {
              "source": "url",
              "url": "https://github.com/apolloio/apollo-mcp-plugin.git",
              "sha": "2adde980e45f421b7e9383d92870455627936bce"
            },
            "policy": null
          }
        },
        {
          "id": "anthropic:apollo-skills",
          "name": "apollo-skills",
          "displayName": "apollo-skills",
          "description": "Agent skills for AI coding agents working with Apollo GraphQL tools and technologies",
          "longDescription": "Agent skills for AI coding agents working with Apollo GraphQL tools and technologies",
          "category": "development",
          "keywords": [
            "graphql",
            "apollo",
            "apollo-client",
            "apollo-connectors",
            "apollo-federation",
            "apollo-ios",
            "apollo-kotlin",
            "apollo-mcp-server",
            "apollo-router",
            "apollo-server",
            "graphql-operations",
            "graphql-schema",
            "graphql-lsp",
            "rover",
            "rust-best-practices"
          ],
          "author": {
            "name": "Apollo GraphQL",
            "email": "opensource@apollographql.com"
          },
          "version": "1.2.9",
          "license": "MIT",
          "logoUrl": null,
          "darkLogoUrl": null,
          "homepage": "https://www.apollographql.com",
          "sourceUrl": "https://github.com/apollographql/skills/tree/c288eb80629dd2309eed81f23d693f66a452d043/",
          "skills": [
            {
              "name": "apollo-client",
              "sourceUrl": "https://github.com/apollographql/skills/blob/c288eb80629dd2309eed81f23d693f66a452d043/skills/apollo-client/SKILL.md"
            },
            {
              "name": "apollo-connectors",
              "sourceUrl": "https://github.com/apollographql/skills/blob/c288eb80629dd2309eed81f23d693f66a452d043/skills/apollo-connectors/SKILL.md"
            },
            {
              "name": "apollo-federation",
              "sourceUrl": "https://github.com/apollographql/skills/blob/c288eb80629dd2309eed81f23d693f66a452d043/skills/apollo-federation/SKILL.md"
            },
            {
              "name": "apollo-ios",
              "sourceUrl": "https://github.com/apollographql/skills/blob/c288eb80629dd2309eed81f23d693f66a452d043/skills/apollo-ios/SKILL.md"
            },
            {
              "name": "apollo-kotlin",
              "sourceUrl": "https://github.com/apollographql/skills/blob/c288eb80629dd2309eed81f23d693f66a452d043/skills/apollo-kotlin/SKILL.md"
            },
            {
              "name": "apollo-mcp-server",
              "sourceUrl": "https://github.com/apollographql/skills/blob/c288eb80629dd2309eed81f23d693f66a452d043/skills/apollo-mcp-server/SKILL.md"
            },
            {
              "name": "apollo-router-plugin-creator",
              "sourceUrl": "https://github.com/apollographql/skills/blob/c288eb80629dd2309eed81f23d693f66a452d043/skills/apollo-router-plugin-creator/SKILL.md"
            },
            {
              "name": "apollo-router",
              "sourceUrl": "https://github.com/apollographql/skills/blob/c288eb80629dd2309eed81f23d693f66a452d043/skills/apollo-router/SKILL.md"
            },
            {
              "name": "apollo-server",
              "sourceUrl": "https://github.com/apollographql/skills/blob/c288eb80629dd2309eed81f23d693f66a452d043/skills/apollo-server/SKILL.md"
            },
            {
              "name": "graphql-operations",
              "sourceUrl": "https://github.com/apollographql/skills/blob/c288eb80629dd2309eed81f23d693f66a452d043/skills/graphql-operations/SKILL.md"
            },
            {
              "name": "graphql-schema",
              "sourceUrl": "https://github.com/apollographql/skills/blob/c288eb80629dd2309eed81f23d693f66a452d043/skills/graphql-schema/SKILL.md"
            },
            {
              "name": "rover",
              "sourceUrl": "https://github.com/apollographql/skills/blob/c288eb80629dd2309eed81f23d693f66a452d043/skills/rover/SKILL.md"
            },
            {
              "name": "rust-best-practices",
              "sourceUrl": "https://github.com/apollographql/skills/blob/c288eb80629dd2309eed81f23d693f66a452d043/skills/rust-best-practices/SKILL.md"
            },
            {
              "name": "skill-creator",
              "sourceUrl": "https://github.com/apollographql/skills/blob/c288eb80629dd2309eed81f23d693f66a452d043/skills/skill-creator/SKILL.md"
            }
          ],
          "mcpServers": [
            {
              "requiresConfiguration": false,
              "name": "graphos-tools",
              "transport": "http",
              "endpoint": "https://mcp.apollographql.com"
            }
          ],
          "components": ["skills", "mcp", "lsp"],
          "componentInspection": "repository",
          "inspectionError": null,
          "installation": "requires_adapter",
          "upstream": {
            "source": {
              "source": "url",
              "url": "https://github.com/apollographql/skills.git",
              "sha": "c288eb80629dd2309eed81f23d693f66a452d043"
            },
            "policy": null
          }
        },
        {
          "id": "anthropic:appwrite",
          "name": "appwrite",
          "displayName": "appwrite",
          "description": "Appwrite tools for Claude Code, including SDK skills, the hosted Appwrite MCP server, and deployment commands.",
          "longDescription": "Appwrite tools for Claude Code, including SDK skills, the hosted Appwrite MCP server, and deployment commands.",
          "category": "development",
          "keywords": ["appwrite", "claude-code", "mcp", "skills"],
          "author": {
            "name": "Appwrite",
            "email": "team@appwrite.io"
          },
          "version": "0.2.0",
          "license": "BSD-3-Clause",
          "logoUrl": null,
          "darkLogoUrl": null,
          "homepage": "https://appwrite.io/docs/tooling/ai/ai-dev-tools/claude-code",
          "sourceUrl": "https://github.com/appwrite/claude-plugin/tree/ab3c90b37c95b7068f0c064dc562cf21958e8e19/",
          "skills": [
            {
              "name": "cli",
              "sourceUrl": "https://github.com/appwrite/claude-plugin/blob/ab3c90b37c95b7068f0c064dc562cf21958e8e19/skills/cli/SKILL.md"
            },
            {
              "name": "dart",
              "sourceUrl": "https://github.com/appwrite/claude-plugin/blob/ab3c90b37c95b7068f0c064dc562cf21958e8e19/skills/dart/SKILL.md"
            },
            {
              "name": "dotnet",
              "sourceUrl": "https://github.com/appwrite/claude-plugin/blob/ab3c90b37c95b7068f0c064dc562cf21958e8e19/skills/dotnet/SKILL.md"
            },
            {
              "name": "go",
              "sourceUrl": "https://github.com/appwrite/claude-plugin/blob/ab3c90b37c95b7068f0c064dc562cf21958e8e19/skills/go/SKILL.md"
            },
            {
              "name": "kotlin",
              "sourceUrl": "https://github.com/appwrite/claude-plugin/blob/ab3c90b37c95b7068f0c064dc562cf21958e8e19/skills/kotlin/SKILL.md"
            },
            {
              "name": "php",
              "sourceUrl": "https://github.com/appwrite/claude-plugin/blob/ab3c90b37c95b7068f0c064dc562cf21958e8e19/skills/php/SKILL.md"
            },
            {
              "name": "python",
              "sourceUrl": "https://github.com/appwrite/claude-plugin/blob/ab3c90b37c95b7068f0c064dc562cf21958e8e19/skills/python/SKILL.md"
            },
            {
              "name": "ruby",
              "sourceUrl": "https://github.com/appwrite/claude-plugin/blob/ab3c90b37c95b7068f0c064dc562cf21958e8e19/skills/ruby/SKILL.md"
            },
            {
              "name": "rust",
              "sourceUrl": "https://github.com/appwrite/claude-plugin/blob/ab3c90b37c95b7068f0c064dc562cf21958e8e19/skills/rust/SKILL.md"
            },
            {
              "name": "swift",
              "sourceUrl": "https://github.com/appwrite/claude-plugin/blob/ab3c90b37c95b7068f0c064dc562cf21958e8e19/skills/swift/SKILL.md"
            },
            {
              "name": "typescript",
              "sourceUrl": "https://github.com/appwrite/claude-plugin/blob/ab3c90b37c95b7068f0c064dc562cf21958e8e19/skills/typescript/SKILL.md"
            }
          ],
          "mcpServers": [
            {
              "requiresConfiguration": false,
              "name": "appwrite",
              "transport": "http",
              "endpoint": "https://mcp.appwrite.io/"
            }
          ],
          "components": ["skills", "mcp", "commands"],
          "componentInspection": "repository",
          "inspectionError": null,
          "installation": "requires_adapter",
          "upstream": {
            "source": {
              "source": "url",
              "url": "https://github.com/appwrite/claude-plugin.git",
              "sha": "ab3c90b37c95b7068f0c064dc562cf21958e8e19"
            },
            "policy": null
          }
        },
        {
          "id": "anthropic:asana",
          "name": "asana",
          "displayName": "asana",
          "description": "Asana project management integration. Connects Claude Code to Asana's V2 MCP server (https://mcp.asana.com/v2/mcp) to create and manage tasks, search projects, update assignments, and track progress. Requires a one-time setup of your own Asana OAuth app — run /asana-setup after installing.",
          "longDescription": "Asana project management integration. Connects Claude Code to Asana's V2 MCP server (https://mcp.asana.com/v2/mcp) to create and manage tasks, search projects, update assignments, and track progress. Requires a one-time setup of your own Asana OAuth app — run /asana-setup after installing.",
          "category": "productivity",
          "keywords": [],
          "author": {
            "name": "Asana"
          },
          "version": null,
          "license": null,
          "logoUrl": null,
          "darkLogoUrl": null,
          "homepage": "https://github.com/anthropics/claude-plugins-public/tree/main/external_plugins/asana",
          "sourceUrl": "https://github.com/anthropics/claude-plugins-official/tree/3b600518a637492d37c9877aeb49c2a55d939c04/external_plugins/asana",
          "skills": [],
          "mcpServers": [],
          "components": ["commands"],
          "componentInspection": "repository",
          "inspectionError": null,
          "installation": "requires_adapter",
          "upstream": {
            "source": "./external_plugins/asana",
            "policy": null
          }
        },
        {
          "id": "anthropic:astronomer-data-agents",
          "name": "astronomer-data-agents",
          "displayName": "astronomer-data",
          "description": "Data engineering plugin - warehouse exploration, pipeline authoring, Airflow integration",
          "longDescription": "Data engineering plugin - warehouse exploration, pipeline authoring, Airflow integration",
          "category": "development",
          "keywords": [],
          "author": null,
          "version": "0.1.0",
          "license": null,
          "logoUrl": null,
          "darkLogoUrl": null,
          "homepage": "https://github.com/astronomer/agents",
          "sourceUrl": "https://github.com/astronomer/agents/tree/dbd9bb79c4f7b7ac9c1cdd2b4b75213c81f423e5/",
          "skills": [
            {
              "name": "airflow-adapter",
              "sourceUrl": "https://github.com/astronomer/agents/blob/dbd9bb79c4f7b7ac9c1cdd2b4b75213c81f423e5/astro-airflow-mcp/.claude/skills/airflow-adapter/SKILL.md"
            },
            {
              "name": "airflow-hitl",
              "sourceUrl": "https://github.com/astronomer/agents/blob/dbd9bb79c4f7b7ac9c1cdd2b4b75213c81f423e5/skills/airflow-hitl/SKILL.md"
            },
            {
              "name": "airflow-plugins",
              "sourceUrl": "https://github.com/astronomer/agents/blob/dbd9bb79c4f7b7ac9c1cdd2b4b75213c81f423e5/skills/airflow-plugins/SKILL.md"
            },
            {
              "name": "airflow-state-store",
              "sourceUrl": "https://github.com/astronomer/agents/blob/dbd9bb79c4f7b7ac9c1cdd2b4b75213c81f423e5/skills/airflow-state-store/SKILL.md"
            },
            {
              "name": "airflow",
              "sourceUrl": "https://github.com/astronomer/agents/blob/dbd9bb79c4f7b7ac9c1cdd2b4b75213c81f423e5/skills/airflow/SKILL.md"
            },
            {
              "name": "analyzing-data",
              "sourceUrl": "https://github.com/astronomer/agents/blob/dbd9bb79c4f7b7ac9c1cdd2b4b75213c81f423e5/skills/analyzing-data/SKILL.md"
            },
            {
              "name": "annotating-task-lineage",
              "sourceUrl": "https://github.com/astronomer/agents/blob/dbd9bb79c4f7b7ac9c1cdd2b4b75213c81f423e5/skills/annotating-task-lineage/SKILL.md"
            },
            {
              "name": "authoring-dags",
              "sourceUrl": "https://github.com/astronomer/agents/blob/dbd9bb79c4f7b7ac9c1cdd2b4b75213c81f423e5/skills/authoring-dags/SKILL.md"
            },
            {
              "name": "authoring-go-sdk-tasks",
              "sourceUrl": "https://github.com/astronomer/agents/blob/dbd9bb79c4f7b7ac9c1cdd2b4b75213c81f423e5/skills/authoring-go-sdk-tasks/SKILL.md"
            },
            {
              "name": "authoring-java-sdk-tasks",
              "sourceUrl": "https://github.com/astronomer/agents/blob/dbd9bb79c4f7b7ac9c1cdd2b4b75213c81f423e5/skills/authoring-java-sdk-tasks/SKILL.md"
            },
            {
              "name": "authoring-language-sdk-tasks",
              "sourceUrl": "https://github.com/astronomer/agents/blob/dbd9bb79c4f7b7ac9c1cdd2b4b75213c81f423e5/skills/authoring-language-sdk-tasks/SKILL.md"
            },
            {
              "name": "blueprint",
              "sourceUrl": "https://github.com/astronomer/agents/blob/dbd9bb79c4f7b7ac9c1cdd2b4b75213c81f423e5/skills/blueprint/SKILL.md"
            },
            {
              "name": "checking-freshness",
              "sourceUrl": "https://github.com/astronomer/agents/blob/dbd9bb79c4f7b7ac9c1cdd2b4b75213c81f423e5/skills/checking-freshness/SKILL.md"
            },
            {
              "name": "configuring-airflow-language-sdks",
              "sourceUrl": "https://github.com/astronomer/agents/blob/dbd9bb79c4f7b7ac9c1cdd2b4b75213c81f423e5/skills/configuring-airflow-language-sdks/SKILL.md"
            },
            {
              "name": "cosmos-dbt-core",
              "sourceUrl": "https://github.com/astronomer/agents/blob/dbd9bb79c4f7b7ac9c1cdd2b4b75213c81f423e5/skills/cosmos-dbt-core/SKILL.md"
            },
            {
              "name": "cosmos-dbt-fusion",
              "sourceUrl": "https://github.com/astronomer/agents/blob/dbd9bb79c4f7b7ac9c1cdd2b4b75213c81f423e5/skills/cosmos-dbt-fusion/SKILL.md"
            },
            {
              "name": "creating-openlineage-extractors",
              "sourceUrl": "https://github.com/astronomer/agents/blob/dbd9bb79c4f7b7ac9c1cdd2b4b75213c81f423e5/skills/creating-openlineage-extractors/SKILL.md"
            },
            {
              "name": "dag-factory",
              "sourceUrl": "https://github.com/astronomer/agents/blob/dbd9bb79c4f7b7ac9c1cdd2b4b75213c81f423e5/skills/dag-factory/SKILL.md"
            },
            {
              "name": "debugging-dags",
              "sourceUrl": "https://github.com/astronomer/agents/blob/dbd9bb79c4f7b7ac9c1cdd2b4b75213c81f423e5/skills/debugging-dags/SKILL.md"
            },
            {
              "name": "delegating-to-otto",
              "sourceUrl": "https://github.com/astronomer/agents/blob/dbd9bb79c4f7b7ac9c1cdd2b4b75213c81f423e5/skills/delegating-to-otto/SKILL.md"
            },
            {
              "name": "deploying-airflow",
              "sourceUrl": "https://github.com/astronomer/agents/blob/dbd9bb79c4f7b7ac9c1cdd2b4b75213c81f423e5/skills/deploying-airflow/SKILL.md"
            },
            {
              "name": "deploying-go-sdk-bundles",
              "sourceUrl": "https://github.com/astronomer/agents/blob/dbd9bb79c4f7b7ac9c1cdd2b4b75213c81f423e5/skills/deploying-go-sdk-bundles/SKILL.md"
            },
            {
              "name": "deploying-java-sdk-bundles",
              "sourceUrl": "https://github.com/astronomer/agents/blob/dbd9bb79c4f7b7ac9c1cdd2b4b75213c81f423e5/skills/deploying-java-sdk-bundles/SKILL.md"
            },
            {
              "name": "managing-astro-deployments",
              "sourceUrl": "https://github.com/astronomer/agents/blob/dbd9bb79c4f7b7ac9c1cdd2b4b75213c81f423e5/skills/managing-astro-deployments/SKILL.md"
            },
            {
              "name": "managing-astro-local-env",
              "sourceUrl": "https://github.com/astronomer/agents/blob/dbd9bb79c4f7b7ac9c1cdd2b4b75213c81f423e5/skills/managing-astro-local-env/SKILL.md"
            },
            {
              "name": "migrating-ai-sdk-to-common-ai",
              "sourceUrl": "https://github.com/astronomer/agents/blob/dbd9bb79c4f7b7ac9c1cdd2b4b75213c81f423e5/skills/migrating-ai-sdk-to-common-ai/SKILL.md"
            },
            {
              "name": "migrating-airflow-2-to-3",
              "sourceUrl": "https://github.com/astronomer/agents/blob/dbd9bb79c4f7b7ac9c1cdd2b4b75213c81f423e5/skills/migrating-airflow-2-to-3/SKILL.md"
            },
            {
              "name": "migrating-dagster-to-airflow",
              "sourceUrl": "https://github.com/astronomer/agents/blob/dbd9bb79c4f7b7ac9c1cdd2b4b75213c81f423e5/skills/migrating-dagster-to-airflow/SKILL.md"
            },
            {
              "name": "profiling-tables",
              "sourceUrl": "https://github.com/astronomer/agents/blob/dbd9bb79c4f7b7ac9c1cdd2b4b75213c81f423e5/skills/profiling-tables/SKILL.md"
            },
            {
              "name": "setting-up-astro-project",
              "sourceUrl": "https://github.com/astronomer/agents/blob/dbd9bb79c4f7b7ac9c1cdd2b4b75213c81f423e5/skills/setting-up-astro-project/SKILL.md"
            },
            {
              "name": "testing-dags",
              "sourceUrl": "https://github.com/astronomer/agents/blob/dbd9bb79c4f7b7ac9c1cdd2b4b75213c81f423e5/skills/testing-dags/SKILL.md"
            },
            {
              "name": "tracing-downstream-lineage",
              "sourceUrl": "https://github.com/astronomer/agents/blob/dbd9bb79c4f7b7ac9c1cdd2b4b75213c81f423e5/skills/tracing-downstream-lineage/SKILL.md"
            },
            {
              "name": "tracing-upstream-lineage",
              "sourceUrl": "https://github.com/astronomer/agents/blob/dbd9bb79c4f7b7ac9c1cdd2b4b75213c81f423e5/skills/tracing-upstream-lineage/SKILL.md"
            },
            {
              "name": "troubleshooting-astro-deployments",
              "sourceUrl": "https://github.com/astronomer/agents/blob/dbd9bb79c4f7b7ac9c1cdd2b4b75213c81f423e5/skills/troubleshooting-astro-deployments/SKILL.md"
            },
            {
              "name": "warehouse-init",
              "sourceUrl": "https://github.com/astronomer/agents/blob/dbd9bb79c4f7b7ac9c1cdd2b4b75213c81f423e5/skills/warehouse-init/SKILL.md"
            }
          ],
          "mcpServers": [],
          "components": ["skills"],
          "componentInspection": "repository",
          "inspectionError": null,
          "installation": "requires_adapter",
          "upstream": {
            "source": {
              "source": "url",
              "url": "https://github.com/astronomer/agents.git",
              "sha": "dbd9bb79c4f7b7ac9c1cdd2b4b75213c81f423e5"
            },
            "policy": null
          }
        },
        {
          "id": "anthropic:atlan",
          "name": "atlan",
          "displayName": "atlan",
          "description": "Atlan context layer plugin for Claude Code. Search, explore, govern, and manage your data assets through natural language. Powered by the Atlan MCP server with semantic search, lineage traversal, glossary management, data quality rules, and more.",
          "longDescription": "Atlan context layer plugin for Claude Code. Search, explore, govern, and manage your data assets through natural language. Powered by the Atlan MCP server with semantic search, lineage traversal, glossary management, data quality rules, and more.",
          "category": null,
          "keywords": [
            "data-catalog",
            "data-governance",
            "metadata",
            "lineage",
            "data-quality",
            "semantic-search",
            "glossary",
            "mcp",
            "atlan"
          ],
          "author": {
            "name": "Atlan",
            "email": "engineering@atlan.com",
            "url": "https://atlan.com"
          },
          "version": "1.0.0",
          "license": "Apache-2.0",
          "logoUrl": null,
          "darkLogoUrl": null,
          "homepage": "https://atlan.com/docs",
          "sourceUrl": "https://github.com/atlanhq/agent-toolkit/tree/86bb1ad27f80e189b328333d2271b360ae579f2b/",
          "skills": [],
          "mcpServers": [
            {
              "requiresConfiguration": false,
              "name": "atlan",
              "transport": "http",
              "endpoint": "https://mcp.atlan.com/mcp"
            }
          ],
          "components": ["mcp"],
          "componentInspection": "repository",
          "inspectionError": null,
          "installation": "requires_adapter",
          "upstream": {
            "source": {
              "source": "url",
              "url": "https://github.com/atlanhq/agent-toolkit.git",
              "sha": "86bb1ad27f80e189b328333d2271b360ae579f2b"
            },
            "policy": null
          }
        },
        {
          "id": "anthropic:atlassian",
          "name": "atlassian",
          "displayName": "atlassian",
          "description": "Connect to Atlassian products including Jira and Confluence. Search and create issues, access documentation, manage sprints, and integrate your development workflow with Atlassian's collaboration tools.",
          "longDescription": "Connect to Atlassian products including Jira and Confluence. Search and create issues, access documentation, manage sprints, and integrate your development workflow with Atlassian's collaboration tools.",
          "category": "productivity",
          "keywords": [],
          "author": {
            "name": "Atlassian"
          },
          "version": null,
          "license": null,
          "logoUrl": null,
          "darkLogoUrl": null,
          "homepage": "https://github.com/atlassian/atlassian-mcp-server",
          "sourceUrl": "https://github.com/atlassian/atlassian-mcp-server/tree/798f8138c976599aa91075f3fc0bb481c3818848/",
          "skills": [
            {
              "name": "capture-tasks-from-meeting-notes",
              "sourceUrl": "https://github.com/atlassian/atlassian-mcp-server/blob/798f8138c976599aa91075f3fc0bb481c3818848/skills/capture-tasks-from-meeting-notes/SKILL.md"
            },
            {
              "name": "generate-status-report",
              "sourceUrl": "https://github.com/atlassian/atlassian-mcp-server/blob/798f8138c976599aa91075f3fc0bb481c3818848/skills/generate-status-report/SKILL.md"
            },
            {
              "name": "jira-sprint-dashboard",
              "sourceUrl": "https://github.com/atlassian/atlassian-mcp-server/blob/798f8138c976599aa91075f3fc0bb481c3818848/skills/jira-sprint-dashboard/SKILL.md"
            },
            {
              "name": "search-company-knowledge",
              "sourceUrl": "https://github.com/atlassian/atlassian-mcp-server/blob/798f8138c976599aa91075f3fc0bb481c3818848/skills/search-company-knowledge/SKILL.md"
            },
            {
              "name": "spec-to-backlog",
              "sourceUrl": "https://github.com/atlassian/atlassian-mcp-server/blob/798f8138c976599aa91075f3fc0bb481c3818848/skills/spec-to-backlog/SKILL.md"
            },
            {
              "name": "triage-issue",
              "sourceUrl": "https://github.com/atlassian/atlassian-mcp-server/blob/798f8138c976599aa91075f3fc0bb481c3818848/skills/triage-issue/SKILL.md"
            },
            {
              "name": "capture-tasks-from-meeting-notes",
              "sourceUrl": "https://github.com/atlassian/atlassian-mcp-server/blob/798f8138c976599aa91075f3fc0bb481c3818848/skills/v1/capture-tasks-from-meeting-notes/SKILL.md"
            },
            {
              "name": "generate-status-report",
              "sourceUrl": "https://github.com/atlassian/atlassian-mcp-server/blob/798f8138c976599aa91075f3fc0bb481c3818848/skills/v1/generate-status-report/SKILL.md"
            },
            {
              "name": "jira-sprint-dashboard",
              "sourceUrl": "https://github.com/atlassian/atlassian-mcp-server/blob/798f8138c976599aa91075f3fc0bb481c3818848/skills/v1/jira-sprint-dashboard/SKILL.md"
            },
            {
              "name": "search-company-knowledge",
              "sourceUrl": "https://github.com/atlassian/atlassian-mcp-server/blob/798f8138c976599aa91075f3fc0bb481c3818848/skills/v1/search-company-knowledge/SKILL.md"
            },
            {
              "name": "spec-to-backlog",
              "sourceUrl": "https://github.com/atlassian/atlassian-mcp-server/blob/798f8138c976599aa91075f3fc0bb481c3818848/skills/v1/spec-to-backlog/SKILL.md"
            },
            {
              "name": "triage-issue",
              "sourceUrl": "https://github.com/atlassian/atlassian-mcp-server/blob/798f8138c976599aa91075f3fc0bb481c3818848/skills/v1/triage-issue/SKILL.md"
            }
          ],
          "mcpServers": [
            {
              "requiresConfiguration": false,
              "name": "atlassian",
              "transport": "http",
              "endpoint": "https://mcp.atlassian.com/v2/mcp"
            }
          ],
          "components": ["skills", "mcp"],
          "componentInspection": "repository",
          "inspectionError": null,
          "installation": "requires_adapter",
          "upstream": {
            "source": {
              "source": "url",
              "url": "https://github.com/atlassian/atlassian-mcp-server.git",
              "sha": "798f8138c976599aa91075f3fc0bb481c3818848"
            },
            "policy": null
          }
        },
        {
          "id": "anthropic:atlassian-twg-cli",
          "name": "atlassian-twg-cli",
          "displayName": "atlassian-twg-cli",
          "description": "Teamwork Graph CLI is Atlassian's agent-first interface to your entire work context: Jira issues, Confluence pages, Bitbucket PRs, along with your connected third-party data sources. Purpose-built for coding agents like Claude Code (terminal or desktop), and powered by Atlassian's context graph. Try: \"draft a Jira issue from this PR and link it to the epic.\" Using Claude Code in the browser? Install the Atlassian Rovo MCP plugin instead. Run /twg-setup after install to connect Atlassian Teamwork Graph CLI to Claude Code.",
          "longDescription": "Teamwork Graph CLI is Atlassian's agent-first interface to your entire work context: Jira issues, Confluence pages, Bitbucket PRs, along with your connected third-party data sources. Purpose-built for coding agents like Claude Code (terminal or desktop), and powered by Atlassian's context graph. Try: \"draft a Jira issue from this PR and link it to the epic.\" Using Claude Code in the browser? Install the Atlassian Rovo MCP plugin instead. Run /twg-setup after install to connect Atlassian Teamwork Graph CLI to Claude Code.",
          "category": "productivity",
          "keywords": [
            "atlassian",
            "twg",
            "teamwork graph",
            "teamwork graph cli",
            "jira",
            "confluence",
            "bitbucket",
            "jsm",
            "jira service management",
            "assets",
            "teams",
            "goals",
            "projects",
            "loom",
            "trello",
            "rovo",
            "cli",
            "atlassian context"
          ],
          "author": {
            "name": "Atlassian",
            "url": "https://www.atlassian.com"
          },
          "version": "1.0.10",
          "license": "Apache-2.0",
          "logoUrl": null,
          "darkLogoUrl": null,
          "homepage": "https://developer.atlassian.com/cloud/twg-cli/",
          "sourceUrl": "https://github.com/atlassian-labs/twg-plugins/tree/49f3a6f9c3fbcd4cd9edb5fd3282bb878322e447/",
          "skills": [
            {
              "name": "twg-setup",
              "sourceUrl": "https://github.com/atlassian-labs/twg-plugins/blob/49f3a6f9c3fbcd4cd9edb5fd3282bb878322e447/skills/twg-setup/SKILL.md"
            }
          ],
          "mcpServers": [],
          "components": ["skills"],
          "componentInspection": "repository",
          "inspectionError": null,
          "installation": "requires_adapter",
          "upstream": {
            "source": {
              "source": "url",
              "url": "https://github.com/atlassian-labs/twg-plugins.git",
              "sha": "49f3a6f9c3fbcd4cd9edb5fd3282bb878322e447"
            },
            "policy": null
          }
        },
        {
          "id": "anthropic:atomic-agents",
          "name": "atomic-agents",
          "displayName": "atomic-agents",
          "description": "Skills plus explorer and reviewer subagents for building, scaffolding, debugging, understanding, and auditing applications with the Atomic Agents Python framework. Includes the umbrella `framework` skill, action-oriented `create-atomic-schema` / `create-atomic-agent` / `create-atomic-tool` / `create-atomic-context-provider` skills, the `troubleshoot` diagnostic skill, the `new-app` scaffolder (emits AGENTS.md + CLAUDE.md), progressive-disclosure reference material for prompts, orchestration, memory, hooks, providers, project structure, and testing, and isolated-context subagents for codebase mapping and code review.",
          "longDescription": "Skills plus explorer and reviewer subagents for building, scaffolding, debugging, understanding, and auditing applications with the Atomic Agents Python framework. Includes the umbrella `framework` skill, action-oriented `create-atomic-schema` / `create-atomic-agent` / `create-atomic-tool` / `create-atomic-context-provider` skills, the `troubleshoot` diagnostic skill, the `new-app` scaffolder (emits AGENTS.md + CLAUDE.md), progressive-disclosure reference material for prompts, orchestration, memory, hooks, providers, project structure, and testing, and isolated-context subagents for codebase mapping and code review.",
          "category": "development",
          "keywords": [],
          "author": {
            "name": "Kenny Vaneetvelde",
            "email": "kenny@eigenwise.io"
          },
          "version": "2.2.0",
          "license": "MIT",
          "logoUrl": null,
          "darkLogoUrl": null,
          "homepage": "https://github.com/eigenwise/atomic-agents",
          "sourceUrl": "https://github.com/BrainBlend-AI/atomic-agents/tree/b15ca449a81278b1c92666bdf9a2e57a817dcacd/claude-plugin/atomic-agents",
          "skills": [
            {
              "name": "create-atomic-agent",
              "sourceUrl": "https://github.com/BrainBlend-AI/atomic-agents/blob/b15ca449a81278b1c92666bdf9a2e57a817dcacd/claude-plugin/atomic-agents/skills/create-atomic-agent/SKILL.md"
            },
            {
              "name": "create-atomic-context-provider",
              "sourceUrl": "https://github.com/BrainBlend-AI/atomic-agents/blob/b15ca449a81278b1c92666bdf9a2e57a817dcacd/claude-plugin/atomic-agents/skills/create-atomic-context-provider/SKILL.md"
            },
            {
              "name": "create-atomic-schema",
              "sourceUrl": "https://github.com/BrainBlend-AI/atomic-agents/blob/b15ca449a81278b1c92666bdf9a2e57a817dcacd/claude-plugin/atomic-agents/skills/create-atomic-schema/SKILL.md"
            },
            {
              "name": "create-atomic-tool",
              "sourceUrl": "https://github.com/BrainBlend-AI/atomic-agents/blob/b15ca449a81278b1c92666bdf9a2e57a817dcacd/claude-plugin/atomic-agents/skills/create-atomic-tool/SKILL.md"
            },
            {
              "name": "framework",
              "sourceUrl": "https://github.com/BrainBlend-AI/atomic-agents/blob/b15ca449a81278b1c92666bdf9a2e57a817dcacd/claude-plugin/atomic-agents/skills/framework/SKILL.md"
            },
            {
              "name": "new-app",
              "sourceUrl": "https://github.com/BrainBlend-AI/atomic-agents/blob/b15ca449a81278b1c92666bdf9a2e57a817dcacd/claude-plugin/atomic-agents/skills/new-app/SKILL.md"
            },
            {
              "name": "troubleshoot",
              "sourceUrl": "https://github.com/BrainBlend-AI/atomic-agents/blob/b15ca449a81278b1c92666bdf9a2e57a817dcacd/claude-plugin/atomic-agents/skills/troubleshoot/SKILL.md"
            }
          ],
          "mcpServers": [],
          "components": ["skills", "agents"],
          "componentInspection": "repository",
          "inspectionError": null,
          "installation": "requires_adapter",
          "upstream": {
            "source": {
              "source": "url",
              "url": "https://github.com/BrainBlend-AI/atomic-agents.git",
              "path": "claude-plugin/atomic-agents",
              "sha": "b15ca449a81278b1c92666bdf9a2e57a817dcacd"
            },
            "policy": null
          }
        },
        {
          "id": "anthropic:auth0",
          "name": "auth0",
          "displayName": "auth0",
          "description": "A single unified Auth0 skill that detects your framework, feature, and tooling, then loads the right reference guides for adding authentication — login, MFA, Organizations, ACUL, custom domains, branding, JWT validation, migration, and debugging — to any app.",
          "longDescription": "A single unified Auth0 skill that detects your framework, feature, and tooling, then loads the right reference guides for adding authentication — login, MFA, Organizations, ACUL, custom domains, branding, JWT validation, migration, and debugging — to any app.",
          "category": "security",
          "keywords": [],
          "author": {
            "name": "Auth0",
            "email": "support@auth0.com"
          },
          "version": "2.1.0",
          "license": null,
          "logoUrl": null,
          "darkLogoUrl": null,
          "homepage": "https://auth0.com",
          "sourceUrl": "https://github.com/auth0/agent-skills/tree/7af36e12061ac5643bf420f35aa3fd8daf958292/plugins/auth0",
          "skills": [
            {
              "name": "auth0",
              "sourceUrl": "https://github.com/auth0/agent-skills/blob/7af36e12061ac5643bf420f35aa3fd8daf958292/plugins/auth0/skills/auth0/SKILL.md"
            }
          ],
          "mcpServers": [],
          "components": ["skills"],
          "componentInspection": "repository",
          "inspectionError": null,
          "installation": "requires_adapter",
          "upstream": {
            "source": {
              "source": "git-subdir",
              "url": "https://github.com/auth0/agent-skills.git",
              "path": "plugins/auth0",
              "ref": "main",
              "sha": "7af36e12061ac5643bf420f35aa3fd8daf958292"
            },
            "policy": null
          }
        },
        {
          "id": "anthropic:aws-agents",
          "name": "aws-agents",
          "displayName": "aws-agents",
          "description": "Build, deploy, and operate AI agents on AWS. Skills for scaffolding agents with Amazon Bedrock AgentCore (Strands, LangGraph), connecting tools via Gateway and MCP, multi-agent and A2A orchestration, memory, Cedar policies, evaluation, observability, debugging traces and logs, and production hardening (inbound auth, IAM, rate limiting, cold-start tuning).",
          "longDescription": "Build, deploy, and operate AI agents on AWS. Skills for scaffolding agents with Amazon Bedrock AgentCore (Strands, LangGraph), connecting tools via Gateway and MCP, multi-agent and A2A orchestration, memory, Cedar policies, evaluation, observability, debugging traces and logs, and production hardening (inbound auth, IAM, rate limiting, cold-start tuning).",
          "category": "development",
          "keywords": [
            "aws",
            "amazon",
            "amazon-web-services",
            "ai",
            "ai-agents",
            "agents",
            "agentcore",
            "bedrock",
            "amazon-bedrock",
            "iam",
            "deploy",
            "debug",
            "memory",
            "gateway",
            "policy",
            "cedar",
            "evaluation",
            "evals",
            "strands",
            "langgraph",
            "mcp",
            "a2a",
            "multi-agent",
            "tool-use",
            "rag",
            "vpc",
            "observability",
            "cloudwatch",
            "tracing",
            "x-ray",
            "production-hardening",
            "jwt",
            "sigv4",
            "oauth",
            "openapi",
            "code-interpreter",
            "browser-tool",
            "rate-limiting"
          ],
          "author": {
            "name": "Amazon Web Services"
          },
          "version": "1.0.0",
          "license": "Apache-2.0",
          "logoUrl": null,
          "darkLogoUrl": null,
          "homepage": "https://github.com/aws/agent-toolkit-for-aws",
          "sourceUrl": "https://github.com/aws/agent-toolkit-for-aws/tree/8ea26bdf9c8b3719e6b5488709f4efecde5a0d93/plugins/aws-agents",
          "skills": [
            {
              "name": "agents-build",
              "sourceUrl": "https://github.com/aws/agent-toolkit-for-aws/blob/8ea26bdf9c8b3719e6b5488709f4efecde5a0d93/plugins/aws-agents/skills/agents-build/SKILL.md"
            },
            {
              "name": "agents-connect",
              "sourceUrl": "https://github.com/aws/agent-toolkit-for-aws/blob/8ea26bdf9c8b3719e6b5488709f4efecde5a0d93/plugins/aws-agents/skills/agents-connect/SKILL.md"
            },
            {
              "name": "agents-debug",
              "sourceUrl": "https://github.com/aws/agent-toolkit-for-aws/blob/8ea26bdf9c8b3719e6b5488709f4efecde5a0d93/plugins/aws-agents/skills/agents-debug/SKILL.md"
            },
            {
              "name": "agents-deploy",
              "sourceUrl": "https://github.com/aws/agent-toolkit-for-aws/blob/8ea26bdf9c8b3719e6b5488709f4efecde5a0d93/plugins/aws-agents/skills/agents-deploy/SKILL.md"
            },
            {
              "name": "agents-get-started",
              "sourceUrl": "https://github.com/aws/agent-toolkit-for-aws/blob/8ea26bdf9c8b3719e6b5488709f4efecde5a0d93/plugins/aws-agents/skills/agents-get-started/SKILL.md"
            },
            {
              "name": "agents-harden",
              "sourceUrl": "https://github.com/aws/agent-toolkit-for-aws/blob/8ea26bdf9c8b3719e6b5488709f4efecde5a0d93/plugins/aws-agents/skills/agents-harden/SKILL.md"
            },
            {
              "name": "agents-optimize",
              "sourceUrl": "https://github.com/aws/agent-toolkit-for-aws/blob/8ea26bdf9c8b3719e6b5488709f4efecde5a0d93/plugins/aws-agents/skills/agents-optimize/SKILL.md"
            },
            {
              "name": "agents-pay",
              "sourceUrl": "https://github.com/aws/agent-toolkit-for-aws/blob/8ea26bdf9c8b3719e6b5488709f4efecde5a0d93/plugins/aws-agents/skills/agents-pay/SKILL.md"
            },
            {
              "name": "agents-pay",
              "sourceUrl": "https://github.com/aws/agent-toolkit-for-aws/blob/8ea26bdf9c8b3719e6b5488709f4efecde5a0d93/plugins/aws-agents/skills/agents-pay/packages/openclaw/skills/agents-pay/SKILL.md"
            }
          ],
          "mcpServers": [
            {
              "requiresConfiguration": false,
              "name": "awsknowledge",
              "transport": "http",
              "endpoint": "https://knowledge-mcp.global.api.aws"
            }
          ],
          "components": ["skills", "mcp"],
          "componentInspection": "repository",
          "inspectionError": null,
          "installation": "requires_adapter",
          "upstream": {
            "source": {
              "source": "git-subdir",
              "url": "https://github.com/aws/agent-toolkit-for-aws.git",
              "path": "plugins/aws-agents",
              "ref": "main",
              "sha": "8ea26bdf9c8b3719e6b5488709f4efecde5a0d93"
            },
            "policy": null
          }
        },
        {
          "id": "anthropic:aws-agents-for-devsecops",
          "name": "aws-agents-for-devsecops",
          "displayName": "aws-agents-for-devsecops",
          "description": "Investigate incidents, review code and execute UAT for release readiness, scan code for vulnerabilities, and run penetration tests with AWS DevOps Agent and AWS Security Agent.",
          "longDescription": "Investigate incidents, review code and execute UAT for release readiness, scan code for vulnerabilities, and run penetration tests with AWS DevOps Agent and AWS Security Agent.",
          "category": "development",
          "keywords": [
            "Amazon Web Services",
            "agentspace",
            "api-testing",
            "appsec",
            "architecture-review",
            "aws",
            "cloudwatch",
            "code-review",
            "cost-optimization",
            "devops",
            "devsecops",
            "incident",
            "investigation",
            "is-my-code-secure",
            "mcp",
            "observability",
            "operations",
            "penetration-test",
            "pentest",
            "pre-merge",
            "qa",
            "release",
            "release-analysis",
            "release-readiness",
            "release-testing",
            "reliability",
            "remediation",
            "risk-analysis",
            "security",
            "security-scan",
            "security-vulnerabilities",
            "testing",
            "threat-model",
            "topology",
            "uat",
            "ui-testing"
          ],
          "author": {
            "name": "Amazon Web Services"
          },
          "version": "1.0.0",
          "license": "Apache-2.0",
          "logoUrl": null,
          "darkLogoUrl": null,
          "homepage": "https://docs.aws.amazon.com/devopsagent/latest/userguide/",
          "sourceUrl": "https://github.com/aws/agent-toolkit-for-aws/tree/08ad220e4e9bbc498821ce9360b3dcdf4813121d/plugins/aws-agents-for-devsecops",
          "skills": [
            {
              "name": "analyzing-release-readiness",
              "sourceUrl": "https://github.com/aws/agent-toolkit-for-aws/blob/08ad220e4e9bbc498821ce9360b3dcdf4813121d/plugins/aws-agents-for-devsecops/skills/analyzing-release-readiness/SKILL.md"
            },
            {
              "name": "chatting-with-aws-devops-agent",
              "sourceUrl": "https://github.com/aws/agent-toolkit-for-aws/blob/08ad220e4e9bbc498821ce9360b3dcdf4813121d/plugins/aws-agents-for-devsecops/skills/chatting-with-aws-devops-agent/SKILL.md"
            },
            {
              "name": "coordinating-multi-space-devops-agent",
              "sourceUrl": "https://github.com/aws/agent-toolkit-for-aws/blob/08ad220e4e9bbc498821ce9360b3dcdf4813121d/plugins/aws-agents-for-devsecops/skills/coordinating-multi-space-devops-agent/SKILL.md"
            },
            {
              "name": "diff-scanning-with-aws-security-agent",
              "sourceUrl": "https://github.com/aws/agent-toolkit-for-aws/blob/08ad220e4e9bbc498821ce9360b3dcdf4813121d/plugins/aws-agents-for-devsecops/skills/diff-scanning-with-aws-security-agent/SKILL.md"
            },
            {
              "name": "investigating-incidents-with-aws-devops-agent",
              "sourceUrl": "https://github.com/aws/agent-toolkit-for-aws/blob/08ad220e4e9bbc498821ce9360b3dcdf4813121d/plugins/aws-agents-for-devsecops/skills/investigating-incidents-with-aws-devops-agent/SKILL.md"
            },
            {
              "name": "pentesting-with-aws-security-agent",
              "sourceUrl": "https://github.com/aws/agent-toolkit-for-aws/blob/08ad220e4e9bbc498821ce9360b3dcdf4813121d/plugins/aws-agents-for-devsecops/skills/pentesting-with-aws-security-agent/SKILL.md"
            },
            {
              "name": "remediating-with-aws-security-agent",
              "sourceUrl": "https://github.com/aws/agent-toolkit-for-aws/blob/08ad220e4e9bbc498821ce9360b3dcdf4813121d/plugins/aws-agents-for-devsecops/skills/remediating-with-aws-security-agent/SKILL.md"
            },
            {
              "name": "running-release-tests",
              "sourceUrl": "https://github.com/aws/agent-toolkit-for-aws/blob/08ad220e4e9bbc498821ce9360b3dcdf4813121d/plugins/aws-agents-for-devsecops/skills/running-release-tests/SKILL.md"
            },
            {
              "name": "scanning-with-aws-security-agent",
              "sourceUrl": "https://github.com/aws/agent-toolkit-for-aws/blob/08ad220e4e9bbc498821ce9360b3dcdf4813121d/plugins/aws-agents-for-devsecops/skills/scanning-with-aws-security-agent/SKILL.md"
            },
            {
              "name": "setup-devops-agent",
              "sourceUrl": "https://github.com/aws/agent-toolkit-for-aws/blob/08ad220e4e9bbc498821ce9360b3dcdf4813121d/plugins/aws-agents-for-devsecops/skills/setup-devops-agent/SKILL.md"
            },
            {
              "name": "setup-security-agent",
              "sourceUrl": "https://github.com/aws/agent-toolkit-for-aws/blob/08ad220e4e9bbc498821ce9360b3dcdf4813121d/plugins/aws-agents-for-devsecops/skills/setup-security-agent/SKILL.md"
            },
            {
              "name": "setup",
              "sourceUrl": "https://github.com/aws/agent-toolkit-for-aws/blob/08ad220e4e9bbc498821ce9360b3dcdf4813121d/plugins/aws-agents-for-devsecops/skills/setup/SKILL.md"
            },
            {
              "name": "threat-modeling-with-aws-security-agent",
              "sourceUrl": "https://github.com/aws/agent-toolkit-for-aws/blob/08ad220e4e9bbc498821ce9360b3dcdf4813121d/plugins/aws-agents-for-devsecops/skills/threat-modeling-with-aws-security-agent/SKILL.md"
            }
          ],
          "mcpServers": [
            {
              "requiresConfiguration": true,
              "name": "aws-devops-agent",
              "transport": "http",
              "endpoint": "https://connect.aidevops.${DEVOPS_AGENT_REGION:-us-east-1}.api.aws/mcp"
            }
          ],
          "components": ["skills", "mcp", "commands"],
          "componentInspection": "repository",
          "inspectionError": null,
          "installation": "requires_adapter",
          "upstream": {
            "source": {
              "source": "git-subdir",
              "url": "https://github.com/aws/agent-toolkit-for-aws.git",
              "path": "plugins/aws-agents-for-devsecops",
              "ref": "main",
              "sha": "08ad220e4e9bbc498821ce9360b3dcdf4813121d"
            },
            "policy": null
          }
        },
        {
          "id": "anthropic:aws-amplify",
          "name": "aws-amplify",
          "displayName": "aws-amplify",
          "description": "Build full-stack apps with AWS Amplify Gen 2 using guided workflows for authentication, data models, storage, GraphQL APIs, and Lambda functions.",
          "longDescription": "Build full-stack apps with AWS Amplify Gen 2 using guided workflows for authentication, data models, storage, GraphQL APIs, and Lambda functions.",
          "category": "development",
          "keywords": [
            "aws",
            "amplify",
            "fullstack",
            "authentication",
            "data",
            "storage",
            "graphql",
            "functions"
          ],
          "author": {
            "name": "Amazon Web Services"
          },
          "version": "1.0.0",
          "license": "Apache-2.0",
          "logoUrl": null,
          "darkLogoUrl": null,
          "homepage": "https://github.com/awslabs/agent-plugins",
          "sourceUrl": "https://github.com/awslabs/agent-plugins/tree/c65ee436b0db77bb75d380aef6fbdc9b114edf2a/plugins/aws-amplify",
          "skills": [
            {
              "name": "amplify-workflow",
              "sourceUrl": "https://github.com/awslabs/agent-plugins/blob/c65ee436b0db77bb75d380aef6fbdc9b114edf2a/plugins/aws-amplify/skills/amplify-workflow/SKILL.md"
            }
          ],
          "mcpServers": [
            {
              "requiresConfiguration": false,
              "name": "aws-mcp",
              "transport": "stdio",
              "endpoint": null
            }
          ],
          "components": ["skills", "mcp"],
          "componentInspection": "repository",
          "inspectionError": null,
          "installation": "requires_adapter",
          "upstream": {
            "source": {
              "source": "git-subdir",
              "url": "https://github.com/awslabs/agent-plugins.git",
              "path": "plugins/aws-amplify",
              "ref": "main",
              "sha": "c65ee436b0db77bb75d380aef6fbdc9b114edf2a"
            },
            "policy": null
          }
        },
        {
          "id": "anthropic:aws-core",
          "name": "aws-core",
          "displayName": "aws-core",
          "description": "Build, deploy, and operate applications on AWS. Skills to author infrastructure-as-code (CDK, CloudFormation), use core services (Lambda, API Gateway, Step Functions, ECS/Fargate, ECR, IAM, Amazon Bedrock with Knowledge Bases and Guardrails, AWS Blocks), select and operate databases across relational, key-value, document, wide-column, graph, time-series, and in-memory engines (Aurora PostgreSQL/MySQL, Aurora DSQL, RDS, Oracle Database@AWS, DynamoDB, DocumentDB, Keyspaces, Neptune, Timestream, ElastiCache, and MemoryDB), and complete common tasks across observability (CloudWatch, X-Ray, CloudTrail, ADOT), messaging and streaming (SQS, SNS, EventBridge, Kinesis, MSK), AWS SDKs (boto3, JS v3, Swift), and cost optimization.",
          "longDescription": "Build, deploy, and operate applications on AWS. Skills to author infrastructure-as-code (CDK, CloudFormation), use core services (Lambda, API Gateway, Step Functions, ECS/Fargate, ECR, IAM, Amazon Bedrock with Knowledge Bases and Guardrails, AWS Blocks), select and operate databases across relational, key-value, document, wide-column, graph, time-series, and in-memory engines (Aurora PostgreSQL/MySQL, Aurora DSQL, RDS, Oracle Database@AWS, DynamoDB, DocumentDB, Keyspaces, Neptune, Timestream, ElastiCache, and MemoryDB), and complete common tasks across observability (CloudWatch, X-Ray, CloudTrail, ADOT), messaging and streaming (SQS, SNS, EventBridge, Kinesis, MSK), AWS SDKs (boto3, JS v3, Swift), and cost optimization.",
          "category": "development",
          "keywords": [
            "aws",
            "amazon",
            "amazon-web-services",
            "iam",
            "bedrock",
            "amazon-bedrock",
            "aws-blocks",
            "billing",
            "cost-explorer",
            "cost-optimization",
            "savings-plans",
            "compute-optimizer",
            "cdk",
            "aws-cdk",
            "cloudformation",
            "sam",
            "serverless",
            "lambda",
            "api-gateway",
            "step-functions",
            "eventbridge",
            "containers",
            "ecs",
            "fargate",
            "ecr",
            "messaging",
            "streaming",
            "sqs",
            "sns",
            "kinesis",
            "kinesis-firehose",
            "msk",
            "kafka",
            "flink",
            "amazon-mq",
            "observability",
            "cloudwatch",
            "logs-insights",
            "x-ray",
            "cloudtrail",
            "adot",
            "opentelemetry",
            "sdk",
            "aws-sdk",
            "boto3",
            "aws-sdk-js-v3",
            "aws-sdk-swift",
            "knowledge-bases",
            "rag",
            "guardrails",
            "opensearch",
            "opensearch-serverless",
            "amazon-opensearch-service",
            "cognito",
            "appsync",
            "dynamodb",
            "database",
            "databases",
            "relational-database",
            "aurora",
            "aurora-postgresql",
            "aurora-mysql",
            "aurora-dsql",
            "dsql",
            "postgres",
            "postgresql",
            "mysql",
            "mariadb",
            "oracle",
            "sql-server",
            "sqlserver",
            "db2",
            "rds",
            "rds-postgresql",
            "rds-mysql",
            "rds-mariadb",
            "rds-oracle",
            "rds-sqlserver",
            "rds-db2",
            "odb",
            "oracle-database-at-aws",
            "documentdb",
            "mongodb",
            "elasticache",
            "memorydb",
            "redis",
            "valkey",
            "memcached",
            "keyspaces",
            "cassandra",
            "neptune",
            "graph-database",
            "timestream",
            "time-series",
            "influxdb",
            "app-runner",
            "snapstart",
            "powertools",
            "durable-functions",
            "budgets",
            "reserved-instances",
            "right-sizing"
          ],
          "author": {
            "name": "Amazon Web Services"
          },
          "version": "1.1.0",
          "license": "Apache-2.0",
          "logoUrl": null,
          "darkLogoUrl": null,
          "homepage": "https://github.com/aws/agent-toolkit-for-aws",
          "sourceUrl": "https://github.com/aws/agent-toolkit-for-aws/tree/08ad220e4e9bbc498821ce9360b3dcdf4813121d/plugins/aws-core",
          "skills": [
            {
              "name": "amazon-bedrock",
              "sourceUrl": "https://github.com/aws/agent-toolkit-for-aws/blob/08ad220e4e9bbc498821ce9360b3dcdf4813121d/plugins/aws-core/skills/amazon-bedrock/SKILL.md"
            },
            {
              "name": "aws-ai-ml",
              "sourceUrl": "https://github.com/aws/agent-toolkit-for-aws/blob/08ad220e4e9bbc498821ce9360b3dcdf4813121d/plugins/aws-core/skills/aws-ai-ml/SKILL.md"
            },
            {
              "name": "aws-auth",
              "sourceUrl": "https://github.com/aws/agent-toolkit-for-aws/blob/08ad220e4e9bbc498821ce9360b3dcdf4813121d/plugins/aws-core/skills/aws-auth/SKILL.md"
            },
            {
              "name": "aws-billing-and-cost-management",
              "sourceUrl": "https://github.com/aws/agent-toolkit-for-aws/blob/08ad220e4e9bbc498821ce9360b3dcdf4813121d/plugins/aws-core/skills/aws-billing-and-cost-management/SKILL.md"
            },
            {
              "name": "aws-blocks",
              "sourceUrl": "https://github.com/aws/agent-toolkit-for-aws/blob/08ad220e4e9bbc498821ce9360b3dcdf4813121d/plugins/aws-core/skills/aws-blocks/SKILL.md"
            },
            {
              "name": "aws-cdk",
              "sourceUrl": "https://github.com/aws/agent-toolkit-for-aws/blob/08ad220e4e9bbc498821ce9360b3dcdf4813121d/plugins/aws-core/skills/aws-cdk/SKILL.md"
            },
            {
              "name": "aws-cloudformation",
              "sourceUrl": "https://github.com/aws/agent-toolkit-for-aws/blob/08ad220e4e9bbc498821ce9360b3dcdf4813121d/plugins/aws-core/skills/aws-cloudformation/SKILL.md"
            },
            {
              "name": "aws-compute",
              "sourceUrl": "https://github.com/aws/agent-toolkit-for-aws/blob/08ad220e4e9bbc498821ce9360b3dcdf4813121d/plugins/aws-core/skills/aws-compute/SKILL.md"
            },
            {
              "name": "aws-containers",
              "sourceUrl": "https://github.com/aws/agent-toolkit-for-aws/blob/08ad220e4e9bbc498821ce9360b3dcdf4813121d/plugins/aws-core/skills/aws-containers/SKILL.md"
            },
            {
              "name": "aws-database",
              "sourceUrl": "https://github.com/aws/agent-toolkit-for-aws/blob/08ad220e4e9bbc498821ce9360b3dcdf4813121d/plugins/aws-core/skills/aws-database/SKILL.md"
            },
            {
              "name": "aws-deployment",
              "sourceUrl": "https://github.com/aws/agent-toolkit-for-aws/blob/08ad220e4e9bbc498821ce9360b3dcdf4813121d/plugins/aws-core/skills/aws-deployment/SKILL.md"
            },
            {
              "name": "aws-iam",
              "sourceUrl": "https://github.com/aws/agent-toolkit-for-aws/blob/08ad220e4e9bbc498821ce9360b3dcdf4813121d/plugins/aws-core/skills/aws-iam/SKILL.md"
            },
            {
              "name": "aws-messaging-and-streaming",
              "sourceUrl": "https://github.com/aws/agent-toolkit-for-aws/blob/08ad220e4e9bbc498821ce9360b3dcdf4813121d/plugins/aws-core/skills/aws-messaging-and-streaming/SKILL.md"
            },
            {
              "name": "aws-networking",
              "sourceUrl": "https://github.com/aws/agent-toolkit-for-aws/blob/08ad220e4e9bbc498821ce9360b3dcdf4813121d/plugins/aws-core/skills/aws-networking/SKILL.md"
            },
            {
              "name": "aws-observability",
              "sourceUrl": "https://github.com/aws/agent-toolkit-for-aws/blob/08ad220e4e9bbc498821ce9360b3dcdf4813121d/plugins/aws-core/skills/aws-observability/SKILL.md"
            },
            {
              "name": "aws-sdk-js-v3-usage",
              "sourceUrl": "https://github.com/aws/agent-toolkit-for-aws/blob/08ad220e4e9bbc498821ce9360b3dcdf4813121d/plugins/aws-core/skills/aws-sdk-js-v3-usage/SKILL.md"
            },
            {
              "name": "aws-sdk-python-usage",
              "sourceUrl": "https://github.com/aws/agent-toolkit-for-aws/blob/08ad220e4e9bbc498821ce9360b3dcdf4813121d/plugins/aws-core/skills/aws-sdk-python-usage/SKILL.md"
            },
            {
              "name": "aws-sdk-swift-usage",
              "sourceUrl": "https://github.com/aws/agent-toolkit-for-aws/blob/08ad220e4e9bbc498821ce9360b3dcdf4813121d/plugins/aws-core/skills/aws-sdk-swift-usage/SKILL.md"
            },
            {
              "name": "aws-secrets-manager",
              "sourceUrl": "https://github.com/aws/agent-toolkit-for-aws/blob/08ad220e4e9bbc498821ce9360b3dcdf4813121d/plugins/aws-core/skills/aws-secrets-manager/SKILL.md"
            },
            {
              "name": "aws-security",
              "sourceUrl": "https://github.com/aws/agent-toolkit-for-aws/blob/08ad220e4e9bbc498821ce9360b3dcdf4813121d/plugins/aws-core/skills/aws-security/SKILL.md"
            },
            {
              "name": "aws-serverless",
              "sourceUrl": "https://github.com/aws/agent-toolkit-for-aws/blob/08ad220e4e9bbc498821ce9360b3dcdf4813121d/plugins/aws-core/skills/aws-serverless/SKILL.md"
            },
            {
              "name": "aws-storage",
              "sourceUrl": "https://github.com/aws/agent-toolkit-for-aws/blob/08ad220e4e9bbc498821ce9360b3dcdf4813121d/plugins/aws-core/skills/aws-storage/SKILL.md"
            },
            {
              "name": "launch-with-aws",
              "sourceUrl": "https://github.com/aws/agent-toolkit-for-aws/blob/08ad220e4e9bbc498821ce9360b3dcdf4813121d/plugins/aws-core/skills/launch-with-aws/SKILL.md"
            },
            {
              "name": "signing-in-to-aws",
              "sourceUrl": "https://github.com/aws/agent-toolkit-for-aws/blob/08ad220e4e9bbc498821ce9360b3dcdf4813121d/plugins/aws-core/skills/signing-in-to-aws/SKILL.md"
            }
          ],
          "mcpServers": [
            {
              "requiresConfiguration": false,
              "name": "aws-mcp",
              "transport": "stdio",
              "endpoint": null
            }
          ],
          "components": ["skills", "mcp"],
          "componentInspection": "repository",
          "inspectionError": null,
          "installation": "requires_adapter",
          "upstream": {
            "source": {
              "source": "git-subdir",
              "url": "https://github.com/aws/agent-toolkit-for-aws.git",
              "path": "plugins/aws-core",
              "ref": "main",
              "sha": "08ad220e4e9bbc498821ce9360b3dcdf4813121d"
            },
            "policy": null
          }
        },
        {
          "id": "anthropic:aws-data-analytics",
          "name": "aws-data-analytics",
          "displayName": "aws-data-analytics",
          "description": "Data lake, analytics, search, and ETL workflows with S3 Tables, AWS Glue, Athena, Amazon Redshift, and Amazon OpenSearch Service. Covers managed Iceberg tables on S3 Tables, ingestion from JDBC databases (Oracle, SQL Server, PostgreSQL, MySQL, RDS), Amazon Redshift, Snowflake, BigQuery, and DynamoDB, AWS Glue Data Catalog inventory and asset discovery, federated Athena queries, vector storage and semantic search on Amazon S3 Vectors, and Amazon OpenSearch Service and Serverless (migration from Solr/Elasticsearch, provisioning, vector/semantic/hybrid search, log analytics, trace analytics).",
          "longDescription": "Data lake, analytics, search, and ETL workflows with S3 Tables, AWS Glue, Athena, Amazon Redshift, and Amazon OpenSearch Service. Covers managed Iceberg tables on S3 Tables, ingestion from JDBC databases (Oracle, SQL Server, PostgreSQL, MySQL, RDS), Amazon Redshift, Snowflake, BigQuery, and DynamoDB, AWS Glue Data Catalog inventory and asset discovery, federated Athena queries, vector storage and semantic search on Amazon S3 Vectors, and Amazon OpenSearch Service and Serverless (migration from Solr/Elasticsearch, provisioning, vector/semantic/hybrid search, log analytics, trace analytics).",
          "category": "development",
          "keywords": [
            "aws",
            "amazon",
            "amazon-web-services",
            "iam",
            "analytics",
            "data-lake",
            "lakehouse",
            "athena",
            "glue",
            "aws-glue",
            "data-catalog",
            "s3",
            "s3-tables",
            "s3-vectors",
            "iceberg",
            "apache-iceberg",
            "etl",
            "redshift",
            "redshift-serverless",
            "data-warehouse",
            "snowflake",
            "bigquery",
            "rds",
            "dynamodb",
            "jdbc",
            "secrets-manager",
            "vector-search",
            "semantic-search",
            "rag",
            "embeddings",
            "vector-database",
            "aurora",
            "opensearch",
            "opensearch-serverless",
            "amazon-opensearch-service",
            "elasticsearch",
            "solr",
            "hybrid-search",
            "k-nn",
            "log-analytics",
            "trace-analytics"
          ],
          "author": {
            "name": "Amazon Web Services"
          },
          "version": "1.2.0",
          "license": "Apache-2.0",
          "logoUrl": null,
          "darkLogoUrl": null,
          "homepage": "https://github.com/aws/agent-toolkit-for-aws",
          "sourceUrl": "https://github.com/aws/agent-toolkit-for-aws/tree/08ad220e4e9bbc498821ce9360b3dcdf4813121d/plugins/aws-data-analytics",
          "skills": [
            {
              "name": "amazon-opensearch-service",
              "sourceUrl": "https://github.com/aws/agent-toolkit-for-aws/blob/08ad220e4e9bbc498821ce9360b3dcdf4813121d/plugins/aws-data-analytics/skills/amazon-opensearch-service/SKILL.md"
            },
            {
              "name": "connecting-to-data-source",
              "sourceUrl": "https://github.com/aws/agent-toolkit-for-aws/blob/08ad220e4e9bbc498821ce9360b3dcdf4813121d/plugins/aws-data-analytics/skills/connecting-to-data-source/SKILL.md"
            },
            {
              "name": "creating-data-lake-table",
              "sourceUrl": "https://github.com/aws/agent-toolkit-for-aws/blob/08ad220e4e9bbc498821ce9360b3dcdf4813121d/plugins/aws-data-analytics/skills/creating-data-lake-table/SKILL.md"
            },
            {
              "name": "exploring-data-catalog",
              "sourceUrl": "https://github.com/aws/agent-toolkit-for-aws/blob/08ad220e4e9bbc498821ce9360b3dcdf4813121d/plugins/aws-data-analytics/skills/exploring-data-catalog/SKILL.md"
            },
            {
              "name": "finding-data-lake-assets",
              "sourceUrl": "https://github.com/aws/agent-toolkit-for-aws/blob/08ad220e4e9bbc498821ce9360b3dcdf4813121d/plugins/aws-data-analytics/skills/finding-data-lake-assets/SKILL.md"
            },
            {
              "name": "ingesting-into-data-lake",
              "sourceUrl": "https://github.com/aws/agent-toolkit-for-aws/blob/08ad220e4e9bbc498821ce9360b3dcdf4813121d/plugins/aws-data-analytics/skills/ingesting-into-data-lake/SKILL.md"
            },
            {
              "name": "querying-data-lake",
              "sourceUrl": "https://github.com/aws/agent-toolkit-for-aws/blob/08ad220e4e9bbc498821ce9360b3dcdf4813121d/plugins/aws-data-analytics/skills/querying-data-lake/SKILL.md"
            },
            {
              "name": "redshift-guide",
              "sourceUrl": "https://github.com/aws/agent-toolkit-for-aws/blob/08ad220e4e9bbc498821ce9360b3dcdf4813121d/plugins/aws-data-analytics/skills/redshift-guide/SKILL.md"
            },
            {
              "name": "storing-and-querying-vectors",
              "sourceUrl": "https://github.com/aws/agent-toolkit-for-aws/blob/08ad220e4e9bbc498821ce9360b3dcdf4813121d/plugins/aws-data-analytics/skills/storing-and-querying-vectors/SKILL.md"
            }
          ],
          "mcpServers": [
            {
              "requiresConfiguration": false,
              "name": "aws-mcp",
              "transport": "stdio",
              "endpoint": null
            }
          ],
          "components": ["skills", "mcp"],
          "componentInspection": "repository",
          "inspectionError": null,
          "installation": "requires_adapter",
          "upstream": {
            "source": {
              "source": "git-subdir",
              "url": "https://github.com/aws/agent-toolkit-for-aws.git",
              "path": "plugins/aws-data-analytics",
              "ref": "main",
              "sha": "08ad220e4e9bbc498821ce9360b3dcdf4813121d"
            },
            "policy": null
          }
        },
        {
          "id": "anthropic:aws-serverless",
          "name": "aws-serverless",
          "displayName": "aws-serverless",
          "description": "Design, build, deploy, test, and debug serverless applications with AWS Serverless services.",
          "longDescription": "Design, build, deploy, test, and debug serverless applications with AWS Serverless services.",
          "category": "development",
          "keywords": [
            "aws",
            "lambda",
            "durable functions",
            "managed-instances",
            "lmi",
            "serverless",
            "development",
            "sam",
            "api-gateway",
            "eventbridge",
            "step-functions",
            "microvms",
            "firecracker"
          ],
          "author": {
            "name": "Amazon Web Services"
          },
          "version": "1.3.0",
          "license": "Apache-2.0",
          "logoUrl": null,
          "darkLogoUrl": null,
          "homepage": "https://github.com/awslabs/agent-plugins",
          "sourceUrl": "https://github.com/awslabs/agent-plugins/tree/34afdf5005325f17d5da2d1443b87f27a53b0a20/plugins/aws-serverless",
          "skills": [
            {
              "name": "api-gateway",
              "sourceUrl": "https://github.com/awslabs/agent-plugins/blob/34afdf5005325f17d5da2d1443b87f27a53b0a20/plugins/aws-serverless/skills/api-gateway/SKILL.md"
            },
            {
              "name": "aws-lambda-durable-functions",
              "sourceUrl": "https://github.com/awslabs/agent-plugins/blob/34afdf5005325f17d5da2d1443b87f27a53b0a20/plugins/aws-serverless/skills/aws-lambda-durable-functions/SKILL.md"
            },
            {
              "name": "aws-lambda-managed-instances",
              "sourceUrl": "https://github.com/awslabs/agent-plugins/blob/34afdf5005325f17d5da2d1443b87f27a53b0a20/plugins/aws-serverless/skills/aws-lambda-managed-instances/SKILL.md"
            },
            {
              "name": "aws-lambda-microvms",
              "sourceUrl": "https://github.com/awslabs/agent-plugins/blob/34afdf5005325f17d5da2d1443b87f27a53b0a20/plugins/aws-serverless/skills/aws-lambda-microvms/SKILL.md"
            },
            {
              "name": "aws-lambda",
              "sourceUrl": "https://github.com/awslabs/agent-plugins/blob/34afdf5005325f17d5da2d1443b87f27a53b0a20/plugins/aws-serverless/skills/aws-lambda/SKILL.md"
            },
            {
              "name": "aws-serverless-deployment",
              "sourceUrl": "https://github.com/awslabs/agent-plugins/blob/34afdf5005325f17d5da2d1443b87f27a53b0a20/plugins/aws-serverless/skills/aws-serverless-deployment/SKILL.md"
            },
            {
              "name": "aws-step-functions",
              "sourceUrl": "https://github.com/awslabs/agent-plugins/blob/34afdf5005325f17d5da2d1443b87f27a53b0a20/plugins/aws-serverless/skills/aws-step-functions/SKILL.md"
            }
          ],
          "mcpServers": [
            {
              "requiresConfiguration": false,
              "name": "aws-serverless-mcp",
              "transport": "stdio",
              "endpoint": null
            }
          ],
          "components": ["skills", "mcp", "hooks"],
          "componentInspection": "repository",
          "inspectionError": null,
          "installation": "requires_adapter",
          "upstream": {
            "source": {
              "source": "git-subdir",
              "url": "https://github.com/awslabs/agent-plugins.git",
              "path": "plugins/aws-serverless",
              "ref": "main",
              "sha": "34afdf5005325f17d5da2d1443b87f27a53b0a20"
            },
            "policy": null
          }
        },
        {
          "id": "anthropic:aws-startup-advisor",
          "name": "aws-startup-advisor",
          "displayName": "aws-startup-advisor",
          "description": "Personalized AWS guidance built on patterns from 350,000+ startups—architecture, cost, security, and migration, from day-one account setup to production-ready infrastructure. Migrate to AWS from GCP or Heroku—including your entire AI stack: OpenAI/Gemini/Anthropic SDK rewrites to Amazon Bedrock, agentic systems (LangChain, CrewAI, AutoGen) to AWS-native runtimes, and Temporal workers. Includes AWS Activate credits eligibility and 60+ exclusive startup offers. Built by AWS Startup Solutions Architects, with multi-account, multi-region support.",
          "longDescription": "Personalized AWS guidance built on patterns from 350,000+ startups—architecture, cost, security, and migration, from day-one account setup to production-ready infrastructure. Migrate to AWS from GCP or Heroku—including your entire AI stack: OpenAI/Gemini/Anthropic SDK rewrites to Amazon Bedrock, agentic systems (LangChain, CrewAI, AutoGen) to AWS-native runtimes, and Temporal workers. Includes AWS Activate credits eligibility and 60+ exclusive startup offers. Built by AWS Startup Solutions Architects, with multi-account, multi-region support.",
          "category": "development",
          "keywords": [
            "aws",
            "startups",
            "activate",
            "knowledge-base",
            "prompt-library",
            "gcp",
            "google-cloud",
            "migration",
            "cloud-migration",
            "terraform",
            "fargate",
            "rds",
            "aurora",
            "eks",
            "bedrock",
            "ai-migration",
            "openai",
            "openai-to-bedrock",
            "langchain",
            "langgraph",
            "crewai",
            "autogen",
            "agentic",
            "agents",
            "llm-migration",
            "cost-estimation",
            "heroku",
            "heroku-to-aws",
            "move-to-aws",
            "gemini",
            "agentcore",
            "agent-runtime",
            "llm-to-bedrock",
            "temporal",
            "durable-execution",
            "anthropic",
            "claude",
            "gcp-to-aws",
            "cloud-run",
            "cloud-sql",
            "gke",
            "vertex-ai",
            "ecs",
            "lambda",
            "lambda-microvms",
            "elastic-beanstalk",
            "postgres",
            "redis",
            "kafka",
            "elasticache",
            "msk",
            "switch-to-aws",
            "cost-comparison",
            "pricing-comparison",
            "cost-optimization",
            "credits",
            "architecture",
            "well-architected",
            "mvp",
            "rag",
            "bedrock-migration",
            "rewrite-sdk-calls",
            "deploy-ai-agent",
            "choose-agent-runtime"
          ],
          "author": {
            "name": "Amazon Web Services"
          },
          "version": "2.0.0",
          "license": "Apache-2.0",
          "logoUrl": null,
          "darkLogoUrl": null,
          "homepage": "https://github.com/awslabs/startups",
          "sourceUrl": "https://github.com/awslabs/startups/tree/f1cc0fb275d45ce053997c7e921b4017f8f40eda/advisor/plugins/aws-startup-advisor",
          "skills": [
            {
              "name": "agent-advisor",
              "sourceUrl": "https://github.com/awslabs/startups/blob/f1cc0fb275d45ce053997c7e921b4017f8f40eda/advisor/plugins/aws-startup-advisor/skills/agent-advisor/SKILL.md"
            },
            {
              "name": "architect-for-startups",
              "sourceUrl": "https://github.com/awslabs/startups/blob/f1cc0fb275d45ce053997c7e921b4017f8f40eda/advisor/plugins/aws-startup-advisor/skills/architect-for-startups/SKILL.md"
            },
            {
              "name": "gcp-to-aws",
              "sourceUrl": "https://github.com/awslabs/startups/blob/f1cc0fb275d45ce053997c7e921b4017f8f40eda/advisor/plugins/aws-startup-advisor/skills/gcp-to-aws/SKILL.md"
            },
            {
              "name": "heroku-to-aws",
              "sourceUrl": "https://github.com/awslabs/startups/blob/f1cc0fb275d45ce053997c7e921b4017f8f40eda/advisor/plugins/aws-startup-advisor/skills/heroku-to-aws/SKILL.md"
            },
            {
              "name": "knowledge-base-for-startups",
              "sourceUrl": "https://github.com/awslabs/startups/blob/f1cc0fb275d45ce053997c7e921b4017f8f40eda/advisor/plugins/aws-startup-advisor/skills/knowledge-base-for-startups/SKILL.md"
            },
            {
              "name": "llm-to-bedrock",
              "sourceUrl": "https://github.com/awslabs/startups/blob/f1cc0fb275d45ce053997c7e921b4017f8f40eda/advisor/plugins/aws-startup-advisor/skills/llm-to-bedrock/SKILL.md"
            },
            {
              "name": "prompt-library-for-startups",
              "sourceUrl": "https://github.com/awslabs/startups/blob/f1cc0fb275d45ce053997c7e921b4017f8f40eda/advisor/plugins/aws-startup-advisor/skills/prompt-library-for-startups/SKILL.md"
            },
            {
              "name": "start-building-for-startups",
              "sourceUrl": "https://github.com/awslabs/startups/blob/f1cc0fb275d45ce053997c7e921b4017f8f40eda/advisor/plugins/aws-startup-advisor/skills/start-building-for-startups/SKILL.md"
            },
            {
              "name": "tf-best-practices",
              "sourceUrl": "https://github.com/awslabs/startups/blob/f1cc0fb275d45ce053997c7e921b4017f8f40eda/advisor/plugins/aws-startup-advisor/skills/tf-best-practices/SKILL.md"
            }
          ],
          "mcpServers": [
            {
              "requiresConfiguration": false,
              "name": "awsknowledge",
              "transport": "http",
              "endpoint": "https://knowledge-mcp.global.api.aws"
            },
            {
              "requiresConfiguration": false,
              "name": "awspricing",
              "transport": "stdio",
              "endpoint": null
            },
            {
              "requiresConfiguration": false,
              "name": "temporal-docs",
              "transport": "http",
              "endpoint": "https://temporal.mcp.kapa.ai"
            },
            {
              "requiresConfiguration": false,
              "name": "aws-pricing-calculator",
              "transport": "stdio",
              "endpoint": null
            }
          ],
          "components": ["skills", "mcp", "hooks", "agents"],
          "componentInspection": "repository",
          "inspectionError": null,
          "installation": "requires_adapter",
          "upstream": {
            "source": {
              "source": "git-subdir",
              "url": "https://github.com/awslabs/startups.git",
              "path": "advisor/plugins/aws-startup-advisor",
              "ref": "main",
              "sha": "f1cc0fb275d45ce053997c7e921b4017f8f40eda"
            },
            "policy": null
          }
        },
        {
          "id": "anthropic:aws-transform",
          "name": "aws-transform",
          "displayName": "aws-transform",
          "description": "Migrate, modernize, and upgrade codebases to AWS. Transforms .NET Framework to .NET 8/10, mainframe COBOL to Java, VMware VMs to EC2, SQL Server to Aurora, and upgrades Java/Python/Node.js versions and AWS SDKs. AWS Transform - continuous modernization analyzes codebases for tech debt, security issues, and upgrade opportunities, then remediates them.",
          "longDescription": "Migrate, modernize, and upgrade codebases to AWS. Transforms .NET Framework to .NET 8/10, mainframe COBOL to Java, VMware VMs to EC2, SQL Server to Aurora, and upgrades Java/Python/Node.js versions and AWS SDKs. AWS Transform - continuous modernization analyzes codebases for tech debt, security issues, and upgrade opportunities, then remediates them.",
          "category": "migration",
          "keywords": [
            "aws",
            "aws-transform",
            "migration",
            "modernization",
            "dotnet",
            "mainframe",
            "cobol",
            "vmware",
            "ec2",
            "sql-server",
            "aurora",
            "java",
            "python",
            "sdk",
            "continuous modernization",
            "AWS Transform - continuous modernization",
            "tech debt",
            "security vulnerabilities",
            "analyze repos",
            "security analysis",
            "modernization analysis",
            "agentic readiness"
          ],
          "author": {
            "name": "Amazon Web Services"
          },
          "version": "1.9.0",
          "license": "Apache-2.0",
          "logoUrl": null,
          "darkLogoUrl": null,
          "homepage": "https://github.com/awslabs/agent-plugins",
          "sourceUrl": "https://github.com/awslabs/agent-plugins/tree/adc01133bbd01433dcb2c0f98641f2b85694f92f/plugins/aws-transform",
          "skills": [
            {
              "name": "aws-transform",
              "sourceUrl": "https://github.com/awslabs/agent-plugins/blob/adc01133bbd01433dcb2c0f98641f2b85694f92f/plugins/aws-transform/skills/aws-transform/SKILL.md"
            }
          ],
          "mcpServers": [
            {
              "requiresConfiguration": false,
              "name": "aws-transform-mcp",
              "transport": "stdio",
              "endpoint": null
            }
          ],
          "components": ["skills", "mcp"],
          "componentInspection": "repository",
          "inspectionError": null,
          "installation": "requires_adapter",
          "upstream": {
            "source": {
              "source": "git-subdir",
              "url": "https://github.com/awslabs/agent-plugins.git",
              "path": "plugins/aws-transform",
              "ref": "main",
              "sha": "adc01133bbd01433dcb2c0f98641f2b85694f92f"
            },
            "policy": null
          }
        },
        {
          "id": "anthropic:azure",
          "name": "azure",
          "displayName": "azure",
          "description": "Microsoft Azure MCP and Skills integration for cloud resource management, deployments, and Azure services. Manage your Azure infrastructure, monitor applications, and deploy resources directly from Claude Code.",
          "longDescription": "Microsoft Azure MCP and Skills integration for cloud resource management, deployments, and Azure services. Manage your Azure infrastructure, monitor applications, and deploy resources directly from Claude Code.",
          "category": "deployment",
          "keywords": [
            "azure",
            "cloud",
            "infrastructure",
            "deployment",
            "microsoft",
            "devops",
            "foundry",
            "diagnostics"
          ],
          "author": {
            "name": "Microsoft",
            "url": "https://www.microsoft.com"
          },
          "version": "1.2.40",
          "license": "MIT",
          "logoUrl": null,
          "darkLogoUrl": null,
          "homepage": "https://github.com/microsoft/azure-skills",
          "sourceUrl": "https://github.com/microsoft/azure-skills/tree/2fe0f02665574305657c6e79a619c6b9554e53dc/",
          "skills": [
            {
              "name": "azure-kusto-graph",
              "sourceUrl": "https://github.com/microsoft/azure-skills/blob/2fe0f02665574305657c6e79a619c6b9554e53dc/.github/plugins/azure-kusto-graph-skills/skills/azure-kusto-graph/SKILL.md"
            },
            {
              "name": "azure-kusto-irql-graph",
              "sourceUrl": "https://github.com/microsoft/azure-skills/blob/2fe0f02665574305657c6e79a619c6b9554e53dc/.github/plugins/azure-kusto-graph-skills/skills/azure-kusto-irql-graph/SKILL.md"
            },
            {
              "name": "azure-kusto-irql",
              "sourceUrl": "https://github.com/microsoft/azure-skills/blob/2fe0f02665574305657c6e79a619c6b9554e53dc/.github/plugins/azure-kusto-graph-skills/skills/azure-kusto-irql/SKILL.md"
            },
            {
              "name": "airunway-aks-setup",
              "sourceUrl": "https://github.com/microsoft/azure-skills/blob/2fe0f02665574305657c6e79a619c6b9554e53dc/.github/plugins/azure-skills/skills/airunway-aks-setup/SKILL.md"
            },
            {
              "name": "appinsights-instrumentation",
              "sourceUrl": "https://github.com/microsoft/azure-skills/blob/2fe0f02665574305657c6e79a619c6b9554e53dc/.github/plugins/azure-skills/skills/appinsights-instrumentation/SKILL.md"
            },
            {
              "name": "azure-ai",
              "sourceUrl": "https://github.com/microsoft/azure-skills/blob/2fe0f02665574305657c6e79a619c6b9554e53dc/.github/plugins/azure-skills/skills/azure-ai/SKILL.md"
            },
            {
              "name": "azure-aigateway",
              "sourceUrl": "https://github.com/microsoft/azure-skills/blob/2fe0f02665574305657c6e79a619c6b9554e53dc/.github/plugins/azure-skills/skills/azure-aigateway/SKILL.md"
            },
            {
              "name": "azure-app-onboard-prereq",
              "sourceUrl": "https://github.com/microsoft/azure-skills/blob/2fe0f02665574305657c6e79a619c6b9554e53dc/.github/plugins/azure-skills/skills/azure-app-onboard-prereq/SKILL.md"
            },
            {
              "name": "azure-app-onboard",
              "sourceUrl": "https://github.com/microsoft/azure-skills/blob/2fe0f02665574305657c6e79a619c6b9554e53dc/.github/plugins/azure-skills/skills/azure-app-onboard/SKILL.md"
            },
            {
              "name": "deploy",
              "sourceUrl": "https://github.com/microsoft/azure-skills/blob/2fe0f02665574305657c6e79a619c6b9554e53dc/.github/plugins/azure-skills/skills/azure-app-onboard/deploy/SKILL.md"
            },
            {
              "name": "prepare",
              "sourceUrl": "https://github.com/microsoft/azure-skills/blob/2fe0f02665574305657c6e79a619c6b9554e53dc/.github/plugins/azure-skills/skills/azure-app-onboard/prepare/SKILL.md"
            },
            {
              "name": "scaffold",
              "sourceUrl": "https://github.com/microsoft/azure-skills/blob/2fe0f02665574305657c6e79a619c6b9554e53dc/.github/plugins/azure-skills/skills/azure-app-onboard/scaffold/SKILL.md"
            },
            {
              "name": "azure-cloud-migrate",
              "sourceUrl": "https://github.com/microsoft/azure-skills/blob/2fe0f02665574305657c6e79a619c6b9554e53dc/.github/plugins/azure-skills/skills/azure-cloud-migrate/SKILL.md"
            },
            {
              "name": "azure-compliance",
              "sourceUrl": "https://github.com/microsoft/azure-skills/blob/2fe0f02665574305657c6e79a619c6b9554e53dc/.github/plugins/azure-skills/skills/azure-compliance/SKILL.md"
            },
            {
              "name": "azure-compute",
              "sourceUrl": "https://github.com/microsoft/azure-skills/blob/2fe0f02665574305657c6e79a619c6b9554e53dc/.github/plugins/azure-skills/skills/azure-compute/SKILL.md"
            },
            {
              "name": "azure-cost",
              "sourceUrl": "https://github.com/microsoft/azure-skills/blob/2fe0f02665574305657c6e79a619c6b9554e53dc/.github/plugins/azure-skills/skills/azure-cost/SKILL.md"
            },
            {
              "name": "azure-deploy",
              "sourceUrl": "https://github.com/microsoft/azure-skills/blob/2fe0f02665574305657c6e79a619c6b9554e53dc/.github/plugins/azure-skills/skills/azure-deploy/SKILL.md"
            },
            {
              "name": "azure-diagnostics",
              "sourceUrl": "https://github.com/microsoft/azure-skills/blob/2fe0f02665574305657c6e79a619c6b9554e53dc/.github/plugins/azure-skills/skills/azure-diagnostics/SKILL.md"
            },
            {
              "name": "azure-enterprise-infra-planner",
              "sourceUrl": "https://github.com/microsoft/azure-skills/blob/2fe0f02665574305657c6e79a619c6b9554e53dc/.github/plugins/azure-skills/skills/azure-enterprise-infra-planner/SKILL.md"
            },
            {
              "name": "azure-kubernetes",
              "sourceUrl": "https://github.com/microsoft/azure-skills/blob/2fe0f02665574305657c6e79a619c6b9554e53dc/.github/plugins/azure-skills/skills/azure-kubernetes/SKILL.md"
            },
            {
              "name": "azure-kubernetes-app-deploy",
              "sourceUrl": "https://github.com/microsoft/azure-skills/blob/2fe0f02665574305657c6e79a619c6b9554e53dc/.github/plugins/azure-skills/skills/azure-kubernetes/azure-kubernetes-app-deploy/SKILL.md"
            },
            {
              "name": "azure-kubernetes-automatic-readiness",
              "sourceUrl": "https://github.com/microsoft/azure-skills/blob/2fe0f02665574305657c6e79a619c6b9554e53dc/.github/plugins/azure-skills/skills/azure-kubernetes/azure-kubernetes-automatic-readiness/SKILL.md"
            },
            {
              "name": "azure-kusto",
              "sourceUrl": "https://github.com/microsoft/azure-skills/blob/2fe0f02665574305657c6e79a619c6b9554e53dc/.github/plugins/azure-skills/skills/azure-kusto/SKILL.md"
            },
            {
              "name": "azure-messaging",
              "sourceUrl": "https://github.com/microsoft/azure-skills/blob/2fe0f02665574305657c6e79a619c6b9554e53dc/.github/plugins/azure-skills/skills/azure-messaging/SKILL.md"
            },
            {
              "name": "azure-prepare",
              "sourceUrl": "https://github.com/microsoft/azure-skills/blob/2fe0f02665574305657c6e79a619c6b9554e53dc/.github/plugins/azure-skills/skills/azure-prepare/SKILL.md"
            },
            {
              "name": "azure-quotas",
              "sourceUrl": "https://github.com/microsoft/azure-skills/blob/2fe0f02665574305657c6e79a619c6b9554e53dc/.github/plugins/azure-skills/skills/azure-quotas/SKILL.md"
            },
            {
              "name": "azure-reliability",
              "sourceUrl": "https://github.com/microsoft/azure-skills/blob/2fe0f02665574305657c6e79a619c6b9554e53dc/.github/plugins/azure-skills/skills/azure-reliability/SKILL.md"
            },
            {
              "name": "azure-resource-lookup",
              "sourceUrl": "https://github.com/microsoft/azure-skills/blob/2fe0f02665574305657c6e79a619c6b9554e53dc/.github/plugins/azure-skills/skills/azure-resource-lookup/SKILL.md"
            },
            {
              "name": "azure-resource-visualizer",
              "sourceUrl": "https://github.com/microsoft/azure-skills/blob/2fe0f02665574305657c6e79a619c6b9554e53dc/.github/plugins/azure-skills/skills/azure-resource-visualizer/SKILL.md"
            },
            {
              "name": "azure-storage",
              "sourceUrl": "https://github.com/microsoft/azure-skills/blob/2fe0f02665574305657c6e79a619c6b9554e53dc/.github/plugins/azure-skills/skills/azure-storage/SKILL.md"
            },
            {
              "name": "azure-upgrade",
              "sourceUrl": "https://github.com/microsoft/azure-skills/blob/2fe0f02665574305657c6e79a619c6b9554e53dc/.github/plugins/azure-skills/skills/azure-upgrade/SKILL.md"
            },
            {
              "name": "azure-validate",
              "sourceUrl": "https://github.com/microsoft/azure-skills/blob/2fe0f02665574305657c6e79a619c6b9554e53dc/.github/plugins/azure-skills/skills/azure-validate/SKILL.md"
            },
            {
              "name": "entra-agent-id",
              "sourceUrl": "https://github.com/microsoft/azure-skills/blob/2fe0f02665574305657c6e79a619c6b9554e53dc/.github/plugins/azure-skills/skills/entra-agent-id/SKILL.md"
            },
            {
              "name": "entra-app-registration",
              "sourceUrl": "https://github.com/microsoft/azure-skills/blob/2fe0f02665574305657c6e79a619c6b9554e53dc/.github/plugins/azure-skills/skills/entra-app-registration/SKILL.md"
            },
            {
              "name": "microsoft-foundry",
              "sourceUrl": "https://github.com/microsoft/azure-skills/blob/2fe0f02665574305657c6e79a619c6b9554e53dc/.github/plugins/azure-skills/skills/microsoft-foundry/SKILL.md"
            },
            {
              "name": "finetuning",
              "sourceUrl": "https://github.com/microsoft/azure-skills/blob/2fe0f02665574305657c6e79a619c6b9554e53dc/.github/plugins/azure-skills/skills/microsoft-foundry/finetuning/SKILL.md"
            },
            {
              "name": "deploy-model",
              "sourceUrl": "https://github.com/microsoft/azure-skills/blob/2fe0f02665574305657c6e79a619c6b9554e53dc/.github/plugins/azure-skills/skills/microsoft-foundry/models/deploy-model/SKILL.md"
            },
            {
              "name": "capacity",
              "sourceUrl": "https://github.com/microsoft/azure-skills/blob/2fe0f02665574305657c6e79a619c6b9554e53dc/.github/plugins/azure-skills/skills/microsoft-foundry/models/deploy-model/capacity/SKILL.md"
            },
            {
              "name": "customize",
              "sourceUrl": "https://github.com/microsoft/azure-skills/blob/2fe0f02665574305657c6e79a619c6b9554e53dc/.github/plugins/azure-skills/skills/microsoft-foundry/models/deploy-model/customize/SKILL.md"
            },
            {
              "name": "preset",
              "sourceUrl": "https://github.com/microsoft/azure-skills/blob/2fe0f02665574305657c6e79a619c6b9554e53dc/.github/plugins/azure-skills/skills/microsoft-foundry/models/deploy-model/preset/SKILL.md"
            },
            {
              "name": "python-appservice-deploy",
              "sourceUrl": "https://github.com/microsoft/azure-skills/blob/2fe0f02665574305657c6e79a619c6b9554e53dc/.github/plugins/azure-skills/skills/python-appservice-deploy/SKILL.md"
            },
            {
              "name": "airunway-aks-setup",
              "sourceUrl": "https://github.com/microsoft/azure-skills/blob/2fe0f02665574305657c6e79a619c6b9554e53dc/skills/airunway-aks-setup/SKILL.md"
            },
            {
              "name": "appinsights-instrumentation",
              "sourceUrl": "https://github.com/microsoft/azure-skills/blob/2fe0f02665574305657c6e79a619c6b9554e53dc/skills/appinsights-instrumentation/SKILL.md"
            },
            {
              "name": "azure-ai",
              "sourceUrl": "https://github.com/microsoft/azure-skills/blob/2fe0f02665574305657c6e79a619c6b9554e53dc/skills/azure-ai/SKILL.md"
            },
            {
              "name": "azure-aigateway",
              "sourceUrl": "https://github.com/microsoft/azure-skills/blob/2fe0f02665574305657c6e79a619c6b9554e53dc/skills/azure-aigateway/SKILL.md"
            },
            {
              "name": "azure-app-onboard-prereq",
              "sourceUrl": "https://github.com/microsoft/azure-skills/blob/2fe0f02665574305657c6e79a619c6b9554e53dc/skills/azure-app-onboard-prereq/SKILL.md"
            },
            {
              "name": "azure-app-onboard",
              "sourceUrl": "https://github.com/microsoft/azure-skills/blob/2fe0f02665574305657c6e79a619c6b9554e53dc/skills/azure-app-onboard/SKILL.md"
            },
            {
              "name": "deploy",
              "sourceUrl": "https://github.com/microsoft/azure-skills/blob/2fe0f02665574305657c6e79a619c6b9554e53dc/skills/azure-app-onboard/deploy/SKILL.md"
            },
            {
              "name": "prepare",
              "sourceUrl": "https://github.com/microsoft/azure-skills/blob/2fe0f02665574305657c6e79a619c6b9554e53dc/skills/azure-app-onboard/prepare/SKILL.md"
            },
            {
              "name": "scaffold",
              "sourceUrl": "https://github.com/microsoft/azure-skills/blob/2fe0f02665574305657c6e79a619c6b9554e53dc/skills/azure-app-onboard/scaffold/SKILL.md"
            },
            {
              "name": "azure-cloud-migrate",
              "sourceUrl": "https://github.com/microsoft/azure-skills/blob/2fe0f02665574305657c6e79a619c6b9554e53dc/skills/azure-cloud-migrate/SKILL.md"
            },
            {
              "name": "azure-compliance",
              "sourceUrl": "https://github.com/microsoft/azure-skills/blob/2fe0f02665574305657c6e79a619c6b9554e53dc/skills/azure-compliance/SKILL.md"
            },
            {
              "name": "azure-compute",
              "sourceUrl": "https://github.com/microsoft/azure-skills/blob/2fe0f02665574305657c6e79a619c6b9554e53dc/skills/azure-compute/SKILL.md"
            },
            {
              "name": "azure-cost",
              "sourceUrl": "https://github.com/microsoft/azure-skills/blob/2fe0f02665574305657c6e79a619c6b9554e53dc/skills/azure-cost/SKILL.md"
            },
            {
              "name": "azure-deploy",
              "sourceUrl": "https://github.com/microsoft/azure-skills/blob/2fe0f02665574305657c6e79a619c6b9554e53dc/skills/azure-deploy/SKILL.md"
            },
            {
              "name": "azure-diagnostics",
              "sourceUrl": "https://github.com/microsoft/azure-skills/blob/2fe0f02665574305657c6e79a619c6b9554e53dc/skills/azure-diagnostics/SKILL.md"
            },
            {
              "name": "azure-enterprise-infra-planner",
              "sourceUrl": "https://github.com/microsoft/azure-skills/blob/2fe0f02665574305657c6e79a619c6b9554e53dc/skills/azure-enterprise-infra-planner/SKILL.md"
            },
            {
              "name": "azure-kubernetes",
              "sourceUrl": "https://github.com/microsoft/azure-skills/blob/2fe0f02665574305657c6e79a619c6b9554e53dc/skills/azure-kubernetes/SKILL.md"
            },
            {
              "name": "azure-kubernetes-app-deploy",
              "sourceUrl": "https://github.com/microsoft/azure-skills/blob/2fe0f02665574305657c6e79a619c6b9554e53dc/skills/azure-kubernetes/azure-kubernetes-app-deploy/SKILL.md"
            },
            {
              "name": "azure-kubernetes-automatic-readiness",
              "sourceUrl": "https://github.com/microsoft/azure-skills/blob/2fe0f02665574305657c6e79a619c6b9554e53dc/skills/azure-kubernetes/azure-kubernetes-automatic-readiness/SKILL.md"
            },
            {
              "name": "azure-kusto",
              "sourceUrl": "https://github.com/microsoft/azure-skills/blob/2fe0f02665574305657c6e79a619c6b9554e53dc/skills/azure-kusto/SKILL.md"
            },
            {
              "name": "azure-messaging",
              "sourceUrl": "https://github.com/microsoft/azure-skills/blob/2fe0f02665574305657c6e79a619c6b9554e53dc/skills/azure-messaging/SKILL.md"
            },
            {
              "name": "azure-prepare",
              "sourceUrl": "https://github.com/microsoft/azure-skills/blob/2fe0f02665574305657c6e79a619c6b9554e53dc/skills/azure-prepare/SKILL.md"
            },
            {
              "name": "azure-quotas",
              "sourceUrl": "https://github.com/microsoft/azure-skills/blob/2fe0f02665574305657c6e79a619c6b9554e53dc/skills/azure-quotas/SKILL.md"
            },
            {
              "name": "azure-reliability",
              "sourceUrl": "https://github.com/microsoft/azure-skills/blob/2fe0f02665574305657c6e79a619c6b9554e53dc/skills/azure-reliability/SKILL.md"
            },
            {
              "name": "azure-resource-lookup",
              "sourceUrl": "https://github.com/microsoft/azure-skills/blob/2fe0f02665574305657c6e79a619c6b9554e53dc/skills/azure-resource-lookup/SKILL.md"
            },
            {
              "name": "azure-resource-visualizer",
              "sourceUrl": "https://github.com/microsoft/azure-skills/blob/2fe0f02665574305657c6e79a619c6b9554e53dc/skills/azure-resource-visualizer/SKILL.md"
            },
            {
              "name": "azure-storage",
              "sourceUrl": "https://github.com/microsoft/azure-skills/blob/2fe0f02665574305657c6e79a619c6b9554e53dc/skills/azure-storage/SKILL.md"
            },
            {
              "name": "azure-upgrade",
              "sourceUrl": "https://github.com/microsoft/azure-skills/blob/2fe0f02665574305657c6e79a619c6b9554e53dc/skills/azure-upgrade/SKILL.md"
            },
            {
              "name": "azure-validate",
              "sourceUrl": "https://github.com/microsoft/azure-skills/blob/2fe0f02665574305657c6e79a619c6b9554e53dc/skills/azure-validate/SKILL.md"
            },
            {
              "name": "entra-agent-id",
              "sourceUrl": "https://github.com/microsoft/azure-skills/blob/2fe0f02665574305657c6e79a619c6b9554e53dc/skills/entra-agent-id/SKILL.md"
            },
            {
              "name": "entra-app-registration",
              "sourceUrl": "https://github.com/microsoft/azure-skills/blob/2fe0f02665574305657c6e79a619c6b9554e53dc/skills/entra-app-registration/SKILL.md"
            },
            {
              "name": "microsoft-foundry",
              "sourceUrl": "https://github.com/microsoft/azure-skills/blob/2fe0f02665574305657c6e79a619c6b9554e53dc/skills/microsoft-foundry/SKILL.md"
            },
            {
              "name": "finetuning",
              "sourceUrl": "https://github.com/microsoft/azure-skills/blob/2fe0f02665574305657c6e79a619c6b9554e53dc/skills/microsoft-foundry/finetuning/SKILL.md"
            },
            {
              "name": "deploy-model",
              "sourceUrl": "https://github.com/microsoft/azure-skills/blob/2fe0f02665574305657c6e79a619c6b9554e53dc/skills/microsoft-foundry/models/deploy-model/SKILL.md"
            },
            {
              "name": "capacity",
              "sourceUrl": "https://github.com/microsoft/azure-skills/blob/2fe0f02665574305657c6e79a619c6b9554e53dc/skills/microsoft-foundry/models/deploy-model/capacity/SKILL.md"
            },
            {
              "name": "customize",
              "sourceUrl": "https://github.com/microsoft/azure-skills/blob/2fe0f02665574305657c6e79a619c6b9554e53dc/skills/microsoft-foundry/models/deploy-model/customize/SKILL.md"
            },
            {
              "name": "preset",
              "sourceUrl": "https://github.com/microsoft/azure-skills/blob/2fe0f02665574305657c6e79a619c6b9554e53dc/skills/microsoft-foundry/models/deploy-model/preset/SKILL.md"
            },
            {
              "name": "python-appservice-deploy",
              "sourceUrl": "https://github.com/microsoft/azure-skills/blob/2fe0f02665574305657c6e79a619c6b9554e53dc/skills/python-appservice-deploy/SKILL.md"
            }
          ],
          "mcpServers": [
            {
              "requiresConfiguration": false,
              "name": "azure",
              "transport": "stdio",
              "endpoint": null
            }
          ],
          "components": ["skills", "mcp", "hooks"],
          "componentInspection": "repository",
          "inspectionError": null,
          "installation": "requires_adapter",
          "upstream": {
            "source": {
              "source": "url",
              "url": "https://github.com/microsoft/azure-skills.git",
              "sha": "2fe0f02665574305657c6e79a619c6b9554e53dc"
            },
            "policy": null
          }
        },
        {
          "id": "anthropic:azure-cosmos-db-assistant",
          "name": "azure-cosmos-db-assistant",
          "displayName": "azure-cosmos-db-assistant",
          "description": "Azure Cosmos DB plugin for Claude Code. Includes 73 best-practice rules across 10 categories covering data modeling, partition key design, query optimization, SDK usage, indexing, throughput management, global distribution, monitoring, design patterns, and vector search. No external services or configuration required. Optional MCP Toolkit integration available for live database operations.",
          "longDescription": "Azure Cosmos DB plugin for Claude Code. Includes 73 best-practice rules across 10 categories covering data modeling, partition key design, query optimization, SDK usage, indexing, throughput management, global distribution, monitoring, design patterns, and vector search. No external services or configuration required. Optional MCP Toolkit integration available for live database operations.",
          "category": "database",
          "keywords": [
            "azure",
            "cosmos-db",
            "cosmosdb",
            "nosql",
            "database",
            "vector-search",
            "best-practices"
          ],
          "author": {
            "name": "Azure Cosmos DB",
            "url": "https://azure.microsoft.com/products/cosmos-db"
          },
          "version": "1.0.0",
          "license": "MIT",
          "logoUrl": null,
          "darkLogoUrl": null,
          "homepage": "https://github.com/AzureCosmosDB/cosmosdb-claude-code-plugin",
          "sourceUrl": "https://github.com/AzureCosmosDB/cosmosdb-claude-code-plugin/tree/f1e0498579a9251e5f3179b92d25d6ce3409bae5/",
          "skills": [
            {
              "name": "cosmosdb-best-practices",
              "sourceUrl": "https://github.com/AzureCosmosDB/cosmosdb-claude-code-plugin/blob/f1e0498579a9251e5f3179b92d25d6ce3409bae5/skills/cosmosdb-best-practices/SKILL.md"
            }
          ],
          "mcpServers": [],
          "components": ["skills", "agents", "commands"],
          "componentInspection": "repository",
          "inspectionError": null,
          "installation": "requires_adapter",
          "upstream": {
            "source": {
              "source": "url",
              "url": "https://github.com/AzureCosmosDB/cosmosdb-claude-code-plugin.git",
              "sha": "f1e0498579a9251e5f3179b92d25d6ce3409bae5"
            },
            "policy": null
          }
        },
        {
          "id": "anthropic:azure-sql-developer",
          "name": "azure-sql-developer",
          "displayName": "azure-sql-database-container",
          "description": "Agent skills for the Azure SQL Database container, the Azure SQL Database engine running locally. Teaches your agent to run the engine, connect, migrate, scaffold, build RAG, wire CI, and go local-to-cloud, using the real Private Preview image instead of the SQL Server image.",
          "longDescription": "Agent skills for the Azure SQL Database container, the Azure SQL Database engine running locally. Teaches your agent to run the engine, connect, migrate, scaffold, build RAG, wire CI, and go local-to-cloud, using the real Private Preview image instead of the SQL Server image.",
          "category": "database",
          "keywords": [
            "azure-sql",
            "sql-server",
            "database",
            "container",
            "docker",
            "local-development",
            "rag",
            "vector-search"
          ],
          "author": {
            "name": "Microsoft"
          },
          "version": "1.1.0",
          "license": "MIT",
          "logoUrl": null,
          "darkLogoUrl": null,
          "homepage": "https://microsoft.github.io/azure-sql-database-container/",
          "sourceUrl": "https://github.com/microsoft/azure-sql-database-container/tree/207f3c309adb62b6df9fa5886ca4f35efd3b88d8/",
          "skills": [
            {
              "name": "azuresql-db-auth",
              "sourceUrl": "https://github.com/microsoft/azure-sql-database-container/blob/207f3c309adb62b6df9fa5886ca4f35efd3b88d8/skills/azuresql-db-auth/SKILL.md"
            },
            {
              "name": "azuresql-db-ci",
              "sourceUrl": "https://github.com/microsoft/azure-sql-database-container/blob/207f3c309adb62b6df9fa5886ca4f35efd3b88d8/skills/azuresql-db-ci/SKILL.md"
            },
            {
              "name": "azuresql-db-connections",
              "sourceUrl": "https://github.com/microsoft/azure-sql-database-container/blob/207f3c309adb62b6df9fa5886ca4f35efd3b88d8/skills/azuresql-db-connections/SKILL.md"
            },
            {
              "name": "azuresql-db-container",
              "sourceUrl": "https://github.com/microsoft/azure-sql-database-container/blob/207f3c309adb62b6df9fa5886ca4f35efd3b88d8/skills/azuresql-db-container/SKILL.md"
            },
            {
              "name": "azuresql-db-dab",
              "sourceUrl": "https://github.com/microsoft/azure-sql-database-container/blob/207f3c309adb62b6df9fa5886ca4f35efd3b88d8/skills/azuresql-db-dab/SKILL.md"
            },
            {
              "name": "azuresql-db-faq",
              "sourceUrl": "https://github.com/microsoft/azure-sql-database-container/blob/207f3c309adb62b6df9fa5886ca4f35efd3b88d8/skills/azuresql-db-faq/SKILL.md"
            },
            {
              "name": "azuresql-db-feedback",
              "sourceUrl": "https://github.com/microsoft/azure-sql-database-container/blob/207f3c309adb62b6df9fa5886ca4f35efd3b88d8/skills/azuresql-db-feedback/SKILL.md"
            },
            {
              "name": "azuresql-db-from-sql-server",
              "sourceUrl": "https://github.com/microsoft/azure-sql-database-container/blob/207f3c309adb62b6df9fa5886ca4f35efd3b88d8/skills/azuresql-db-from-sql-server/SKILL.md"
            },
            {
              "name": "azuresql-db-functions",
              "sourceUrl": "https://github.com/microsoft/azure-sql-database-container/blob/207f3c309adb62b6df9fa5886ca4f35efd3b88d8/skills/azuresql-db-functions/SKILL.md"
            },
            {
              "name": "azuresql-db-import",
              "sourceUrl": "https://github.com/microsoft/azure-sql-database-container/blob/207f3c309adb62b6df9fa5886ca4f35efd3b88d8/skills/azuresql-db-import/SKILL.md"
            },
            {
              "name": "azuresql-db-local-to-cloud",
              "sourceUrl": "https://github.com/microsoft/azure-sql-database-container/blob/207f3c309adb62b6df9fa5886ca4f35efd3b88d8/skills/azuresql-db-local-to-cloud/SKILL.md"
            },
            {
              "name": "azuresql-db-rag",
              "sourceUrl": "https://github.com/microsoft/azure-sql-database-container/blob/207f3c309adb62b6df9fa5886ca4f35efd3b88d8/skills/azuresql-db-rag/SKILL.md"
            },
            {
              "name": "azuresql-db-scaffold",
              "sourceUrl": "https://github.com/microsoft/azure-sql-database-container/blob/207f3c309adb62b6df9fa5886ca4f35efd3b88d8/skills/azuresql-db-scaffold/SKILL.md"
            },
            {
              "name": "azuresql-db-schema-migration",
              "sourceUrl": "https://github.com/microsoft/azure-sql-database-container/blob/207f3c309adb62b6df9fa5886ca4f35efd3b88d8/skills/azuresql-db-schema-migration/SKILL.md"
            },
            {
              "name": "azuresql-db-seed",
              "sourceUrl": "https://github.com/microsoft/azure-sql-database-container/blob/207f3c309adb62b6df9fa5886ca4f35efd3b88d8/skills/azuresql-db-seed/SKILL.md"
            },
            {
              "name": "azuresql-db-sidecar",
              "sourceUrl": "https://github.com/microsoft/azure-sql-database-container/blob/207f3c309adb62b6df9fa5886ca4f35efd3b88d8/skills/azuresql-db-sidecar/SKILL.md"
            },
            {
              "name": "azuresql-db-testing",
              "sourceUrl": "https://github.com/microsoft/azure-sql-database-container/blob/207f3c309adb62b6df9fa5886ca4f35efd3b88d8/skills/azuresql-db-testing/SKILL.md"
            }
          ],
          "mcpServers": [],
          "components": ["skills"],
          "componentInspection": "repository",
          "inspectionError": null,
          "installation": "requires_adapter",
          "upstream": {
            "source": {
              "source": "url",
              "url": "https://github.com/microsoft/azure-sql-database-container.git",
              "sha": "207f3c309adb62b6df9fa5886ca4f35efd3b88d8"
            },
            "policy": null
          }
        },
        {
          "id": "anthropic:base44",
          "name": "base44",
          "displayName": "base44",
          "description": "Build and deploy Base44 full-stack apps with CLI project management and JavaScript/TypeScript SDK development skills",
          "longDescription": "Build and deploy Base44 full-stack apps with CLI project management and JavaScript/TypeScript SDK development skills",
          "category": "development",
          "keywords": [
            "base44",
            "full-stack",
            "sdk",
            "cli",
            "deployment",
            "entities",
            "backend-functions",
            "javascript",
            "typescript"
          ],
          "author": {
            "name": "base44",
            "url": "https://base44.com"
          },
          "version": "1.0.0-beta.1",
          "license": "MIT",
          "logoUrl": null,
          "darkLogoUrl": null,
          "homepage": "https://docs.base44.com",
          "sourceUrl": "https://github.com/base44/skills/tree/8641b9467c852b39f6d1ae0108eec6ffe70b204c/",
          "skills": [
            {
              "name": "review-skills",
              "sourceUrl": "https://github.com/base44/skills/blob/8641b9467c852b39f6d1ae0108eec6ffe70b204c/.claude/skills/review-skills/SKILL.md"
            },
            {
              "name": "skill-creator",
              "sourceUrl": "https://github.com/base44/skills/blob/8641b9467c852b39f6d1ae0108eec6ffe70b204c/.claude/skills/skill-creator/SKILL.md"
            },
            {
              "name": "sync-cli-skill",
              "sourceUrl": "https://github.com/base44/skills/blob/8641b9467c852b39f6d1ae0108eec6ffe70b204c/.claude/skills/sync-cli-skill/SKILL.md"
            },
            {
              "name": "sync-sdk-skill",
              "sourceUrl": "https://github.com/base44/skills/blob/8641b9467c852b39f6d1ae0108eec6ffe70b204c/.claude/skills/sync-sdk-skill/SKILL.md"
            },
            {
              "name": "base44-cli",
              "sourceUrl": "https://github.com/base44/skills/blob/8641b9467c852b39f6d1ae0108eec6ffe70b204c/skills/base44-cli/SKILL.md"
            },
            {
              "name": "base44-remote-dev",
              "sourceUrl": "https://github.com/base44/skills/blob/8641b9467c852b39f6d1ae0108eec6ffe70b204c/skills/base44-remote-dev/SKILL.md"
            },
            {
              "name": "base44-sandbox",
              "sourceUrl": "https://github.com/base44/skills/blob/8641b9467c852b39f6d1ae0108eec6ffe70b204c/skills/base44-sandbox/SKILL.md"
            },
            {
              "name": "base44-sdk",
              "sourceUrl": "https://github.com/base44/skills/blob/8641b9467c852b39f6d1ae0108eec6ffe70b204c/skills/base44-sdk/SKILL.md"
            },
            {
              "name": "base44-troubleshooter",
              "sourceUrl": "https://github.com/base44/skills/blob/8641b9467c852b39f6d1ae0108eec6ffe70b204c/skills/base44-troubleshooter/SKILL.md"
            }
          ],
          "mcpServers": [],
          "components": ["skills"],
          "componentInspection": "repository",
          "inspectionError": null,
          "installation": "requires_adapter",
          "upstream": {
            "source": {
              "source": "url",
              "url": "https://github.com/base44/skills.git",
              "sha": "8641b9467c852b39f6d1ae0108eec6ffe70b204c"
            },
            "policy": null
          }
        },
        {
          "id": "anthropic:bigdata-com",
          "name": "bigdata-com",
          "displayName": "bigdata-com",
          "description": "Financial research and market intelligence on stocks, companies, sectors, and economies. Run valuation snapshots, peer comparables, and investment memos; preview, digest, and analyze earnings (quality, reactions, surprises); assess risk, monitor catalysts, and review competitive moats and governance. Covers thematic and sector research, cross-sector and regional comparisons, country and macro analysis, G7 benchmarking, scenario analysis, and company briefs. Powered by Bigdata MCP.",
          "longDescription": "Financial research and market intelligence on stocks, companies, sectors, and economies. Run valuation snapshots, peer comparables, and investment memos; preview, digest, and analyze earnings (quality, reactions, surprises); assess risk, monitor catalysts, and review competitive moats and governance. Covers thematic and sector research, cross-sector and regional comparisons, country and macro analysis, G7 benchmarking, scenario analysis, and company briefs. Powered by Bigdata MCP.",
          "category": "database",
          "keywords": [
            "Bigdata",
            "finance",
            "RavenPack",
            "stocks",
            "companies",
            "sectors",
            "economies",
            "valuation",
            "peers",
            "investment memos",
            "earnings",
            "risk",
            "catalysts",
            "moats",
            "governance",
            "thematic research",
            "sector research",
            "cross-sector comparisons",
            "regional comparisons",
            "country analysis",
            "macro analysis",
            "G7 benchmarking",
            "scenario analysis",
            "company briefs"
          ],
          "author": {
            "name": "RavenPack",
            "email": "support@bigdata.com"
          },
          "version": "1.2.0",
          "license": null,
          "logoUrl": null,
          "darkLogoUrl": null,
          "homepage": "https://docs.bigdata.com",
          "sourceUrl": "https://github.com/Bigdata-com/bigdata-plugins-marketplace/tree/2a52a001366227e205cfa7565d78e8198dc42fa8/plugins/bigdata-com",
          "skills": [
            {
              "name": "bigdata-catalyst-monitor",
              "sourceUrl": "https://github.com/Bigdata-com/bigdata-plugins-marketplace/blob/2a52a001366227e205cfa7565d78e8198dc42fa8/plugins/bigdata-com/skills/bigdata-catalyst-monitor/SKILL.md"
            },
            {
              "name": "bigdata-company-brief",
              "sourceUrl": "https://github.com/Bigdata-com/bigdata-plugins-marketplace/blob/2a52a001366227e205cfa7565d78e8198dc42fa8/plugins/bigdata-com/skills/bigdata-company-brief/SKILL.md"
            },
            {
              "name": "bigdata-country-analysis",
              "sourceUrl": "https://github.com/Bigdata-com/bigdata-plugins-marketplace/blob/2a52a001366227e205cfa7565d78e8198dc42fa8/plugins/bigdata-com/skills/bigdata-country-analysis/SKILL.md"
            },
            {
              "name": "bigdata-country-sector-analysis",
              "sourceUrl": "https://github.com/Bigdata-com/bigdata-plugins-marketplace/blob/2a52a001366227e205cfa7565d78e8198dc42fa8/plugins/bigdata-com/skills/bigdata-country-sector-analysis/SKILL.md"
            },
            {
              "name": "bigdata-cross-sector",
              "sourceUrl": "https://github.com/Bigdata-com/bigdata-plugins-marketplace/blob/2a52a001366227e205cfa7565d78e8198dc42fa8/plugins/bigdata-com/skills/bigdata-cross-sector/SKILL.md"
            },
            {
              "name": "bigdata-earnings-digest",
              "sourceUrl": "https://github.com/Bigdata-com/bigdata-plugins-marketplace/blob/2a52a001366227e205cfa7565d78e8198dc42fa8/plugins/bigdata-com/skills/bigdata-earnings-digest/SKILL.md"
            },
            {
              "name": "bigdata-earnings-preview",
              "sourceUrl": "https://github.com/Bigdata-com/bigdata-plugins-marketplace/blob/2a52a001366227e205cfa7565d78e8198dc42fa8/plugins/bigdata-com/skills/bigdata-earnings-preview/SKILL.md"
            },
            {
              "name": "bigdata-earnings-quality-screen",
              "sourceUrl": "https://github.com/Bigdata-com/bigdata-plugins-marketplace/blob/2a52a001366227e205cfa7565d78e8198dc42fa8/plugins/bigdata-com/skills/bigdata-earnings-quality-screen/SKILL.md"
            },
            {
              "name": "bigdata-earnings-reaction",
              "sourceUrl": "https://github.com/Bigdata-com/bigdata-plugins-marketplace/blob/2a52a001366227e205cfa7565d78e8198dc42fa8/plugins/bigdata-com/skills/bigdata-earnings-reaction/SKILL.md"
            },
            {
              "name": "bigdata-g7-comparison",
              "sourceUrl": "https://github.com/Bigdata-com/bigdata-plugins-marketplace/blob/2a52a001366227e205cfa7565d78e8198dc42fa8/plugins/bigdata-com/skills/bigdata-g7-comparison/SKILL.md"
            },
            {
              "name": "bigdata-investment-memo",
              "sourceUrl": "https://github.com/Bigdata-com/bigdata-plugins-marketplace/blob/2a52a001366227e205cfa7565d78e8198dc42fa8/plugins/bigdata-com/skills/bigdata-investment-memo/SKILL.md"
            },
            {
              "name": "bigdata-moat-governance-review",
              "sourceUrl": "https://github.com/Bigdata-com/bigdata-plugins-marketplace/blob/2a52a001366227e205cfa7565d78e8198dc42fa8/plugins/bigdata-com/skills/bigdata-moat-governance-review/SKILL.md"
            },
            {
              "name": "bigdata-peer-comparables",
              "sourceUrl": "https://github.com/Bigdata-com/bigdata-plugins-marketplace/blob/2a52a001366227e205cfa7565d78e8198dc42fa8/plugins/bigdata-com/skills/bigdata-peer-comparables/SKILL.md"
            },
            {
              "name": "bigdata-post-ipo-day1",
              "sourceUrl": "https://github.com/Bigdata-com/bigdata-plugins-marketplace/blob/2a52a001366227e205cfa7565d78e8198dc42fa8/plugins/bigdata-com/skills/bigdata-post-ipo-day1/SKILL.md"
            },
            {
              "name": "bigdata-post-ipo-day14",
              "sourceUrl": "https://github.com/Bigdata-com/bigdata-plugins-marketplace/blob/2a52a001366227e205cfa7565d78e8198dc42fa8/plugins/bigdata-com/skills/bigdata-post-ipo-day14/SKILL.md"
            },
            {
              "name": "bigdata-post-ipo-day179",
              "sourceUrl": "https://github.com/Bigdata-com/bigdata-plugins-marketplace/blob/2a52a001366227e205cfa7565d78e8198dc42fa8/plugins/bigdata-com/skills/bigdata-post-ipo-day179/SKILL.md"
            },
            {
              "name": "bigdata-post-ipo-day365",
              "sourceUrl": "https://github.com/Bigdata-com/bigdata-plugins-marketplace/blob/2a52a001366227e205cfa7565d78e8198dc42fa8/plugins/bigdata-com/skills/bigdata-post-ipo-day365/SKILL.md"
            },
            {
              "name": "bigdata-pre-ipo-analysis",
              "sourceUrl": "https://github.com/Bigdata-com/bigdata-plugins-marketplace/blob/2a52a001366227e205cfa7565d78e8198dc42fa8/plugins/bigdata-com/skills/bigdata-pre-ipo-analysis/SKILL.md"
            },
            {
              "name": "bigdata-quick-take",
              "sourceUrl": "https://github.com/Bigdata-com/bigdata-plugins-marketplace/blob/2a52a001366227e205cfa7565d78e8198dc42fa8/plugins/bigdata-com/skills/bigdata-quick-take/SKILL.md"
            },
            {
              "name": "bigdata-regional-comparison",
              "sourceUrl": "https://github.com/Bigdata-com/bigdata-plugins-marketplace/blob/2a52a001366227e205cfa7565d78e8198dc42fa8/plugins/bigdata-com/skills/bigdata-regional-comparison/SKILL.md"
            },
            {
              "name": "bigdata-risk-assessment",
              "sourceUrl": "https://github.com/Bigdata-com/bigdata-plugins-marketplace/blob/2a52a001366227e205cfa7565d78e8198dc42fa8/plugins/bigdata-com/skills/bigdata-risk-assessment/SKILL.md"
            },
            {
              "name": "bigdata-scenario-analysis",
              "sourceUrl": "https://github.com/Bigdata-com/bigdata-plugins-marketplace/blob/2a52a001366227e205cfa7565d78e8198dc42fa8/plugins/bigdata-com/skills/bigdata-scenario-analysis/SKILL.md"
            },
            {
              "name": "bigdata-sector-analysis",
              "sourceUrl": "https://github.com/Bigdata-com/bigdata-plugins-marketplace/blob/2a52a001366227e205cfa7565d78e8198dc42fa8/plugins/bigdata-com/skills/bigdata-sector-analysis/SKILL.md"
            },
            {
              "name": "bigdata-sector-playbook",
              "sourceUrl": "https://github.com/Bigdata-com/bigdata-plugins-marketplace/blob/2a52a001366227e205cfa7565d78e8198dc42fa8/plugins/bigdata-com/skills/bigdata-sector-playbook/SKILL.md"
            },
            {
              "name": "bigdata-thematic-research",
              "sourceUrl": "https://github.com/Bigdata-com/bigdata-plugins-marketplace/blob/2a52a001366227e205cfa7565d78e8198dc42fa8/plugins/bigdata-com/skills/bigdata-thematic-research/SKILL.md"
            },
            {
              "name": "bigdata-valuation-snapshot",
              "sourceUrl": "https://github.com/Bigdata-com/bigdata-plugins-marketplace/blob/2a52a001366227e205cfa7565d78e8198dc42fa8/plugins/bigdata-com/skills/bigdata-valuation-snapshot/SKILL.md"
            },
            {
              "name": "bigdata-variant-perception",
              "sourceUrl": "https://github.com/Bigdata-com/bigdata-plugins-marketplace/blob/2a52a001366227e205cfa7565d78e8198dc42fa8/plugins/bigdata-com/skills/bigdata-variant-perception/SKILL.md"
            }
          ],
          "mcpServers": [
            {
              "requiresConfiguration": false,
              "name": "bigdata.com",
              "transport": "http",
              "endpoint": "https://mcp.bigdata.com"
            }
          ],
          "components": ["skills", "mcp"],
          "componentInspection": "repository",
          "inspectionError": null,
          "installation": "requires_adapter",
          "upstream": {
            "source": {
              "source": "git-subdir",
              "url": "https://github.com/Bigdata-com/bigdata-plugins-marketplace.git",
              "path": "plugins/bigdata-com",
              "ref": "main",
              "sha": "2a52a001366227e205cfa7565d78e8198dc42fa8"
            },
            "policy": null
          }
        },
        {
          "id": "anthropic:bigquery-data-analytics",
          "name": "bigquery-data-analytics",
          "displayName": "bigquery-data-analytics",
          "description": "Connect, query, and generate data insights for BigQuery datasets and data.",
          "longDescription": "Connect, query, and generate data insights for BigQuery datasets and data.",
          "category": "database",
          "keywords": [],
          "author": {
            "name": "Google LLC",
            "email": "data-cloud-ai-integrations@google.com"
          },
          "version": "0.2.4",
          "license": "Apache-2.0",
          "logoUrl": null,
          "darkLogoUrl": null,
          "homepage": "https://cloud.google.com/bigquery",
          "sourceUrl": "https://github.com/gemini-cli-extensions/bigquery-data-analytics/tree/9870fce2723360135948b039bab03bc81ed814c8/",
          "skills": [
            {
              "name": "bigquery-ai-ml",
              "sourceUrl": "https://github.com/gemini-cli-extensions/bigquery-data-analytics/blob/9870fce2723360135948b039bab03bc81ed814c8/skills/bigquery-ai-ml/SKILL.md"
            }
          ],
          "mcpServers": [
            {
              "requiresConfiguration": false,
              "name": "bigquery",
              "transport": "stdio",
              "endpoint": null
            }
          ],
          "components": ["skills", "mcp"],
          "componentInspection": "repository",
          "inspectionError": null,
          "installation": "requires_adapter",
          "upstream": {
            "source": {
              "source": "url",
              "url": "https://github.com/gemini-cli-extensions/bigquery-data-analytics.git",
              "sha": "9870fce2723360135948b039bab03bc81ed814c8"
            },
            "policy": null
          }
        },
        {
          "id": "anthropic:boltz",
          "name": "boltz",
          "displayName": "boltz",
          "description": "Predict structures, screen molecules and proteins, and design binders with Boltz from Claude Code.",
          "longDescription": "Predict structures, screen molecules and proteins, and design binders with Boltz from Claude Code.",
          "category": "development",
          "keywords": [
            "boltz",
            "boltz-api",
            "computational-biology",
            "protein-design",
            "protein-screening",
            "small-molecule-design",
            "virtual-screening",
            "structure-prediction",
            "molecular-modeling",
            "drug-discovery"
          ],
          "author": {
            "name": "Boltz",
            "email": "support@boltz.bio",
            "url": "https://boltz.bio"
          },
          "version": "0.1.1",
          "license": "MIT",
          "logoUrl": null,
          "darkLogoUrl": null,
          "homepage": "https://boltz.bio",
          "sourceUrl": "https://github.com/boltz-bio/boltz-api-skills/tree/beafb3c16236347ab10fb54f78a5da49cbf7c7bb/plugins/boltz",
          "skills": [
            {
              "name": "boltz-check-status",
              "sourceUrl": "https://github.com/boltz-bio/boltz-api-skills/blob/beafb3c16236347ab10fb54f78a5da49cbf7c7bb/plugins/boltz/skills/boltz-check-status/SKILL.md"
            },
            {
              "name": "boltz-cli-setup",
              "sourceUrl": "https://github.com/boltz-bio/boltz-api-skills/blob/beafb3c16236347ab10fb54f78a5da49cbf7c7bb/plugins/boltz/skills/boltz-cli-setup/SKILL.md"
            },
            {
              "name": "boltz-protein-design",
              "sourceUrl": "https://github.com/boltz-bio/boltz-api-skills/blob/beafb3c16236347ab10fb54f78a5da49cbf7c7bb/plugins/boltz/skills/boltz-protein-design/SKILL.md"
            },
            {
              "name": "boltz-protein-screen",
              "sourceUrl": "https://github.com/boltz-bio/boltz-api-skills/blob/beafb3c16236347ab10fb54f78a5da49cbf7c7bb/plugins/boltz/skills/boltz-protein-screen/SKILL.md"
            },
            {
              "name": "boltz-small-molecule-adme",
              "sourceUrl": "https://github.com/boltz-bio/boltz-api-skills/blob/beafb3c16236347ab10fb54f78a5da49cbf7c7bb/plugins/boltz/skills/boltz-small-molecule-adme/SKILL.md"
            },
            {
              "name": "boltz-small-molecule-design",
              "sourceUrl": "https://github.com/boltz-bio/boltz-api-skills/blob/beafb3c16236347ab10fb54f78a5da49cbf7c7bb/plugins/boltz/skills/boltz-small-molecule-design/SKILL.md"
            },
            {
              "name": "boltz-small-molecule-screen",
              "sourceUrl": "https://github.com/boltz-bio/boltz-api-skills/blob/beafb3c16236347ab10fb54f78a5da49cbf7c7bb/plugins/boltz/skills/boltz-small-molecule-screen/SKILL.md"
            },
            {
              "name": "boltz-structure-and-binding",
              "sourceUrl": "https://github.com/boltz-bio/boltz-api-skills/blob/beafb3c16236347ab10fb54f78a5da49cbf7c7bb/plugins/boltz/skills/boltz-structure-and-binding/SKILL.md"
            }
          ],
          "mcpServers": [],
          "components": ["skills"],
          "componentInspection": "repository",
          "inspectionError": null,
          "installation": "requires_adapter",
          "upstream": {
            "source": {
              "source": "git-subdir",
              "url": "https://github.com/boltz-bio/boltz-api-skills.git",
              "path": "plugins/boltz",
              "ref": "main",
              "sha": "beafb3c16236347ab10fb54f78a5da49cbf7c7bb"
            },
            "policy": null
          }
        },
        {
          "id": "anthropic:box",
          "name": "box",
          "displayName": "box",
          "description": "Box Plugin for Claude Code to help with Box Platform integrations including content workflows, shared links, webhooks, metadata, and Box AI retrieval.",
          "longDescription": "Box Plugin for Claude Code to help with Box Platform integrations including content workflows, shared links, webhooks, metadata, and Box AI retrieval.",
          "category": "productivity",
          "keywords": ["box", "content", "cloud-storage", "file-management", "collaboration"],
          "author": {
            "name": "Box"
          },
          "version": "1.0.0",
          "license": "MIT",
          "logoUrl": null,
          "darkLogoUrl": null,
          "homepage": "https://github.com/box/skills",
          "sourceUrl": "https://github.com/box/skills/tree/aa75770f645367778df215dcbebbeec0b7e05546/",
          "skills": [
            {
              "name": "box-legal-workflows-contract",
              "sourceUrl": "https://github.com/box/skills/blob/aa75770f645367778df215dcbebbeec0b7e05546/skills/box-legal-workflows-contract/SKILL.md"
            },
            {
              "name": "box-legal-workflows-intake",
              "sourceUrl": "https://github.com/box/skills/blob/aa75770f645367778df215dcbebbeec0b7e05546/skills/box-legal-workflows-intake/SKILL.md"
            },
            {
              "name": "box-legal-workflows-ma",
              "sourceUrl": "https://github.com/box/skills/blob/aa75770f645367778df215dcbebbeec0b7e05546/skills/box-legal-workflows-ma/SKILL.md"
            },
            {
              "name": "box-legal-workflows",
              "sourceUrl": "https://github.com/box/skills/blob/aa75770f645367778df215dcbebbeec0b7e05546/skills/box-legal-workflows/SKILL.md"
            },
            {
              "name": "box",
              "sourceUrl": "https://github.com/box/skills/blob/aa75770f645367778df215dcbebbeec0b7e05546/skills/box/SKILL.md"
            }
          ],
          "mcpServers": [],
          "components": ["skills"],
          "componentInspection": "repository",
          "inspectionError": null,
          "installation": "requires_adapter",
          "upstream": {
            "source": {
              "source": "url",
              "url": "https://github.com/box/skills.git",
              "sha": "aa75770f645367778df215dcbebbeec0b7e05546"
            },
            "policy": null
          }
        },
        {
          "id": "anthropic:brightdata-plugin",
          "name": "brightdata-plugin",
          "displayName": "brightdata-plugin",
          "description": "Web scraping, Google search, structured data extraction, and MCP server integration powered by Bright Data. Includes 21 skills: scrape any webpage as markdown (with bot detection/CAPTCHA bypass), search Google with structured JSON results, extract data from 40+ websites (Amazon, LinkedIn, Instagram, TikTok, YouTube, and more), orchestrate Bright Data's 60+ MCP tools, Bright Data CLI for terminal-based scraping/search/data extraction/zone management, real-time competitive intelligence (competitor snapshots, pricing comparison, review mining, hiring signals, market landscape mapping), built-in best practices for Web Unlocker, SERP API, Web Scraper API, and Browser API, proxy integration code for Datacenter/ISP/Residential/Mobile networks, Python SDK best practices for the brightdata-sdk package, JavaScript/TypeScript SDK best practices for the @brightdata/sdk package, Discover API for intent-ranked semantic web search (trigger/poll, relevance scoring, parsed page content), deep multi-source cited research briefs, RAG and search-engine pipelines built on Discover (live retrieval and vector ingestion), scraper builder for any website, AI-generated Scraper Studio scrapers (`bdata scraper create` / `bdata scraper run`), SEO audits with live web data, social listening and brand reputation monitoring (sentiment and themes across Reddit/X/Instagram/TikTok/YouTube/reviews), shopping price comparison across Amazon/Walmart/eBay/Best Buy/Google Shopping (find the cheapest in-stock offer, region-aware), agent onboarding, design system mirroring, and Browser API session debugging.",
          "longDescription": "Web scraping, Google search, structured data extraction, and MCP server integration powered by Bright Data. Includes 21 skills: scrape any webpage as markdown (with bot detection/CAPTCHA bypass), search Google with structured JSON results, extract data from 40+ websites (Amazon, LinkedIn, Instagram, TikTok, YouTube, and more), orchestrate Bright Data's 60+ MCP tools, Bright Data CLI for terminal-based scraping/search/data extraction/zone management, real-time competitive intelligence (competitor snapshots, pricing comparison, review mining, hiring signals, market landscape mapping), built-in best practices for Web Unlocker, SERP API, Web Scraper API, and Browser API, proxy integration code for Datacenter/ISP/Residential/Mobile networks, Python SDK best practices for the brightdata-sdk package, JavaScript/TypeScript SDK best practices for the @brightdata/sdk package, Discover API for intent-ranked semantic web search (trigger/poll, relevance scoring, parsed page content), deep multi-source cited research briefs, RAG and search-engine pipelines built on Discover (live retrieval and vector ingestion), scraper builder for any website, AI-generated Scraper Studio scrapers (`bdata scraper create` / `bdata scraper run`), SEO audits with live web data, social listening and brand reputation monitoring (sentiment and themes across Reddit/X/Instagram/TikTok/YouTube/reviews), shopping price comparison across Amazon/Walmart/eBay/Best Buy/Google Shopping (find the cheapest in-stock offer, region-aware), agent onboarding, design system mirroring, and Browser API session debugging.",
          "category": null,
          "keywords": [
            "web-scraping",
            "search",
            "serp",
            "bright-data",
            "web-unlocker",
            "captcha-bypass",
            "claude-code",
            "data-feeds",
            "mcp",
            "mcp-server",
            "browser-automation",
            "structured-data",
            "best-practices",
            "serp-api",
            "browser-api",
            "python-sdk",
            "javascript-sdk",
            "typescript-sdk",
            "nodejs",
            "discover-api",
            "live-research",
            "rag",
            "rag-pipeline",
            "semantic-search",
            "vector-search",
            "brightdata-sdk",
            "brightdata-cli",
            "bdata",
            "cli",
            "scraper-studio",
            "ai-generated-scraper",
            "linkedin",
            "amazon",
            "instagram",
            "tiktok",
            "youtube",
            "facebook",
            "competitive-intelligence",
            "market-research",
            "competitor-analysis",
            "pricing-intelligence",
            "social-listening",
            "brand-monitoring",
            "sentiment-analysis",
            "brand-research",
            "price-comparison",
            "shopping",
            "deal-finder",
            "price-tracking"
          ],
          "author": {
            "name": "Bright Data",
            "email": "support@brightdata.com",
            "url": "https://brightdata.com"
          },
          "version": "1.8.0",
          "license": "MIT",
          "logoUrl": null,
          "darkLogoUrl": null,
          "homepage": "https://brightdata.com",
          "sourceUrl": "https://github.com/brightdata/skills/tree/e825f02fbcd7a89087fd1053a57ddcd45113370f/",
          "skills": [
            {
              "name": "agent-onboarding",
              "sourceUrl": "https://github.com/brightdata/skills/blob/e825f02fbcd7a89087fd1053a57ddcd45113370f/skills/agent-onboarding/SKILL.md"
            },
            {
              "name": "brand-listening",
              "sourceUrl": "https://github.com/brightdata/skills/blob/e825f02fbcd7a89087fd1053a57ddcd45113370f/skills/brand-listening/SKILL.md"
            },
            {
              "name": "brd-browser-debug",
              "sourceUrl": "https://github.com/brightdata/skills/blob/e825f02fbcd7a89087fd1053a57ddcd45113370f/skills/brd-browser-debug/SKILL.md"
            },
            {
              "name": "bright-data-best-practices",
              "sourceUrl": "https://github.com/brightdata/skills/blob/e825f02fbcd7a89087fd1053a57ddcd45113370f/skills/bright-data-best-practices/SKILL.md"
            },
            {
              "name": "bright-data-mcp",
              "sourceUrl": "https://github.com/brightdata/skills/blob/e825f02fbcd7a89087fd1053a57ddcd45113370f/skills/bright-data-mcp/SKILL.md"
            },
            {
              "name": "brightdata-cli",
              "sourceUrl": "https://github.com/brightdata/skills/blob/e825f02fbcd7a89087fd1053a57ddcd45113370f/skills/brightdata-cli/SKILL.md"
            },
            {
              "name": "competitive-intel",
              "sourceUrl": "https://github.com/brightdata/skills/blob/e825f02fbcd7a89087fd1053a57ddcd45113370f/skills/competitive-intel/SKILL.md"
            },
            {
              "name": "data-feeds",
              "sourceUrl": "https://github.com/brightdata/skills/blob/e825f02fbcd7a89087fd1053a57ddcd45113370f/skills/data-feeds/SKILL.md"
            },
            {
              "name": "design-mirror",
              "sourceUrl": "https://github.com/brightdata/skills/blob/e825f02fbcd7a89087fd1053a57ddcd45113370f/skills/design-mirror/SKILL.md"
            },
            {
              "name": "discover-api",
              "sourceUrl": "https://github.com/brightdata/skills/blob/e825f02fbcd7a89087fd1053a57ddcd45113370f/skills/discover-api/SKILL.md"
            },
            {
              "name": "js-sdk-best-practices",
              "sourceUrl": "https://github.com/brightdata/skills/blob/e825f02fbcd7a89087fd1053a57ddcd45113370f/skills/js-sdk-best-practices/SKILL.md"
            },
            {
              "name": "live-research",
              "sourceUrl": "https://github.com/brightdata/skills/blob/e825f02fbcd7a89087fd1053a57ddcd45113370f/skills/live-research/SKILL.md"
            },
            {
              "name": "price-comparison",
              "sourceUrl": "https://github.com/brightdata/skills/blob/e825f02fbcd7a89087fd1053a57ddcd45113370f/skills/price-comparison/SKILL.md"
            },
            {
              "name": "proxy",
              "sourceUrl": "https://github.com/brightdata/skills/blob/e825f02fbcd7a89087fd1053a57ddcd45113370f/skills/proxy/SKILL.md"
            },
            {
              "name": "python-sdk-best-practices",
              "sourceUrl": "https://github.com/brightdata/skills/blob/e825f02fbcd7a89087fd1053a57ddcd45113370f/skills/python-sdk-best-practices/SKILL.md"
            },
            {
              "name": "rag-pipeline",
              "sourceUrl": "https://github.com/brightdata/skills/blob/e825f02fbcd7a89087fd1053a57ddcd45113370f/skills/rag-pipeline/SKILL.md"
            },
            {
              "name": "scrape",
              "sourceUrl": "https://github.com/brightdata/skills/blob/e825f02fbcd7a89087fd1053a57ddcd45113370f/skills/scrape/SKILL.md"
            },
            {
              "name": "scraper-builder",
              "sourceUrl": "https://github.com/brightdata/skills/blob/e825f02fbcd7a89087fd1053a57ddcd45113370f/skills/scraper-builder/SKILL.md"
            },
            {
              "name": "scraper-studio",
              "sourceUrl": "https://github.com/brightdata/skills/blob/e825f02fbcd7a89087fd1053a57ddcd45113370f/skills/scraper-studio/SKILL.md"
            },
            {
              "name": "search",
              "sourceUrl": "https://github.com/brightdata/skills/blob/e825f02fbcd7a89087fd1053a57ddcd45113370f/skills/search/SKILL.md"
            },
            {
              "name": "seo-audit",
              "sourceUrl": "https://github.com/brightdata/skills/blob/e825f02fbcd7a89087fd1053a57ddcd45113370f/skills/seo-audit/SKILL.md"
            }
          ],
          "mcpServers": [],
          "components": ["skills"],
          "componentInspection": "repository",
          "inspectionError": null,
          "installation": "requires_adapter",
          "upstream": {
            "source": {
              "source": "url",
              "url": "https://github.com/brightdata/skills.git",
              "sha": "e825f02fbcd7a89087fd1053a57ddcd45113370f"
            },
            "policy": null
          }
        },
        {
          "id": "anthropic:browser-use",
          "name": "browser-use",
          "displayName": "browser-use",
          "description": "Give Claude a real browser — your Chrome or a Browser Use Cloud browser. Use it whenever a task involves a website or web app: browsing, scraping and data extraction, filling forms, testing sites, taking screenshots, automating web workflows.",
          "longDescription": "Give Claude a real browser — your Chrome or a Browser Use Cloud browser. Use it whenever a task involves a website or web app: browsing, scraping and data extraction, filling forms, testing sites, taking screenshots, automating web workflows.",
          "category": "automation",
          "keywords": [],
          "author": {
            "name": "Browser Use",
            "url": "https://browser-use.com"
          },
          "version": null,
          "license": null,
          "logoUrl": null,
          "darkLogoUrl": null,
          "homepage": "https://github.com/browser-use/browser-use",
          "sourceUrl": "https://github.com/browser-use/plugins/tree/a25f0a262928bcbb62071432636d943ed9f2b6aa/browser-use",
          "skills": [],
          "mcpServers": [
            {
              "requiresConfiguration": false,
              "name": "browser-use",
              "transport": "stdio",
              "endpoint": null
            }
          ],
          "components": ["mcp"],
          "componentInspection": "repository",
          "inspectionError": null,
          "installation": "requires_adapter",
          "upstream": {
            "source": {
              "source": "git-subdir",
              "url": "https://github.com/browser-use/plugins.git",
              "path": "browser-use",
              "ref": "main",
              "sha": "a25f0a262928bcbb62071432636d943ed9f2b6aa"
            },
            "policy": null
          }
        },
        {
          "id": "anthropic:buildkite",
          "name": "buildkite",
          "displayName": "buildkite",
          "description": "Official Buildkite skills for Claude Code, Cursor, and other AI coding agents — pipelines, migration, preflight, agent runtime, CLI, and API",
          "longDescription": "Official Buildkite skills for Claude Code, Cursor, and other AI coding agents — pipelines, migration, preflight, agent runtime, CLI, and API",
          "category": "development",
          "keywords": [],
          "author": {
            "name": "Buildkite"
          },
          "version": "1.0.0",
          "license": null,
          "logoUrl": null,
          "darkLogoUrl": null,
          "homepage": "https://buildkite.com",
          "sourceUrl": "https://github.com/buildkite/skills/tree/a4bb20c6bf9ae535335f782015f65b9975065f27/",
          "skills": [
            {
              "name": "buildkite-agent-runtime",
              "sourceUrl": "https://github.com/buildkite/skills/blob/a4bb20c6bf9ae535335f782015f65b9975065f27/skills/buildkite-agent-runtime/SKILL.md"
            },
            {
              "name": "buildkite-api",
              "sourceUrl": "https://github.com/buildkite/skills/blob/a4bb20c6bf9ae535335f782015f65b9975065f27/skills/buildkite-api/SKILL.md"
            },
            {
              "name": "buildkite-cli",
              "sourceUrl": "https://github.com/buildkite/skills/blob/a4bb20c6bf9ae535335f782015f65b9975065f27/skills/buildkite-cli/SKILL.md"
            },
            {
              "name": "buildkite-migration",
              "sourceUrl": "https://github.com/buildkite/skills/blob/a4bb20c6bf9ae535335f782015f65b9975065f27/skills/buildkite-migration/SKILL.md"
            },
            {
              "name": "buildkite-pipelines",
              "sourceUrl": "https://github.com/buildkite/skills/blob/a4bb20c6bf9ae535335f782015f65b9975065f27/skills/buildkite-pipelines/SKILL.md"
            },
            {
              "name": "buildkite-preflight",
              "sourceUrl": "https://github.com/buildkite/skills/blob/a4bb20c6bf9ae535335f782015f65b9975065f27/skills/buildkite-preflight/SKILL.md"
            }
          ],
          "mcpServers": [],
          "components": ["skills"],
          "componentInspection": "repository",
          "inspectionError": null,
          "installation": "requires_adapter",
          "upstream": {
            "source": {
              "source": "url",
              "url": "https://github.com/buildkite/skills.git",
              "sha": "a4bb20c6bf9ae535335f782015f65b9975065f27"
            },
            "policy": null
          }
        },
        {
          "id": "anthropic:canva",
          "name": "canva",
          "displayName": "canva",
          "description": "Create, edit, review, resize, and brand-check Canva designs with the Canva MCP server.",
          "longDescription": "Create, edit, review, resize, and brand-check Canva designs with the Canva MCP server.",
          "category": "design",
          "keywords": [
            "canva",
            "design",
            "presentation",
            "social media",
            "brand kit",
            "ai generation",
            "flyer",
            "poster",
            "graphic design",
            "marketing"
          ],
          "author": {
            "name": "Canva"
          },
          "version": "1.0.0",
          "license": null,
          "logoUrl": null,
          "darkLogoUrl": null,
          "homepage": "https://www.canva.com",
          "sourceUrl": "https://github.com/canva-sdks/canva-skills/tree/b56291ea0a36d0a941e1478b47959be5f1771dee/plugins/canva",
          "skills": [
            {
              "name": "branded-presentation",
              "sourceUrl": "https://github.com/canva-sdks/canva-skills/blob/b56291ea0a36d0a941e1478b47959be5f1771dee/plugins/canva/inactive-skills/branded-presentation/SKILL.md"
            },
            {
              "name": "classroom-helper",
              "sourceUrl": "https://github.com/canva-sdks/canva-skills/blob/b56291ea0a36d0a941e1478b47959be5f1771dee/plugins/canva/inactive-skills/classroom-helper/SKILL.md"
            },
            {
              "name": "design-translation",
              "sourceUrl": "https://github.com/canva-sdks/canva-skills/blob/b56291ea0a36d0a941e1478b47959be5f1771dee/plugins/canva/inactive-skills/design-translation/SKILL.md"
            },
            {
              "name": "presentation-time-fitting",
              "sourceUrl": "https://github.com/canva-sdks/canva-skills/blob/b56291ea0a36d0a941e1478b47959be5f1771dee/plugins/canva/inactive-skills/presentation-time-fitting/SKILL.md"
            },
            {
              "name": "brand-check",
              "sourceUrl": "https://github.com/canva-sdks/canva-skills/blob/b56291ea0a36d0a941e1478b47959be5f1771dee/plugins/canva/skills/brand-check/SKILL.md"
            },
            {
              "name": "bulk-create",
              "sourceUrl": "https://github.com/canva-sdks/canva-skills/blob/b56291ea0a36d0a941e1478b47959be5f1771dee/plugins/canva/skills/bulk-create/SKILL.md"
            },
            {
              "name": "edit-design",
              "sourceUrl": "https://github.com/canva-sdks/canva-skills/blob/b56291ea0a36d0a941e1478b47959be5f1771dee/plugins/canva/skills/edit-design/SKILL.md"
            },
            {
              "name": "get-design-feedback",
              "sourceUrl": "https://github.com/canva-sdks/canva-skills/blob/b56291ea0a36d0a941e1478b47959be5f1771dee/plugins/canva/skills/get-design-feedback/SKILL.md"
            },
            {
              "name": "implement-feedback",
              "sourceUrl": "https://github.com/canva-sdks/canva-skills/blob/b56291ea0a36d0a941e1478b47959be5f1771dee/plugins/canva/skills/implement-feedback/SKILL.md"
            },
            {
              "name": "resize-for-social-media",
              "sourceUrl": "https://github.com/canva-sdks/canva-skills/blob/b56291ea0a36d0a941e1478b47959be5f1771dee/plugins/canva/skills/resize-for-social-media/SKILL.md"
            }
          ],
          "mcpServers": [
            {
              "requiresConfiguration": false,
              "name": "canva",
              "transport": "http",
              "endpoint": "https://mcp.canva.com/mcp"
            }
          ],
          "components": ["skills", "mcp"],
          "componentInspection": "repository",
          "inspectionError": null,
          "installation": "requires_adapter",
          "upstream": {
            "source": {
              "source": "git-subdir",
              "url": "https://github.com/canva-sdks/canva-skills.git",
              "path": "plugins/canva",
              "ref": "main",
              "sha": "b56291ea0a36d0a941e1478b47959be5f1771dee"
            },
            "policy": null
          }
        },
        {
          "id": "anthropic:carbone-skill",
          "name": "carbone-skill",
          "displayName": "carbone-skill",
          "description": "Official Carbone skill — complete templating language reference covering tags, loops, conditions, formatters, aggregators, PDF form filling (AcroForm), format support and conversion, and all template formats (DOCX, XLSX, PPTX, ODT, HTML, Markdown, PDF, CSV, TXT, SVG, IDML)",
          "longDescription": "Official Carbone skill — complete templating language reference covering tags, loops, conditions, formatters, aggregators, PDF form filling (AcroForm), format support and conversion, and all template formats (DOCX, XLSX, PPTX, ODT, HTML, Markdown, PDF, CSV, TXT, SVG, IDML)",
          "category": "productivity",
          "keywords": [],
          "author": {
            "name": "Carbone",
            "email": "support@carbone.io"
          },
          "version": "1.6.1",
          "license": "Apache-2.0",
          "logoUrl": null,
          "darkLogoUrl": null,
          "homepage": "https://carbone.io",
          "sourceUrl": "https://github.com/carboneio/carbone-skill/tree/25207b3f52b97872312eab997ee5c62cc5c9542d/",
          "skills": [
            {
              "name": "carbone",
              "sourceUrl": "https://github.com/carboneio/carbone-skill/blob/25207b3f52b97872312eab997ee5c62cc5c9542d/carbone/SKILL.md"
            }
          ],
          "mcpServers": [],
          "components": ["skills"],
          "componentInspection": "repository",
          "inspectionError": null,
          "installation": "requires_adapter",
          "upstream": {
            "source": {
              "source": "url",
              "url": "https://github.com/carboneio/carbone-skill.git",
              "sha": "25207b3f52b97872312eab997ee5c62cc5c9542d"
            },
            "policy": null
          }
        },
        {
          "id": "anthropic:carta-cap-table",
          "name": "carta-cap-table",
          "displayName": "carta-cap-table",
          "description": "Carta Cap Table plugin — skills and hooks for querying cap tables, grants, SAFEs, 409A valuations, waterfall scenarios, and more",
          "longDescription": "Carta Cap Table plugin — skills and hooks for querying cap tables, grants, SAFEs, 409A valuations, waterfall scenarios, and more",
          "category": "productivity",
          "keywords": ["cap_table", "mcp", "carta", "equity", "grants"],
          "author": {
            "name": "Carta",
            "email": "engineering@carta.com"
          },
          "version": "6.70.0",
          "license": null,
          "logoUrl": null,
          "darkLogoUrl": null,
          "homepage": "https://github.com/carta/plugins",
          "sourceUrl": "https://github.com/carta/plugins/tree/c02c7ecf2e2d2c3f87ab30a04210732da10931be/plugins/carta-cap-table",
          "skills": [
            {
              "name": "carta-compensation-app",
              "sourceUrl": "https://github.com/carta/plugins/blob/c02c7ecf2e2d2c3f87ab30a04210732da10931be/plugins/carta-cap-table/skills/carta-compensation-app/SKILL.md"
            },
            {
              "name": "carta-compensation-benchmarks",
              "sourceUrl": "https://github.com/carta/plugins/blob/c02c7ecf2e2d2c3f87ab30a04210732da10931be/plugins/carta-cap-table/skills/carta-compensation-benchmarks/SKILL.md"
            },
            {
              "name": "carta-compensation-rolematcher",
              "sourceUrl": "https://github.com/carta/plugins/blob/c02c7ecf2e2d2c3f87ab30a04210732da10931be/plugins/carta-cap-table/skills/carta-compensation-rolematcher/SKILL.md"
            },
            {
              "name": "carta-compensation-scorecard",
              "sourceUrl": "https://github.com/carta/plugins/blob/c02c7ecf2e2d2c3f87ab30a04210732da10931be/plugins/carta-cap-table/skills/carta-compensation-scorecard/SKILL.md"
            },
            {
              "name": "carta-conversion-calculator",
              "sourceUrl": "https://github.com/carta/plugins/blob/c02c7ecf2e2d2c3f87ab30a04210732da10931be/plugins/carta-cap-table/skills/carta-conversion-calculator/SKILL.md"
            },
            {
              "name": "carta-discover-commands",
              "sourceUrl": "https://github.com/carta/plugins/blob/c02c7ecf2e2d2c3f87ab30a04210732da10931be/plugins/carta-cap-table/skills/carta-discover-commands/SKILL.md"
            },
            {
              "name": "carta-grant-vesting",
              "sourceUrl": "https://github.com/carta/plugins/blob/c02c7ecf2e2d2c3f87ab30a04210732da10931be/plugins/carta-cap-table/skills/carta-grant-vesting/SKILL.md"
            },
            {
              "name": "carta-interaction-reference-core",
              "sourceUrl": "https://github.com/carta/plugins/blob/c02c7ecf2e2d2c3f87ab30a04210732da10931be/plugins/carta-cap-table/skills/carta-interaction-reference-core/SKILL.md"
            },
            {
              "name": "carta-interaction-reference",
              "sourceUrl": "https://github.com/carta/plugins/blob/c02c7ecf2e2d2c3f87ab30a04210732da10931be/plugins/carta-cap-table/skills/carta-interaction-reference/SKILL.md"
            },
            {
              "name": "carta-issuance",
              "sourceUrl": "https://github.com/carta/plugins/blob/c02c7ecf2e2d2c3f87ab30a04210732da10931be/plugins/carta-cap-table/skills/carta-issuance/SKILL.md"
            },
            {
              "name": "issuance-config",
              "sourceUrl": "https://github.com/carta/plugins/blob/c02c7ecf2e2d2c3f87ab30a04210732da10931be/plugins/carta-cap-table/skills/carta-issuance/issuance-config/SKILL.md"
            },
            {
              "name": "issuance-import",
              "sourceUrl": "https://github.com/carta/plugins/blob/c02c7ecf2e2d2c3f87ab30a04210732da10931be/plugins/carta-cap-table/skills/carta-issuance/issuance-import/SKILL.md"
            },
            {
              "name": "issuance-review",
              "sourceUrl": "https://github.com/carta/plugins/blob/c02c7ecf2e2d2c3f87ab30a04210732da10931be/plugins/carta-cap-table/skills/carta-issuance/issuance-review/SKILL.md"
            },
            {
              "name": "carta-market-benchmarks",
              "sourceUrl": "https://github.com/carta/plugins/blob/c02c7ecf2e2d2c3f87ab30a04210732da10931be/plugins/carta-cap-table/skills/carta-market-benchmarks/SKILL.md"
            },
            {
              "name": "carta-portfolio-alerts",
              "sourceUrl": "https://github.com/carta/plugins/blob/c02c7ecf2e2d2c3f87ab30a04210732da10931be/plugins/carta-cap-table/skills/carta-portfolio-alerts/SKILL.md"
            },
            {
              "name": "carta-reporting-excel",
              "sourceUrl": "https://github.com/carta/plugins/blob/c02c7ecf2e2d2c3f87ab30a04210732da10931be/plugins/carta-cap-table/skills/carta-reporting-excel/SKILL.md"
            },
            {
              "name": "carta-reporting-markdown",
              "sourceUrl": "https://github.com/carta/plugins/blob/c02c7ecf2e2d2c3f87ab30a04210732da10931be/plugins/carta-cap-table/skills/carta-reporting-markdown/SKILL.md"
            },
            {
              "name": "carta-reporting",
              "sourceUrl": "https://github.com/carta/plugins/blob/c02c7ecf2e2d2c3f87ab30a04210732da10931be/plugins/carta-cap-table/skills/carta-reporting/SKILL.md"
            },
            {
              "name": "carta-round-history",
              "sourceUrl": "https://github.com/carta/plugins/blob/c02c7ecf2e2d2c3f87ab30a04210732da10931be/plugins/carta-cap-table/skills/carta-round-history/SKILL.md"
            },
            {
              "name": "carta-valuation-history",
              "sourceUrl": "https://github.com/carta/plugins/blob/c02c7ecf2e2d2c3f87ab30a04210732da10931be/plugins/carta-cap-table/skills/carta-valuation-history/SKILL.md"
            },
            {
              "name": "carta-waterfall-scenarios",
              "sourceUrl": "https://github.com/carta/plugins/blob/c02c7ecf2e2d2c3f87ab30a04210732da10931be/plugins/carta-cap-table/skills/carta-waterfall-scenarios/SKILL.md"
            },
            {
              "name": "carta-witness-signatures",
              "sourceUrl": "https://github.com/carta/plugins/blob/c02c7ecf2e2d2c3f87ab30a04210732da10931be/plugins/carta-cap-table/skills/carta-witness-signatures/SKILL.md"
            }
          ],
          "mcpServers": [],
          "components": ["skills", "hooks"],
          "componentInspection": "repository",
          "inspectionError": null,
          "installation": "requires_adapter",
          "upstream": {
            "source": {
              "source": "git-subdir",
              "url": "https://github.com/carta/plugins.git",
              "path": "plugins/carta-cap-table",
              "ref": "main",
              "sha": "c02c7ecf2e2d2c3f87ab30a04210732da10931be"
            },
            "policy": null
          }
        },
        {
          "id": "anthropic:carta-crm",
          "name": "carta-crm",
          "displayName": "carta-crm",
          "description": "Manage the Carta CRM conversationally — search, add, update, and enrich investors, companies, contacts, deals, notes, and fundraisings via the Carta CRM MCP Server",
          "longDescription": "Manage the Carta CRM conversationally — search, add, update, and enrich investors, companies, contacts, deals, notes, and fundraisings via the Carta CRM MCP Server",
          "category": "productivity",
          "keywords": [
            "carta",
            "crm",
            "investors",
            "companies",
            "contacts",
            "deals",
            "notes",
            "fundraisings",
            "search",
            "enrich",
            "analytics",
            "angles",
            "introductions",
            "network"
          ],
          "author": {
            "name": "Carta",
            "email": "crm@carta.com"
          },
          "version": "1.12.2",
          "license": null,
          "logoUrl": null,
          "darkLogoUrl": null,
          "homepage": "https://github.com/carta/plugins",
          "sourceUrl": "https://github.com/carta/plugins/tree/797077220ed39d3113d8f6af8f6ac10201f3a86a/plugins/carta-crm",
          "skills": [
            {
              "name": "add-company",
              "sourceUrl": "https://github.com/carta/plugins/blob/797077220ed39d3113d8f6af8f6ac10201f3a86a/plugins/carta-crm/skills/add-company/SKILL.md"
            },
            {
              "name": "add-contact",
              "sourceUrl": "https://github.com/carta/plugins/blob/797077220ed39d3113d8f6af8f6ac10201f3a86a/plugins/carta-crm/skills/add-contact/SKILL.md"
            },
            {
              "name": "add-deal",
              "sourceUrl": "https://github.com/carta/plugins/blob/797077220ed39d3113d8f6af8f6ac10201f3a86a/plugins/carta-crm/skills/add-deal/SKILL.md"
            },
            {
              "name": "add-fundraising",
              "sourceUrl": "https://github.com/carta/plugins/blob/797077220ed39d3113d8f6af8f6ac10201f3a86a/plugins/carta-crm/skills/add-fundraising/SKILL.md"
            },
            {
              "name": "add-investor",
              "sourceUrl": "https://github.com/carta/plugins/blob/797077220ed39d3113d8f6af8f6ac10201f3a86a/plugins/carta-crm/skills/add-investor/SKILL.md"
            },
            {
              "name": "add-note",
              "sourceUrl": "https://github.com/carta/plugins/blob/797077220ed39d3113d8f6af8f6ac10201f3a86a/plugins/carta-crm/skills/add-note/SKILL.md"
            },
            {
              "name": "carta-crm-home-build",
              "sourceUrl": "https://github.com/carta/plugins/blob/797077220ed39d3113d8f6af8f6ac10201f3a86a/plugins/carta-crm/skills/carta-crm-home-build/SKILL.md"
            },
            {
              "name": "deal-flow-analytics",
              "sourceUrl": "https://github.com/carta/plugins/blob/797077220ed39d3113d8f6af8f6ac10201f3a86a/plugins/carta-crm/skills/deal-flow-analytics/SKILL.md"
            },
            {
              "name": "enrich-company",
              "sourceUrl": "https://github.com/carta/plugins/blob/797077220ed39d3113d8f6af8f6ac10201f3a86a/plugins/carta-crm/skills/enrich-company/SKILL.md"
            },
            {
              "name": "get-angles",
              "sourceUrl": "https://github.com/carta/plugins/blob/797077220ed39d3113d8f6af8f6ac10201f3a86a/plugins/carta-crm/skills/get-angles/SKILL.md"
            },
            {
              "name": "home",
              "sourceUrl": "https://github.com/carta/plugins/blob/797077220ed39d3113d8f6af8f6ac10201f3a86a/plugins/carta-crm/skills/home/SKILL.md"
            },
            {
              "name": "prepare-for-meeting",
              "sourceUrl": "https://github.com/carta/plugins/blob/797077220ed39d3113d8f6af8f6ac10201f3a86a/plugins/carta-crm/skills/prepare-for-meeting/SKILL.md"
            },
            {
              "name": "search-companies",
              "sourceUrl": "https://github.com/carta/plugins/blob/797077220ed39d3113d8f6af8f6ac10201f3a86a/plugins/carta-crm/skills/search-companies/SKILL.md"
            },
            {
              "name": "search-contacts",
              "sourceUrl": "https://github.com/carta/plugins/blob/797077220ed39d3113d8f6af8f6ac10201f3a86a/plugins/carta-crm/skills/search-contacts/SKILL.md"
            },
            {
              "name": "search-deals",
              "sourceUrl": "https://github.com/carta/plugins/blob/797077220ed39d3113d8f6af8f6ac10201f3a86a/plugins/carta-crm/skills/search-deals/SKILL.md"
            },
            {
              "name": "search-fundraisings",
              "sourceUrl": "https://github.com/carta/plugins/blob/797077220ed39d3113d8f6af8f6ac10201f3a86a/plugins/carta-crm/skills/search-fundraisings/SKILL.md"
            },
            {
              "name": "search-investors",
              "sourceUrl": "https://github.com/carta/plugins/blob/797077220ed39d3113d8f6af8f6ac10201f3a86a/plugins/carta-crm/skills/search-investors/SKILL.md"
            },
            {
              "name": "search-notes",
              "sourceUrl": "https://github.com/carta/plugins/blob/797077220ed39d3113d8f6af8f6ac10201f3a86a/plugins/carta-crm/skills/search-notes/SKILL.md"
            },
            {
              "name": "search-reports",
              "sourceUrl": "https://github.com/carta/plugins/blob/797077220ed39d3113d8f6af8f6ac10201f3a86a/plugins/carta-crm/skills/search-reports/SKILL.md"
            },
            {
              "name": "tutorial",
              "sourceUrl": "https://github.com/carta/plugins/blob/797077220ed39d3113d8f6af8f6ac10201f3a86a/plugins/carta-crm/skills/tutorial/SKILL.md"
            },
            {
              "name": "update-company",
              "sourceUrl": "https://github.com/carta/plugins/blob/797077220ed39d3113d8f6af8f6ac10201f3a86a/plugins/carta-crm/skills/update-company/SKILL.md"
            },
            {
              "name": "update-contact",
              "sourceUrl": "https://github.com/carta/plugins/blob/797077220ed39d3113d8f6af8f6ac10201f3a86a/plugins/carta-crm/skills/update-contact/SKILL.md"
            },
            {
              "name": "update-deal",
              "sourceUrl": "https://github.com/carta/plugins/blob/797077220ed39d3113d8f6af8f6ac10201f3a86a/plugins/carta-crm/skills/update-deal/SKILL.md"
            },
            {
              "name": "update-fundraising",
              "sourceUrl": "https://github.com/carta/plugins/blob/797077220ed39d3113d8f6af8f6ac10201f3a86a/plugins/carta-crm/skills/update-fundraising/SKILL.md"
            },
            {
              "name": "update-investor",
              "sourceUrl": "https://github.com/carta/plugins/blob/797077220ed39d3113d8f6af8f6ac10201f3a86a/plugins/carta-crm/skills/update-investor/SKILL.md"
            },
            {
              "name": "update-note",
              "sourceUrl": "https://github.com/carta/plugins/blob/797077220ed39d3113d8f6af8f6ac10201f3a86a/plugins/carta-crm/skills/update-note/SKILL.md"
            }
          ],
          "mcpServers": [],
          "components": ["skills", "hooks"],
          "componentInspection": "repository",
          "inspectionError": null,
          "installation": "requires_adapter",
          "upstream": {
            "source": {
              "source": "git-subdir",
              "url": "https://github.com/carta/plugins.git",
              "path": "plugins/carta-crm",
              "ref": "main",
              "sha": "797077220ed39d3113d8f6af8f6ac10201f3a86a"
            },
            "policy": null
          }
        },
        {
          "id": "anthropic:carta-investors",
          "name": "carta-investors",
          "displayName": "carta-investors",
          "description": "Carta Investors plugin — write-capable skills for querying and updating investors data, performance benchmarks, regulatory reporting, AGM deck generation, brand extraction, and more via the Carta MCP server",
          "longDescription": "Carta Investors plugin — write-capable skills for querying and updating investors data, performance benchmarks, regulatory reporting, AGM deck generation, brand extraction, and more via the Carta MCP server",
          "category": "productivity",
          "keywords": [
            "investors",
            "mcp",
            "carta",
            "write",
            "write-capable",
            "agm",
            "annual-general-meeting",
            "deck",
            "presentation",
            "brand",
            "brand-board",
            "pdf",
            "pptx"
          ],
          "author": {
            "name": "Carta",
            "email": "engineering@carta.com"
          },
          "version": "5.6.5",
          "license": null,
          "logoUrl": null,
          "darkLogoUrl": null,
          "homepage": "https://github.com/carta/plugins",
          "sourceUrl": "https://github.com/carta/plugins/tree/3aac6aebe11080a469e92935a544e02ed7aa0702/plugins/carta-investors",
          "skills": [
            {
              "name": "carta-agm-deck-builder",
              "sourceUrl": "https://github.com/carta/plugins/blob/3aac6aebe11080a469e92935a544e02ed7aa0702/plugins/carta-investors/skills/carta-agm-deck-builder/SKILL.md"
            },
            {
              "name": "carta-brand-extraction",
              "sourceUrl": "https://github.com/carta/plugins/blob/3aac6aebe11080a469e92935a544e02ed7aa0702/plugins/carta-investors/skills/carta-brand-extraction/SKILL.md"
            },
            {
              "name": "carta-co-investors",
              "sourceUrl": "https://github.com/carta/plugins/blob/3aac6aebe11080a469e92935a544e02ed7aa0702/plugins/carta-investors/skills/carta-co-investors/SKILL.md"
            },
            {
              "name": "carta-compliance-routing",
              "sourceUrl": "https://github.com/carta/plugins/blob/3aac6aebe11080a469e92935a544e02ed7aa0702/plugins/carta-investors/skills/carta-compliance-routing/SKILL.md"
            },
            {
              "name": "carta-consolidating-balance-sheet",
              "sourceUrl": "https://github.com/carta/plugins/blob/3aac6aebe11080a469e92935a544e02ed7aa0702/plugins/carta-investors/skills/carta-consolidating-balance-sheet/SKILL.md"
            },
            {
              "name": "carta-consolidating-pnl",
              "sourceUrl": "https://github.com/carta/plugins/blob/3aac6aebe11080a469e92935a544e02ed7aa0702/plugins/carta-investors/skills/carta-consolidating-pnl/SKILL.md"
            },
            {
              "name": "carta-download-tearsheet",
              "sourceUrl": "https://github.com/carta/plugins/blob/3aac6aebe11080a469e92935a544e02ed7aa0702/plugins/carta-investors/skills/carta-download-tearsheet/SKILL.md"
            },
            {
              "name": "carta-explore-data",
              "sourceUrl": "https://github.com/carta/plugins/blob/3aac6aebe11080a469e92935a544e02ed7aa0702/plugins/carta-investors/skills/carta-explore-data/SKILL.md"
            },
            {
              "name": "carta-fund-admin-requests",
              "sourceUrl": "https://github.com/carta/plugins/blob/3aac6aebe11080a469e92935a544e02ed7aa0702/plugins/carta-investors/skills/carta-fund-admin-requests/SKILL.md"
            },
            {
              "name": "carta-fund-forecasting",
              "sourceUrl": "https://github.com/carta/plugins/blob/3aac6aebe11080a469e92935a544e02ed7aa0702/plugins/carta-investors/skills/carta-fund-forecasting/SKILL.md"
            },
            {
              "name": "carta-fund-modeling",
              "sourceUrl": "https://github.com/carta/plugins/blob/3aac6aebe11080a469e92935a544e02ed7aa0702/plugins/carta-investors/skills/carta-fund-modeling/SKILL.md"
            },
            {
              "name": "carta-home-build",
              "sourceUrl": "https://github.com/carta/plugins/blob/3aac6aebe11080a469e92935a544e02ed7aa0702/plugins/carta-investors/skills/carta-home-build/SKILL.md"
            },
            {
              "name": "carta-manco",
              "sourceUrl": "https://github.com/carta/plugins/blob/3aac6aebe11080a469e92935a544e02ed7aa0702/plugins/carta-investors/skills/carta-manco/SKILL.md"
            },
            {
              "name": "carta-portfolio-analytics-routing",
              "sourceUrl": "https://github.com/carta/plugins/blob/3aac6aebe11080a469e92935a544e02ed7aa0702/plugins/carta-investors/skills/carta-portfolio-analytics-routing/SKILL.md"
            },
            {
              "name": "carta-spa-audit",
              "sourceUrl": "https://github.com/carta/plugins/blob/3aac6aebe11080a469e92935a544e02ed7aa0702/plugins/carta-investors/skills/carta-spa-audit/SKILL.md"
            },
            {
              "name": "carta-workhub-build",
              "sourceUrl": "https://github.com/carta/plugins/blob/3aac6aebe11080a469e92935a544e02ed7aa0702/plugins/carta-investors/skills/carta-workhub-build/SKILL.md"
            }
          ],
          "mcpServers": [],
          "components": ["skills", "hooks"],
          "componentInspection": "repository",
          "inspectionError": null,
          "installation": "requires_adapter",
          "upstream": {
            "source": {
              "source": "git-subdir",
              "url": "https://github.com/carta/plugins.git",
              "path": "plugins/carta-investors",
              "ref": "main",
              "sha": "3aac6aebe11080a469e92935a544e02ed7aa0702"
            },
            "policy": null
          }
        },
        {
          "id": "anthropic:catalyst-by-zoho",
          "name": "catalyst-by-zoho",
          "displayName": "catalyst-by-zoho",
          "description": "Official Claude Code plugin for Catalyst by Zoho — full-stack serverless cloud platform. With Skills that covers all services, SDKs, CLI, architecture patterns, pricing, migration guides, and Zoho MCP tool-based resource management.",
          "longDescription": "Official Claude Code plugin for Catalyst by Zoho — full-stack serverless cloud platform. With Skills that covers all services, SDKs, CLI, architecture patterns, pricing, migration guides, and Zoho MCP tool-based resource management.",
          "category": "development",
          "keywords": [
            "catalyst",
            "zoho",
            "mcp",
            "serverless",
            "cloud",
            "datastore",
            "zcql",
            "appsail",
            "stratus",
            "functions"
          ],
          "author": {
            "name": "Catalyst by Zoho",
            "url": "https://catalyst.zoho.com/"
          },
          "version": "0.0.2",
          "license": "Apache-2.0",
          "logoUrl": null,
          "darkLogoUrl": null,
          "homepage": "https://github.com/catalystbyzoho/claude-plugin",
          "sourceUrl": "https://github.com/catalystbyzoho/claude-plugin/tree/9670b79d72fe4923cc845ca0414d009ef3684ccb/",
          "skills": [
            {
              "name": "catalyst-appsail",
              "sourceUrl": "https://github.com/catalystbyzoho/claude-plugin/blob/9670b79d72fe4923cc845ca0414d009ef3684ccb/skills/catalyst-appsail/SKILL.md"
            },
            {
              "name": "catalyst-authentication",
              "sourceUrl": "https://github.com/catalystbyzoho/claude-plugin/blob/9670b79d72fe4923cc845ca0414d009ef3684ccb/skills/catalyst-authentication/SKILL.md"
            },
            {
              "name": "catalyst-basics",
              "sourceUrl": "https://github.com/catalystbyzoho/claude-plugin/blob/9670b79d72fe4923cc845ca0414d009ef3684ccb/skills/catalyst-basics/SKILL.md"
            },
            {
              "name": "catalyst-by-zoho",
              "sourceUrl": "https://github.com/catalystbyzoho/claude-plugin/blob/9670b79d72fe4923cc845ca0414d009ef3684ccb/skills/catalyst-by-zoho/SKILL.md"
            },
            {
              "name": "catalyst-cache",
              "sourceUrl": "https://github.com/catalystbyzoho/claude-plugin/blob/9670b79d72fe4923cc845ca0414d009ef3684ccb/skills/catalyst-cache/SKILL.md"
            },
            {
              "name": "catalyst-datastore",
              "sourceUrl": "https://github.com/catalystbyzoho/claude-plugin/blob/9670b79d72fe4923cc845ca0414d009ef3684ccb/skills/catalyst-datastore/SKILL.md"
            },
            {
              "name": "catalyst-functions",
              "sourceUrl": "https://github.com/catalystbyzoho/claude-plugin/blob/9670b79d72fe4923cc845ca0414d009ef3684ccb/skills/catalyst-functions/SKILL.md"
            },
            {
              "name": "catalyst-nosql",
              "sourceUrl": "https://github.com/catalystbyzoho/claude-plugin/blob/9670b79d72fe4923cc845ca0414d009ef3684ccb/skills/catalyst-nosql/SKILL.md"
            },
            {
              "name": "catalyst-pricing",
              "sourceUrl": "https://github.com/catalystbyzoho/claude-plugin/blob/9670b79d72fe4923cc845ca0414d009ef3684ccb/skills/catalyst-pricing/SKILL.md"
            },
            {
              "name": "catalyst-sdk",
              "sourceUrl": "https://github.com/catalystbyzoho/claude-plugin/blob/9670b79d72fe4923cc845ca0414d009ef3684ccb/skills/catalyst-sdk/SKILL.md"
            },
            {
              "name": "catalyst-signals",
              "sourceUrl": "https://github.com/catalystbyzoho/claude-plugin/blob/9670b79d72fe4923cc845ca0414d009ef3684ccb/skills/catalyst-signals/SKILL.md"
            },
            {
              "name": "catalyst-slate",
              "sourceUrl": "https://github.com/catalystbyzoho/claude-plugin/blob/9670b79d72fe4923cc845ca0414d009ef3684ccb/skills/catalyst-slate/SKILL.md"
            },
            {
              "name": "catalyst-smartbrowz",
              "sourceUrl": "https://github.com/catalystbyzoho/claude-plugin/blob/9670b79d72fe4923cc845ca0414d009ef3684ccb/skills/catalyst-smartbrowz/SKILL.md"
            },
            {
              "name": "catalyst-stratus",
              "sourceUrl": "https://github.com/catalystbyzoho/claude-plugin/blob/9670b79d72fe4923cc845ca0414d009ef3684ccb/skills/catalyst-stratus/SKILL.md"
            },
            {
              "name": "catalyst-zia",
              "sourceUrl": "https://github.com/catalystbyzoho/claude-plugin/blob/9670b79d72fe4923cc845ca0414d009ef3684ccb/skills/catalyst-zia/SKILL.md"
            },
            {
              "name": "catalyst-zoho-mcp",
              "sourceUrl": "https://github.com/catalystbyzoho/claude-plugin/blob/9670b79d72fe4923cc845ca0414d009ef3684ccb/skills/catalyst-zoho-mcp/SKILL.md"
            }
          ],
          "mcpServers": [
            {
              "requiresConfiguration": false,
              "name": "catalyst-by-zoho",
              "transport": "streamable-http",
              "endpoint": "https://catalyst.zohomcp.com/mcp/message"
            }
          ],
          "components": ["skills", "mcp", "hooks", "commands"],
          "componentInspection": "repository",
          "inspectionError": null,
          "installation": "requires_adapter",
          "upstream": {
            "source": {
              "source": "url",
              "url": "https://github.com/catalystbyzoho/claude-plugin.git",
              "sha": "9670b79d72fe4923cc845ca0414d009ef3684ccb"
            },
            "policy": null
          }
        },
        {
          "id": "anthropic:cds-mcp",
          "name": "cds-mcp",
          "displayName": "cds-mcp",
          "description": "Model Context Protocol (MCP) server for AI-assisted development of CAP applications.",
          "longDescription": "Model Context Protocol (MCP) server for AI-assisted development of CAP applications.",
          "category": "development",
          "keywords": ["sap", "cap", "cds", "mcp"],
          "author": {
            "name": "SAP SE"
          },
          "version": "0.0.5",
          "license": "Apache-2.0",
          "logoUrl": null,
          "darkLogoUrl": null,
          "homepage": "https://cap.cloud.sap/",
          "sourceUrl": "https://github.com/cap-js/mcp-server/tree/644bf4a132313cf506b2ae11ac51db9123198af3/",
          "skills": [],
          "mcpServers": [
            {
              "requiresConfiguration": false,
              "name": "cds-mcp",
              "transport": "stdio",
              "endpoint": null
            }
          ],
          "components": ["mcp"],
          "componentInspection": "repository",
          "inspectionError": null,
          "installation": "requires_adapter",
          "upstream": {
            "source": {
              "source": "url",
              "url": "https://github.com/cap-js/mcp-server.git",
              "sha": "644bf4a132313cf506b2ae11ac51db9123198af3"
            },
            "policy": null
          }
        },
        {
          "id": "anthropic:chrome-devtools-mcp",
          "name": "chrome-devtools-mcp",
          "displayName": "chrome-devtools-mcp",
          "description": "Reliable automation, in-depth debugging, and performance analysis in Chrome using Chrome DevTools and Puppeteer",
          "longDescription": "Reliable automation, in-depth debugging, and performance analysis in Chrome using Chrome DevTools and Puppeteer",
          "category": "development",
          "keywords": [],
          "author": null,
          "version": "1.8.0",
          "license": null,
          "logoUrl": null,
          "darkLogoUrl": null,
          "homepage": "https://github.com/ChromeDevTools/chrome-devtools-mcp",
          "sourceUrl": "https://github.com/ChromeDevTools/chrome-devtools-mcp/tree/45f187b1e3202c9f32ddba913be5d68751c3caa3/",
          "skills": [
            {
              "name": "a11y-debugging",
              "sourceUrl": "https://github.com/ChromeDevTools/chrome-devtools-mcp/blob/45f187b1e3202c9f32ddba913be5d68751c3caa3/skills/a11y-debugging/SKILL.md"
            },
            {
              "name": "chrome-devtools-cli",
              "sourceUrl": "https://github.com/ChromeDevTools/chrome-devtools-mcp/blob/45f187b1e3202c9f32ddba913be5d68751c3caa3/skills/chrome-devtools-cli/SKILL.md"
            },
            {
              "name": "chrome-devtools",
              "sourceUrl": "https://github.com/ChromeDevTools/chrome-devtools-mcp/blob/45f187b1e3202c9f32ddba913be5d68751c3caa3/skills/chrome-devtools/SKILL.md"
            },
            {
              "name": "debug-optimize-lcp",
              "sourceUrl": "https://github.com/ChromeDevTools/chrome-devtools-mcp/blob/45f187b1e3202c9f32ddba913be5d68751c3caa3/skills/debug-optimize-lcp/SKILL.md"
            },
            {
              "name": "memory-leak-debugging",
              "sourceUrl": "https://github.com/ChromeDevTools/chrome-devtools-mcp/blob/45f187b1e3202c9f32ddba913be5d68751c3caa3/skills/memory-leak-debugging/SKILL.md"
            },
            {
              "name": "troubleshooting",
              "sourceUrl": "https://github.com/ChromeDevTools/chrome-devtools-mcp/blob/45f187b1e3202c9f32ddba913be5d68751c3caa3/skills/troubleshooting/SKILL.md"
            }
          ],
          "mcpServers": [
            {
              "requiresConfiguration": false,
              "name": "chrome-devtools",
              "transport": "stdio",
              "endpoint": null
            }
          ],
          "components": ["skills", "mcp"],
          "componentInspection": "repository",
          "inspectionError": null,
          "installation": "requires_adapter",
          "upstream": {
            "source": {
              "source": "url",
              "url": "https://github.com/ChromeDevTools/chrome-devtools-mcp.git",
              "sha": "45f187b1e3202c9f32ddba913be5d68751c3caa3"
            },
            "policy": null
          }
        },
        {
          "id": "anthropic:circle-skills",
          "name": "circle-skills",
          "displayName": "circle",
          "description": "Ship stablecoin apps faster. Best-practice skills for USDC payments, cross-chain transfers, wallets, and smart contracts — plus Circle's MCP server for real-time SDK and documentation guidance.",
          "longDescription": "Ship stablecoin apps faster. Best-practice skills for USDC payments, cross-chain transfers, wallets, and smart contracts — plus Circle's MCP server for real-time SDK and documentation guidance.",
          "category": "development",
          "keywords": ["usdc", "stablecoin", "circle", "cctp", "wallets", "web3", "payments"],
          "author": {
            "name": "Circle Technology Services"
          },
          "version": "1.4.0",
          "license": "Apache-2.0",
          "logoUrl": null,
          "darkLogoUrl": null,
          "homepage": "https://www.circle.com",
          "sourceUrl": "https://github.com/circlefin/skills/tree/26dc09ea0746a038c969c6f197feee1267f834b5/plugins/circle",
          "skills": [
            {
              "name": "accept-agent-payments",
              "sourceUrl": "https://github.com/circlefin/skills/blob/26dc09ea0746a038c969c6f197feee1267f834b5/plugins/circle/skills/accept-agent-payments/SKILL.md"
            },
            {
              "name": "agent-wallet-policy",
              "sourceUrl": "https://github.com/circlefin/skills/blob/26dc09ea0746a038c969c6f197feee1267f834b5/plugins/circle/skills/agent-wallet-policy/SKILL.md"
            },
            {
              "name": "bridge-stablecoin",
              "sourceUrl": "https://github.com/circlefin/skills/blob/26dc09ea0746a038c969c6f197feee1267f834b5/plugins/circle/skills/bridge-stablecoin/SKILL.md"
            },
            {
              "name": "fund-agent-wallet",
              "sourceUrl": "https://github.com/circlefin/skills/blob/26dc09ea0746a038c969c6f197feee1267f834b5/plugins/circle/skills/fund-agent-wallet/SKILL.md"
            },
            {
              "name": "pay-via-agent-wallet",
              "sourceUrl": "https://github.com/circlefin/skills/blob/26dc09ea0746a038c969c6f197feee1267f834b5/plugins/circle/skills/pay-via-agent-wallet/SKILL.md"
            },
            {
              "name": "recover-eco-funds",
              "sourceUrl": "https://github.com/circlefin/skills/blob/26dc09ea0746a038c969c6f197feee1267f834b5/plugins/circle/skills/recover-eco-funds/SKILL.md"
            },
            {
              "name": "swap-tokens",
              "sourceUrl": "https://github.com/circlefin/skills/blob/26dc09ea0746a038c969c6f197feee1267f834b5/plugins/circle/skills/swap-tokens/SKILL.md"
            },
            {
              "name": "unify-balance",
              "sourceUrl": "https://github.com/circlefin/skills/blob/26dc09ea0746a038c969c6f197feee1267f834b5/plugins/circle/skills/unify-balance/SKILL.md"
            },
            {
              "name": "use-agent-wallet",
              "sourceUrl": "https://github.com/circlefin/skills/blob/26dc09ea0746a038c969c6f197feee1267f834b5/plugins/circle/skills/use-agent-wallet/SKILL.md"
            },
            {
              "name": "use-arc",
              "sourceUrl": "https://github.com/circlefin/skills/blob/26dc09ea0746a038c969c6f197feee1267f834b5/plugins/circle/skills/use-arc/SKILL.md"
            },
            {
              "name": "use-circle-cli",
              "sourceUrl": "https://github.com/circlefin/skills/blob/26dc09ea0746a038c969c6f197feee1267f834b5/plugins/circle/skills/use-circle-cli/SKILL.md"
            },
            {
              "name": "use-circle-wallets",
              "sourceUrl": "https://github.com/circlefin/skills/blob/26dc09ea0746a038c969c6f197feee1267f834b5/plugins/circle/skills/use-circle-wallets/SKILL.md"
            },
            {
              "name": "use-developer-controlled-wallets",
              "sourceUrl": "https://github.com/circlefin/skills/blob/26dc09ea0746a038c969c6f197feee1267f834b5/plugins/circle/skills/use-developer-controlled-wallets/SKILL.md"
            },
            {
              "name": "use-gateway",
              "sourceUrl": "https://github.com/circlefin/skills/blob/26dc09ea0746a038c969c6f197feee1267f834b5/plugins/circle/skills/use-gateway/SKILL.md"
            },
            {
              "name": "use-modular-wallets",
              "sourceUrl": "https://github.com/circlefin/skills/blob/26dc09ea0746a038c969c6f197feee1267f834b5/plugins/circle/skills/use-modular-wallets/SKILL.md"
            },
            {
              "name": "use-smart-contract-platform",
              "sourceUrl": "https://github.com/circlefin/skills/blob/26dc09ea0746a038c969c6f197feee1267f834b5/plugins/circle/skills/use-smart-contract-platform/SKILL.md"
            },
            {
              "name": "use-usdc",
              "sourceUrl": "https://github.com/circlefin/skills/blob/26dc09ea0746a038c969c6f197feee1267f834b5/plugins/circle/skills/use-usdc/SKILL.md"
            },
            {
              "name": "use-user-controlled-wallets",
              "sourceUrl": "https://github.com/circlefin/skills/blob/26dc09ea0746a038c969c6f197feee1267f834b5/plugins/circle/skills/use-user-controlled-wallets/SKILL.md"
            }
          ],
          "mcpServers": [
            {
              "requiresConfiguration": false,
              "name": "circle",
              "transport": "http",
              "endpoint": "https://api.circle.com/v1/codegen/mcp"
            }
          ],
          "components": ["skills", "mcp"],
          "componentInspection": "repository",
          "inspectionError": null,
          "installation": "requires_adapter",
          "upstream": {
            "source": {
              "source": "git-subdir",
              "url": "https://github.com/circlefin/skills.git",
              "path": "plugins/circle",
              "ref": "master",
              "sha": "26dc09ea0746a038c969c6f197feee1267f834b5"
            },
            "policy": null
          }
        },
        {
          "id": "anthropic:circleback",
          "name": "circleback",
          "displayName": "circleback",
          "description": "Circleback conversational context integration. Search and access meetings, emails, calendar events, and more.",
          "longDescription": "Circleback conversational context integration. Search and access meetings, emails, calendar events, and more.",
          "category": "productivity",
          "keywords": [],
          "author": {
            "name": "Circleback"
          },
          "version": "1.0.0",
          "license": null,
          "logoUrl": null,
          "darkLogoUrl": null,
          "homepage": "https://github.com/circlebackai/claude-code-plugin.git",
          "sourceUrl": "https://github.com/circlebackai/claude-code-plugin/tree/a610634c95ab310accf20a0cabdf0fa7ab784fa3/",
          "skills": [],
          "mcpServers": [
            {
              "requiresConfiguration": false,
              "name": "circleback",
              "transport": "http",
              "endpoint": "https://circleback.ai/api/mcp"
            }
          ],
          "components": ["mcp"],
          "componentInspection": "repository",
          "inspectionError": null,
          "installation": "requires_adapter",
          "upstream": {
            "source": {
              "source": "url",
              "url": "https://github.com/circlebackai/claude-code-plugin.git",
              "sha": "a610634c95ab310accf20a0cabdf0fa7ab784fa3"
            },
            "policy": null
          }
        },
        {
          "id": "anthropic:ckeditor",
          "name": "ckeditor",
          "displayName": "ckeditor",
          "description": "Install, configure, and integrate CKEditor 5 (free and premium) in any JavaScript project.",
          "longDescription": "Install, configure, and integrate CKEditor 5 (free and premium) in any JavaScript project.",
          "category": "development",
          "keywords": [
            "ckeditor",
            "ckeditor5",
            "editor",
            "wysiwyg",
            "wysiwyg-editor",
            "rich-text-editor",
            "rich-text",
            "html-editor",
            "text-editor",
            "content-editor",
            "document-editor",
            "word-processor",
            "markdown-editor",
            "contenteditable",
            "react-editor",
            "vue-editor",
            "angular-editor",
            "collaborative-editor",
            "track-changes",
            "ai-writing-assistant"
          ],
          "author": {
            "name": "CKEditor (CKSource)",
            "url": "https://ckeditor.com"
          },
          "version": "0.1.1",
          "license": "MIT",
          "logoUrl": null,
          "darkLogoUrl": null,
          "homepage": "https://github.com/ckeditor/skills",
          "sourceUrl": "https://github.com/ckeditor/skills/tree/9491b46f6628bb2f2a9d81500a0bbae390f6fecd/",
          "skills": [
            {
              "name": "ckeditor",
              "sourceUrl": "https://github.com/ckeditor/skills/blob/9491b46f6628bb2f2a9d81500a0bbae390f6fecd/skills/ckeditor/SKILL.md"
            }
          ],
          "mcpServers": [],
          "components": ["skills"],
          "componentInspection": "repository",
          "inspectionError": null,
          "installation": "requires_adapter",
          "upstream": {
            "source": {
              "source": "url",
              "url": "https://github.com/ckeditor/skills.git",
              "sha": "9491b46f6628bb2f2a9d81500a0bbae390f6fecd"
            },
            "policy": null
          }
        },
        {
          "id": "anthropic:clangd-lsp",
          "name": "clangd-lsp",
          "displayName": "clangd-lsp",
          "description": "C/C++ language server (clangd) for code intelligence",
          "longDescription": "C/C++ language server (clangd) for code intelligence",
          "category": "development",
          "keywords": [],
          "author": {
            "name": "Anthropic",
            "email": "support@anthropic.com"
          },
          "version": "1.0.0",
          "license": null,
          "logoUrl": null,
          "darkLogoUrl": null,
          "homepage": null,
          "sourceUrl": "https://github.com/anthropics/claude-plugins-official/tree/3b600518a637492d37c9877aeb49c2a55d939c04/plugins/clangd-lsp",
          "skills": [],
          "mcpServers": [],
          "components": [],
          "componentInspection": "repository",
          "inspectionError": null,
          "installation": "requires_adapter",
          "upstream": {
            "source": "./plugins/clangd-lsp",
            "policy": null
          }
        },
        {
          "id": "anthropic:claude-code-setup",
          "name": "claude-code-setup",
          "displayName": "claude-code-setup",
          "description": "Analyze codebases and recommend tailored Claude Code automations such as hooks, skills, MCP servers, and subagents.",
          "longDescription": "Analyze codebases and recommend tailored Claude Code automations such as hooks, skills, MCP servers, and subagents.",
          "category": "productivity",
          "keywords": [],
          "author": {
            "name": "Anthropic",
            "email": "support@anthropic.com"
          },
          "version": "1.0.0",
          "license": null,
          "logoUrl": null,
          "darkLogoUrl": null,
          "homepage": "https://github.com/anthropics/claude-plugins-official/tree/main/plugins/claude-code-setup",
          "sourceUrl": "https://github.com/anthropics/claude-plugins-official/tree/3b600518a637492d37c9877aeb49c2a55d939c04/plugins/claude-code-setup",
          "skills": [
            {
              "name": "claude-automation-recommender",
              "sourceUrl": "https://github.com/anthropics/claude-plugins-official/blob/3b600518a637492d37c9877aeb49c2a55d939c04/plugins/claude-code-setup/skills/claude-automation-recommender/SKILL.md"
            }
          ],
          "mcpServers": [],
          "components": ["skills"],
          "componentInspection": "repository",
          "inspectionError": null,
          "installation": "requires_adapter",
          "upstream": {
            "source": "./plugins/claude-code-setup",
            "policy": null
          }
        },
        {
          "id": "anthropic:claude-md-management",
          "name": "claude-md-management",
          "displayName": "claude-md-management",
          "description": "Tools to maintain and improve CLAUDE.md files - audit quality, capture session learnings, and keep project memory current.",
          "longDescription": "Tools to maintain and improve CLAUDE.md files - audit quality, capture session learnings, and keep project memory current.",
          "category": "productivity",
          "keywords": [],
          "author": {
            "name": "Anthropic",
            "email": "support@anthropic.com"
          },
          "version": "1.0.0",
          "license": null,
          "logoUrl": null,
          "darkLogoUrl": null,
          "homepage": "https://github.com/anthropics/claude-plugins-official/tree/main/plugins/claude-md-management",
          "sourceUrl": "https://github.com/anthropics/claude-plugins-official/tree/3b600518a637492d37c9877aeb49c2a55d939c04/plugins/claude-md-management",
          "skills": [
            {
              "name": "claude-md-improver",
              "sourceUrl": "https://github.com/anthropics/claude-plugins-official/blob/3b600518a637492d37c9877aeb49c2a55d939c04/plugins/claude-md-management/skills/claude-md-improver/SKILL.md"
            }
          ],
          "mcpServers": [],
          "components": ["skills", "commands"],
          "componentInspection": "repository",
          "inspectionError": null,
          "installation": "requires_adapter",
          "upstream": {
            "source": "./plugins/claude-md-management",
            "policy": null
          }
        },
        {
          "id": "anthropic:claude-security",
          "name": "claude-security",
          "displayName": "claude-security",
          "description": "Deep vulnerability scanning of your own code, run entirely inside your Claude Code session at a chosen effort tier, with every finding challenged before it is reported and the verification tally computed in code. Turns surviving findings into targeted patches, each verified by a panel of agents, that you apply when you choose. See the plugin README for the tiers, the report format, and the trust model.",
          "longDescription": "Deep vulnerability scanning of your own code, run entirely inside your Claude Code session at a chosen effort tier, with every finding challenged before it is reported and the verification tally computed in code. Turns surviving findings into targeted patches, each verified by a panel of agents, that you apply when you choose. See the plugin README for the tiers, the report format, and the trust model.",
          "category": "security",
          "keywords": [
            "security",
            "vulnerability",
            "scan",
            "audit",
            "appsec",
            "code-review",
            "remediation",
            "autofix"
          ],
          "author": {
            "name": "Anthropic",
            "email": "support@anthropic.com"
          },
          "version": "0.11.0",
          "license": "SEE LICENSE IN LICENSE",
          "logoUrl": null,
          "darkLogoUrl": null,
          "homepage": "https://github.com/anthropics/claude-plugins-official/tree/main/plugins/claude-security",
          "sourceUrl": "https://github.com/anthropics/claude-plugins-official/tree/3b600518a637492d37c9877aeb49c2a55d939c04/plugins/claude-security",
          "skills": [
            {
              "name": "claude-security",
              "sourceUrl": "https://github.com/anthropics/claude-plugins-official/blob/3b600518a637492d37c9877aeb49c2a55d939c04/plugins/claude-security/skills/claude-security/SKILL.md"
            }
          ],
          "mcpServers": [],
          "components": ["skills", "hooks", "agents"],
          "componentInspection": "repository",
          "inspectionError": null,
          "installation": "requires_adapter",
          "upstream": {
            "source": "./plugins/claude-security",
            "policy": null
          }
        },
        {
          "id": "anthropic:clickhouse",
          "name": "clickhouse",
          "displayName": "clickhouse",
          "description": "ClickHouse Claude Code plugin: skills (ClickHouse best practices), rules and MCP.",
          "longDescription": "ClickHouse Claude Code plugin: skills (ClickHouse best practices), rules and MCP.",
          "category": "database",
          "keywords": ["database", "clickhouse", "skills", "mcp", "analytics"],
          "author": {
            "name": "ClickHouse",
            "email": "ai@clickhouse.com"
          },
          "version": "1.0.0",
          "license": "Apache-2.0",
          "logoUrl": null,
          "darkLogoUrl": null,
          "homepage": "https://clickhouse.com",
          "sourceUrl": "https://github.com/ClickHouse/clickhouse-claude-code-plugin/tree/988a7a39834af9c9e14ec3650365243e2cfc6882/",
          "skills": [
            {
              "name": "clickhouse-best-practices",
              "sourceUrl": "https://github.com/ClickHouse/clickhouse-claude-code-plugin/blob/988a7a39834af9c9e14ec3650365243e2cfc6882/skills/clickhouse-best-practices/SKILL.md"
            },
            {
              "name": "setup",
              "sourceUrl": "https://github.com/ClickHouse/clickhouse-claude-code-plugin/blob/988a7a39834af9c9e14ec3650365243e2cfc6882/skills/setup/SKILL.md"
            }
          ],
          "mcpServers": [
            {
              "requiresConfiguration": false,
              "name": "clickhouse",
              "transport": "http",
              "endpoint": "https://mcp.clickhouse.cloud/mcp"
            }
          ],
          "components": ["skills", "mcp"],
          "componentInspection": "repository",
          "inspectionError": null,
          "installation": "requires_adapter",
          "upstream": {
            "source": {
              "source": "url",
              "url": "https://github.com/ClickHouse/clickhouse-claude-code-plugin.git",
              "sha": "988a7a39834af9c9e14ec3650365243e2cfc6882"
            },
            "policy": null
          }
        },
        {
          "id": "anthropic:clickhouse-best-practices",
          "name": "clickhouse-best-practices",
          "displayName": "clickhouse-best-practices",
          "description": "28 best practice rules for ClickHouse schema design, query optimization, and data ingestion — prioritized by impact",
          "longDescription": "28 best practice rules for ClickHouse schema design, query optimization, and data ingestion — prioritized by impact",
          "category": "database",
          "keywords": [
            "clickhouse",
            "database",
            "query-optimization",
            "schema-design",
            "best-practices",
            "data-ingestion"
          ],
          "author": {
            "name": "ClickHouse Inc",
            "url": "https://clickhouse.com"
          },
          "version": "0.3.0",
          "license": "Apache-2.0",
          "logoUrl": null,
          "darkLogoUrl": null,
          "homepage": "https://clickhouse.ai",
          "sourceUrl": "https://github.com/ClickHouse/agent-skills/tree/5aec3114379671f33b1c502a51d420a0729c8172/",
          "skills": [
            {
              "name": "chdb-datastore",
              "sourceUrl": "https://github.com/ClickHouse/agent-skills/blob/5aec3114379671f33b1c502a51d420a0729c8172/skills/chdb-datastore/SKILL.md"
            },
            {
              "name": "chdb-sql",
              "sourceUrl": "https://github.com/ClickHouse/agent-skills/blob/5aec3114379671f33b1c502a51d420a0729c8172/skills/chdb-sql/SKILL.md"
            },
            {
              "name": "clickhouse-architecture-advisor",
              "sourceUrl": "https://github.com/ClickHouse/agent-skills/blob/5aec3114379671f33b1c502a51d420a0729c8172/skills/clickhouse-architecture-advisor/SKILL.md"
            },
            {
              "name": "clickhouse-best-practices",
              "sourceUrl": "https://github.com/ClickHouse/agent-skills/blob/5aec3114379671f33b1c502a51d420a0729c8172/skills/clickhouse-best-practices/SKILL.md"
            },
            {
              "name": "clickhouse-js-node-coding",
              "sourceUrl": "https://github.com/ClickHouse/agent-skills/blob/5aec3114379671f33b1c502a51d420a0729c8172/skills/clickhouse-js-node-coding/SKILL.md"
            },
            {
              "name": "clickhouse-js-node-rowbinary",
              "sourceUrl": "https://github.com/ClickHouse/agent-skills/blob/5aec3114379671f33b1c502a51d420a0729c8172/skills/clickhouse-js-node-rowbinary/SKILL.md"
            },
            {
              "name": "clickhouse-js-node-troubleshooting",
              "sourceUrl": "https://github.com/ClickHouse/agent-skills/blob/5aec3114379671f33b1c502a51d420a0729c8172/skills/clickhouse-js-node-troubleshooting/SKILL.md"
            },
            {
              "name": "clickhouse-managed-postgres-rca",
              "sourceUrl": "https://github.com/ClickHouse/agent-skills/blob/5aec3114379671f33b1c502a51d420a0729c8172/skills/clickhouse-managed-postgres-rca/SKILL.md"
            },
            {
              "name": "clickstack-otel-collector",
              "sourceUrl": "https://github.com/ClickHouse/agent-skills/blob/5aec3114379671f33b1c502a51d420a0729c8172/skills/clickstack-otel-collector/SKILL.md"
            },
            {
              "name": "infra-clickhouse",
              "sourceUrl": "https://github.com/ClickHouse/agent-skills/blob/5aec3114379671f33b1c502a51d420a0729c8172/skills/infra-clickhouse/SKILL.md"
            },
            {
              "name": "infra-postgres",
              "sourceUrl": "https://github.com/ClickHouse/agent-skills/blob/5aec3114379671f33b1c502a51d420a0729c8172/skills/infra-postgres/SKILL.md"
            }
          ],
          "mcpServers": [],
          "components": ["skills"],
          "componentInspection": "repository",
          "inspectionError": null,
          "installation": "requires_adapter",
          "upstream": {
            "source": {
              "source": "url",
              "url": "https://github.com/ClickHouse/agent-skills.git",
              "sha": "5aec3114379671f33b1c502a51d420a0729c8172"
            },
            "policy": null
          }
        },
        {
          "id": "anthropic:cloud-sql-mysql",
          "name": "cloud-sql-mysql",
          "displayName": "cloud-sql-mysql",
          "description": "Connect and interact with a Cloud SQL for MySQL database and data.",
          "longDescription": "Connect and interact with a Cloud SQL for MySQL database and data.",
          "category": "database",
          "keywords": [],
          "author": {
            "name": "Google LLC",
            "email": "data-cloud-ai-integrations@google.com"
          },
          "version": "0.2.0",
          "license": "Apache-2.0",
          "logoUrl": null,
          "darkLogoUrl": null,
          "homepage": "https://cloud.google.com/sql",
          "sourceUrl": "https://github.com/gemini-cli-extensions/cloud-sql-mysql/tree/ed4fbfe3e0cb6770b15b2a66bd1192a684547678/",
          "skills": [],
          "mcpServers": [
            {
              "requiresConfiguration": false,
              "name": "cloud-sql-mysql",
              "transport": "stdio",
              "endpoint": null
            }
          ],
          "components": ["mcp"],
          "componentInspection": "repository",
          "inspectionError": null,
          "installation": "requires_adapter",
          "upstream": {
            "source": {
              "source": "url",
              "url": "https://github.com/gemini-cli-extensions/cloud-sql-mysql.git",
              "sha": "ed4fbfe3e0cb6770b15b2a66bd1192a684547678"
            },
            "policy": null
          }
        },
        {
          "id": "anthropic:cloud-sql-postgresql",
          "name": "cloud-sql-postgresql",
          "displayName": "cloud-sql-postgresql",
          "description": "Create, connect, and interact with a Cloud SQL for PostgreSQL database and data.",
          "longDescription": "Create, connect, and interact with a Cloud SQL for PostgreSQL database and data.",
          "category": "database",
          "keywords": [],
          "author": {
            "name": "Google LLC",
            "email": "data-cloud-ai-integrations@google.com"
          },
          "version": "0.4.0",
          "license": "Apache-2.0",
          "logoUrl": null,
          "darkLogoUrl": null,
          "homepage": "https://cloud.google.com/sql",
          "sourceUrl": "https://github.com/gemini-cli-extensions/cloud-sql-postgresql/tree/6191fb93757355204a5f909d41ad6c9fa2900a83/",
          "skills": [],
          "mcpServers": [
            {
              "requiresConfiguration": false,
              "name": "cloud-sql-postgres",
              "transport": "stdio",
              "endpoint": null
            }
          ],
          "components": ["mcp"],
          "componentInspection": "repository",
          "inspectionError": null,
          "installation": "requires_adapter",
          "upstream": {
            "source": {
              "source": "url",
              "url": "https://github.com/gemini-cli-extensions/cloud-sql-postgresql.git",
              "sha": "6191fb93757355204a5f909d41ad6c9fa2900a83"
            },
            "policy": null
          }
        },
        {
          "id": "anthropic:cloud-sql-sqlserver",
          "name": "cloud-sql-sqlserver",
          "displayName": "cloud-sql-sqlserver",
          "description": "Connect to Cloud SQL for SQL Server",
          "longDescription": "Connect to Cloud SQL for SQL Server",
          "category": "database",
          "keywords": [],
          "author": {
            "name": "Google LLC",
            "email": "data-cloud-ai-integrations@google.com"
          },
          "version": "0.2.0",
          "license": "Apache-2.0",
          "logoUrl": null,
          "darkLogoUrl": null,
          "homepage": "https://cloud.google.com/sql/docs/sqlserver",
          "sourceUrl": "https://github.com/gemini-cli-extensions/cloud-sql-sqlserver/tree/8858b0fd066f1590ab7dad70ceacb1366af86a1f/",
          "skills": [],
          "mcpServers": [
            {
              "requiresConfiguration": false,
              "name": "cloud-sql-mssql",
              "transport": "stdio",
              "endpoint": null
            }
          ],
          "components": ["mcp"],
          "componentInspection": "repository",
          "inspectionError": null,
          "installation": "requires_adapter",
          "upstream": {
            "source": {
              "source": "url",
              "url": "https://github.com/gemini-cli-extensions/cloud-sql-sqlserver.git",
              "sha": "8858b0fd066f1590ab7dad70ceacb1366af86a1f"
            },
            "policy": null
          }
        },
        {
          "id": "anthropic:cloudflare",
          "name": "cloudflare",
          "displayName": "cloudflare",
          "description": "Build, test, and deploy applications on Cloudflare with platform guidance Skills and the Cloudflare MCP server.",
          "longDescription": "Build, test, and deploy applications on Cloudflare with platform guidance Skills and the Cloudflare MCP server.",
          "category": "deployment",
          "keywords": [],
          "author": {
            "name": "Cloudflare"
          },
          "version": "1.0.0",
          "license": null,
          "logoUrl": null,
          "darkLogoUrl": null,
          "homepage": "https://github.com/cloudflare/skills",
          "sourceUrl": "https://github.com/cloudflare/skills/tree/b8aeca6d7e2d614d7bd0e5220c8dd7645fe58a93/",
          "skills": [
            {
              "name": "agents-sdk",
              "sourceUrl": "https://github.com/cloudflare/skills/blob/b8aeca6d7e2d614d7bd0e5220c8dd7645fe58a93/skills/agents-sdk/SKILL.md"
            },
            {
              "name": "cloudflare-email-service",
              "sourceUrl": "https://github.com/cloudflare/skills/blob/b8aeca6d7e2d614d7bd0e5220c8dd7645fe58a93/skills/cloudflare-email-service/SKILL.md"
            },
            {
              "name": "cloudflare-one-migrations",
              "sourceUrl": "https://github.com/cloudflare/skills/blob/b8aeca6d7e2d614d7bd0e5220c8dd7645fe58a93/skills/cloudflare-one-migrations/SKILL.md"
            },
            {
              "name": "cloudflare-one",
              "sourceUrl": "https://github.com/cloudflare/skills/blob/b8aeca6d7e2d614d7bd0e5220c8dd7645fe58a93/skills/cloudflare-one/SKILL.md"
            },
            {
              "name": "cloudflare",
              "sourceUrl": "https://github.com/cloudflare/skills/blob/b8aeca6d7e2d614d7bd0e5220c8dd7645fe58a93/skills/cloudflare/SKILL.md"
            },
            {
              "name": "durable-objects",
              "sourceUrl": "https://github.com/cloudflare/skills/blob/b8aeca6d7e2d614d7bd0e5220c8dd7645fe58a93/skills/durable-objects/SKILL.md"
            },
            {
              "name": "sandbox-migrate-to-next",
              "sourceUrl": "https://github.com/cloudflare/skills/blob/b8aeca6d7e2d614d7bd0e5220c8dd7645fe58a93/skills/sandbox-migrate-to-next/SKILL.md"
            },
            {
              "name": "sandbox-next",
              "sourceUrl": "https://github.com/cloudflare/skills/blob/b8aeca6d7e2d614d7bd0e5220c8dd7645fe58a93/skills/sandbox-next/SKILL.md"
            },
            {
              "name": "sandbox-stable",
              "sourceUrl": "https://github.com/cloudflare/skills/blob/b8aeca6d7e2d614d7bd0e5220c8dd7645fe58a93/skills/sandbox-stable/SKILL.md"
            },
            {
              "name": "turnstile-spin",
              "sourceUrl": "https://github.com/cloudflare/skills/blob/b8aeca6d7e2d614d7bd0e5220c8dd7645fe58a93/skills/turnstile-spin/SKILL.md"
            },
            {
              "name": "web-perf",
              "sourceUrl": "https://github.com/cloudflare/skills/blob/b8aeca6d7e2d614d7bd0e5220c8dd7645fe58a93/skills/web-perf/SKILL.md"
            },
            {
              "name": "workers-best-practices",
              "sourceUrl": "https://github.com/cloudflare/skills/blob/b8aeca6d7e2d614d7bd0e5220c8dd7645fe58a93/skills/workers-best-practices/SKILL.md"
            },
            {
              "name": "wrangler",
              "sourceUrl": "https://github.com/cloudflare/skills/blob/b8aeca6d7e2d614d7bd0e5220c8dd7645fe58a93/skills/wrangler/SKILL.md"
            }
          ],
          "mcpServers": [
            {
              "requiresConfiguration": false,
              "name": "cloudflare",
              "transport": "http",
              "endpoint": "https://mcp.cloudflare.com/mcp"
            }
          ],
          "components": ["skills", "mcp", "commands"],
          "componentInspection": "repository",
          "inspectionError": null,
          "installation": "requires_adapter",
          "upstream": {
            "source": {
              "source": "url",
              "url": "https://github.com/cloudflare/skills.git",
              "sha": "b8aeca6d7e2d614d7bd0e5220c8dd7645fe58a93"
            },
            "policy": null
          }
        },
        {
          "id": "anthropic:cloudinary",
          "name": "cloudinary",
          "displayName": "cloudinary",
          "description": "Use Cloudinary directly in Claude. Upload, manage, optimize, and transform images and videos at scale using natural language.",
          "longDescription": "Use Cloudinary directly in Claude. Upload, manage, optimize, and transform images and videos at scale using natural language.",
          "category": null,
          "keywords": [
            "cloudinary",
            "media",
            "images",
            "video",
            "transformations",
            "asset-management",
            "optimization",
            "mcp"
          ],
          "author": {
            "name": "Cloudinary",
            "email": "support@cloudinary.com"
          },
          "version": "1.2.0",
          "license": "MIT",
          "logoUrl": null,
          "darkLogoUrl": null,
          "homepage": "https://cloudinary.com",
          "sourceUrl": "https://github.com/cloudinary-devs/cloudinary-plugin/tree/86be53409e3fb1c465cd5ff4d1dc937a2860f45c/",
          "skills": [
            {
              "name": "claimable-cloud",
              "sourceUrl": "https://github.com/cloudinary-devs/cloudinary-plugin/blob/86be53409e3fb1c465cd5ff4d1dc937a2860f45c/skills/claimable-cloud/SKILL.md"
            },
            {
              "name": "cloudinary-docs",
              "sourceUrl": "https://github.com/cloudinary-devs/cloudinary-plugin/blob/86be53409e3fb1c465cd5ff4d1dc937a2860f45c/skills/cloudinary-docs/SKILL.md"
            },
            {
              "name": "cloudinary-transformations",
              "sourceUrl": "https://github.com/cloudinary-devs/cloudinary-plugin/blob/86be53409e3fb1c465cd5ff4d1dc937a2860f45c/skills/cloudinary-transformations/SKILL.md"
            }
          ],
          "mcpServers": [],
          "components": ["skills", "mcp"],
          "componentInspection": "repository",
          "inspectionError": null,
          "installation": "requires_adapter",
          "upstream": {
            "source": {
              "source": "url",
              "url": "https://github.com/cloudinary-devs/cloudinary-plugin.git",
              "sha": "86be53409e3fb1c465cd5ff4d1dc937a2860f45c"
            },
            "policy": null
          }
        },
        {
          "id": "anthropic:cockroachdb",
          "name": "cockroachdb",
          "displayName": "cockroachdb",
          "description": "Connect Claude Code directly to your CockroachDB clusters for hands-on database work — explore schemas, write optimized SQL, debug queries, and manage distributed database clusters. This plugin provides tools across MCP backends (self-hosted MCP Toolbox and managed CockroachDB Cloud MCP Server), specialized agents (DBA, Developer, Operator), skills across operational domains, and built-in safety hooks.",
          "longDescription": "Connect Claude Code directly to your CockroachDB clusters for hands-on database work — explore schemas, write optimized SQL, debug queries, and manage distributed database clusters. This plugin provides tools across MCP backends (self-hosted MCP Toolbox and managed CockroachDB Cloud MCP Server), specialized agents (DBA, Developer, Operator), skills across operational domains, and built-in safety hooks.",
          "category": "database",
          "keywords": [
            "cockroachdb",
            "database",
            "sql",
            "distributed-sql",
            "postgres-compatible",
            "mcp",
            "schema",
            "migration",
            "multi-region"
          ],
          "author": {
            "name": "Cockroach Labs",
            "url": "https://github.com/cockroachdb"
          },
          "version": "0.1.10",
          "license": "Apache-2.0",
          "logoUrl": null,
          "darkLogoUrl": null,
          "homepage": "https://github.com/cockroachdb/claude-plugin",
          "sourceUrl": "https://github.com/cockroachdb/claude-plugin/tree/6c96c6394a61f366e8ec1b7cec2281e97507cbff/",
          "skills": [
            {
              "name": "benchmarking-transaction-patterns",
              "sourceUrl": "https://github.com/cockroachdb/claude-plugin/blob/6c96c6394a61f366e8ec1b7cec2281e97507cbff/skills/cockroachdb-application-development/benchmarking-transaction-patterns/SKILL.md"
            },
            {
              "name": "designing-application-transactions",
              "sourceUrl": "https://github.com/cockroachdb/claude-plugin/blob/6c96c6394a61f366e8ec1b7cec2281e97507cbff/skills/cockroachdb-application-development/designing-application-transactions/SKILL.md"
            },
            {
              "name": "designing-multi-region-applications",
              "sourceUrl": "https://github.com/cockroachdb/claude-plugin/blob/6c96c6394a61f366e8ec1b7cec2281e97507cbff/skills/cockroachdb-application-development/designing-multi-region-applications/SKILL.md"
            },
            {
              "name": "analyzing-range-distribution",
              "sourceUrl": "https://github.com/cockroachdb/claude-plugin/blob/6c96c6394a61f366e8ec1b7cec2281e97507cbff/skills/cockroachdb-observability-and-diagnostics/analyzing-range-distribution/SKILL.md"
            },
            {
              "name": "analyzing-schema-change-storage-risk",
              "sourceUrl": "https://github.com/cockroachdb/claude-plugin/blob/6c96c6394a61f366e8ec1b7cec2281e97507cbff/skills/cockroachdb-observability-and-diagnostics/analyzing-schema-change-storage-risk/SKILL.md"
            },
            {
              "name": "auditing-table-statistics",
              "sourceUrl": "https://github.com/cockroachdb/claude-plugin/blob/6c96c6394a61f366e8ec1b7cec2281e97507cbff/skills/cockroachdb-observability-and-diagnostics/auditing-table-statistics/SKILL.md"
            },
            {
              "name": "monitoring-background-jobs",
              "sourceUrl": "https://github.com/cockroachdb/claude-plugin/blob/6c96c6394a61f366e8ec1b7cec2281e97507cbff/skills/cockroachdb-observability-and-diagnostics/monitoring-background-jobs/SKILL.md"
            },
            {
              "name": "profiling-statement-fingerprints",
              "sourceUrl": "https://github.com/cockroachdb/claude-plugin/blob/6c96c6394a61f366e8ec1b7cec2281e97507cbff/skills/cockroachdb-observability-and-diagnostics/profiling-statement-fingerprints/SKILL.md"
            },
            {
              "name": "profiling-transaction-fingerprints",
              "sourceUrl": "https://github.com/cockroachdb/claude-plugin/blob/6c96c6394a61f366e8ec1b7cec2281e97507cbff/skills/cockroachdb-observability-and-diagnostics/profiling-transaction-fingerprints/SKILL.md"
            },
            {
              "name": "triaging-live-sql-activity",
              "sourceUrl": "https://github.com/cockroachdb/claude-plugin/blob/6c96c6394a61f366e8ec1b7cec2281e97507cbff/skills/cockroachdb-observability-and-diagnostics/triaging-live-sql-activity/SKILL.md"
            },
            {
              "name": "molt-fetch",
              "sourceUrl": "https://github.com/cockroachdb/claude-plugin/blob/6c96c6394a61f366e8ec1b7cec2281e97507cbff/skills/cockroachdb-onboarding-and-migrations/molt-fetch/SKILL.md"
            },
            {
              "name": "molt-replicator",
              "sourceUrl": "https://github.com/cockroachdb/claude-plugin/blob/6c96c6394a61f366e8ec1b7cec2281e97507cbff/skills/cockroachdb-onboarding-and-migrations/molt-replicator/SKILL.md"
            },
            {
              "name": "molt-verify",
              "sourceUrl": "https://github.com/cockroachdb/claude-plugin/blob/6c96c6394a61f366e8ec1b7cec2281e97507cbff/skills/cockroachdb-onboarding-and-migrations/molt-verify/SKILL.md"
            },
            {
              "name": "setting-up-local-cluster",
              "sourceUrl": "https://github.com/cockroachdb/claude-plugin/blob/6c96c6394a61f366e8ec1b7cec2281e97507cbff/skills/cockroachdb-onboarding-and-migrations/setting-up-local-cluster/SKILL.md"
            },
            {
              "name": "managing-certificates-and-encryption",
              "sourceUrl": "https://github.com/cockroachdb/claude-plugin/blob/6c96c6394a61f366e8ec1b7cec2281e97507cbff/skills/cockroachdb-operations-and-lifecycle/managing-certificates-and-encryption/SKILL.md"
            },
            {
              "name": "managing-cluster-capacity",
              "sourceUrl": "https://github.com/cockroachdb/claude-plugin/blob/6c96c6394a61f366e8ec1b7cec2281e97507cbff/skills/cockroachdb-operations-and-lifecycle/managing-cluster-capacity/SKILL.md"
            },
            {
              "name": "managing-cluster-settings",
              "sourceUrl": "https://github.com/cockroachdb/claude-plugin/blob/6c96c6394a61f366e8ec1b7cec2281e97507cbff/skills/cockroachdb-operations-and-lifecycle/managing-cluster-settings/SKILL.md"
            },
            {
              "name": "performing-cluster-maintenance",
              "sourceUrl": "https://github.com/cockroachdb/claude-plugin/blob/6c96c6394a61f366e8ec1b7cec2281e97507cbff/skills/cockroachdb-operations-and-lifecycle/performing-cluster-maintenance/SKILL.md"
            },
            {
              "name": "provisioning-cluster-for-production",
              "sourceUrl": "https://github.com/cockroachdb/claude-plugin/blob/6c96c6394a61f366e8ec1b7cec2281e97507cbff/skills/cockroachdb-operations-and-lifecycle/provisioning-cluster-for-production/SKILL.md"
            },
            {
              "name": "reviewing-cluster-health",
              "sourceUrl": "https://github.com/cockroachdb/claude-plugin/blob/6c96c6394a61f366e8ec1b7cec2281e97507cbff/skills/cockroachdb-operations-and-lifecycle/reviewing-cluster-health/SKILL.md"
            },
            {
              "name": "upgrading-cluster-version",
              "sourceUrl": "https://github.com/cockroachdb/claude-plugin/blob/6c96c6394a61f366e8ec1b7cec2281e97507cbff/skills/cockroachdb-operations-and-lifecycle/upgrading-cluster-version/SKILL.md"
            },
            {
              "name": "cockroachdb-sql",
              "sourceUrl": "https://github.com/cockroachdb/claude-plugin/blob/6c96c6394a61f366e8ec1b7cec2281e97507cbff/skills/cockroachdb-query-and-schema-design/cockroachdb-sql/SKILL.md"
            },
            {
              "name": "auditing-cis-benchmark",
              "sourceUrl": "https://github.com/cockroachdb/claude-plugin/blob/6c96c6394a61f366e8ec1b7cec2281e97507cbff/skills/cockroachdb-security-and-governance/auditing-cis-benchmark/SKILL.md"
            },
            {
              "name": "auditing-cloud-cluster-security",
              "sourceUrl": "https://github.com/cockroachdb/claude-plugin/blob/6c96c6394a61f366e8ec1b7cec2281e97507cbff/skills/cockroachdb-security-and-governance/auditing-cloud-cluster-security/SKILL.md"
            },
            {
              "name": "configuring-audit-logging",
              "sourceUrl": "https://github.com/cockroachdb/claude-plugin/blob/6c96c6394a61f366e8ec1b7cec2281e97507cbff/skills/cockroachdb-security-and-governance/configuring-audit-logging/SKILL.md"
            },
            {
              "name": "configuring-ip-allowlists",
              "sourceUrl": "https://github.com/cockroachdb/claude-plugin/blob/6c96c6394a61f366e8ec1b7cec2281e97507cbff/skills/cockroachdb-security-and-governance/configuring-ip-allowlists/SKILL.md"
            },
            {
              "name": "configuring-log-export",
              "sourceUrl": "https://github.com/cockroachdb/claude-plugin/blob/6c96c6394a61f366e8ec1b7cec2281e97507cbff/skills/cockroachdb-security-and-governance/configuring-log-export/SKILL.md"
            },
            {
              "name": "configuring-private-connectivity",
              "sourceUrl": "https://github.com/cockroachdb/claude-plugin/blob/6c96c6394a61f366e8ec1b7cec2281e97507cbff/skills/cockroachdb-security-and-governance/configuring-private-connectivity/SKILL.md"
            },
            {
              "name": "configuring-sso-and-scim",
              "sourceUrl": "https://github.com/cockroachdb/claude-plugin/blob/6c96c6394a61f366e8ec1b7cec2281e97507cbff/skills/cockroachdb-security-and-governance/configuring-sso-and-scim/SKILL.md"
            },
            {
              "name": "enabling-cmek-encryption",
              "sourceUrl": "https://github.com/cockroachdb/claude-plugin/blob/6c96c6394a61f366e8ec1b7cec2281e97507cbff/skills/cockroachdb-security-and-governance/enabling-cmek-encryption/SKILL.md"
            },
            {
              "name": "enforcing-password-policies",
              "sourceUrl": "https://github.com/cockroachdb/claude-plugin/blob/6c96c6394a61f366e8ec1b7cec2281e97507cbff/skills/cockroachdb-security-and-governance/enforcing-password-policies/SKILL.md"
            },
            {
              "name": "hardening-user-privileges",
              "sourceUrl": "https://github.com/cockroachdb/claude-plugin/blob/6c96c6394a61f366e8ec1b7cec2281e97507cbff/skills/cockroachdb-security-and-governance/hardening-user-privileges/SKILL.md"
            },
            {
              "name": "managing-tls-certificates",
              "sourceUrl": "https://github.com/cockroachdb/claude-plugin/blob/6c96c6394a61f366e8ec1b7cec2281e97507cbff/skills/cockroachdb-security-and-governance/managing-tls-certificates/SKILL.md"
            },
            {
              "name": "preparing-compliance-documentation",
              "sourceUrl": "https://github.com/cockroachdb/claude-plugin/blob/6c96c6394a61f366e8ec1b7cec2281e97507cbff/skills/cockroachdb-security-and-governance/preparing-compliance-documentation/SKILL.md"
            }
          ],
          "mcpServers": [
            {
              "requiresConfiguration": false,
              "name": "cockroachdb-toolbox",
              "transport": "stdio",
              "endpoint": null
            },
            {
              "requiresConfiguration": false,
              "name": "cockroachdb-toolbox-http",
              "transport": "http",
              "endpoint": "http://127.0.0.1:5000/mcp"
            },
            {
              "requiresConfiguration": true,
              "name": "cockroachdb-cloud",
              "transport": "http",
              "endpoint": "https://cockroachlabs.cloud/mcp"
            }
          ],
          "components": ["skills", "mcp", "hooks", "agents"],
          "componentInspection": "repository",
          "inspectionError": null,
          "installation": "requires_adapter",
          "upstream": {
            "source": {
              "source": "url",
              "url": "https://github.com/cockroachdb/claude-plugin.git",
              "sha": "6c96c6394a61f366e8ec1b7cec2281e97507cbff"
            },
            "policy": null
          }
        },
        {
          "id": "anthropic:code-modernization",
          "name": "code-modernization",
          "displayName": "code-modernization",
          "description": "Modernize legacy codebases (COBOL, legacy Java/C++/.NET, monolith web apps) with a structured preflight / assess / map / extract-rules / brief / (reimagine | transform | uplift) / harden / status workflow. Cross-stack rewrites, greenfield reimagining, and same-stack version uplifts (e.g. .NET Framework → .NET 8); an interactive topology viewer; specialist agents; and optional dynamic-workflow orchestration with adversarial verification.",
          "longDescription": "Modernize legacy codebases (COBOL, legacy Java/C++/.NET, monolith web apps) with a structured preflight / assess / map / extract-rules / brief / (reimagine | transform | uplift) / harden / status workflow. Cross-stack rewrites, greenfield reimagining, and same-stack version uplifts (e.g. .NET Framework → .NET 8); an interactive topology viewer; specialist agents; and optional dynamic-workflow orchestration with adversarial verification.",
          "category": "development",
          "keywords": [],
          "author": {
            "name": "Anthropic",
            "email": "support@anthropic.com"
          },
          "version": null,
          "license": null,
          "logoUrl": null,
          "darkLogoUrl": null,
          "homepage": "https://github.com/anthropics/claude-plugins-official/tree/main/plugins/code-modernization",
          "sourceUrl": "https://github.com/anthropics/claude-plugins-official/tree/3b600518a637492d37c9877aeb49c2a55d939c04/plugins/code-modernization",
          "skills": [],
          "mcpServers": [],
          "components": ["agents", "commands"],
          "componentInspection": "repository",
          "inspectionError": null,
          "installation": "requires_adapter",
          "upstream": {
            "source": "./plugins/code-modernization",
            "policy": null
          }
        },
        {
          "id": "anthropic:code-review",
          "name": "code-review",
          "displayName": "code-review",
          "description": "Automated code review for pull requests using multiple specialized agents with confidence-based scoring",
          "longDescription": "Automated code review for pull requests using multiple specialized agents with confidence-based scoring",
          "category": "productivity",
          "keywords": [],
          "author": {
            "name": "Anthropic",
            "email": "support@anthropic.com"
          },
          "version": null,
          "license": null,
          "logoUrl": null,
          "darkLogoUrl": null,
          "homepage": "https://github.com/anthropics/claude-plugins-public/tree/main/plugins/code-review",
          "sourceUrl": "https://github.com/anthropics/claude-plugins-official/tree/3b600518a637492d37c9877aeb49c2a55d939c04/plugins/code-review",
          "skills": [],
          "mcpServers": [],
          "components": ["commands"],
          "componentInspection": "repository",
          "inspectionError": null,
          "installation": "requires_adapter",
          "upstream": {
            "source": "./plugins/code-review",
            "policy": null
          }
        },
        {
          "id": "anthropic:code-simplifier",
          "name": "code-simplifier",
          "displayName": "code-simplifier",
          "description": "Agent that simplifies and refines code for clarity, consistency, and maintainability while preserving functionality",
          "longDescription": "Agent that simplifies and refines code for clarity, consistency, and maintainability while preserving functionality",
          "category": "productivity",
          "keywords": [],
          "author": {
            "name": "Anthropic",
            "email": "support@anthropic.com"
          },
          "version": "1.0.0",
          "license": null,
          "logoUrl": null,
          "darkLogoUrl": null,
          "homepage": "https://github.com/anthropics/claude-plugins-official/tree/main/plugins/code-simplifier",
          "sourceUrl": "https://github.com/anthropics/claude-plugins-official/tree/3b600518a637492d37c9877aeb49c2a55d939c04/plugins/code-simplifier",
          "skills": [],
          "mcpServers": [],
          "components": ["agents"],
          "componentInspection": "repository",
          "inspectionError": null,
          "installation": "requires_adapter",
          "upstream": {
            "source": "./plugins/code-simplifier",
            "policy": null
          }
        },
        {
          "id": "anthropic:coderabbit",
          "name": "coderabbit",
          "displayName": "coderabbit",
          "description": "AI-powered code review in Claude Code, powered by CodeRabbit",
          "longDescription": "AI-powered code review in Claude Code, powered by CodeRabbit",
          "category": "productivity",
          "keywords": ["code-review", "ai", "coderabbit", "claude-code"],
          "author": {
            "name": "CodeRabbit AI",
            "email": "support@coderabbit.ai",
            "url": "https://coderabbit.ai"
          },
          "version": "1.1.1",
          "license": "MIT",
          "logoUrl": null,
          "darkLogoUrl": null,
          "homepage": "https://docs.coderabbit.ai/cli/claude-code-integration",
          "sourceUrl": "https://github.com/coderabbitai/skills/tree/aa49953c4cb2590e35480637b1b6a29cf4187cfa/",
          "skills": [
            {
              "name": "autofix",
              "sourceUrl": "https://github.com/coderabbitai/skills/blob/aa49953c4cb2590e35480637b1b6a29cf4187cfa/skills/autofix/SKILL.md"
            },
            {
              "name": "code-review",
              "sourceUrl": "https://github.com/coderabbitai/skills/blob/aa49953c4cb2590e35480637b1b6a29cf4187cfa/skills/code-review/SKILL.md"
            }
          ],
          "mcpServers": [],
          "components": ["skills", "agents", "commands"],
          "componentInspection": "repository",
          "inspectionError": null,
          "installation": "requires_adapter",
          "upstream": {
            "source": {
              "source": "url",
              "url": "https://github.com/coderabbitai/skills.git",
              "sha": "aa49953c4cb2590e35480637b1b6a29cf4187cfa"
            },
            "policy": null
          }
        },
        {
          "id": "anthropic:codspeed",
          "name": "codspeed",
          "displayName": "codspeed",
          "description": "CodSpeed plugin for Claude Code helping with performance measurement and optimization.",
          "longDescription": "CodSpeed plugin for Claude Code helping with performance measurement and optimization.",
          "category": "development",
          "keywords": ["codspeed", "performance", "profiling", "optimization", "benchmarking"],
          "author": {
            "name": "CodSpeed"
          },
          "version": "1.0.0",
          "license": "MIT",
          "logoUrl": null,
          "darkLogoUrl": null,
          "homepage": "https://codspeed.io",
          "sourceUrl": "https://github.com/CodSpeedHQ/codspeed/tree/a4bd056972ba530d84f020357f616ac25a7f5391/",
          "skills": [
            {
              "name": "codspeed-optimize",
              "sourceUrl": "https://github.com/CodSpeedHQ/codspeed/blob/a4bd056972ba530d84f020357f616ac25a7f5391/skills/codspeed-optimize/SKILL.md"
            },
            {
              "name": "codspeed-setup-harness",
              "sourceUrl": "https://github.com/CodSpeedHQ/codspeed/blob/a4bd056972ba530d84f020357f616ac25a7f5391/skills/codspeed-setup-harness/SKILL.md"
            }
          ],
          "mcpServers": [
            {
              "requiresConfiguration": false,
              "name": "CodSpeed",
              "transport": "http",
              "endpoint": "https://mcp.codspeed.io/mcp"
            }
          ],
          "components": ["skills", "mcp"],
          "componentInspection": "repository",
          "inspectionError": null,
          "installation": "requires_adapter",
          "upstream": {
            "source": {
              "source": "url",
              "url": "https://github.com/CodSpeedHQ/codspeed.git",
              "sha": "a4bd056972ba530d84f020357f616ac25a7f5391"
            },
            "policy": null
          }
        },
        {
          "id": "anthropic:commit-commands",
          "name": "commit-commands",
          "displayName": "commit-commands",
          "description": "Streamline your git workflow with simple commands for committing, pushing, and creating pull requests",
          "longDescription": "Streamline your git workflow with simple commands for committing, pushing, and creating pull requests",
          "category": "productivity",
          "keywords": [],
          "author": {
            "name": "Anthropic",
            "email": "support@anthropic.com"
          },
          "version": null,
          "license": null,
          "logoUrl": null,
          "darkLogoUrl": null,
          "homepage": "https://github.com/anthropics/claude-plugins-public/tree/main/plugins/commit-commands",
          "sourceUrl": "https://github.com/anthropics/claude-plugins-official/tree/3b600518a637492d37c9877aeb49c2a55d939c04/plugins/commit-commands",
          "skills": [],
          "mcpServers": [],
          "components": ["commands"],
          "componentInspection": "repository",
          "inspectionError": null,
          "installation": "requires_adapter",
          "upstream": {
            "source": "./plugins/commit-commands",
            "policy": null
          }
        },
        {
          "id": "anthropic:confidence",
          "name": "confidence",
          "displayName": "confidence",
          "description": "Access Confidence feature flags, experiments, and migration tools directly from Claude Code.",
          "longDescription": "Access Confidence feature flags, experiments, and migration tools directly from Claude Code.",
          "category": "development",
          "keywords": ["feature-flags", "experiments", "a/b-testing", "migration", "openfeature"],
          "author": {
            "name": "Spotify Confidence",
            "url": "https://confidence.spotify.com"
          },
          "version": "0.9.0",
          "license": "Apache-2.0",
          "logoUrl": null,
          "darkLogoUrl": null,
          "homepage": "https://confidence.spotify.com",
          "sourceUrl": "https://github.com/spotify/confidence-ai-plugins/tree/c8eb4aefefc4e095759ef0e5d1dd7e4e5ae6dae7/",
          "skills": [
            {
              "name": "analyze-project",
              "sourceUrl": "https://github.com/spotify/confidence-ai-plugins/blob/c8eb4aefefc4e095759ef0e5d1dd7e4e5ae6dae7/skills/analyze-project/SKILL.md"
            },
            {
              "name": "explore-metric",
              "sourceUrl": "https://github.com/spotify/confidence-ai-plugins/blob/c8eb4aefefc4e095759ef0e5d1dd7e4e5ae6dae7/skills/explore-metric/SKILL.md"
            },
            {
              "name": "instrument-events",
              "sourceUrl": "https://github.com/spotify/confidence-ai-plugins/blob/c8eb4aefefc4e095759ef0e5d1dd7e4e5ae6dae7/skills/instrument-events/SKILL.md"
            },
            {
              "name": "migrate-eppo",
              "sourceUrl": "https://github.com/spotify/confidence-ai-plugins/blob/c8eb4aefefc4e095759ef0e5d1dd7e4e5ae6dae7/skills/migrate-eppo/SKILL.md"
            },
            {
              "name": "migrate-optimizely",
              "sourceUrl": "https://github.com/spotify/confidence-ai-plugins/blob/c8eb4aefefc4e095759ef0e5d1dd7e4e5ae6dae7/skills/migrate-optimizely/SKILL.md"
            },
            {
              "name": "migrate-posthog",
              "sourceUrl": "https://github.com/spotify/confidence-ai-plugins/blob/c8eb4aefefc4e095759ef0e5d1dd7e4e5ae6dae7/skills/migrate-posthog/SKILL.md"
            },
            {
              "name": "migrate-statsig",
              "sourceUrl": "https://github.com/spotify/confidence-ai-plugins/blob/c8eb4aefefc4e095759ef0e5d1dd7e4e5ae6dae7/skills/migrate-statsig/SKILL.md"
            },
            {
              "name": "onboard-confidence-dry-run",
              "sourceUrl": "https://github.com/spotify/confidence-ai-plugins/blob/c8eb4aefefc4e095759ef0e5d1dd7e4e5ae6dae7/skills/onboard-confidence-dry-run/SKILL.md"
            },
            {
              "name": "onboard-confidence",
              "sourceUrl": "https://github.com/spotify/confidence-ai-plugins/blob/c8eb4aefefc4e095759ef0e5d1dd7e4e5ae6dae7/skills/onboard-confidence/SKILL.md"
            },
            {
              "name": "setup-warehouse-bigquery",
              "sourceUrl": "https://github.com/spotify/confidence-ai-plugins/blob/c8eb4aefefc4e095759ef0e5d1dd7e4e5ae6dae7/skills/setup-warehouse-bigquery/SKILL.md"
            },
            {
              "name": "setup-warehouse-databricks",
              "sourceUrl": "https://github.com/spotify/confidence-ai-plugins/blob/c8eb4aefefc4e095759ef0e5d1dd7e4e5ae6dae7/skills/setup-warehouse-databricks/SKILL.md"
            },
            {
              "name": "setup-warehouse-redshift",
              "sourceUrl": "https://github.com/spotify/confidence-ai-plugins/blob/c8eb4aefefc4e095759ef0e5d1dd7e4e5ae6dae7/skills/setup-warehouse-redshift/SKILL.md"
            },
            {
              "name": "setup-warehouse-snowflake",
              "sourceUrl": "https://github.com/spotify/confidence-ai-plugins/blob/c8eb4aefefc4e095759ef0e5d1dd7e4e5ae6dae7/skills/setup-warehouse-snowflake/SKILL.md"
            },
            {
              "name": "setup-warehouse",
              "sourceUrl": "https://github.com/spotify/confidence-ai-plugins/blob/c8eb4aefefc4e095759ef0e5d1dd7e4e5ae6dae7/skills/setup-warehouse/SKILL.md"
            }
          ],
          "mcpServers": [
            {
              "requiresConfiguration": true,
              "name": "confidence-flags",
              "transport": "http",
              "endpoint": "https://mcp.confidence.dev/mcp/flags"
            },
            {
              "requiresConfiguration": true,
              "name": "confidence-docs",
              "transport": "http",
              "endpoint": "https://mcp.confidence.dev/mcp/docs"
            }
          ],
          "components": ["skills", "mcp", "commands"],
          "componentInspection": "repository",
          "inspectionError": null,
          "installation": "requires_adapter",
          "upstream": {
            "source": {
              "source": "url",
              "url": "https://github.com/spotify/confidence-ai-plugins.git",
              "sha": "c8eb4aefefc4e095759ef0e5d1dd7e4e5ae6dae7"
            },
            "policy": null
          }
        },
        {
          "id": "anthropic:context7",
          "name": "context7",
          "displayName": "context7",
          "description": "Upstash Context7 MCP server for up-to-date documentation lookup. Connects to Context7's hosted remote MCP server (https://mcp.context7.com/mcp) — no local Node.js or npx required — to pull version-specific documentation and code examples directly from source repositories into your LLM context. Works anonymously out of the box; set CONTEXT7_API_KEY for higher rate limits.",
          "longDescription": "Upstash Context7 MCP server for up-to-date documentation lookup. Connects to Context7's hosted remote MCP server (https://mcp.context7.com/mcp) — no local Node.js or npx required — to pull version-specific documentation and code examples directly from source repositories into your LLM context. Works anonymously out of the box; set CONTEXT7_API_KEY for higher rate limits.",
          "category": "development",
          "keywords": [],
          "author": {
            "name": "Upstash"
          },
          "version": null,
          "license": null,
          "logoUrl": null,
          "darkLogoUrl": null,
          "homepage": "https://github.com/anthropics/claude-plugins-public/tree/main/external_plugins/context7",
          "sourceUrl": "https://github.com/anthropics/claude-plugins-official/tree/3b600518a637492d37c9877aeb49c2a55d939c04/external_plugins/context7",
          "skills": [],
          "mcpServers": [
            {
              "requiresConfiguration": true,
              "name": "context7",
              "transport": "http",
              "endpoint": "https://mcp.context7.com/mcp?client=claude-code-plugin"
            }
          ],
          "components": ["mcp"],
          "componentInspection": "repository",
          "inspectionError": null,
          "installation": "requires_adapter",
          "upstream": {
            "source": "./external_plugins/context7",
            "policy": null
          }
        },
        {
          "id": "anthropic:convex",
          "name": "convex",
          "displayName": "convex",
          "description": "Bundled design + quickstart skills, code-writing and code-review subagents, lint guard + end-of-turn verify hooks, runtime-error and OCC-insights monitors, and MCP server for live deployment introspection. The quickstart scaffolds a running app from one sentence and builds it live LOCALLY, narrated in chat; the convex-reviewer subagent audits Convex functions for auth, validators, and performance. Build reactive, type-safe backends on one platform — schema, real-time, file storage, scheduled jobs, and AI agents.",
          "longDescription": "Bundled design + quickstart skills, code-writing and code-review subagents, lint guard + end-of-turn verify hooks, runtime-error and OCC-insights monitors, and MCP server for live deployment introspection. The quickstart scaffolds a running app from one sentence and builds it live LOCALLY, narrated in chat; the convex-reviewer subagent audits Convex functions for auth, validators, and performance. Build reactive, type-safe backends on one platform — schema, real-time, file storage, scheduled jobs, and AI agents.",
          "category": "database",
          "keywords": [
            "convex",
            "backend",
            "database",
            "realtime",
            "reactive",
            "websocket",
            "auth",
            "storage",
            "scheduler",
            "cron",
            "agent",
            "rag",
            "mobile",
            "typescript",
            "mcp"
          ],
          "author": {
            "name": "Convex",
            "url": "https://convex.dev"
          },
          "version": "1.14.0",
          "license": "Apache-2.0",
          "logoUrl": null,
          "darkLogoUrl": null,
          "homepage": "https://github.com/get-convex/convex-backend-skill",
          "sourceUrl": "https://github.com/get-convex/convex-backend-skill/tree/6ca54f6e2e7582812187b8a5a4783fb4dff52692/",
          "skills": [
            {
              "name": "add",
              "sourceUrl": "https://github.com/get-convex/convex-backend-skill/blob/6ca54f6e2e7582812187b8a5a4783fb4dff52692/skills/add/SKILL.md"
            },
            {
              "name": "agent",
              "sourceUrl": "https://github.com/get-convex/convex-backend-skill/blob/6ca54f6e2e7582812187b8a5a4783fb4dff52692/skills/agent/SKILL.md"
            },
            {
              "name": "auth",
              "sourceUrl": "https://github.com/get-convex/convex-backend-skill/blob/6ca54f6e2e7582812187b8a5a4783fb4dff52692/skills/auth/SKILL.md"
            },
            {
              "name": "billing",
              "sourceUrl": "https://github.com/get-convex/convex-backend-skill/blob/6ca54f6e2e7582812187b8a5a4783fb4dff52692/skills/billing/SKILL.md"
            },
            {
              "name": "convex-authz",
              "sourceUrl": "https://github.com/get-convex/convex-backend-skill/blob/6ca54f6e2e7582812187b8a5a4783fb4dff52692/skills/convex-authz/SKILL.md"
            },
            {
              "name": "crons",
              "sourceUrl": "https://github.com/get-convex/convex-backend-skill/blob/6ca54f6e2e7582812187b8a5a4783fb4dff52692/skills/crons/SKILL.md"
            },
            {
              "name": "design",
              "sourceUrl": "https://github.com/get-convex/convex-backend-skill/blob/6ca54f6e2e7582812187b8a5a4783fb4dff52692/skills/design/SKILL.md"
            },
            {
              "name": "domains",
              "sourceUrl": "https://github.com/get-convex/convex-backend-skill/blob/6ca54f6e2e7582812187b8a5a4783fb4dff52692/skills/domains/SKILL.md"
            },
            {
              "name": "env",
              "sourceUrl": "https://github.com/get-convex/convex-backend-skill/blob/6ca54f6e2e7582812187b8a5a4783fb4dff52692/skills/env/SKILL.md"
            },
            {
              "name": "improve-convex-plugin",
              "sourceUrl": "https://github.com/get-convex/convex-backend-skill/blob/6ca54f6e2e7582812187b8a5a4783fb4dff52692/skills/improve-convex-plugin/SKILL.md"
            },
            {
              "name": "labs-quickstart",
              "sourceUrl": "https://github.com/get-convex/convex-backend-skill/blob/6ca54f6e2e7582812187b8a5a4783fb4dff52692/skills/labs-quickstart/SKILL.md"
            },
            {
              "name": "migrate",
              "sourceUrl": "https://github.com/get-convex/convex-backend-skill/blob/6ca54f6e2e7582812187b8a5a4783fb4dff52692/skills/migrate/SKILL.md"
            },
            {
              "name": "quickstart",
              "sourceUrl": "https://github.com/get-convex/convex-backend-skill/blob/6ca54f6e2e7582812187b8a5a4783fb4dff52692/skills/quickstart/SKILL.md"
            },
            {
              "name": "seed",
              "sourceUrl": "https://github.com/get-convex/convex-backend-skill/blob/6ca54f6e2e7582812187b8a5a4783fb4dff52692/skills/seed/SKILL.md"
            },
            {
              "name": "suggest",
              "sourceUrl": "https://github.com/get-convex/convex-backend-skill/blob/6ca54f6e2e7582812187b8a5a4783fb4dff52692/skills/suggest/SKILL.md"
            },
            {
              "name": "test",
              "sourceUrl": "https://github.com/get-convex/convex-backend-skill/blob/6ca54f6e2e7582812187b8a5a4783fb4dff52692/skills/test/SKILL.md"
            },
            {
              "name": "workflow",
              "sourceUrl": "https://github.com/get-convex/convex-backend-skill/blob/6ca54f6e2e7582812187b8a5a4783fb4dff52692/skills/workflow/SKILL.md"
            }
          ],
          "mcpServers": [
            {
              "requiresConfiguration": false,
              "name": "convex",
              "transport": "stdio",
              "endpoint": null
            }
          ],
          "components": ["skills", "mcp", "hooks", "agents", "commands"],
          "componentInspection": "repository",
          "inspectionError": null,
          "installation": "requires_adapter",
          "upstream": {
            "source": {
              "source": "url",
              "url": "https://github.com/get-convex/convex-backend-skill.git",
              "sha": "6ca54f6e2e7582812187b8a5a4783fb4dff52692"
            },
            "policy": null
          }
        },
        {
          "id": "anthropic:crowdsec",
          "name": "crowdsec",
          "displayName": "crowdsec",
          "description": "CrowdSec skills: an operational skill (install/configure/operate/debug the engine, cscli, bouncers, WAF and bot detection across bare-metal/Docker/Kubernetes) and a Service API skill (drive the premium Console cloud API — blocklists, allowlists, firewall integrations, metrics, decisions).",
          "longDescription": "CrowdSec skills: an operational skill (install/configure/operate/debug the engine, cscli, bouncers, WAF and bot detection across bare-metal/Docker/Kubernetes) and a Service API skill (drive the premium Console cloud API — blocklists, allowlists, firewall integrations, metrics, decisions).",
          "category": "security",
          "keywords": [
            "crowdsec",
            "security",
            "waf",
            "appsec",
            "bouncer",
            "fail2ban",
            "console",
            "service-api",
            "sapi",
            "blocklist",
            "integration",
            "cloud",
            "bot-detection",
            "bot-management",
            "challenge"
          ],
          "author": {
            "name": "CrowdSec",
            "url": "https://github.com/crowdsecurity"
          },
          "version": "0.3.0",
          "license": "MIT",
          "logoUrl": null,
          "darkLogoUrl": null,
          "homepage": "https://github.com/crowdsecurity/crowdsec-skill",
          "sourceUrl": "https://github.com/crowdsecurity/crowdsec-skill/tree/517173c3899b165934f06042e3737aae94685b07/",
          "skills": [
            {
              "name": "crowdsec-service-api",
              "sourceUrl": "https://github.com/crowdsecurity/crowdsec-skill/blob/517173c3899b165934f06042e3737aae94685b07/skills/crowdsec-service-api/SKILL.md"
            },
            {
              "name": "crowdsec",
              "sourceUrl": "https://github.com/crowdsecurity/crowdsec-skill/blob/517173c3899b165934f06042e3737aae94685b07/skills/crowdsec/SKILL.md"
            }
          ],
          "mcpServers": [],
          "components": ["skills"],
          "componentInspection": "repository",
          "inspectionError": null,
          "installation": "requires_adapter",
          "upstream": {
            "source": {
              "source": "url",
              "url": "https://github.com/crowdsecurity/crowdsec-skill.git",
              "sha": "517173c3899b165934f06042e3737aae94685b07"
            },
            "policy": null
          }
        },
        {
          "id": "anthropic:crowdstrike-falcon-foundry",
          "name": "crowdstrike-falcon-foundry",
          "displayName": "crowdstrike-falcon-foundry",
          "description": "CrowdStrike Falcon Foundry development skills for building cybersecurity applications on the Falcon platform. Includes UI development, collections, functions, workflows, API integration, security patterns, and debugging workflows. Swagger 2.0 specs are auto-converted to OpenAPI 3.0 via npx swagger2openapi (requires Node.js; network call to npm registry).",
          "longDescription": "CrowdStrike Falcon Foundry development skills for building cybersecurity applications on the Falcon platform. Includes UI development, collections, functions, workflows, API integration, security patterns, and debugging workflows. Swagger 2.0 specs are auto-converted to OpenAPI 3.0 via npx swagger2openapi (requires Node.js; network call to npm registry).",
          "category": "security",
          "keywords": [
            "foundry",
            "crowdstrike",
            "cybersecurity",
            "falcon",
            "ui-development",
            "collections",
            "functions",
            "workflows",
            "api-integration",
            "security"
          ],
          "author": {
            "name": "CrowdStrike"
          },
          "version": "1.5.0",
          "license": null,
          "logoUrl": null,
          "darkLogoUrl": null,
          "homepage": "https://github.com/CrowdStrike/foundry-skills",
          "sourceUrl": "https://github.com/CrowdStrike/foundry-skills/tree/7f7d46687c16a9a37c9b08ad58ad58999aabe497/",
          "skills": [
            {
              "name": "api-integrations",
              "sourceUrl": "https://github.com/CrowdStrike/foundry-skills/blob/7f7d46687c16a9a37c9b08ad58ad58999aabe497/skills/api-integrations/SKILL.md"
            },
            {
              "name": "collections-development",
              "sourceUrl": "https://github.com/CrowdStrike/foundry-skills/blob/7f7d46687c16a9a37c9b08ad58ad58999aabe497/skills/collections-development/SKILL.md"
            },
            {
              "name": "debugging-workflows",
              "sourceUrl": "https://github.com/CrowdStrike/foundry-skills/blob/7f7d46687c16a9a37c9b08ad58ad58999aabe497/skills/debugging-workflows/SKILL.md"
            },
            {
              "name": "development-workflow",
              "sourceUrl": "https://github.com/CrowdStrike/foundry-skills/blob/7f7d46687c16a9a37c9b08ad58ad58999aabe497/skills/development-workflow/SKILL.md"
            },
            {
              "name": "e2e-testing",
              "sourceUrl": "https://github.com/CrowdStrike/foundry-skills/blob/7f7d46687c16a9a37c9b08ad58ad58999aabe497/skills/e2e-testing/SKILL.md"
            },
            {
              "name": "functions-development",
              "sourceUrl": "https://github.com/CrowdStrike/foundry-skills/blob/7f7d46687c16a9a37c9b08ad58ad58999aabe497/skills/functions-development/SKILL.md"
            },
            {
              "name": "functions-falcon-api",
              "sourceUrl": "https://github.com/CrowdStrike/foundry-skills/blob/7f7d46687c16a9a37c9b08ad58ad58999aabe497/skills/functions-falcon-api/SKILL.md"
            },
            {
              "name": "fusion-redirect",
              "sourceUrl": "https://github.com/CrowdStrike/foundry-skills/blob/7f7d46687c16a9a37c9b08ad58ad58999aabe497/skills/fusion-redirect/SKILL.md"
            },
            {
              "name": "security-patterns",
              "sourceUrl": "https://github.com/CrowdStrike/foundry-skills/blob/7f7d46687c16a9a37c9b08ad58ad58999aabe497/skills/security-patterns/SKILL.md"
            },
            {
              "name": "ui-development",
              "sourceUrl": "https://github.com/CrowdStrike/foundry-skills/blob/7f7d46687c16a9a37c9b08ad58ad58999aabe497/skills/ui-development/SKILL.md"
            },
            {
              "name": "workflows-development",
              "sourceUrl": "https://github.com/CrowdStrike/foundry-skills/blob/7f7d46687c16a9a37c9b08ad58ad58999aabe497/skills/workflows-development/SKILL.md"
            }
          ],
          "mcpServers": [],
          "components": ["skills", "hooks"],
          "componentInspection": "repository",
          "inspectionError": null,
          "installation": "requires_adapter",
          "upstream": {
            "source": {
              "source": "url",
              "url": "https://github.com/CrowdStrike/foundry-skills.git",
              "sha": "7f7d46687c16a9a37c9b08ad58ad58999aabe497"
            },
            "policy": null
          }
        },
        {
          "id": "anthropic:crowdstrike-falcon-fusion",
          "name": "crowdstrike-falcon-fusion",
          "displayName": "crowdstrike-falcon-fusion",
          "description": "CrowdStrike Falcon Fusion skills for authoring, deploying, and executing Fusion workflows. Includes live action discovery, YAML authoring with schema validation, workflow import and release, execution monitoring, and Falcon Next-Gen SIEM lookup files.",
          "longDescription": "CrowdStrike Falcon Fusion skills for authoring, deploying, and executing Fusion workflows. Includes live action discovery, YAML authoring with schema validation, workflow import and release, execution monitoring, and Falcon Next-Gen SIEM lookup files.",
          "category": "security",
          "keywords": [
            "crowdstrike",
            "falcon",
            "fusion",
            "soar",
            "workflow",
            "automation",
            "security"
          ],
          "author": {
            "name": "CrowdStrike"
          },
          "version": "1.1.0",
          "license": "MIT",
          "logoUrl": null,
          "darkLogoUrl": null,
          "homepage": "https://github.com/CrowdStrike/fusion-skills",
          "sourceUrl": "https://github.com/CrowdStrike/fusion-skills/tree/8df28a78be316f619a0a5227a401b395da990c40/",
          "skills": [
            {
              "name": "authoring",
              "sourceUrl": "https://github.com/CrowdStrike/fusion-skills/blob/8df28a78be316f619a0a5227a401b395da990c40/skills/authoring/SKILL.md"
            },
            {
              "name": "deployment",
              "sourceUrl": "https://github.com/CrowdStrike/fusion-skills/blob/8df28a78be316f619a0a5227a401b395da990c40/skills/deployment/SKILL.md"
            },
            {
              "name": "execution",
              "sourceUrl": "https://github.com/CrowdStrike/fusion-skills/blob/8df28a78be316f619a0a5227a401b395da990c40/skills/execution/SKILL.md"
            },
            {
              "name": "foundry-redirect",
              "sourceUrl": "https://github.com/CrowdStrike/fusion-skills/blob/8df28a78be316f619a0a5227a401b395da990c40/skills/foundry-redirect/SKILL.md"
            },
            {
              "name": "lookup-files",
              "sourceUrl": "https://github.com/CrowdStrike/fusion-skills/blob/8df28a78be316f619a0a5227a401b395da990c40/skills/lookup-files/SKILL.md"
            },
            {
              "name": "setup",
              "sourceUrl": "https://github.com/CrowdStrike/fusion-skills/blob/8df28a78be316f619a0a5227a401b395da990c40/skills/setup/SKILL.md"
            },
            {
              "name": "workflows",
              "sourceUrl": "https://github.com/CrowdStrike/fusion-skills/blob/8df28a78be316f619a0a5227a401b395da990c40/skills/workflows/SKILL.md"
            }
          ],
          "mcpServers": [],
          "components": ["skills", "hooks"],
          "componentInspection": "repository",
          "inspectionError": null,
          "installation": "requires_adapter",
          "upstream": {
            "source": {
              "source": "url",
              "url": "https://github.com/CrowdStrike/fusion-skills.git",
              "sha": "8df28a78be316f619a0a5227a401b395da990c40"
            },
            "policy": null
          }
        },
        {
          "id": "anthropic:csharp-lsp",
          "name": "csharp-lsp",
          "displayName": "csharp-lsp",
          "description": "C# language server for code intelligence",
          "longDescription": "C# language server for code intelligence",
          "category": "development",
          "keywords": [],
          "author": {
            "name": "Anthropic",
            "email": "support@anthropic.com"
          },
          "version": "1.0.0",
          "license": null,
          "logoUrl": null,
          "darkLogoUrl": null,
          "homepage": null,
          "sourceUrl": "https://github.com/anthropics/claude-plugins-official/tree/3b600518a637492d37c9877aeb49c2a55d939c04/plugins/csharp-lsp",
          "skills": [],
          "mcpServers": [],
          "components": [],
          "componentInspection": "repository",
          "inspectionError": null,
          "installation": "requires_adapter",
          "upstream": {
            "source": "./plugins/csharp-lsp",
            "policy": null
          }
        },
        {
          "id": "anthropic:cwc-makers",
          "name": "cwc-makers",
          "displayName": "cwc-makers",
          "description": "Seamless onboarding for the Code-with-Claude Makers Cardputer: one /maker-setup command clones the build-with-claude repo, flashes UIFlow firmware, and installs the Claude Buddy app bundle onto a freshly-plugged-in M5Stack Cardputer-Adv.",
          "longDescription": "Seamless onboarding for the Code-with-Claude Makers Cardputer: one /maker-setup command clones the build-with-claude repo, flashes UIFlow firmware, and installs the Claude Buddy app bundle onto a freshly-plugged-in M5Stack Cardputer-Adv.",
          "category": "productivity",
          "keywords": ["cardputer", "m5stack", "esp32", "hardware", "maker", "onboarding", "cwc"],
          "author": {
            "name": "Anthropic",
            "email": "support@anthropic.com"
          },
          "version": "1.0.0",
          "license": "Apache-2.0",
          "logoUrl": null,
          "darkLogoUrl": null,
          "homepage": "https://claude.com/cwc-makers",
          "sourceUrl": "https://github.com/anthropics/claude-plugins-official/tree/3b600518a637492d37c9877aeb49c2a55d939c04/plugins/cwc-makers",
          "skills": [
            {
              "name": "cardputer-buddy",
              "sourceUrl": "https://github.com/anthropics/claude-plugins-official/blob/3b600518a637492d37c9877aeb49c2a55d939c04/plugins/cwc-makers/skills/cardputer-buddy/SKILL.md"
            },
            {
              "name": "m5-onboard",
              "sourceUrl": "https://github.com/anthropics/claude-plugins-official/blob/3b600518a637492d37c9877aeb49c2a55d939c04/plugins/cwc-makers/skills/m5-onboard/SKILL.md"
            }
          ],
          "mcpServers": [],
          "components": ["skills", "commands"],
          "componentInspection": "repository",
          "inspectionError": null,
          "installation": "requires_adapter",
          "upstream": {
            "source": "./plugins/cwc-makers",
            "policy": null
          }
        },
        {
          "id": "anthropic:dash0",
          "name": "dash0",
          "displayName": "dash0-agent-plugin",
          "description": "OpenTelemetry observability for Claude Code sessions. Captures tool calls, LLM invocations, token usage, and errors as OTel traces.",
          "longDescription": "OpenTelemetry observability for Claude Code sessions. Captures tool calls, LLM invocations, token usage, and errors as OTel traces.",
          "category": "monitoring",
          "keywords": ["observability", "tracing", "opentelemetry", "dash0", "otel"],
          "author": {
            "name": "Dash0"
          },
          "version": "0.1.28",
          "license": "Apache-2.0",
          "logoUrl": null,
          "darkLogoUrl": null,
          "homepage": "https://dash0.com",
          "sourceUrl": "https://github.com/dash0hq/dash0-agent-plugin/tree/529203383805cf15b6f4a1c7e73e49efa86da311/",
          "skills": [
            {
              "name": "copilot-local-dev",
              "sourceUrl": "https://github.com/dash0hq/dash0-agent-plugin/blob/529203383805cf15b6f4a1c7e73e49efa86da311/.claude/skills/copilot-local-dev/SKILL.md"
            },
            {
              "name": "dash0-configure",
              "sourceUrl": "https://github.com/dash0hq/dash0-agent-plugin/blob/529203383805cf15b6f4a1c7e73e49efa86da311/claude/skills/dash0-configure/SKILL.md"
            },
            {
              "name": "dash0-configure",
              "sourceUrl": "https://github.com/dash0hq/dash0-agent-plugin/blob/529203383805cf15b6f4a1c7e73e49efa86da311/copilot/skills/dash0-configure/SKILL.md"
            },
            {
              "name": "dash0-configure",
              "sourceUrl": "https://github.com/dash0hq/dash0-agent-plugin/blob/529203383805cf15b6f4a1c7e73e49efa86da311/cursor/skills/dash0-configure/SKILL.md"
            },
            {
              "name": "qa-echo",
              "sourceUrl": "https://github.com/dash0hq/dash0-agent-plugin/blob/529203383805cf15b6f4a1c7e73e49efa86da311/qa/skill-fixture/qa-echo/SKILL.md"
            }
          ],
          "mcpServers": [],
          "components": ["skills"],
          "componentInspection": "repository",
          "inspectionError": null,
          "installation": "requires_adapter",
          "upstream": {
            "source": {
              "source": "url",
              "url": "https://github.com/dash0hq/dash0-agent-plugin.git",
              "sha": "529203383805cf15b6f4a1c7e73e49efa86da311"
            },
            "policy": null
          }
        },
        {
          "id": "anthropic:data",
          "name": "data",
          "displayName": "astronomer-data",
          "description": "Data engineering plugin - warehouse exploration, pipeline authoring, Airflow integration",
          "longDescription": "Data engineering plugin - warehouse exploration, pipeline authoring, Airflow integration",
          "category": "development",
          "keywords": [],
          "author": null,
          "version": "0.1.0",
          "license": null,
          "logoUrl": null,
          "darkLogoUrl": null,
          "homepage": "https://github.com/astronomer/agents",
          "sourceUrl": "https://github.com/astronomer/agents/tree/dbd9bb79c4f7b7ac9c1cdd2b4b75213c81f423e5/",
          "skills": [
            {
              "name": "airflow-adapter",
              "sourceUrl": "https://github.com/astronomer/agents/blob/dbd9bb79c4f7b7ac9c1cdd2b4b75213c81f423e5/astro-airflow-mcp/.claude/skills/airflow-adapter/SKILL.md"
            },
            {
              "name": "airflow-hitl",
              "sourceUrl": "https://github.com/astronomer/agents/blob/dbd9bb79c4f7b7ac9c1cdd2b4b75213c81f423e5/skills/airflow-hitl/SKILL.md"
            },
            {
              "name": "airflow-plugins",
              "sourceUrl": "https://github.com/astronomer/agents/blob/dbd9bb79c4f7b7ac9c1cdd2b4b75213c81f423e5/skills/airflow-plugins/SKILL.md"
            },
            {
              "name": "airflow-state-store",
              "sourceUrl": "https://github.com/astronomer/agents/blob/dbd9bb79c4f7b7ac9c1cdd2b4b75213c81f423e5/skills/airflow-state-store/SKILL.md"
            },
            {
              "name": "airflow",
              "sourceUrl": "https://github.com/astronomer/agents/blob/dbd9bb79c4f7b7ac9c1cdd2b4b75213c81f423e5/skills/airflow/SKILL.md"
            },
            {
              "name": "analyzing-data",
              "sourceUrl": "https://github.com/astronomer/agents/blob/dbd9bb79c4f7b7ac9c1cdd2b4b75213c81f423e5/skills/analyzing-data/SKILL.md"
            },
            {
              "name": "annotating-task-lineage",
              "sourceUrl": "https://github.com/astronomer/agents/blob/dbd9bb79c4f7b7ac9c1cdd2b4b75213c81f423e5/skills/annotating-task-lineage/SKILL.md"
            },
            {
              "name": "authoring-dags",
              "sourceUrl": "https://github.com/astronomer/agents/blob/dbd9bb79c4f7b7ac9c1cdd2b4b75213c81f423e5/skills/authoring-dags/SKILL.md"
            },
            {
              "name": "authoring-go-sdk-tasks",
              "sourceUrl": "https://github.com/astronomer/agents/blob/dbd9bb79c4f7b7ac9c1cdd2b4b75213c81f423e5/skills/authoring-go-sdk-tasks/SKILL.md"
            },
            {
              "name": "authoring-java-sdk-tasks",
              "sourceUrl": "https://github.com/astronomer/agents/blob/dbd9bb79c4f7b7ac9c1cdd2b4b75213c81f423e5/skills/authoring-java-sdk-tasks/SKILL.md"
            },
            {
              "name": "authoring-language-sdk-tasks",
              "sourceUrl": "https://github.com/astronomer/agents/blob/dbd9bb79c4f7b7ac9c1cdd2b4b75213c81f423e5/skills/authoring-language-sdk-tasks/SKILL.md"
            },
            {
              "name": "blueprint",
              "sourceUrl": "https://github.com/astronomer/agents/blob/dbd9bb79c4f7b7ac9c1cdd2b4b75213c81f423e5/skills/blueprint/SKILL.md"
            },
            {
              "name": "checking-freshness",
              "sourceUrl": "https://github.com/astronomer/agents/blob/dbd9bb79c4f7b7ac9c1cdd2b4b75213c81f423e5/skills/checking-freshness/SKILL.md"
            },
            {
              "name": "configuring-airflow-language-sdks",
              "sourceUrl": "https://github.com/astronomer/agents/blob/dbd9bb79c4f7b7ac9c1cdd2b4b75213c81f423e5/skills/configuring-airflow-language-sdks/SKILL.md"
            },
            {
              "name": "cosmos-dbt-core",
              "sourceUrl": "https://github.com/astronomer/agents/blob/dbd9bb79c4f7b7ac9c1cdd2b4b75213c81f423e5/skills/cosmos-dbt-core/SKILL.md"
            },
            {
              "name": "cosmos-dbt-fusion",
              "sourceUrl": "https://github.com/astronomer/agents/blob/dbd9bb79c4f7b7ac9c1cdd2b4b75213c81f423e5/skills/cosmos-dbt-fusion/SKILL.md"
            },
            {
              "name": "creating-openlineage-extractors",
              "sourceUrl": "https://github.com/astronomer/agents/blob/dbd9bb79c4f7b7ac9c1cdd2b4b75213c81f423e5/skills/creating-openlineage-extractors/SKILL.md"
            },
            {
              "name": "dag-factory",
              "sourceUrl": "https://github.com/astronomer/agents/blob/dbd9bb79c4f7b7ac9c1cdd2b4b75213c81f423e5/skills/dag-factory/SKILL.md"
            },
            {
              "name": "debugging-dags",
              "sourceUrl": "https://github.com/astronomer/agents/blob/dbd9bb79c4f7b7ac9c1cdd2b4b75213c81f423e5/skills/debugging-dags/SKILL.md"
            },
            {
              "name": "delegating-to-otto",
              "sourceUrl": "https://github.com/astronomer/agents/blob/dbd9bb79c4f7b7ac9c1cdd2b4b75213c81f423e5/skills/delegating-to-otto/SKILL.md"
            },
            {
              "name": "deploying-airflow",
              "sourceUrl": "https://github.com/astronomer/agents/blob/dbd9bb79c4f7b7ac9c1cdd2b4b75213c81f423e5/skills/deploying-airflow/SKILL.md"
            },
            {
              "name": "deploying-go-sdk-bundles",
              "sourceUrl": "https://github.com/astronomer/agents/blob/dbd9bb79c4f7b7ac9c1cdd2b4b75213c81f423e5/skills/deploying-go-sdk-bundles/SKILL.md"
            },
            {
              "name": "deploying-java-sdk-bundles",
              "sourceUrl": "https://github.com/astronomer/agents/blob/dbd9bb79c4f7b7ac9c1cdd2b4b75213c81f423e5/skills/deploying-java-sdk-bundles/SKILL.md"
            },
            {
              "name": "managing-astro-deployments",
              "sourceUrl": "https://github.com/astronomer/agents/blob/dbd9bb79c4f7b7ac9c1cdd2b4b75213c81f423e5/skills/managing-astro-deployments/SKILL.md"
            },
            {
              "name": "managing-astro-local-env",
              "sourceUrl": "https://github.com/astronomer/agents/blob/dbd9bb79c4f7b7ac9c1cdd2b4b75213c81f423e5/skills/managing-astro-local-env/SKILL.md"
            },
            {
              "name": "migrating-ai-sdk-to-common-ai",
              "sourceUrl": "https://github.com/astronomer/agents/blob/dbd9bb79c4f7b7ac9c1cdd2b4b75213c81f423e5/skills/migrating-ai-sdk-to-common-ai/SKILL.md"
            },
            {
              "name": "migrating-airflow-2-to-3",
              "sourceUrl": "https://github.com/astronomer/agents/blob/dbd9bb79c4f7b7ac9c1cdd2b4b75213c81f423e5/skills/migrating-airflow-2-to-3/SKILL.md"
            },
            {
              "name": "migrating-dagster-to-airflow",
              "sourceUrl": "https://github.com/astronomer/agents/blob/dbd9bb79c4f7b7ac9c1cdd2b4b75213c81f423e5/skills/migrating-dagster-to-airflow/SKILL.md"
            },
            {
              "name": "profiling-tables",
              "sourceUrl": "https://github.com/astronomer/agents/blob/dbd9bb79c4f7b7ac9c1cdd2b4b75213c81f423e5/skills/profiling-tables/SKILL.md"
            },
            {
              "name": "setting-up-astro-project",
              "sourceUrl": "https://github.com/astronomer/agents/blob/dbd9bb79c4f7b7ac9c1cdd2b4b75213c81f423e5/skills/setting-up-astro-project/SKILL.md"
            },
            {
              "name": "testing-dags",
              "sourceUrl": "https://github.com/astronomer/agents/blob/dbd9bb79c4f7b7ac9c1cdd2b4b75213c81f423e5/skills/testing-dags/SKILL.md"
            },
            {
              "name": "tracing-downstream-lineage",
              "sourceUrl": "https://github.com/astronomer/agents/blob/dbd9bb79c4f7b7ac9c1cdd2b4b75213c81f423e5/skills/tracing-downstream-lineage/SKILL.md"
            },
            {
              "name": "tracing-upstream-lineage",
              "sourceUrl": "https://github.com/astronomer/agents/blob/dbd9bb79c4f7b7ac9c1cdd2b4b75213c81f423e5/skills/tracing-upstream-lineage/SKILL.md"
            },
            {
              "name": "troubleshooting-astro-deployments",
              "sourceUrl": "https://github.com/astronomer/agents/blob/dbd9bb79c4f7b7ac9c1cdd2b4b75213c81f423e5/skills/troubleshooting-astro-deployments/SKILL.md"
            },
            {
              "name": "warehouse-init",
              "sourceUrl": "https://github.com/astronomer/agents/blob/dbd9bb79c4f7b7ac9c1cdd2b4b75213c81f423e5/skills/warehouse-init/SKILL.md"
            }
          ],
          "mcpServers": [],
          "components": ["skills"],
          "componentInspection": "repository",
          "inspectionError": null,
          "installation": "requires_adapter",
          "upstream": {
            "source": {
              "source": "url",
              "url": "https://github.com/astronomer/agents.git",
              "sha": "dbd9bb79c4f7b7ac9c1cdd2b4b75213c81f423e5"
            },
            "policy": null
          }
        },
        {
          "id": "anthropic:data-agent-kit-starter-pack",
          "name": "data-agent-kit-starter-pack",
          "displayName": "dak",
          "description": "This plugin provides a specialized suite of skills for data engineers and database practitioners working on Google Cloud. It acts as an expert assistant, allowing you to use natural language prompts in your preferred coding agent to architect complex data pipelines, transform data with dbt, write Spark and BigQuery SQL notebooks, and orchestrate end-to-end workflows across GCP's data ecosystem.",
          "longDescription": "This plugin provides a specialized suite of skills for data engineers and database practitioners working on Google Cloud. It acts as an expert assistant, allowing you to use natural language prompts in your preferred coding agent to architect complex data pipelines, transform data with dbt, write Spark and BigQuery SQL notebooks, and orchestrate end-to-end workflows across GCP's data ecosystem.",
          "category": "development",
          "keywords": [],
          "author": {
            "name": "Google LLC",
            "email": "data-cloud-ai-integrations@google.com"
          },
          "version": "0.10.1",
          "license": null,
          "logoUrl": null,
          "darkLogoUrl": null,
          "homepage": "https://github.com/gemini-cli-extensions/data-agent-kit-starter-pack",
          "sourceUrl": "https://github.com/gemini-cli-extensions/data-agent-kit-starter-pack/tree/42e9b54f582af24b462729d7c82b451aaee1fbfd/",
          "skills": [
            {
              "name": "accidental-data-loss-prevention",
              "sourceUrl": "https://github.com/gemini-cli-extensions/data-agent-kit-starter-pack/blob/42e9b54f582af24b462729d7c82b451aaee1fbfd/skills/accidental-data-loss-prevention/SKILL.md"
            },
            {
              "name": "bigquery-ai-ml",
              "sourceUrl": "https://github.com/gemini-cli-extensions/data-agent-kit-starter-pack/blob/42e9b54f582af24b462729d7c82b451aaee1fbfd/skills/bigquery-ai-ml/SKILL.md"
            },
            {
              "name": "bigquery-bigframes",
              "sourceUrl": "https://github.com/gemini-cli-extensions/data-agent-kit-starter-pack/blob/42e9b54f582af24b462729d7c82b451aaee1fbfd/skills/bigquery-bigframes/SKILL.md"
            },
            {
              "name": "bigquery-data-transfer-service",
              "sourceUrl": "https://github.com/gemini-cli-extensions/data-agent-kit-starter-pack/blob/42e9b54f582af24b462729d7c82b451aaee1fbfd/skills/bigquery-data-transfer-service/SKILL.md"
            },
            {
              "name": "bigquery-graph",
              "sourceUrl": "https://github.com/gemini-cli-extensions/data-agent-kit-starter-pack/blob/42e9b54f582af24b462729d7c82b451aaee1fbfd/skills/bigquery-graph/SKILL.md"
            },
            {
              "name": "bigquery-sql",
              "sourceUrl": "https://github.com/gemini-cli-extensions/data-agent-kit-starter-pack/blob/42e9b54f582af24b462729d7c82b451aaee1fbfd/skills/bigquery-sql/SKILL.md"
            },
            {
              "name": "bigtable-basics",
              "sourceUrl": "https://github.com/gemini-cli-extensions/data-agent-kit-starter-pack/blob/42e9b54f582af24b462729d7c82b451aaee1fbfd/skills/bigtable-basics/SKILL.md"
            },
            {
              "name": "building-data-apps",
              "sourceUrl": "https://github.com/gemini-cli-extensions/data-agent-kit-starter-pack/blob/42e9b54f582af24b462729d7c82b451aaee1fbfd/skills/building-data-apps/SKILL.md"
            },
            {
              "name": "data-autocleaning",
              "sourceUrl": "https://github.com/gemini-cli-extensions/data-agent-kit-starter-pack/blob/42e9b54f582af24b462729d7c82b451aaee1fbfd/skills/data-autocleaning/SKILL.md"
            },
            {
              "name": "dataform-bigquery",
              "sourceUrl": "https://github.com/gemini-cli-extensions/data-agent-kit-starter-pack/blob/42e9b54f582af24b462729d7c82b451aaee1fbfd/skills/dataform-bigquery/SKILL.md"
            },
            {
              "name": "dbt-bigquery",
              "sourceUrl": "https://github.com/gemini-cli-extensions/data-agent-kit-starter-pack/blob/42e9b54f582af24b462729d7c82b451aaee1fbfd/skills/dbt-bigquery/SKILL.md"
            },
            {
              "name": "discovering-gcp-data-assets",
              "sourceUrl": "https://github.com/gemini-cli-extensions/data-agent-kit-starter-pack/blob/42e9b54f582af24b462729d7c82b451aaee1fbfd/skills/discovering-gcp-data-assets/SKILL.md"
            },
            {
              "name": "enforcing-resource-attribution",
              "sourceUrl": "https://github.com/gemini-cli-extensions/data-agent-kit-starter-pack/blob/42e9b54f582af24b462729d7c82b451aaee1fbfd/skills/enforcing-resource-attribution/SKILL.md"
            },
            {
              "name": "federate-lakehouse-catalog",
              "sourceUrl": "https://github.com/gemini-cli-extensions/data-agent-kit-starter-pack/blob/42e9b54f582af24b462729d7c82b451aaee1fbfd/skills/federate-lakehouse-catalog/SKILL.md"
            },
            {
              "name": "gcp-composer-troubleshooting",
              "sourceUrl": "https://github.com/gemini-cli-extensions/data-agent-kit-starter-pack/blob/42e9b54f582af24b462729d7c82b451aaee1fbfd/skills/gcp-composer-troubleshooting/SKILL.md"
            },
            {
              "name": "gcp-data-pipelines",
              "sourceUrl": "https://github.com/gemini-cli-extensions/data-agent-kit-starter-pack/blob/42e9b54f582af24b462729d7c82b451aaee1fbfd/skills/gcp-data-pipelines/SKILL.md"
            },
            {
              "name": "gcp-dataflow",
              "sourceUrl": "https://github.com/gemini-cli-extensions/data-agent-kit-starter-pack/blob/42e9b54f582af24b462729d7c82b451aaee1fbfd/skills/gcp-dataflow/SKILL.md"
            },
            {
              "name": "gcp-managed-airflow-dag-authoring",
              "sourceUrl": "https://github.com/gemini-cli-extensions/data-agent-kit-starter-pack/blob/42e9b54f582af24b462729d7c82b451aaee1fbfd/skills/gcp-managed-airflow-dag-authoring/SKILL.md"
            },
            {
              "name": "gcp-managed-airflow-migrations",
              "sourceUrl": "https://github.com/gemini-cli-extensions/data-agent-kit-starter-pack/blob/42e9b54f582af24b462729d7c82b451aaee1fbfd/skills/gcp-managed-airflow-migrations/SKILL.md"
            },
            {
              "name": "gcp-managed-airflow-recommendations",
              "sourceUrl": "https://github.com/gemini-cli-extensions/data-agent-kit-starter-pack/blob/42e9b54f582af24b462729d7c82b451aaee1fbfd/skills/gcp-managed-airflow-recommendations/SKILL.md"
            },
            {
              "name": "gcp-pipeline-orchestration",
              "sourceUrl": "https://github.com/gemini-cli-extensions/data-agent-kit-starter-pack/blob/42e9b54f582af24b462729d7c82b451aaee1fbfd/skills/gcp-pipeline-orchestration/SKILL.md"
            },
            {
              "name": "gcp-pipeline-resource-provisioning",
              "sourceUrl": "https://github.com/gemini-cli-extensions/data-agent-kit-starter-pack/blob/42e9b54f582af24b462729d7c82b451aaee1fbfd/skills/gcp-pipeline-resource-provisioning/SKILL.md"
            },
            {
              "name": "gcp-spark",
              "sourceUrl": "https://github.com/gemini-cli-extensions/data-agent-kit-starter-pack/blob/42e9b54f582af24b462729d7c82b451aaee1fbfd/skills/gcp-spark/SKILL.md"
            },
            {
              "name": "gcs-security-assessment",
              "sourceUrl": "https://github.com/gemini-cli-extensions/data-agent-kit-starter-pack/blob/42e9b54f582af24b462729d7c82b451aaee1fbfd/skills/gcs-security-assessment/SKILL.md"
            },
            {
              "name": "google-cloud-auth-verification",
              "sourceUrl": "https://github.com/gemini-cli-extensions/data-agent-kit-starter-pack/blob/42e9b54f582af24b462729d7c82b451aaee1fbfd/skills/google-cloud-auth-verification/SKILL.md"
            },
            {
              "name": "google-cloud-storage-basics",
              "sourceUrl": "https://github.com/gemini-cli-extensions/data-agent-kit-starter-pack/blob/42e9b54f582af24b462729d7c82b451aaee1fbfd/skills/google-cloud-storage-basics/SKILL.md"
            },
            {
              "name": "google-cloud-storage-bucket-architect",
              "sourceUrl": "https://github.com/gemini-cli-extensions/data-agent-kit-starter-pack/blob/42e9b54f582af24b462729d7c82b451aaee1fbfd/skills/google-cloud-storage-bucket-architect/SKILL.md"
            },
            {
              "name": "google-cloud-storage-fuse",
              "sourceUrl": "https://github.com/gemini-cli-extensions/data-agent-kit-starter-pack/blob/42e9b54f582af24b462729d7c82b451aaee1fbfd/skills/google-cloud-storage-fuse/SKILL.md"
            },
            {
              "name": "managing-python-dependencies",
              "sourceUrl": "https://github.com/gemini-cli-extensions/data-agent-kit-starter-pack/blob/42e9b54f582af24b462729d7c82b451aaee1fbfd/skills/managing-python-dependencies/SKILL.md"
            },
            {
              "name": "ml-best-practices",
              "sourceUrl": "https://github.com/gemini-cli-extensions/data-agent-kit-starter-pack/blob/42e9b54f582af24b462729d7c82b451aaee1fbfd/skills/ml-best-practices/SKILL.md"
            },
            {
              "name": "notebook-guidance",
              "sourceUrl": "https://github.com/gemini-cli-extensions/data-agent-kit-starter-pack/blob/42e9b54f582af24b462729d7c82b451aaee1fbfd/skills/notebook-guidance/SKILL.md"
            },
            {
              "name": "resolving-mcp-region-configs",
              "sourceUrl": "https://github.com/gemini-cli-extensions/data-agent-kit-starter-pack/blob/42e9b54f582af24b462729d7c82b451aaee1fbfd/skills/resolving-mcp-region-configs/SKILL.md"
            },
            {
              "name": "schema-mapping",
              "sourceUrl": "https://github.com/gemini-cli-extensions/data-agent-kit-starter-pack/blob/42e9b54f582af24b462729d7c82b451aaee1fbfd/skills/schema-mapping/SKILL.md"
            }
          ],
          "mcpServers": [],
          "components": ["skills", "mcp"],
          "componentInspection": "repository",
          "inspectionError": null,
          "installation": "requires_adapter",
          "upstream": {
            "source": {
              "source": "url",
              "url": "https://github.com/gemini-cli-extensions/data-agent-kit-starter-pack.git",
              "sha": "42e9b54f582af24b462729d7c82b451aaee1fbfd"
            },
            "policy": null
          }
        },
        {
          "id": "anthropic:data-engineering",
          "name": "data-engineering",
          "displayName": "astronomer-data",
          "description": "Data engineering plugin - warehouse exploration, pipeline authoring, Airflow integration",
          "longDescription": "Data engineering plugin - warehouse exploration, pipeline authoring, Airflow integration",
          "category": null,
          "keywords": [],
          "author": null,
          "version": "0.1.0",
          "license": null,
          "logoUrl": null,
          "darkLogoUrl": null,
          "homepage": "https://github.com/astronomer/agents",
          "sourceUrl": "https://github.com/astronomer/agents/tree/dbd9bb79c4f7b7ac9c1cdd2b4b75213c81f423e5/",
          "skills": [
            {
              "name": "airflow-adapter",
              "sourceUrl": "https://github.com/astronomer/agents/blob/dbd9bb79c4f7b7ac9c1cdd2b4b75213c81f423e5/astro-airflow-mcp/.claude/skills/airflow-adapter/SKILL.md"
            },
            {
              "name": "airflow-hitl",
              "sourceUrl": "https://github.com/astronomer/agents/blob/dbd9bb79c4f7b7ac9c1cdd2b4b75213c81f423e5/skills/airflow-hitl/SKILL.md"
            },
            {
              "name": "airflow-plugins",
              "sourceUrl": "https://github.com/astronomer/agents/blob/dbd9bb79c4f7b7ac9c1cdd2b4b75213c81f423e5/skills/airflow-plugins/SKILL.md"
            },
            {
              "name": "airflow-state-store",
              "sourceUrl": "https://github.com/astronomer/agents/blob/dbd9bb79c4f7b7ac9c1cdd2b4b75213c81f423e5/skills/airflow-state-store/SKILL.md"
            },
            {
              "name": "airflow",
              "sourceUrl": "https://github.com/astronomer/agents/blob/dbd9bb79c4f7b7ac9c1cdd2b4b75213c81f423e5/skills/airflow/SKILL.md"
            },
            {
              "name": "analyzing-data",
              "sourceUrl": "https://github.com/astronomer/agents/blob/dbd9bb79c4f7b7ac9c1cdd2b4b75213c81f423e5/skills/analyzing-data/SKILL.md"
            },
            {
              "name": "annotating-task-lineage",
              "sourceUrl": "https://github.com/astronomer/agents/blob/dbd9bb79c4f7b7ac9c1cdd2b4b75213c81f423e5/skills/annotating-task-lineage/SKILL.md"
            },
            {
              "name": "authoring-dags",
              "sourceUrl": "https://github.com/astronomer/agents/blob/dbd9bb79c4f7b7ac9c1cdd2b4b75213c81f423e5/skills/authoring-dags/SKILL.md"
            },
            {
              "name": "authoring-go-sdk-tasks",
              "sourceUrl": "https://github.com/astronomer/agents/blob/dbd9bb79c4f7b7ac9c1cdd2b4b75213c81f423e5/skills/authoring-go-sdk-tasks/SKILL.md"
            },
            {
              "name": "authoring-java-sdk-tasks",
              "sourceUrl": "https://github.com/astronomer/agents/blob/dbd9bb79c4f7b7ac9c1cdd2b4b75213c81f423e5/skills/authoring-java-sdk-tasks/SKILL.md"
            },
            {
              "name": "authoring-language-sdk-tasks",
              "sourceUrl": "https://github.com/astronomer/agents/blob/dbd9bb79c4f7b7ac9c1cdd2b4b75213c81f423e5/skills/authoring-language-sdk-tasks/SKILL.md"
            },
            {
              "name": "blueprint",
              "sourceUrl": "https://github.com/astronomer/agents/blob/dbd9bb79c4f7b7ac9c1cdd2b4b75213c81f423e5/skills/blueprint/SKILL.md"
            },
            {
              "name": "checking-freshness",
              "sourceUrl": "https://github.com/astronomer/agents/blob/dbd9bb79c4f7b7ac9c1cdd2b4b75213c81f423e5/skills/checking-freshness/SKILL.md"
            },
            {
              "name": "configuring-airflow-language-sdks",
              "sourceUrl": "https://github.com/astronomer/agents/blob/dbd9bb79c4f7b7ac9c1cdd2b4b75213c81f423e5/skills/configuring-airflow-language-sdks/SKILL.md"
            },
            {
              "name": "cosmos-dbt-core",
              "sourceUrl": "https://github.com/astronomer/agents/blob/dbd9bb79c4f7b7ac9c1cdd2b4b75213c81f423e5/skills/cosmos-dbt-core/SKILL.md"
            },
            {
              "name": "cosmos-dbt-fusion",
              "sourceUrl": "https://github.com/astronomer/agents/blob/dbd9bb79c4f7b7ac9c1cdd2b4b75213c81f423e5/skills/cosmos-dbt-fusion/SKILL.md"
            },
            {
              "name": "creating-openlineage-extractors",
              "sourceUrl": "https://github.com/astronomer/agents/blob/dbd9bb79c4f7b7ac9c1cdd2b4b75213c81f423e5/skills/creating-openlineage-extractors/SKILL.md"
            },
            {
              "name": "dag-factory",
              "sourceUrl": "https://github.com/astronomer/agents/blob/dbd9bb79c4f7b7ac9c1cdd2b4b75213c81f423e5/skills/dag-factory/SKILL.md"
            },
            {
              "name": "debugging-dags",
              "sourceUrl": "https://github.com/astronomer/agents/blob/dbd9bb79c4f7b7ac9c1cdd2b4b75213c81f423e5/skills/debugging-dags/SKILL.md"
            },
            {
              "name": "delegating-to-otto",
              "sourceUrl": "https://github.com/astronomer/agents/blob/dbd9bb79c4f7b7ac9c1cdd2b4b75213c81f423e5/skills/delegating-to-otto/SKILL.md"
            },
            {
              "name": "deploying-airflow",
              "sourceUrl": "https://github.com/astronomer/agents/blob/dbd9bb79c4f7b7ac9c1cdd2b4b75213c81f423e5/skills/deploying-airflow/SKILL.md"
            },
            {
              "name": "deploying-go-sdk-bundles",
              "sourceUrl": "https://github.com/astronomer/agents/blob/dbd9bb79c4f7b7ac9c1cdd2b4b75213c81f423e5/skills/deploying-go-sdk-bundles/SKILL.md"
            },
            {
              "name": "deploying-java-sdk-bundles",
              "sourceUrl": "https://github.com/astronomer/agents/blob/dbd9bb79c4f7b7ac9c1cdd2b4b75213c81f423e5/skills/deploying-java-sdk-bundles/SKILL.md"
            },
            {
              "name": "managing-astro-deployments",
              "sourceUrl": "https://github.com/astronomer/agents/blob/dbd9bb79c4f7b7ac9c1cdd2b4b75213c81f423e5/skills/managing-astro-deployments/SKILL.md"
            },
            {
              "name": "managing-astro-local-env",
              "sourceUrl": "https://github.com/astronomer/agents/blob/dbd9bb79c4f7b7ac9c1cdd2b4b75213c81f423e5/skills/managing-astro-local-env/SKILL.md"
            },
            {
              "name": "migrating-ai-sdk-to-common-ai",
              "sourceUrl": "https://github.com/astronomer/agents/blob/dbd9bb79c4f7b7ac9c1cdd2b4b75213c81f423e5/skills/migrating-ai-sdk-to-common-ai/SKILL.md"
            },
            {
              "name": "migrating-airflow-2-to-3",
              "sourceUrl": "https://github.com/astronomer/agents/blob/dbd9bb79c4f7b7ac9c1cdd2b4b75213c81f423e5/skills/migrating-airflow-2-to-3/SKILL.md"
            },
            {
              "name": "migrating-dagster-to-airflow",
              "sourceUrl": "https://github.com/astronomer/agents/blob/dbd9bb79c4f7b7ac9c1cdd2b4b75213c81f423e5/skills/migrating-dagster-to-airflow/SKILL.md"
            },
            {
              "name": "profiling-tables",
              "sourceUrl": "https://github.com/astronomer/agents/blob/dbd9bb79c4f7b7ac9c1cdd2b4b75213c81f423e5/skills/profiling-tables/SKILL.md"
            },
            {
              "name": "setting-up-astro-project",
              "sourceUrl": "https://github.com/astronomer/agents/blob/dbd9bb79c4f7b7ac9c1cdd2b4b75213c81f423e5/skills/setting-up-astro-project/SKILL.md"
            },
            {
              "name": "testing-dags",
              "sourceUrl": "https://github.com/astronomer/agents/blob/dbd9bb79c4f7b7ac9c1cdd2b4b75213c81f423e5/skills/testing-dags/SKILL.md"
            },
            {
              "name": "tracing-downstream-lineage",
              "sourceUrl": "https://github.com/astronomer/agents/blob/dbd9bb79c4f7b7ac9c1cdd2b4b75213c81f423e5/skills/tracing-downstream-lineage/SKILL.md"
            },
            {
              "name": "tracing-upstream-lineage",
              "sourceUrl": "https://github.com/astronomer/agents/blob/dbd9bb79c4f7b7ac9c1cdd2b4b75213c81f423e5/skills/tracing-upstream-lineage/SKILL.md"
            },
            {
              "name": "troubleshooting-astro-deployments",
              "sourceUrl": "https://github.com/astronomer/agents/blob/dbd9bb79c4f7b7ac9c1cdd2b4b75213c81f423e5/skills/troubleshooting-astro-deployments/SKILL.md"
            },
            {
              "name": "warehouse-init",
              "sourceUrl": "https://github.com/astronomer/agents/blob/dbd9bb79c4f7b7ac9c1cdd2b4b75213c81f423e5/skills/warehouse-init/SKILL.md"
            }
          ],
          "mcpServers": [],
          "components": ["skills"],
          "componentInspection": "repository",
          "inspectionError": null,
          "installation": "requires_adapter",
          "upstream": {
            "source": {
              "source": "url",
              "url": "https://github.com/astronomer/agents.git",
              "sha": "dbd9bb79c4f7b7ac9c1cdd2b4b75213c81f423e5"
            },
            "policy": null
          }
        },
        {
          "id": "anthropic:databases-on-aws",
          "name": "databases-on-aws",
          "displayName": "databases-on-aws",
          "description": "Expert database guidance for the AWS database portfolio. Design schemas, execute queries, handle migrations, and choose the right database for your workload.",
          "longDescription": "Expert database guidance for the AWS database portfolio. Design schemas, execute queries, handle migrations, and choose the right database for your workload.",
          "category": "database",
          "keywords": [
            "aws",
            "aurora",
            "database",
            "databases",
            "distributed-sql",
            "dsql",
            "iam-auth",
            "migration",
            "postgresql",
            "postgres",
            "schema",
            "serverless",
            "sql"
          ],
          "author": {
            "name": "Amazon Web Services"
          },
          "version": "1.8.1",
          "license": "Apache-2.0",
          "logoUrl": null,
          "darkLogoUrl": null,
          "homepage": "https://github.com/awslabs/agent-plugins",
          "sourceUrl": "https://github.com/awslabs/agent-plugins/tree/026f03dc9a2f217ab96aa61f87f10fe8c09e067d/plugins/databases-on-aws",
          "skills": [
            {
              "name": "dsql",
              "sourceUrl": "https://github.com/awslabs/agent-plugins/blob/026f03dc9a2f217ab96aa61f87f10fe8c09e067d/plugins/databases-on-aws/skills/dsql/SKILL.md"
            }
          ],
          "mcpServers": [
            {
              "requiresConfiguration": false,
              "name": "awsknowledge",
              "transport": "http",
              "endpoint": "https://knowledge-mcp.global.api.aws"
            },
            {
              "requiresConfiguration": false,
              "name": "aurora-dsql",
              "transport": "stdio",
              "endpoint": null
            },
            {
              "requiresConfiguration": false,
              "name": "cloudwatch",
              "transport": "stdio",
              "endpoint": null
            }
          ],
          "components": ["skills", "mcp", "hooks"],
          "componentInspection": "repository",
          "inspectionError": null,
          "installation": "requires_adapter",
          "upstream": {
            "source": {
              "source": "git-subdir",
              "url": "https://github.com/awslabs/agent-plugins.git",
              "path": "plugins/databases-on-aws",
              "ref": "main",
              "sha": "026f03dc9a2f217ab96aa61f87f10fe8c09e067d"
            },
            "policy": null
          }
        },
        {
          "id": "anthropic:databricks",
          "name": "databricks",
          "displayName": "databricks",
          "description": "Databricks skills for the CLI, Apps, Lakebase, Model Serving, Lakeflow Jobs, Spark Declarative Pipelines, Declarative Automation Bundles (DABs), and classic-to-serverless migration.",
          "longDescription": "Databricks skills for the CLI, Apps, Lakebase, Model Serving, Lakeflow Jobs, Spark Declarative Pipelines, Declarative Automation Bundles (DABs), and classic-to-serverless migration.",
          "category": "database",
          "keywords": [
            "databricks",
            "cli",
            "data-discovery",
            "apps",
            "app-design",
            "lakebase",
            "model-serving",
            "jobs",
            "pipelines",
            "dabs",
            "serverless",
            "vector-search",
            "agent-bricks",
            "ai-functions",
            "aibi-dashboards",
            "apps-python",
            "dbsql",
            "docs",
            "execution-compute",
            "genie-agents",
            "iceberg",
            "lakeflow-connect",
            "metric-views",
            "ml-training",
            "mlflow-evaluation",
            "python-sdk",
            "setup-local",
            "structured-streaming",
            "synthetic-data",
            "unity-catalog",
            "pdf-generation",
            "zerobus",
            "data-engineering"
          ],
          "author": {
            "name": "Databricks",
            "url": "https://databricks.com"
          },
          "version": "0.2.14",
          "license": "LicenseRef-Databricks",
          "logoUrl": null,
          "darkLogoUrl": null,
          "homepage": "https://github.com/databricks/databricks-agent-skills",
          "sourceUrl": "https://github.com/databricks/databricks-agent-skills/tree/eac3d8cf1d635360c686bbe38110580d194272e3/plugins/databricks/claude",
          "skills": [
            {
              "name": "databricks-agent-bricks",
              "sourceUrl": "https://github.com/databricks/databricks-agent-skills/blob/eac3d8cf1d635360c686bbe38110580d194272e3/plugins/databricks/claude/skills/databricks-agent-bricks/SKILL.md"
            },
            {
              "name": "databricks-ai-functions",
              "sourceUrl": "https://github.com/databricks/databricks-agent-skills/blob/eac3d8cf1d635360c686bbe38110580d194272e3/plugins/databricks/claude/skills/databricks-ai-functions/SKILL.md"
            },
            {
              "name": "databricks-aibi-dashboards",
              "sourceUrl": "https://github.com/databricks/databricks-agent-skills/blob/eac3d8cf1d635360c686bbe38110580d194272e3/plugins/databricks/claude/skills/databricks-aibi-dashboards/SKILL.md"
            },
            {
              "name": "databricks-app-design",
              "sourceUrl": "https://github.com/databricks/databricks-agent-skills/blob/eac3d8cf1d635360c686bbe38110580d194272e3/plugins/databricks/claude/skills/databricks-app-design/SKILL.md"
            },
            {
              "name": "databricks-apps-python",
              "sourceUrl": "https://github.com/databricks/databricks-agent-skills/blob/eac3d8cf1d635360c686bbe38110580d194272e3/plugins/databricks/claude/skills/databricks-apps-python/SKILL.md"
            },
            {
              "name": "databricks-apps",
              "sourceUrl": "https://github.com/databricks/databricks-agent-skills/blob/eac3d8cf1d635360c686bbe38110580d194272e3/plugins/databricks/claude/skills/databricks-apps/SKILL.md"
            },
            {
              "name": "databricks-core",
              "sourceUrl": "https://github.com/databricks/databricks-agent-skills/blob/eac3d8cf1d635360c686bbe38110580d194272e3/plugins/databricks/claude/skills/databricks-core/SKILL.md"
            },
            {
              "name": "databricks-dabs",
              "sourceUrl": "https://github.com/databricks/databricks-agent-skills/blob/eac3d8cf1d635360c686bbe38110580d194272e3/plugins/databricks/claude/skills/databricks-dabs/SKILL.md"
            },
            {
              "name": "databricks-data-discovery",
              "sourceUrl": "https://github.com/databricks/databricks-agent-skills/blob/eac3d8cf1d635360c686bbe38110580d194272e3/plugins/databricks/claude/skills/databricks-data-discovery/SKILL.md"
            },
            {
              "name": "databricks-dbsql",
              "sourceUrl": "https://github.com/databricks/databricks-agent-skills/blob/eac3d8cf1d635360c686bbe38110580d194272e3/plugins/databricks/claude/skills/databricks-dbsql/SKILL.md"
            },
            {
              "name": "databricks-docs",
              "sourceUrl": "https://github.com/databricks/databricks-agent-skills/blob/eac3d8cf1d635360c686bbe38110580d194272e3/plugins/databricks/claude/skills/databricks-docs/SKILL.md"
            },
            {
              "name": "databricks-execution-compute",
              "sourceUrl": "https://github.com/databricks/databricks-agent-skills/blob/eac3d8cf1d635360c686bbe38110580d194272e3/plugins/databricks/claude/skills/databricks-execution-compute/SKILL.md"
            },
            {
              "name": "databricks-genie-agents",
              "sourceUrl": "https://github.com/databricks/databricks-agent-skills/blob/eac3d8cf1d635360c686bbe38110580d194272e3/plugins/databricks/claude/skills/databricks-genie-agents/SKILL.md"
            },
            {
              "name": "databricks-iceberg",
              "sourceUrl": "https://github.com/databricks/databricks-agent-skills/blob/eac3d8cf1d635360c686bbe38110580d194272e3/plugins/databricks/claude/skills/databricks-iceberg/SKILL.md"
            },
            {
              "name": "databricks-jobs",
              "sourceUrl": "https://github.com/databricks/databricks-agent-skills/blob/eac3d8cf1d635360c686bbe38110580d194272e3/plugins/databricks/claude/skills/databricks-jobs/SKILL.md"
            },
            {
              "name": "databricks-lakebase",
              "sourceUrl": "https://github.com/databricks/databricks-agent-skills/blob/eac3d8cf1d635360c686bbe38110580d194272e3/plugins/databricks/claude/skills/databricks-lakebase/SKILL.md"
            },
            {
              "name": "databricks-lakeflow-connect",
              "sourceUrl": "https://github.com/databricks/databricks-agent-skills/blob/eac3d8cf1d635360c686bbe38110580d194272e3/plugins/databricks/claude/skills/databricks-lakeflow-connect/SKILL.md"
            },
            {
              "name": "databricks-metric-views",
              "sourceUrl": "https://github.com/databricks/databricks-agent-skills/blob/eac3d8cf1d635360c686bbe38110580d194272e3/plugins/databricks/claude/skills/databricks-metric-views/SKILL.md"
            },
            {
              "name": "databricks-ml-training",
              "sourceUrl": "https://github.com/databricks/databricks-agent-skills/blob/eac3d8cf1d635360c686bbe38110580d194272e3/plugins/databricks/claude/skills/databricks-ml-training/SKILL.md"
            },
            {
              "name": "databricks-mlflow-evaluation",
              "sourceUrl": "https://github.com/databricks/databricks-agent-skills/blob/eac3d8cf1d635360c686bbe38110580d194272e3/plugins/databricks/claude/skills/databricks-mlflow-evaluation/SKILL.md"
            },
            {
              "name": "databricks-model-serving",
              "sourceUrl": "https://github.com/databricks/databricks-agent-skills/blob/eac3d8cf1d635360c686bbe38110580d194272e3/plugins/databricks/claude/skills/databricks-model-serving/SKILL.md"
            },
            {
              "name": "databricks-pipelines",
              "sourceUrl": "https://github.com/databricks/databricks-agent-skills/blob/eac3d8cf1d635360c686bbe38110580d194272e3/plugins/databricks/claude/skills/databricks-pipelines/SKILL.md"
            },
            {
              "name": "databricks-python-sdk",
              "sourceUrl": "https://github.com/databricks/databricks-agent-skills/blob/eac3d8cf1d635360c686bbe38110580d194272e3/plugins/databricks/claude/skills/databricks-python-sdk/SKILL.md"
            },
            {
              "name": "databricks-serverless-migration",
              "sourceUrl": "https://github.com/databricks/databricks-agent-skills/blob/eac3d8cf1d635360c686bbe38110580d194272e3/plugins/databricks/claude/skills/databricks-serverless-migration/SKILL.md"
            },
            {
              "name": "databricks-setup-local",
              "sourceUrl": "https://github.com/databricks/databricks-agent-skills/blob/eac3d8cf1d635360c686bbe38110580d194272e3/plugins/databricks/claude/skills/databricks-setup-local/SKILL.md"
            },
            {
              "name": "databricks-spark-structured-streaming",
              "sourceUrl": "https://github.com/databricks/databricks-agent-skills/blob/eac3d8cf1d635360c686bbe38110580d194272e3/plugins/databricks/claude/skills/databricks-spark-structured-streaming/SKILL.md"
            },
            {
              "name": "databricks-synthetic-data-gen",
              "sourceUrl": "https://github.com/databricks/databricks-agent-skills/blob/eac3d8cf1d635360c686bbe38110580d194272e3/plugins/databricks/claude/skills/databricks-synthetic-data-gen/SKILL.md"
            },
            {
              "name": "databricks-unity-catalog",
              "sourceUrl": "https://github.com/databricks/databricks-agent-skills/blob/eac3d8cf1d635360c686bbe38110580d194272e3/plugins/databricks/claude/skills/databricks-unity-catalog/SKILL.md"
            },
            {
              "name": "databricks-unstructured-pdf-generation",
              "sourceUrl": "https://github.com/databricks/databricks-agent-skills/blob/eac3d8cf1d635360c686bbe38110580d194272e3/plugins/databricks/claude/skills/databricks-unstructured-pdf-generation/SKILL.md"
            },
            {
              "name": "databricks-vector-search",
              "sourceUrl": "https://github.com/databricks/databricks-agent-skills/blob/eac3d8cf1d635360c686bbe38110580d194272e3/plugins/databricks/claude/skills/databricks-vector-search/SKILL.md"
            },
            {
              "name": "databricks-zerobus-ingest",
              "sourceUrl": "https://github.com/databricks/databricks-agent-skills/blob/eac3d8cf1d635360c686bbe38110580d194272e3/plugins/databricks/claude/skills/databricks-zerobus-ingest/SKILL.md"
            }
          ],
          "mcpServers": [],
          "components": ["skills", "hooks", "commands"],
          "componentInspection": "repository",
          "inspectionError": null,
          "installation": "requires_adapter",
          "upstream": {
            "source": {
              "source": "git-subdir",
              "url": "https://github.com/databricks/databricks-agent-skills.git",
              "path": "plugins/databricks/claude",
              "ref": "main",
              "sha": "eac3d8cf1d635360c686bbe38110580d194272e3"
            },
            "policy": null
          }
        },
        {
          "id": "anthropic:datadog",
          "name": "datadog",
          "displayName": "datadog",
          "description": "Use Datadog directly in Claude Code through a preconfigured Datadog MCP server. Query logs, metrics, traces, dashboards, and more through natural conversation. This plugin is in preview.",
          "longDescription": "Use Datadog directly in Claude Code through a preconfigured Datadog MCP server. Query logs, metrics, traces, dashboards, and more through natural conversation. This plugin is in preview.",
          "category": "monitoring",
          "keywords": ["datadog", "infrastructure", "mcp", "observability", "productivity"],
          "author": {
            "name": "Datadog"
          },
          "version": "0.7.17",
          "license": null,
          "logoUrl": null,
          "darkLogoUrl": null,
          "homepage": "https://www.datadoghq.com/",
          "sourceUrl": "https://github.com/datadog-labs/claude-code-plugin/tree/195f570c002beab3d7bd342739034d0019aa4863/",
          "skills": [
            {
              "name": "datadog-app",
              "sourceUrl": "https://github.com/datadog-labs/claude-code-plugin/blob/195f570c002beab3d7bd342739034d0019aa4863/skills/datadog-app/SKILL.md"
            },
            {
              "name": "ddconfig",
              "sourceUrl": "https://github.com/datadog-labs/claude-code-plugin/blob/195f570c002beab3d7bd342739034d0019aa4863/skills/ddconfig/SKILL.md"
            },
            {
              "name": "ddsetup",
              "sourceUrl": "https://github.com/datadog-labs/claude-code-plugin/blob/195f570c002beab3d7bd342739034d0019aa4863/skills/ddsetup/SKILL.md"
            },
            {
              "name": "ddtoolsets",
              "sourceUrl": "https://github.com/datadog-labs/claude-code-plugin/blob/195f570c002beab3d7bd342739034d0019aa4863/skills/ddtoolsets/SKILL.md"
            },
            {
              "name": "ddviz",
              "sourceUrl": "https://github.com/datadog-labs/claude-code-plugin/blob/195f570c002beab3d7bd342739034d0019aa4863/skills/ddviz/SKILL.md"
            }
          ],
          "mcpServers": [],
          "components": ["skills", "mcp", "hooks"],
          "componentInspection": "repository",
          "inspectionError": null,
          "installation": "requires_adapter",
          "upstream": {
            "source": {
              "source": "url",
              "url": "https://github.com/datadog-labs/claude-code-plugin.git",
              "sha": "195f570c002beab3d7bd342739034d0019aa4863"
            },
            "policy": null
          }
        },
        {
          "id": "anthropic:datahub-skills",
          "name": "datahub-skills",
          "displayName": "datahub-skills",
          "description": "DataHub development and interaction toolkit with connector planning, PR review, catalog search, metadata enrichment, lineage tracing, data quality management, and connection setup skills",
          "longDescription": "DataHub development and interaction toolkit with connector planning, PR review, catalog search, metadata enrichment, lineage tracing, data quality management, and connection setup skills",
          "category": "database",
          "keywords": [],
          "author": {
            "name": "DataHub Project"
          },
          "version": "1.4.1",
          "license": null,
          "logoUrl": null,
          "darkLogoUrl": null,
          "homepage": "https://datahub.com",
          "sourceUrl": "https://github.com/datahub-project/datahub-skills/tree/c6d0ded76eca4c649276e39ab376ad6c66142eb7/",
          "skills": [
            {
              "name": "datahub-connector-planning",
              "sourceUrl": "https://github.com/datahub-project/datahub-skills/blob/c6d0ded76eca4c649276e39ab376ad6c66142eb7/skills/datahub-connector-planning/SKILL.md"
            },
            {
              "name": "datahub-connector-pr-review",
              "sourceUrl": "https://github.com/datahub-project/datahub-skills/blob/c6d0ded76eca4c649276e39ab376ad6c66142eb7/skills/datahub-connector-pr-review/SKILL.md"
            },
            {
              "name": "datahub-enrich",
              "sourceUrl": "https://github.com/datahub-project/datahub-skills/blob/c6d0ded76eca4c649276e39ab376ad6c66142eb7/skills/datahub-enrich/SKILL.md"
            },
            {
              "name": "datahub-evals",
              "sourceUrl": "https://github.com/datahub-project/datahub-skills/blob/c6d0ded76eca4c649276e39ab376ad6c66142eb7/skills/datahub-evals/SKILL.md"
            },
            {
              "name": "datahub-lineage",
              "sourceUrl": "https://github.com/datahub-project/datahub-skills/blob/c6d0ded76eca4c649276e39ab376ad6c66142eb7/skills/datahub-lineage/SKILL.md"
            },
            {
              "name": "datahub-mfe-configure-app",
              "sourceUrl": "https://github.com/datahub-project/datahub-skills/blob/c6d0ded76eca4c649276e39ab376ad6c66142eb7/skills/datahub-mfe-configure-app/SKILL.md"
            },
            {
              "name": "datahub-mfe-create-app",
              "sourceUrl": "https://github.com/datahub-project/datahub-skills/blob/c6d0ded76eca4c649276e39ab376ad6c66142eb7/skills/datahub-mfe-create-app/SKILL.md"
            },
            {
              "name": "datahub-quality",
              "sourceUrl": "https://github.com/datahub-project/datahub-skills/blob/c6d0ded76eca4c649276e39ab376ad6c66142eb7/skills/datahub-quality/SKILL.md"
            },
            {
              "name": "datahub-search",
              "sourceUrl": "https://github.com/datahub-project/datahub-skills/blob/c6d0ded76eca4c649276e39ab376ad6c66142eb7/skills/datahub-search/SKILL.md"
            },
            {
              "name": "datahub-setup",
              "sourceUrl": "https://github.com/datahub-project/datahub-skills/blob/c6d0ded76eca4c649276e39ab376ad6c66142eb7/skills/datahub-setup/SKILL.md"
            },
            {
              "name": "datahub-sql-workflow",
              "sourceUrl": "https://github.com/datahub-project/datahub-skills/blob/c6d0ded76eca4c649276e39ab376ad6c66142eb7/skills/datahub-sql-workflow/SKILL.md"
            },
            {
              "name": "load-standards",
              "sourceUrl": "https://github.com/datahub-project/datahub-skills/blob/c6d0ded76eca4c649276e39ab376ad6c66142eb7/skills/load-standards/SKILL.md"
            },
            {
              "name": "using-datahub",
              "sourceUrl": "https://github.com/datahub-project/datahub-skills/blob/c6d0ded76eca4c649276e39ab376ad6c66142eb7/skills/using-datahub/SKILL.md"
            }
          ],
          "mcpServers": [],
          "components": ["skills", "agents", "commands"],
          "componentInspection": "repository",
          "inspectionError": null,
          "installation": "requires_adapter",
          "upstream": {
            "source": {
              "source": "url",
              "url": "https://github.com/datahub-project/datahub-skills.git",
              "sha": "c6d0ded76eca4c649276e39ab376ad6c66142eb7"
            },
            "policy": null
          }
        },
        {
          "id": "anthropic:dataproc",
          "name": "dataproc",
          "displayName": "dataproc",
          "description": "Manage Dataproc clusters and jobs.",
          "longDescription": "Manage Dataproc clusters and jobs.",
          "category": "database",
          "keywords": [],
          "author": {
            "name": "Google LLC",
            "email": "data-cloud-ai-integrations@google.com"
          },
          "version": "0.1.0",
          "license": "Apache-2.0",
          "logoUrl": null,
          "darkLogoUrl": null,
          "homepage": "https://cloud.google.com/dataproc",
          "sourceUrl": "https://github.com/gemini-cli-extensions/dataproc/tree/afbd516845a34fcf460ec447b81868bc48962b0f/",
          "skills": [],
          "mcpServers": [
            {
              "requiresConfiguration": false,
              "name": "dataproc",
              "transport": "stdio",
              "endpoint": null
            }
          ],
          "components": ["mcp"],
          "componentInspection": "repository",
          "inspectionError": null,
          "installation": "requires_adapter",
          "upstream": {
            "source": {
              "source": "url",
              "url": "https://github.com/gemini-cli-extensions/dataproc.git",
              "sha": "afbd516845a34fcf460ec447b81868bc48962b0f"
            },
            "policy": null
          }
        },
        {
          "id": "anthropic:datarobot-agent-skills",
          "name": "datarobot-agent-skills",
          "displayName": "datarobot-agent-skills",
          "description": "DataRobot skills for AI/ML workflows — model training, deployment, predictions, feature engineering, monitoring, explainability, data preparation, App Framework CI/CD, and external agent monitoring.",
          "longDescription": "DataRobot skills for AI/ML workflows — model training, deployment, predictions, feature engineering, monitoring, explainability, data preparation, App Framework CI/CD, and external agent monitoring.",
          "category": "development",
          "keywords": [],
          "author": {
            "name": "DataRobot"
          },
          "version": "1.8.0",
          "license": null,
          "logoUrl": null,
          "darkLogoUrl": null,
          "homepage": "https://datarobot.com",
          "sourceUrl": "https://github.com/datarobot-oss/datarobot-agent-skills/tree/e6dddbe327dc2c83e9b7677a5577d33a1063feaf/",
          "skills": [
            {
              "name": "progressive-disclosure",
              "sourceUrl": "https://github.com/datarobot-oss/datarobot-agent-skills/blob/e6dddbe327dc2c83e9b7677a5577d33a1063feaf/.skills/progressive-disclosure/SKILL.md"
            },
            {
              "name": "datarobot-agent-assist",
              "sourceUrl": "https://github.com/datarobot-oss/datarobot-agent-skills/blob/e6dddbe327dc2c83e9b7677a5577d33a1063feaf/skills/datarobot-agent-assist/SKILL.md"
            },
            {
              "name": "agent-assist-build",
              "sourceUrl": "https://github.com/datarobot-oss/datarobot-agent-skills/blob/e6dddbe327dc2c83e9b7677a5577d33a1063feaf/skills/datarobot-agent-assist/agent-assist-build/SKILL.md"
            },
            {
              "name": "agent-assist-simulate",
              "sourceUrl": "https://github.com/datarobot-oss/datarobot-agent-skills/blob/e6dddbe327dc2c83e9b7677a5577d33a1063feaf/skills/datarobot-agent-assist/agent-assist-simulate/SKILL.md"
            },
            {
              "name": "datarobot-agent-llm-selection",
              "sourceUrl": "https://github.com/datarobot-oss/datarobot-agent-skills/blob/e6dddbe327dc2c83e9b7677a5577d33a1063feaf/skills/datarobot-agent-llm-selection/SKILL.md"
            },
            {
              "name": "datarobot-app-framework-cicd",
              "sourceUrl": "https://github.com/datarobot-oss/datarobot-agent-skills/blob/e6dddbe327dc2c83e9b7677a5577d33a1063feaf/skills/datarobot-app-framework-cicd/SKILL.md"
            },
            {
              "name": "datarobot-data-preparation",
              "sourceUrl": "https://github.com/datarobot-oss/datarobot-agent-skills/blob/e6dddbe327dc2c83e9b7677a5577d33a1063feaf/skills/datarobot-data-preparation/SKILL.md"
            },
            {
              "name": "datarobot-discover",
              "sourceUrl": "https://github.com/datarobot-oss/datarobot-agent-skills/blob/e6dddbe327dc2c83e9b7677a5577d33a1063feaf/skills/datarobot-discover/SKILL.md"
            },
            {
              "name": "datarobot-external-agent-monitoring",
              "sourceUrl": "https://github.com/datarobot-oss/datarobot-agent-skills/blob/e6dddbe327dc2c83e9b7677a5577d33a1063feaf/skills/datarobot-external-agent-monitoring/SKILL.md"
            },
            {
              "name": "datarobot-feature-engineering",
              "sourceUrl": "https://github.com/datarobot-oss/datarobot-agent-skills/blob/e6dddbe327dc2c83e9b7677a5577d33a1063feaf/skills/datarobot-feature-engineering/SKILL.md"
            },
            {
              "name": "datarobot-model-deployment",
              "sourceUrl": "https://github.com/datarobot-oss/datarobot-agent-skills/blob/e6dddbe327dc2c83e9b7677a5577d33a1063feaf/skills/datarobot-model-deployment/SKILL.md"
            },
            {
              "name": "datarobot-model-explainability",
              "sourceUrl": "https://github.com/datarobot-oss/datarobot-agent-skills/blob/e6dddbe327dc2c83e9b7677a5577d33a1063feaf/skills/datarobot-model-explainability/SKILL.md"
            },
            {
              "name": "datarobot-model-monitoring",
              "sourceUrl": "https://github.com/datarobot-oss/datarobot-agent-skills/blob/e6dddbe327dc2c83e9b7677a5577d33a1063feaf/skills/datarobot-model-monitoring/SKILL.md"
            },
            {
              "name": "datarobot-model-training",
              "sourceUrl": "https://github.com/datarobot-oss/datarobot-agent-skills/blob/e6dddbe327dc2c83e9b7677a5577d33a1063feaf/skills/datarobot-model-training/SKILL.md"
            },
            {
              "name": "datarobot-predictions",
              "sourceUrl": "https://github.com/datarobot-oss/datarobot-agent-skills/blob/e6dddbe327dc2c83e9b7677a5577d33a1063feaf/skills/datarobot-predictions/SKILL.md"
            },
            {
              "name": "datarobot-setup",
              "sourceUrl": "https://github.com/datarobot-oss/datarobot-agent-skills/blob/e6dddbe327dc2c83e9b7677a5577d33a1063feaf/skills/datarobot-setup/SKILL.md"
            },
            {
              "name": "datarobot-workload-api",
              "sourceUrl": "https://github.com/datarobot-oss/datarobot-agent-skills/blob/e6dddbe327dc2c83e9b7677a5577d33a1063feaf/skills/datarobot-workload-api/SKILL.md"
            }
          ],
          "mcpServers": [],
          "components": ["skills"],
          "componentInspection": "repository",
          "inspectionError": null,
          "installation": "requires_adapter",
          "upstream": {
            "source": {
              "source": "url",
              "url": "https://github.com/datarobot-oss/datarobot-agent-skills.git",
              "sha": "e6dddbe327dc2c83e9b7677a5577d33a1063feaf"
            },
            "policy": null
          }
        },
        {
          "id": "anthropic:dataverse",
          "name": "dataverse",
          "displayName": "dataverse",
          "description": "Microsoft Dataverse plugin for coding agents, covering record CRUD, bulk data operations, advanced queries, schema and metadata, administration, security, environment management, and solution lifecycle through MCP, CLI, and SDK workflows.",
          "longDescription": "Microsoft Dataverse plugin for coding agents, covering record CRUD, bulk data operations, advanced queries, schema and metadata, administration, security, environment management, and solution lifecycle through MCP, CLI, and SDK workflows.",
          "category": "database",
          "keywords": ["dataverse", "mcp", "power-platform", "dynamics-365"],
          "author": {
            "name": "Microsoft",
            "url": "https://www.microsoft.com"
          },
          "version": "1.12.1",
          "license": "MIT",
          "logoUrl": null,
          "darkLogoUrl": null,
          "homepage": "https://github.com/microsoft/Dataverse-skills",
          "sourceUrl": "https://github.com/microsoft/Dataverse-skills/tree/001b31e0c78e63a0675078ad599e44c16078cd7f/.github/plugins/dataverse",
          "skills": [
            {
              "name": "dv-admin",
              "sourceUrl": "https://github.com/microsoft/Dataverse-skills/blob/001b31e0c78e63a0675078ad599e44c16078cd7f/.github/plugins/dataverse/skills/dv-admin/SKILL.md"
            },
            {
              "name": "dv-connect",
              "sourceUrl": "https://github.com/microsoft/Dataverse-skills/blob/001b31e0c78e63a0675078ad599e44c16078cd7f/.github/plugins/dataverse/skills/dv-connect/SKILL.md"
            },
            {
              "name": "dv-data",
              "sourceUrl": "https://github.com/microsoft/Dataverse-skills/blob/001b31e0c78e63a0675078ad599e44c16078cd7f/.github/plugins/dataverse/skills/dv-data/SKILL.md"
            },
            {
              "name": "dv-metadata",
              "sourceUrl": "https://github.com/microsoft/Dataverse-skills/blob/001b31e0c78e63a0675078ad599e44c16078cd7f/.github/plugins/dataverse/skills/dv-metadata/SKILL.md"
            },
            {
              "name": "dv-overview",
              "sourceUrl": "https://github.com/microsoft/Dataverse-skills/blob/001b31e0c78e63a0675078ad599e44c16078cd7f/.github/plugins/dataverse/skills/dv-overview/SKILL.md"
            },
            {
              "name": "dv-query",
              "sourceUrl": "https://github.com/microsoft/Dataverse-skills/blob/001b31e0c78e63a0675078ad599e44c16078cd7f/.github/plugins/dataverse/skills/dv-query/SKILL.md"
            },
            {
              "name": "dv-security",
              "sourceUrl": "https://github.com/microsoft/Dataverse-skills/blob/001b31e0c78e63a0675078ad599e44c16078cd7f/.github/plugins/dataverse/skills/dv-security/SKILL.md"
            },
            {
              "name": "dv-solution",
              "sourceUrl": "https://github.com/microsoft/Dataverse-skills/blob/001b31e0c78e63a0675078ad599e44c16078cd7f/.github/plugins/dataverse/skills/dv-solution/SKILL.md"
            },
            {
              "name": "erp-xpp",
              "sourceUrl": "https://github.com/microsoft/Dataverse-skills/blob/001b31e0c78e63a0675078ad599e44c16078cd7f/.github/plugins/dataverse/skills/erp-xpp/SKILL.md"
            }
          ],
          "mcpServers": [],
          "components": ["skills"],
          "componentInspection": "repository",
          "inspectionError": null,
          "installation": "requires_adapter",
          "upstream": {
            "source": {
              "source": "git-subdir",
              "url": "https://github.com/microsoft/Dataverse-skills.git",
              "path": ".github/plugins/dataverse",
              "ref": "main",
              "sha": "001b31e0c78e63a0675078ad599e44c16078cd7f"
            },
            "policy": null
          }
        },
        {
          "id": "anthropic:deepeval",
          "name": "deepeval",
          "displayName": "deepeval",
          "description": "Skills for adding DeepEval evaluations, tracing, datasets, Confident AI reports, and iterative improvement loops to AI applications.",
          "longDescription": "Skills for adding DeepEval evaluations, tracing, datasets, Confident AI reports, and iterative improvement loops to AI applications.",
          "category": "development",
          "keywords": ["deepeval", "llm", "evaluation", "tracing", "datasets", "confident-ai"],
          "author": {
            "name": "Confident AI",
            "email": "open-source@confident-ai.com"
          },
          "version": "1.0.0",
          "license": "Apache-2.0",
          "logoUrl": null,
          "darkLogoUrl": null,
          "homepage": "https://deepeval.com",
          "sourceUrl": "https://github.com/confident-ai/deepeval/tree/c144abbce848a6dfbd35bbdaaab49a62bb3fb7b6/",
          "skills": [
            {
              "name": "deepeval-otel",
              "sourceUrl": "https://github.com/confident-ai/deepeval/blob/c144abbce848a6dfbd35bbdaaab49a62bb3fb7b6/skills/deepeval-otel/SKILL.md"
            },
            {
              "name": "deepeval-tracing",
              "sourceUrl": "https://github.com/confident-ai/deepeval/blob/c144abbce848a6dfbd35bbdaaab49a62bb3fb7b6/skills/deepeval-tracing/SKILL.md"
            },
            {
              "name": "deepeval",
              "sourceUrl": "https://github.com/confident-ai/deepeval/blob/c144abbce848a6dfbd35bbdaaab49a62bb3fb7b6/skills/deepeval/SKILL.md"
            }
          ],
          "mcpServers": [],
          "components": ["skills"],
          "componentInspection": "repository",
          "inspectionError": null,
          "installation": "requires_adapter",
          "upstream": {
            "source": {
              "source": "url",
              "url": "https://github.com/confident-ai/deepeval.git",
              "sha": "c144abbce848a6dfbd35bbdaaab49a62bb3fb7b6"
            },
            "policy": null
          }
        },
        {
          "id": "anthropic:deploy-on-aws",
          "name": "deploy-on-aws",
          "displayName": "deploy-on-aws",
          "description": "Deploy applications to AWS with architecture recommendations, cost estimates, and IaC deployment. Generate validated AWS architecture diagrams as draw.io XML.",
          "longDescription": "Deploy applications to AWS with architecture recommendations, cost estimates, and IaC deployment. Generate validated AWS architecture diagrams as draw.io XML.",
          "category": "deployment",
          "keywords": [
            "aws",
            "deploy",
            "infrastructure",
            "cdk",
            "cloudformation",
            "pricing",
            "diagrams",
            "draw.io",
            "architecture"
          ],
          "author": {
            "name": "Amazon Web Services"
          },
          "version": "1.3.0",
          "license": "Apache-2.0",
          "logoUrl": null,
          "darkLogoUrl": null,
          "homepage": "https://github.com/awslabs/agent-plugins",
          "sourceUrl": "https://github.com/awslabs/agent-plugins/tree/efe040ab66ed7eb4bccc0a94133181da5bc57567/plugins/deploy-on-aws",
          "skills": [
            {
              "name": "aws-architecture-diagram",
              "sourceUrl": "https://github.com/awslabs/agent-plugins/blob/efe040ab66ed7eb4bccc0a94133181da5bc57567/plugins/deploy-on-aws/skills/aws-architecture-diagram/SKILL.md"
            },
            {
              "name": "deploy",
              "sourceUrl": "https://github.com/awslabs/agent-plugins/blob/efe040ab66ed7eb4bccc0a94133181da5bc57567/plugins/deploy-on-aws/skills/deploy/SKILL.md"
            },
            {
              "name": "elastic-beanstalk",
              "sourceUrl": "https://github.com/awslabs/agent-plugins/blob/efe040ab66ed7eb4bccc0a94133181da5bc57567/plugins/deploy-on-aws/skills/elastic-beanstalk/SKILL.md"
            }
          ],
          "mcpServers": [
            {
              "requiresConfiguration": false,
              "name": "awsiac",
              "transport": "stdio",
              "endpoint": null
            },
            {
              "requiresConfiguration": false,
              "name": "awsknowledge",
              "transport": "http",
              "endpoint": "https://knowledge-mcp.global.api.aws"
            },
            {
              "requiresConfiguration": false,
              "name": "awspricing",
              "transport": "stdio",
              "endpoint": null
            }
          ],
          "components": ["skills", "mcp", "hooks"],
          "componentInspection": "repository",
          "inspectionError": null,
          "installation": "requires_adapter",
          "upstream": {
            "source": {
              "source": "git-subdir",
              "url": "https://github.com/awslabs/agent-plugins.git",
              "path": "plugins/deploy-on-aws",
              "ref": "main",
              "sha": "efe040ab66ed7eb4bccc0a94133181da5bc57567"
            },
            "policy": null
          }
        },
        {
          "id": "anthropic:desktop-commander",
          "name": "desktop-commander",
          "displayName": "desktop-commander",
          "description": "MCP server for terminal commands, process management, and file operations across text, code, PDF, DOCX, Excel, images, and structured data.",
          "longDescription": "MCP server for terminal commands, process management, and file operations across text, code, PDF, DOCX, Excel, images, and structured data.",
          "category": "productivity",
          "keywords": [],
          "author": {
            "name": "Desktop Commander"
          },
          "version": null,
          "license": null,
          "logoUrl": null,
          "darkLogoUrl": null,
          "homepage": "https://desktopcommander.app",
          "sourceUrl": "https://github.com/wonderwhy-er/DesktopCommanderMCP.git",
          "skills": null,
          "mcpServers": null,
          "components": null,
          "componentInspection": "not_inspected",
          "inspectionError": "Archive exceeds 32 MiB",
          "installation": "requires_adapter",
          "upstream": {
            "source": {
              "source": "git-subdir",
              "url": "https://github.com/wonderwhy-er/DesktopCommanderMCP.git",
              "path": "plugins/claude",
              "ref": "main",
              "sha": "1eccc8b09cc09805202a1737fd20d605356c3671"
            },
            "policy": null
          }
        },
        {
          "id": "anthropic:discord",
          "name": "discord",
          "displayName": "discord",
          "description": "Discord channel for Claude Code — messaging bridge with built-in access control. Manage pairing, allowlists, and policy via /discord:access.",
          "longDescription": "Discord channel for Claude Code — messaging bridge with built-in access control. Manage pairing, allowlists, and policy via /discord:access.",
          "category": "productivity",
          "keywords": ["discord", "messaging", "channel", "mcp"],
          "author": null,
          "version": "0.0.4",
          "license": null,
          "logoUrl": null,
          "darkLogoUrl": null,
          "homepage": null,
          "sourceUrl": "https://github.com/anthropics/claude-plugins-official/tree/3b600518a637492d37c9877aeb49c2a55d939c04/external_plugins/discord",
          "skills": [
            {
              "name": "access",
              "sourceUrl": "https://github.com/anthropics/claude-plugins-official/blob/3b600518a637492d37c9877aeb49c2a55d939c04/external_plugins/discord/skills/access/SKILL.md"
            },
            {
              "name": "configure",
              "sourceUrl": "https://github.com/anthropics/claude-plugins-official/blob/3b600518a637492d37c9877aeb49c2a55d939c04/external_plugins/discord/skills/configure/SKILL.md"
            }
          ],
          "mcpServers": [
            {
              "requiresConfiguration": false,
              "name": "discord",
              "transport": "stdio",
              "endpoint": null
            }
          ],
          "components": ["skills", "mcp"],
          "componentInspection": "repository",
          "inspectionError": null,
          "installation": "requires_adapter",
          "upstream": {
            "source": "./external_plugins/discord",
            "policy": null
          }
        },
        {
          "id": "anthropic:dominodatalab",
          "name": "dominodatalab",
          "displayName": "dominodatalab",
          "description": "Full Domino Data Lab platform support — workspaces, jobs, model deployment, experiment tracking, GenAI tracing, Spark/Ray/Dask, and app deployment for data science teams",
          "longDescription": "Full Domino Data Lab platform support — workspaces, jobs, model deployment, experiment tracking, GenAI tracing, Spark/Ray/Dask, and app deployment for data science teams",
          "category": "development",
          "keywords": [
            "domino",
            "mlops",
            "data-science",
            "machine-learning",
            "experiment-tracking",
            "genai-tracing",
            "spark",
            "ray",
            "dask",
            "app-deployment"
          ],
          "author": {
            "name": "Domino Data Lab",
            "url": "https://www.domino.ai"
          },
          "version": "1.0.0",
          "license": "MIT",
          "logoUrl": null,
          "darkLogoUrl": null,
          "homepage": "https://github.com/dominodatalab/domino-claude-plugin",
          "sourceUrl": "https://github.com/dominodatalab/domino-claude-plugin/tree/d86698d74d56d3934c8f8ddccb4f6aa55eb2bba7/",
          "skills": [
            {
              "name": "ai-gateway",
              "sourceUrl": "https://github.com/dominodatalab/domino-claude-plugin/blob/d86698d74d56d3934c8f8ddccb4f6aa55eb2bba7/skills/ai-gateway/SKILL.md"
            },
            {
              "name": "apps",
              "sourceUrl": "https://github.com/dominodatalab/domino-claude-plugin/blob/d86698d74d56d3934c8f8ddccb4f6aa55eb2bba7/skills/apps/SKILL.md"
            },
            {
              "name": "data-connectivity",
              "sourceUrl": "https://github.com/dominodatalab/domino-claude-plugin/blob/d86698d74d56d3934c8f8ddccb4f6aa55eb2bba7/skills/data-connectivity/SKILL.md"
            },
            {
              "name": "datasets",
              "sourceUrl": "https://github.com/dominodatalab/domino-claude-plugin/blob/d86698d74d56d3934c8f8ddccb4f6aa55eb2bba7/skills/datasets/SKILL.md"
            },
            {
              "name": "distributed-computing",
              "sourceUrl": "https://github.com/dominodatalab/domino-claude-plugin/blob/d86698d74d56d3934c8f8ddccb4f6aa55eb2bba7/skills/distributed-computing/SKILL.md"
            },
            {
              "name": "domino-data-sdk",
              "sourceUrl": "https://github.com/dominodatalab/domino-claude-plugin/blob/d86698d74d56d3934c8f8ddccb4f6aa55eb2bba7/skills/domino-data-sdk/SKILL.md"
            },
            {
              "name": "domino-governance",
              "sourceUrl": "https://github.com/dominodatalab/domino-claude-plugin/blob/d86698d74d56d3934c8f8ddccb4f6aa55eb2bba7/skills/domino-governance/SKILL.md"
            },
            {
              "name": "domino-ui-bootstrap",
              "sourceUrl": "https://github.com/dominodatalab/domino-claude-plugin/blob/d86698d74d56d3934c8f8ddccb4f6aa55eb2bba7/skills/domino-ui-bootstrap/SKILL.md"
            },
            {
              "name": "domino-ui-design",
              "sourceUrl": "https://github.com/dominodatalab/domino-claude-plugin/blob/d86698d74d56d3934c8f8ddccb4f6aa55eb2bba7/skills/domino-ui-design/SKILL.md"
            },
            {
              "name": "environments",
              "sourceUrl": "https://github.com/dominodatalab/domino-claude-plugin/blob/d86698d74d56d3934c8f8ddccb4f6aa55eb2bba7/skills/environments/SKILL.md"
            },
            {
              "name": "experiment-tracking",
              "sourceUrl": "https://github.com/dominodatalab/domino-claude-plugin/blob/d86698d74d56d3934c8f8ddccb4f6aa55eb2bba7/skills/experiment-tracking/SKILL.md"
            },
            {
              "name": "flows",
              "sourceUrl": "https://github.com/dominodatalab/domino-claude-plugin/blob/d86698d74d56d3934c8f8ddccb4f6aa55eb2bba7/skills/flows/SKILL.md"
            },
            {
              "name": "genai-tracing",
              "sourceUrl": "https://github.com/dominodatalab/domino-claude-plugin/blob/d86698d74d56d3934c8f8ddccb4f6aa55eb2bba7/skills/genai-tracing/SKILL.md"
            },
            {
              "name": "jobs",
              "sourceUrl": "https://github.com/dominodatalab/domino-claude-plugin/blob/d86698d74d56d3934c8f8ddccb4f6aa55eb2bba7/skills/jobs/SKILL.md"
            },
            {
              "name": "launchers",
              "sourceUrl": "https://github.com/dominodatalab/domino-claude-plugin/blob/d86698d74d56d3934c8f8ddccb4f6aa55eb2bba7/skills/launchers/SKILL.md"
            },
            {
              "name": "model-endpoints",
              "sourceUrl": "https://github.com/dominodatalab/domino-claude-plugin/blob/d86698d74d56d3934c8f8ddccb4f6aa55eb2bba7/skills/model-endpoints/SKILL.md"
            },
            {
              "name": "model-monitoring",
              "sourceUrl": "https://github.com/dominodatalab/domino-claude-plugin/blob/d86698d74d56d3934c8f8ddccb4f6aa55eb2bba7/skills/model-monitoring/SKILL.md"
            },
            {
              "name": "modeling-assistant",
              "sourceUrl": "https://github.com/dominodatalab/domino-claude-plugin/blob/d86698d74d56d3934c8f8ddccb4f6aa55eb2bba7/skills/modeling-assistant/SKILL.md"
            },
            {
              "name": "netapp-volumes",
              "sourceUrl": "https://github.com/dominodatalab/domino-claude-plugin/blob/d86698d74d56d3934c8f8ddccb4f6aa55eb2bba7/skills/netapp-volumes/SKILL.md"
            },
            {
              "name": "projects",
              "sourceUrl": "https://github.com/dominodatalab/domino-claude-plugin/blob/d86698d74d56d3934c8f8ddccb4f6aa55eb2bba7/skills/projects/SKILL.md"
            },
            {
              "name": "python-sdk",
              "sourceUrl": "https://github.com/dominodatalab/domino-claude-plugin/blob/d86698d74d56d3934c8f8ddccb4f6aa55eb2bba7/skills/python-sdk/SKILL.md"
            },
            {
              "name": "tags-and-properties",
              "sourceUrl": "https://github.com/dominodatalab/domino-claude-plugin/blob/d86698d74d56d3934c8f8ddccb4f6aa55eb2bba7/skills/tags-and-properties/SKILL.md"
            },
            {
              "name": "workspaces",
              "sourceUrl": "https://github.com/dominodatalab/domino-claude-plugin/blob/d86698d74d56d3934c8f8ddccb4f6aa55eb2bba7/skills/workspaces/SKILL.md"
            }
          ],
          "mcpServers": [
            {
              "requiresConfiguration": false,
              "name": "domino_server",
              "transport": "stdio",
              "endpoint": null
            }
          ],
          "components": ["skills", "mcp", "hooks", "agents", "commands"],
          "componentInspection": "repository",
          "inspectionError": null,
          "installation": "requires_adapter",
          "upstream": {
            "source": {
              "source": "url",
              "url": "https://github.com/dominodatalab/domino-claude-plugin.git",
              "sha": "d86698d74d56d3934c8f8ddccb4f6aa55eb2bba7"
            },
            "policy": null
          }
        },
        {
          "id": "anthropic:dropbox",
          "name": "dropbox",
          "displayName": "dropbox",
          "description": "The Dropbox plugin for Claude connects your Dropbox files directly to Claude, so you can search, organize, save generated content, and create sharing links without switching tools. It respects your existing Dropbox permissions, and Claude only works with files you already have access to.",
          "longDescription": "The Dropbox plugin for Claude connects your Dropbox files directly to Claude, so you can search, organize, save generated content, and create sharing links without switching tools. It respects your existing Dropbox permissions, and Claude only works with files you already have access to.",
          "category": "productivity",
          "keywords": [
            "dropbox",
            "files",
            "storage",
            "cloud",
            "cloud storage",
            "save",
            "upload",
            "download",
            "share",
            "sharing",
            "sync",
            "folder",
            "folders",
            "documents",
            "docs",
            "content",
            "links",
            "permissions",
            "organize",
            "search",
            "retrieve",
            "manage",
            "import",
            "export"
          ],
          "author": {
            "name": "Dropbox"
          },
          "version": "1.0.0",
          "license": "Apache-2.0",
          "logoUrl": null,
          "darkLogoUrl": null,
          "homepage": "https://www.dropbox.com",
          "sourceUrl": "https://github.com/dropbox/dropbox-ai-plugins/tree/4135e81caf8275b4c97caef244479e0dcb6fb823/claude",
          "skills": [
            {
              "name": "clean-up-dropbox-content",
              "sourceUrl": "https://github.com/dropbox/dropbox-ai-plugins/blob/4135e81caf8275b4c97caef244479e0dcb6fb823/claude/skills/clean-up-dropbox-content/SKILL.md"
            },
            {
              "name": "collect-files-with-request",
              "sourceUrl": "https://github.com/dropbox/dropbox-ai-plugins/blob/4135e81caf8275b4c97caef244479e0dcb6fb823/claude/skills/collect-files-with-request/SKILL.md"
            },
            {
              "name": "find-dropbox-content",
              "sourceUrl": "https://github.com/dropbox/dropbox-ai-plugins/blob/4135e81caf8275b4c97caef244479e0dcb6fb823/claude/skills/find-dropbox-content/SKILL.md"
            },
            {
              "name": "inspect-dropbox-file",
              "sourceUrl": "https://github.com/dropbox/dropbox-ai-plugins/blob/4135e81caf8275b4c97caef244479e0dcb6fb823/claude/skills/inspect-dropbox-file/SKILL.md"
            },
            {
              "name": "organize-dropbox-folder",
              "sourceUrl": "https://github.com/dropbox/dropbox-ai-plugins/blob/4135e81caf8275b4c97caef244479e0dcb6fb823/claude/skills/organize-dropbox-folder/SKILL.md"
            },
            {
              "name": "share-dropbox-content",
              "sourceUrl": "https://github.com/dropbox/dropbox-ai-plugins/blob/4135e81caf8275b4c97caef244479e0dcb6fb823/claude/skills/share-dropbox-content/SKILL.md"
            }
          ],
          "mcpServers": [
            {
              "requiresConfiguration": false,
              "name": "claude_app_mcp",
              "transport": "http",
              "endpoint": "https://mcp.dropbox.com/claude_app_mcp"
            }
          ],
          "components": ["skills", "mcp"],
          "componentInspection": "repository",
          "inspectionError": null,
          "installation": "requires_adapter",
          "upstream": {
            "source": {
              "source": "git-subdir",
              "url": "https://github.com/dropbox/dropbox-ai-plugins.git",
              "path": "claude",
              "ref": "main",
              "sha": "4135e81caf8275b4c97caef244479e0dcb6fb823"
            },
            "policy": null
          }
        },
        {
          "id": "anthropic:duckdb-skills",
          "name": "duckdb-skills",
          "displayName": "duckdb-skills",
          "description": "DuckDB-powered skills for Claude Code: read any data file, attach and query DuckDB databases, search DuckDB/DuckLake docs, search past session logs, and install/update DuckDB extensions.",
          "longDescription": "DuckDB-powered skills for Claude Code: read any data file, attach and query DuckDB databases, search DuckDB/DuckLake docs, search past session logs, and install/update DuckDB extensions.",
          "category": "database",
          "keywords": [
            "duckdb",
            "ducklake",
            "parquet",
            "csv",
            "json",
            "avro",
            "excel",
            "iceberg",
            "delta",
            "read-file",
            "read-memories",
            "duckdb-docs",
            "data-exploration",
            "session-logs",
            "query",
            "sql",
            "attach-db"
          ],
          "author": {
            "name": "duckdb",
            "url": "https://github.com/duckdb"
          },
          "version": "0.2.4",
          "license": "MIT",
          "logoUrl": null,
          "darkLogoUrl": null,
          "homepage": "https://duckdb.org",
          "sourceUrl": "https://github.com/duckdb/duckdb-skills/tree/7feda8e01e22bc0886c86123f3884947e36d8c69/",
          "skills": [
            {
              "name": "attach-db",
              "sourceUrl": "https://github.com/duckdb/duckdb-skills/blob/7feda8e01e22bc0886c86123f3884947e36d8c69/skills/attach-db/SKILL.md"
            },
            {
              "name": "convert-file",
              "sourceUrl": "https://github.com/duckdb/duckdb-skills/blob/7feda8e01e22bc0886c86123f3884947e36d8c69/skills/convert-file/SKILL.md"
            },
            {
              "name": "duckdb-docs",
              "sourceUrl": "https://github.com/duckdb/duckdb-skills/blob/7feda8e01e22bc0886c86123f3884947e36d8c69/skills/duckdb-docs/SKILL.md"
            },
            {
              "name": "install-duckdb",
              "sourceUrl": "https://github.com/duckdb/duckdb-skills/blob/7feda8e01e22bc0886c86123f3884947e36d8c69/skills/install-duckdb/SKILL.md"
            },
            {
              "name": "query",
              "sourceUrl": "https://github.com/duckdb/duckdb-skills/blob/7feda8e01e22bc0886c86123f3884947e36d8c69/skills/query/SKILL.md"
            },
            {
              "name": "read-file",
              "sourceUrl": "https://github.com/duckdb/duckdb-skills/blob/7feda8e01e22bc0886c86123f3884947e36d8c69/skills/read-file/SKILL.md"
            },
            {
              "name": "read-memories",
              "sourceUrl": "https://github.com/duckdb/duckdb-skills/blob/7feda8e01e22bc0886c86123f3884947e36d8c69/skills/read-memories/SKILL.md"
            },
            {
              "name": "s3-explore",
              "sourceUrl": "https://github.com/duckdb/duckdb-skills/blob/7feda8e01e22bc0886c86123f3884947e36d8c69/skills/s3-explore/SKILL.md"
            },
            {
              "name": "spatial",
              "sourceUrl": "https://github.com/duckdb/duckdb-skills/blob/7feda8e01e22bc0886c86123f3884947e36d8c69/skills/spatial/SKILL.md"
            }
          ],
          "mcpServers": [],
          "components": ["skills"],
          "componentInspection": "repository",
          "inspectionError": null,
          "installation": "requires_adapter",
          "upstream": {
            "source": {
              "source": "url",
              "url": "https://github.com/duckdb/duckdb-skills.git",
              "sha": "7feda8e01e22bc0886c86123f3884947e36d8c69"
            },
            "policy": null
          }
        },
        {
          "id": "anthropic:duende-skills",
          "name": "duende-skills",
          "displayName": "duende-skills",
          "description": "Duende development skills and agents for Claude Code — covering OAuth/OIDC protocols, IdentityServer, token management, ASP.NET Core authentication/authorization, BFF patterns, and secure identity architecture",
          "longDescription": "Duende development skills and agents for Claude Code — covering OAuth/OIDC protocols, IdentityServer, token management, ASP.NET Core authentication/authorization, BFF patterns, and secure identity architecture",
          "category": "security",
          "keywords": [],
          "author": {
            "name": "Duende Software",
            "url": "https://github.com/DuendeSoftware"
          },
          "version": "0.2.0",
          "license": null,
          "logoUrl": null,
          "darkLogoUrl": null,
          "homepage": "https://duendesoftware.com",
          "sourceUrl": "https://github.com/DuendeSoftware/duende-skills/tree/723d77254267621aed00628667e4ee77893af2d4/",
          "skills": [
            {
              "name": "aspnetcore-authentication",
              "sourceUrl": "https://github.com/DuendeSoftware/duende-skills/blob/723d77254267621aed00628667e4ee77893af2d4/skills/aspnetcore-authentication/SKILL.md"
            },
            {
              "name": "aspnetcore-authorization",
              "sourceUrl": "https://github.com/DuendeSoftware/duende-skills/blob/723d77254267621aed00628667e4ee77893af2d4/skills/aspnetcore-authorization/SKILL.md"
            },
            {
              "name": "claims-authorization",
              "sourceUrl": "https://github.com/DuendeSoftware/duende-skills/blob/723d77254267621aed00628667e4ee77893af2d4/skills/claims-authorization/SKILL.md"
            },
            {
              "name": "duende-bff",
              "sourceUrl": "https://github.com/DuendeSoftware/duende-skills/blob/723d77254267621aed00628667e4ee77893af2d4/skills/duende-bff/SKILL.md"
            },
            {
              "name": "identity-security-hardening",
              "sourceUrl": "https://github.com/DuendeSoftware/duende-skills/blob/723d77254267621aed00628667e4ee77893af2d4/skills/identity-security-hardening/SKILL.md"
            },
            {
              "name": "identity-testing-patterns",
              "sourceUrl": "https://github.com/DuendeSoftware/duende-skills/blob/723d77254267621aed00628667e4ee77893af2d4/skills/identity-testing-patterns/SKILL.md"
            },
            {
              "name": "identityserver-api-protection",
              "sourceUrl": "https://github.com/DuendeSoftware/duende-skills/blob/723d77254267621aed00628667e4ee77893af2d4/skills/identityserver-api-protection/SKILL.md"
            },
            {
              "name": "identityserver-aspire",
              "sourceUrl": "https://github.com/DuendeSoftware/duende-skills/blob/723d77254267621aed00628667e4ee77893af2d4/skills/identityserver-aspire/SKILL.md"
            },
            {
              "name": "identityserver-configuration",
              "sourceUrl": "https://github.com/DuendeSoftware/duende-skills/blob/723d77254267621aed00628667e4ee77893af2d4/skills/identityserver-configuration/SKILL.md"
            },
            {
              "name": "identityserver-dcr",
              "sourceUrl": "https://github.com/DuendeSoftware/duende-skills/blob/723d77254267621aed00628667e4ee77893af2d4/skills/identityserver-dcr/SKILL.md"
            },
            {
              "name": "identityserver-deployment",
              "sourceUrl": "https://github.com/DuendeSoftware/duende-skills/blob/723d77254267621aed00628667e4ee77893af2d4/skills/identityserver-deployment/SKILL.md"
            },
            {
              "name": "identityserver-hosting-setup",
              "sourceUrl": "https://github.com/DuendeSoftware/duende-skills/blob/723d77254267621aed00628667e4ee77893af2d4/skills/identityserver-hosting-setup/SKILL.md"
            },
            {
              "name": "identityserver-key-management",
              "sourceUrl": "https://github.com/DuendeSoftware/duende-skills/blob/723d77254267621aed00628667e4ee77893af2d4/skills/identityserver-key-management/SKILL.md"
            },
            {
              "name": "identityserver-saml",
              "sourceUrl": "https://github.com/DuendeSoftware/duende-skills/blob/723d77254267621aed00628667e4ee77893af2d4/skills/identityserver-saml/SKILL.md"
            },
            {
              "name": "identityserver-sessions-providers",
              "sourceUrl": "https://github.com/DuendeSoftware/duende-skills/blob/723d77254267621aed00628667e4ee77893af2d4/skills/identityserver-sessions-providers/SKILL.md"
            },
            {
              "name": "identityserver-stores",
              "sourceUrl": "https://github.com/DuendeSoftware/duende-skills/blob/723d77254267621aed00628667e4ee77893af2d4/skills/identityserver-stores/SKILL.md"
            },
            {
              "name": "identityserver-token-lifecycle",
              "sourceUrl": "https://github.com/DuendeSoftware/duende-skills/blob/723d77254267621aed00628667e4ee77893af2d4/skills/identityserver-token-lifecycle/SKILL.md"
            },
            {
              "name": "identityserver-token-security",
              "sourceUrl": "https://github.com/DuendeSoftware/duende-skills/blob/723d77254267621aed00628667e4ee77893af2d4/skills/identityserver-token-security/SKILL.md"
            },
            {
              "name": "identityserver-ui-flows",
              "sourceUrl": "https://github.com/DuendeSoftware/duende-skills/blob/723d77254267621aed00628667e4ee77893af2d4/skills/identityserver-ui-flows/SKILL.md"
            },
            {
              "name": "identityserver-upgrade-v7-to-v8",
              "sourceUrl": "https://github.com/DuendeSoftware/duende-skills/blob/723d77254267621aed00628667e4ee77893af2d4/skills/identityserver-upgrade-v7-to-v8/SKILL.md"
            },
            {
              "name": "identityserver-usermanagement",
              "sourceUrl": "https://github.com/DuendeSoftware/duende-skills/blob/723d77254267621aed00628667e4ee77893af2d4/skills/identityserver-usermanagement/SKILL.md"
            },
            {
              "name": "identityserver4-migration",
              "sourceUrl": "https://github.com/DuendeSoftware/duende-skills/blob/723d77254267621aed00628667e4ee77893af2d4/skills/identityserver4-migration/SKILL.md"
            },
            {
              "name": "oauth-oidc-protocols",
              "sourceUrl": "https://github.com/DuendeSoftware/duende-skills/blob/723d77254267621aed00628667e4ee77893af2d4/skills/oauth-oidc-protocols/SKILL.md"
            },
            {
              "name": "token-management",
              "sourceUrl": "https://github.com/DuendeSoftware/duende-skills/blob/723d77254267621aed00628667e4ee77893af2d4/skills/token-management/SKILL.md"
            }
          ],
          "mcpServers": [],
          "components": ["skills", "agents"],
          "componentInspection": "repository",
          "inspectionError": null,
          "installation": "requires_adapter",
          "upstream": {
            "source": {
              "source": "url",
              "url": "https://github.com/DuendeSoftware/duende-skills.git",
              "sha": "723d77254267621aed00628667e4ee77893af2d4"
            },
            "policy": null
          }
        },
        {
          "id": "anthropic:exa",
          "name": "exa",
          "displayName": "exa",
          "description": "Exa web search, content fetching, and multi-step research via MCP tools and skills.",
          "longDescription": "Exa web search, content fetching, and multi-step research via MCP tools and skills.",
          "category": "productivity",
          "keywords": [],
          "author": {
            "name": "Exa",
            "email": "hello@exa.ai"
          },
          "version": "3.4.1",
          "license": null,
          "logoUrl": null,
          "darkLogoUrl": null,
          "homepage": "https://exa.ai/docs/reference/exa-mcp",
          "sourceUrl": "https://github.com/exa-labs/exa-mcp-server/tree/15ffb50519e719dc791cdc750ce5ed1934c0a1ed/",
          "skills": [
            {
              "name": "exa-agent",
              "sourceUrl": "https://github.com/exa-labs/exa-mcp-server/blob/15ffb50519e719dc791cdc750ce5ed1934c0a1ed/skills/exa-agent/SKILL.md"
            },
            {
              "name": "search",
              "sourceUrl": "https://github.com/exa-labs/exa-mcp-server/blob/15ffb50519e719dc791cdc750ce5ed1934c0a1ed/skills/search/SKILL.md"
            }
          ],
          "mcpServers": [
            {
              "requiresConfiguration": true,
              "name": "exa",
              "transport": "http",
              "endpoint": "https://mcp.exa.ai/mcp?client=claude-code-plugin"
            }
          ],
          "components": ["skills", "mcp"],
          "componentInspection": "repository",
          "inspectionError": null,
          "installation": "requires_adapter",
          "upstream": {
            "source": {
              "source": "url",
              "url": "https://github.com/exa-labs/exa-mcp-server.git",
              "sha": "15ffb50519e719dc791cdc750ce5ed1934c0a1ed"
            },
            "policy": null
          }
        },
        {
          "id": "anthropic:explanatory-output-style",
          "name": "explanatory-output-style",
          "displayName": "explanatory-output-style",
          "description": "Adds educational insights about implementation choices and codebase patterns (mimics the deprecated Explanatory output style)",
          "longDescription": "Adds educational insights about implementation choices and codebase patterns (mimics the deprecated Explanatory output style)",
          "category": "learning",
          "keywords": [],
          "author": {
            "name": "Anthropic",
            "email": "support@anthropic.com"
          },
          "version": "1.0.0",
          "license": null,
          "logoUrl": null,
          "darkLogoUrl": null,
          "homepage": "https://github.com/anthropics/claude-plugins-public/tree/main/plugins/explanatory-output-style",
          "sourceUrl": "https://github.com/anthropics/claude-plugins-official/tree/3b600518a637492d37c9877aeb49c2a55d939c04/plugins/explanatory-output-style",
          "skills": [],
          "mcpServers": [],
          "components": ["hooks"],
          "componentInspection": "repository",
          "inspectionError": null,
          "installation": "requires_adapter",
          "upstream": {
            "source": "./plugins/explanatory-output-style",
            "policy": null
          }
        },
        {
          "id": "anthropic:expo",
          "name": "expo",
          "displayName": "expo",
          "description": "Official Expo skills for building, deploying, upgrading, and debugging Expo apps",
          "longDescription": "Official Expo skills for building, deploying, upgrading, and debugging Expo apps",
          "category": "development",
          "keywords": [],
          "author": {
            "name": "Expo Team",
            "email": "support@expo.dev"
          },
          "version": "1.12.5",
          "license": null,
          "logoUrl": null,
          "darkLogoUrl": null,
          "homepage": "https://github.com/expo/skills/blob/main/plugins/expo/README.md",
          "sourceUrl": "https://github.com/expo/skills/tree/d0075ffa09928f1edb3e7ac4f5af07586d4b344d/plugins/expo",
          "skills": [
            {
              "name": "eas-app-stores",
              "sourceUrl": "https://github.com/expo/skills/blob/d0075ffa09928f1edb3e7ac4f5af07586d4b344d/plugins/expo/skills/eas-app-stores/SKILL.md"
            },
            {
              "name": "eas-hosting",
              "sourceUrl": "https://github.com/expo/skills/blob/d0075ffa09928f1edb3e7ac4f5af07586d4b344d/plugins/expo/skills/eas-hosting/SKILL.md"
            },
            {
              "name": "eas-observe",
              "sourceUrl": "https://github.com/expo/skills/blob/d0075ffa09928f1edb3e7ac4f5af07586d4b344d/plugins/expo/skills/eas-observe/SKILL.md"
            },
            {
              "name": "eas-simulator",
              "sourceUrl": "https://github.com/expo/skills/blob/d0075ffa09928f1edb3e7ac4f5af07586d4b344d/plugins/expo/skills/eas-simulator/SKILL.md"
            },
            {
              "name": "eas-update-insights",
              "sourceUrl": "https://github.com/expo/skills/blob/d0075ffa09928f1edb3e7ac4f5af07586d4b344d/plugins/expo/skills/eas-update-insights/SKILL.md"
            },
            {
              "name": "eas-update",
              "sourceUrl": "https://github.com/expo/skills/blob/d0075ffa09928f1edb3e7ac4f5af07586d4b344d/plugins/expo/skills/eas-update/SKILL.md"
            },
            {
              "name": "eas-workflows",
              "sourceUrl": "https://github.com/expo/skills/blob/d0075ffa09928f1edb3e7ac4f5af07586d4b344d/plugins/expo/skills/eas-workflows/SKILL.md"
            },
            {
              "name": "expo-animation",
              "sourceUrl": "https://github.com/expo/skills/blob/d0075ffa09928f1edb3e7ac4f5af07586d4b344d/plugins/expo/skills/expo-animation/SKILL.md"
            },
            {
              "name": "expo-app-clip",
              "sourceUrl": "https://github.com/expo/skills/blob/d0075ffa09928f1edb3e7ac4f5af07586d4b344d/plugins/expo/skills/expo-app-clip/SKILL.md"
            },
            {
              "name": "expo-brownfield",
              "sourceUrl": "https://github.com/expo/skills/blob/d0075ffa09928f1edb3e7ac4f5af07586d4b344d/plugins/expo/skills/expo-brownfield/SKILL.md"
            },
            {
              "name": "expo-data-fetching",
              "sourceUrl": "https://github.com/expo/skills/blob/d0075ffa09928f1edb3e7ac4f5af07586d4b344d/plugins/expo/skills/expo-data-fetching/SKILL.md"
            },
            {
              "name": "expo-design-system",
              "sourceUrl": "https://github.com/expo/skills/blob/d0075ffa09928f1edb3e7ac4f5af07586d4b344d/plugins/expo/skills/expo-design-system/SKILL.md"
            },
            {
              "name": "expo-dev-client",
              "sourceUrl": "https://github.com/expo/skills/blob/d0075ffa09928f1edb3e7ac4f5af07586d4b344d/plugins/expo/skills/expo-dev-client/SKILL.md"
            },
            {
              "name": "expo-dom",
              "sourceUrl": "https://github.com/expo/skills/blob/d0075ffa09928f1edb3e7ac4f5af07586d4b344d/plugins/expo/skills/expo-dom/SKILL.md"
            },
            {
              "name": "expo-examples",
              "sourceUrl": "https://github.com/expo/skills/blob/d0075ffa09928f1edb3e7ac4f5af07586d4b344d/plugins/expo/skills/expo-examples/SKILL.md"
            },
            {
              "name": "expo-module",
              "sourceUrl": "https://github.com/expo/skills/blob/d0075ffa09928f1edb3e7ac4f5af07586d4b344d/plugins/expo/skills/expo-module/SKILL.md"
            },
            {
              "name": "expo-native-ui",
              "sourceUrl": "https://github.com/expo/skills/blob/d0075ffa09928f1edb3e7ac4f5af07586d4b344d/plugins/expo/skills/expo-native-ui/SKILL.md"
            },
            {
              "name": "expo-overview",
              "sourceUrl": "https://github.com/expo/skills/blob/d0075ffa09928f1edb3e7ac4f5af07586d4b344d/plugins/expo/skills/expo-overview/SKILL.md"
            },
            {
              "name": "expo-project-structure",
              "sourceUrl": "https://github.com/expo/skills/blob/d0075ffa09928f1edb3e7ac4f5af07586d4b344d/plugins/expo/skills/expo-project-structure/SKILL.md"
            },
            {
              "name": "expo-router",
              "sourceUrl": "https://github.com/expo/skills/blob/d0075ffa09928f1edb3e7ac4f5af07586d4b344d/plugins/expo/skills/expo-router/SKILL.md"
            },
            {
              "name": "expo-skill-feedback",
              "sourceUrl": "https://github.com/expo/skills/blob/d0075ffa09928f1edb3e7ac4f5af07586d4b344d/plugins/expo/skills/expo-skill-feedback/SKILL.md"
            },
            {
              "name": "expo-ui",
              "sourceUrl": "https://github.com/expo/skills/blob/d0075ffa09928f1edb3e7ac4f5af07586d4b344d/plugins/expo/skills/expo-ui/SKILL.md"
            },
            {
              "name": "expo-upgrade",
              "sourceUrl": "https://github.com/expo/skills/blob/d0075ffa09928f1edb3e7ac4f5af07586d4b344d/plugins/expo/skills/expo-upgrade/SKILL.md"
            },
            {
              "name": "expo-web-to-native",
              "sourceUrl": "https://github.com/expo/skills/blob/d0075ffa09928f1edb3e7ac4f5af07586d4b344d/plugins/expo/skills/expo-web-to-native/SKILL.md"
            }
          ],
          "mcpServers": [
            {
              "requiresConfiguration": false,
              "name": "expo",
              "transport": "http",
              "endpoint": "https://mcp.expo.dev/mcp"
            }
          ],
          "components": ["skills", "mcp", "hooks", "agents"],
          "componentInspection": "repository",
          "inspectionError": null,
          "installation": "requires_adapter",
          "upstream": {
            "source": {
              "source": "git-subdir",
              "url": "https://github.com/expo/skills.git",
              "path": "plugins/expo",
              "ref": "main",
              "sha": "d0075ffa09928f1edb3e7ac4f5af07586d4b344d"
            },
            "policy": null
          }
        },
        {
          "id": "anthropic:fakechat",
          "name": "fakechat",
          "displayName": "fakechat",
          "description": "Localhost iMessage-style web chat for Claude Code — test surface with file upload and edits. No tokens, no access control.",
          "longDescription": "Localhost iMessage-style web chat for Claude Code — test surface with file upload and edits. No tokens, no access control.",
          "category": "development",
          "keywords": ["fakechat", "web", "localhost", "testing", "channel", "mcp"],
          "author": null,
          "version": "0.0.1",
          "license": null,
          "logoUrl": null,
          "darkLogoUrl": null,
          "homepage": null,
          "sourceUrl": "https://github.com/anthropics/claude-plugins-official/tree/3b600518a637492d37c9877aeb49c2a55d939c04/external_plugins/fakechat",
          "skills": [],
          "mcpServers": [
            {
              "requiresConfiguration": false,
              "name": "fakechat",
              "transport": "stdio",
              "endpoint": null
            }
          ],
          "components": ["mcp"],
          "componentInspection": "repository",
          "inspectionError": null,
          "installation": "requires_adapter",
          "upstream": {
            "source": "./external_plugins/fakechat",
            "policy": null
          }
        },
        {
          "id": "anthropic:fastly-agent-toolkit",
          "name": "fastly-agent-toolkit",
          "displayName": "fastly-agent-toolkit",
          "description": "Fastly development tools and platform skills",
          "longDescription": "Fastly development tools and platform skills",
          "category": null,
          "keywords": ["fastly", "edge", "compute", "vcl", "cdn"],
          "author": {
            "name": "Fastly"
          },
          "version": "0.1.0",
          "license": null,
          "logoUrl": null,
          "darkLogoUrl": null,
          "homepage": "https://github.com/fastly/fastly-agent-toolkit/blob/main/README.md",
          "sourceUrl": "https://github.com/fastly/fastly-agent-toolkit/tree/42a6070055b2cc08e1f085107685d7eb216b72ed/",
          "skills": [
            {
              "name": "falco",
              "sourceUrl": "https://github.com/fastly/fastly-agent-toolkit/blob/42a6070055b2cc08e1f085107685d7eb216b72ed/skills/falco/SKILL.md"
            },
            {
              "name": "fastlike",
              "sourceUrl": "https://github.com/fastly/fastly-agent-toolkit/blob/42a6070055b2cc08e1f085107685d7eb216b72ed/skills/fastlike/SKILL.md"
            },
            {
              "name": "fastly-cli",
              "sourceUrl": "https://github.com/fastly/fastly-agent-toolkit/blob/42a6070055b2cc08e1f085107685d7eb216b72ed/skills/fastly-cli/SKILL.md"
            },
            {
              "name": "fastly-fiddle",
              "sourceUrl": "https://github.com/fastly/fastly-agent-toolkit/blob/42a6070055b2cc08e1f085107685d7eb216b72ed/skills/fastly-fiddle/SKILL.md"
            },
            {
              "name": "fastly-ngwaf",
              "sourceUrl": "https://github.com/fastly/fastly-agent-toolkit/blob/42a6070055b2cc08e1f085107685d7eb216b72ed/skills/fastly-ngwaf/SKILL.md"
            },
            {
              "name": "fastly-reference-architectures",
              "sourceUrl": "https://github.com/fastly/fastly-agent-toolkit/blob/42a6070055b2cc08e1f085107685d7eb216b72ed/skills/fastly-reference-architectures/SKILL.md"
            },
            {
              "name": "fastly-stats",
              "sourceUrl": "https://github.com/fastly/fastly-agent-toolkit/blob/42a6070055b2cc08e1f085107685d7eb216b72ed/skills/fastly-stats/SKILL.md"
            },
            {
              "name": "fastly",
              "sourceUrl": "https://github.com/fastly/fastly-agent-toolkit/blob/42a6070055b2cc08e1f085107685d7eb216b72ed/skills/fastly/SKILL.md"
            },
            {
              "name": "viceroy",
              "sourceUrl": "https://github.com/fastly/fastly-agent-toolkit/blob/42a6070055b2cc08e1f085107685d7eb216b72ed/skills/viceroy/SKILL.md"
            },
            {
              "name": "xvcl",
              "sourceUrl": "https://github.com/fastly/fastly-agent-toolkit/blob/42a6070055b2cc08e1f085107685d7eb216b72ed/skills/xvcl/SKILL.md"
            }
          ],
          "mcpServers": [],
          "components": ["skills"],
          "componentInspection": "repository",
          "inspectionError": null,
          "installation": "requires_adapter",
          "upstream": {
            "source": {
              "source": "url",
              "url": "https://github.com/fastly/fastly-agent-toolkit.git",
              "sha": "42a6070055b2cc08e1f085107685d7eb216b72ed"
            },
            "policy": null
          }
        },
        {
          "id": "anthropic:feature-dev",
          "name": "feature-dev",
          "displayName": "feature-dev",
          "description": "Comprehensive feature development workflow with specialized agents for codebase exploration, architecture design, and quality review",
          "longDescription": "Comprehensive feature development workflow with specialized agents for codebase exploration, architecture design, and quality review",
          "category": "development",
          "keywords": [],
          "author": {
            "name": "Anthropic",
            "email": "support@anthropic.com"
          },
          "version": null,
          "license": null,
          "logoUrl": null,
          "darkLogoUrl": null,
          "homepage": "https://github.com/anthropics/claude-plugins-public/tree/main/plugins/feature-dev",
          "sourceUrl": "https://github.com/anthropics/claude-plugins-official/tree/3b600518a637492d37c9877aeb49c2a55d939c04/plugins/feature-dev",
          "skills": [],
          "mcpServers": [],
          "components": ["agents", "commands"],
          "componentInspection": "repository",
          "inspectionError": null,
          "installation": "requires_adapter",
          "upstream": {
            "source": "./plugins/feature-dev",
            "policy": null
          }
        },
        {
          "id": "anthropic:fiftyone",
          "name": "fiftyone",
          "displayName": "fiftyone",
          "description": "Build high-quality datasets and computer vision models. Visualize datasets, analyze models, find duplicates, run inference, evaluate predictions, and develop custom plugins.",
          "longDescription": "Build high-quality datasets and computer vision models. Visualize datasets, analyze models, find duplicates, run inference, evaluate predictions, and develop custom plugins.",
          "category": null,
          "keywords": [],
          "author": {
            "name": "Voxel51"
          },
          "version": "1.0.3",
          "license": "Apache-2.0",
          "logoUrl": null,
          "darkLogoUrl": null,
          "homepage": "https://docs.voxel51.com/",
          "sourceUrl": "https://github.com/voxel51/fiftyone-skills/tree/4fedd6ee7aa88e6e540e31bf54602528c9ca529d/",
          "skills": [
            {
              "name": "fiftyone-app-playwright",
              "sourceUrl": "https://github.com/voxel51/fiftyone-skills/blob/4fedd6ee7aa88e6e540e31bf54602528c9ca529d/skills/fiftyone-app-playwright/SKILL.md"
            },
            {
              "name": "fiftyone-code-style",
              "sourceUrl": "https://github.com/voxel51/fiftyone-skills/blob/4fedd6ee7aa88e6e540e31bf54602528c9ca529d/skills/fiftyone-code-style/SKILL.md"
            },
            {
              "name": "fiftyone-create-notebook",
              "sourceUrl": "https://github.com/voxel51/fiftyone-skills/blob/4fedd6ee7aa88e6e540e31bf54602528c9ca529d/skills/fiftyone-create-notebook/SKILL.md"
            },
            {
              "name": "fiftyone-dataset-curation",
              "sourceUrl": "https://github.com/voxel51/fiftyone-skills/blob/4fedd6ee7aa88e6e540e31bf54602528c9ca529d/skills/fiftyone-dataset-curation/SKILL.md"
            },
            {
              "name": "fiftyone-dataset-export",
              "sourceUrl": "https://github.com/voxel51/fiftyone-skills/blob/4fedd6ee7aa88e6e540e31bf54602528c9ca529d/skills/fiftyone-dataset-export/SKILL.md"
            },
            {
              "name": "fiftyone-dataset-import",
              "sourceUrl": "https://github.com/voxel51/fiftyone-skills/blob/4fedd6ee7aa88e6e540e31bf54602528c9ca529d/skills/fiftyone-dataset-import/SKILL.md"
            },
            {
              "name": "fiftyone-dataset-inference",
              "sourceUrl": "https://github.com/voxel51/fiftyone-skills/blob/4fedd6ee7aa88e6e540e31bf54602528c9ca529d/skills/fiftyone-dataset-inference/SKILL.md"
            },
            {
              "name": "fiftyone-develop-plugin",
              "sourceUrl": "https://github.com/voxel51/fiftyone-skills/blob/4fedd6ee7aa88e6e540e31bf54602528c9ca529d/skills/fiftyone-develop-plugin/SKILL.md"
            },
            {
              "name": "fiftyone-embeddings-visualization",
              "sourceUrl": "https://github.com/voxel51/fiftyone-skills/blob/4fedd6ee7aa88e6e540e31bf54602528c9ca529d/skills/fiftyone-embeddings-visualization/SKILL.md"
            },
            {
              "name": "fiftyone-eval-plugin",
              "sourceUrl": "https://github.com/voxel51/fiftyone-skills/blob/4fedd6ee7aa88e6e540e31bf54602528c9ca529d/skills/fiftyone-eval-plugin/SKILL.md"
            },
            {
              "name": "fiftyone-find-duplicates",
              "sourceUrl": "https://github.com/voxel51/fiftyone-skills/blob/4fedd6ee7aa88e6e540e31bf54602528c9ca529d/skills/fiftyone-find-duplicates/SKILL.md"
            },
            {
              "name": "fiftyone-generate-data-lens-connector",
              "sourceUrl": "https://github.com/voxel51/fiftyone-skills/blob/4fedd6ee7aa88e6e540e31bf54602528c9ca529d/skills/fiftyone-generate-data-lens-connector/SKILL.md"
            },
            {
              "name": "fiftyone-issue-triage",
              "sourceUrl": "https://github.com/voxel51/fiftyone-skills/blob/4fedd6ee7aa88e6e540e31bf54602528c9ca529d/skills/fiftyone-issue-triage/SKILL.md"
            },
            {
              "name": "fiftyone-model-evaluation",
              "sourceUrl": "https://github.com/voxel51/fiftyone-skills/blob/4fedd6ee7aa88e6e540e31bf54602528c9ca529d/skills/fiftyone-model-evaluation/SKILL.md"
            },
            {
              "name": "fiftyone-sdk-guidance",
              "sourceUrl": "https://github.com/voxel51/fiftyone-skills/blob/4fedd6ee7aa88e6e540e31bf54602528c9ca529d/skills/fiftyone-sdk-guidance/SKILL.md"
            },
            {
              "name": "fiftyone-troubleshoot",
              "sourceUrl": "https://github.com/voxel51/fiftyone-skills/blob/4fedd6ee7aa88e6e540e31bf54602528c9ca529d/skills/fiftyone-troubleshoot/SKILL.md"
            },
            {
              "name": "fiftyone-voodo-design",
              "sourceUrl": "https://github.com/voxel51/fiftyone-skills/blob/4fedd6ee7aa88e6e540e31bf54602528c9ca529d/skills/fiftyone-voodo-design/SKILL.md"
            },
            {
              "name": "fiftyone-zoo-remote-model",
              "sourceUrl": "https://github.com/voxel51/fiftyone-skills/blob/4fedd6ee7aa88e6e540e31bf54602528c9ca529d/skills/fiftyone-zoo-remote-model/SKILL.md"
            }
          ],
          "mcpServers": [
            {
              "requiresConfiguration": false,
              "name": "fiftyone",
              "transport": "stdio",
              "endpoint": null
            }
          ],
          "components": ["skills", "mcp", "commands"],
          "componentInspection": "repository",
          "inspectionError": null,
          "installation": "requires_adapter",
          "upstream": {
            "source": {
              "source": "url",
              "url": "https://github.com/voxel51/fiftyone-skills.git",
              "sha": "4fedd6ee7aa88e6e540e31bf54602528c9ca529d"
            },
            "policy": null
          }
        },
        {
          "id": "anthropic:figma",
          "name": "figma",
          "displayName": "figma",
          "description": "Plugin that includes the Figma MCP server and Skills for common workflows",
          "longDescription": "Plugin that includes the Figma MCP server and Skills for common workflows",
          "category": "design",
          "keywords": [],
          "author": {
            "name": "Figma"
          },
          "version": "2.2.107",
          "license": null,
          "logoUrl": null,
          "darkLogoUrl": null,
          "homepage": "https://github.com/figma/mcp-server-guide",
          "sourceUrl": "https://github.com/figma/mcp-server-guide/tree/ae7e5e5f80da20f1dd7445e0c6ae5ac58a5b0bce/",
          "skills": [
            {
              "name": "figma-code-connect",
              "sourceUrl": "https://github.com/figma/mcp-server-guide/blob/ae7e5e5f80da20f1dd7445e0c6ae5ac58a5b0bce/skills/figma-code-connect/SKILL.md"
            },
            {
              "name": "figma-create-new-file",
              "sourceUrl": "https://github.com/figma/mcp-server-guide/blob/ae7e5e5f80da20f1dd7445e0c6ae5ac58a5b0bce/skills/figma-create-new-file/SKILL.md"
            },
            {
              "name": "figma-design-to-code",
              "sourceUrl": "https://github.com/figma/mcp-server-guide/blob/ae7e5e5f80da20f1dd7445e0c6ae5ac58a5b0bce/skills/figma-design-to-code/SKILL.md"
            },
            {
              "name": "figma-generate-design",
              "sourceUrl": "https://github.com/figma/mcp-server-guide/blob/ae7e5e5f80da20f1dd7445e0c6ae5ac58a5b0bce/skills/figma-generate-design/SKILL.md"
            },
            {
              "name": "figma-generate-diagram",
              "sourceUrl": "https://github.com/figma/mcp-server-guide/blob/ae7e5e5f80da20f1dd7445e0c6ae5ac58a5b0bce/skills/figma-generate-diagram/SKILL.md"
            },
            {
              "name": "figma-generate-library",
              "sourceUrl": "https://github.com/figma/mcp-server-guide/blob/ae7e5e5f80da20f1dd7445e0c6ae5ac58a5b0bce/skills/figma-generate-library/SKILL.md"
            },
            {
              "name": "figma-generative-plugins",
              "sourceUrl": "https://github.com/figma/mcp-server-guide/blob/ae7e5e5f80da20f1dd7445e0c6ae5ac58a5b0bce/skills/figma-generative-plugins/SKILL.md"
            },
            {
              "name": "figma-implement-motion",
              "sourceUrl": "https://github.com/figma/mcp-server-guide/blob/ae7e5e5f80da20f1dd7445e0c6ae5ac58a5b0bce/skills/figma-implement-motion/SKILL.md"
            },
            {
              "name": "figma-shaders",
              "sourceUrl": "https://github.com/figma/mcp-server-guide/blob/ae7e5e5f80da20f1dd7445e0c6ae5ac58a5b0bce/skills/figma-shaders/SKILL.md"
            },
            {
              "name": "figma-swiftui",
              "sourceUrl": "https://github.com/figma/mcp-server-guide/blob/ae7e5e5f80da20f1dd7445e0c6ae5ac58a5b0bce/skills/figma-swiftui/SKILL.md"
            },
            {
              "name": "figma-use-figjam",
              "sourceUrl": "https://github.com/figma/mcp-server-guide/blob/ae7e5e5f80da20f1dd7445e0c6ae5ac58a5b0bce/skills/figma-use-figjam/SKILL.md"
            },
            {
              "name": "figma-use-motion",
              "sourceUrl": "https://github.com/figma/mcp-server-guide/blob/ae7e5e5f80da20f1dd7445e0c6ae5ac58a5b0bce/skills/figma-use-motion/SKILL.md"
            },
            {
              "name": "figma-use-slides",
              "sourceUrl": "https://github.com/figma/mcp-server-guide/blob/ae7e5e5f80da20f1dd7445e0c6ae5ac58a5b0bce/skills/figma-use-slides/SKILL.md"
            },
            {
              "name": "figma-use",
              "sourceUrl": "https://github.com/figma/mcp-server-guide/blob/ae7e5e5f80da20f1dd7445e0c6ae5ac58a5b0bce/skills/figma-use/SKILL.md"
            },
            {
              "name": "generate-project-plan",
              "sourceUrl": "https://github.com/figma/mcp-server-guide/blob/ae7e5e5f80da20f1dd7445e0c6ae5ac58a5b0bce/workflow-skills/generate-project-plan/SKILL.md"
            },
            {
              "name": "video-interaction-mapper",
              "sourceUrl": "https://github.com/figma/mcp-server-guide/blob/ae7e5e5f80da20f1dd7445e0c6ae5ac58a5b0bce/workflow-skills/video-interaction-mapper/SKILL.md"
            }
          ],
          "mcpServers": [
            {
              "requiresConfiguration": true,
              "name": "figma",
              "transport": "http",
              "endpoint": "https://mcp.figma.com/mcp"
            }
          ],
          "components": ["skills", "mcp"],
          "componentInspection": "repository",
          "inspectionError": null,
          "installation": "requires_adapter",
          "upstream": {
            "source": {
              "source": "url",
              "url": "https://github.com/figma/mcp-server-guide.git",
              "sha": "ae7e5e5f80da20f1dd7445e0c6ae5ac58a5b0bce"
            },
            "policy": null
          }
        },
        {
          "id": "anthropic:firebase",
          "name": "firebase",
          "displayName": "firebase",
          "description": "Google Firebase MCP integration. Manage Firestore databases, authentication, cloud functions, hosting, and storage. Build and manage your Firebase backend directly from your development workflow.",
          "longDescription": "Google Firebase MCP integration. Manage Firestore databases, authentication, cloud functions, hosting, and storage. Build and manage your Firebase backend directly from your development workflow.",
          "category": "database",
          "keywords": [],
          "author": {
            "name": "Google"
          },
          "version": null,
          "license": null,
          "logoUrl": null,
          "darkLogoUrl": null,
          "homepage": "https://github.com/anthropics/claude-plugins-public/tree/main/external_plugins/firebase",
          "sourceUrl": "https://github.com/anthropics/claude-plugins-official/tree/3b600518a637492d37c9877aeb49c2a55d939c04/external_plugins/firebase",
          "skills": [],
          "mcpServers": [
            {
              "requiresConfiguration": false,
              "name": "firebase",
              "transport": "stdio",
              "endpoint": null
            }
          ],
          "components": ["mcp"],
          "componentInspection": "repository",
          "inspectionError": null,
          "installation": "requires_adapter",
          "upstream": {
            "source": "./external_plugins/firebase",
            "policy": null
          }
        },
        {
          "id": "anthropic:firecrawl",
          "name": "firecrawl",
          "displayName": "firecrawl",
          "description": "Scrape, search, crawl, and map the web with a single command.",
          "longDescription": "Scrape, search, crawl, and map the web with a single command.",
          "category": "development",
          "keywords": [],
          "author": {
            "name": "Firecrawl"
          },
          "version": "1.0.9",
          "license": null,
          "logoUrl": null,
          "darkLogoUrl": null,
          "homepage": "https://github.com/firecrawl/firecrawl-claude-plugin.git",
          "sourceUrl": "https://github.com/firecrawl/firecrawl-claude-plugin/tree/b5978f60d8308650821918bf4476fc3b701e88b9/",
          "skills": [
            {
              "name": "firecrawl-agent",
              "sourceUrl": "https://github.com/firecrawl/firecrawl-claude-plugin/blob/b5978f60d8308650821918bf4476fc3b701e88b9/skills/firecrawl-agent/SKILL.md"
            },
            {
              "name": "firecrawl-crawl",
              "sourceUrl": "https://github.com/firecrawl/firecrawl-claude-plugin/blob/b5978f60d8308650821918bf4476fc3b701e88b9/skills/firecrawl-crawl/SKILL.md"
            },
            {
              "name": "firecrawl-developer-index",
              "sourceUrl": "https://github.com/firecrawl/firecrawl-claude-plugin/blob/b5978f60d8308650821918bf4476fc3b701e88b9/skills/firecrawl-developer-index/SKILL.md"
            },
            {
              "name": "firecrawl-download",
              "sourceUrl": "https://github.com/firecrawl/firecrawl-claude-plugin/blob/b5978f60d8308650821918bf4476fc3b701e88b9/skills/firecrawl-download/SKILL.md"
            },
            {
              "name": "firecrawl-interact",
              "sourceUrl": "https://github.com/firecrawl/firecrawl-claude-plugin/blob/b5978f60d8308650821918bf4476fc3b701e88b9/skills/firecrawl-interact/SKILL.md"
            },
            {
              "name": "firecrawl-map",
              "sourceUrl": "https://github.com/firecrawl/firecrawl-claude-plugin/blob/b5978f60d8308650821918bf4476fc3b701e88b9/skills/firecrawl-map/SKILL.md"
            },
            {
              "name": "firecrawl-monitor",
              "sourceUrl": "https://github.com/firecrawl/firecrawl-claude-plugin/blob/b5978f60d8308650821918bf4476fc3b701e88b9/skills/firecrawl-monitor/SKILL.md"
            },
            {
              "name": "firecrawl-parse",
              "sourceUrl": "https://github.com/firecrawl/firecrawl-claude-plugin/blob/b5978f60d8308650821918bf4476fc3b701e88b9/skills/firecrawl-parse/SKILL.md"
            },
            {
              "name": "firecrawl-research-index",
              "sourceUrl": "https://github.com/firecrawl/firecrawl-claude-plugin/blob/b5978f60d8308650821918bf4476fc3b701e88b9/skills/firecrawl-research-index/SKILL.md"
            },
            {
              "name": "firecrawl-scrape",
              "sourceUrl": "https://github.com/firecrawl/firecrawl-claude-plugin/blob/b5978f60d8308650821918bf4476fc3b701e88b9/skills/firecrawl-scrape/SKILL.md"
            },
            {
              "name": "firecrawl-search",
              "sourceUrl": "https://github.com/firecrawl/firecrawl-claude-plugin/blob/b5978f60d8308650821918bf4476fc3b701e88b9/skills/firecrawl-search/SKILL.md"
            },
            {
              "name": "firecrawl",
              "sourceUrl": "https://github.com/firecrawl/firecrawl-claude-plugin/blob/b5978f60d8308650821918bf4476fc3b701e88b9/skills/firecrawl/SKILL.md"
            }
          ],
          "mcpServers": [],
          "components": ["skills", "commands"],
          "componentInspection": "repository",
          "inspectionError": null,
          "installation": "requires_adapter",
          "upstream": {
            "source": {
              "source": "url",
              "url": "https://github.com/firecrawl/firecrawl-claude-plugin.git",
              "sha": "b5978f60d8308650821918bf4476fc3b701e88b9"
            },
            "policy": null
          }
        },
        {
          "id": "anthropic:firestore-native",
          "name": "firestore-native",
          "displayName": "firestore-native",
          "description": "Connect and interact with Firestore databases, collections, and documents.",
          "longDescription": "Connect and interact with Firestore databases, collections, and documents.",
          "category": "database",
          "keywords": [],
          "author": {
            "name": "Google LLC",
            "email": "data-cloud-ai-integrations@google.com"
          },
          "version": "0.3.4",
          "license": "Apache-2.0",
          "logoUrl": null,
          "darkLogoUrl": null,
          "homepage": "https://cloud.google.com/firestore",
          "sourceUrl": "https://github.com/gemini-cli-extensions/firestore-native/tree/502ff19b853e760539717d3c640300af3400bba3/",
          "skills": [],
          "mcpServers": [
            {
              "requiresConfiguration": false,
              "name": "firestore",
              "transport": "stdio",
              "endpoint": null
            }
          ],
          "components": ["mcp"],
          "componentInspection": "repository",
          "inspectionError": null,
          "installation": "requires_adapter",
          "upstream": {
            "source": {
              "source": "url",
              "url": "https://github.com/gemini-cli-extensions/firestore-native.git",
              "sha": "502ff19b853e760539717d3c640300af3400bba3"
            },
            "policy": null
          }
        },
        {
          "id": "anthropic:forge-skills",
          "name": "forge-skills",
          "displayName": "forge-skills",
          "description": "Forge app builder skill bundle with Forge MCP configuration for Atlassian Forge workflows.",
          "longDescription": "Forge app builder skill bundle with Forge MCP configuration for Atlassian Forge workflows.",
          "category": "development",
          "keywords": [],
          "author": {
            "name": "Atlassian Labs"
          },
          "version": "0.1.0",
          "license": null,
          "logoUrl": null,
          "darkLogoUrl": null,
          "homepage": "https://developer.atlassian.com/platform/forge/",
          "sourceUrl": "https://github.com/atlassian/forge-skills/tree/4f04ae02879435f23808a4798da28f75d3ab74c3/",
          "skills": [
            {
              "name": "forge-app-builder",
              "sourceUrl": "https://github.com/atlassian/forge-skills/blob/4f04ae02879435f23808a4798da28f75d3ab74c3/skills/forge-app-builder/SKILL.md"
            },
            {
              "name": "forge-app-review",
              "sourceUrl": "https://github.com/atlassian/forge-skills/blob/4f04ae02879435f23808a4798da28f75d3ab74c3/skills/forge-app-review/SKILL.md"
            },
            {
              "name": "forge-connector",
              "sourceUrl": "https://github.com/atlassian/forge-skills/blob/4f04ae02879435f23808a4798da28f75d3ab74c3/skills/forge-connector/SKILL.md"
            },
            {
              "name": "forge-cost-optimizer",
              "sourceUrl": "https://github.com/atlassian/forge-skills/blob/4f04ae02879435f23808a4798da28f75d3ab74c3/skills/forge-cost-optimizer/SKILL.md"
            },
            {
              "name": "forge-debugger",
              "sourceUrl": "https://github.com/atlassian/forge-skills/blob/4f04ae02879435f23808a4798da28f75d3ab74c3/skills/forge-debugger/SKILL.md"
            },
            {
              "name": "forge-security-review",
              "sourceUrl": "https://github.com/atlassian/forge-skills/blob/4f04ae02879435f23808a4798da28f75d3ab74c3/skills/forge-security-review/SKILL.md"
            }
          ],
          "mcpServers": [
            {
              "requiresConfiguration": false,
              "name": "forge",
              "transport": "http",
              "endpoint": "https://mcp.atlassian.com/v1/forge/mcp"
            },
            {
              "requiresConfiguration": false,
              "name": "ads-mcp",
              "transport": "http",
              "endpoint": "https://mcp.atlassian.com/v1/ads/public/mcp"
            }
          ],
          "components": ["skills", "mcp"],
          "componentInspection": "repository",
          "inspectionError": null,
          "installation": "requires_adapter",
          "upstream": {
            "source": {
              "source": "url",
              "url": "https://github.com/atlassian/forge-skills.git",
              "sha": "4f04ae02879435f23808a4798da28f75d3ab74c3"
            },
            "policy": null
          }
        },
        {
          "id": "anthropic:frontend-design",
          "name": "frontend-design",
          "displayName": "frontend-design",
          "description": "Frontend design skill for UI/UX implementation",
          "longDescription": "Frontend design skill for UI/UX implementation",
          "category": "development",
          "keywords": [],
          "author": {
            "name": "Anthropic",
            "email": "support@anthropic.com"
          },
          "version": null,
          "license": null,
          "logoUrl": null,
          "darkLogoUrl": null,
          "homepage": "https://github.com/anthropics/claude-plugins-public/tree/main/plugins/frontend-design",
          "sourceUrl": "https://github.com/anthropics/claude-plugins-official/tree/3b600518a637492d37c9877aeb49c2a55d939c04/plugins/frontend-design",
          "skills": [
            {
              "name": "frontend-design",
              "sourceUrl": "https://github.com/anthropics/claude-plugins-official/blob/3b600518a637492d37c9877aeb49c2a55d939c04/plugins/frontend-design/skills/frontend-design/SKILL.md"
            }
          ],
          "mcpServers": [],
          "components": ["skills"],
          "componentInspection": "repository",
          "inspectionError": null,
          "installation": "requires_adapter",
          "upstream": {
            "source": "./plugins/frontend-design",
            "policy": null
          }
        },
        {
          "id": "anthropic:fullstory",
          "name": "fullstory",
          "displayName": "fullstory",
          "description": "Connect Claude to Fullstory to query behavioral analytics, session replays, and customer experience insights.",
          "longDescription": "Connect Claude to Fullstory to query behavioral analytics, session replays, and customer experience insights.",
          "category": "monitoring",
          "keywords": [
            "analytics",
            "customer-experience",
            "behavioral-analytics",
            "session-replay"
          ],
          "author": {
            "name": "Fullstory"
          },
          "version": "0.1.0",
          "license": "MIT",
          "logoUrl": null,
          "darkLogoUrl": null,
          "homepage": "https://www.fullstory.com",
          "sourceUrl": "https://github.com/fullstorydev/fullstory-skills/tree/b20614e2d08d7a7c70775bb62b5af640f60b024b/",
          "skills": [
            {
              "name": "comparisons",
              "sourceUrl": "https://github.com/fullstorydev/fullstory-skills/blob/b20614e2d08d7a7c70775bb62b5af640f60b024b/skills/comparisons/SKILL.md"
            },
            {
              "name": "general-analysis",
              "sourceUrl": "https://github.com/fullstorydev/fullstory-skills/blob/b20614e2d08d7a7c70775bb62b5af640f60b024b/skills/general-analysis/SKILL.md"
            },
            {
              "name": "session-review",
              "sourceUrl": "https://github.com/fullstorydev/fullstory-skills/blob/b20614e2d08d7a7c70775bb62b5af640f60b024b/skills/session-review/SKILL.md"
            }
          ],
          "mcpServers": [
            {
              "requiresConfiguration": false,
              "name": "fullstory",
              "transport": "http",
              "endpoint": "https://api.fullstory.com/mcp/fullstory"
            }
          ],
          "components": ["skills", "mcp", "agents"],
          "componentInspection": "repository",
          "inspectionError": null,
          "installation": "requires_adapter",
          "upstream": {
            "source": {
              "source": "url",
              "url": "https://github.com/fullstorydev/fullstory-skills.git",
              "sha": "b20614e2d08d7a7c70775bb62b5af640f60b024b"
            },
            "policy": null
          }
        },
        {
          "id": "anthropic:gc-ai",
          "name": "gc-ai",
          "displayName": "gc-ai",
          "description": "Work in your GC AI legal knowledge base from Claude: upload documents, run review playbooks, and ask questions grounded in your own files, all as you.",
          "longDescription": "Work in your GC AI legal knowledge base from Claude: upload documents, run review playbooks, and ask questions grounded in your own files, all as you.",
          "category": "productivity",
          "keywords": ["legal", "contracts", "document-review", "playbooks", "gc-ai"],
          "author": {
            "name": "GC AI",
            "email": "support@gc.ai",
            "url": "https://gc.ai"
          },
          "version": "0.1.0",
          "license": "MIT",
          "logoUrl": null,
          "darkLogoUrl": null,
          "homepage": "https://github.com/GC-AI-Inc/gc-ai-claude-plugin",
          "sourceUrl": "https://github.com/GC-AI-Inc/gc-ai-claude-plugin/tree/efda779972c7b7162e79234e164bc2f359a8a518/",
          "skills": [
            {
              "name": "ask",
              "sourceUrl": "https://github.com/GC-AI-Inc/gc-ai-claude-plugin/blob/efda779972c7b7162e79234e164bc2f359a8a518/skills/ask/SKILL.md"
            },
            {
              "name": "organize-matter",
              "sourceUrl": "https://github.com/GC-AI-Inc/gc-ai-claude-plugin/blob/efda779972c7b7162e79234e164bc2f359a8a518/skills/organize-matter/SKILL.md"
            },
            {
              "name": "review-document",
              "sourceUrl": "https://github.com/GC-AI-Inc/gc-ai-claude-plugin/blob/efda779972c7b7162e79234e164bc2f359a8a518/skills/review-document/SKILL.md"
            }
          ],
          "mcpServers": [
            {
              "requiresConfiguration": false,
              "name": "gc-ai",
              "transport": "http",
              "endpoint": "https://app.gc.ai/api/mcp"
            }
          ],
          "components": ["skills", "mcp", "agents"],
          "componentInspection": "repository",
          "inspectionError": null,
          "installation": "requires_adapter",
          "upstream": {
            "source": {
              "source": "url",
              "url": "https://github.com/GC-AI-Inc/gc-ai-claude-plugin.git",
              "sha": "efda779972c7b7162e79234e164bc2f359a8a518"
            },
            "policy": null
          }
        },
        {
          "id": "anthropic:github",
          "name": "github",
          "displayName": "github",
          "description": "Official GitHub MCP server for repository management. Create issues, manage pull requests, review code, search repositories, and interact with GitHub's full API directly from Claude Code.",
          "longDescription": "Official GitHub MCP server for repository management. Create issues, manage pull requests, review code, search repositories, and interact with GitHub's full API directly from Claude Code.",
          "category": "productivity",
          "keywords": [],
          "author": {
            "name": "GitHub"
          },
          "version": null,
          "license": null,
          "logoUrl": null,
          "darkLogoUrl": null,
          "homepage": "https://github.com/anthropics/claude-plugins-public/tree/main/external_plugins/github",
          "sourceUrl": "https://github.com/anthropics/claude-plugins-official/tree/3b600518a637492d37c9877aeb49c2a55d939c04/external_plugins/github",
          "skills": [],
          "mcpServers": [
            {
              "requiresConfiguration": true,
              "name": "github",
              "transport": "http",
              "endpoint": "https://api.githubcopilot.com/mcp/"
            }
          ],
          "components": ["mcp"],
          "componentInspection": "repository",
          "inspectionError": null,
          "installation": "requires_adapter",
          "upstream": {
            "source": "./external_plugins/github",
            "policy": null
          }
        },
        {
          "id": "anthropic:gitkraken",
          "name": "gitkraken",
          "displayName": "gitkraken",
          "description": "This plugin gives Claude access to your real Git and project context: commits, branches, pull requests, and issues across every repo you work in. Ask the agent a question about your work, and it answers from what's actually in your history and your trackers, not what it can guess from the open file.\n\nWorks with GitHub, GitLab, Azure DevOps, Bitbucket, and Jira.",
          "longDescription": "This plugin gives Claude access to your real Git and project context: commits, branches, pull requests, and issues across every repo you work in. Ask the agent a question about your work, and it answers from what's actually in your history and your trackers, not what it can guess from the open file.\n\nWorks with GitHub, GitLab, Azure DevOps, Bitbucket, and Jira.",
          "category": "development",
          "keywords": [],
          "author": {
            "name": "GitKraken"
          },
          "version": "1.0.0",
          "license": null,
          "logoUrl": null,
          "darkLogoUrl": null,
          "homepage": "https://www.gitkraken.com",
          "sourceUrl": "https://github.com/gitkraken/claude-plugin/tree/f7a53b2cd138c22eccb977b9d93494ea6d423d12/",
          "skills": [],
          "mcpServers": [],
          "components": ["mcp"],
          "componentInspection": "repository",
          "inspectionError": null,
          "installation": "requires_adapter",
          "upstream": {
            "source": {
              "source": "url",
              "url": "https://github.com/gitkraken/claude-plugin.git",
              "sha": "f7a53b2cd138c22eccb977b9d93494ea6d423d12"
            },
            "policy": null
          }
        },
        {
          "id": "anthropic:gitlab",
          "name": "gitlab",
          "displayName": "gitlab",
          "description": "GitLab DevOps platform integration. Manage repositories, merge requests, CI/CD pipelines, issues, and wikis. Full access to GitLab's comprehensive DevOps lifecycle tools.",
          "longDescription": "GitLab DevOps platform integration. Manage repositories, merge requests, CI/CD pipelines, issues, and wikis. Full access to GitLab's comprehensive DevOps lifecycle tools.",
          "category": "productivity",
          "keywords": [],
          "author": {
            "name": "GitLab"
          },
          "version": null,
          "license": null,
          "logoUrl": null,
          "darkLogoUrl": null,
          "homepage": "https://github.com/anthropics/claude-plugins-public/tree/main/external_plugins/gitlab",
          "sourceUrl": "https://github.com/anthropics/claude-plugins-official/tree/3b600518a637492d37c9877aeb49c2a55d939c04/external_plugins/gitlab",
          "skills": [],
          "mcpServers": [
            {
              "requiresConfiguration": false,
              "name": "gitlab",
              "transport": "http",
              "endpoint": "https://gitlab.com/api/v4/mcp"
            }
          ],
          "components": ["mcp"],
          "componentInspection": "repository",
          "inspectionError": null,
          "installation": "requires_adapter",
          "upstream": {
            "source": "./external_plugins/gitlab",
            "policy": null
          }
        },
        {
          "id": "anthropic:google-cloud-storage",
          "name": "google-cloud-storage",
          "displayName": "google-cloud-storage",
          "description": "Official Google Cloud Storage (GCS) plugin. Storage tools plus vetted skills to manage buckets and objects, transfer data, and configure MCP, FUSE, IAM, security, lifecycle rules, signed URLs, Terraform, and the CLI.",
          "longDescription": "Official Google Cloud Storage (GCS) plugin. Storage tools plus vetted skills to manage buckets and objects, transfer data, and configure MCP, FUSE, IAM, security, lifecycle rules, signed URLs, Terraform, and the CLI.",
          "category": "deployment",
          "keywords": [],
          "author": {
            "name": "Google LLC",
            "email": "gcs-agentic-ai-customer-support@google.com"
          },
          "version": "1.1.0",
          "license": "Apache-2.0",
          "logoUrl": null,
          "darkLogoUrl": null,
          "homepage": "https://cloud.google.com/storage",
          "sourceUrl": "https://github.com/gemini-cli-extensions/google-cloud-storage/tree/db08d0fdb8c133ca0cb82e742d9d54228c4a318b/",
          "skills": [
            {
              "name": "gcs-security-assessment",
              "sourceUrl": "https://github.com/gemini-cli-extensions/google-cloud-storage/blob/db08d0fdb8c133ca0cb82e742d9d54228c4a318b/skills/gcs-security-assessment/SKILL.md"
            },
            {
              "name": "google-cloud-storage-basics",
              "sourceUrl": "https://github.com/gemini-cli-extensions/google-cloud-storage/blob/db08d0fdb8c133ca0cb82e742d9d54228c4a318b/skills/google-cloud-storage-basics/SKILL.md"
            },
            {
              "name": "google-cloud-storage-bucket-architect",
              "sourceUrl": "https://github.com/gemini-cli-extensions/google-cloud-storage/blob/db08d0fdb8c133ca0cb82e742d9d54228c4a318b/skills/google-cloud-storage-bucket-architect/SKILL.md"
            },
            {
              "name": "google-cloud-storage-diagnostic",
              "sourceUrl": "https://github.com/gemini-cli-extensions/google-cloud-storage/blob/db08d0fdb8c133ca0cb82e742d9d54228c4a318b/skills/google-cloud-storage-diagnostic/SKILL.md"
            },
            {
              "name": "google-cloud-storage-fuse",
              "sourceUrl": "https://github.com/gemini-cli-extensions/google-cloud-storage/blob/db08d0fdb8c133ca0cb82e742d9d54228c4a318b/skills/google-cloud-storage-fuse/SKILL.md"
            }
          ],
          "mcpServers": [
            {
              "requiresConfiguration": false,
              "name": "cloud-storage",
              "transport": "stdio",
              "endpoint": null
            }
          ],
          "components": ["skills", "mcp"],
          "componentInspection": "repository",
          "inspectionError": null,
          "installation": "requires_adapter",
          "upstream": {
            "source": {
              "source": "url",
              "url": "https://github.com/gemini-cli-extensions/google-cloud-storage.git",
              "sha": "db08d0fdb8c133ca0cb82e742d9d54228c4a318b"
            },
            "policy": null
          }
        },
        {
          "id": "anthropic:gopls-lsp",
          "name": "gopls-lsp",
          "displayName": "gopls-lsp",
          "description": "Go language server for code intelligence and refactoring",
          "longDescription": "Go language server for code intelligence and refactoring",
          "category": "development",
          "keywords": [],
          "author": {
            "name": "Anthropic",
            "email": "support@anthropic.com"
          },
          "version": "1.0.0",
          "license": null,
          "logoUrl": null,
          "darkLogoUrl": null,
          "homepage": null,
          "sourceUrl": "https://github.com/anthropics/claude-plugins-official/tree/3b600518a637492d37c9877aeb49c2a55d939c04/plugins/gopls-lsp",
          "skills": [],
          "mcpServers": [],
          "components": [],
          "componentInspection": "repository",
          "inspectionError": null,
          "installation": "requires_adapter",
          "upstream": {
            "source": "./plugins/gopls-lsp",
            "policy": null
          }
        },
        {
          "id": "anthropic:grafana-assistant",
          "name": "grafana-assistant",
          "displayName": "grafana-assistant",
          "description": "Skills and rules for developing and using the Grafana Assistant app and CLI.",
          "longDescription": "Skills and rules for developing and using the Grafana Assistant app and CLI.",
          "category": "monitoring",
          "keywords": ["grafana", "assistant", "a2a", "cli"],
          "author": {
            "name": "Grafana Labs",
            "email": "grafana-assistant@grafana.com"
          },
          "version": "0.2.0",
          "license": "Apache-2.0",
          "logoUrl": null,
          "darkLogoUrl": null,
          "homepage": "https://github.com/grafana/ai-marketplace/tree/main/plugins/grafana-assistant",
          "sourceUrl": "https://github.com/grafana/ai-marketplace/tree/a5c72f2d74c640e9675eb0249526447968535015/plugins/grafana-assistant",
          "skills": [
            {
              "name": "grafana-assistant-cli",
              "sourceUrl": "https://github.com/grafana/ai-marketplace/blob/a5c72f2d74c640e9675eb0249526447968535015/plugins/grafana-assistant/skills/grafana-assistant-cli/SKILL.md"
            }
          ],
          "mcpServers": [],
          "components": ["skills"],
          "componentInspection": "repository",
          "inspectionError": null,
          "installation": "requires_adapter",
          "upstream": {
            "source": {
              "source": "git-subdir",
              "url": "https://github.com/grafana/ai-marketplace.git",
              "path": "plugins/grafana-assistant",
              "ref": "main",
              "sha": "a5c72f2d74c640e9675eb0249526447968535015"
            },
            "policy": null
          }
        },
        {
          "id": "anthropic:grafana-cloud-mcp",
          "name": "grafana-cloud-mcp",
          "displayName": "grafana-cloud-mcp",
          "description": "Hosted MCP server for AI-assisted Grafana Cloud observability — no local installation required.",
          "longDescription": "Hosted MCP server for AI-assisted Grafana Cloud observability — no local installation required.",
          "category": "monitoring",
          "keywords": [
            "grafana",
            "mcp",
            "cloud",
            "observability",
            "dashboards",
            "prometheus",
            "loki"
          ],
          "author": {
            "name": "Grafana Labs",
            "email": "grafana-assistant@grafana.com"
          },
          "version": "0.2.0",
          "license": "Apache-2.0",
          "logoUrl": null,
          "darkLogoUrl": null,
          "homepage": "https://github.com/grafana/ai-marketplace/tree/main/plugins/grafana-cloud-mcp",
          "sourceUrl": "https://github.com/grafana/ai-marketplace/tree/12be5634a492f73c189d466c5449d09b853ad7a4/plugins/grafana-cloud-mcp",
          "skills": [
            {
              "name": "grafana-cloud-mcp-tools",
              "sourceUrl": "https://github.com/grafana/ai-marketplace/blob/12be5634a492f73c189d466c5449d09b853ad7a4/plugins/grafana-cloud-mcp/skills/grafana-cloud-mcp-tools/SKILL.md"
            }
          ],
          "mcpServers": [
            {
              "requiresConfiguration": false,
              "name": "grafana-cloud",
              "transport": "http",
              "endpoint": "https://mcp.grafana.com/mcp"
            }
          ],
          "components": ["skills", "mcp"],
          "componentInspection": "repository",
          "inspectionError": null,
          "installation": "requires_adapter",
          "upstream": {
            "source": {
              "source": "git-subdir",
              "url": "https://github.com/grafana/ai-marketplace.git",
              "path": "plugins/grafana-cloud-mcp",
              "ref": "main",
              "sha": "12be5634a492f73c189d466c5449d09b853ad7a4"
            },
            "policy": null
          }
        },
        {
          "id": "anthropic:grafana-mcp",
          "name": "grafana-mcp",
          "displayName": "grafana-mcp",
          "description": "MCP server for AI-assisted Grafana dashboard, datasource, alerting, and incident management.",
          "longDescription": "MCP server for AI-assisted Grafana dashboard, datasource, alerting, and incident management.",
          "category": "monitoring",
          "keywords": ["grafana", "mcp", "observability", "dashboards", "prometheus", "loki"],
          "author": {
            "name": "Grafana Labs",
            "email": "grafana-assistant@grafana.com"
          },
          "version": "0.2.0",
          "license": "Apache-2.0",
          "logoUrl": null,
          "darkLogoUrl": null,
          "homepage": "https://github.com/grafana/ai-marketplace/tree/main/plugins/grafana-mcp",
          "sourceUrl": "https://github.com/grafana/ai-marketplace/tree/a5c72f2d74c640e9675eb0249526447968535015/plugins/grafana-mcp",
          "skills": [
            {
              "name": "grafana-mcp-tools",
              "sourceUrl": "https://github.com/grafana/ai-marketplace/blob/a5c72f2d74c640e9675eb0249526447968535015/plugins/grafana-mcp/skills/grafana-mcp-tools/SKILL.md"
            }
          ],
          "mcpServers": [
            {
              "requiresConfiguration": false,
              "name": "grafana",
              "transport": "stdio",
              "endpoint": null
            }
          ],
          "components": ["skills", "mcp"],
          "componentInspection": "repository",
          "inspectionError": null,
          "installation": "requires_adapter",
          "upstream": {
            "source": {
              "source": "git-subdir",
              "url": "https://github.com/grafana/ai-marketplace.git",
              "path": "plugins/grafana-mcp",
              "ref": "main",
              "sha": "a5c72f2d74c640e9675eb0249526447968535015"
            },
            "policy": null
          }
        },
        {
          "id": "anthropic:greptile",
          "name": "greptile",
          "displayName": "greptile",
          "description": "AI code review agent for GitHub and GitLab. View and resolve Greptile's PR review comments, run reviews on your working branch, and search your organization's knowledge base and coding patterns, directly from Claude Code.",
          "longDescription": "AI code review agent for GitHub and GitLab. View and resolve Greptile's PR review comments, run reviews on your working branch, and search your organization's knowledge base and coding patterns, directly from Claude Code.",
          "category": "development",
          "keywords": ["code-review", "pull-requests", "github", "gitlab", "knowledge-base", "ai"],
          "author": {
            "name": "Greptile",
            "url": "https://greptile.com"
          },
          "version": "1.2.3",
          "license": "MIT",
          "logoUrl": null,
          "darkLogoUrl": null,
          "homepage": "https://www.greptile.com/docs/mcp-v2/overview",
          "sourceUrl": "https://github.com/greptileai/claude-plugin/tree/6b725af2636072cab79e0a5426f6a960b0fd29ef/plugins/greptile",
          "skills": [],
          "mcpServers": [
            {
              "requiresConfiguration": false,
              "name": "greptile",
              "transport": "http",
              "endpoint": "https://api.greptile.com/mcp"
            }
          ],
          "components": ["mcp", "commands"],
          "componentInspection": "repository",
          "inspectionError": null,
          "installation": "requires_adapter",
          "upstream": {
            "source": {
              "source": "git-subdir",
              "url": "https://github.com/greptileai/claude-plugin.git",
              "path": "plugins/greptile",
              "ref": "greptile--v1.2.3",
              "sha": "6b725af2636072cab79e0a5426f6a960b0fd29ef"
            },
            "policy": null
          }
        },
        {
          "id": "anthropic:growthbook",
          "name": "growthbook",
          "displayName": "growthbook",
          "description": "Domain skills for the full GrowthBook feature flag, experimentation, and product analytics lifecycle.",
          "longDescription": "Domain skills for the full GrowthBook feature flag, experimentation, and product analytics lifecycle.",
          "category": "testing",
          "keywords": ["growthbook", "feature-flags", "experimentation", "ab-testing"],
          "author": {
            "name": "GrowthBook",
            "url": "https://growthbook.io"
          },
          "version": "2.0.0",
          "license": "MIT",
          "logoUrl": null,
          "darkLogoUrl": null,
          "homepage": "https://growthbook.io",
          "sourceUrl": "https://github.com/growthbook/skills/tree/6ab3294a4f9fe2b6f88ad567cbb2bf6cb9a2343b/",
          "skills": [
            {
              "name": "analytics",
              "sourceUrl": "https://github.com/growthbook/skills/blob/6ab3294a4f9fe2b6f88ad567cbb2bf6cb9a2343b/skills/analytics/SKILL.md"
            },
            {
              "name": "experiments",
              "sourceUrl": "https://github.com/growthbook/skills/blob/6ab3294a4f9fe2b6f88ad567cbb2bf6cb9a2343b/skills/experiments/SKILL.md"
            },
            {
              "name": "feature-flags",
              "sourceUrl": "https://github.com/growthbook/skills/blob/6ab3294a4f9fe2b6f88ad567cbb2bf6cb9a2343b/skills/feature-flags/SKILL.md"
            },
            {
              "name": "gb-setup",
              "sourceUrl": "https://github.com/growthbook/skills/blob/6ab3294a4f9fe2b6f88ad567cbb2bf6cb9a2343b/skills/gb-setup/SKILL.md"
            }
          ],
          "mcpServers": [],
          "components": ["skills"],
          "componentInspection": "repository",
          "inspectionError": null,
          "installation": "requires_adapter",
          "upstream": {
            "source": {
              "source": "url",
              "url": "https://github.com/growthbook/skills.git",
              "sha": "6ab3294a4f9fe2b6f88ad567cbb2bf6cb9a2343b"
            },
            "policy": null
          }
        },
        {
          "id": "anthropic:honeycomb",
          "name": "honeycomb",
          "displayName": "honeycomb",
          "description": "Skills, agents, and workflows for Honeycomb observability — query patterns, production investigations, SLOs, OpenTelemetry instrumentation, and Beeline migration. Designed to complement the Honeycomb MCP server.",
          "longDescription": "Skills, agents, and workflows for Honeycomb observability — query patterns, production investigations, SLOs, OpenTelemetry instrumentation, and Beeline migration. Designed to complement the Honeycomb MCP server.",
          "category": "monitoring",
          "keywords": [
            "honeycomb",
            "observability",
            "opentelemetry",
            "tracing",
            "slo",
            "mcp",
            "debugging",
            "instrumentation"
          ],
          "author": {
            "name": "Honeycomb",
            "url": "https://honeycomb.io"
          },
          "version": "1.2.1",
          "license": "MIT",
          "logoUrl": null,
          "darkLogoUrl": null,
          "homepage": "https://docs.honeycomb.io/integrations/mcp/",
          "sourceUrl": "https://github.com/honeycombio/agent-skill/tree/41214b7dfb97f262adabf295fa6f0fcad85bc0f6/honeycomb",
          "skills": [
            {
              "name": "beeline-migration",
              "sourceUrl": "https://github.com/honeycombio/agent-skill/blob/41214b7dfb97f262adabf295fa6f0fcad85bc0f6/honeycomb/skills/beeline-migration/SKILL.md"
            },
            {
              "name": "create-honeycomb-board",
              "sourceUrl": "https://github.com/honeycombio/agent-skill/blob/41214b7dfb97f262adabf295fa6f0fcad85bc0f6/honeycomb/skills/create-honeycomb-board/SKILL.md"
            },
            {
              "name": "metrics-queries",
              "sourceUrl": "https://github.com/honeycombio/agent-skill/blob/41214b7dfb97f262adabf295fa6f0fcad85bc0f6/honeycomb/skills/metrics-queries/SKILL.md"
            },
            {
              "name": "observability-fundamentals",
              "sourceUrl": "https://github.com/honeycombio/agent-skill/blob/41214b7dfb97f262adabf295fa6f0fcad85bc0f6/honeycomb/skills/observability-fundamentals/SKILL.md"
            },
            {
              "name": "otel-genai-instrumentation",
              "sourceUrl": "https://github.com/honeycombio/agent-skill/blob/41214b7dfb97f262adabf295fa6f0fcad85bc0f6/honeycomb/skills/otel-genai-instrumentation/SKILL.md"
            },
            {
              "name": "otel-instrumentation",
              "sourceUrl": "https://github.com/honeycombio/agent-skill/blob/41214b7dfb97f262adabf295fa6f0fcad85bc0f6/honeycomb/skills/otel-instrumentation/SKILL.md"
            },
            {
              "name": "otel-migration",
              "sourceUrl": "https://github.com/honeycombio/agent-skill/blob/41214b7dfb97f262adabf295fa6f0fcad85bc0f6/honeycomb/skills/otel-migration/SKILL.md"
            },
            {
              "name": "production-investigation",
              "sourceUrl": "https://github.com/honeycombio/agent-skill/blob/41214b7dfb97f262adabf295fa6f0fcad85bc0f6/honeycomb/skills/production-investigation/SKILL.md"
            },
            {
              "name": "query-patterns",
              "sourceUrl": "https://github.com/honeycombio/agent-skill/blob/41214b7dfb97f262adabf295fa6f0fcad85bc0f6/honeycomb/skills/query-patterns/SKILL.md"
            },
            {
              "name": "slos-and-triggers",
              "sourceUrl": "https://github.com/honeycombio/agent-skill/blob/41214b7dfb97f262adabf295fa6f0fcad85bc0f6/honeycomb/skills/slos-and-triggers/SKILL.md"
            },
            {
              "name": "verify-recent-trace",
              "sourceUrl": "https://github.com/honeycombio/agent-skill/blob/41214b7dfb97f262adabf295fa6f0fcad85bc0f6/honeycomb/skills/verify-recent-trace/SKILL.md"
            }
          ],
          "mcpServers": [
            {
              "requiresConfiguration": false,
              "name": "honeycomb",
              "transport": "http",
              "endpoint": "https://mcp.honeycomb.io/mcp"
            }
          ],
          "components": ["skills", "mcp", "hooks", "agents", "commands"],
          "componentInspection": "repository",
          "inspectionError": null,
          "installation": "requires_adapter",
          "upstream": {
            "source": {
              "source": "git-subdir",
              "url": "https://github.com/honeycombio/agent-skill.git",
              "path": "honeycomb",
              "ref": "main",
              "sha": "41214b7dfb97f262adabf295fa6f0fcad85bc0f6"
            },
            "policy": null
          }
        },
        {
          "id": "anthropic:hookify",
          "name": "hookify",
          "displayName": "hookify",
          "description": "Easily create hooks to prevent unwanted behaviors by analyzing conversation patterns",
          "longDescription": "Easily create hooks to prevent unwanted behaviors by analyzing conversation patterns",
          "category": "productivity",
          "keywords": [],
          "author": {
            "name": "Anthropic",
            "email": "support@anthropic.com"
          },
          "version": null,
          "license": null,
          "logoUrl": null,
          "darkLogoUrl": null,
          "homepage": "https://github.com/anthropics/claude-plugins-public/tree/main/plugins/hookify",
          "sourceUrl": "https://github.com/anthropics/claude-plugins-official/tree/3b600518a637492d37c9877aeb49c2a55d939c04/plugins/hookify",
          "skills": [
            {
              "name": "writing-rules",
              "sourceUrl": "https://github.com/anthropics/claude-plugins-official/blob/3b600518a637492d37c9877aeb49c2a55d939c04/plugins/hookify/skills/writing-rules/SKILL.md"
            }
          ],
          "mcpServers": [],
          "components": ["skills", "hooks", "agents", "commands"],
          "componentInspection": "repository",
          "inspectionError": null,
          "installation": "requires_adapter",
          "upstream": {
            "source": "./plugins/hookify",
            "policy": null
          }
        },
        {
          "id": "anthropic:hostinger",
          "name": "hostinger",
          "displayName": "hostinger",
          "description": "Deploy, manage and monitor Hostinger services — Websites, Domains & DNS, Ecommerce, Email, Email Marketing, WordPress, Subscriptions & Payments, and VPS. Runs as a remote MCP server with browser (OAuth) sign-in — nothing to install locally.",
          "longDescription": "Deploy, manage and monitor Hostinger services — Websites, Domains & DNS, Ecommerce, Email, Email Marketing, WordPress, Subscriptions & Payments, and VPS. Runs as a remote MCP server with browser (OAuth) sign-in — nothing to install locally.",
          "category": "deployment",
          "keywords": [],
          "author": {
            "name": "Hostinger",
            "url": "https://www.hostinger.com"
          },
          "version": "1.2.0",
          "license": "MIT",
          "logoUrl": null,
          "darkLogoUrl": null,
          "homepage": "https://developers.hostinger.com",
          "sourceUrl": "https://github.com/hostinger/claude-plugin/tree/569880c60681a7068b3ca8ca84e2fe7ab6cfa7ff/",
          "skills": [
            {
              "name": "agency-hosting-deploy-php-site",
              "sourceUrl": "https://github.com/hostinger/claude-plugin/blob/569880c60681a7068b3ca8ca84e2fe7ab6cfa7ff/skills/agency-hosting-deploy-php-site/SKILL.md"
            },
            {
              "name": "agency-hosting-deploy-static-site",
              "sourceUrl": "https://github.com/hostinger/claude-plugin/blob/569880c60681a7068b3ca8ca84e2fe7ab6cfa7ff/skills/agency-hosting-deploy-static-site/SKILL.md"
            },
            {
              "name": "hosting-deploy-nodejs-app",
              "sourceUrl": "https://github.com/hostinger/claude-plugin/blob/569880c60681a7068b3ca8ca84e2fe7ab6cfa7ff/skills/hosting-deploy-nodejs-app/SKILL.md"
            },
            {
              "name": "hosting-deploy-static-site",
              "sourceUrl": "https://github.com/hostinger/claude-plugin/blob/569880c60681a7068b3ca8ca84e2fe7ab6cfa7ff/skills/hosting-deploy-static-site/SKILL.md"
            },
            {
              "name": "hosting-deploy-wordpress-plugin",
              "sourceUrl": "https://github.com/hostinger/claude-plugin/blob/569880c60681a7068b3ca8ca84e2fe7ab6cfa7ff/skills/hosting-deploy-wordpress-plugin/SKILL.md"
            },
            {
              "name": "hosting-deploy-wordpress-site",
              "sourceUrl": "https://github.com/hostinger/claude-plugin/blob/569880c60681a7068b3ca8ca84e2fe7ab6cfa7ff/skills/hosting-deploy-wordpress-site/SKILL.md"
            },
            {
              "name": "hosting-deploy-wordpress-theme",
              "sourceUrl": "https://github.com/hostinger/claude-plugin/blob/569880c60681a7068b3ca8ca84e2fe7ab6cfa7ff/skills/hosting-deploy-wordpress-theme/SKILL.md"
            }
          ],
          "mcpServers": [
            {
              "requiresConfiguration": false,
              "name": "hostinger",
              "transport": "http",
              "endpoint": "https://mcp.hostinger.com"
            }
          ],
          "components": ["skills", "mcp"],
          "componentInspection": "repository",
          "inspectionError": null,
          "installation": "requires_adapter",
          "upstream": {
            "source": {
              "source": "url",
              "url": "https://github.com/hostinger/claude-plugin.git",
              "sha": "569880c60681a7068b3ca8ca84e2fe7ab6cfa7ff"
            },
            "policy": null
          }
        },
        {
          "id": "anthropic:huggingface-skills",
          "name": "huggingface-skills",
          "displayName": "huggingface-skills",
          "description": "Core Hugging Face Hub operations through the hf CLI, including skill installation, repo management, jobs, datasets, models, Spaces, and discovery.",
          "longDescription": "Core Hugging Face Hub operations through the hf CLI, including skill installation, repo management, jobs, datasets, models, Spaces, and discovery.",
          "category": "development",
          "keywords": ["huggingface", "machine-learning", "hub", "cli", "skills", "jobs", "llm"],
          "author": {
            "name": "Hugging Face"
          },
          "version": "1.0.27",
          "license": "Apache-2.0",
          "logoUrl": null,
          "darkLogoUrl": null,
          "homepage": "https://github.com/huggingface/skills",
          "sourceUrl": "https://github.com/huggingface/skills/tree/97862b0fcc89c850fdd00c82ede1e62d3c930a6d/",
          "skills": [
            {
              "name": "hf-mcp",
              "sourceUrl": "https://github.com/huggingface/skills/blob/97862b0fcc89c850fdd00c82ede1e62d3c930a6d/hf-mcp/skills/hf-mcp/SKILL.md"
            },
            {
              "name": "hf-cli",
              "sourceUrl": "https://github.com/huggingface/skills/blob/97862b0fcc89c850fdd00c82ede1e62d3c930a6d/skills/hf-cli/SKILL.md"
            },
            {
              "name": "hf-cloud-aws-context-discovery",
              "sourceUrl": "https://github.com/huggingface/skills/blob/97862b0fcc89c850fdd00c82ede1e62d3c930a6d/skills/hf-cloud-aws-context-discovery/SKILL.md"
            },
            {
              "name": "hf-cloud-python-env-setup",
              "sourceUrl": "https://github.com/huggingface/skills/blob/97862b0fcc89c850fdd00c82ede1e62d3c930a6d/skills/hf-cloud-python-env-setup/SKILL.md"
            },
            {
              "name": "hf-cloud-sagemaker-deployment-planner",
              "sourceUrl": "https://github.com/huggingface/skills/blob/97862b0fcc89c850fdd00c82ede1e62d3c930a6d/skills/hf-cloud-sagemaker-deployment-planner/SKILL.md"
            },
            {
              "name": "hf-cloud-sagemaker-iam-preflight",
              "sourceUrl": "https://github.com/huggingface/skills/blob/97862b0fcc89c850fdd00c82ede1e62d3c930a6d/skills/hf-cloud-sagemaker-iam-preflight/SKILL.md"
            },
            {
              "name": "hf-cloud-sagemaker-production-defaults",
              "sourceUrl": "https://github.com/huggingface/skills/blob/97862b0fcc89c850fdd00c82ede1e62d3c930a6d/skills/hf-cloud-sagemaker-production-defaults/SKILL.md"
            },
            {
              "name": "hf-cloud-serving-image-selection",
              "sourceUrl": "https://github.com/huggingface/skills/blob/97862b0fcc89c850fdd00c82ede1e62d3c930a6d/skills/hf-cloud-serving-image-selection/SKILL.md"
            },
            {
              "name": "hf-mem",
              "sourceUrl": "https://github.com/huggingface/skills/blob/97862b0fcc89c850fdd00c82ede1e62d3c930a6d/skills/hf-mem/SKILL.md"
            },
            {
              "name": "huggingface-best",
              "sourceUrl": "https://github.com/huggingface/skills/blob/97862b0fcc89c850fdd00c82ede1e62d3c930a6d/skills/huggingface-best/SKILL.md"
            },
            {
              "name": "huggingface-community-evals",
              "sourceUrl": "https://github.com/huggingface/skills/blob/97862b0fcc89c850fdd00c82ede1e62d3c930a6d/skills/huggingface-community-evals/SKILL.md"
            },
            {
              "name": "huggingface-datasets",
              "sourceUrl": "https://github.com/huggingface/skills/blob/97862b0fcc89c850fdd00c82ede1e62d3c930a6d/skills/huggingface-datasets/SKILL.md"
            },
            {
              "name": "huggingface-gradio",
              "sourceUrl": "https://github.com/huggingface/skills/blob/97862b0fcc89c850fdd00c82ede1e62d3c930a6d/skills/huggingface-gradio/SKILL.md"
            },
            {
              "name": "huggingface-llm-trainer",
              "sourceUrl": "https://github.com/huggingface/skills/blob/97862b0fcc89c850fdd00c82ede1e62d3c930a6d/skills/huggingface-llm-trainer/SKILL.md"
            },
            {
              "name": "huggingface-local-models",
              "sourceUrl": "https://github.com/huggingface/skills/blob/97862b0fcc89c850fdd00c82ede1e62d3c930a6d/skills/huggingface-local-models/SKILL.md"
            },
            {
              "name": "huggingface-lora-space-builder",
              "sourceUrl": "https://github.com/huggingface/skills/blob/97862b0fcc89c850fdd00c82ede1e62d3c930a6d/skills/huggingface-lora-space-builder/SKILL.md"
            },
            {
              "name": "huggingface-paper-publisher",
              "sourceUrl": "https://github.com/huggingface/skills/blob/97862b0fcc89c850fdd00c82ede1e62d3c930a6d/skills/huggingface-paper-publisher/SKILL.md"
            },
            {
              "name": "huggingface-papers",
              "sourceUrl": "https://github.com/huggingface/skills/blob/97862b0fcc89c850fdd00c82ede1e62d3c930a6d/skills/huggingface-papers/SKILL.md"
            },
            {
              "name": "huggingface-spaces",
              "sourceUrl": "https://github.com/huggingface/skills/blob/97862b0fcc89c850fdd00c82ede1e62d3c930a6d/skills/huggingface-spaces/SKILL.md"
            },
            {
              "name": "huggingface-tool-builder",
              "sourceUrl": "https://github.com/huggingface/skills/blob/97862b0fcc89c850fdd00c82ede1e62d3c930a6d/skills/huggingface-tool-builder/SKILL.md"
            },
            {
              "name": "huggingface-trackio",
              "sourceUrl": "https://github.com/huggingface/skills/blob/97862b0fcc89c850fdd00c82ede1e62d3c930a6d/skills/huggingface-trackio/SKILL.md"
            },
            {
              "name": "huggingface-vision-trainer",
              "sourceUrl": "https://github.com/huggingface/skills/blob/97862b0fcc89c850fdd00c82ede1e62d3c930a6d/skills/huggingface-vision-trainer/SKILL.md"
            },
            {
              "name": "huggingface-zerogpu",
              "sourceUrl": "https://github.com/huggingface/skills/blob/97862b0fcc89c850fdd00c82ede1e62d3c930a6d/skills/huggingface-zerogpu/SKILL.md"
            },
            {
              "name": "train-sentence-transformers",
              "sourceUrl": "https://github.com/huggingface/skills/blob/97862b0fcc89c850fdd00c82ede1e62d3c930a6d/skills/train-sentence-transformers/SKILL.md"
            },
            {
              "name": "transformers-js",
              "sourceUrl": "https://github.com/huggingface/skills/blob/97862b0fcc89c850fdd00c82ede1e62d3c930a6d/skills/transformers-js/SKILL.md"
            },
            {
              "name": "trl-training",
              "sourceUrl": "https://github.com/huggingface/skills/blob/97862b0fcc89c850fdd00c82ede1e62d3c930a6d/skills/trl-training/SKILL.md"
            }
          ],
          "mcpServers": [
            {
              "requiresConfiguration": false,
              "name": "huggingface-skills",
              "transport": "http",
              "endpoint": "https://huggingface.co/mcp?login"
            }
          ],
          "components": ["skills", "mcp"],
          "componentInspection": "repository",
          "inspectionError": null,
          "installation": "requires_adapter",
          "upstream": {
            "source": {
              "source": "url",
              "url": "https://github.com/huggingface/skills.git",
              "sha": "97862b0fcc89c850fdd00c82ede1e62d3c930a6d"
            },
            "policy": null
          }
        },
        {
          "id": "anthropic:hunter",
          "name": "hunter",
          "displayName": "hunter",
          "description": "Find and verify professional email addresses, search contacts by domain, enrich company and person data, organize leads and lists, run outreach sequences, and push to your CRM -- directly in Claude.",
          "longDescription": "Find and verify professional email addresses, search contacts by domain, enrich company and person data, organize leads and lists, run outreach sequences, and push to your CRM -- directly in Claude.",
          "category": "productivity",
          "keywords": [
            "hunter",
            "email",
            "leads",
            "b2b",
            "prospecting",
            "sales",
            "enrichment",
            "verification",
            "sequences",
            "outreach",
            "crm"
          ],
          "author": {
            "name": "Hunter.io",
            "url": "https://hunter.io"
          },
          "version": "0.1.0",
          "license": "MIT",
          "logoUrl": null,
          "darkLogoUrl": null,
          "homepage": "https://hunter.io",
          "sourceUrl": "https://github.com/hunter-io/claude-plugin/tree/2a6de2a00f7f459a05c146c6f0712417b8d30db9/",
          "skills": [
            {
              "name": "build-sequences",
              "sourceUrl": "https://github.com/hunter-io/claude-plugin/blob/2a6de2a00f7f459a05c146c6f0712417b8d30db9/skills/build-sequences/SKILL.md"
            },
            {
              "name": "check-usage",
              "sourceUrl": "https://github.com/hunter-io/claude-plugin/blob/2a6de2a00f7f459a05c146c6f0712417b8d30db9/skills/check-usage/SKILL.md"
            },
            {
              "name": "company-enrichment",
              "sourceUrl": "https://github.com/hunter-io/claude-plugin/blob/2a6de2a00f7f459a05c146c6f0712417b8d30db9/skills/company-enrichment/SKILL.md"
            },
            {
              "name": "company-lists",
              "sourceUrl": "https://github.com/hunter-io/claude-plugin/blob/2a6de2a00f7f459a05c146c6f0712417b8d30db9/skills/company-lists/SKILL.md"
            },
            {
              "name": "discover",
              "sourceUrl": "https://github.com/hunter-io/claude-plugin/blob/2a6de2a00f7f459a05c146c6f0712417b8d30db9/skills/discover/SKILL.md"
            },
            {
              "name": "domain-search",
              "sourceUrl": "https://github.com/hunter-io/claude-plugin/blob/2a6de2a00f7f459a05c146c6f0712417b8d30db9/skills/domain-search/SKILL.md"
            },
            {
              "name": "email-finder",
              "sourceUrl": "https://github.com/hunter-io/claude-plugin/blob/2a6de2a00f7f459a05c146c6f0712417b8d30db9/skills/email-finder/SKILL.md"
            },
            {
              "name": "email-verifier",
              "sourceUrl": "https://github.com/hunter-io/claude-plugin/blob/2a6de2a00f7f459a05c146c6f0712417b8d30db9/skills/email-verifier/SKILL.md"
            },
            {
              "name": "lead-lists",
              "sourceUrl": "https://github.com/hunter-io/claude-plugin/blob/2a6de2a00f7f459a05c146c6f0712417b8d30db9/skills/lead-lists/SKILL.md"
            },
            {
              "name": "manage-leads",
              "sourceUrl": "https://github.com/hunter-io/claude-plugin/blob/2a6de2a00f7f459a05c146c6f0712417b8d30db9/skills/manage-leads/SKILL.md"
            },
            {
              "name": "person-enrichment",
              "sourceUrl": "https://github.com/hunter-io/claude-plugin/blob/2a6de2a00f7f459a05c146c6f0712417b8d30db9/skills/person-enrichment/SKILL.md"
            },
            {
              "name": "prospecting",
              "sourceUrl": "https://github.com/hunter-io/claude-plugin/blob/2a6de2a00f7f459a05c146c6f0712417b8d30db9/skills/prospecting/SKILL.md"
            },
            {
              "name": "push-to-crm",
              "sourceUrl": "https://github.com/hunter-io/claude-plugin/blob/2a6de2a00f7f459a05c146c6f0712417b8d30db9/skills/push-to-crm/SKILL.md"
            }
          ],
          "mcpServers": [
            {
              "requiresConfiguration": false,
              "name": "hunter",
              "transport": "http",
              "endpoint": "https://mcp.hunter.io/mcp"
            }
          ],
          "components": ["skills", "mcp"],
          "componentInspection": "repository",
          "inspectionError": null,
          "installation": "requires_adapter",
          "upstream": {
            "source": {
              "source": "url",
              "url": "https://github.com/hunter-io/claude-plugin.git",
              "sha": "2a6de2a00f7f459a05c146c6f0712417b8d30db9"
            },
            "policy": null
          }
        },
        {
          "id": "anthropic:hyperframes",
          "name": "hyperframes",
          "displayName": "hyperframes",
          "description": "HyperFrames by HeyGen. Write HTML, render video. Compositions, GSAP and runtime adapter animations, captions, voiceovers, audio-reactive visuals, and website-to-video capture for HyperFrames.",
          "longDescription": "HyperFrames by HeyGen. Write HTML, render video. Compositions, GSAP and runtime adapter animations, captions, voiceovers, audio-reactive visuals, and website-to-video capture for HyperFrames.",
          "category": "design",
          "keywords": [],
          "author": {
            "name": "HeyGen"
          },
          "version": null,
          "license": null,
          "logoUrl": null,
          "darkLogoUrl": null,
          "homepage": "https://hyperframes.heygen.com",
          "sourceUrl": "https://github.com/heygen-com/hyperframes.git",
          "skills": null,
          "mcpServers": null,
          "components": null,
          "componentInspection": "not_inspected",
          "inspectionError": "Archive exceeds 32 MiB",
          "installation": "requires_adapter",
          "upstream": {
            "source": {
              "source": "url",
              "url": "https://github.com/heygen-com/hyperframes.git",
              "sha": "ae3d80c30f89f8811e27189838f8a1f34572d062"
            },
            "policy": null
          }
        },
        {
          "id": "anthropic:idmp-plugin",
          "name": "idmp-plugin",
          "displayName": "idmp-plugin",
          "description": "TDengine IDMP plugin with packaged skills for discovery, schema inspection, and safe operational workflows.",
          "longDescription": "TDengine IDMP plugin with packaged skills for discovery, schema inspection, and safe operational workflows.",
          "category": "development",
          "keywords": [
            "TDengine",
            "IDMP",
            "database",
            "monitoring",
            "alert",
            "dashboard",
            "industrial-data",
            "industrial-manufacturing",
            "data-management",
            "iot",
            "time-series",
            "asset-modeling",
            "data-ingestion"
          ],
          "author": {
            "name": "TaosData",
            "email": "it@taosdata.com"
          },
          "version": "0.1.0",
          "license": null,
          "logoUrl": null,
          "darkLogoUrl": null,
          "homepage": "https://github.com/taosdata/agent-skills",
          "sourceUrl": "https://github.com/taosdata/agent-skills/tree/0b67242e2cd114ad9631c39aa20969fdd9780a11/plugins/idmp-plugin",
          "skills": [
            {
              "name": "idmp-ai",
              "sourceUrl": "https://github.com/taosdata/agent-skills/blob/0b67242e2cd114ad9631c39aa20969fdd9780a11/plugins/idmp-plugin/skills/idmp-ai/SKILL.md"
            },
            {
              "name": "idmp-analysis",
              "sourceUrl": "https://github.com/taosdata/agent-skills/blob/0b67242e2cd114ad9631c39aa20969fdd9780a11/plugins/idmp-plugin/skills/idmp-analysis/SKILL.md"
            },
            {
              "name": "idmp-annotation",
              "sourceUrl": "https://github.com/taosdata/agent-skills/blob/0b67242e2cd114ad9631c39aa20969fdd9780a11/plugins/idmp-plugin/skills/idmp-annotation/SKILL.md"
            },
            {
              "name": "idmp-attribute",
              "sourceUrl": "https://github.com/taosdata/agent-skills/blob/0b67242e2cd114ad9631c39aa20969fdd9780a11/plugins/idmp-plugin/skills/idmp-attribute/SKILL.md"
            },
            {
              "name": "idmp-dashboard",
              "sourceUrl": "https://github.com/taosdata/agent-skills/blob/0b67242e2cd114ad9631c39aa20969fdd9780a11/plugins/idmp-plugin/skills/idmp-dashboard/SKILL.md"
            },
            {
              "name": "idmp-data",
              "sourceUrl": "https://github.com/taosdata/agent-skills/blob/0b67242e2cd114ad9631c39aa20969fdd9780a11/plugins/idmp-plugin/skills/idmp-data/SKILL.md"
            },
            {
              "name": "idmp-datasource",
              "sourceUrl": "https://github.com/taosdata/agent-skills/blob/0b67242e2cd114ad9631c39aa20969fdd9780a11/plugins/idmp-plugin/skills/idmp-datasource/SKILL.md"
            },
            {
              "name": "idmp-element",
              "sourceUrl": "https://github.com/taosdata/agent-skills/blob/0b67242e2cd114ad9631c39aa20969fdd9780a11/plugins/idmp-plugin/skills/idmp-element/SKILL.md"
            },
            {
              "name": "idmp-event",
              "sourceUrl": "https://github.com/taosdata/agent-skills/blob/0b67242e2cd114ad9631c39aa20969fdd9780a11/plugins/idmp-plugin/skills/idmp-event/SKILL.md"
            },
            {
              "name": "idmp-notification",
              "sourceUrl": "https://github.com/taosdata/agent-skills/blob/0b67242e2cd114ad9631c39aa20969fdd9780a11/plugins/idmp-plugin/skills/idmp-notification/SKILL.md"
            },
            {
              "name": "idmp-openapi-explorer",
              "sourceUrl": "https://github.com/taosdata/agent-skills/blob/0b67242e2cd114ad9631c39aa20969fdd9780a11/plugins/idmp-plugin/skills/idmp-openapi-explorer/SKILL.md"
            },
            {
              "name": "idmp-panel",
              "sourceUrl": "https://github.com/taosdata/agent-skills/blob/0b67242e2cd114ad9631c39aa20969fdd9780a11/plugins/idmp-plugin/skills/idmp-panel/SKILL.md"
            },
            {
              "name": "idmp-shared",
              "sourceUrl": "https://github.com/taosdata/agent-skills/blob/0b67242e2cd114ad9631c39aa20969fdd9780a11/plugins/idmp-plugin/skills/idmp-shared/SKILL.md"
            },
            {
              "name": "idmp-template",
              "sourceUrl": "https://github.com/taosdata/agent-skills/blob/0b67242e2cd114ad9631c39aa20969fdd9780a11/plugins/idmp-plugin/skills/idmp-template/SKILL.md"
            },
            {
              "name": "idmp-uom",
              "sourceUrl": "https://github.com/taosdata/agent-skills/blob/0b67242e2cd114ad9631c39aa20969fdd9780a11/plugins/idmp-plugin/skills/idmp-uom/SKILL.md"
            },
            {
              "name": "idmp-user-access",
              "sourceUrl": "https://github.com/taosdata/agent-skills/blob/0b67242e2cd114ad9631c39aa20969fdd9780a11/plugins/idmp-plugin/skills/idmp-user-access/SKILL.md"
            },
            {
              "name": "idmp-workflow-alert-create",
              "sourceUrl": "https://github.com/taosdata/agent-skills/blob/0b67242e2cd114ad9631c39aa20969fdd9780a11/plugins/idmp-plugin/skills/idmp-workflow-alert-create/SKILL.md"
            },
            {
              "name": "idmp-workflow-alert-debug",
              "sourceUrl": "https://github.com/taosdata/agent-skills/blob/0b67242e2cd114ad9631c39aa20969fdd9780a11/plugins/idmp-plugin/skills/idmp-workflow-alert-debug/SKILL.md"
            },
            {
              "name": "idmp-workflow-analysis-create",
              "sourceUrl": "https://github.com/taosdata/agent-skills/blob/0b67242e2cd114ad9631c39aa20969fdd9780a11/plugins/idmp-plugin/skills/idmp-workflow-analysis-create/SKILL.md"
            },
            {
              "name": "idmp-workflow-asset-bootstrap",
              "sourceUrl": "https://github.com/taosdata/agent-skills/blob/0b67242e2cd114ad9631c39aa20969fdd9780a11/plugins/idmp-plugin/skills/idmp-workflow-asset-bootstrap/SKILL.md"
            },
            {
              "name": "idmp-workflow-data-import-export",
              "sourceUrl": "https://github.com/taosdata/agent-skills/blob/0b67242e2cd114ad9631c39aa20969fdd9780a11/plugins/idmp-plugin/skills/idmp-workflow-data-import-export/SKILL.md"
            },
            {
              "name": "idmp-workflow-datasource-diagnose",
              "sourceUrl": "https://github.com/taosdata/agent-skills/blob/0b67242e2cd114ad9631c39aa20969fdd9780a11/plugins/idmp-plugin/skills/idmp-workflow-datasource-diagnose/SKILL.md"
            },
            {
              "name": "idmp-workflow-panel-build",
              "sourceUrl": "https://github.com/taosdata/agent-skills/blob/0b67242e2cd114ad9631c39aa20969fdd9780a11/plugins/idmp-plugin/skills/idmp-workflow-panel-build/SKILL.md"
            }
          ],
          "mcpServers": [],
          "components": ["skills"],
          "componentInspection": "repository",
          "inspectionError": null,
          "installation": "requires_adapter",
          "upstream": {
            "source": {
              "source": "git-subdir",
              "url": "https://github.com/taosdata/agent-skills.git",
              "path": "plugins/idmp-plugin",
              "ref": "main",
              "sha": "0b67242e2cd114ad9631c39aa20969fdd9780a11"
            },
            "policy": null
          }
        },
        {
          "id": "anthropic:imessage",
          "name": "imessage",
          "displayName": "imessage",
          "description": "iMessage channel for Claude Code — reads chat.db directly, sends via AppleScript. Built-in access control; manage pairing, allowlists, and policy via /imessage:access.",
          "longDescription": "iMessage channel for Claude Code — reads chat.db directly, sends via AppleScript. Built-in access control; manage pairing, allowlists, and policy via /imessage:access.",
          "category": "productivity",
          "keywords": ["imessage", "messaging", "channel", "mcp"],
          "author": null,
          "version": "0.1.0",
          "license": null,
          "logoUrl": null,
          "darkLogoUrl": null,
          "homepage": null,
          "sourceUrl": "https://github.com/anthropics/claude-plugins-official/tree/3b600518a637492d37c9877aeb49c2a55d939c04/external_plugins/imessage",
          "skills": [
            {
              "name": "access",
              "sourceUrl": "https://github.com/anthropics/claude-plugins-official/blob/3b600518a637492d37c9877aeb49c2a55d939c04/external_plugins/imessage/skills/access/SKILL.md"
            },
            {
              "name": "configure",
              "sourceUrl": "https://github.com/anthropics/claude-plugins-official/blob/3b600518a637492d37c9877aeb49c2a55d939c04/external_plugins/imessage/skills/configure/SKILL.md"
            }
          ],
          "mcpServers": [
            {
              "requiresConfiguration": false,
              "name": "imessage",
              "transport": "stdio",
              "endpoint": null
            }
          ],
          "components": ["skills", "mcp"],
          "componentInspection": "repository",
          "inspectionError": null,
          "installation": "requires_adapter",
          "upstream": {
            "source": "./external_plugins/imessage",
            "policy": null
          }
        },
        {
          "id": "anthropic:intercom",
          "name": "intercom",
          "displayName": "intercom",
          "description": "Intercom integration for Claude Code. Search conversations, analyze customer support patterns, look up contacts and companies, and install the Intercom Messenger. Connect your Intercom workspace to get real-time insights from customer data.",
          "longDescription": "Intercom integration for Claude Code. Search conversations, analyze customer support patterns, look up contacts and companies, and install the Intercom Messenger. Connect your Intercom workspace to get real-time insights from customer data.",
          "category": "productivity",
          "keywords": [
            "intercom",
            "customer-support",
            "conversations",
            "contacts",
            "messenger",
            "crm",
            "api"
          ],
          "author": {
            "name": "Intercom",
            "url": "https://intercom.com"
          },
          "version": "0.1.0",
          "license": "MIT",
          "logoUrl": null,
          "darkLogoUrl": null,
          "homepage": "https://developers.intercom.com",
          "sourceUrl": "https://github.com/intercom/claude-plugin-external/tree/62773a7d4b8aac31545d6888fe6479be3bc53804/",
          "skills": [
            {
              "name": "customer-360",
              "sourceUrl": "https://github.com/intercom/claude-plugin-external/blob/62773a7d4b8aac31545d6888fe6479be3bc53804/skills/customer-360/SKILL.md"
            },
            {
              "name": "install-cli",
              "sourceUrl": "https://github.com/intercom/claude-plugin-external/blob/62773a7d4b8aac31545d6888fe6479be3bc53804/skills/install-cli/SKILL.md"
            },
            {
              "name": "install-messenger",
              "sourceUrl": "https://github.com/intercom/claude-plugin-external/blob/62773a7d4b8aac31545d6888fe6479be3bc53804/skills/install-messenger/SKILL.md"
            },
            {
              "name": "intercom-analysis",
              "sourceUrl": "https://github.com/intercom/claude-plugin-external/blob/62773a7d4b8aac31545d6888fe6479be3bc53804/skills/intercom-analysis/SKILL.md"
            }
          ],
          "mcpServers": [
            {
              "requiresConfiguration": false,
              "name": "intercom",
              "transport": "http",
              "endpoint": "https://mcp.intercom.com/mcp"
            }
          ],
          "components": ["skills", "mcp"],
          "componentInspection": "repository",
          "inspectionError": null,
          "installation": "requires_adapter",
          "upstream": {
            "source": {
              "source": "url",
              "url": "https://github.com/intercom/claude-plugin-external.git",
              "sha": "62773a7d4b8aac31545d6888fe6479be3bc53804"
            },
            "policy": null
          }
        },
        {
          "id": "anthropic:jdtls-lsp",
          "name": "jdtls-lsp",
          "displayName": "jdtls-lsp",
          "description": "Java language server (Eclipse JDT.LS) for code intelligence",
          "longDescription": "Java language server (Eclipse JDT.LS) for code intelligence",
          "category": "development",
          "keywords": [],
          "author": {
            "name": "Anthropic",
            "email": "support@anthropic.com"
          },
          "version": "1.0.0",
          "license": null,
          "logoUrl": null,
          "darkLogoUrl": null,
          "homepage": null,
          "sourceUrl": "https://github.com/anthropics/claude-plugins-official/tree/3b600518a637492d37c9877aeb49c2a55d939c04/plugins/jdtls-lsp",
          "skills": [],
          "mcpServers": [],
          "components": [],
          "componentInspection": "repository",
          "inspectionError": null,
          "installation": "requires_adapter",
          "upstream": {
            "source": "./plugins/jdtls-lsp",
            "policy": null
          }
        },
        {
          "id": "anthropic:jfrog",
          "name": "jfrog",
          "displayName": "jfrog",
          "description": "Official JFrog plugin. Connect Claude Code to JFrog to manage, secure, and govern your software supply chain. Give agents the context to build secure, compliant software.",
          "longDescription": "Official JFrog plugin. Connect Claude Code to JFrog to manage, secure, and govern your software supply chain. Give agents the context to build secure, compliant software.",
          "category": "security",
          "keywords": [
            "jfrog",
            "artifactory",
            "xray",
            "security",
            "devops",
            "supply-chain",
            "artifacts",
            "curation",
            "agent-guard",
            "package-resolution",
            "ai-catalog"
          ],
          "author": {
            "name": "JFrog Ltd.",
            "email": "devrel@jfrog.com",
            "url": "https://jfrog.com"
          },
          "version": "0.3.5",
          "license": "Apache-2.0",
          "logoUrl": null,
          "darkLogoUrl": null,
          "homepage": "https://jfrog.com",
          "sourceUrl": "https://github.com/jfrog/claude-plugin/tree/d5b04a75c479452cdc3797259e5ae539a5c0391f/",
          "skills": [
            {
              "name": "jfrog-ai-catalog",
              "sourceUrl": "https://github.com/jfrog/claude-plugin/blob/d5b04a75c479452cdc3797259e5ae539a5c0391f/skills/jfrog-ai-catalog/SKILL.md"
            },
            {
              "name": "jfrog-init",
              "sourceUrl": "https://github.com/jfrog/claude-plugin/blob/d5b04a75c479452cdc3797259e5ae539a5c0391f/skills/jfrog-init/SKILL.md"
            },
            {
              "name": "jfrog-mcp-management",
              "sourceUrl": "https://github.com/jfrog/claude-plugin/blob/d5b04a75c479452cdc3797259e5ae539a5c0391f/skills/jfrog-mcp-management/SKILL.md"
            },
            {
              "name": "jfrog-package-curation",
              "sourceUrl": "https://github.com/jfrog/claude-plugin/blob/d5b04a75c479452cdc3797259e5ae539a5c0391f/skills/jfrog-package-curation/SKILL.md"
            },
            {
              "name": "jfrog-reference-architecture",
              "sourceUrl": "https://github.com/jfrog/claude-plugin/blob/d5b04a75c479452cdc3797259e5ae539a5c0391f/skills/jfrog-reference-architecture/SKILL.md"
            },
            {
              "name": "jfrog-setup-package-managers",
              "sourceUrl": "https://github.com/jfrog/claude-plugin/blob/d5b04a75c479452cdc3797259e5ae539a5c0391f/skills/jfrog-setup-package-managers/SKILL.md"
            },
            {
              "name": "jfrog",
              "sourceUrl": "https://github.com/jfrog/claude-plugin/blob/d5b04a75c479452cdc3797259e5ae539a5c0391f/skills/jfrog/SKILL.md"
            }
          ],
          "mcpServers": [
            {
              "requiresConfiguration": false,
              "name": "jfrog",
              "transport": "http",
              "endpoint": "${JFROG_URL}/mcp"
            }
          ],
          "components": ["skills", "mcp", "hooks"],
          "componentInspection": "repository",
          "inspectionError": null,
          "installation": "requires_adapter",
          "upstream": {
            "source": {
              "source": "url",
              "url": "https://github.com/jfrog/claude-plugin.git",
              "sha": "d5b04a75c479452cdc3797259e5ae539a5c0391f"
            },
            "policy": null
          }
        },
        {
          "id": "anthropic:knowledge-catalog",
          "name": "knowledge-catalog",
          "displayName": "knowledge-catalog",
          "description": "Connect to Knowledge Catalog to discover, manage, monitor, and govern data and AI artifacts across your data platform",
          "longDescription": "Connect to Knowledge Catalog to discover, manage, monitor, and govern data and AI artifacts across your data platform",
          "category": "database",
          "keywords": [],
          "author": {
            "name": "Google LLC",
            "email": "data-cloud-ai-integrations@google.com"
          },
          "version": "0.5.3",
          "license": "Apache-2.0",
          "logoUrl": null,
          "darkLogoUrl": null,
          "homepage": "https://cloud.google.com/dataplex",
          "sourceUrl": "https://github.com/gemini-cli-extensions/knowledge-catalog/tree/930d73cfbb8e0637d79cb335ff0b8d80af383bd8/",
          "skills": [],
          "mcpServers": [
            {
              "requiresConfiguration": false,
              "name": "dataplex",
              "transport": "stdio",
              "endpoint": null
            }
          ],
          "components": ["mcp"],
          "componentInspection": "repository",
          "inspectionError": null,
          "installation": "requires_adapter",
          "upstream": {
            "source": {
              "source": "url",
              "url": "https://github.com/gemini-cli-extensions/knowledge-catalog.git",
              "sha": "930d73cfbb8e0637d79cb335ff0b8d80af383bd8"
            },
            "policy": null
          }
        },
        {
          "id": "anthropic:kotlin-lsp",
          "name": "kotlin-lsp",
          "displayName": "kotlin-lsp",
          "description": "Kotlin language server for code intelligence",
          "longDescription": "Kotlin language server for code intelligence",
          "category": "development",
          "keywords": [],
          "author": {
            "name": "Anthropic",
            "email": "support@anthropic.com"
          },
          "version": "1.0.0",
          "license": null,
          "logoUrl": null,
          "darkLogoUrl": null,
          "homepage": null,
          "sourceUrl": "https://github.com/anthropics/claude-plugins-official/tree/3b600518a637492d37c9877aeb49c2a55d939c04/plugins/kotlin-lsp",
          "skills": [],
          "mcpServers": [],
          "components": [],
          "componentInspection": "repository",
          "inspectionError": null,
          "installation": "requires_adapter",
          "upstream": {
            "source": "./plugins/kotlin-lsp",
            "policy": null
          }
        },
        {
          "id": "anthropic:langfuse-observability",
          "name": "langfuse-observability",
          "displayName": "langfuse-observability",
          "description": "The Langfuse x Claude Code Observability Plugin",
          "longDescription": "The Langfuse x Claude Code Observability Plugin",
          "category": "monitoring",
          "keywords": [],
          "author": {
            "name": "Langfuse"
          },
          "version": "1.1.0",
          "license": "MIT",
          "logoUrl": null,
          "darkLogoUrl": null,
          "homepage": "https://langfuse.com/integrations/other/claude-code",
          "sourceUrl": "https://github.com/langfuse/claude-observability-plugin/tree/ece30fee77831df36503b9bbb6d11b78f64d698f/",
          "skills": [],
          "mcpServers": [],
          "components": ["hooks"],
          "componentInspection": "repository",
          "inspectionError": null,
          "installation": "requires_adapter",
          "upstream": {
            "source": {
              "source": "url",
              "url": "https://github.com/langfuse/claude-observability-plugin.git",
              "sha": "ece30fee77831df36503b9bbb6d11b78f64d698f"
            },
            "policy": null
          }
        },
        {
          "id": "anthropic:laravel-boost",
          "name": "laravel-boost",
          "displayName": "laravel-boost",
          "description": "Laravel development toolkit MCP server. Provides intelligent assistance for Laravel applications including Artisan commands, Eloquent queries, routing, migrations, and framework-specific code generation.",
          "longDescription": "Laravel development toolkit MCP server. Provides intelligent assistance for Laravel applications including Artisan commands, Eloquent queries, routing, migrations, and framework-specific code generation.",
          "category": "development",
          "keywords": [],
          "author": {
            "name": "Laravel"
          },
          "version": null,
          "license": null,
          "logoUrl": null,
          "darkLogoUrl": null,
          "homepage": "https://github.com/anthropics/claude-plugins-public/tree/main/external_plugins/laravel-boost",
          "sourceUrl": "https://github.com/anthropics/claude-plugins-official/tree/3b600518a637492d37c9877aeb49c2a55d939c04/external_plugins/laravel-boost",
          "skills": [],
          "mcpServers": [
            {
              "requiresConfiguration": false,
              "name": "laravel-boost",
              "transport": "stdio",
              "endpoint": null
            }
          ],
          "components": ["mcp"],
          "componentInspection": "repository",
          "inspectionError": null,
          "installation": "requires_adapter",
          "upstream": {
            "source": "./external_plugins/laravel-boost",
            "policy": null
          }
        },
        {
          "id": "anthropic:learn-with-coursera",
          "name": "learn-with-coursera",
          "displayName": "learn-with-coursera",
          "description": "Turn any learning intent into a personalized Coursera experience. Asks three quick questions (topic, familiarity, preferred format), searches Coursera's catalog, and delivers the right next step — a course, hands-on project, short video, or live roleplay — then maps a path forward. Requires the Coursera connector for catalog tools.",
          "longDescription": "Turn any learning intent into a personalized Coursera experience. Asks three quick questions (topic, familiarity, preferred format), searches Coursera's catalog, and delivers the right next step — a course, hands-on project, short video, or live roleplay — then maps a path forward. Requires the Coursera connector for catalog tools.",
          "category": "learning",
          "keywords": [],
          "author": {
            "name": "Coursera"
          },
          "version": null,
          "license": null,
          "logoUrl": null,
          "darkLogoUrl": null,
          "homepage": "https://github.com/coursera/skills",
          "sourceUrl": "https://github.com/coursera/skills/tree/ac28fd6ebf8584e3ee196159bd6d4514fa07de0f/skills",
          "skills": [
            {
              "name": "learn-with-coursera",
              "sourceUrl": "https://github.com/coursera/skills/blob/ac28fd6ebf8584e3ee196159bd6d4514fa07de0f/skills/learn-with-coursera/SKILL.md"
            }
          ],
          "mcpServers": [],
          "components": ["skills"],
          "componentInspection": "repository",
          "inspectionError": null,
          "installation": "requires_adapter",
          "upstream": {
            "source": {
              "source": "git-subdir",
              "url": "https://github.com/coursera/skills.git",
              "path": "skills",
              "ref": "main",
              "sha": "ac28fd6ebf8584e3ee196159bd6d4514fa07de0f"
            },
            "policy": null
          }
        },
        {
          "id": "anthropic:learning-output-style",
          "name": "learning-output-style",
          "displayName": "learning-output-style",
          "description": "Interactive learning mode that requests meaningful code contributions at decision points (mimics the unshipped Learning output style)",
          "longDescription": "Interactive learning mode that requests meaningful code contributions at decision points (mimics the unshipped Learning output style)",
          "category": "learning",
          "keywords": [],
          "author": {
            "name": "Anthropic",
            "email": "support@anthropic.com"
          },
          "version": "1.0.0",
          "license": null,
          "logoUrl": null,
          "darkLogoUrl": null,
          "homepage": "https://github.com/anthropics/claude-plugins-public/tree/main/plugins/learning-output-style",
          "sourceUrl": "https://github.com/anthropics/claude-plugins-official/tree/3b600518a637492d37c9877aeb49c2a55d939c04/plugins/learning-output-style",
          "skills": [],
          "mcpServers": [],
          "components": ["hooks"],
          "componentInspection": "repository",
          "inspectionError": null,
          "installation": "requires_adapter",
          "upstream": {
            "source": "./plugins/learning-output-style",
            "policy": null
          }
        },
        {
          "id": "anthropic:legalzoom",
          "name": "legalzoom",
          "displayName": "legalzoom",
          "description": "LegalZoom Plugin - AI-powered business legal assistance with contract review and attorney consultation",
          "longDescription": "LegalZoom Plugin - AI-powered business legal assistance with contract review and attorney consultation",
          "category": "productivity",
          "keywords": [],
          "author": {
            "name": "LegalZoom",
            "email": "engineering@legalzoom.com"
          },
          "version": "1.0.0",
          "license": "PROPRIETARY",
          "logoUrl": null,
          "darkLogoUrl": null,
          "homepage": "https://github.com/legalzoom/claude-plugins",
          "sourceUrl": "https://github.com/legalzoom/claude-plugins/tree/f9fd8a0ca6e1421bc1aacb113a109663a7a6f6d8/plugins/legalzoom",
          "skills": [
            {
              "name": "attorney-assist",
              "sourceUrl": "https://github.com/legalzoom/claude-plugins/blob/f9fd8a0ca6e1421bc1aacb113a109663a7a6f6d8/plugins/legalzoom/skills/attorney-assist/SKILL.md"
            }
          ],
          "mcpServers": [
            {
              "requiresConfiguration": false,
              "name": "legalzoom",
              "transport": "http",
              "endpoint": "https://www.legalzoom.com/mcp/claude/v1"
            }
          ],
          "components": ["skills", "mcp", "commands"],
          "componentInspection": "repository",
          "inspectionError": null,
          "installation": "requires_adapter",
          "upstream": {
            "source": {
              "source": "git-subdir",
              "url": "https://github.com/legalzoom/claude-plugins.git",
              "path": "plugins/legalzoom",
              "ref": "main",
              "sha": "f9fd8a0ca6e1421bc1aacb113a109663a7a6f6d8"
            },
            "policy": null
          }
        },
        {
          "id": "anthropic:linear",
          "name": "linear",
          "displayName": "linear",
          "description": "Linear issue tracking integration. Create issues, manage projects, update statuses, search across workspaces, and streamline your software development workflow with Linear's modern issue tracker.",
          "longDescription": "Linear issue tracking integration. Create issues, manage projects, update statuses, search across workspaces, and streamline your software development workflow with Linear's modern issue tracker.",
          "category": "productivity",
          "keywords": [],
          "author": {
            "name": "Linear"
          },
          "version": null,
          "license": null,
          "logoUrl": null,
          "darkLogoUrl": null,
          "homepage": "https://github.com/anthropics/claude-plugins-public/tree/main/external_plugins/linear",
          "sourceUrl": "https://github.com/anthropics/claude-plugins-official/tree/3b600518a637492d37c9877aeb49c2a55d939c04/external_plugins/linear",
          "skills": [],
          "mcpServers": [
            {
              "requiresConfiguration": false,
              "name": "linear",
              "transport": "http",
              "endpoint": "https://mcp.linear.app/mcp"
            }
          ],
          "components": ["mcp"],
          "componentInspection": "repository",
          "inspectionError": null,
          "installation": "requires_adapter",
          "upstream": {
            "source": "./external_plugins/linear",
            "policy": null
          }
        },
        {
          "id": "anthropic:liquid-lsp",
          "name": "liquid-lsp",
          "displayName": "liquid-lsp",
          "description": "LSP integration for Shopify Liquid templates via the Shopify CLI theme language server",
          "longDescription": "LSP integration for Shopify Liquid templates via the Shopify CLI theme language server",
          "category": "development",
          "keywords": ["lsp", "liquid", "shopify", "theme"],
          "author": {
            "name": "James Meng"
          },
          "version": "1.0.0",
          "license": "MIT",
          "logoUrl": null,
          "darkLogoUrl": null,
          "homepage": "https://github.com/Shopify/liquid-skills/tree/main/plugins/liquid-lsp",
          "sourceUrl": "https://github.com/Shopify/liquid-skills/tree/ae3e4cc3f454923e388bbd841fd931f0c7bf5be4/plugins/liquid-lsp",
          "skills": [],
          "mcpServers": [],
          "components": ["lsp"],
          "componentInspection": "repository",
          "inspectionError": null,
          "installation": "requires_adapter",
          "upstream": {
            "source": {
              "source": "git-subdir",
              "url": "https://github.com/Shopify/liquid-skills.git",
              "path": "plugins/liquid-lsp",
              "ref": "main",
              "sha": "ae3e4cc3f454923e388bbd841fd931f0c7bf5be4"
            },
            "policy": null
          }
        },
        {
          "id": "anthropic:liquid-skills",
          "name": "liquid-skills",
          "displayName": "liquid-skills",
          "description": "Liquid language fundamentals, CSS/JS/HTML coding standards, and WCAG accessibility patterns for Shopify themes",
          "longDescription": "Liquid language fundamentals, CSS/JS/HTML coding standards, and WCAG accessibility patterns for Shopify themes",
          "category": "development",
          "keywords": ["liquid", "shopify", "theme", "accessibility", "css", "javascript"],
          "author": {
            "name": "Shopify"
          },
          "version": "1.0.0",
          "license": "MIT",
          "logoUrl": null,
          "darkLogoUrl": null,
          "homepage": "https://github.com/Shopify/liquid-skills/tree/main/plugins/liquid-skills",
          "sourceUrl": "https://github.com/Shopify/liquid-skills/tree/ae3e4cc3f454923e388bbd841fd931f0c7bf5be4/plugins/liquid-skills",
          "skills": [
            {
              "name": "liquid-theme-a11y",
              "sourceUrl": "https://github.com/Shopify/liquid-skills/blob/ae3e4cc3f454923e388bbd841fd931f0c7bf5be4/plugins/liquid-skills/skills/liquid-theme-a11y/SKILL.md"
            },
            {
              "name": "liquid-theme-standards",
              "sourceUrl": "https://github.com/Shopify/liquid-skills/blob/ae3e4cc3f454923e388bbd841fd931f0c7bf5be4/plugins/liquid-skills/skills/liquid-theme-standards/SKILL.md"
            },
            {
              "name": "shopify-liquid-themes",
              "sourceUrl": "https://github.com/Shopify/liquid-skills/blob/ae3e4cc3f454923e388bbd841fd931f0c7bf5be4/plugins/liquid-skills/skills/shopify-liquid-themes/SKILL.md"
            }
          ],
          "mcpServers": [],
          "components": ["skills"],
          "componentInspection": "repository",
          "inspectionError": null,
          "installation": "requires_adapter",
          "upstream": {
            "source": {
              "source": "git-subdir",
              "url": "https://github.com/Shopify/liquid-skills.git",
              "path": "plugins/liquid-skills",
              "ref": "main",
              "sha": "ae3e4cc3f454923e388bbd841fd931f0c7bf5be4"
            },
            "policy": null
          }
        },
        {
          "id": "anthropic:logfire",
          "name": "logfire",
          "displayName": "logfire",
          "description": "Add Logfire observability to Python applications with auto-instrumentation for FastAPI, httpx, asyncpg, SQLAlchemy, and more",
          "longDescription": "Add Logfire observability to Python applications with auto-instrumentation for FastAPI, httpx, asyncpg, SQLAlchemy, and more",
          "category": "monitoring",
          "keywords": [],
          "author": {
            "name": "Pydantic",
            "email": "support@pydantic.dev"
          },
          "version": "0.1.4",
          "license": null,
          "logoUrl": null,
          "darkLogoUrl": null,
          "homepage": "https://github.com/pydantic/skills/tree/main/plugins/logfire",
          "sourceUrl": "https://github.com/pydantic/skills/tree/9e9390ee24d44b32cf5379c58acaebd7563f5f86/plugins/logfire",
          "skills": [
            {
              "name": "logfire-evals",
              "sourceUrl": "https://github.com/pydantic/skills/blob/9e9390ee24d44b32cf5379c58acaebd7563f5f86/plugins/logfire/skills/logfire-evals/SKILL.md"
            },
            {
              "name": "logfire-infrastructure",
              "sourceUrl": "https://github.com/pydantic/skills/blob/9e9390ee24d44b32cf5379c58acaebd7563f5f86/plugins/logfire/skills/logfire-infrastructure/SKILL.md"
            },
            {
              "name": "logfire-instrumentation",
              "sourceUrl": "https://github.com/pydantic/skills/blob/9e9390ee24d44b32cf5379c58acaebd7563f5f86/plugins/logfire/skills/logfire-instrumentation/SKILL.md"
            },
            {
              "name": "logfire-query",
              "sourceUrl": "https://github.com/pydantic/skills/blob/9e9390ee24d44b32cf5379c58acaebd7563f5f86/plugins/logfire/skills/logfire-query/SKILL.md"
            },
            {
              "name": "logfire-setup",
              "sourceUrl": "https://github.com/pydantic/skills/blob/9e9390ee24d44b32cf5379c58acaebd7563f5f86/plugins/logfire/skills/logfire-setup/SKILL.md"
            },
            {
              "name": "logfire-ui",
              "sourceUrl": "https://github.com/pydantic/skills/blob/9e9390ee24d44b32cf5379c58acaebd7563f5f86/plugins/logfire/skills/logfire-ui/SKILL.md"
            }
          ],
          "mcpServers": [
            {
              "requiresConfiguration": false,
              "name": "logfire",
              "transport": "http",
              "endpoint": "${LOGFIRE_MCP_URL:-https://logfire-us.pydantic.dev/mcp}"
            }
          ],
          "components": ["skills", "mcp", "commands"],
          "componentInspection": "repository",
          "inspectionError": null,
          "installation": "requires_adapter",
          "upstream": {
            "source": {
              "source": "git-subdir",
              "url": "https://github.com/pydantic/skills.git",
              "path": "plugins/logfire",
              "ref": "main",
              "sha": "9e9390ee24d44b32cf5379c58acaebd7563f5f86"
            },
            "policy": null
          }
        },
        {
          "id": "anthropic:logrocket",
          "name": "logrocket",
          "displayName": "logrocket",
          "description": "Connect Claude Code to LogRocket to query session replays, metrics, issues, and user behavior using natural language.",
          "longDescription": "Connect Claude Code to LogRocket to query session replays, metrics, issues, and user behavior using natural language.",
          "category": "monitoring",
          "keywords": ["logrocket", "session-replay", "analytics", "mcp", "galileo"],
          "author": {
            "name": "LogRocket",
            "email": "support@logrocket.com"
          },
          "version": null,
          "license": "MIT",
          "logoUrl": null,
          "darkLogoUrl": null,
          "homepage": "https://logrocket.com",
          "sourceUrl": "https://github.com/LogRocket/logrocket-claude-plugin/tree/2e44dbb47faf9bb54e3405a8ae2714e7c5ce9791/plugins/logrocket",
          "skills": [
            {
              "name": "use-logrocket",
              "sourceUrl": "https://github.com/LogRocket/logrocket-claude-plugin/blob/2e44dbb47faf9bb54e3405a8ae2714e7c5ce9791/plugins/logrocket/skills/use-logrocket/SKILL.md"
            }
          ],
          "mcpServers": [
            {
              "requiresConfiguration": false,
              "name": "logrocket",
              "transport": "http",
              "endpoint": "https://mcp.logrocket.com/mcp?toolsets=all"
            }
          ],
          "components": ["skills", "mcp"],
          "componentInspection": "repository",
          "inspectionError": null,
          "installation": "requires_adapter",
          "upstream": {
            "source": {
              "source": "git-subdir",
              "url": "https://github.com/LogRocket/logrocket-claude-plugin.git",
              "path": "plugins/logrocket",
              "ref": "main",
              "sha": "2e44dbb47faf9bb54e3405a8ae2714e7c5ce9791"
            },
            "policy": null
          }
        },
        {
          "id": "anthropic:looker",
          "name": "looker",
          "displayName": "looker",
          "description": "Connect to Looker and interact with your data using LookML.",
          "longDescription": "Connect to Looker and interact with your data using LookML.",
          "category": "database",
          "keywords": [],
          "author": {
            "name": "Google LLC",
            "email": "data-cloud-ai-integrations@google.com"
          },
          "version": "0.3.10",
          "license": "Apache-2.0",
          "logoUrl": null,
          "darkLogoUrl": null,
          "homepage": "https://cloud.google.com/looker",
          "sourceUrl": "https://github.com/gemini-cli-extensions/looker/tree/4a8edc0912897a3bc9e9edfb85e9ec4914f38182/",
          "skills": [],
          "mcpServers": [
            {
              "requiresConfiguration": false,
              "name": "looker",
              "transport": "stdio",
              "endpoint": null
            },
            {
              "requiresConfiguration": false,
              "name": "looker-dev",
              "transport": "stdio",
              "endpoint": null
            }
          ],
          "components": ["mcp"],
          "componentInspection": "repository",
          "inspectionError": null,
          "installation": "requires_adapter",
          "upstream": {
            "source": {
              "source": "url",
              "url": "https://github.com/gemini-cli-extensions/looker.git",
              "sha": "4a8edc0912897a3bc9e9edfb85e9ec4914f38182"
            },
            "policy": null
          }
        },
        {
          "id": "anthropic:lovable",
          "name": "lovable",
          "displayName": "lovable",
          "description": "Build, iterate on, deploy, and manage Lovable apps from Claude Code. Bundles the official Lovable MCP server (remote, OAuth 2.1) and adds focused commands for the common build/iterate/database workflows, with credit- and publish-safety prompts.",
          "longDescription": "Build, iterate on, deploy, and manage Lovable apps from Claude Code. Bundles the official Lovable MCP server (remote, OAuth 2.1) and adds focused commands for the common build/iterate/database workflows, with credit- and publish-safety prompts.",
          "category": "development",
          "keywords": ["lovable", "app-builder", "deploy", "full-stack", "mcp"],
          "author": {
            "name": "Lovable",
            "url": "https://lovable.dev"
          },
          "version": "0.1.0",
          "license": "Apache-2.0",
          "logoUrl": null,
          "darkLogoUrl": null,
          "homepage": "https://lovable.dev",
          "sourceUrl": "https://github.com/lovablelabs/mcp/tree/0336e6db8026b0f02cb89d1451cc48ea3f469791/",
          "skills": [],
          "mcpServers": [
            {
              "requiresConfiguration": false,
              "name": "lovable",
              "transport": "http",
              "endpoint": "https://mcp.lovable.dev/?src=cc-plugin"
            }
          ],
          "components": ["mcp", "commands"],
          "componentInspection": "repository",
          "inspectionError": null,
          "installation": "requires_adapter",
          "upstream": {
            "source": {
              "source": "url",
              "url": "https://github.com/lovablelabs/mcp.git",
              "sha": "0336e6db8026b0f02cb89d1451cc48ea3f469791"
            },
            "policy": null
          }
        },
        {
          "id": "anthropic:lua-lsp",
          "name": "lua-lsp",
          "displayName": "lua-lsp",
          "description": "Lua language server for code intelligence",
          "longDescription": "Lua language server for code intelligence",
          "category": "development",
          "keywords": [],
          "author": {
            "name": "Anthropic",
            "email": "support@anthropic.com"
          },
          "version": "1.0.0",
          "license": null,
          "logoUrl": null,
          "darkLogoUrl": null,
          "homepage": null,
          "sourceUrl": "https://github.com/anthropics/claude-plugins-official/tree/3b600518a637492d37c9877aeb49c2a55d939c04/plugins/lua-lsp",
          "skills": [],
          "mcpServers": [],
          "components": [],
          "componentInspection": "repository",
          "inspectionError": null,
          "installation": "requires_adapter",
          "upstream": {
            "source": "./plugins/lua-lsp",
            "policy": null
          }
        },
        {
          "id": "anthropic:lumen",
          "name": "lumen",
          "displayName": "lumen",
          "description": "Precise local semantic code search via MCP. Indexes your codebase with Go AST parsing, embeds with Ollama or LM Studio, and exposes vector search to Claude through an MCP server — no cloud, no npm.",
          "longDescription": "Precise local semantic code search via MCP. Indexes your codebase with Go AST parsing, embeds with Ollama or LM Studio, and exposes vector search to Claude through an MCP server — no cloud, no npm.",
          "category": "development",
          "keywords": ["semantic-search", "code-index", "mcp", "embeddings", "ollama", "rag"],
          "author": {
            "name": "Ory Corp",
            "url": "https://github.com/ory"
          },
          "version": "0.0.42",
          "license": "Apache-2.0",
          "logoUrl": null,
          "darkLogoUrl": null,
          "homepage": "https://github.com/ory/lumen",
          "sourceUrl": "https://github.com/ory/lumen/tree/f60f9ecee41723b42f3758e9a9409141881ac7d5/",
          "skills": [
            {
              "name": "add-benchmark",
              "sourceUrl": "https://github.com/ory/lumen/blob/f60f9ecee41723b42f3758e9a9409141881ac7d5/.claude/skills/add-benchmark/SKILL.md"
            },
            {
              "name": "doctor",
              "sourceUrl": "https://github.com/ory/lumen/blob/f60f9ecee41723b42f3758e9a9409141881ac7d5/plugins/lumen/skills/doctor/SKILL.md"
            },
            {
              "name": "reindex",
              "sourceUrl": "https://github.com/ory/lumen/blob/f60f9ecee41723b42f3758e9a9409141881ac7d5/plugins/lumen/skills/reindex/SKILL.md"
            },
            {
              "name": "doctor",
              "sourceUrl": "https://github.com/ory/lumen/blob/f60f9ecee41723b42f3758e9a9409141881ac7d5/skills/doctor/SKILL.md"
            },
            {
              "name": "reindex",
              "sourceUrl": "https://github.com/ory/lumen/blob/f60f9ecee41723b42f3758e9a9409141881ac7d5/skills/reindex/SKILL.md"
            }
          ],
          "mcpServers": [
            {
              "requiresConfiguration": false,
              "name": "lumen",
              "transport": "stdio",
              "endpoint": null
            }
          ],
          "components": ["skills", "mcp", "hooks"],
          "componentInspection": "repository",
          "inspectionError": null,
          "installation": "requires_adapter",
          "upstream": {
            "source": {
              "source": "url",
              "url": "https://github.com/ory/lumen.git",
              "sha": "f60f9ecee41723b42f3758e9a9409141881ac7d5"
            },
            "policy": null
          }
        },
        {
          "id": "anthropic:lusha",
          "name": "lusha",
          "displayName": "lusha",
          "description": "Connect Lusha to Claude to pull verified B2B data, contact data, and company data — including verified emails, direct dials, mobile numbers, and real-time buying signals — straight into your conversation. Lusha is the B2B data layer behind 300M+ verified contacts, used for sales intelligence, prospecting, data enrichment, and lead enrichment across sales, marketing, and RevOps workflows. Backed by GDPR, CCPA, SOC 2 Type II, and ISO 27701 compliance. Perfect for building prospect lists, researching accounts before a call, qualifying inbound leads, and natural language prospecting inside Claude.\n\nUse Lusha to:\n- Find contacts and decision makers by role, company, industry, or seniority — \"Find 10 VPs of RevOps at Series B SaaS companies in NYC\"\n- Pull verified emails, direct dials, and mobile numbers with 98% email deliverability and 85% phone accuracy — \"Get the verified work email and mobile number for the Head of Marketing at Notion\"\n- Enrich CRM records and inbound leads with firmographics, technographics, headcount, revenue, and buying signals — \"Enrich these 25 webinar signup domains with industry, tech stack, and recent hiring signals\"\n- Track signals across target accounts — funding rounds, leadership hires, hiring surges, and tech stack changes — \"Show me the buying signals from the last 90 days for these 15 accounts\"\n- Find lookalike accounts based on your closed-won customers — \"Find 20 companies that look like these 5 customers\"",
          "longDescription": "Connect Lusha to Claude to pull verified B2B data, contact data, and company data — including verified emails, direct dials, mobile numbers, and real-time buying signals — straight into your conversation. Lusha is the B2B data layer behind 300M+ verified contacts, used for sales intelligence, prospecting, data enrichment, and lead enrichment across sales, marketing, and RevOps workflows. Backed by GDPR, CCPA, SOC 2 Type II, and ISO 27701 compliance. Perfect for building prospect lists, researching accounts before a call, qualifying inbound leads, and natural language prospecting inside Claude.\n\nUse Lusha to:\n- Find contacts and decision makers by role, company, industry, or seniority — \"Find 10 VPs of RevOps at Series B SaaS companies in NYC\"\n- Pull verified emails, direct dials, and mobile numbers with 98% email deliverability and 85% phone accuracy — \"Get the verified work email and mobile number for the Head of Marketing at Notion\"\n- Enrich CRM records and inbound leads with firmographics, technographics, headcount, revenue, and buying signals — \"Enrich these 25 webinar signup domains with industry, tech stack, and recent hiring signals\"\n- Track signals across target accounts — funding rounds, leadership hires, hiring surges, and tech stack changes — \"Show me the buying signals from the last 90 days for these 15 accounts\"\n- Find lookalike accounts based on your closed-won customers — \"Find 20 companies that look like these 5 customers\"",
          "category": "productivity",
          "keywords": [
            "lusha",
            "b2b",
            "sales-intelligence",
            "prospecting",
            "data-enrichment",
            "lead-enrichment",
            "verified-emails",
            "phone-numbers",
            "buying-signals",
            "contacts",
            "companies",
            "revops",
            "mcp"
          ],
          "author": {
            "name": "Lusha",
            "email": "support@lusha.com",
            "url": "https://www.lusha.com"
          },
          "version": "0.1.2",
          "license": "MIT",
          "logoUrl": null,
          "darkLogoUrl": null,
          "homepage": "https://www.lusha.com",
          "sourceUrl": "https://github.com/lusha-oss/lusha-mcp-plugin/tree/ed34947a36754411f03cdeaba91c8cdaa153ef2e/",
          "skills": [
            {
              "name": "enrich-contact",
              "sourceUrl": "https://github.com/lusha-oss/lusha-mcp-plugin/blob/ed34947a36754411f03cdeaba91c8cdaa153ef2e/skills/enrich-contact/SKILL.md"
            },
            {
              "name": "lookalike-prospect",
              "sourceUrl": "https://github.com/lusha-oss/lusha-mcp-plugin/blob/ed34947a36754411f03cdeaba91c8cdaa153ef2e/skills/lookalike-prospect/SKILL.md"
            },
            {
              "name": "outreach-research",
              "sourceUrl": "https://github.com/lusha-oss/lusha-mcp-plugin/blob/ed34947a36754411f03cdeaba91c8cdaa153ef2e/skills/outreach-research/SKILL.md"
            },
            {
              "name": "outreach-sequence",
              "sourceUrl": "https://github.com/lusha-oss/lusha-mcp-plugin/blob/ed34947a36754411f03cdeaba91c8cdaa153ef2e/skills/outreach-sequence/SKILL.md"
            },
            {
              "name": "prospect",
              "sourceUrl": "https://github.com/lusha-oss/lusha-mcp-plugin/blob/ed34947a36754411f03cdeaba91c8cdaa153ef2e/skills/prospect/SKILL.md"
            },
            {
              "name": "signal-prospect",
              "sourceUrl": "https://github.com/lusha-oss/lusha-mcp-plugin/blob/ed34947a36754411f03cdeaba91c8cdaa153ef2e/skills/signal-prospect/SKILL.md"
            }
          ],
          "mcpServers": [
            {
              "requiresConfiguration": true,
              "name": "lusha",
              "transport": "http",
              "endpoint": "https://mcp.lusha.com/mcp/claude"
            }
          ],
          "components": ["skills", "mcp"],
          "componentInspection": "repository",
          "inspectionError": null,
          "installation": "requires_adapter",
          "upstream": {
            "source": {
              "source": "url",
              "url": "https://github.com/lusha-oss/lusha-mcp-plugin.git",
              "sha": "ed34947a36754411f03cdeaba91c8cdaa153ef2e"
            },
            "policy": null
          }
        },
        {
          "id": "anthropic:mapbox",
          "name": "mapbox",
          "displayName": "mapbox",
          "description": "Mapbox skills and MCP servers for building location-aware applications with AI. Includes geospatial tools, style management, and patterns for web, iOS, Android, and AI agent frameworks.",
          "longDescription": "Mapbox skills and MCP servers for building location-aware applications with AI. Includes geospatial tools, style management, and patterns for web, iOS, Android, and AI agent frameworks.",
          "category": "location",
          "keywords": ["mapbox", "maps", "geospatial", "location", "mcp", "gis"],
          "author": {
            "name": "Mapbox",
            "url": "https://mapbox.com"
          },
          "version": "1.0.0",
          "license": "MIT",
          "logoUrl": null,
          "darkLogoUrl": null,
          "homepage": "https://github.com/mapbox/mapbox-agent-skills",
          "sourceUrl": "https://github.com/mapbox/mapbox-agent-skills/tree/209e8c408fd65edfff45e491c941e8a00025a1a6/",
          "skills": [
            {
              "name": "mapbox-android-patterns",
              "sourceUrl": "https://github.com/mapbox/mapbox-agent-skills/blob/209e8c408fd65edfff45e491c941e8a00025a1a6/skills/mapbox-android-patterns/SKILL.md"
            },
            {
              "name": "mapbox-cartography",
              "sourceUrl": "https://github.com/mapbox/mapbox-agent-skills/blob/209e8c408fd65edfff45e491c941e8a00025a1a6/skills/mapbox-cartography/SKILL.md"
            },
            {
              "name": "mapbox-data-visualization-patterns",
              "sourceUrl": "https://github.com/mapbox/mapbox-agent-skills/blob/209e8c408fd65edfff45e491c941e8a00025a1a6/skills/mapbox-data-visualization-patterns/SKILL.md"
            },
            {
              "name": "mapbox-flutter-patterns",
              "sourceUrl": "https://github.com/mapbox/mapbox-agent-skills/blob/209e8c408fd65edfff45e491c941e8a00025a1a6/skills/mapbox-flutter-patterns/SKILL.md"
            },
            {
              "name": "mapbox-geospatial-operations",
              "sourceUrl": "https://github.com/mapbox/mapbox-agent-skills/blob/209e8c408fd65edfff45e491c941e8a00025a1a6/skills/mapbox-geospatial-operations/SKILL.md"
            },
            {
              "name": "mapbox-google-maps-migration",
              "sourceUrl": "https://github.com/mapbox/mapbox-agent-skills/blob/209e8c408fd65edfff45e491c941e8a00025a1a6/skills/mapbox-google-maps-migration/SKILL.md"
            },
            {
              "name": "mapbox-ios-patterns",
              "sourceUrl": "https://github.com/mapbox/mapbox-agent-skills/blob/209e8c408fd65edfff45e491c941e8a00025a1a6/skills/mapbox-ios-patterns/SKILL.md"
            },
            {
              "name": "mapbox-location-grounding",
              "sourceUrl": "https://github.com/mapbox/mapbox-agent-skills/blob/209e8c408fd65edfff45e491c941e8a00025a1a6/skills/mapbox-location-grounding/SKILL.md"
            },
            {
              "name": "mapbox-maplibre-migration",
              "sourceUrl": "https://github.com/mapbox/mapbox-agent-skills/blob/209e8c408fd65edfff45e491c941e8a00025a1a6/skills/mapbox-maplibre-migration/SKILL.md"
            },
            {
              "name": "mapbox-mcp-devkit-patterns",
              "sourceUrl": "https://github.com/mapbox/mapbox-agent-skills/blob/209e8c408fd65edfff45e491c941e8a00025a1a6/skills/mapbox-mcp-devkit-patterns/SKILL.md"
            },
            {
              "name": "mapbox-mcp-runtime-patterns",
              "sourceUrl": "https://github.com/mapbox/mapbox-agent-skills/blob/209e8c408fd65edfff45e491c941e8a00025a1a6/skills/mapbox-mcp-runtime-patterns/SKILL.md"
            },
            {
              "name": "mapbox-navigation-patterns",
              "sourceUrl": "https://github.com/mapbox/mapbox-agent-skills/blob/209e8c408fd65edfff45e491c941e8a00025a1a6/skills/mapbox-navigation-patterns/SKILL.md"
            },
            {
              "name": "mapbox-search-integration",
              "sourceUrl": "https://github.com/mapbox/mapbox-agent-skills/blob/209e8c408fd65edfff45e491c941e8a00025a1a6/skills/mapbox-search-integration/SKILL.md"
            },
            {
              "name": "mapbox-search-patterns",
              "sourceUrl": "https://github.com/mapbox/mapbox-agent-skills/blob/209e8c408fd65edfff45e491c941e8a00025a1a6/skills/mapbox-search-patterns/SKILL.md"
            },
            {
              "name": "mapbox-store-locator-patterns",
              "sourceUrl": "https://github.com/mapbox/mapbox-agent-skills/blob/209e8c408fd65edfff45e491c941e8a00025a1a6/skills/mapbox-store-locator-patterns/SKILL.md"
            },
            {
              "name": "mapbox-style-patterns",
              "sourceUrl": "https://github.com/mapbox/mapbox-agent-skills/blob/209e8c408fd65edfff45e491c941e8a00025a1a6/skills/mapbox-style-patterns/SKILL.md"
            },
            {
              "name": "mapbox-style-quality",
              "sourceUrl": "https://github.com/mapbox/mapbox-agent-skills/blob/209e8c408fd65edfff45e491c941e8a00025a1a6/skills/mapbox-style-quality/SKILL.md"
            },
            {
              "name": "mapbox-token-security",
              "sourceUrl": "https://github.com/mapbox/mapbox-agent-skills/blob/209e8c408fd65edfff45e491c941e8a00025a1a6/skills/mapbox-token-security/SKILL.md"
            },
            {
              "name": "mapbox-web-integration-patterns",
              "sourceUrl": "https://github.com/mapbox/mapbox-agent-skills/blob/209e8c408fd65edfff45e491c941e8a00025a1a6/skills/mapbox-web-integration-patterns/SKILL.md"
            },
            {
              "name": "mapbox-web-performance-patterns",
              "sourceUrl": "https://github.com/mapbox/mapbox-agent-skills/blob/209e8c408fd65edfff45e491c941e8a00025a1a6/skills/mapbox-web-performance-patterns/SKILL.md"
            }
          ],
          "mcpServers": [
            {
              "requiresConfiguration": false,
              "name": "mapbox-devkit",
              "transport": "http",
              "endpoint": "https://mcp-devkit.mapbox.com/mcp"
            },
            {
              "requiresConfiguration": false,
              "name": "mapbox",
              "transport": "http",
              "endpoint": "https://mcp.mapbox.com/mcp"
            },
            {
              "requiresConfiguration": false,
              "name": "mapbox-docs",
              "transport": "http",
              "endpoint": "https://mcp-docs.mapbox.com/mcp"
            }
          ],
          "components": ["skills", "mcp"],
          "componentInspection": "repository",
          "inspectionError": null,
          "installation": "requires_adapter",
          "upstream": {
            "source": {
              "source": "url",
              "url": "https://github.com/mapbox/mapbox-agent-skills.git",
              "sha": "209e8c408fd65edfff45e491c941e8a00025a1a6"
            },
            "policy": null
          }
        },
        {
          "id": "anthropic:math-olympiad",
          "name": "math-olympiad",
          "displayName": "math-olympiad",
          "description": "Solve competition math (IMO, Putnam, USAMO) with adversarial verification that catches what self-verification misses. Fresh-context verifiers attack proofs with specific failure patterns. Calibrated abstention over bluffing.",
          "longDescription": "Solve competition math (IMO, Putnam, USAMO) with adversarial verification that catches what self-verification misses. Fresh-context verifiers attack proofs with specific failure patterns. Calibrated abstention over bluffing.",
          "category": "math",
          "keywords": [],
          "author": {
            "name": "Anthropic",
            "email": "support@anthropic.com"
          },
          "version": null,
          "license": null,
          "logoUrl": null,
          "darkLogoUrl": null,
          "homepage": "https://github.com/anthropics/claude-plugins-official/tree/main/plugins/math-olympiad",
          "sourceUrl": "https://github.com/anthropics/claude-plugins-official/tree/3b600518a637492d37c9877aeb49c2a55d939c04/plugins/math-olympiad",
          "skills": [
            {
              "name": "math-olympiad",
              "sourceUrl": "https://github.com/anthropics/claude-plugins-official/blob/3b600518a637492d37c9877aeb49c2a55d939c04/plugins/math-olympiad/skills/math-olympiad/SKILL.md"
            }
          ],
          "mcpServers": [],
          "components": ["skills"],
          "componentInspection": "repository",
          "inspectionError": null,
          "installation": "requires_adapter",
          "upstream": {
            "source": "./plugins/math-olympiad",
            "policy": null
          }
        },
        {
          "id": "anthropic:mattpocock-skills",
          "name": "mattpocock-skills",
          "displayName": "mattpocock-skills",
          "description": "Matt Pocock's agent skills for real engineering: grilling, spec/ticket flows, TDD, code review, domain modelling and more. Plug-and-play, not vibe coding.",
          "longDescription": "Matt Pocock's agent skills for real engineering: grilling, spec/ticket flows, TDD, code review, domain modelling and more. Plug-and-play, not vibe coding.",
          "category": "development",
          "keywords": [
            "engineering",
            "skills",
            "tdd",
            "code-review",
            "grilling",
            "domain-modeling",
            "productivity"
          ],
          "author": {
            "name": "Matt Pocock",
            "url": "https://www.aihero.dev"
          },
          "version": "1.2.3",
          "license": "MIT",
          "logoUrl": null,
          "darkLogoUrl": null,
          "homepage": "https://www.aihero.dev/s/skills-newsletter",
          "sourceUrl": "https://github.com/mattpocock/skills/tree/3cca18b368ae95cdbdebbff572ccafa662551015/",
          "skills": [
            {
              "name": "ask-matt",
              "sourceUrl": "https://github.com/mattpocock/skills/blob/3cca18b368ae95cdbdebbff572ccafa662551015/skills/engineering/ask-matt/SKILL.md"
            },
            {
              "name": "code-review",
              "sourceUrl": "https://github.com/mattpocock/skills/blob/3cca18b368ae95cdbdebbff572ccafa662551015/skills/engineering/code-review/SKILL.md"
            },
            {
              "name": "codebase-design",
              "sourceUrl": "https://github.com/mattpocock/skills/blob/3cca18b368ae95cdbdebbff572ccafa662551015/skills/engineering/codebase-design/SKILL.md"
            },
            {
              "name": "diagnosing-bugs",
              "sourceUrl": "https://github.com/mattpocock/skills/blob/3cca18b368ae95cdbdebbff572ccafa662551015/skills/engineering/diagnosing-bugs/SKILL.md"
            },
            {
              "name": "domain-modeling",
              "sourceUrl": "https://github.com/mattpocock/skills/blob/3cca18b368ae95cdbdebbff572ccafa662551015/skills/engineering/domain-modeling/SKILL.md"
            },
            {
              "name": "grill-with-docs",
              "sourceUrl": "https://github.com/mattpocock/skills/blob/3cca18b368ae95cdbdebbff572ccafa662551015/skills/engineering/grill-with-docs/SKILL.md"
            },
            {
              "name": "implement",
              "sourceUrl": "https://github.com/mattpocock/skills/blob/3cca18b368ae95cdbdebbff572ccafa662551015/skills/engineering/implement/SKILL.md"
            },
            {
              "name": "improve-codebase-architecture",
              "sourceUrl": "https://github.com/mattpocock/skills/blob/3cca18b368ae95cdbdebbff572ccafa662551015/skills/engineering/improve-codebase-architecture/SKILL.md"
            },
            {
              "name": "prototype",
              "sourceUrl": "https://github.com/mattpocock/skills/blob/3cca18b368ae95cdbdebbff572ccafa662551015/skills/engineering/prototype/SKILL.md"
            },
            {
              "name": "research",
              "sourceUrl": "https://github.com/mattpocock/skills/blob/3cca18b368ae95cdbdebbff572ccafa662551015/skills/engineering/research/SKILL.md"
            },
            {
              "name": "resolving-merge-conflicts",
              "sourceUrl": "https://github.com/mattpocock/skills/blob/3cca18b368ae95cdbdebbff572ccafa662551015/skills/engineering/resolving-merge-conflicts/SKILL.md"
            },
            {
              "name": "setup-matt-pocock-skills",
              "sourceUrl": "https://github.com/mattpocock/skills/blob/3cca18b368ae95cdbdebbff572ccafa662551015/skills/engineering/setup-matt-pocock-skills/SKILL.md"
            },
            {
              "name": "tdd",
              "sourceUrl": "https://github.com/mattpocock/skills/blob/3cca18b368ae95cdbdebbff572ccafa662551015/skills/engineering/tdd/SKILL.md"
            },
            {
              "name": "to-spec",
              "sourceUrl": "https://github.com/mattpocock/skills/blob/3cca18b368ae95cdbdebbff572ccafa662551015/skills/engineering/to-spec/SKILL.md"
            },
            {
              "name": "to-tickets",
              "sourceUrl": "https://github.com/mattpocock/skills/blob/3cca18b368ae95cdbdebbff572ccafa662551015/skills/engineering/to-tickets/SKILL.md"
            },
            {
              "name": "triage",
              "sourceUrl": "https://github.com/mattpocock/skills/blob/3cca18b368ae95cdbdebbff572ccafa662551015/skills/engineering/triage/SKILL.md"
            },
            {
              "name": "wayfinder",
              "sourceUrl": "https://github.com/mattpocock/skills/blob/3cca18b368ae95cdbdebbff572ccafa662551015/skills/engineering/wayfinder/SKILL.md"
            },
            {
              "name": "wizard",
              "sourceUrl": "https://github.com/mattpocock/skills/blob/3cca18b368ae95cdbdebbff572ccafa662551015/skills/engineering/wizard/SKILL.md"
            },
            {
              "name": "claude-handoff",
              "sourceUrl": "https://github.com/mattpocock/skills/blob/3cca18b368ae95cdbdebbff572ccafa662551015/skills/in-progress/claude-handoff/SKILL.md"
            },
            {
              "name": "implement-spec",
              "sourceUrl": "https://github.com/mattpocock/skills/blob/3cca18b368ae95cdbdebbff572ccafa662551015/skills/in-progress/implement-spec/SKILL.md"
            },
            {
              "name": "loop-me",
              "sourceUrl": "https://github.com/mattpocock/skills/blob/3cca18b368ae95cdbdebbff572ccafa662551015/skills/in-progress/loop-me/SKILL.md"
            },
            {
              "name": "retro",
              "sourceUrl": "https://github.com/mattpocock/skills/blob/3cca18b368ae95cdbdebbff572ccafa662551015/skills/in-progress/retro/SKILL.md"
            },
            {
              "name": "setup-ts-deep-modules",
              "sourceUrl": "https://github.com/mattpocock/skills/blob/3cca18b368ae95cdbdebbff572ccafa662551015/skills/in-progress/setup-ts-deep-modules/SKILL.md"
            },
            {
              "name": "writing-beats",
              "sourceUrl": "https://github.com/mattpocock/skills/blob/3cca18b368ae95cdbdebbff572ccafa662551015/skills/in-progress/writing-beats/SKILL.md"
            },
            {
              "name": "writing-fragments",
              "sourceUrl": "https://github.com/mattpocock/skills/blob/3cca18b368ae95cdbdebbff572ccafa662551015/skills/in-progress/writing-fragments/SKILL.md"
            },
            {
              "name": "writing-shape",
              "sourceUrl": "https://github.com/mattpocock/skills/blob/3cca18b368ae95cdbdebbff572ccafa662551015/skills/in-progress/writing-shape/SKILL.md"
            },
            {
              "name": "git-guardrails-claude-code",
              "sourceUrl": "https://github.com/mattpocock/skills/blob/3cca18b368ae95cdbdebbff572ccafa662551015/skills/misc/git-guardrails-claude-code/SKILL.md"
            },
            {
              "name": "migrate-to-shoehorn",
              "sourceUrl": "https://github.com/mattpocock/skills/blob/3cca18b368ae95cdbdebbff572ccafa662551015/skills/misc/migrate-to-shoehorn/SKILL.md"
            },
            {
              "name": "scaffold-exercises",
              "sourceUrl": "https://github.com/mattpocock/skills/blob/3cca18b368ae95cdbdebbff572ccafa662551015/skills/misc/scaffold-exercises/SKILL.md"
            },
            {
              "name": "setup-pre-commit",
              "sourceUrl": "https://github.com/mattpocock/skills/blob/3cca18b368ae95cdbdebbff572ccafa662551015/skills/misc/setup-pre-commit/SKILL.md"
            },
            {
              "name": "grill-me",
              "sourceUrl": "https://github.com/mattpocock/skills/blob/3cca18b368ae95cdbdebbff572ccafa662551015/skills/productivity/grill-me/SKILL.md"
            },
            {
              "name": "grilling",
              "sourceUrl": "https://github.com/mattpocock/skills/blob/3cca18b368ae95cdbdebbff572ccafa662551015/skills/productivity/grilling/SKILL.md"
            },
            {
              "name": "handoff",
              "sourceUrl": "https://github.com/mattpocock/skills/blob/3cca18b368ae95cdbdebbff572ccafa662551015/skills/productivity/handoff/SKILL.md"
            },
            {
              "name": "teach",
              "sourceUrl": "https://github.com/mattpocock/skills/blob/3cca18b368ae95cdbdebbff572ccafa662551015/skills/productivity/teach/SKILL.md"
            },
            {
              "name": "to-questionnaire",
              "sourceUrl": "https://github.com/mattpocock/skills/blob/3cca18b368ae95cdbdebbff572ccafa662551015/skills/productivity/to-questionnaire/SKILL.md"
            },
            {
              "name": "wait-what",
              "sourceUrl": "https://github.com/mattpocock/skills/blob/3cca18b368ae95cdbdebbff572ccafa662551015/skills/productivity/wait-what/SKILL.md"
            },
            {
              "name": "writing-for-agents",
              "sourceUrl": "https://github.com/mattpocock/skills/blob/3cca18b368ae95cdbdebbff572ccafa662551015/skills/productivity/writing-for-agents/SKILL.md"
            }
          ],
          "mcpServers": [],
          "components": ["skills"],
          "componentInspection": "repository",
          "inspectionError": null,
          "installation": "requires_adapter",
          "upstream": {
            "source": {
              "source": "url",
              "url": "https://github.com/mattpocock/skills.git",
              "sha": "3cca18b368ae95cdbdebbff572ccafa662551015"
            },
            "policy": null
          }
        },
        {
          "id": "anthropic:mcp-apps",
          "name": "mcp-apps",
          "displayName": "mcp-apps",
          "description": "Claude Code skill for building MCP Apps with interactive UIs",
          "longDescription": "Claude Code skill for building MCP Apps with interactive UIs",
          "category": "development",
          "keywords": ["mcp", "mcp-apps", "model-context-protocol", "ui", "interactive"],
          "author": {
            "name": "MCP Apps"
          },
          "version": "0.1.0",
          "license": "MIT",
          "logoUrl": null,
          "darkLogoUrl": null,
          "homepage": "https://modelcontextprotocol.io",
          "sourceUrl": "https://github.com/modelcontextprotocol/ext-apps/tree/fa1274490873f869c9a084e1abb9cf3031d288c7/plugins/mcp-apps",
          "skills": [
            {
              "name": "add-app-to-server",
              "sourceUrl": "https://github.com/modelcontextprotocol/ext-apps/blob/fa1274490873f869c9a084e1abb9cf3031d288c7/plugins/mcp-apps/skills/add-app-to-server/SKILL.md"
            },
            {
              "name": "convert-web-app",
              "sourceUrl": "https://github.com/modelcontextprotocol/ext-apps/blob/fa1274490873f869c9a084e1abb9cf3031d288c7/plugins/mcp-apps/skills/convert-web-app/SKILL.md"
            },
            {
              "name": "create-mcp-app",
              "sourceUrl": "https://github.com/modelcontextprotocol/ext-apps/blob/fa1274490873f869c9a084e1abb9cf3031d288c7/plugins/mcp-apps/skills/create-mcp-app/SKILL.md"
            },
            {
              "name": "migrate-oai-app",
              "sourceUrl": "https://github.com/modelcontextprotocol/ext-apps/blob/fa1274490873f869c9a084e1abb9cf3031d288c7/plugins/mcp-apps/skills/migrate-oai-app/SKILL.md"
            }
          ],
          "mcpServers": [],
          "components": ["skills"],
          "componentInspection": "repository",
          "inspectionError": null,
          "installation": "requires_adapter",
          "upstream": {
            "source": {
              "source": "git-subdir",
              "url": "https://github.com/modelcontextprotocol/ext-apps.git",
              "path": "plugins/mcp-apps",
              "ref": "main",
              "sha": "fa1274490873f869c9a084e1abb9cf3031d288c7"
            },
            "policy": null
          }
        },
        {
          "id": "anthropic:mcp-server-dev",
          "name": "mcp-server-dev",
          "displayName": "mcp-server-dev",
          "description": "Skills for designing and building MCP servers that work seamlessly with Claude — guides you through deployment models (remote HTTP, MCPB, local), tool design patterns, auth, and interactive MCP apps.",
          "longDescription": "Skills for designing and building MCP servers that work seamlessly with Claude — guides you through deployment models (remote HTTP, MCPB, local), tool design patterns, auth, and interactive MCP apps.",
          "category": "development",
          "keywords": [],
          "author": {
            "name": "Anthropic",
            "email": "support@anthropic.com"
          },
          "version": null,
          "license": null,
          "logoUrl": null,
          "darkLogoUrl": null,
          "homepage": "https://github.com/anthropics/claude-plugins-official/tree/main/plugins/mcp-server-dev",
          "sourceUrl": "https://github.com/anthropics/claude-plugins-official/tree/3b600518a637492d37c9877aeb49c2a55d939c04/plugins/mcp-server-dev",
          "skills": [
            {
              "name": "build-mcp-app",
              "sourceUrl": "https://github.com/anthropics/claude-plugins-official/blob/3b600518a637492d37c9877aeb49c2a55d939c04/plugins/mcp-server-dev/skills/build-mcp-app/SKILL.md"
            },
            {
              "name": "build-mcp-server",
              "sourceUrl": "https://github.com/anthropics/claude-plugins-official/blob/3b600518a637492d37c9877aeb49c2a55d939c04/plugins/mcp-server-dev/skills/build-mcp-server/SKILL.md"
            },
            {
              "name": "build-mcpb",
              "sourceUrl": "https://github.com/anthropics/claude-plugins-official/blob/3b600518a637492d37c9877aeb49c2a55d939c04/plugins/mcp-server-dev/skills/build-mcpb/SKILL.md"
            }
          ],
          "mcpServers": [],
          "components": ["skills"],
          "componentInspection": "repository",
          "inspectionError": null,
          "installation": "requires_adapter",
          "upstream": {
            "source": "./plugins/mcp-server-dev",
            "policy": null
          }
        },
        {
          "id": "anthropic:mcp-tunnels",
          "name": "mcp-tunnels",
          "displayName": "mcp-tunnels",
          "description": "Connect Claude to a private MCP server through an Anthropic MCP tunnel. Drives the Docker Compose quickstart end to end: certificates, proxy config, cloudflared, and a verifiable sample server.",
          "longDescription": "Connect Claude to a private MCP server through an Anthropic MCP tunnel. Drives the Docker Compose quickstart end to end: certificates, proxy config, cloudflared, and a verifiable sample server.",
          "category": "development",
          "keywords": [],
          "author": {
            "name": "Anthropic",
            "email": "support@anthropic.com"
          },
          "version": null,
          "license": null,
          "logoUrl": null,
          "darkLogoUrl": null,
          "homepage": "https://github.com/anthropics/claude-plugins-official/tree/main/plugins/mcp-tunnels",
          "sourceUrl": "https://github.com/anthropics/claude-plugins-official/tree/3b600518a637492d37c9877aeb49c2a55d939c04/plugins/mcp-tunnels",
          "skills": [],
          "mcpServers": [],
          "components": ["commands"],
          "componentInspection": "repository",
          "inspectionError": null,
          "installation": "requires_adapter",
          "upstream": {
            "source": "./plugins/mcp-tunnels",
            "policy": null
          }
        },
        {
          "id": "anthropic:mercadopago",
          "name": "mercadopago",
          "displayName": "mercadopago",
          "description": "Mercado Pago integration toolkit for Claude Code. One agent routes to four skills: mp-integrate (wizard for Checkout Pro, Checkout API, Bricks, QR Code, Point, Subscriptions, Marketplace, Wallet Connect, Payouts, and SmartApps — plus migration of legacy Instore integrations to the Orders API), mp-webhooks (HMAC-validated receiver scaffold and diagnostics), mp-test-setup (test users, credentials, and test cards), and mp-review (quality and security checks). Scaffolding works offline where possible; live account and documentation operations use the official Mercado Pago MCP server on demand.",
          "longDescription": "Mercado Pago integration toolkit for Claude Code. One agent routes to four skills: mp-integrate (wizard for Checkout Pro, Checkout API, Bricks, QR Code, Point, Subscriptions, Marketplace, Wallet Connect, Payouts, and SmartApps — plus migration of legacy Instore integrations to the Orders API), mp-webhooks (HMAC-validated receiver scaffold and diagnostics), mp-test-setup (test users, credentials, and test cards), and mp-review (quality and security checks). Scaffolding works offline where possible; live account and documentation operations use the official Mercado Pago MCP server on demand.",
          "category": "development",
          "keywords": [
            "mercadopago",
            "payments",
            "checkout",
            "webhooks",
            "ipn",
            "qr",
            "point",
            "subscriptions",
            "marketplace",
            "payouts",
            "smartapps",
            "wallet",
            "3ds",
            "fintech",
            "meli"
          ],
          "author": {
            "name": "Mercado Pago Developer Experience"
          },
          "version": "4.3.2",
          "license": "Apache-2.0",
          "logoUrl": null,
          "darkLogoUrl": null,
          "homepage": "https://github.com/mercadopago/mercadopago-claude-marketplace/tree/main/plugins/mercadopago",
          "sourceUrl": "https://github.com/mercadopago/mercadopago-claude-marketplace/tree/c0d06959afc90b2f3d637c35eeb51c36f512c005/plugins/mercadopago",
          "skills": [
            {
              "name": "mp-integrate",
              "sourceUrl": "https://github.com/mercadopago/mercadopago-claude-marketplace/blob/c0d06959afc90b2f3d637c35eeb51c36f512c005/plugins/mercadopago/skills/mp-integrate/SKILL.md"
            },
            {
              "name": "mp-review",
              "sourceUrl": "https://github.com/mercadopago/mercadopago-claude-marketplace/blob/c0d06959afc90b2f3d637c35eeb51c36f512c005/plugins/mercadopago/skills/mp-review/SKILL.md"
            },
            {
              "name": "mp-test-setup",
              "sourceUrl": "https://github.com/mercadopago/mercadopago-claude-marketplace/blob/c0d06959afc90b2f3d637c35eeb51c36f512c005/plugins/mercadopago/skills/mp-test-setup/SKILL.md"
            },
            {
              "name": "mp-webhooks",
              "sourceUrl": "https://github.com/mercadopago/mercadopago-claude-marketplace/blob/c0d06959afc90b2f3d637c35eeb51c36f512c005/plugins/mercadopago/skills/mp-webhooks/SKILL.md"
            }
          ],
          "mcpServers": [
            {
              "requiresConfiguration": true,
              "name": "mcp",
              "transport": "http",
              "endpoint": "https://mcp.mercadopago.com/mcp"
            }
          ],
          "components": ["skills", "mcp", "hooks", "agents", "commands"],
          "componentInspection": "repository",
          "inspectionError": null,
          "installation": "requires_adapter",
          "upstream": {
            "source": {
              "source": "git-subdir",
              "url": "https://github.com/mercadopago/mercadopago-claude-marketplace.git",
              "path": "plugins/mercadopago",
              "ref": "main",
              "sha": "c0d06959afc90b2f3d637c35eeb51c36f512c005"
            },
            "policy": null
          }
        },
        {
          "id": "anthropic:mergify",
          "name": "mergify",
          "displayName": "mergify",
          "description": "Skills for the Mergify CLI: manage merge queues, stacked pull requests, Test Insights (flaky tests, quarantine), merge protections, and Mergify configuration directly from the terminal.",
          "longDescription": "Skills for the Mergify CLI: manage merge queues, stacked pull requests, Test Insights (flaky tests, quarantine), merge protections, and Mergify configuration directly from the terminal.",
          "category": "development",
          "keywords": [
            "git",
            "pr",
            "stacked-prs",
            "merge-queue",
            "ci",
            "test-insights",
            "flaky-tests",
            "quarantine",
            "freeze",
            "config",
            "push",
            "commit",
            "branch",
            "rebase",
            "checkout",
            "workflow"
          ],
          "author": {
            "name": "Mergify"
          },
          "version": null,
          "license": "Apache-2.0",
          "logoUrl": null,
          "darkLogoUrl": null,
          "homepage": "https://mergify.com",
          "sourceUrl": "https://github.com/mergifyio/mergify-cli/tree/727ce50b8fb3be8a9a24025807e159d644dbba80/",
          "skills": [
            {
              "name": "mergify-ci",
              "sourceUrl": "https://github.com/mergifyio/mergify-cli/blob/727ce50b8fb3be8a9a24025807e159d644dbba80/skills/mergify-ci/SKILL.md"
            },
            {
              "name": "mergify-config",
              "sourceUrl": "https://github.com/mergifyio/mergify-cli/blob/727ce50b8fb3be8a9a24025807e159d644dbba80/skills/mergify-config/SKILL.md"
            },
            {
              "name": "mergify-events",
              "sourceUrl": "https://github.com/mergifyio/mergify-cli/blob/727ce50b8fb3be8a9a24025807e159d644dbba80/skills/mergify-events/SKILL.md"
            },
            {
              "name": "mergify-merge-protections",
              "sourceUrl": "https://github.com/mergifyio/mergify-cli/blob/727ce50b8fb3be8a9a24025807e159d644dbba80/skills/mergify-merge-protections/SKILL.md"
            },
            {
              "name": "mergify-merge-queue",
              "sourceUrl": "https://github.com/mergifyio/mergify-cli/blob/727ce50b8fb3be8a9a24025807e159d644dbba80/skills/mergify-merge-queue/SKILL.md"
            },
            {
              "name": "mergify-stack",
              "sourceUrl": "https://github.com/mergifyio/mergify-cli/blob/727ce50b8fb3be8a9a24025807e159d644dbba80/skills/mergify-stack/SKILL.md"
            }
          ],
          "mcpServers": [],
          "components": ["skills"],
          "componentInspection": "repository",
          "inspectionError": null,
          "installation": "requires_adapter",
          "upstream": {
            "source": {
              "source": "url",
              "url": "https://github.com/mergifyio/mergify-cli.git",
              "sha": "727ce50b8fb3be8a9a24025807e159d644dbba80"
            },
            "policy": null
          }
        },
        {
          "id": "anthropic:microsoft-docs",
          "name": "microsoft-docs",
          "displayName": "microsoft-docs",
          "description": "Access official Microsoft documentation, API references, and code samples for Azure, .NET, Windows, and more.",
          "longDescription": "Access official Microsoft documentation, API references, and code samples for Azure, .NET, Windows, and more.",
          "category": "development",
          "keywords": [
            "microsoft",
            "docs",
            "azure",
            ".net",
            "windows",
            "api",
            "documentation",
            "rag",
            "dynamics",
            "powerbi",
            "office"
          ],
          "author": {
            "name": "Microsoft"
          },
          "version": "0.3.1",
          "license": null,
          "logoUrl": null,
          "darkLogoUrl": null,
          "homepage": "https://learn.microsoft.com",
          "sourceUrl": "https://github.com/MicrosoftDocs/mcp/tree/bb124f19c9304a33e507d0017f0613f8bda3a16c/",
          "skills": [
            {
              "name": "microsoft-learn-cli",
              "sourceUrl": "https://github.com/MicrosoftDocs/mcp/blob/bb124f19c9304a33e507d0017f0613f8bda3a16c/cli/assets/microsoft-learn-cli/SKILL.md"
            },
            {
              "name": "microsoft-code-reference",
              "sourceUrl": "https://github.com/MicrosoftDocs/mcp/blob/bb124f19c9304a33e507d0017f0613f8bda3a16c/skills/microsoft-code-reference/SKILL.md"
            },
            {
              "name": "microsoft-docs",
              "sourceUrl": "https://github.com/MicrosoftDocs/mcp/blob/bb124f19c9304a33e507d0017f0613f8bda3a16c/skills/microsoft-docs/SKILL.md"
            },
            {
              "name": "microsoft-skill-creator",
              "sourceUrl": "https://github.com/MicrosoftDocs/mcp/blob/bb124f19c9304a33e507d0017f0613f8bda3a16c/skills/microsoft-skill-creator/SKILL.md"
            }
          ],
          "mcpServers": [
            {
              "requiresConfiguration": false,
              "name": "microsoft-learn",
              "transport": "http",
              "endpoint": "https://learn.microsoft.com/api/mcp"
            }
          ],
          "components": ["skills", "mcp"],
          "componentInspection": "repository",
          "inspectionError": null,
          "installation": "requires_adapter",
          "upstream": {
            "source": {
              "source": "url",
              "url": "https://github.com/MicrosoftDocs/mcp.git",
              "sha": "bb124f19c9304a33e507d0017f0613f8bda3a16c"
            },
            "policy": null
          }
        },
        {
          "id": "anthropic:migration-to-aws",
          "name": "migration-to-aws",
          "displayName": "migration-to-aws",
          "description": "This no-cost tool assesses your current cloud provider's usage, geography, and billing data to estimate and compare AWS services and pricing, and recommends migration or continued use of your current provider. Supports GCP and Heroku migrations. AWS pricing is based on current published pricing and may vary over time. The tool may generate a .migration folder containing comparison and migration execution data, which you may delete upon completion or use to migrate to AWS.",
          "longDescription": "This no-cost tool assesses your current cloud provider's usage, geography, and billing data to estimate and compare AWS services and pricing, and recommends migration or continued use of your current provider. Supports GCP and Heroku migrations. AWS pricing is based on current published pricing and may vary over time. The tool may generate a .migration folder containing comparison and migration execution data, which you may delete upon completion or use to migrate to AWS.",
          "category": "development",
          "keywords": [
            "aws",
            "gcp",
            "google-cloud",
            "cloud-run",
            "cloud-sql",
            "vertex-ai",
            "gemini",
            "migration",
            "cloud-migration",
            "move-to-aws",
            "switch-to-aws",
            "terraform",
            "fargate",
            "rds",
            "aurora",
            "eks",
            "bedrock",
            "ai-migration",
            "openai",
            "openai-to-bedrock",
            "langchain",
            "langgraph",
            "crewai",
            "autogen",
            "agentic",
            "agents",
            "llm-migration",
            "cost-estimation",
            "cost-comparison",
            "pricing-comparison",
            "agent-runtime",
            "agentcore",
            "lambda-microvms",
            "deploy-ai-agent",
            "agent-architecture",
            "choose-agent-runtime",
            "agentcore-vs-lambda",
            "where-to-run-my-agent",
            "add-agentcore-services",
            "bedrock-migration",
            "openai-to-bedrock-execute",
            "llm-to-bedrock",
            "rewrite-sdk-calls",
            "bedrock-code-rewrite",
            "ai-migration-execute",
            "temporal",
            "temporal-cloud",
            "temporal-workers",
            "temporal-to-aws",
            "durable-execution"
          ],
          "author": {
            "name": "Amazon Web Services"
          },
          "version": "1.5.0",
          "license": "Apache-2.0",
          "logoUrl": null,
          "darkLogoUrl": null,
          "homepage": "https://github.com/awslabs/startups",
          "sourceUrl": "https://github.com/awslabs/startups/tree/f1cc0fb275d45ce053997c7e921b4017f8f40eda/migrate/plugins/migration-to-aws",
          "skills": [
            {
              "name": "agent-advisor",
              "sourceUrl": "https://github.com/awslabs/startups/blob/f1cc0fb275d45ce053997c7e921b4017f8f40eda/migrate/plugins/migration-to-aws/skills/agent-advisor/SKILL.md"
            },
            {
              "name": "gcp-to-aws",
              "sourceUrl": "https://github.com/awslabs/startups/blob/f1cc0fb275d45ce053997c7e921b4017f8f40eda/migrate/plugins/migration-to-aws/skills/gcp-to-aws/SKILL.md"
            },
            {
              "name": "heroku-to-aws",
              "sourceUrl": "https://github.com/awslabs/startups/blob/f1cc0fb275d45ce053997c7e921b4017f8f40eda/migrate/plugins/migration-to-aws/skills/heroku-to-aws/SKILL.md"
            },
            {
              "name": "llm-to-bedrock",
              "sourceUrl": "https://github.com/awslabs/startups/blob/f1cc0fb275d45ce053997c7e921b4017f8f40eda/migrate/plugins/migration-to-aws/skills/llm-to-bedrock/SKILL.md"
            },
            {
              "name": "tf-best-practices",
              "sourceUrl": "https://github.com/awslabs/startups/blob/f1cc0fb275d45ce053997c7e921b4017f8f40eda/migrate/plugins/migration-to-aws/skills/tf-best-practices/SKILL.md"
            }
          ],
          "mcpServers": [
            {
              "requiresConfiguration": false,
              "name": "awsknowledge",
              "transport": "http",
              "endpoint": "https://knowledge-mcp.global.api.aws"
            },
            {
              "requiresConfiguration": false,
              "name": "awspricing",
              "transport": "stdio",
              "endpoint": null
            },
            {
              "requiresConfiguration": false,
              "name": "temporal-docs",
              "transport": "http",
              "endpoint": "https://temporal.mcp.kapa.ai"
            },
            {
              "requiresConfiguration": false,
              "name": "aws-pricing-calculator",
              "transport": "stdio",
              "endpoint": null
            }
          ],
          "components": ["skills", "mcp", "agents"],
          "componentInspection": "repository",
          "inspectionError": null,
          "installation": "requires_adapter",
          "upstream": {
            "source": {
              "source": "git-subdir",
              "url": "https://github.com/awslabs/startups.git",
              "path": "migrate/plugins/migration-to-aws",
              "ref": "main",
              "sha": "f1cc0fb275d45ce053997c7e921b4017f8f40eda"
            },
            "policy": null
          }
        },
        {
          "id": "anthropic:mintlify",
          "name": "mintlify",
          "displayName": "mintlify",
          "description": "Build beautiful documentation sites with Mintlify. Convert non-markdown files into properly formatted MDX pages, add and modify content with correct component use, and automate documentation updates.",
          "longDescription": "Build beautiful documentation sites with Mintlify. Convert non-markdown files into properly formatted MDX pages, add and modify content with correct component use, and automate documentation updates.",
          "category": "development",
          "keywords": [],
          "author": null,
          "version": null,
          "license": null,
          "logoUrl": null,
          "darkLogoUrl": null,
          "homepage": "https://www.mintlify.com/",
          "sourceUrl": "https://github.com/mintlify/mintlify-claude-plugin/tree/acd6d2e0128c4f235d55cfb8d8c91ecbdd5df8cc/",
          "skills": [
            {
              "name": "mintlify",
              "sourceUrl": "https://github.com/mintlify/mintlify-claude-plugin/blob/acd6d2e0128c4f235d55cfb8d8c91ecbdd5df8cc/skills/mintlify/SKILL.md"
            }
          ],
          "mcpServers": [
            {
              "requiresConfiguration": false,
              "name": "Mintlify",
              "transport": "http",
              "endpoint": "https://mintlify.com/docs/mcp"
            }
          ],
          "components": ["skills", "mcp"],
          "componentInspection": "repository",
          "inspectionError": null,
          "installation": "requires_adapter",
          "upstream": {
            "source": {
              "source": "url",
              "url": "https://github.com/mintlify/mintlify-claude-plugin.git",
              "sha": "acd6d2e0128c4f235d55cfb8d8c91ecbdd5df8cc"
            },
            "policy": null
          }
        },
        {
          "id": "anthropic:miro",
          "name": "miro",
          "displayName": "miro",
          "description": "Secure access to Miro boards. Enables AI to read board context, create diagrams, and generate code with enterprise-grade security.",
          "longDescription": "Secure access to Miro boards. Enables AI to read board context, create diagrams, and generate code with enterprise-grade security.",
          "category": "design",
          "keywords": [
            "miro",
            "whiteboard",
            "boards",
            "diagrams",
            "flowchart",
            "mindmap",
            "uml",
            "mermaid",
            "plantuml",
            "documents",
            "tables",
            "stickies",
            "wireframes",
            "prototypes",
            "visualization",
            "collaboration",
            "design-to-code",
            "mcp",
            "prd",
            "specs",
            "documentation",
            "planning",
            "frames",
            "cards",
            "shapes",
            "connectors",
            "images",
            "extraction",
            "design",
            "requirements",
            "tasks",
            "tracking",
            "todos",
            "project-management",
            "kanban",
            "sync"
          ],
          "author": {
            "name": "Miro",
            "email": "support@miro.com"
          },
          "version": "1.3.0",
          "license": "MIT",
          "logoUrl": null,
          "darkLogoUrl": null,
          "homepage": "https://miro.com",
          "sourceUrl": "https://github.com/miroapp/miro-ai/tree/85c2c7347542b3ce185eb1d2793f8d79ad485c63/claude-plugins/miro",
          "skills": [
            {
              "name": "miro-browse",
              "sourceUrl": "https://github.com/miroapp/miro-ai/blob/85c2c7347542b3ce185eb1d2793f8d79ad485c63/claude-plugins/miro/skills/miro-browse/SKILL.md"
            },
            {
              "name": "miro-code-explain-on-board",
              "sourceUrl": "https://github.com/miroapp/miro-ai/blob/85c2c7347542b3ce185eb1d2793f8d79ad485c63/claude-plugins/miro/skills/miro-code-explain-on-board/SKILL.md"
            },
            {
              "name": "miro-code-review",
              "sourceUrl": "https://github.com/miroapp/miro-ai/blob/85c2c7347542b3ce185eb1d2793f8d79ad485c63/claude-plugins/miro/skills/miro-code-review/SKILL.md"
            },
            {
              "name": "miro-code-spec",
              "sourceUrl": "https://github.com/miroapp/miro-ai/blob/85c2c7347542b3ce185eb1d2793f8d79ad485c63/claude-plugins/miro/skills/miro-code-spec/SKILL.md"
            },
            {
              "name": "miro-diagram",
              "sourceUrl": "https://github.com/miroapp/miro-ai/blob/85c2c7347542b3ce185eb1d2793f8d79ad485c63/claude-plugins/miro/skills/miro-diagram/SKILL.md"
            },
            {
              "name": "miro-doc",
              "sourceUrl": "https://github.com/miroapp/miro-ai/blob/85c2c7347542b3ce185eb1d2793f8d79ad485c63/claude-plugins/miro/skills/miro-doc/SKILL.md"
            },
            {
              "name": "miro-table",
              "sourceUrl": "https://github.com/miroapp/miro-ai/blob/85c2c7347542b3ce185eb1d2793f8d79ad485c63/claude-plugins/miro/skills/miro-table/SKILL.md"
            }
          ],
          "mcpServers": [
            {
              "requiresConfiguration": true,
              "name": "miro",
              "transport": "http",
              "endpoint": "https://mcp.miro.com/"
            }
          ],
          "components": ["skills", "mcp"],
          "componentInspection": "repository",
          "inspectionError": null,
          "installation": "requires_adapter",
          "upstream": {
            "source": {
              "source": "git-subdir",
              "url": "https://github.com/miroapp/miro-ai.git",
              "path": "claude-plugins/miro",
              "ref": "main",
              "sha": "85c2c7347542b3ce185eb1d2793f8d79ad485c63"
            },
            "policy": null
          }
        },
        {
          "id": "anthropic:modern-web-guidance",
          "name": "modern-web-guidance",
          "displayName": "modern-web-guidance",
          "description": "Keep your coding agent up to date with the latest web best practices",
          "longDescription": "Keep your coding agent up to date with the latest web best practices",
          "category": "development",
          "keywords": [],
          "author": {
            "name": "Google Chrome"
          },
          "version": "0.0.187",
          "license": null,
          "logoUrl": null,
          "darkLogoUrl": null,
          "homepage": "https://goo.gle/modern-web-guidance",
          "sourceUrl": "https://github.com/GoogleChrome/modern-web-guidance/tree/bfd8c8dded770f3ba07a518e28991a32df40f902/",
          "skills": [
            {
              "name": "chrome-extensions",
              "sourceUrl": "https://github.com/GoogleChrome/modern-web-guidance/blob/bfd8c8dded770f3ba07a518e28991a32df40f902/skills/chrome-extensions/SKILL.md"
            },
            {
              "name": "modern-web-guidance",
              "sourceUrl": "https://github.com/GoogleChrome/modern-web-guidance/blob/bfd8c8dded770f3ba07a518e28991a32df40f902/skills/modern-web-guidance/SKILL.md"
            }
          ],
          "mcpServers": [],
          "components": ["skills"],
          "componentInspection": "repository",
          "inspectionError": null,
          "installation": "requires_adapter",
          "upstream": {
            "source": {
              "source": "url",
              "url": "https://github.com/GoogleChrome/modern-web-guidance.git",
              "sha": "bfd8c8dded770f3ba07a518e28991a32df40f902"
            },
            "policy": null
          }
        },
        {
          "id": "anthropic:mlflow",
          "name": "mlflow",
          "displayName": "mlflow",
          "description": "Skills for tracing, evaluating, and improving AI agents with MLflow. Supports the full agent improvement loop: instrument → trace → evaluate → iterate → validate.",
          "longDescription": "Skills for tracing, evaluating, and improving AI agents with MLflow. Supports the full agent improvement loop: instrument → trace → evaluate → iterate → validate.",
          "category": "monitoring",
          "keywords": [],
          "author": {
            "name": "MLflow Team"
          },
          "version": "1.0.0",
          "license": null,
          "logoUrl": null,
          "darkLogoUrl": null,
          "homepage": "https://github.com/mlflow/skills",
          "sourceUrl": "https://github.com/mlflow/skills/tree/79d28d61f1edac723c2f2c80ab1795d24bca66c5/",
          "skills": [
            {
              "name": "agent-evaluation",
              "sourceUrl": "https://github.com/mlflow/skills/blob/79d28d61f1edac723c2f2c80ab1795d24bca66c5/agent-evaluation/SKILL.md"
            },
            {
              "name": "analyze-mlflow-chat-session",
              "sourceUrl": "https://github.com/mlflow/skills/blob/79d28d61f1edac723c2f2c80ab1795d24bca66c5/analyze-mlflow-chat-session/SKILL.md"
            },
            {
              "name": "analyze-mlflow-trace",
              "sourceUrl": "https://github.com/mlflow/skills/blob/79d28d61f1edac723c2f2c80ab1795d24bca66c5/analyze-mlflow-trace/SKILL.md"
            },
            {
              "name": "build-a-scorer",
              "sourceUrl": "https://github.com/mlflow/skills/blob/79d28d61f1edac723c2f2c80ab1795d24bca66c5/build-a-scorer/SKILL.md"
            },
            {
              "name": "fix-agent-issue",
              "sourceUrl": "https://github.com/mlflow/skills/blob/79d28d61f1edac723c2f2c80ab1795d24bca66c5/fix-agent-issue/SKILL.md"
            },
            {
              "name": "instrumenting-with-mlflow-tracing",
              "sourceUrl": "https://github.com/mlflow/skills/blob/79d28d61f1edac723c2f2c80ab1795d24bca66c5/instrumenting-with-mlflow-tracing/SKILL.md"
            },
            {
              "name": "mlflow-agent",
              "sourceUrl": "https://github.com/mlflow/skills/blob/79d28d61f1edac723c2f2c80ab1795d24bca66c5/mlflow-agent/SKILL.md"
            },
            {
              "name": "mlflow-onboarding",
              "sourceUrl": "https://github.com/mlflow/skills/blob/79d28d61f1edac723c2f2c80ab1795d24bca66c5/mlflow-onboarding/SKILL.md"
            },
            {
              "name": "querying-mlflow-metrics",
              "sourceUrl": "https://github.com/mlflow/skills/blob/79d28d61f1edac723c2f2c80ab1795d24bca66c5/querying-mlflow-metrics/SKILL.md"
            },
            {
              "name": "retrieving-mlflow-traces",
              "sourceUrl": "https://github.com/mlflow/skills/blob/79d28d61f1edac723c2f2c80ab1795d24bca66c5/retrieving-mlflow-traces/SKILL.md"
            },
            {
              "name": "sagemaker-mlflow",
              "sourceUrl": "https://github.com/mlflow/skills/blob/79d28d61f1edac723c2f2c80ab1795d24bca66c5/sagemaker-mlflow/SKILL.md"
            },
            {
              "name": "searching-mlflow-docs",
              "sourceUrl": "https://github.com/mlflow/skills/blob/79d28d61f1edac723c2f2c80ab1795d24bca66c5/searching-mlflow-docs/SKILL.md"
            }
          ],
          "mcpServers": [],
          "components": ["skills", "hooks"],
          "componentInspection": "repository",
          "inspectionError": null,
          "installation": "requires_adapter",
          "upstream": {
            "source": {
              "source": "url",
              "url": "https://github.com/mlflow/skills.git",
              "sha": "79d28d61f1edac723c2f2c80ab1795d24bca66c5"
            },
            "policy": null
          }
        },
        {
          "id": "anthropic:monday-crm",
          "name": "monday-crm",
          "displayName": "monday-crm",
          "description": "Run your sales pipeline in monday CRM from plain language. Start the day with a ranked deal briefing, build a forecast, turn meeting notes into deal updates, set up a CRM workspace from scratch, keep your data clean, manage sequences end-to-end, log calls and meetings to timelines, analyze team activity and rep performance, and set up automations — every result written straight back into monday. Built on the official monday MCP connector.",
          "longDescription": "Run your sales pipeline in monday CRM from plain language. Start the day with a ranked deal briefing, build a forecast, turn meeting notes into deal updates, set up a CRM workspace from scratch, keep your data clean, manage sequences end-to-end, log calls and meetings to timelines, analyze team activity and rep performance, and set up automations — every result written straight back into monday. Built on the official monday MCP connector.",
          "category": "productivity",
          "keywords": [
            "monday",
            "monday-crm",
            "crm",
            "sales",
            "pipeline",
            "forecast",
            "daily-briefing",
            "meeting-to-deal",
            "data-cleanup",
            "workspace-builder",
            "sequence",
            "automation",
            "activity",
            "timeline",
            "activity-insights"
          ],
          "author": {
            "name": "monday.com",
            "url": "https://monday.com",
            "email": "support@monday.com"
          },
          "version": "0.5.0",
          "license": "MIT",
          "logoUrl": null,
          "darkLogoUrl": null,
          "homepage": "https://github.com/mondaycom/mcp/tree/master/plugins/monday-crm",
          "sourceUrl": "https://github.com/mondaycom/mcp/tree/5eb0835e921de42ba603d7a8315ab4a2575a46b2/plugins/monday-crm",
          "skills": [
            {
              "name": "activity-insights",
              "sourceUrl": "https://github.com/mondaycom/mcp/blob/5eb0835e921de42ba603d7a8315ab4a2575a46b2/plugins/monday-crm/skills/activity-insights/SKILL.md"
            },
            {
              "name": "automate-crm",
              "sourceUrl": "https://github.com/mondaycom/mcp/blob/5eb0835e921de42ba603d7a8315ab4a2575a46b2/plugins/monday-crm/skills/automate-crm/SKILL.md"
            },
            {
              "name": "daily-briefing",
              "sourceUrl": "https://github.com/mondaycom/mcp/blob/5eb0835e921de42ba603d7a8315ab4a2575a46b2/plugins/monday-crm/skills/daily-briefing/SKILL.md"
            },
            {
              "name": "data-cleanup",
              "sourceUrl": "https://github.com/mondaycom/mcp/blob/5eb0835e921de42ba603d7a8315ab4a2575a46b2/plugins/monday-crm/skills/data-cleanup/SKILL.md"
            },
            {
              "name": "forecast",
              "sourceUrl": "https://github.com/mondaycom/mcp/blob/5eb0835e921de42ba603d7a8315ab4a2575a46b2/plugins/monday-crm/skills/forecast/SKILL.md"
            },
            {
              "name": "log-activity",
              "sourceUrl": "https://github.com/mondaycom/mcp/blob/5eb0835e921de42ba603d7a8315ab4a2575a46b2/plugins/monday-crm/skills/log-activity/SKILL.md"
            },
            {
              "name": "meeting-to-deal",
              "sourceUrl": "https://github.com/mondaycom/mcp/blob/5eb0835e921de42ba603d7a8315ab4a2575a46b2/plugins/monday-crm/skills/meeting-to-deal/SKILL.md"
            },
            {
              "name": "run-sequence",
              "sourceUrl": "https://github.com/mondaycom/mcp/blob/5eb0835e921de42ba603d7a8315ab4a2575a46b2/plugins/monday-crm/skills/run-sequence/SKILL.md"
            },
            {
              "name": "workspace-builder",
              "sourceUrl": "https://github.com/mondaycom/mcp/blob/5eb0835e921de42ba603d7a8315ab4a2575a46b2/plugins/monday-crm/skills/workspace-builder/SKILL.md"
            }
          ],
          "mcpServers": [
            {
              "requiresConfiguration": false,
              "name": "monday",
              "transport": "http",
              "endpoint": "https://mcp.monday.com/mcp"
            }
          ],
          "components": ["skills", "mcp"],
          "componentInspection": "repository",
          "inspectionError": null,
          "installation": "requires_adapter",
          "upstream": {
            "source": {
              "source": "git-subdir",
              "url": "https://github.com/mondaycom/mcp.git",
              "path": "plugins/monday-crm",
              "ref": "master",
              "sha": "5eb0835e921de42ba603d7a8315ab4a2575a46b2"
            },
            "policy": null
          }
        },
        {
          "id": "anthropic:mongodb",
          "name": "mongodb",
          "displayName": "mongodb",
          "description": "Connect to any MongoDB deployment (Community, Enterprise Advanced, local dev container via Atlas CLI or Atlas clusters) through a self-managed MongoDB MCP Server using your connection string. Explore data, manage collections, optimize queries, and generate reliable code with MongoDB best practices.",
          "longDescription": "Connect to any MongoDB deployment (Community, Enterprise Advanced, local dev container via Atlas CLI or Atlas clusters) through a self-managed MongoDB MCP Server using your connection string. Explore data, manage collections, optimize queries, and generate reliable code with MongoDB best practices.",
          "category": "database",
          "keywords": ["mongodb", "database", "mcp", "vector-search"],
          "author": {
            "name": "MongoDB",
            "email": "agent-plugins@mongodb.com",
            "url": "https://www.mongodb.com"
          },
          "version": "1.2.1",
          "license": "Apache-2.0",
          "logoUrl": null,
          "darkLogoUrl": null,
          "homepage": "https://www.mongodb.com/docs/mcp-server/get-started/",
          "sourceUrl": "https://github.com/mongodb/agent-skills/tree/8ada610346e678b8dc9f866e8166092840c6eb2f/plugins/mongodb",
          "skills": [
            {
              "name": "mongodb-atlas-stream-processing",
              "sourceUrl": "https://github.com/mongodb/agent-skills/blob/8ada610346e678b8dc9f866e8166092840c6eb2f/plugins/mongodb/.agy-plugin/skills/mongodb-atlas-stream-processing/SKILL.md"
            },
            {
              "name": "mongodb-connection",
              "sourceUrl": "https://github.com/mongodb/agent-skills/blob/8ada610346e678b8dc9f866e8166092840c6eb2f/plugins/mongodb/.agy-plugin/skills/mongodb-connection/SKILL.md"
            },
            {
              "name": "mongodb-mcp-setup",
              "sourceUrl": "https://github.com/mongodb/agent-skills/blob/8ada610346e678b8dc9f866e8166092840c6eb2f/plugins/mongodb/.agy-plugin/skills/mongodb-mcp-setup/SKILL.md"
            },
            {
              "name": "mongodb-natural-language-querying",
              "sourceUrl": "https://github.com/mongodb/agent-skills/blob/8ada610346e678b8dc9f866e8166092840c6eb2f/plugins/mongodb/.agy-plugin/skills/mongodb-natural-language-querying/SKILL.md"
            },
            {
              "name": "mongodb-query-optimizer",
              "sourceUrl": "https://github.com/mongodb/agent-skills/blob/8ada610346e678b8dc9f866e8166092840c6eb2f/plugins/mongodb/.agy-plugin/skills/mongodb-query-optimizer/SKILL.md"
            },
            {
              "name": "mongodb-schema-design",
              "sourceUrl": "https://github.com/mongodb/agent-skills/blob/8ada610346e678b8dc9f866e8166092840c6eb2f/plugins/mongodb/.agy-plugin/skills/mongodb-schema-design/SKILL.md"
            },
            {
              "name": "mongodb-search-and-ai",
              "sourceUrl": "https://github.com/mongodb/agent-skills/blob/8ada610346e678b8dc9f866e8166092840c6eb2f/plugins/mongodb/.agy-plugin/skills/mongodb-search-and-ai/SKILL.md"
            },
            {
              "name": "mongodb-atlas-stream-processing",
              "sourceUrl": "https://github.com/mongodb/agent-skills/blob/8ada610346e678b8dc9f866e8166092840c6eb2f/plugins/mongodb/skills/mongodb-atlas-stream-processing/SKILL.md"
            },
            {
              "name": "mongodb-connection",
              "sourceUrl": "https://github.com/mongodb/agent-skills/blob/8ada610346e678b8dc9f866e8166092840c6eb2f/plugins/mongodb/skills/mongodb-connection/SKILL.md"
            },
            {
              "name": "mongodb-mcp-setup",
              "sourceUrl": "https://github.com/mongodb/agent-skills/blob/8ada610346e678b8dc9f866e8166092840c6eb2f/plugins/mongodb/skills/mongodb-mcp-setup/SKILL.md"
            },
            {
              "name": "mongodb-natural-language-querying",
              "sourceUrl": "https://github.com/mongodb/agent-skills/blob/8ada610346e678b8dc9f866e8166092840c6eb2f/plugins/mongodb/skills/mongodb-natural-language-querying/SKILL.md"
            },
            {
              "name": "mongodb-query-optimizer",
              "sourceUrl": "https://github.com/mongodb/agent-skills/blob/8ada610346e678b8dc9f866e8166092840c6eb2f/plugins/mongodb/skills/mongodb-query-optimizer/SKILL.md"
            },
            {
              "name": "mongodb-schema-design",
              "sourceUrl": "https://github.com/mongodb/agent-skills/blob/8ada610346e678b8dc9f866e8166092840c6eb2f/plugins/mongodb/skills/mongodb-schema-design/SKILL.md"
            },
            {
              "name": "mongodb-search-and-ai",
              "sourceUrl": "https://github.com/mongodb/agent-skills/blob/8ada610346e678b8dc9f866e8166092840c6eb2f/plugins/mongodb/skills/mongodb-search-and-ai/SKILL.md"
            }
          ],
          "mcpServers": [],
          "components": ["skills", "mcp"],
          "componentInspection": "repository",
          "inspectionError": null,
          "installation": "requires_adapter",
          "upstream": {
            "source": {
              "source": "git-subdir",
              "url": "https://github.com/mongodb/agent-skills.git",
              "path": "plugins/mongodb",
              "ref": "main",
              "sha": "8ada610346e678b8dc9f866e8166092840c6eb2f"
            },
            "policy": null
          }
        },
        {
          "id": "anthropic:mongodb-atlas",
          "name": "mongodb-atlas",
          "displayName": "mongodb-atlas",
          "description": "Connect to MongoDB Atlas clusters only through the Atlas Managed MCP Server. Sign in with your Atlas account to explore data, manage collections, optimize queries, generate reliable code with MongoDB best practices, and manage Atlas resources such as clusters, projects, database users, and network access.\n\nIf you are running a different MongoDB deployment or want to run a local MongoDB MCP Server, install the MongoDB (Self-Managed MCP) plugin instead.",
          "longDescription": "Connect to MongoDB Atlas clusters only through the Atlas Managed MCP Server. Sign in with your Atlas account to explore data, manage collections, optimize queries, generate reliable code with MongoDB best practices, and manage Atlas resources such as clusters, projects, database users, and network access.\n\nIf you are running a different MongoDB deployment or want to run a local MongoDB MCP Server, install the MongoDB (Self-Managed MCP) plugin instead.",
          "category": "database",
          "keywords": ["mongodb", "atlas", "database", "mcp", "vector-search"],
          "author": {
            "name": "MongoDB",
            "email": "agent-plugins@mongodb.com",
            "url": "https://www.mongodb.com"
          },
          "version": "1.2.1",
          "license": "Apache-2.0",
          "logoUrl": null,
          "darkLogoUrl": null,
          "homepage": "https://www.mongodb.com/docs/mcp-server/get-started/",
          "sourceUrl": "https://github.com/mongodb/agent-skills/tree/8ada610346e678b8dc9f866e8166092840c6eb2f/plugins/mongodb-atlas",
          "skills": [
            {
              "name": "mongodb-atlas-stream-processing",
              "sourceUrl": "https://github.com/mongodb/agent-skills/blob/8ada610346e678b8dc9f866e8166092840c6eb2f/plugins/mongodb-atlas/.agy-plugin/skills/mongodb-atlas-stream-processing/SKILL.md"
            },
            {
              "name": "mongodb-connection",
              "sourceUrl": "https://github.com/mongodb/agent-skills/blob/8ada610346e678b8dc9f866e8166092840c6eb2f/plugins/mongodb-atlas/.agy-plugin/skills/mongodb-connection/SKILL.md"
            },
            {
              "name": "mongodb-natural-language-querying",
              "sourceUrl": "https://github.com/mongodb/agent-skills/blob/8ada610346e678b8dc9f866e8166092840c6eb2f/plugins/mongodb-atlas/.agy-plugin/skills/mongodb-natural-language-querying/SKILL.md"
            },
            {
              "name": "mongodb-query-optimizer",
              "sourceUrl": "https://github.com/mongodb/agent-skills/blob/8ada610346e678b8dc9f866e8166092840c6eb2f/plugins/mongodb-atlas/.agy-plugin/skills/mongodb-query-optimizer/SKILL.md"
            },
            {
              "name": "mongodb-schema-design",
              "sourceUrl": "https://github.com/mongodb/agent-skills/blob/8ada610346e678b8dc9f866e8166092840c6eb2f/plugins/mongodb-atlas/.agy-plugin/skills/mongodb-schema-design/SKILL.md"
            },
            {
              "name": "mongodb-search-and-ai",
              "sourceUrl": "https://github.com/mongodb/agent-skills/blob/8ada610346e678b8dc9f866e8166092840c6eb2f/plugins/mongodb-atlas/.agy-plugin/skills/mongodb-search-and-ai/SKILL.md"
            },
            {
              "name": "mongodb-atlas-stream-processing",
              "sourceUrl": "https://github.com/mongodb/agent-skills/blob/8ada610346e678b8dc9f866e8166092840c6eb2f/plugins/mongodb-atlas/skills/mongodb-atlas-stream-processing/SKILL.md"
            },
            {
              "name": "mongodb-connection",
              "sourceUrl": "https://github.com/mongodb/agent-skills/blob/8ada610346e678b8dc9f866e8166092840c6eb2f/plugins/mongodb-atlas/skills/mongodb-connection/SKILL.md"
            },
            {
              "name": "mongodb-natural-language-querying",
              "sourceUrl": "https://github.com/mongodb/agent-skills/blob/8ada610346e678b8dc9f866e8166092840c6eb2f/plugins/mongodb-atlas/skills/mongodb-natural-language-querying/SKILL.md"
            },
            {
              "name": "mongodb-query-optimizer",
              "sourceUrl": "https://github.com/mongodb/agent-skills/blob/8ada610346e678b8dc9f866e8166092840c6eb2f/plugins/mongodb-atlas/skills/mongodb-query-optimizer/SKILL.md"
            },
            {
              "name": "mongodb-schema-design",
              "sourceUrl": "https://github.com/mongodb/agent-skills/blob/8ada610346e678b8dc9f866e8166092840c6eb2f/plugins/mongodb-atlas/skills/mongodb-schema-design/SKILL.md"
            },
            {
              "name": "mongodb-search-and-ai",
              "sourceUrl": "https://github.com/mongodb/agent-skills/blob/8ada610346e678b8dc9f866e8166092840c6eb2f/plugins/mongodb-atlas/skills/mongodb-search-and-ai/SKILL.md"
            }
          ],
          "mcpServers": [
            {
              "requiresConfiguration": false,
              "name": "mongodb-atlas",
              "transport": "http",
              "endpoint": "https://mcp.mongodb.com/"
            }
          ],
          "components": ["skills", "mcp", "apps"],
          "componentInspection": "repository",
          "inspectionError": null,
          "installation": "requires_adapter",
          "upstream": {
            "source": {
              "source": "git-subdir",
              "url": "https://github.com/mongodb/agent-skills.git",
              "path": "plugins/mongodb-atlas",
              "ref": "main",
              "sha": "8ada610346e678b8dc9f866e8166092840c6eb2f"
            },
            "policy": null
          }
        },
        {
          "id": "anthropic:neon",
          "name": "neon",
          "displayName": "neon",
          "description": "Manage your Neon backend with the Neon agent skills and the Neon MCP Server: Lakebase Postgres, branching, Object Storage, Functions, and the AI Gateway",
          "longDescription": "Manage your Neon backend with the Neon agent skills and the Neon MCP Server: Lakebase Postgres, branching, Object Storage, Functions, and the AI Gateway",
          "category": "database",
          "keywords": ["neon", "lakebase", "postgres", "serverless", "database", "mcp"],
          "author": {
            "name": "Neon",
            "url": "https://neon.com"
          },
          "version": "1.2.0",
          "license": "Apache-2.0",
          "logoUrl": null,
          "darkLogoUrl": null,
          "homepage": "https://neon.com",
          "sourceUrl": "https://github.com/neondatabase/agent-skills/tree/2e0da3a1653bcdd227565ac14bb3e9e453a8b854/plugins/neon-postgres",
          "skills": [
            {
              "name": "neon-ai-gateway",
              "sourceUrl": "https://github.com/neondatabase/agent-skills/blob/2e0da3a1653bcdd227565ac14bb3e9e453a8b854/plugins/neon-postgres/skills/neon-ai-gateway/SKILL.md"
            },
            {
              "name": "neon-functions",
              "sourceUrl": "https://github.com/neondatabase/agent-skills/blob/2e0da3a1653bcdd227565ac14bb3e9e453a8b854/plugins/neon-postgres/skills/neon-functions/SKILL.md"
            },
            {
              "name": "neon-object-storage",
              "sourceUrl": "https://github.com/neondatabase/agent-skills/blob/2e0da3a1653bcdd227565ac14bb3e9e453a8b854/plugins/neon-postgres/skills/neon-object-storage/SKILL.md"
            },
            {
              "name": "neon-postgres-branches",
              "sourceUrl": "https://github.com/neondatabase/agent-skills/blob/2e0da3a1653bcdd227565ac14bb3e9e453a8b854/plugins/neon-postgres/skills/neon-postgres-branches/SKILL.md"
            },
            {
              "name": "neon-postgres-egress-optimizer",
              "sourceUrl": "https://github.com/neondatabase/agent-skills/blob/2e0da3a1653bcdd227565ac14bb3e9e453a8b854/plugins/neon-postgres/skills/neon-postgres-egress-optimizer/SKILL.md"
            },
            {
              "name": "neon-postgres",
              "sourceUrl": "https://github.com/neondatabase/agent-skills/blob/2e0da3a1653bcdd227565ac14bb3e9e453a8b854/plugins/neon-postgres/skills/neon-postgres/SKILL.md"
            },
            {
              "name": "neon",
              "sourceUrl": "https://github.com/neondatabase/agent-skills/blob/2e0da3a1653bcdd227565ac14bb3e9e453a8b854/plugins/neon-postgres/skills/neon/SKILL.md"
            }
          ],
          "mcpServers": [],
          "components": ["skills", "mcp"],
          "componentInspection": "repository",
          "inspectionError": null,
          "installation": "requires_adapter",
          "upstream": {
            "source": {
              "source": "git-subdir",
              "url": "https://github.com/neondatabase/agent-skills.git",
              "path": "plugins/neon-postgres",
              "ref": "main",
              "sha": "2e0da3a1653bcdd227565ac14bb3e9e453a8b854"
            },
            "policy": null
          }
        },
        {
          "id": "anthropic:netlify-skills",
          "name": "netlify-skills",
          "displayName": "netlify-skills",
          "description": "Netlify platform skills for Claude Code",
          "longDescription": "Netlify platform skills for Claude Code",
          "category": "development",
          "keywords": [],
          "author": {
            "name": "Netlify"
          },
          "version": "1.3.1",
          "license": null,
          "logoUrl": null,
          "darkLogoUrl": null,
          "homepage": "https://github.com/netlify/context-and-tools",
          "sourceUrl": "https://github.com/netlify/context-and-tools/tree/b79c1e58e82ecb319f1f213727f65ea10a5a69a5/",
          "skills": [
            {
              "name": "skill-creator",
              "sourceUrl": "https://github.com/netlify/context-and-tools/blob/b79c1e58e82ecb319f1f213727f65ea10a5a69a5/.claude/skills/skill-creator/SKILL.md"
            },
            {
              "name": "netlify-access-control",
              "sourceUrl": "https://github.com/netlify/context-and-tools/blob/b79c1e58e82ecb319f1f213727f65ea10a5a69a5/agent-plugin/skills/netlify-access-control/SKILL.md"
            },
            {
              "name": "netlify-agent-runner",
              "sourceUrl": "https://github.com/netlify/context-and-tools/blob/b79c1e58e82ecb319f1f213727f65ea10a5a69a5/agent-plugin/skills/netlify-agent-runner/SKILL.md"
            },
            {
              "name": "netlify-ai-gateway",
              "sourceUrl": "https://github.com/netlify/context-and-tools/blob/b79c1e58e82ecb319f1f213727f65ea10a5a69a5/agent-plugin/skills/netlify-ai-gateway/SKILL.md"
            },
            {
              "name": "netlify-blobs",
              "sourceUrl": "https://github.com/netlify/context-and-tools/blob/b79c1e58e82ecb319f1f213727f65ea10a5a69a5/agent-plugin/skills/netlify-blobs/SKILL.md"
            },
            {
              "name": "netlify-caching",
              "sourceUrl": "https://github.com/netlify/context-and-tools/blob/b79c1e58e82ecb319f1f213727f65ea10a5a69a5/agent-plugin/skills/netlify-caching/SKILL.md"
            },
            {
              "name": "netlify-config",
              "sourceUrl": "https://github.com/netlify/context-and-tools/blob/b79c1e58e82ecb319f1f213727f65ea10a5a69a5/agent-plugin/skills/netlify-config/SKILL.md"
            },
            {
              "name": "netlify-database",
              "sourceUrl": "https://github.com/netlify/context-and-tools/blob/b79c1e58e82ecb319f1f213727f65ea10a5a69a5/agent-plugin/skills/netlify-database/SKILL.md"
            },
            {
              "name": "netlify-deploy",
              "sourceUrl": "https://github.com/netlify/context-and-tools/blob/b79c1e58e82ecb319f1f213727f65ea10a5a69a5/agent-plugin/skills/netlify-deploy/SKILL.md"
            },
            {
              "name": "netlify-edge-functions",
              "sourceUrl": "https://github.com/netlify/context-and-tools/blob/b79c1e58e82ecb319f1f213727f65ea10a5a69a5/agent-plugin/skills/netlify-edge-functions/SKILL.md"
            },
            {
              "name": "netlify-forms",
              "sourceUrl": "https://github.com/netlify/context-and-tools/blob/b79c1e58e82ecb319f1f213727f65ea10a5a69a5/agent-plugin/skills/netlify-forms/SKILL.md"
            },
            {
              "name": "netlify-frameworks",
              "sourceUrl": "https://github.com/netlify/context-and-tools/blob/b79c1e58e82ecb319f1f213727f65ea10a5a69a5/agent-plugin/skills/netlify-frameworks/SKILL.md"
            },
            {
              "name": "netlify-functions",
              "sourceUrl": "https://github.com/netlify/context-and-tools/blob/b79c1e58e82ecb319f1f213727f65ea10a5a69a5/agent-plugin/skills/netlify-functions/SKILL.md"
            },
            {
              "name": "netlify-identity",
              "sourceUrl": "https://github.com/netlify/context-and-tools/blob/b79c1e58e82ecb319f1f213727f65ea10a5a69a5/agent-plugin/skills/netlify-identity/SKILL.md"
            },
            {
              "name": "netlify-image-cdn",
              "sourceUrl": "https://github.com/netlify/context-and-tools/blob/b79c1e58e82ecb319f1f213727f65ea10a5a69a5/agent-plugin/skills/netlify-image-cdn/SKILL.md"
            },
            {
              "name": "netlify-mcp-servers",
              "sourceUrl": "https://github.com/netlify/context-and-tools/blob/b79c1e58e82ecb319f1f213727f65ea10a5a69a5/agent-plugin/skills/netlify-mcp-servers/SKILL.md"
            },
            {
              "name": "netlify-access-control",
              "sourceUrl": "https://github.com/netlify/context-and-tools/blob/b79c1e58e82ecb319f1f213727f65ea10a5a69a5/codex/skills/netlify-access-control/SKILL.md"
            },
            {
              "name": "netlify-agent-runner",
              "sourceUrl": "https://github.com/netlify/context-and-tools/blob/b79c1e58e82ecb319f1f213727f65ea10a5a69a5/codex/skills/netlify-agent-runner/SKILL.md"
            },
            {
              "name": "netlify-ai-gateway",
              "sourceUrl": "https://github.com/netlify/context-and-tools/blob/b79c1e58e82ecb319f1f213727f65ea10a5a69a5/codex/skills/netlify-ai-gateway/SKILL.md"
            },
            {
              "name": "netlify-blobs",
              "sourceUrl": "https://github.com/netlify/context-and-tools/blob/b79c1e58e82ecb319f1f213727f65ea10a5a69a5/codex/skills/netlify-blobs/SKILL.md"
            },
            {
              "name": "netlify-caching",
              "sourceUrl": "https://github.com/netlify/context-and-tools/blob/b79c1e58e82ecb319f1f213727f65ea10a5a69a5/codex/skills/netlify-caching/SKILL.md"
            },
            {
              "name": "netlify-config",
              "sourceUrl": "https://github.com/netlify/context-and-tools/blob/b79c1e58e82ecb319f1f213727f65ea10a5a69a5/codex/skills/netlify-config/SKILL.md"
            },
            {
              "name": "netlify-database",
              "sourceUrl": "https://github.com/netlify/context-and-tools/blob/b79c1e58e82ecb319f1f213727f65ea10a5a69a5/codex/skills/netlify-database/SKILL.md"
            },
            {
              "name": "netlify-deploy",
              "sourceUrl": "https://github.com/netlify/context-and-tools/blob/b79c1e58e82ecb319f1f213727f65ea10a5a69a5/codex/skills/netlify-deploy/SKILL.md"
            },
            {
              "name": "netlify-edge-functions",
              "sourceUrl": "https://github.com/netlify/context-and-tools/blob/b79c1e58e82ecb319f1f213727f65ea10a5a69a5/codex/skills/netlify-edge-functions/SKILL.md"
            },
            {
              "name": "netlify-forms",
              "sourceUrl": "https://github.com/netlify/context-and-tools/blob/b79c1e58e82ecb319f1f213727f65ea10a5a69a5/codex/skills/netlify-forms/SKILL.md"
            },
            {
              "name": "netlify-frameworks",
              "sourceUrl": "https://github.com/netlify/context-and-tools/blob/b79c1e58e82ecb319f1f213727f65ea10a5a69a5/codex/skills/netlify-frameworks/SKILL.md"
            },
            {
              "name": "netlify-functions",
              "sourceUrl": "https://github.com/netlify/context-and-tools/blob/b79c1e58e82ecb319f1f213727f65ea10a5a69a5/codex/skills/netlify-functions/SKILL.md"
            },
            {
              "name": "netlify-identity",
              "sourceUrl": "https://github.com/netlify/context-and-tools/blob/b79c1e58e82ecb319f1f213727f65ea10a5a69a5/codex/skills/netlify-identity/SKILL.md"
            },
            {
              "name": "netlify-image-cdn",
              "sourceUrl": "https://github.com/netlify/context-and-tools/blob/b79c1e58e82ecb319f1f213727f65ea10a5a69a5/codex/skills/netlify-image-cdn/SKILL.md"
            },
            {
              "name": "netlify-mcp-servers",
              "sourceUrl": "https://github.com/netlify/context-and-tools/blob/b79c1e58e82ecb319f1f213727f65ea10a5a69a5/codex/skills/netlify-mcp-servers/SKILL.md"
            },
            {
              "name": "netlify-access-control",
              "sourceUrl": "https://github.com/netlify/context-and-tools/blob/b79c1e58e82ecb319f1f213727f65ea10a5a69a5/skills/netlify-access-control/SKILL.md"
            },
            {
              "name": "netlify-agent-runner",
              "sourceUrl": "https://github.com/netlify/context-and-tools/blob/b79c1e58e82ecb319f1f213727f65ea10a5a69a5/skills/netlify-agent-runner/SKILL.md"
            },
            {
              "name": "netlify-ai-gateway",
              "sourceUrl": "https://github.com/netlify/context-and-tools/blob/b79c1e58e82ecb319f1f213727f65ea10a5a69a5/skills/netlify-ai-gateway/SKILL.md"
            },
            {
              "name": "netlify-blobs",
              "sourceUrl": "https://github.com/netlify/context-and-tools/blob/b79c1e58e82ecb319f1f213727f65ea10a5a69a5/skills/netlify-blobs/SKILL.md"
            },
            {
              "name": "netlify-caching",
              "sourceUrl": "https://github.com/netlify/context-and-tools/blob/b79c1e58e82ecb319f1f213727f65ea10a5a69a5/skills/netlify-caching/SKILL.md"
            },
            {
              "name": "netlify-config",
              "sourceUrl": "https://github.com/netlify/context-and-tools/blob/b79c1e58e82ecb319f1f213727f65ea10a5a69a5/skills/netlify-config/SKILL.md"
            },
            {
              "name": "netlify-database",
              "sourceUrl": "https://github.com/netlify/context-and-tools/blob/b79c1e58e82ecb319f1f213727f65ea10a5a69a5/skills/netlify-database/SKILL.md"
            },
            {
              "name": "netlify-deploy",
              "sourceUrl": "https://github.com/netlify/context-and-tools/blob/b79c1e58e82ecb319f1f213727f65ea10a5a69a5/skills/netlify-deploy/SKILL.md"
            },
            {
              "name": "netlify-edge-functions",
              "sourceUrl": "https://github.com/netlify/context-and-tools/blob/b79c1e58e82ecb319f1f213727f65ea10a5a69a5/skills/netlify-edge-functions/SKILL.md"
            },
            {
              "name": "netlify-forms",
              "sourceUrl": "https://github.com/netlify/context-and-tools/blob/b79c1e58e82ecb319f1f213727f65ea10a5a69a5/skills/netlify-forms/SKILL.md"
            },
            {
              "name": "netlify-frameworks",
              "sourceUrl": "https://github.com/netlify/context-and-tools/blob/b79c1e58e82ecb319f1f213727f65ea10a5a69a5/skills/netlify-frameworks/SKILL.md"
            },
            {
              "name": "netlify-functions",
              "sourceUrl": "https://github.com/netlify/context-and-tools/blob/b79c1e58e82ecb319f1f213727f65ea10a5a69a5/skills/netlify-functions/SKILL.md"
            },
            {
              "name": "netlify-identity",
              "sourceUrl": "https://github.com/netlify/context-and-tools/blob/b79c1e58e82ecb319f1f213727f65ea10a5a69a5/skills/netlify-identity/SKILL.md"
            },
            {
              "name": "netlify-image-cdn",
              "sourceUrl": "https://github.com/netlify/context-and-tools/blob/b79c1e58e82ecb319f1f213727f65ea10a5a69a5/skills/netlify-image-cdn/SKILL.md"
            },
            {
              "name": "netlify-mcp-servers",
              "sourceUrl": "https://github.com/netlify/context-and-tools/blob/b79c1e58e82ecb319f1f213727f65ea10a5a69a5/skills/netlify-mcp-servers/SKILL.md"
            }
          ],
          "mcpServers": [
            {
              "requiresConfiguration": false,
              "name": "netlify",
              "transport": "http",
              "endpoint": "https://netlify-mcp.netlify.app/mcp"
            }
          ],
          "components": ["skills", "mcp"],
          "componentInspection": "repository",
          "inspectionError": null,
          "installation": "requires_adapter",
          "upstream": {
            "source": {
              "source": "url",
              "url": "https://github.com/netlify/context-and-tools.git",
              "sha": "b79c1e58e82ecb319f1f213727f65ea10a5a69a5"
            },
            "policy": null
          }
        },
        {
          "id": "anthropic:netsuite-ai-companion",
          "name": "netsuite-ai-companion",
          "displayName": "netsuite-ai-companion",
          "description": "Guide AI assistants using NetSuite AI Connector.",
          "longDescription": "Guide AI assistants using NetSuite AI Connector.",
          "category": "productivity",
          "keywords": ["netsuite", "aiconnector", "mcp"],
          "author": {
            "name": "Oracle NetSuite",
            "url": "https://www.netsuite.com"
          },
          "version": "1.0.0",
          "license": "The Universal Permissive License (UPL), Version 1.0",
          "logoUrl": null,
          "darkLogoUrl": null,
          "homepage": "https://github.com/oracle/netsuite-suitecloud-sdk/tree/ai-plugins-dist/anthropic/netsuite-ai-companion",
          "sourceUrl": "https://github.com/oracle/netsuite-suitecloud-sdk/tree/23793a10a9bb557c684c5cb8a97f926eb3463f12/anthropic/netsuite-ai-companion",
          "skills": [
            {
              "name": "netsuite-ai-connector-instructions",
              "sourceUrl": "https://github.com/oracle/netsuite-suitecloud-sdk/blob/23793a10a9bb557c684c5cb8a97f926eb3463f12/anthropic/netsuite-ai-companion/skills/netsuite-ai-connector-instructions/SKILL.md"
            }
          ],
          "mcpServers": [],
          "components": ["skills"],
          "componentInspection": "repository",
          "inspectionError": null,
          "installation": "requires_adapter",
          "upstream": {
            "source": {
              "source": "git-subdir",
              "url": "https://github.com/oracle/netsuite-suitecloud-sdk.git",
              "path": "anthropic/netsuite-ai-companion",
              "ref": "ai-plugins-dist",
              "sha": "23793a10a9bb557c684c5cb8a97f926eb3463f12"
            },
            "policy": null
          }
        },
        {
          "id": "anthropic:netsuite-finance-analyst",
          "name": "netsuite-finance-analyst",
          "displayName": "netsuite-finance-analyst",
          "description": "Deliver Director-level finance analysis on live NetSuite data.",
          "longDescription": "Deliver Director-level finance analysis on live NetSuite data.",
          "category": "productivity",
          "keywords": ["netsuite", "finance", "mcp"],
          "author": {
            "name": "Oracle NetSuite",
            "url": "https://www.netsuite.com"
          },
          "version": "1.0.0",
          "license": "The Universal Permissive License (UPL), Version 1.0",
          "logoUrl": null,
          "darkLogoUrl": null,
          "homepage": "https://github.com/oracle/netsuite-suitecloud-sdk/tree/ai-plugins-dist/anthropic/netsuite-finance-analyst",
          "sourceUrl": "https://github.com/oracle/netsuite-suitecloud-sdk/tree/23793a10a9bb557c684c5cb8a97f926eb3463f12/anthropic/netsuite-finance-analyst",
          "skills": [
            {
              "name": "netsuite-finance-analyst",
              "sourceUrl": "https://github.com/oracle/netsuite-suitecloud-sdk/blob/23793a10a9bb557c684c5cb8a97f926eb3463f12/anthropic/netsuite-finance-analyst/skills/netsuite-finance-analyst/SKILL.md"
            }
          ],
          "mcpServers": [],
          "components": ["skills"],
          "componentInspection": "repository",
          "inspectionError": null,
          "installation": "requires_adapter",
          "upstream": {
            "source": {
              "source": "git-subdir",
              "url": "https://github.com/oracle/netsuite-suitecloud-sdk.git",
              "path": "anthropic/netsuite-finance-analyst",
              "ref": "ai-plugins-dist",
              "sha": "23793a10a9bb557c684c5cb8a97f926eb3463f12"
            },
            "policy": null
          }
        },
        {
          "id": "anthropic:netsuite-suitecloud",
          "name": "netsuite-suitecloud",
          "displayName": "netsuite-suitecloud",
          "description": "Develop NetSuite SuiteCloud solutions with SuiteScript, SDF, and best practices.",
          "longDescription": "Develop NetSuite SuiteCloud solutions with SuiteScript, SDF, and best practices.",
          "category": "development",
          "keywords": ["netsuite", "suitecloud", "suitescript", "sdf", "uif"],
          "author": {
            "name": "Oracle NetSuite",
            "url": "https://www.netsuite.com"
          },
          "version": "1.0.0",
          "license": "The Universal Permissive License (UPL), Version 1.0",
          "logoUrl": null,
          "darkLogoUrl": null,
          "homepage": "https://github.com/oracle/netsuite-suitecloud-sdk/tree/ai-plugins-dist/anthropic/netsuite-suitecloud",
          "sourceUrl": "https://github.com/oracle/netsuite-suitecloud-sdk/tree/23793a10a9bb557c684c5cb8a97f926eb3463f12/anthropic/netsuite-suitecloud",
          "skills": [
            {
              "name": "netsuite-owasp-secure-coding",
              "sourceUrl": "https://github.com/oracle/netsuite-suitecloud-sdk/blob/23793a10a9bb557c684c5cb8a97f926eb3463f12/anthropic/netsuite-suitecloud/skills/netsuite-owasp-secure-coding/SKILL.md"
            },
            {
              "name": "netsuite-sdf-project-documentation",
              "sourceUrl": "https://github.com/oracle/netsuite-suitecloud-sdk/blob/23793a10a9bb557c684c5cb8a97f926eb3463f12/anthropic/netsuite-suitecloud/skills/netsuite-sdf-project-documentation/SKILL.md"
            },
            {
              "name": "netsuite-sdf-roles-and-permissions",
              "sourceUrl": "https://github.com/oracle/netsuite-suitecloud-sdk/blob/23793a10a9bb557c684c5cb8a97f926eb3463f12/anthropic/netsuite-suitecloud/skills/netsuite-sdf-roles-and-permissions/SKILL.md"
            },
            {
              "name": "netsuite-sdf-safe-guide",
              "sourceUrl": "https://github.com/oracle/netsuite-suitecloud-sdk/blob/23793a10a9bb557c684c5cb8a97f926eb3463f12/anthropic/netsuite-suitecloud/skills/netsuite-sdf-safe-guide/SKILL.md"
            },
            {
              "name": "netsuite-suitescript-learning",
              "sourceUrl": "https://github.com/oracle/netsuite-suitecloud-sdk/blob/23793a10a9bb557c684c5cb8a97f926eb3463f12/anthropic/netsuite-suitecloud/skills/netsuite-suitescript-learning/SKILL.md"
            },
            {
              "name": "netsuite-suitescript-records-reference",
              "sourceUrl": "https://github.com/oracle/netsuite-suitecloud-sdk/blob/23793a10a9bb557c684c5cb8a97f926eb3463f12/anthropic/netsuite-suitecloud/skills/netsuite-suitescript-records-reference/SKILL.md"
            },
            {
              "name": "netsuite-suitescript-upgrade",
              "sourceUrl": "https://github.com/oracle/netsuite-suitecloud-sdk/blob/23793a10a9bb557c684c5cb8a97f926eb3463f12/anthropic/netsuite-suitecloud/skills/netsuite-suitescript-upgrade/SKILL.md"
            },
            {
              "name": "netsuite-uif-spa-reference",
              "sourceUrl": "https://github.com/oracle/netsuite-suitecloud-sdk/blob/23793a10a9bb557c684c5cb8a97f926eb3463f12/anthropic/netsuite-suitecloud/skills/netsuite-uif-spa-reference/SKILL.md"
            }
          ],
          "mcpServers": [],
          "components": ["skills"],
          "componentInspection": "repository",
          "inspectionError": null,
          "installation": "requires_adapter",
          "upstream": {
            "source": {
              "source": "git-subdir",
              "url": "https://github.com/oracle/netsuite-suitecloud-sdk.git",
              "path": "anthropic/netsuite-suitecloud",
              "ref": "ai-plugins-dist",
              "sha": "23793a10a9bb557c684c5cb8a97f926eb3463f12"
            },
            "policy": null
          }
        },
        {
          "id": "anthropic:newrelic",
          "name": "newrelic",
          "displayName": "newrelic",
          "description": "New Relic observability intelligence for Claude Code. Investigate APM performance, analyze cloud costs, debug Kubernetes, write NRQL queries, and respond to alerts — all from your terminal using New Relic telemetry data.",
          "longDescription": "New Relic observability intelligence for Claude Code. Investigate APM performance, analyze cloud costs, debug Kubernetes, write NRQL queries, and respond to alerts — all from your terminal using New Relic telemetry data.",
          "category": "monitoring",
          "keywords": [],
          "author": {
            "name": "New Relic",
            "url": "https://newrelic.com"
          },
          "version": "1.0.0",
          "license": "Apache-2.0",
          "logoUrl": null,
          "darkLogoUrl": null,
          "homepage": "https://newrelic.com/",
          "sourceUrl": "https://github.com/newrelic/claude-code-plugin/tree/f8e5f8b62139072a22153ec92de1c0cc1af2f56a/",
          "skills": [
            {
              "name": "apm",
              "sourceUrl": "https://github.com/newrelic/claude-code-plugin/blob/f8e5f8b62139072a22153ec92de1c0cc1af2f56a/skills/apm/SKILL.md"
            },
            {
              "name": "finops",
              "sourceUrl": "https://github.com/newrelic/claude-code-plugin/blob/f8e5f8b62139072a22153ec92de1c0cc1af2f56a/skills/finops/SKILL.md"
            },
            {
              "name": "kubernetes",
              "sourceUrl": "https://github.com/newrelic/claude-code-plugin/blob/f8e5f8b62139072a22153ec92de1c0cc1af2f56a/skills/kubernetes/SKILL.md"
            }
          ],
          "mcpServers": [
            {
              "requiresConfiguration": false,
              "name": "newrelic",
              "transport": "http",
              "endpoint": "https://mcp.newrelic.com/mcp/"
            }
          ],
          "components": ["skills", "mcp"],
          "componentInspection": "repository",
          "inspectionError": null,
          "installation": "requires_adapter",
          "upstream": {
            "source": {
              "source": "url",
              "url": "https://github.com/newrelic/claude-code-plugin.git",
              "sha": "f8e5f8b62139072a22153ec92de1c0cc1af2f56a"
            },
            "policy": null
          }
        },
        {
          "id": "anthropic:nightvision",
          "name": "nightvision",
          "displayName": "nightvision",
          "description": "Skills for working with NightVision, a DAST and API Discovery platform that finds exploitable vulnerabilities in web applications and REST APIs",
          "longDescription": "Skills for working with NightVision, a DAST and API Discovery platform that finds exploitable vulnerabilities in web applications and REST APIs",
          "category": null,
          "keywords": [
            "dast",
            "api-discovery",
            "security-scanning",
            "ci-cd",
            "openapi",
            "vulnerability-detection"
          ],
          "author": {
            "name": "NightVision Engineering",
            "email": "support@nightviz.ai",
            "url": "https://nightviz.ai"
          },
          "version": "1.1.0",
          "license": "Apache-2.0",
          "logoUrl": null,
          "darkLogoUrl": null,
          "homepage": "https://nightviz.ai",
          "sourceUrl": "https://github.com/nvsecurity/nightvision-skills/tree/957db6bb934839275c0f643042101bbb675ddbf7/",
          "skills": [
            {
              "name": "api-discovery",
              "sourceUrl": "https://github.com/nvsecurity/nightvision-skills/blob/957db6bb934839275c0f643042101bbb675ddbf7/skills/api-discovery/SKILL.md"
            },
            {
              "name": "app-security-scan",
              "sourceUrl": "https://github.com/nvsecurity/nightvision-skills/blob/957db6bb934839275c0f643042101bbb675ddbf7/skills/app-security-scan/SKILL.md"
            },
            {
              "name": "ci-cd-integration",
              "sourceUrl": "https://github.com/nvsecurity/nightvision-skills/blob/957db6bb934839275c0f643042101bbb675ddbf7/skills/ci-cd-integration/SKILL.md"
            },
            {
              "name": "scan-configuration",
              "sourceUrl": "https://github.com/nvsecurity/nightvision-skills/blob/957db6bb934839275c0f643042101bbb675ddbf7/skills/scan-configuration/SKILL.md"
            },
            {
              "name": "scan-triage",
              "sourceUrl": "https://github.com/nvsecurity/nightvision-skills/blob/957db6bb934839275c0f643042101bbb675ddbf7/skills/scan-triage/SKILL.md"
            }
          ],
          "mcpServers": [],
          "components": ["skills"],
          "componentInspection": "repository",
          "inspectionError": null,
          "installation": "requires_adapter",
          "upstream": {
            "source": {
              "source": "url",
              "url": "https://github.com/nvsecurity/nightvision-skills.git",
              "sha": "957db6bb934839275c0f643042101bbb675ddbf7"
            },
            "policy": null
          }
        },
        {
          "id": "anthropic:nimble",
          "name": "nimble",
          "displayName": "nimble",
          "description": "Live web search for AI agents. Find current pages, read any URL, and run research agents that work across many sources and return findings with citations. Includes reusable Extraction Templates for consistently shaped records from known sites, and Web Search Agents for research, enrichment, and dataset building.",
          "longDescription": "Live web search for AI agents. Find current pages, read any URL, and run research agents that work across many sources and return findings with citations. Includes reusable Extraction Templates for consistently shaped records from known sites, and Web Search Agents for research, enrichment, and dataset building.",
          "category": null,
          "keywords": [
            "nimble",
            "web-extraction",
            "web-search",
            "web-crawl",
            "web-map",
            "agents",
            "mcp",
            "cli",
            "data-extraction",
            "structured-data",
            "competitor-intelligence",
            "meeting-prep",
            "company-research",
            "business-intelligence"
          ],
          "author": {
            "name": "Nimble",
            "email": "support@nimbleway.com",
            "url": "https://www.nimbleway.com"
          },
          "version": "1.7.0",
          "license": "MIT",
          "logoUrl": null,
          "darkLogoUrl": null,
          "homepage": "https://www.nimbleway.com",
          "sourceUrl": "https://github.com/Nimbleway/agent-skills/tree/2890fdf94f0adfae79bf05b4de3c91667701bafb/",
          "skills": [
            {
              "name": "brand-mention-monitor",
              "sourceUrl": "https://github.com/Nimbleway/agent-skills/blob/2890fdf94f0adfae79bf05b4de3c91667701bafb/skills/brand-mention-monitor/SKILL.md"
            },
            {
              "name": "company-deep-dive",
              "sourceUrl": "https://github.com/Nimbleway/agent-skills/blob/2890fdf94f0adfae79bf05b4de3c91667701bafb/skills/company-deep-dive/SKILL.md"
            },
            {
              "name": "competitor-intel",
              "sourceUrl": "https://github.com/Nimbleway/agent-skills/blob/2890fdf94f0adfae79bf05b4de3c91667701bafb/skills/competitor-intel/SKILL.md"
            },
            {
              "name": "competitor-positioning",
              "sourceUrl": "https://github.com/Nimbleway/agent-skills/blob/2890fdf94f0adfae79bf05b4de3c91667701bafb/skills/competitor-positioning/SKILL.md"
            },
            {
              "name": "healthcare-providers-enrich",
              "sourceUrl": "https://github.com/Nimbleway/agent-skills/blob/2890fdf94f0adfae79bf05b4de3c91667701bafb/skills/healthcare-providers-enrich/SKILL.md"
            },
            {
              "name": "healthcare-providers-extract",
              "sourceUrl": "https://github.com/Nimbleway/agent-skills/blob/2890fdf94f0adfae79bf05b4de3c91667701bafb/skills/healthcare-providers-extract/SKILL.md"
            },
            {
              "name": "healthcare-providers-verify",
              "sourceUrl": "https://github.com/Nimbleway/agent-skills/blob/2890fdf94f0adfae79bf05b4de3c91667701bafb/skills/healthcare-providers-verify/SKILL.md"
            },
            {
              "name": "launch-monitor",
              "sourceUrl": "https://github.com/Nimbleway/agent-skills/blob/2890fdf94f0adfae79bf05b4de3c91667701bafb/skills/launch-monitor/SKILL.md"
            },
            {
              "name": "local-places",
              "sourceUrl": "https://github.com/Nimbleway/agent-skills/blob/2890fdf94f0adfae79bf05b4de3c91667701bafb/skills/local-places/SKILL.md"
            },
            {
              "name": "market-finder",
              "sourceUrl": "https://github.com/Nimbleway/agent-skills/blob/2890fdf94f0adfae79bf05b4de3c91667701bafb/skills/market-finder/SKILL.md"
            },
            {
              "name": "meeting-prep",
              "sourceUrl": "https://github.com/Nimbleway/agent-skills/blob/2890fdf94f0adfae79bf05b4de3c91667701bafb/skills/meeting-prep/SKILL.md"
            },
            {
              "name": "nimble-databricks-data-products",
              "sourceUrl": "https://github.com/Nimbleway/agent-skills/blob/2890fdf94f0adfae79bf05b4de3c91667701bafb/skills/nimble-databricks-data-products/SKILL.md"
            },
            {
              "name": "nimble-web-expert",
              "sourceUrl": "https://github.com/Nimbleway/agent-skills/blob/2890fdf94f0adfae79bf05b4de3c91667701bafb/skills/nimble-web-expert/SKILL.md"
            },
            {
              "name": "seo-intel",
              "sourceUrl": "https://github.com/Nimbleway/agent-skills/blob/2890fdf94f0adfae79bf05b4de3c91667701bafb/skills/seo-intel/SKILL.md"
            },
            {
              "name": "talent-sourcing",
              "sourceUrl": "https://github.com/Nimbleway/agent-skills/blob/2890fdf94f0adfae79bf05b4de3c91667701bafb/skills/talent-sourcing/SKILL.md"
            }
          ],
          "mcpServers": [
            {
              "requiresConfiguration": false,
              "name": "nimble",
              "transport": "http",
              "endpoint": "https://mcp.nimbleway.com/mcp"
            }
          ],
          "components": ["skills", "mcp", "agents", "commands"],
          "componentInspection": "repository",
          "inspectionError": null,
          "installation": "requires_adapter",
          "upstream": {
            "source": {
              "source": "url",
              "url": "https://github.com/Nimbleway/agent-skills.git",
              "sha": "2890fdf94f0adfae79bf05b4de3c91667701bafb"
            },
            "policy": null
          }
        },
        {
          "id": "anthropic:noibu",
          "name": "noibu",
          "displayName": "noibu",
          "description": "Connects Claude to the Noibu MCP server",
          "longDescription": "Connects Claude to the Noibu MCP server",
          "category": "monitoring",
          "keywords": [],
          "author": {
            "name": "Noibu",
            "url": "https://noibu.com"
          },
          "version": null,
          "license": null,
          "logoUrl": null,
          "darkLogoUrl": null,
          "homepage": "https://help.noibu.com/articles/3918362002-overview-of-the-noibu-plugin-for-claude",
          "sourceUrl": "https://github.com/Noibu/ai-plugin/tree/5e696fc88ef0ef9324776b6ae05413a296504e7c/src",
          "skills": [
            {
              "name": "build-business-context",
              "sourceUrl": "https://github.com/Noibu/ai-plugin/blob/5e696fc88ef0ef9324776b6ae05413a296504e7c/src/skills/build-business-context/SKILL.md"
            },
            {
              "name": "checkout-analysis",
              "sourceUrl": "https://github.com/Noibu/ai-plugin/blob/5e696fc88ef0ef9324776b6ae05413a296504e7c/src/skills/checkout-analysis/SKILL.md"
            },
            {
              "name": "product-analysis",
              "sourceUrl": "https://github.com/Noibu/ai-plugin/blob/5e696fc88ef0ef9324776b6ae05413a296504e7c/src/skills/product-analysis/SKILL.md"
            },
            {
              "name": "querying-noibu-data",
              "sourceUrl": "https://github.com/Noibu/ai-plugin/blob/5e696fc88ef0ef9324776b6ae05413a296504e7c/src/skills/querying-noibu-data/SKILL.md"
            },
            {
              "name": "segment-analysis",
              "sourceUrl": "https://github.com/Noibu/ai-plugin/blob/5e696fc88ef0ef9324776b6ae05413a296504e7c/src/skills/segment-analysis/SKILL.md"
            },
            {
              "name": "store-pulse",
              "sourceUrl": "https://github.com/Noibu/ai-plugin/blob/5e696fc88ef0ef9324776b6ae05413a296504e7c/src/skills/store-pulse/SKILL.md"
            },
            {
              "name": "tech-diagnosis",
              "sourceUrl": "https://github.com/Noibu/ai-plugin/blob/5e696fc88ef0ef9324776b6ae05413a296504e7c/src/skills/tech-diagnosis/SKILL.md"
            }
          ],
          "mcpServers": [],
          "components": ["skills"],
          "componentInspection": "repository",
          "inspectionError": null,
          "installation": "requires_adapter",
          "upstream": {
            "source": {
              "source": "git-subdir",
              "url": "https://github.com/Noibu/ai-plugin.git",
              "path": "src",
              "ref": "main",
              "sha": "5e696fc88ef0ef9324776b6ae05413a296504e7c"
            },
            "policy": null
          }
        },
        {
          "id": "anthropic:notion",
          "name": "notion",
          "displayName": "Notion",
          "description": "Notion Skills + Notion MCP server packaged as a Claude Code plugin.",
          "longDescription": "Notion Skills + Notion MCP server packaged as a Claude Code plugin.",
          "category": "productivity",
          "keywords": [],
          "author": {
            "name": "Notion Labs",
            "url": "https://www.notion.so"
          },
          "version": "0.1.0",
          "license": "MIT",
          "logoUrl": null,
          "darkLogoUrl": null,
          "homepage": "https://github.com/makenotion/claude-code-notion-plugin",
          "sourceUrl": "https://github.com/makenotion/claude-code-notion-plugin/tree/9847f2aa1a15f25df35ed1fb7b4557dbb60cd651/",
          "skills": [
            {
              "name": "knowledge-capture",
              "sourceUrl": "https://github.com/makenotion/claude-code-notion-plugin/blob/9847f2aa1a15f25df35ed1fb7b4557dbb60cd651/skills/notion/knowledge-capture/SKILL.md"
            },
            {
              "name": "meeting-intelligence",
              "sourceUrl": "https://github.com/makenotion/claude-code-notion-plugin/blob/9847f2aa1a15f25df35ed1fb7b4557dbb60cd651/skills/notion/meeting-intelligence/SKILL.md"
            },
            {
              "name": "research-documentation",
              "sourceUrl": "https://github.com/makenotion/claude-code-notion-plugin/blob/9847f2aa1a15f25df35ed1fb7b4557dbb60cd651/skills/notion/research-documentation/SKILL.md"
            },
            {
              "name": "spec-to-implementation",
              "sourceUrl": "https://github.com/makenotion/claude-code-notion-plugin/blob/9847f2aa1a15f25df35ed1fb7b4557dbb60cd651/skills/notion/spec-to-implementation/SKILL.md"
            }
          ],
          "mcpServers": [
            {
              "requiresConfiguration": false,
              "name": "notion",
              "transport": "http",
              "endpoint": "https://mcp.notion.com/mcp"
            }
          ],
          "components": ["skills", "mcp", "commands"],
          "componentInspection": "repository",
          "inspectionError": null,
          "installation": "requires_adapter",
          "upstream": {
            "source": {
              "source": "url",
              "url": "https://github.com/makenotion/claude-code-notion-plugin.git",
              "sha": "9847f2aa1a15f25df35ed1fb7b4557dbb60cd651"
            },
            "policy": null
          }
        },
        {
          "id": "anthropic:nvidia-skills",
          "name": "nvidia-skills",
          "displayName": "nvidia-skills",
          "description": "Find the right NVIDIA skill for GPU acceleration, CUDA, AI agents, data loading, training, inference, robotics, Physical AI, Omniverse, simulation, and other NVIDIA-powered workflows.",
          "longDescription": "Find the right NVIDIA skill for GPU acceleration, CUDA, AI agents, data loading, training, inference, robotics, Physical AI, Omniverse, simulation, and other NVIDIA-powered workflows.",
          "category": "development",
          "keywords": [
            "nvidia",
            "gpu",
            "cuda",
            "ai-agents",
            "data-loading",
            "training",
            "inference",
            "llm-serving",
            "robotics",
            "simulation",
            "omniverse",
            "openusd",
            "digital-twin",
            "physical-ai",
            "cad"
          ],
          "author": {
            "name": "NVIDIA",
            "url": "https://github.com/NVIDIA/skills"
          },
          "version": "1.4.0",
          "license": "Apache-2.0 AND CC-BY-4.0",
          "logoUrl": null,
          "darkLogoUrl": null,
          "homepage": "https://build.nvidia.com/skills/",
          "sourceUrl": "https://github.com/NVIDIA/skills/tree/2455514388e984b7e5a78a30e928f39d1401f16b/plugins/nvidia-skills",
          "skills": [
            {
              "name": "nvidia-skill-finder",
              "sourceUrl": "https://github.com/NVIDIA/skills/blob/2455514388e984b7e5a78a30e928f39d1401f16b/plugins/nvidia-skills/skills/nvidia-skill-finder/SKILL.md"
            }
          ],
          "mcpServers": [],
          "components": ["skills"],
          "componentInspection": "repository",
          "inspectionError": null,
          "installation": "requires_adapter",
          "upstream": {
            "source": {
              "source": "git-subdir",
              "url": "https://github.com/NVIDIA/skills.git",
              "path": "plugins/nvidia-skills",
              "ref": "main",
              "sha": "2455514388e984b7e5a78a30e928f39d1401f16b"
            },
            "policy": null
          }
        },
        {
          "id": "anthropic:oracle-ai-data-platform-workbench-databricks-migrator",
          "name": "oracle-ai-data-platform-workbench-databricks-migrator",
          "displayName": "oracle-ai-data-platform-workbench-databricks-migrator",
          "description": "Drive the Oracle AI Data Platform (AIDP) Databricks Migration Toolkit in natural language. Self-contained — the full Python engine (scripts/, aidp_compat/) ships bundled under engine/ and is invoked from skills via ${CLAUDE_PLUGIN_ROOT}/engine/scripts/. Teaches Claude how to plan and execute an automated end-to-end migration of Databricks (Unity Catalog / HMS) notebooks, jobs, schedules, and catalog DDL onto AIDP — Pass-1 dependency resolution + Pass-2 cell-by-cell execute/verify/fix on a live AIDP cluster using Claude with tool use. Covers job_migrate.py orchestration, catalog migration (18 DDL rewrite rules: 3-part→2-part name flatten, s3://→oci:// via bucket-map, source-format preserved with delta.* property scrub), workflow DAG manifest building, fixup_cell rewind, pre-migration data-availability checks, write-redirect sandbox schema, and the acceptance-contract pattern for batch/streaming convergence. Bundles 10 skills, 4 slash commands, 2 reviewer agents, and 4 reference docs + an env-coords template (cli-map, ddl-rewrite-rules, gotchas, job-report-format + env-coords.template.md).",
          "longDescription": "Drive the Oracle AI Data Platform (AIDP) Databricks Migration Toolkit in natural language. Self-contained — the full Python engine (scripts/, aidp_compat/) ships bundled under engine/ and is invoked from skills via ${CLAUDE_PLUGIN_ROOT}/engine/scripts/. Teaches Claude how to plan and execute an automated end-to-end migration of Databricks (Unity Catalog / HMS) notebooks, jobs, schedules, and catalog DDL onto AIDP — Pass-1 dependency resolution + Pass-2 cell-by-cell execute/verify/fix on a live AIDP cluster using Claude with tool use. Covers job_migrate.py orchestration, catalog migration (18 DDL rewrite rules: 3-part→2-part name flatten, s3://→oci:// via bucket-map, source-format preserved with delta.* property scrub), workflow DAG manifest building, fixup_cell rewind, pre-migration data-availability checks, write-redirect sandbox schema, and the acceptance-contract pattern for batch/streaming convergence. Bundles 10 skills, 4 slash commands, 2 reviewer agents, and 4 reference docs + an env-coords template (cli-map, ddl-rewrite-rules, gotchas, job-report-format + env-coords.template.md).",
          "category": "development",
          "keywords": [
            "oracle",
            "aidp",
            "databricks",
            "migration",
            "spark",
            "spark-sql",
            "delta",
            "unity-catalog",
            "hive-metastore",
            "notebooks",
            "jobs",
            "workflow",
            "dag",
            "catalog",
            "ddl",
            "rewriter",
            "claude-with-tool-use",
            "agentic",
            "automated-migration",
            "cell-by-cell",
            "verify-and-fix",
            "fixup-cell",
            "redirect-schema",
            "data-safety",
            "acceptance-contract",
            "streaming-convergence",
            "fuse",
            "volumes",
            "oci",
            "lakehouse",
            "rest-api"
          ],
          "author": {
            "name": "Oracle"
          },
          "version": "0.2.0",
          "license": "MIT",
          "logoUrl": null,
          "darkLogoUrl": null,
          "homepage": "https://github.com/oracle-samples/oracle-aidp-samples/tree/main/ai/claude-code-plugins/oracle-ai-data-platform-workbench-databricks-migrator",
          "sourceUrl": "https://github.com/oracle-samples/oracle-aidp-samples/tree/a88bcf3a9f9acca94663a727de42d8535e869486/ai/claude-code-plugins/oracle-ai-data-platform-workbench-databricks-migrator",
          "skills": [
            {
              "name": "aidp-acceptance-contract",
              "sourceUrl": "https://github.com/oracle-samples/oracle-aidp-samples/blob/a88bcf3a9f9acca94663a727de42d8535e869486/ai/claude-code-plugins/oracle-ai-data-platform-workbench-databricks-migrator/skills/aidp-acceptance-contract/SKILL.md"
            },
            {
              "name": "aidp-bucket-mapping",
              "sourceUrl": "https://github.com/oracle-samples/oracle-aidp-samples/blob/a88bcf3a9f9acca94663a727de42d8535e869486/ai/claude-code-plugins/oracle-ai-data-platform-workbench-databricks-migrator/skills/aidp-bucket-mapping/SKILL.md"
            },
            {
              "name": "aidp-build-dag",
              "sourceUrl": "https://github.com/oracle-samples/oracle-aidp-samples/blob/a88bcf3a9f9acca94663a727de42d8535e869486/ai/claude-code-plugins/oracle-ai-data-platform-workbench-databricks-migrator/skills/aidp-build-dag/SKILL.md"
            },
            {
              "name": "aidp-check-data",
              "sourceUrl": "https://github.com/oracle-samples/oracle-aidp-samples/blob/a88bcf3a9f9acca94663a727de42d8535e869486/ai/claude-code-plugins/oracle-ai-data-platform-workbench-databricks-migrator/skills/aidp-check-data/SKILL.md"
            },
            {
              "name": "aidp-fixup-cell",
              "sourceUrl": "https://github.com/oracle-samples/oracle-aidp-samples/blob/a88bcf3a9f9acca94663a727de42d8535e869486/ai/claude-code-plugins/oracle-ai-data-platform-workbench-databricks-migrator/skills/aidp-fixup-cell/SKILL.md"
            },
            {
              "name": "aidp-migrate-catalog",
              "sourceUrl": "https://github.com/oracle-samples/oracle-aidp-samples/blob/a88bcf3a9f9acca94663a727de42d8535e869486/ai/claude-code-plugins/oracle-ai-data-platform-workbench-databricks-migrator/skills/aidp-migrate-catalog/SKILL.md"
            },
            {
              "name": "aidp-migrate-job",
              "sourceUrl": "https://github.com/oracle-samples/oracle-aidp-samples/blob/a88bcf3a9f9acca94663a727de42d8535e869486/ai/claude-code-plugins/oracle-ai-data-platform-workbench-databricks-migrator/skills/aidp-migrate-job/SKILL.md"
            },
            {
              "name": "aidp-migrator-bootstrap",
              "sourceUrl": "https://github.com/oracle-samples/oracle-aidp-samples/blob/a88bcf3a9f9acca94663a727de42d8535e869486/ai/claude-code-plugins/oracle-ai-data-platform-workbench-databricks-migrator/skills/aidp-migrator-bootstrap/SKILL.md"
            },
            {
              "name": "aidp-migrator-overview",
              "sourceUrl": "https://github.com/oracle-samples/oracle-aidp-samples/blob/a88bcf3a9f9acca94663a727de42d8535e869486/ai/claude-code-plugins/oracle-ai-data-platform-workbench-databricks-migrator/skills/aidp-migrator-overview/SKILL.md"
            },
            {
              "name": "aidp-resume-migration",
              "sourceUrl": "https://github.com/oracle-samples/oracle-aidp-samples/blob/a88bcf3a9f9acca94663a727de42d8535e869486/ai/claude-code-plugins/oracle-ai-data-platform-workbench-databricks-migrator/skills/aidp-resume-migration/SKILL.md"
            }
          ],
          "mcpServers": [],
          "components": ["skills", "agents", "commands"],
          "componentInspection": "repository",
          "inspectionError": null,
          "installation": "requires_adapter",
          "upstream": {
            "source": {
              "source": "git-subdir",
              "url": "https://github.com/oracle-samples/oracle-aidp-samples.git",
              "path": "ai/claude-code-plugins/oracle-ai-data-platform-workbench-databricks-migrator",
              "ref": "main",
              "sha": "a88bcf3a9f9acca94663a727de42d8535e869486"
            },
            "policy": null
          }
        },
        {
          "id": "anthropic:oracle-ai-data-platform-workbench-engineer-agent",
          "name": "oracle-ai-data-platform-workbench-engineer-agent",
          "displayName": "oracle-ai-data-platform-workbench-engineer-agent",
          "description": "Operate the entire Oracle AI Data Platform (AIDP) Workbench in natural language — a 37-skill agent (not a single-engine orchestrator). Discovers your catalog into a grounding cache (FK/join hints + value dictionaries), turns plain English into accurate Spark SQL, and runs the full lakehouse SQL lifecycle (CREATE/INSERT/UPDATE/DELETE/MERGE/OPTIMIZE/VACUUM/DESCRIBE HISTORY/time-travel on the Spark/Delta lakehouse). Ingests files, profiles data and sets quality rules, authors and repairs cron pipelines, provisions clusters (Compute/AI Compute), and debugs via the Spark UI. Governs the platform (roles + per-resource permissions, credential store, Delta Sharing, audit logs, user settings; plus native Git, bundles, and MLOps/MLflow in Preview) and ships AI — Agent Flows across 13 node types with guardrails (content moderation, prompt-attack prevention, PII detection), Knowledge Base RAG, high-code LangGraph/aidputils agents, and reusable Tools. A semantic model + verified-query repository are matched before free generation for accuracy. Signature differentiators: LLM-in-SQL via ai_generate('openai.gpt-5.4', '<prompt>') and cross-source federation in one Spark session. Runs via the official Oracle aidp CLI with an oci raw-request REST fallback — under either api_key or oci-session-token auth. Additive to your Oracle stack.",
          "longDescription": "Operate the entire Oracle AI Data Platform (AIDP) Workbench in natural language — a 37-skill agent (not a single-engine orchestrator). Discovers your catalog into a grounding cache (FK/join hints + value dictionaries), turns plain English into accurate Spark SQL, and runs the full lakehouse SQL lifecycle (CREATE/INSERT/UPDATE/DELETE/MERGE/OPTIMIZE/VACUUM/DESCRIBE HISTORY/time-travel on the Spark/Delta lakehouse). Ingests files, profiles data and sets quality rules, authors and repairs cron pipelines, provisions clusters (Compute/AI Compute), and debugs via the Spark UI. Governs the platform (roles + per-resource permissions, credential store, Delta Sharing, audit logs, user settings; plus native Git, bundles, and MLOps/MLflow in Preview) and ships AI — Agent Flows across 13 node types with guardrails (content moderation, prompt-attack prevention, PII detection), Knowledge Base RAG, high-code LangGraph/aidputils agents, and reusable Tools. A semantic model + verified-query repository are matched before free generation for accuracy. Signature differentiators: LLM-in-SQL via ai_generate('openai.gpt-5.4', '<prompt>') and cross-source federation in one Spark session. Runs via the official Oracle aidp CLI with an oci raw-request REST fallback — under either api_key or oci-session-token auth. Additive to your Oracle stack.",
          "category": "development",
          "keywords": [
            "oracle",
            "aidp",
            "data-engineering",
            "spark",
            "spark-sql",
            "lakehouse",
            "catalog",
            "data-quality",
            "data-profiling",
            "pipelines",
            "jobs",
            "orchestration",
            "notebooks",
            "cluster",
            "spark-ui",
            "mcp",
            "oci",
            "session-token",
            "credentials",
            "delta-sharing",
            "git",
            "agent-flows",
            "bundle",
            "roles",
            "mlops",
            "mlflow",
            "federation",
            "ai-generate",
            "migration",
            "ddl",
            "delta",
            "merge",
            "knowledge-bases",
            "rag",
            "langgraph",
            "guardrails",
            "agent-tools"
          ],
          "author": {
            "name": "Oracle"
          },
          "version": "0.5.0",
          "license": "MIT",
          "logoUrl": null,
          "darkLogoUrl": null,
          "homepage": "https://github.com/oracle-samples/oracle-aidp-samples/tree/main/ai/claude-code-plugins/oracle-ai-data-platform-workbench-engineer-agent",
          "sourceUrl": "https://github.com/oracle-samples/oracle-aidp-samples/tree/13e7a9139b3b62172119c7fc1a63bf4a2eac919d/ai/claude-code-plugins/oracle-ai-data-platform-workbench-engineer-agent",
          "skills": [
            {
              "name": "aidp-agent-flows",
              "sourceUrl": "https://github.com/oracle-samples/oracle-aidp-samples/blob/13e7a9139b3b62172119c7fc1a63bf4a2eac919d/ai/claude-code-plugins/oracle-ai-data-platform-workbench-engineer-agent/skills/aidp-agent-flows/SKILL.md"
            },
            {
              "name": "aidp-agent-highcode",
              "sourceUrl": "https://github.com/oracle-samples/oracle-aidp-samples/blob/13e7a9139b3b62172119c7fc1a63bf4a2eac919d/ai/claude-code-plugins/oracle-ai-data-platform-workbench-engineer-agent/skills/aidp-agent-highcode/SKILL.md"
            },
            {
              "name": "aidp-ai-sql",
              "sourceUrl": "https://github.com/oracle-samples/oracle-aidp-samples/blob/13e7a9139b3b62172119c7fc1a63bf4a2eac919d/ai/claude-code-plugins/oracle-ai-data-platform-workbench-engineer-agent/skills/aidp-ai-sql/SKILL.md"
            },
            {
              "name": "aidp-analyzing-data",
              "sourceUrl": "https://github.com/oracle-samples/oracle-aidp-samples/blob/13e7a9139b3b62172119c7fc1a63bf4a2eac919d/ai/claude-code-plugins/oracle-ai-data-platform-workbench-engineer-agent/skills/aidp-analyzing-data/SKILL.md"
            },
            {
              "name": "aidp-audit",
              "sourceUrl": "https://github.com/oracle-samples/oracle-aidp-samples/blob/13e7a9139b3b62172119c7fc1a63bf4a2eac919d/ai/claude-code-plugins/oracle-ai-data-platform-workbench-engineer-agent/skills/aidp-audit/SKILL.md"
            },
            {
              "name": "aidp-bundle",
              "sourceUrl": "https://github.com/oracle-samples/oracle-aidp-samples/blob/13e7a9139b3b62172119c7fc1a63bf4a2eac919d/ai/claude-code-plugins/oracle-ai-data-platform-workbench-engineer-agent/skills/aidp-bundle/SKILL.md"
            },
            {
              "name": "aidp-catalog-explore",
              "sourceUrl": "https://github.com/oracle-samples/oracle-aidp-samples/blob/13e7a9139b3b62172119c7fc1a63bf4a2eac919d/ai/claude-code-plugins/oracle-ai-data-platform-workbench-engineer-agent/skills/aidp-catalog-explore/SKILL.md"
            },
            {
              "name": "aidp-catalog-init",
              "sourceUrl": "https://github.com/oracle-samples/oracle-aidp-samples/blob/13e7a9139b3b62172119c7fc1a63bf4a2eac919d/ai/claude-code-plugins/oracle-ai-data-platform-workbench-engineer-agent/skills/aidp-catalog-init/SKILL.md"
            },
            {
              "name": "aidp-cluster-ops",
              "sourceUrl": "https://github.com/oracle-samples/oracle-aidp-samples/blob/13e7a9139b3b62172119c7fc1a63bf4a2eac919d/ai/claude-code-plugins/oracle-ai-data-platform-workbench-engineer-agent/skills/aidp-cluster-ops/SKILL.md"
            },
            {
              "name": "aidp-credentials",
              "sourceUrl": "https://github.com/oracle-samples/oracle-aidp-samples/blob/13e7a9139b3b62172119c7fc1a63bf4a2eac919d/ai/claude-code-plugins/oracle-ai-data-platform-workbench-engineer-agent/skills/aidp-credentials/SKILL.md"
            },
            {
              "name": "aidp-data-quality",
              "sourceUrl": "https://github.com/oracle-samples/oracle-aidp-samples/blob/13e7a9139b3b62172119c7fc1a63bf4a2eac919d/ai/claude-code-plugins/oracle-ai-data-platform-workbench-engineer-agent/skills/aidp-data-quality/SKILL.md"
            },
            {
              "name": "aidp-data-sharing",
              "sourceUrl": "https://github.com/oracle-samples/oracle-aidp-samples/blob/13e7a9139b3b62172119c7fc1a63bf4a2eac919d/ai/claude-code-plugins/oracle-ai-data-platform-workbench-engineer-agent/skills/aidp-data-sharing/SKILL.md"
            },
            {
              "name": "aidp-engineer-bootstrap",
              "sourceUrl": "https://github.com/oracle-samples/oracle-aidp-samples/blob/13e7a9139b3b62172119c7fc1a63bf4a2eac919d/ai/claude-code-plugins/oracle-ai-data-platform-workbench-engineer-agent/skills/aidp-engineer-bootstrap/SKILL.md"
            },
            {
              "name": "aidp-engineer-overview",
              "sourceUrl": "https://github.com/oracle-samples/oracle-aidp-samples/blob/13e7a9139b3b62172119c7fc1a63bf4a2eac919d/ai/claude-code-plugins/oracle-ai-data-platform-workbench-engineer-agent/skills/aidp-engineer-overview/SKILL.md"
            },
            {
              "name": "aidp-federate",
              "sourceUrl": "https://github.com/oracle-samples/oracle-aidp-samples/blob/13e7a9139b3b62172119c7fc1a63bf4a2eac919d/ai/claude-code-plugins/oracle-ai-data-platform-workbench-engineer-agent/skills/aidp-federate/SKILL.md"
            },
            {
              "name": "aidp-git",
              "sourceUrl": "https://github.com/oracle-samples/oracle-aidp-samples/blob/13e7a9139b3b62172119c7fc1a63bf4a2eac919d/ai/claude-code-plugins/oracle-ai-data-platform-workbench-engineer-agent/skills/aidp-git/SKILL.md"
            },
            {
              "name": "aidp-ingest-file-to-table",
              "sourceUrl": "https://github.com/oracle-samples/oracle-aidp-samples/blob/13e7a9139b3b62172119c7fc1a63bf4a2eac919d/ai/claude-code-plugins/oracle-ai-data-platform-workbench-engineer-agent/skills/aidp-ingest-file-to-table/SKILL.md"
            },
            {
              "name": "aidp-knowledge-bases",
              "sourceUrl": "https://github.com/oracle-samples/oracle-aidp-samples/blob/13e7a9139b3b62172119c7fc1a63bf4a2eac919d/ai/claude-code-plugins/oracle-ai-data-platform-workbench-engineer-agent/skills/aidp-knowledge-bases/SKILL.md"
            },
            {
              "name": "aidp-migration",
              "sourceUrl": "https://github.com/oracle-samples/oracle-aidp-samples/blob/13e7a9139b3b62172119c7fc1a63bf4a2eac919d/ai/claude-code-plugins/oracle-ai-data-platform-workbench-engineer-agent/skills/aidp-migration/SKILL.md"
            },
            {
              "name": "aidp-mlops",
              "sourceUrl": "https://github.com/oracle-samples/oracle-aidp-samples/blob/13e7a9139b3b62172119c7fc1a63bf4a2eac919d/ai/claude-code-plugins/oracle-ai-data-platform-workbench-engineer-agent/skills/aidp-mlops/SKILL.md"
            },
            {
              "name": "aidp-models-catalog",
              "sourceUrl": "https://github.com/oracle-samples/oracle-aidp-samples/blob/13e7a9139b3b62172119c7fc1a63bf4a2eac919d/ai/claude-code-plugins/oracle-ai-data-platform-workbench-engineer-agent/skills/aidp-models-catalog/SKILL.md"
            },
            {
              "name": "aidp-notebooks",
              "sourceUrl": "https://github.com/oracle-samples/oracle-aidp-samples/blob/13e7a9139b3b62172119c7fc1a63bf4a2eac919d/ai/claude-code-plugins/oracle-ai-data-platform-workbench-engineer-agent/skills/aidp-notebooks/SKILL.md"
            },
            {
              "name": "aidp-observability",
              "sourceUrl": "https://github.com/oracle-samples/oracle-aidp-samples/blob/13e7a9139b3b62172119c7fc1a63bf4a2eac919d/ai/claude-code-plugins/oracle-ai-data-platform-workbench-engineer-agent/skills/aidp-observability/SKILL.md"
            },
            {
              "name": "aidp-pipelines",
              "sourceUrl": "https://github.com/oracle-samples/oracle-aidp-samples/blob/13e7a9139b3b62172119c7fc1a63bf4a2eac919d/ai/claude-code-plugins/oracle-ai-data-platform-workbench-engineer-agent/skills/aidp-pipelines/SKILL.md"
            },
            {
              "name": "aidp-profiling-tables",
              "sourceUrl": "https://github.com/oracle-samples/oracle-aidp-samples/blob/13e7a9139b3b62172119c7fc1a63bf4a2eac919d/ai/claude-code-plugins/oracle-ai-data-platform-workbench-engineer-agent/skills/aidp-profiling-tables/SKILL.md"
            },
            {
              "name": "aidp-roles-access",
              "sourceUrl": "https://github.com/oracle-samples/oracle-aidp-samples/blob/13e7a9139b3b62172119c7fc1a63bf4a2eac919d/ai/claude-code-plugins/oracle-ai-data-platform-workbench-engineer-agent/skills/aidp-roles-access/SKILL.md"
            },
            {
              "name": "aidp-semantic-model",
              "sourceUrl": "https://github.com/oracle-samples/oracle-aidp-samples/blob/13e7a9139b3b62172119c7fc1a63bf4a2eac919d/ai/claude-code-plugins/oracle-ai-data-platform-workbench-engineer-agent/skills/aidp-semantic-model/SKILL.md"
            },
            {
              "name": "aidp-spark-debugging",
              "sourceUrl": "https://github.com/oracle-samples/oracle-aidp-samples/blob/13e7a9139b3b62172119c7fc1a63bf4a2eac919d/ai/claude-code-plugins/oracle-ai-data-platform-workbench-engineer-agent/skills/aidp-spark-debugging/SKILL.md"
            },
            {
              "name": "aidp-spark-optimization",
              "sourceUrl": "https://github.com/oracle-samples/oracle-aidp-samples/blob/13e7a9139b3b62172119c7fc1a63bf4a2eac919d/ai/claude-code-plugins/oracle-ai-data-platform-workbench-engineer-agent/skills/aidp-spark-optimization/SKILL.md"
            },
            {
              "name": "aidp-sql-ddl",
              "sourceUrl": "https://github.com/oracle-samples/oracle-aidp-samples/blob/13e7a9139b3b62172119c7fc1a63bf4a2eac919d/ai/claude-code-plugins/oracle-ai-data-platform-workbench-engineer-agent/skills/aidp-sql-ddl/SKILL.md"
            },
            {
              "name": "aidp-table-management",
              "sourceUrl": "https://github.com/oracle-samples/oracle-aidp-samples/blob/13e7a9139b3b62172119c7fc1a63bf4a2eac919d/ai/claude-code-plugins/oracle-ai-data-platform-workbench-engineer-agent/skills/aidp-table-management/SKILL.md"
            },
            {
              "name": "aidp-tools",
              "sourceUrl": "https://github.com/oracle-samples/oracle-aidp-samples/blob/13e7a9139b3b62172119c7fc1a63bf4a2eac919d/ai/claude-code-plugins/oracle-ai-data-platform-workbench-engineer-agent/skills/aidp-tools/SKILL.md"
            },
            {
              "name": "aidp-user-settings",
              "sourceUrl": "https://github.com/oracle-samples/oracle-aidp-samples/blob/13e7a9139b3b62172119c7fc1a63bf4a2eac919d/ai/claude-code-plugins/oracle-ai-data-platform-workbench-engineer-agent/skills/aidp-user-settings/SKILL.md"
            },
            {
              "name": "aidp-verified-queries",
              "sourceUrl": "https://github.com/oracle-samples/oracle-aidp-samples/blob/13e7a9139b3b62172119c7fc1a63bf4a2eac919d/ai/claude-code-plugins/oracle-ai-data-platform-workbench-engineer-agent/skills/aidp-verified-queries/SKILL.md"
            },
            {
              "name": "aidp-volumes",
              "sourceUrl": "https://github.com/oracle-samples/oracle-aidp-samples/blob/13e7a9139b3b62172119c7fc1a63bf4a2eac919d/ai/claude-code-plugins/oracle-ai-data-platform-workbench-engineer-agent/skills/aidp-volumes/SKILL.md"
            },
            {
              "name": "aidp-workspace-admin",
              "sourceUrl": "https://github.com/oracle-samples/oracle-aidp-samples/blob/13e7a9139b3b62172119c7fc1a63bf4a2eac919d/ai/claude-code-plugins/oracle-ai-data-platform-workbench-engineer-agent/skills/aidp-workspace-admin/SKILL.md"
            },
            {
              "name": "aidp-workspace-files",
              "sourceUrl": "https://github.com/oracle-samples/oracle-aidp-samples/blob/13e7a9139b3b62172119c7fc1a63bf4a2eac919d/ai/claude-code-plugins/oracle-ai-data-platform-workbench-engineer-agent/skills/aidp-workspace-files/SKILL.md"
            }
          ],
          "mcpServers": [],
          "components": ["skills", "hooks"],
          "componentInspection": "repository",
          "inspectionError": null,
          "installation": "requires_adapter",
          "upstream": {
            "source": {
              "source": "git-subdir",
              "url": "https://github.com/oracle-samples/oracle-aidp-samples.git",
              "path": "ai/claude-code-plugins/oracle-ai-data-platform-workbench-engineer-agent",
              "ref": "main",
              "sha": "13e7a9139b3b62172119c7fc1a63bf4a2eac919d"
            },
            "policy": null
          }
        },
        {
          "id": "anthropic:oracle-ai-data-platform-workbench-spark-connectors",
          "name": "oracle-ai-data-platform-workbench-spark-connectors",
          "displayName": "oracle-ai-data-platform-workbench-spark-connectors",
          "description": "Oracle AI Data Platform Workbench Spark connectors for Claude Code. 26 connector skills covering Oracle, OCI, SaaS, JDBC, object storage, streaming, REST, Excel, and multi-cloud data sources, including dedicated DB2 and Azure SQL guidance.",
          "longDescription": "Oracle AI Data Platform Workbench Spark connectors for Claude Code. 26 connector skills covering Oracle, OCI, SaaS, JDBC, object storage, streaming, REST, Excel, and multi-cloud data sources, including dedicated DB2 and Azure SQL guidance.",
          "category": "development",
          "keywords": [
            "oracle",
            "aidp",
            "spark",
            "jdbc",
            "lakehouse",
            "autonomous-database",
            "atp",
            "adw",
            "exacs",
            "fusion",
            "epm",
            "essbase",
            "kafka",
            "streaming",
            "object-storage",
            "iceberg",
            "postgresql",
            "mysql",
            "sqlserver",
            "azure-sql",
            "db2",
            "snowflake",
            "netsuite",
            "adls",
            "s3",
            "rest",
            "connector",
            "peoplesoft",
            "siebel",
            "salesforce",
            "hive",
            "pushdown",
            "catalog"
          ],
          "author": {
            "name": "Ahmed Awan"
          },
          "version": "0.7.0",
          "license": "MIT",
          "logoUrl": null,
          "darkLogoUrl": null,
          "homepage": "https://github.com/oracle-samples/oracle-aidp-samples/tree/main/ai/claude-code-plugins/oracle-ai-data-platform-workbench-spark-connectors",
          "sourceUrl": "https://github.com/oracle-samples/oracle-aidp-samples/tree/da0ce42f3b71cc16ee8b3a3e1ed2420c7eb180ad/ai/claude-code-plugins/oracle-ai-data-platform-workbench-spark-connectors",
          "skills": [
            {
              "name": "aidp-alh",
              "sourceUrl": "https://github.com/oracle-samples/oracle-aidp-samples/blob/da0ce42f3b71cc16ee8b3a3e1ed2420c7eb180ad/ai/claude-code-plugins/oracle-ai-data-platform-workbench-spark-connectors/skills/aidp-alh/SKILL.md"
            },
            {
              "name": "aidp-aws-s3",
              "sourceUrl": "https://github.com/oracle-samples/oracle-aidp-samples/blob/da0ce42f3b71cc16ee8b3a3e1ed2420c7eb180ad/ai/claude-code-plugins/oracle-ai-data-platform-workbench-spark-connectors/skills/aidp-aws-s3/SKILL.md"
            },
            {
              "name": "aidp-azure-adls",
              "sourceUrl": "https://github.com/oracle-samples/oracle-aidp-samples/blob/da0ce42f3b71cc16ee8b3a3e1ed2420c7eb180ad/ai/claude-code-plugins/oracle-ai-data-platform-workbench-spark-connectors/skills/aidp-azure-adls/SKILL.md"
            },
            {
              "name": "aidp-azuresql",
              "sourceUrl": "https://github.com/oracle-samples/oracle-aidp-samples/blob/da0ce42f3b71cc16ee8b3a3e1ed2420c7eb180ad/ai/claude-code-plugins/oracle-ai-data-platform-workbench-spark-connectors/skills/aidp-azuresql/SKILL.md"
            },
            {
              "name": "aidp-connectors-bootstrap",
              "sourceUrl": "https://github.com/oracle-samples/oracle-aidp-samples/blob/da0ce42f3b71cc16ee8b3a3e1ed2420c7eb180ad/ai/claude-code-plugins/oracle-ai-data-platform-workbench-spark-connectors/skills/aidp-connectors-bootstrap/SKILL.md"
            },
            {
              "name": "aidp-connectors-overview",
              "sourceUrl": "https://github.com/oracle-samples/oracle-aidp-samples/blob/da0ce42f3b71cc16ee8b3a3e1ed2420c7eb180ad/ai/claude-code-plugins/oracle-ai-data-platform-workbench-spark-connectors/skills/aidp-connectors-overview/SKILL.md"
            },
            {
              "name": "aidp-db2",
              "sourceUrl": "https://github.com/oracle-samples/oracle-aidp-samples/blob/da0ce42f3b71cc16ee8b3a3e1ed2420c7eb180ad/ai/claude-code-plugins/oracle-ai-data-platform-workbench-spark-connectors/skills/aidp-db2/SKILL.md"
            },
            {
              "name": "aidp-epm-cloud",
              "sourceUrl": "https://github.com/oracle-samples/oracle-aidp-samples/blob/da0ce42f3b71cc16ee8b3a3e1ed2420c7eb180ad/ai/claude-code-plugins/oracle-ai-data-platform-workbench-spark-connectors/skills/aidp-epm-cloud/SKILL.md"
            },
            {
              "name": "aidp-essbase",
              "sourceUrl": "https://github.com/oracle-samples/oracle-aidp-samples/blob/da0ce42f3b71cc16ee8b3a3e1ed2420c7eb180ad/ai/claude-code-plugins/oracle-ai-data-platform-workbench-spark-connectors/skills/aidp-essbase/SKILL.md"
            },
            {
              "name": "aidp-exacs",
              "sourceUrl": "https://github.com/oracle-samples/oracle-aidp-samples/blob/da0ce42f3b71cc16ee8b3a3e1ed2420c7eb180ad/ai/claude-code-plugins/oracle-ai-data-platform-workbench-spark-connectors/skills/aidp-exacs/SKILL.md"
            },
            {
              "name": "aidp-excel",
              "sourceUrl": "https://github.com/oracle-samples/oracle-aidp-samples/blob/da0ce42f3b71cc16ee8b3a3e1ed2420c7eb180ad/ai/claude-code-plugins/oracle-ai-data-platform-workbench-spark-connectors/skills/aidp-excel/SKILL.md"
            },
            {
              "name": "aidp-fusion-bicc",
              "sourceUrl": "https://github.com/oracle-samples/oracle-aidp-samples/blob/da0ce42f3b71cc16ee8b3a3e1ed2420c7eb180ad/ai/claude-code-plugins/oracle-ai-data-platform-workbench-spark-connectors/skills/aidp-fusion-bicc/SKILL.md"
            },
            {
              "name": "aidp-fusion-rest",
              "sourceUrl": "https://github.com/oracle-samples/oracle-aidp-samples/blob/da0ce42f3b71cc16ee8b3a3e1ed2420c7eb180ad/ai/claude-code-plugins/oracle-ai-data-platform-workbench-spark-connectors/skills/aidp-fusion-rest/SKILL.md"
            },
            {
              "name": "aidp-hive",
              "sourceUrl": "https://github.com/oracle-samples/oracle-aidp-samples/blob/da0ce42f3b71cc16ee8b3a3e1ed2420c7eb180ad/ai/claude-code-plugins/oracle-ai-data-platform-workbench-spark-connectors/skills/aidp-hive/SKILL.md"
            },
            {
              "name": "aidp-iceberg",
              "sourceUrl": "https://github.com/oracle-samples/oracle-aidp-samples/blob/da0ce42f3b71cc16ee8b3a3e1ed2420c7eb180ad/ai/claude-code-plugins/oracle-ai-data-platform-workbench-spark-connectors/skills/aidp-iceberg/SKILL.md"
            },
            {
              "name": "aidp-jdbc-custom",
              "sourceUrl": "https://github.com/oracle-samples/oracle-aidp-samples/blob/da0ce42f3b71cc16ee8b3a3e1ed2420c7eb180ad/ai/claude-code-plugins/oracle-ai-data-platform-workbench-spark-connectors/skills/aidp-jdbc-custom/SKILL.md"
            },
            {
              "name": "aidp-mysql",
              "sourceUrl": "https://github.com/oracle-samples/oracle-aidp-samples/blob/da0ce42f3b71cc16ee8b3a3e1ed2420c7eb180ad/ai/claude-code-plugins/oracle-ai-data-platform-workbench-spark-connectors/skills/aidp-mysql/SKILL.md"
            },
            {
              "name": "aidp-netsuite",
              "sourceUrl": "https://github.com/oracle-samples/oracle-aidp-samples/blob/da0ce42f3b71cc16ee8b3a3e1ed2420c7eb180ad/ai/claude-code-plugins/oracle-ai-data-platform-workbench-spark-connectors/skills/aidp-netsuite/SKILL.md"
            },
            {
              "name": "aidp-object-storage",
              "sourceUrl": "https://github.com/oracle-samples/oracle-aidp-samples/blob/da0ce42f3b71cc16ee8b3a3e1ed2420c7eb180ad/ai/claude-code-plugins/oracle-ai-data-platform-workbench-spark-connectors/skills/aidp-object-storage/SKILL.md"
            },
            {
              "name": "aidp-oracle-db",
              "sourceUrl": "https://github.com/oracle-samples/oracle-aidp-samples/blob/da0ce42f3b71cc16ee8b3a3e1ed2420c7eb180ad/ai/claude-code-plugins/oracle-ai-data-platform-workbench-spark-connectors/skills/aidp-oracle-db/SKILL.md"
            },
            {
              "name": "aidp-peoplesoft",
              "sourceUrl": "https://github.com/oracle-samples/oracle-aidp-samples/blob/da0ce42f3b71cc16ee8b3a3e1ed2420c7eb180ad/ai/claude-code-plugins/oracle-ai-data-platform-workbench-spark-connectors/skills/aidp-peoplesoft/SKILL.md"
            },
            {
              "name": "aidp-postgresql",
              "sourceUrl": "https://github.com/oracle-samples/oracle-aidp-samples/blob/da0ce42f3b71cc16ee8b3a3e1ed2420c7eb180ad/ai/claude-code-plugins/oracle-ai-data-platform-workbench-spark-connectors/skills/aidp-postgresql/SKILL.md"
            },
            {
              "name": "aidp-rest-generic",
              "sourceUrl": "https://github.com/oracle-samples/oracle-aidp-samples/blob/da0ce42f3b71cc16ee8b3a3e1ed2420c7eb180ad/ai/claude-code-plugins/oracle-ai-data-platform-workbench-spark-connectors/skills/aidp-rest-generic/SKILL.md"
            },
            {
              "name": "aidp-salesforce",
              "sourceUrl": "https://github.com/oracle-samples/oracle-aidp-samples/blob/da0ce42f3b71cc16ee8b3a3e1ed2420c7eb180ad/ai/claude-code-plugins/oracle-ai-data-platform-workbench-spark-connectors/skills/aidp-salesforce/SKILL.md"
            },
            {
              "name": "aidp-siebel",
              "sourceUrl": "https://github.com/oracle-samples/oracle-aidp-samples/blob/da0ce42f3b71cc16ee8b3a3e1ed2420c7eb180ad/ai/claude-code-plugins/oracle-ai-data-platform-workbench-spark-connectors/skills/aidp-siebel/SKILL.md"
            },
            {
              "name": "aidp-snowflake",
              "sourceUrl": "https://github.com/oracle-samples/oracle-aidp-samples/blob/da0ce42f3b71cc16ee8b3a3e1ed2420c7eb180ad/ai/claude-code-plugins/oracle-ai-data-platform-workbench-spark-connectors/skills/aidp-snowflake/SKILL.md"
            },
            {
              "name": "aidp-sqlserver",
              "sourceUrl": "https://github.com/oracle-samples/oracle-aidp-samples/blob/da0ce42f3b71cc16ee8b3a3e1ed2420c7eb180ad/ai/claude-code-plugins/oracle-ai-data-platform-workbench-spark-connectors/skills/aidp-sqlserver/SKILL.md"
            },
            {
              "name": "aidp-streaming-kafka",
              "sourceUrl": "https://github.com/oracle-samples/oracle-aidp-samples/blob/da0ce42f3b71cc16ee8b3a3e1ed2420c7eb180ad/ai/claude-code-plugins/oracle-ai-data-platform-workbench-spark-connectors/skills/aidp-streaming-kafka/SKILL.md"
            }
          ],
          "mcpServers": [],
          "components": ["skills"],
          "componentInspection": "repository",
          "inspectionError": null,
          "installation": "requires_adapter",
          "upstream": {
            "source": {
              "source": "git-subdir",
              "url": "https://github.com/oracle-samples/oracle-aidp-samples.git",
              "path": "ai/claude-code-plugins/oracle-ai-data-platform-workbench-spark-connectors",
              "ref": "main",
              "sha": "da0ce42f3b71cc16ee8b3a3e1ed2420c7eb180ad"
            },
            "policy": null
          }
        },
        {
          "id": "anthropic:oracledb",
          "name": "oracledb",
          "displayName": "oracledb",
          "description": "Connect, query, and interact with Oracle Databases and their data.",
          "longDescription": "Connect, query, and interact with Oracle Databases and their data.",
          "category": "database",
          "keywords": [],
          "author": {
            "name": "Google LLC",
            "email": "data-cloud-ai-integrations@google.com"
          },
          "version": "0.2.6",
          "license": "Apache-2.0",
          "logoUrl": null,
          "darkLogoUrl": null,
          "homepage": "https://cloud.google.com/solutions/oracle",
          "sourceUrl": "https://github.com/gemini-cli-extensions/oracledb/tree/bc589fe2bd006edf4c3a008ed2fb9e068d801c99/",
          "skills": [],
          "mcpServers": [
            {
              "requiresConfiguration": false,
              "name": "oracledb",
              "transport": "stdio",
              "endpoint": null
            }
          ],
          "components": ["mcp"],
          "componentInspection": "repository",
          "inspectionError": null,
          "installation": "requires_adapter",
          "upstream": {
            "source": {
              "source": "url",
              "url": "https://github.com/gemini-cli-extensions/oracledb.git",
              "sha": "bc589fe2bd006edf4c3a008ed2fb9e068d801c99"
            },
            "policy": null
          }
        },
        {
          "id": "anthropic:outputai",
          "name": "outputai",
          "displayName": "outputai",
          "description": "Workflow development tools",
          "longDescription": "Workflow development tools",
          "category": "development",
          "keywords": [],
          "author": {
            "name": "Output.ai",
            "email": "oss@growthx.ai"
          },
          "version": "0.3.0",
          "license": null,
          "logoUrl": null,
          "darkLogoUrl": null,
          "homepage": "https://output.ai",
          "sourceUrl": "https://github.com/growthxai/output/tree/69255d7fd577139a7828bd219637d067b86a42b1/coding_assistants/claude/plugins/outputai",
          "skills": [
            {
              "name": "output-build-workflow",
              "sourceUrl": "https://github.com/growthxai/output/blob/69255d7fd577139a7828bd219637d067b86a42b1/coding_assistants/claude/plugins/outputai/skills/output-build-workflow/SKILL.md"
            },
            {
              "name": "output-credentials-edit",
              "sourceUrl": "https://github.com/growthxai/output/blob/69255d7fd577139a7828bd219637d067b86a42b1/coding_assistants/claude/plugins/outputai/skills/output-credentials-edit/SKILL.md"
            },
            {
              "name": "output-credentials-env-vars",
              "sourceUrl": "https://github.com/growthxai/output/blob/69255d7fd577139a7828bd219637d067b86a42b1/coding_assistants/claude/plugins/outputai/skills/output-credentials-env-vars/SKILL.md"
            },
            {
              "name": "output-credentials-init",
              "sourceUrl": "https://github.com/growthxai/output/blob/69255d7fd577139a7828bd219637d067b86a42b1/coding_assistants/claude/plugins/outputai/skills/output-credentials-init/SKILL.md"
            },
            {
              "name": "output-debug-workflow",
              "sourceUrl": "https://github.com/growthxai/output/blob/69255d7fd577139a7828bd219637d067b86a42b1/coding_assistants/claude/plugins/outputai/skills/output-debug-workflow/SKILL.md"
            },
            {
              "name": "output-dev-agent-class",
              "sourceUrl": "https://github.com/growthxai/output/blob/69255d7fd577139a7828bd219637d067b86a42b1/coding_assistants/claude/plugins/outputai/skills/output-dev-agent-class/SKILL.md"
            },
            {
              "name": "output-dev-code-style",
              "sourceUrl": "https://github.com/growthxai/output/blob/69255d7fd577139a7828bd219637d067b86a42b1/coding_assistants/claude/plugins/outputai/skills/output-dev-code-style/SKILL.md"
            },
            {
              "name": "output-dev-create-skeleton",
              "sourceUrl": "https://github.com/growthxai/output/blob/69255d7fd577139a7828bd219637d067b86a42b1/coding_assistants/claude/plugins/outputai/skills/output-dev-create-skeleton/SKILL.md"
            },
            {
              "name": "output-dev-credentials",
              "sourceUrl": "https://github.com/growthxai/output/blob/69255d7fd577139a7828bd219637d067b86a42b1/coding_assistants/claude/plugins/outputai/skills/output-dev-credentials/SKILL.md"
            },
            {
              "name": "output-dev-eval-testing",
              "sourceUrl": "https://github.com/growthxai/output/blob/69255d7fd577139a7828bd219637d067b86a42b1/coding_assistants/claude/plugins/outputai/skills/output-dev-eval-testing/SKILL.md"
            },
            {
              "name": "output-dev-evaluator-function",
              "sourceUrl": "https://github.com/growthxai/output/blob/69255d7fd577139a7828bd219637d067b86a42b1/coding_assistants/claude/plugins/outputai/skills/output-dev-evaluator-function/SKILL.md"
            },
            {
              "name": "output-dev-folder-structure",
              "sourceUrl": "https://github.com/growthxai/output/blob/69255d7fd577139a7828bd219637d067b86a42b1/coding_assistants/claude/plugins/outputai/skills/output-dev-folder-structure/SKILL.md"
            },
            {
              "name": "output-dev-http-client-create",
              "sourceUrl": "https://github.com/growthxai/output/blob/69255d7fd577139a7828bd219637d067b86a42b1/coding_assistants/claude/plugins/outputai/skills/output-dev-http-client-create/SKILL.md"
            },
            {
              "name": "output-dev-llm-streaming",
              "sourceUrl": "https://github.com/growthxai/output/blob/69255d7fd577139a7828bd219637d067b86a42b1/coding_assistants/claude/plugins/outputai/skills/output-dev-llm-streaming/SKILL.md"
            },
            {
              "name": "output-dev-model-selection",
              "sourceUrl": "https://github.com/growthxai/output/blob/69255d7fd577139a7828bd219637d067b86a42b1/coding_assistants/claude/plugins/outputai/skills/output-dev-model-selection/SKILL.md"
            },
            {
              "name": "output-dev-prompt-file",
              "sourceUrl": "https://github.com/growthxai/output/blob/69255d7fd577139a7828bd219637d067b86a42b1/coding_assistants/claude/plugins/outputai/skills/output-dev-prompt-file/SKILL.md"
            },
            {
              "name": "output-dev-scenario-file",
              "sourceUrl": "https://github.com/growthxai/output/blob/69255d7fd577139a7828bd219637d067b86a42b1/coding_assistants/claude/plugins/outputai/skills/output-dev-scenario-file/SKILL.md"
            },
            {
              "name": "output-dev-skill-file",
              "sourceUrl": "https://github.com/growthxai/output/blob/69255d7fd577139a7828bd219637d067b86a42b1/coding_assistants/claude/plugins/outputai/skills/output-dev-skill-file/SKILL.md"
            },
            {
              "name": "output-dev-step-function",
              "sourceUrl": "https://github.com/growthxai/output/blob/69255d7fd577139a7828bd219637d067b86a42b1/coding_assistants/claude/plugins/outputai/skills/output-dev-step-function/SKILL.md"
            },
            {
              "name": "output-dev-types-file",
              "sourceUrl": "https://github.com/growthxai/output/blob/69255d7fd577139a7828bd219637d067b86a42b1/coding_assistants/claude/plugins/outputai/skills/output-dev-types-file/SKILL.md"
            },
            {
              "name": "output-dev-upgrade-prompt-models",
              "sourceUrl": "https://github.com/growthxai/output/blob/69255d7fd577139a7828bd219637d067b86a42b1/coding_assistants/claude/plugins/outputai/skills/output-dev-upgrade-prompt-models/SKILL.md"
            },
            {
              "name": "output-dev-workflow-cost",
              "sourceUrl": "https://github.com/growthxai/output/blob/69255d7fd577139a7828bd219637d067b86a42b1/coding_assistants/claude/plugins/outputai/skills/output-dev-workflow-cost/SKILL.md"
            },
            {
              "name": "output-dev-workflow-function",
              "sourceUrl": "https://github.com/growthxai/output/blob/69255d7fd577139a7828bd219637d067b86a42b1/coding_assistants/claude/plugins/outputai/skills/output-dev-workflow-function/SKILL.md"
            },
            {
              "name": "output-error-direct-io",
              "sourceUrl": "https://github.com/growthxai/output/blob/69255d7fd577139a7828bd219637d067b86a42b1/coding_assistants/claude/plugins/outputai/skills/output-error-direct-io/SKILL.md"
            },
            {
              "name": "output-error-http-client",
              "sourceUrl": "https://github.com/growthxai/output/blob/69255d7fd577139a7828bd219637d067b86a42b1/coding_assistants/claude/plugins/outputai/skills/output-error-http-client/SKILL.md"
            },
            {
              "name": "output-error-missing-schemas",
              "sourceUrl": "https://github.com/growthxai/output/blob/69255d7fd577139a7828bd219637d067b86a42b1/coding_assistants/claude/plugins/outputai/skills/output-error-missing-schemas/SKILL.md"
            },
            {
              "name": "output-error-nondeterminism",
              "sourceUrl": "https://github.com/growthxai/output/blob/69255d7fd577139a7828bd219637d067b86a42b1/coding_assistants/claude/plugins/outputai/skills/output-error-nondeterminism/SKILL.md"
            },
            {
              "name": "output-error-try-catch",
              "sourceUrl": "https://github.com/growthxai/output/blob/69255d7fd577139a7828bd219637d067b86a42b1/coding_assistants/claude/plugins/outputai/skills/output-error-try-catch/SKILL.md"
            },
            {
              "name": "output-error-zod-import",
              "sourceUrl": "https://github.com/growthxai/output/blob/69255d7fd577139a7828bd219637d067b86a42b1/coding_assistants/claude/plugins/outputai/skills/output-error-zod-import/SKILL.md"
            },
            {
              "name": "output-eval-audit",
              "sourceUrl": "https://github.com/growthxai/output/blob/69255d7fd577139a7828bd219637d067b86a42b1/coding_assistants/claude/plugins/outputai/skills/output-eval-audit/SKILL.md"
            },
            {
              "name": "output-eval-dataset-design",
              "sourceUrl": "https://github.com/growthxai/output/blob/69255d7fd577139a7828bd219637d067b86a42b1/coding_assistants/claude/plugins/outputai/skills/output-eval-dataset-design/SKILL.md"
            },
            {
              "name": "output-eval-error-analysis",
              "sourceUrl": "https://github.com/growthxai/output/blob/69255d7fd577139a7828bd219637d067b86a42b1/coding_assistants/claude/plugins/outputai/skills/output-eval-error-analysis/SKILL.md"
            },
            {
              "name": "output-eval-judge-prompt",
              "sourceUrl": "https://github.com/growthxai/output/blob/69255d7fd577139a7828bd219637d067b86a42b1/coding_assistants/claude/plugins/outputai/skills/output-eval-judge-prompt/SKILL.md"
            },
            {
              "name": "output-eval-validate-judge",
              "sourceUrl": "https://github.com/growthxai/output/blob/69255d7fd577139a7828bd219637d067b86a42b1/coding_assistants/claude/plugins/outputai/skills/output-eval-validate-judge/SKILL.md"
            },
            {
              "name": "output-meta-post-flight",
              "sourceUrl": "https://github.com/growthxai/output/blob/69255d7fd577139a7828bd219637d067b86a42b1/coding_assistants/claude/plugins/outputai/skills/output-meta-post-flight/SKILL.md"
            },
            {
              "name": "output-meta-pre-flight",
              "sourceUrl": "https://github.com/growthxai/output/blob/69255d7fd577139a7828bd219637d067b86a42b1/coding_assistants/claude/plugins/outputai/skills/output-meta-pre-flight/SKILL.md"
            },
            {
              "name": "output-meta-project-context",
              "sourceUrl": "https://github.com/growthxai/output/blob/69255d7fd577139a7828bd219637d067b86a42b1/coding_assistants/claude/plugins/outputai/skills/output-meta-project-context/SKILL.md"
            },
            {
              "name": "output-migrate",
              "sourceUrl": "https://github.com/growthxai/output/blob/69255d7fd577139a7828bd219637d067b86a42b1/coding_assistants/claude/plugins/outputai/skills/output-migrate/SKILL.md"
            },
            {
              "name": "output-plan-workflow",
              "sourceUrl": "https://github.com/growthxai/output/blob/69255d7fd577139a7828bd219637d067b86a42b1/coding_assistants/claude/plugins/outputai/skills/output-plan-workflow/SKILL.md"
            },
            {
              "name": "output-services-check",
              "sourceUrl": "https://github.com/growthxai/output/blob/69255d7fd577139a7828bd219637d067b86a42b1/coding_assistants/claude/plugins/outputai/skills/output-services-check/SKILL.md"
            },
            {
              "name": "output-workflow-list",
              "sourceUrl": "https://github.com/growthxai/output/blob/69255d7fd577139a7828bd219637d067b86a42b1/coding_assistants/claude/plugins/outputai/skills/output-workflow-list/SKILL.md"
            },
            {
              "name": "output-workflow-reset",
              "sourceUrl": "https://github.com/growthxai/output/blob/69255d7fd577139a7828bd219637d067b86a42b1/coding_assistants/claude/plugins/outputai/skills/output-workflow-reset/SKILL.md"
            },
            {
              "name": "output-workflow-result",
              "sourceUrl": "https://github.com/growthxai/output/blob/69255d7fd577139a7828bd219637d067b86a42b1/coding_assistants/claude/plugins/outputai/skills/output-workflow-result/SKILL.md"
            },
            {
              "name": "output-workflow-run",
              "sourceUrl": "https://github.com/growthxai/output/blob/69255d7fd577139a7828bd219637d067b86a42b1/coding_assistants/claude/plugins/outputai/skills/output-workflow-run/SKILL.md"
            },
            {
              "name": "output-workflow-runs-list",
              "sourceUrl": "https://github.com/growthxai/output/blob/69255d7fd577139a7828bd219637d067b86a42b1/coding_assistants/claude/plugins/outputai/skills/output-workflow-runs-list/SKILL.md"
            },
            {
              "name": "output-workflow-start",
              "sourceUrl": "https://github.com/growthxai/output/blob/69255d7fd577139a7828bd219637d067b86a42b1/coding_assistants/claude/plugins/outputai/skills/output-workflow-start/SKILL.md"
            },
            {
              "name": "output-workflow-status",
              "sourceUrl": "https://github.com/growthxai/output/blob/69255d7fd577139a7828bd219637d067b86a42b1/coding_assistants/claude/plugins/outputai/skills/output-workflow-status/SKILL.md"
            },
            {
              "name": "output-workflow-stop",
              "sourceUrl": "https://github.com/growthxai/output/blob/69255d7fd577139a7828bd219637d067b86a42b1/coding_assistants/claude/plugins/outputai/skills/output-workflow-stop/SKILL.md"
            },
            {
              "name": "output-workflow-trace-file",
              "sourceUrl": "https://github.com/growthxai/output/blob/69255d7fd577139a7828bd219637d067b86a42b1/coding_assistants/claude/plugins/outputai/skills/output-workflow-trace-file/SKILL.md"
            },
            {
              "name": "output-workflow-trace",
              "sourceUrl": "https://github.com/growthxai/output/blob/69255d7fd577139a7828bd219637d067b86a42b1/coding_assistants/claude/plugins/outputai/skills/output-workflow-trace/SKILL.md"
            }
          ],
          "mcpServers": [],
          "components": ["skills", "hooks", "agents"],
          "componentInspection": "repository",
          "inspectionError": null,
          "installation": "requires_adapter",
          "upstream": {
            "source": {
              "source": "git-subdir",
              "url": "https://github.com/growthxai/output.git",
              "path": "coding_assistants/claude/plugins/outputai",
              "ref": "main",
              "sha": "69255d7fd577139a7828bd219637d067b86a42b1"
            },
            "policy": null
          }
        },
        {
          "id": "anthropic:pagerduty",
          "name": "pagerduty",
          "displayName": "pagerduty",
          "description": "A collection of Claude Code plugins developed by PagerDuty for pre-commit risk assessment and PagerDuty skill creation for AI agents (Early Access).",
          "longDescription": "A collection of Claude Code plugins developed by PagerDuty for pre-commit risk assessment and PagerDuty skill creation for AI agents (Early Access).",
          "category": "monitoring",
          "keywords": [],
          "author": {
            "name": "PagerDuty"
          },
          "version": "1.1.0",
          "license": null,
          "logoUrl": null,
          "darkLogoUrl": null,
          "homepage": "https://github.com/PagerDuty/claude-code-plugins",
          "sourceUrl": "https://github.com/PagerDuty/claude-code-plugins/tree/761cba75bd50fd561405c3b173ecf36084432089/",
          "skills": [],
          "mcpServers": [
            {
              "requiresConfiguration": true,
              "name": "pagerduty",
              "transport": "http",
              "endpoint": "https://mcp.pagerduty.com/mcp"
            }
          ],
          "components": ["mcp", "commands"],
          "componentInspection": "repository",
          "inspectionError": null,
          "installation": "requires_adapter",
          "upstream": {
            "source": {
              "source": "url",
              "url": "https://github.com/PagerDuty/claude-code-plugins.git",
              "sha": "761cba75bd50fd561405c3b173ecf36084432089"
            },
            "policy": null
          }
        },
        {
          "id": "anthropic:paypal",
          "name": "paypal",
          "displayName": "paypal",
          "description": "PayPal development plugin for Claude — integrate payments, subscriptions, invoices, disputes, and more using PayPal's APIs and MCP server",
          "longDescription": "PayPal development plugin for Claude — integrate payments, subscriptions, invoices, disputes, and more using PayPal's APIs and MCP server",
          "category": "development",
          "keywords": [
            "paypal",
            "payments",
            "checkout",
            "subscriptions",
            "invoices",
            "disputes",
            "mcp",
            "commerce"
          ],
          "author": {
            "name": "PayPal",
            "url": "https://developer.paypal.com"
          },
          "version": "1.0.0",
          "license": "Apache-2.0",
          "logoUrl": null,
          "darkLogoUrl": null,
          "homepage": "https://developer.paypal.com/docs/",
          "sourceUrl": "https://github.com/paypal/AI-Toolkit/tree/310b4962f0e5b3d09ff1c909d96ad5e226703ecb/",
          "skills": [
            {
              "name": "paypal-best-practices",
              "sourceUrl": "https://github.com/paypal/AI-Toolkit/blob/310b4962f0e5b3d09ff1c909d96ad5e226703ecb/skills/paypal-best-practices/SKILL.md"
            },
            {
              "name": "paypal-routing",
              "sourceUrl": "https://github.com/paypal/AI-Toolkit/blob/310b4962f0e5b3d09ff1c909d96ad5e226703ecb/skills/paypal-routing/SKILL.md"
            }
          ],
          "mcpServers": [
            {
              "requiresConfiguration": true,
              "name": "paypal-sandbox",
              "transport": "sse",
              "endpoint": "https://mcp.sandbox.paypal.com/sse"
            }
          ],
          "components": ["skills", "mcp", "hooks", "commands"],
          "componentInspection": "repository",
          "inspectionError": null,
          "installation": "requires_adapter",
          "upstream": {
            "source": {
              "source": "url",
              "url": "https://github.com/paypal/AI-Toolkit.git",
              "sha": "310b4962f0e5b3d09ff1c909d96ad5e226703ecb"
            },
            "policy": null
          }
        },
        {
          "id": "anthropic:php-lsp",
          "name": "php-lsp",
          "displayName": "php-lsp",
          "description": "PHP language server (Intelephense) for code intelligence",
          "longDescription": "PHP language server (Intelephense) for code intelligence",
          "category": "development",
          "keywords": [],
          "author": {
            "name": "Anthropic",
            "email": "support@anthropic.com"
          },
          "version": "1.0.0",
          "license": null,
          "logoUrl": null,
          "darkLogoUrl": null,
          "homepage": null,
          "sourceUrl": "https://github.com/anthropics/claude-plugins-official/tree/3b600518a637492d37c9877aeb49c2a55d939c04/plugins/php-lsp",
          "skills": [],
          "mcpServers": [],
          "components": [],
          "componentInspection": "repository",
          "inspectionError": null,
          "installation": "requires_adapter",
          "upstream": {
            "source": "./plugins/php-lsp",
            "policy": null
          }
        },
        {
          "id": "anthropic:pigment",
          "name": "pigment",
          "displayName": "pigment",
          "description": "Analyze business data and build planning models in your Pigment workspace",
          "longDescription": "Analyze business data and build planning models in your Pigment workspace",
          "category": "productivity",
          "keywords": [],
          "author": {
            "name": "Pigment"
          },
          "version": "1.0.14",
          "license": null,
          "logoUrl": null,
          "darkLogoUrl": null,
          "homepage": "https://www.pigment.com",
          "sourceUrl": "https://github.com/gopigment/ai-plugins/tree/673e6994c9cc9745e1b5655a0dc4ba3607bb08ee/",
          "skills": [
            {
              "name": "analyzing-pigment-data",
              "sourceUrl": "https://github.com/gopigment/ai-plugins/blob/673e6994c9cc9745e1b5655a0dc4ba3607bb08ee/skills/analyzing-pigment-data/SKILL.md"
            },
            {
              "name": "building-pigment-frames",
              "sourceUrl": "https://github.com/gopigment/ai-plugins/blob/673e6994c9cc9745e1b5655a0dc4ba3607bb08ee/skills/building-pigment-frames/SKILL.md"
            },
            {
              "name": "designing-boards",
              "sourceUrl": "https://github.com/gopigment/ai-plugins/blob/673e6994c9cc9745e1b5655a0dc4ba3607bb08ee/skills/designing-boards/SKILL.md"
            },
            {
              "name": "designing-views",
              "sourceUrl": "https://github.com/gopigment/ai-plugins/blob/673e6994c9cc9745e1b5655a0dc4ba3607bb08ee/skills/designing-views/SKILL.md"
            },
            {
              "name": "formatting-and-highlighting",
              "sourceUrl": "https://github.com/gopigment/ai-plugins/blob/673e6994c9cc9745e1b5655a0dc4ba3607bb08ee/skills/formatting-and-highlighting/SKILL.md"
            },
            {
              "name": "integrating-pigment-data",
              "sourceUrl": "https://github.com/gopigment/ai-plugins/blob/673e6994c9cc9745e1b5655a0dc4ba3607bb08ee/skills/integrating-pigment-data/SKILL.md"
            },
            {
              "name": "modeling-pigment-applications",
              "sourceUrl": "https://github.com/gopigment/ai-plugins/blob/673e6994c9cc9745e1b5655a0dc4ba3607bb08ee/skills/modeling-pigment-applications/SKILL.md"
            },
            {
              "name": "optimizing-pigment-performance",
              "sourceUrl": "https://github.com/gopigment/ai-plugins/blob/673e6994c9cc9745e1b5655a0dc4ba3607bb08ee/skills/optimizing-pigment-performance/SKILL.md"
            },
            {
              "name": "planning-cycles-pigment-applications",
              "sourceUrl": "https://github.com/gopigment/ai-plugins/blob/673e6994c9cc9745e1b5655a0dc4ba3607bb08ee/skills/planning-cycles-pigment-applications/SKILL.md"
            },
            {
              "name": "securing-pigment-applications",
              "sourceUrl": "https://github.com/gopigment/ai-plugins/blob/673e6994c9cc9745e1b5655a0dc4ba3607bb08ee/skills/securing-pigment-applications/SKILL.md"
            },
            {
              "name": "solving-specific-use-cases",
              "sourceUrl": "https://github.com/gopigment/ai-plugins/blob/673e6994c9cc9745e1b5655a0dc4ba3607bb08ee/skills/solving-specific-use-cases/SKILL.md"
            },
            {
              "name": "writing-pigment-formulas",
              "sourceUrl": "https://github.com/gopigment/ai-plugins/blob/673e6994c9cc9745e1b5655a0dc4ba3607bb08ee/skills/writing-pigment-formulas/SKILL.md"
            }
          ],
          "mcpServers": [
            {
              "requiresConfiguration": false,
              "name": "pigment",
              "transport": "http",
              "endpoint": "https://pigment.app/api/mcp/public/{your-mcp-id}"
            }
          ],
          "components": ["skills", "mcp"],
          "componentInspection": "repository",
          "inspectionError": null,
          "installation": "requires_adapter",
          "upstream": {
            "source": {
              "source": "url",
              "url": "https://github.com/gopigment/ai-plugins.git",
              "sha": "673e6994c9cc9745e1b5655a0dc4ba3607bb08ee"
            },
            "policy": null
          }
        },
        {
          "id": "anthropic:pinecone",
          "name": "pinecone",
          "displayName": "pinecone",
          "description": "Pinecone vector database integration. Streamline your Pinecone development with powerful tools for managing vector indexes, querying data, and rapid prototyping. Use slash commands like /quickstart to generate AGENTS.md files and initialize Python projects and /query to quickly explore indexes. Access the Pinecone MCP server for creating, describing, upserting and querying indexes with Claude. Perfect for developers building semantic search, RAG applications, recommendation systems, and other vector-based applications with Pinecone.",
          "longDescription": "Pinecone vector database integration. Streamline your Pinecone development with powerful tools for managing vector indexes, querying data, and rapid prototyping. Use slash commands like /quickstart to generate AGENTS.md files and initialize Python projects and /query to quickly explore indexes. Access the Pinecone MCP server for creating, describing, upserting and querying indexes with Claude. Perfect for developers building semantic search, RAG applications, recommendation systems, and other vector-based applications with Pinecone.",
          "category": "database",
          "keywords": [
            "pinecone",
            "semantic search",
            "retrieval",
            "vector search",
            "vector database",
            "retrieval augmented generation",
            "rag",
            "agentic rag",
            "sparse search",
            "assistant",
            "pinecone assistant",
            "rag chatbot",
            "full text search",
            "bm25",
            "hybrid search"
          ],
          "author": {
            "name": "Pinecone"
          },
          "version": "1.7.0",
          "license": null,
          "logoUrl": null,
          "darkLogoUrl": null,
          "homepage": "https://github.com/pinecone-io/pinecone-claude-code-plugin",
          "sourceUrl": "https://github.com/pinecone-io/pinecone-claude-code-plugin/tree/db29e063ce51322e962fe477a7cebaf6729a7eed/",
          "skills": [
            {
              "name": "assistant",
              "sourceUrl": "https://github.com/pinecone-io/pinecone-claude-code-plugin/blob/db29e063ce51322e962fe477a7cebaf6729a7eed/skills/assistant/SKILL.md"
            },
            {
              "name": "cli",
              "sourceUrl": "https://github.com/pinecone-io/pinecone-claude-code-plugin/blob/db29e063ce51322e962fe477a7cebaf6729a7eed/skills/cli/SKILL.md"
            },
            {
              "name": "docs",
              "sourceUrl": "https://github.com/pinecone-io/pinecone-claude-code-plugin/blob/db29e063ce51322e962fe477a7cebaf6729a7eed/skills/docs/SKILL.md"
            },
            {
              "name": "full-text-search",
              "sourceUrl": "https://github.com/pinecone-io/pinecone-claude-code-plugin/blob/db29e063ce51322e962fe477a7cebaf6729a7eed/skills/full-text-search/SKILL.md"
            },
            {
              "name": "help",
              "sourceUrl": "https://github.com/pinecone-io/pinecone-claude-code-plugin/blob/db29e063ce51322e962fe477a7cebaf6729a7eed/skills/help/SKILL.md"
            },
            {
              "name": "mcp",
              "sourceUrl": "https://github.com/pinecone-io/pinecone-claude-code-plugin/blob/db29e063ce51322e962fe477a7cebaf6729a7eed/skills/mcp/SKILL.md"
            },
            {
              "name": "n8n",
              "sourceUrl": "https://github.com/pinecone-io/pinecone-claude-code-plugin/blob/db29e063ce51322e962fe477a7cebaf6729a7eed/skills/n8n/SKILL.md"
            },
            {
              "name": "query",
              "sourceUrl": "https://github.com/pinecone-io/pinecone-claude-code-plugin/blob/db29e063ce51322e962fe477a7cebaf6729a7eed/skills/query/SKILL.md"
            },
            {
              "name": "quickstart",
              "sourceUrl": "https://github.com/pinecone-io/pinecone-claude-code-plugin/blob/db29e063ce51322e962fe477a7cebaf6729a7eed/skills/quickstart/SKILL.md"
            }
          ],
          "mcpServers": [
            {
              "requiresConfiguration": false,
              "name": "pinecone",
              "transport": "stdio",
              "endpoint": null
            }
          ],
          "components": ["skills", "mcp", "hooks", "commands"],
          "componentInspection": "repository",
          "inspectionError": null,
          "installation": "requires_adapter",
          "upstream": {
            "source": {
              "source": "url",
              "url": "https://github.com/pinecone-io/pinecone-claude-code-plugin.git",
              "sha": "db29e063ce51322e962fe477a7cebaf6729a7eed"
            },
            "policy": null
          }
        },
        {
          "id": "anthropic:pixeltable",
          "name": "pixeltable",
          "displayName": "pixeltable",
          "description": "Build multimodal AI applications with Pixeltable -- tables, computed columns, embedding search, UDFs, tool-calling agents, and 25+ AI provider integrations.",
          "longDescription": "Build multimodal AI applications with Pixeltable -- tables, computed columns, embedding search, UDFs, tool-calling agents, and 25+ AI provider integrations.",
          "category": "development",
          "keywords": [],
          "author": {
            "name": "Pixeltable",
            "url": "https://github.com/pixeltable"
          },
          "version": "2.8.0",
          "license": null,
          "logoUrl": null,
          "darkLogoUrl": null,
          "homepage": "https://docs.pixeltable.com",
          "sourceUrl": "https://github.com/pixeltable/pixeltable-skill/tree/e1e47d2a3f015c0fe2ea78df57bbb4bb945ecc14/",
          "skills": [
            {
              "name": "pixeltable-skill",
              "sourceUrl": "https://github.com/pixeltable/pixeltable-skill/blob/e1e47d2a3f015c0fe2ea78df57bbb4bb945ecc14/skills/pixeltable-skill/SKILL.md"
            }
          ],
          "mcpServers": [],
          "components": ["skills", "hooks", "agents", "commands"],
          "componentInspection": "repository",
          "inspectionError": null,
          "installation": "requires_adapter",
          "upstream": {
            "source": {
              "source": "url",
              "url": "https://github.com/pixeltable/pixeltable-skill.git",
              "sha": "e1e47d2a3f015c0fe2ea78df57bbb4bb945ecc14"
            },
            "policy": null
          }
        },
        {
          "id": "anthropic:planetscale",
          "name": "planetscale",
          "displayName": "planetscale",
          "description": "An authenticated hosted MCP server that accesses your PlanetScale organizations, databases, branches, schema, and Insights data.",
          "longDescription": "An authenticated hosted MCP server that accesses your PlanetScale organizations, databases, branches, schema, and Insights data.",
          "category": "database",
          "keywords": [],
          "author": {
            "name": "PlanetScale"
          },
          "version": "1.1.1",
          "license": null,
          "logoUrl": null,
          "darkLogoUrl": null,
          "homepage": "https://planetscale.com/",
          "sourceUrl": "https://github.com/planetscale/claude-plugin/tree/95c80f9f391be9b1b6172bf82d4191e1ec11b637/",
          "skills": [
            {
              "name": "mysql",
              "sourceUrl": "https://github.com/planetscale/claude-plugin/blob/95c80f9f391be9b1b6172bf82d4191e1ec11b637/database-skills/skills/mysql/SKILL.md"
            },
            {
              "name": "neki",
              "sourceUrl": "https://github.com/planetscale/claude-plugin/blob/95c80f9f391be9b1b6172bf82d4191e1ec11b637/database-skills/skills/neki/SKILL.md"
            },
            {
              "name": "postgres",
              "sourceUrl": "https://github.com/planetscale/claude-plugin/blob/95c80f9f391be9b1b6172bf82d4191e1ec11b637/database-skills/skills/postgres/SKILL.md"
            },
            {
              "name": "vitess",
              "sourceUrl": "https://github.com/planetscale/claude-plugin/blob/95c80f9f391be9b1b6172bf82d4191e1ec11b637/database-skills/skills/vitess/SKILL.md"
            },
            {
              "name": "00-safe-orchestrator",
              "sourceUrl": "https://github.com/planetscale/claude-plugin/blob/95c80f9f391be9b1b6172bf82d4191e1ec11b637/planetscale-skills/00-safe-orchestrator/SKILL.md"
            },
            {
              "name": "01-readonly-inventory",
              "sourceUrl": "https://github.com/planetscale/claude-plugin/blob/95c80f9f391be9b1b6172bf82d4191e1ec11b637/planetscale-skills/01-readonly-inventory/SKILL.md"
            },
            {
              "name": "02-vitess-safety-review",
              "sourceUrl": "https://github.com/planetscale/claude-plugin/blob/95c80f9f391be9b1b6172bf82d4191e1ec11b637/planetscale-skills/02-vitess-safety-review/SKILL.md"
            },
            {
              "name": "03-postgres-safety-review",
              "sourceUrl": "https://github.com/planetscale/claude-plugin/blob/95c80f9f391be9b1b6172bf82d4191e1ec11b637/planetscale-skills/03-postgres-safety-review/SKILL.md"
            },
            {
              "name": "04-query-insights-and-tags",
              "sourceUrl": "https://github.com/planetscale/claude-plugin/blob/95c80f9f391be9b1b6172bf82d4191e1ec11b637/planetscale-skills/04-query-insights-and-tags/SKILL.md"
            },
            {
              "name": "05-traffic-control-recommendations",
              "sourceUrl": "https://github.com/planetscale/claude-plugin/blob/95c80f9f391be9b1b6172bf82d4191e1ec11b637/planetscale-skills/05-traffic-control-recommendations/SKILL.md"
            },
            {
              "name": "06-webhook-automation-recommendations",
              "sourceUrl": "https://github.com/planetscale/claude-plugin/blob/95c80f9f391be9b1b6172bf82d4191e1ec11b637/planetscale-skills/06-webhook-automation-recommendations/SKILL.md"
            },
            {
              "name": "07-schema-recommendations-agent-loop",
              "sourceUrl": "https://github.com/planetscale/claude-plugin/blob/95c80f9f391be9b1b6172bf82d4191e1ec11b637/planetscale-skills/07-schema-recommendations-agent-loop/SKILL.md"
            },
            {
              "name": "08-codebase-sqlcommenter-instrumentation",
              "sourceUrl": "https://github.com/planetscale/claude-plugin/blob/95c80f9f391be9b1b6172bf82d4191e1ec11b637/planetscale-skills/08-codebase-sqlcommenter-instrumentation/SKILL.md"
            },
            {
              "name": "09-mcp-agent-operating-model",
              "sourceUrl": "https://github.com/planetscale/claude-plugin/blob/95c80f9f391be9b1b6172bf82d4191e1ec11b637/planetscale-skills/09-mcp-agent-operating-model/SKILL.md"
            },
            {
              "name": "10-customer-report-template",
              "sourceUrl": "https://github.com/planetscale/claude-plugin/blob/95c80f9f391be9b1b6172bf82d4191e1ec11b637/planetscale-skills/10-customer-report-template/SKILL.md"
            },
            {
              "name": "11-change-gates-and-approval-contract",
              "sourceUrl": "https://github.com/planetscale/claude-plugin/blob/95c80f9f391be9b1b6172bf82d4191e1ec11b637/planetscale-skills/11-change-gates-and-approval-contract/SKILL.md"
            },
            {
              "name": "12-best-practices-matrix",
              "sourceUrl": "https://github.com/planetscale/claude-plugin/blob/95c80f9f391be9b1b6172bf82d4191e1ec11b637/planetscale-skills/12-best-practices-matrix/SKILL.md"
            },
            {
              "name": "13-autonomous-execution-mode",
              "sourceUrl": "https://github.com/planetscale/claude-plugin/blob/95c80f9f391be9b1b6172bf82d4191e1ec11b637/planetscale-skills/13-autonomous-execution-mode/SKILL.md"
            },
            {
              "name": "14-pscale-cli-automation",
              "sourceUrl": "https://github.com/planetscale/claude-plugin/blob/95c80f9f391be9b1b6172bf82d4191e1ec11b637/planetscale-skills/14-pscale-cli-automation/SKILL.md"
            }
          ],
          "mcpServers": [
            {
              "requiresConfiguration": false,
              "name": "planetscale",
              "transport": "http",
              "endpoint": "https://mcp.pscale.dev/mcp/planetscale"
            }
          ],
          "components": ["skills", "mcp"],
          "componentInspection": "repository",
          "inspectionError": null,
          "installation": "requires_adapter",
          "upstream": {
            "source": {
              "source": "url",
              "url": "https://github.com/planetscale/claude-plugin.git",
              "sha": "95c80f9f391be9b1b6172bf82d4191e1ec11b637"
            },
            "policy": null
          }
        },
        {
          "id": "anthropic:playground",
          "name": "playground",
          "displayName": "playground",
          "description": "Creates interactive HTML playgrounds — self-contained single-file explorers with visual controls, live preview, and prompt output with copy button",
          "longDescription": "Creates interactive HTML playgrounds — self-contained single-file explorers with visual controls, live preview, and prompt output with copy button",
          "category": "development",
          "keywords": [],
          "author": {
            "name": "Anthropic",
            "email": "support@anthropic.com"
          },
          "version": null,
          "license": null,
          "logoUrl": null,
          "darkLogoUrl": null,
          "homepage": "https://github.com/anthropics/claude-plugins-official/tree/main/plugins/playground",
          "sourceUrl": "https://github.com/anthropics/claude-plugins-official/tree/3b600518a637492d37c9877aeb49c2a55d939c04/plugins/playground",
          "skills": [
            {
              "name": "playground",
              "sourceUrl": "https://github.com/anthropics/claude-plugins-official/blob/3b600518a637492d37c9877aeb49c2a55d939c04/plugins/playground/skills/playground/SKILL.md"
            }
          ],
          "mcpServers": [],
          "components": ["skills"],
          "componentInspection": "repository",
          "inspectionError": null,
          "installation": "requires_adapter",
          "upstream": {
            "source": "./plugins/playground",
            "policy": null
          }
        },
        {
          "id": "anthropic:playwright",
          "name": "playwright",
          "displayName": "playwright",
          "description": "Browser automation and end-to-end testing MCP server by Microsoft. Enables Claude to interact with web pages, take screenshots, fill forms, click elements, and perform automated browser testing workflows.",
          "longDescription": "Browser automation and end-to-end testing MCP server by Microsoft. Enables Claude to interact with web pages, take screenshots, fill forms, click elements, and perform automated browser testing workflows.",
          "category": "testing",
          "keywords": [],
          "author": {
            "name": "Microsoft"
          },
          "version": null,
          "license": null,
          "logoUrl": null,
          "darkLogoUrl": null,
          "homepage": "https://github.com/anthropics/claude-plugins-public/tree/main/external_plugins/playwright",
          "sourceUrl": "https://github.com/anthropics/claude-plugins-official/tree/3b600518a637492d37c9877aeb49c2a55d939c04/external_plugins/playwright",
          "skills": [],
          "mcpServers": [
            {
              "requiresConfiguration": false,
              "name": "playwright",
              "transport": "stdio",
              "endpoint": null
            }
          ],
          "components": ["mcp"],
          "componentInspection": "repository",
          "inspectionError": null,
          "installation": "requires_adapter",
          "upstream": {
            "source": "./external_plugins/playwright",
            "policy": null
          }
        },
        {
          "id": "anthropic:plugin-dev",
          "name": "plugin-dev",
          "displayName": "plugin-dev",
          "description": "Plugin development toolkit with skills for creating agents, commands, hooks, MCP integrations, and comprehensive plugin structure guidance",
          "longDescription": "Plugin development toolkit with skills for creating agents, commands, hooks, MCP integrations, and comprehensive plugin structure guidance",
          "category": "development",
          "keywords": [],
          "author": {
            "name": "Anthropic",
            "email": "support@anthropic.com"
          },
          "version": null,
          "license": null,
          "logoUrl": null,
          "darkLogoUrl": null,
          "homepage": "https://github.com/anthropics/claude-plugins-public/tree/main/plugins/plugin-dev",
          "sourceUrl": "https://github.com/anthropics/claude-plugins-official/tree/3b600518a637492d37c9877aeb49c2a55d939c04/plugins/plugin-dev",
          "skills": [
            {
              "name": "agent-development",
              "sourceUrl": "https://github.com/anthropics/claude-plugins-official/blob/3b600518a637492d37c9877aeb49c2a55d939c04/plugins/plugin-dev/skills/agent-development/SKILL.md"
            },
            {
              "name": "command-development",
              "sourceUrl": "https://github.com/anthropics/claude-plugins-official/blob/3b600518a637492d37c9877aeb49c2a55d939c04/plugins/plugin-dev/skills/command-development/SKILL.md"
            },
            {
              "name": "hook-development",
              "sourceUrl": "https://github.com/anthropics/claude-plugins-official/blob/3b600518a637492d37c9877aeb49c2a55d939c04/plugins/plugin-dev/skills/hook-development/SKILL.md"
            },
            {
              "name": "mcp-integration",
              "sourceUrl": "https://github.com/anthropics/claude-plugins-official/blob/3b600518a637492d37c9877aeb49c2a55d939c04/plugins/plugin-dev/skills/mcp-integration/SKILL.md"
            },
            {
              "name": "plugin-settings",
              "sourceUrl": "https://github.com/anthropics/claude-plugins-official/blob/3b600518a637492d37c9877aeb49c2a55d939c04/plugins/plugin-dev/skills/plugin-settings/SKILL.md"
            },
            {
              "name": "plugin-structure",
              "sourceUrl": "https://github.com/anthropics/claude-plugins-official/blob/3b600518a637492d37c9877aeb49c2a55d939c04/plugins/plugin-dev/skills/plugin-structure/SKILL.md"
            },
            {
              "name": "skill-development",
              "sourceUrl": "https://github.com/anthropics/claude-plugins-official/blob/3b600518a637492d37c9877aeb49c2a55d939c04/plugins/plugin-dev/skills/skill-development/SKILL.md"
            }
          ],
          "mcpServers": [],
          "components": ["skills", "agents", "commands"],
          "componentInspection": "repository",
          "inspectionError": null,
          "installation": "requires_adapter",
          "upstream": {
            "source": "./plugins/plugin-dev",
            "policy": null
          }
        },
        {
          "id": "anthropic:posthog",
          "name": "posthog",
          "displayName": "posthog",
          "description": "Access PostHog analytics, feature flags, experiments, error tracking, and insights directly from your AI coding tool. Optionally capture Claude Code sessions to PostHog LLM Analytics.",
          "longDescription": "Access PostHog analytics, feature flags, experiments, error tracking, and insights directly from your AI coding tool. Optionally capture Claude Code sessions to PostHog LLM Analytics.",
          "category": "monitoring",
          "keywords": [
            "analytics",
            "feature-flags",
            "experiments",
            "error-tracking",
            "a/b-testing",
            "surveys",
            "dashboards",
            "llm-analytics"
          ],
          "author": {
            "name": "PostHog",
            "email": "hey@posthog.com",
            "url": "https://posthog.com"
          },
          "version": "1.1.62",
          "license": "MIT",
          "logoUrl": null,
          "darkLogoUrl": null,
          "homepage": "https://posthog.com/docs/model-context-protocol",
          "sourceUrl": "https://github.com/PostHog/ai-plugin/tree/19e4737aa8ab3db315e43f35f796976a1ac37787/",
          "skills": [
            {
              "name": "adding-warehouse-person-properties",
              "sourceUrl": "https://github.com/PostHog/ai-plugin/blob/19e4737aa8ab3db315e43f35f796976a1ac37787/skills/adding-warehouse-person-properties/SKILL.md"
            },
            {
              "name": "analyzing-expensive-users",
              "sourceUrl": "https://github.com/PostHog/ai-plugin/blob/19e4737aa8ab3db315e43f35f796976a1ac37787/skills/analyzing-expensive-users/SKILL.md"
            },
            {
              "name": "analyzing-experiment-session-replays",
              "sourceUrl": "https://github.com/PostHog/ai-plugin/blob/19e4737aa8ab3db315e43f35f796976a1ac37787/skills/analyzing-experiment-session-replays/SKILL.md"
            },
            {
              "name": "analyzing-task-runs",
              "sourceUrl": "https://github.com/PostHog/ai-plugin/blob/19e4737aa8ab3db315e43f35f796976a1ac37787/skills/analyzing-task-runs/SKILL.md"
            },
            {
              "name": "assessing-heatmaps",
              "sourceUrl": "https://github.com/PostHog/ai-plugin/blob/19e4737aa8ab3db315e43f35f796976a1ac37787/skills/assessing-heatmaps/SKILL.md"
            },
            {
              "name": "auditing-endpoints",
              "sourceUrl": "https://github.com/PostHog/ai-plugin/blob/19e4737aa8ab3db315e43f35f796976a1ac37787/skills/auditing-endpoints/SKILL.md"
            },
            {
              "name": "auditing-experiments-flags",
              "sourceUrl": "https://github.com/PostHog/ai-plugin/blob/19e4737aa8ab3db315e43f35f796976a1ac37787/skills/auditing-experiments-flags/SKILL.md"
            },
            {
              "name": "auditing-warehouse-source-health",
              "sourceUrl": "https://github.com/PostHog/ai-plugin/blob/19e4737aa8ab3db315e43f35f796976a1ac37787/skills/auditing-warehouse-source-health/SKILL.md"
            },
            {
              "name": "auditing-warehouse-view-health",
              "sourceUrl": "https://github.com/PostHog/ai-plugin/blob/19e4737aa8ab3db315e43f35f796976a1ac37787/skills/auditing-warehouse-view-health/SKILL.md"
            },
            {
              "name": "authoring-data-quality-checks",
              "sourceUrl": "https://github.com/PostHog/ai-plugin/blob/19e4737aa8ab3db315e43f35f796976a1ac37787/skills/authoring-data-quality-checks/SKILL.md"
            },
            {
              "name": "authoring-error-tracking-alerts",
              "sourceUrl": "https://github.com/PostHog/ai-plugin/blob/19e4737aa8ab3db315e43f35f796976a1ac37787/skills/authoring-error-tracking-alerts/SKILL.md"
            },
            {
              "name": "authoring-log-alerts",
              "sourceUrl": "https://github.com/PostHog/ai-plugin/blob/19e4737aa8ab3db315e43f35f796976a1ac37787/skills/authoring-log-alerts/SKILL.md"
            },
            {
              "name": "authoring-scouts",
              "sourceUrl": "https://github.com/PostHog/ai-plugin/blob/19e4737aa8ab3db315e43f35f796976a1ac37787/skills/authoring-scouts/SKILL.md"
            },
            {
              "name": "building-a-dashboard",
              "sourceUrl": "https://github.com/PostHog/ai-plugin/blob/19e4737aa8ab3db315e43f35f796976a1ac37787/skills/building-a-dashboard/SKILL.md"
            },
            {
              "name": "building-canvases",
              "sourceUrl": "https://github.com/PostHog/ai-plugin/blob/19e4737aa8ab3db315e43f35f796976a1ac37787/skills/building-canvases/SKILL.md"
            },
            {
              "name": "building-html-canvases",
              "sourceUrl": "https://github.com/PostHog/ai-plugin/blob/19e4737aa8ab3db315e43f35f796976a1ac37787/skills/building-html-canvases/SKILL.md"
            },
            {
              "name": "building-react-quill-canvases",
              "sourceUrl": "https://github.com/PostHog/ai-plugin/blob/19e4737aa8ab3db315e43f35f796976a1ac37787/skills/building-react-quill-canvases/SKILL.md"
            },
            {
              "name": "building-workflows",
              "sourceUrl": "https://github.com/PostHog/ai-plugin/blob/19e4737aa8ab3db315e43f35f796976a1ac37787/skills/building-workflows/SKILL.md"
            },
            {
              "name": "checking-deploy-timing",
              "sourceUrl": "https://github.com/PostHog/ai-plugin/blob/19e4737aa8ab3db315e43f35f796976a1ac37787/skills/checking-deploy-timing/SKILL.md"
            },
            {
              "name": "choosing-trend-or-slope-view",
              "sourceUrl": "https://github.com/PostHog/ai-plugin/blob/19e4737aa8ab3db315e43f35f796976a1ac37787/skills/choosing-trend-or-slope-view/SKILL.md"
            },
            {
              "name": "cleaning-up-stale-feature-flags",
              "sourceUrl": "https://github.com/PostHog/ai-plugin/blob/19e4737aa8ab3db315e43f35f796976a1ac37787/skills/cleaning-up-stale-feature-flags/SKILL.md"
            },
            {
              "name": "composing-grid-canvases",
              "sourceUrl": "https://github.com/PostHog/ai-plugin/blob/19e4737aa8ab3db315e43f35f796976a1ac37787/skills/composing-grid-canvases/SKILL.md"
            },
            {
              "name": "configuring-experiment-analytics",
              "sourceUrl": "https://github.com/PostHog/ai-plugin/blob/19e4737aa8ab3db315e43f35f796976a1ac37787/skills/configuring-experiment-analytics/SKILL.md"
            },
            {
              "name": "configuring-experiment-rollout",
              "sourceUrl": "https://github.com/PostHog/ai-plugin/blob/19e4737aa8ab3db315e43f35f796976a1ac37787/skills/configuring-experiment-rollout/SKILL.md"
            },
            {
              "name": "consuming-endpoints-from-client-code",
              "sourceUrl": "https://github.com/PostHog/ai-plugin/blob/19e4737aa8ab3db315e43f35f796976a1ac37787/skills/consuming-endpoints-from-client-code/SKILL.md"
            },
            {
              "name": "context-layer-consolidation",
              "sourceUrl": "https://github.com/PostHog/ai-plugin/blob/19e4737aa8ab3db315e43f35f796976a1ac37787/skills/context-layer-consolidation/SKILL.md"
            },
            {
              "name": "context-layer-dreaming",
              "sourceUrl": "https://github.com/PostHog/ai-plugin/blob/19e4737aa8ab3db315e43f35f796976a1ac37787/skills/context-layer-dreaming/SKILL.md"
            },
            {
              "name": "context-layer-health-check",
              "sourceUrl": "https://github.com/PostHog/ai-plugin/blob/19e4737aa8ab3db315e43f35f796976a1ac37787/skills/context-layer-health-check/SKILL.md"
            },
            {
              "name": "copying-endpoints-across-projects",
              "sourceUrl": "https://github.com/PostHog/ai-plugin/blob/19e4737aa8ab3db315e43f35f796976a1ac37787/skills/copying-endpoints-across-projects/SKILL.md"
            },
            {
              "name": "copying-flags-across-projects",
              "sourceUrl": "https://github.com/PostHog/ai-plugin/blob/19e4737aa8ab3db315e43f35f796976a1ac37787/skills/copying-flags-across-projects/SKILL.md"
            },
            {
              "name": "creating-ai-subscription",
              "sourceUrl": "https://github.com/PostHog/ai-plugin/blob/19e4737aa8ab3db315e43f35f796976a1ac37787/skills/creating-ai-subscription/SKILL.md"
            },
            {
              "name": "creating-an-endpoint",
              "sourceUrl": "https://github.com/PostHog/ai-plugin/blob/19e4737aa8ab3db315e43f35f796976a1ac37787/skills/creating-an-endpoint/SKILL.md"
            },
            {
              "name": "creating-box-plot-insights",
              "sourceUrl": "https://github.com/PostHog/ai-plugin/blob/19e4737aa8ab3db315e43f35f796976a1ac37787/skills/creating-box-plot-insights/SKILL.md"
            },
            {
              "name": "creating-experiments",
              "sourceUrl": "https://github.com/PostHog/ai-plugin/blob/19e4737aa8ab3db315e43f35f796976a1ac37787/skills/creating-experiments/SKILL.md"
            },
            {
              "name": "creating-online-evaluations",
              "sourceUrl": "https://github.com/PostHog/ai-plugin/blob/19e4737aa8ab3db315e43f35f796976a1ac37787/skills/creating-online-evaluations/SKILL.md"
            },
            {
              "name": "creating-replay-vision-scanners",
              "sourceUrl": "https://github.com/PostHog/ai-plugin/blob/19e4737aa8ab3db315e43f35f796976a1ac37787/skills/creating-replay-vision-scanners/SKILL.md"
            },
            {
              "name": "debugging-experiments",
              "sourceUrl": "https://github.com/PostHog/ai-plugin/blob/19e4737aa8ab3db315e43f35f796976a1ac37787/skills/debugging-experiments/SKILL.md"
            },
            {
              "name": "debugging-local-replay",
              "sourceUrl": "https://github.com/PostHog/ai-plugin/blob/19e4737aa8ab3db315e43f35f796976a1ac37787/skills/debugging-local-replay/SKILL.md"
            },
            {
              "name": "debugging-mcp-analytics",
              "sourceUrl": "https://github.com/PostHog/ai-plugin/blob/19e4737aa8ab3db315e43f35f796976a1ac37787/skills/debugging-mcp-analytics/SKILL.md"
            },
            {
              "name": "debugging-signals-pipeline",
              "sourceUrl": "https://github.com/PostHog/ai-plugin/blob/19e4737aa8ab3db315e43f35f796976a1ac37787/skills/debugging-signals-pipeline/SKILL.md"
            },
            {
              "name": "debugging-surveys",
              "sourceUrl": "https://github.com/PostHog/ai-plugin/blob/19e4737aa8ab3db315e43f35f796976a1ac37787/skills/debugging-surveys/SKILL.md"
            },
            {
              "name": "designing-email-templates",
              "sourceUrl": "https://github.com/PostHog/ai-plugin/blob/19e4737aa8ab3db315e43f35f796976a1ac37787/skills/designing-email-templates/SKILL.md"
            },
            {
              "name": "diagnosing-ci-and-merge-bottlenecks",
              "sourceUrl": "https://github.com/PostHog/ai-plugin/blob/19e4737aa8ab3db315e43f35f796976a1ac37787/skills/diagnosing-ci-and-merge-bottlenecks/SKILL.md"
            },
            {
              "name": "diagnosing-endpoint-performance",
              "sourceUrl": "https://github.com/PostHog/ai-plugin/blob/19e4737aa8ab3db315e43f35f796976a1ac37787/skills/diagnosing-endpoint-performance/SKILL.md"
            },
            {
              "name": "diagnosing-experiment-results",
              "sourceUrl": "https://github.com/PostHog/ai-plugin/blob/19e4737aa8ab3db315e43f35f796976a1ac37787/skills/diagnosing-experiment-results/SKILL.md"
            },
            {
              "name": "diagnosing-failed-warehouse-syncs",
              "sourceUrl": "https://github.com/PostHog/ai-plugin/blob/19e4737aa8ab3db315e43f35f796976a1ac37787/skills/diagnosing-failed-warehouse-syncs/SKILL.md"
            },
            {
              "name": "diagnosing-missing-recordings",
              "sourceUrl": "https://github.com/PostHog/ai-plugin/blob/19e4737aa8ab3db315e43f35f796976a1ac37787/skills/diagnosing-missing-recordings/SKILL.md"
            },
            {
              "name": "diagnosing-sdk-health",
              "sourceUrl": "https://github.com/PostHog/ai-plugin/blob/19e4737aa8ab3db315e43f35f796976a1ac37787/skills/diagnosing-sdk-health/SKILL.md"
            },
            {
              "name": "diagnosing-stacktrace-symbolication",
              "sourceUrl": "https://github.com/PostHog/ai-plugin/blob/19e4737aa8ab3db315e43f35f796976a1ac37787/skills/diagnosing-stacktrace-symbolication/SKILL.md"
            },
            {
              "name": "downloading-batch-export-files",
              "sourceUrl": "https://github.com/PostHog/ai-plugin/blob/19e4737aa8ab3db315e43f35f796976a1ac37787/skills/downloading-batch-export-files/SKILL.md"
            },
            {
              "name": "exploring-ai-failures",
              "sourceUrl": "https://github.com/PostHog/ai-plugin/blob/19e4737aa8ab3db315e43f35f796976a1ac37787/skills/exploring-ai-failures/SKILL.md"
            },
            {
              "name": "exploring-apm-traces",
              "sourceUrl": "https://github.com/PostHog/ai-plugin/blob/19e4737aa8ab3db315e43f35f796976a1ac37787/skills/exploring-apm-traces/SKILL.md"
            },
            {
              "name": "exploring-autocapture-events",
              "sourceUrl": "https://github.com/PostHog/ai-plugin/blob/19e4737aa8ab3db315e43f35f796976a1ac37787/skills/exploring-autocapture-events/SKILL.md"
            },
            {
              "name": "exploring-endpoint-execution-logs",
              "sourceUrl": "https://github.com/PostHog/ai-plugin/blob/19e4737aa8ab3db315e43f35f796976a1ac37787/skills/exploring-endpoint-execution-logs/SKILL.md"
            },
            {
              "name": "exploring-live-traffic",
              "sourceUrl": "https://github.com/PostHog/ai-plugin/blob/19e4737aa8ab3db315e43f35f796976a1ac37787/skills/exploring-live-traffic/SKILL.md"
            },
            {
              "name": "exploring-llm-clusters",
              "sourceUrl": "https://github.com/PostHog/ai-plugin/blob/19e4737aa8ab3db315e43f35f796976a1ac37787/skills/exploring-llm-clusters/SKILL.md"
            },
            {
              "name": "exploring-llm-costs",
              "sourceUrl": "https://github.com/PostHog/ai-plugin/blob/19e4737aa8ab3db315e43f35f796976a1ac37787/skills/exploring-llm-costs/SKILL.md"
            },
            {
              "name": "exploring-llm-evaluations",
              "sourceUrl": "https://github.com/PostHog/ai-plugin/blob/19e4737aa8ab3db315e43f35f796976a1ac37787/skills/exploring-llm-evaluations/SKILL.md"
            },
            {
              "name": "exploring-llm-traces",
              "sourceUrl": "https://github.com/PostHog/ai-plugin/blob/19e4737aa8ab3db315e43f35f796976a1ac37787/skills/exploring-llm-traces/SKILL.md"
            },
            {
              "name": "exploring-mcp-intent-clusters",
              "sourceUrl": "https://github.com/PostHog/ai-plugin/blob/19e4737aa8ab3db315e43f35f796976a1ac37787/skills/exploring-mcp-intent-clusters/SKILL.md"
            },
            {
              "name": "exploring-mcp-sessions",
              "sourceUrl": "https://github.com/PostHog/ai-plugin/blob/19e4737aa8ab3db315e43f35f796976a1ac37787/skills/exploring-mcp-sessions/SKILL.md"
            },
            {
              "name": "exploring-mcp-tool-original-user-motive",
              "sourceUrl": "https://github.com/PostHog/ai-plugin/blob/19e4737aa8ab3db315e43f35f796976a1ac37787/skills/exploring-mcp-tool-original-user-motive/SKILL.md"
            },
            {
              "name": "exploring-mcp-tool-quality",
              "sourceUrl": "https://github.com/PostHog/ai-plugin/blob/19e4737aa8ab3db315e43f35f796976a1ac37787/skills/exploring-mcp-tool-quality/SKILL.md"
            },
            {
              "name": "exploring-mcp-tool-usage",
              "sourceUrl": "https://github.com/PostHog/ai-plugin/blob/19e4737aa8ab3db315e43f35f796976a1ac37787/skills/exploring-mcp-tool-usage/SKILL.md"
            },
            {
              "name": "exploring-replay-vision-observations",
              "sourceUrl": "https://github.com/PostHog/ai-plugin/blob/19e4737aa8ab3db315e43f35f796976a1ac37787/skills/exploring-replay-vision-observations/SKILL.md"
            },
            {
              "name": "exploring-scouts",
              "sourceUrl": "https://github.com/PostHog/ai-plugin/blob/19e4737aa8ab3db315e43f35f796976a1ac37787/skills/exploring-scouts/SKILL.md"
            },
            {
              "name": "feature-usage-feed",
              "sourceUrl": "https://github.com/PostHog/ai-plugin/blob/19e4737aa8ab3db315e43f35f796976a1ac37787/skills/feature-usage-feed/SKILL.md"
            },
            {
              "name": "filtering-bot-traffic",
              "sourceUrl": "https://github.com/PostHog/ai-plugin/blob/19e4737aa8ab3db315e43f35f796976a1ac37787/skills/filtering-bot-traffic/SKILL.md"
            },
            {
              "name": "finding-deleted-feature-flags",
              "sourceUrl": "https://github.com/PostHog/ai-plugin/blob/19e4737aa8ab3db315e43f35f796976a1ac37787/skills/finding-deleted-feature-flags/SKILL.md"
            },
            {
              "name": "finding-experiments",
              "sourceUrl": "https://github.com/PostHog/ai-plugin/blob/19e4737aa8ab3db315e43f35f796976a1ac37787/skills/finding-experiments/SKILL.md"
            },
            {
              "name": "finding-replay-for-issue",
              "sourceUrl": "https://github.com/PostHog/ai-plugin/blob/19e4737aa8ab3db315e43f35f796976a1ac37787/skills/finding-replay-for-issue/SKILL.md"
            },
            {
              "name": "finding-sessions-to-watch",
              "sourceUrl": "https://github.com/PostHog/ai-plugin/blob/19e4737aa8ab3db315e43f35f796976a1ac37787/skills/finding-sessions-to-watch/SKILL.md"
            },
            {
              "name": "formatting-insight-axes",
              "sourceUrl": "https://github.com/PostHog/ai-plugin/blob/19e4737aa8ab3db315e43f35f796976a1ac37787/skills/formatting-insight-axes/SKILL.md"
            },
            {
              "name": "grouping-noisy-errors",
              "sourceUrl": "https://github.com/PostHog/ai-plugin/blob/19e4737aa8ab3db315e43f35f796976a1ac37787/skills/grouping-noisy-errors/SKILL.md"
            },
            {
              "name": "improving-mcp-tools",
              "sourceUrl": "https://github.com/PostHog/ai-plugin/blob/19e4737aa8ab3db315e43f35f796976a1ac37787/skills/improving-mcp-tools/SKILL.md"
            },
            {
              "name": "inbox-exploration",
              "sourceUrl": "https://github.com/PostHog/ai-plugin/blob/19e4737aa8ab3db315e43f35f796976a1ac37787/skills/inbox-exploration/SKILL.md"
            },
            {
              "name": "instrument-error-tracking",
              "sourceUrl": "https://github.com/PostHog/ai-plugin/blob/19e4737aa8ab3db315e43f35f796976a1ac37787/skills/instrument-error-tracking/SKILL.md"
            },
            {
              "name": "instrument-feature-flags",
              "sourceUrl": "https://github.com/PostHog/ai-plugin/blob/19e4737aa8ab3db315e43f35f796976a1ac37787/skills/instrument-feature-flags/SKILL.md"
            },
            {
              "name": "instrument-integration",
              "sourceUrl": "https://github.com/PostHog/ai-plugin/blob/19e4737aa8ab3db315e43f35f796976a1ac37787/skills/instrument-integration/SKILL.md"
            },
            {
              "name": "instrument-llm-analytics",
              "sourceUrl": "https://github.com/PostHog/ai-plugin/blob/19e4737aa8ab3db315e43f35f796976a1ac37787/skills/instrument-llm-analytics/SKILL.md"
            },
            {
              "name": "instrument-logs",
              "sourceUrl": "https://github.com/PostHog/ai-plugin/blob/19e4737aa8ab3db315e43f35f796976a1ac37787/skills/instrument-logs/SKILL.md"
            },
            {
              "name": "instrument-metrics",
              "sourceUrl": "https://github.com/PostHog/ai-plugin/blob/19e4737aa8ab3db315e43f35f796976a1ac37787/skills/instrument-metrics/SKILL.md"
            },
            {
              "name": "instrument-product-analytics",
              "sourceUrl": "https://github.com/PostHog/ai-plugin/blob/19e4737aa8ab3db315e43f35f796976a1ac37787/skills/instrument-product-analytics/SKILL.md"
            },
            {
              "name": "investigate-metric",
              "sourceUrl": "https://github.com/PostHog/ai-plugin/blob/19e4737aa8ab3db315e43f35f796976a1ac37787/skills/investigate-metric/SKILL.md"
            },
            {
              "name": "investigating-ci-failures",
              "sourceUrl": "https://github.com/PostHog/ai-plugin/blob/19e4737aa8ab3db315e43f35f796976a1ac37787/skills/investigating-ci-failures/SKILL.md"
            },
            {
              "name": "investigating-error-issue",
              "sourceUrl": "https://github.com/PostHog/ai-plugin/blob/19e4737aa8ab3db315e43f35f796976a1ac37787/skills/investigating-error-issue/SKILL.md"
            },
            {
              "name": "investigating-logs",
              "sourceUrl": "https://github.com/PostHog/ai-plugin/blob/19e4737aa8ab3db315e43f35f796976a1ac37787/skills/investigating-logs/SKILL.md"
            },
            {
              "name": "investigating-metric-anomalies",
              "sourceUrl": "https://github.com/PostHog/ai-plugin/blob/19e4737aa8ab3db315e43f35f796976a1ac37787/skills/investigating-metric-anomalies/SKILL.md"
            },
            {
              "name": "investigating-replay",
              "sourceUrl": "https://github.com/PostHog/ai-plugin/blob/19e4737aa8ab3db315e43f35f796976a1ac37787/skills/investigating-replay/SKILL.md"
            },
            {
              "name": "managing-endpoint-versions",
              "sourceUrl": "https://github.com/PostHog/ai-plugin/blob/19e4737aa8ab3db315e43f35f796976a1ac37787/skills/managing-endpoint-versions/SKILL.md"
            },
            {
              "name": "managing-experiment-lifecycle",
              "sourceUrl": "https://github.com/PostHog/ai-plugin/blob/19e4737aa8ab3db315e43f35f796976a1ac37787/skills/managing-experiment-lifecycle/SKILL.md"
            },
            {
              "name": "managing-path-cleaning-rules",
              "sourceUrl": "https://github.com/PostHog/ai-plugin/blob/19e4737aa8ab3db315e43f35f796976a1ac37787/skills/managing-path-cleaning-rules/SKILL.md"
            },
            {
              "name": "managing-reminders",
              "sourceUrl": "https://github.com/PostHog/ai-plugin/blob/19e4737aa8ab3db315e43f35f796976a1ac37787/skills/managing-reminders/SKILL.md"
            },
            {
              "name": "managing-streamlit-apps",
              "sourceUrl": "https://github.com/PostHog/ai-plugin/blob/19e4737aa8ab3db315e43f35f796976a1ac37787/skills/managing-streamlit-apps/SKILL.md"
            },
            {
              "name": "managing-subscriptions",
              "sourceUrl": "https://github.com/PostHog/ai-plugin/blob/19e4737aa8ab3db315e43f35f796976a1ac37787/skills/managing-subscriptions/SKILL.md"
            },
            {
              "name": "modeling-activation-metrics",
              "sourceUrl": "https://github.com/PostHog/ai-plugin/blob/19e4737aa8ab3db315e43f35f796976a1ac37787/skills/modeling-activation-metrics/SKILL.md"
            },
            {
              "name": "modeling-conversion-metrics",
              "sourceUrl": "https://github.com/PostHog/ai-plugin/blob/19e4737aa8ab3db315e43f35f796976a1ac37787/skills/modeling-conversion-metrics/SKILL.md"
            },
            {
              "name": "modeling-dimension-tables",
              "sourceUrl": "https://github.com/PostHog/ai-plugin/blob/19e4737aa8ab3db315e43f35f796976a1ac37787/skills/modeling-dimension-tables/SKILL.md"
            },
            {
              "name": "modeling-product-usage-metrics",
              "sourceUrl": "https://github.com/PostHog/ai-plugin/blob/19e4737aa8ab3db315e43f35f796976a1ac37787/skills/modeling-product-usage-metrics/SKILL.md"
            },
            {
              "name": "modeling-revenue-metrics",
              "sourceUrl": "https://github.com/PostHog/ai-plugin/blob/19e4737aa8ab3db315e43f35f796976a1ac37787/skills/modeling-revenue-metrics/SKILL.md"
            },
            {
              "name": "modeling-warehouse-foundations",
              "sourceUrl": "https://github.com/PostHog/ai-plugin/blob/19e4737aa8ab3db315e43f35f796976a1ac37787/skills/modeling-warehouse-foundations/SKILL.md"
            },
            {
              "name": "organizing-conversations-code",
              "sourceUrl": "https://github.com/PostHog/ai-plugin/blob/19e4737aa8ab3db315e43f35f796976a1ac37787/skills/organizing-conversations-code/SKILL.md"
            },
            {
              "name": "planning-voice-agent-user-interviews",
              "sourceUrl": "https://github.com/PostHog/ai-plugin/blob/19e4737aa8ab3db315e43f35f796976a1ac37787/skills/planning-voice-agent-user-interviews/SKILL.md"
            },
            {
              "name": "querying-canvas-data",
              "sourceUrl": "https://github.com/PostHog/ai-plugin/blob/19e4737aa8ab3db315e43f35f796976a1ac37787/skills/querying-canvas-data/SKILL.md"
            },
            {
              "name": "querying-posthog-data",
              "sourceUrl": "https://github.com/PostHog/ai-plugin/blob/19e4737aa8ab3db315e43f35f796976a1ac37787/skills/querying-posthog-data/SKILL.md"
            },
            {
              "name": "resolving-ingestion-warnings",
              "sourceUrl": "https://github.com/PostHog/ai-plugin/blob/19e4737aa8ab3db315e43f35f796976a1ac37787/skills/resolving-ingestion-warnings/SKILL.md"
            },
            {
              "name": "review-hog-authoring",
              "sourceUrl": "https://github.com/PostHog/ai-plugin/blob/19e4737aa8ab3db315e43f35f796976a1ac37787/skills/review-hog-authoring/SKILL.md"
            },
            {
              "name": "review-hog-blind-spots-general",
              "sourceUrl": "https://github.com/PostHog/ai-plugin/blob/19e4737aa8ab3db315e43f35f796976a1ac37787/skills/review-hog-blind-spots-general/SKILL.md"
            },
            {
              "name": "review-hog-perspective-contracts-security",
              "sourceUrl": "https://github.com/PostHog/ai-plugin/blob/19e4737aa8ab3db315e43f35f796976a1ac37787/skills/review-hog-perspective-contracts-security/SKILL.md"
            },
            {
              "name": "review-hog-perspective-logic-correctness",
              "sourceUrl": "https://github.com/PostHog/ai-plugin/blob/19e4737aa8ab3db315e43f35f796976a1ac37787/skills/review-hog-perspective-logic-correctness/SKILL.md"
            },
            {
              "name": "review-hog-perspective-performance-reliability",
              "sourceUrl": "https://github.com/PostHog/ai-plugin/blob/19e4737aa8ab3db315e43f35f796976a1ac37787/skills/review-hog-perspective-performance-reliability/SKILL.md"
            },
            {
              "name": "review-hog-resolution-criteria",
              "sourceUrl": "https://github.com/PostHog/ai-plugin/blob/19e4737aa8ab3db315e43f35f796976a1ac37787/skills/review-hog-resolution-criteria/SKILL.md"
            },
            {
              "name": "review-hog-validation-criteria",
              "sourceUrl": "https://github.com/PostHog/ai-plugin/blob/19e4737aa8ab3db315e43f35f796976a1ac37787/skills/review-hog-validation-criteria/SKILL.md"
            },
            {
              "name": "scanning-experiments-with-replay-vision",
              "sourceUrl": "https://github.com/PostHog/ai-plugin/blob/19e4737aa8ab3db315e43f35f796976a1ac37787/skills/scanning-experiments-with-replay-vision/SKILL.md"
            },
            {
              "name": "setting-up-a-custom-rest-source",
              "sourceUrl": "https://github.com/PostHog/ai-plugin/blob/19e4737aa8ab3db315e43f35f796976a1ac37787/skills/setting-up-a-custom-rest-source/SKILL.md"
            },
            {
              "name": "setting-up-a-data-warehouse-source",
              "sourceUrl": "https://github.com/PostHog/ai-plugin/blob/19e4737aa8ab3db315e43f35f796976a1ac37787/skills/setting-up-a-data-warehouse-source/SKILL.md"
            },
            {
              "name": "setting-up-data-catalog",
              "sourceUrl": "https://github.com/PostHog/ai-plugin/blob/19e4737aa8ab3db315e43f35f796976a1ac37787/skills/setting-up-data-catalog/SKILL.md"
            },
            {
              "name": "setting-up-support-slack-locally",
              "sourceUrl": "https://github.com/PostHog/ai-plugin/blob/19e4737aa8ab3db315e43f35f796976a1ac37787/skills/setting-up-support-slack-locally/SKILL.md"
            },
            {
              "name": "setting-up-warehouse-properties",
              "sourceUrl": "https://github.com/PostHog/ai-plugin/blob/19e4737aa8ab3db315e43f35f796976a1ac37787/skills/setting-up-warehouse-properties/SKILL.md"
            },
            {
              "name": "signals-scout-ai-observability",
              "sourceUrl": "https://github.com/PostHog/ai-plugin/blob/19e4737aa8ab3db315e43f35f796976a1ac37787/skills/signals-scout-ai-observability/SKILL.md"
            },
            {
              "name": "signals-scout-anomaly-detection",
              "sourceUrl": "https://github.com/PostHog/ai-plugin/blob/19e4737aa8ab3db315e43f35f796976a1ac37787/skills/signals-scout-anomaly-detection/SKILL.md"
            },
            {
              "name": "signals-scout-apm",
              "sourceUrl": "https://github.com/PostHog/ai-plugin/blob/19e4737aa8ab3db315e43f35f796976a1ac37787/skills/signals-scout-apm/SKILL.md"
            },
            {
              "name": "signals-scout-conversations",
              "sourceUrl": "https://github.com/PostHog/ai-plugin/blob/19e4737aa8ab3db315e43f35f796976a1ac37787/skills/signals-scout-conversations/SKILL.md"
            },
            {
              "name": "signals-scout-csp-violations",
              "sourceUrl": "https://github.com/PostHog/ai-plugin/blob/19e4737aa8ab3db315e43f35f796976a1ac37787/skills/signals-scout-csp-violations/SKILL.md"
            },
            {
              "name": "signals-scout-customer-analytics-billing-and-usage",
              "sourceUrl": "https://github.com/PostHog/ai-plugin/blob/19e4737aa8ab3db315e43f35f796976a1ac37787/skills/signals-scout-customer-analytics-billing-and-usage/SKILL.md"
            },
            {
              "name": "signals-scout-customer-analytics",
              "sourceUrl": "https://github.com/PostHog/ai-plugin/blob/19e4737aa8ab3db315e43f35f796976a1ac37787/skills/signals-scout-customer-analytics/SKILL.md"
            },
            {
              "name": "signals-scout-data-pipelines",
              "sourceUrl": "https://github.com/PostHog/ai-plugin/blob/19e4737aa8ab3db315e43f35f796976a1ac37787/skills/signals-scout-data-pipelines/SKILL.md"
            },
            {
              "name": "signals-scout-data-warehouse",
              "sourceUrl": "https://github.com/PostHog/ai-plugin/blob/19e4737aa8ab3db315e43f35f796976a1ac37787/skills/signals-scout-data-warehouse/SKILL.md"
            },
            {
              "name": "signals-scout-error-tracking",
              "sourceUrl": "https://github.com/PostHog/ai-plugin/blob/19e4737aa8ab3db315e43f35f796976a1ac37787/skills/signals-scout-error-tracking/SKILL.md"
            },
            {
              "name": "signals-scout-experiments",
              "sourceUrl": "https://github.com/PostHog/ai-plugin/blob/19e4737aa8ab3db315e43f35f796976a1ac37787/skills/signals-scout-experiments/SKILL.md"
            },
            {
              "name": "signals-scout-feature-flags",
              "sourceUrl": "https://github.com/PostHog/ai-plugin/blob/19e4737aa8ab3db315e43f35f796976a1ac37787/skills/signals-scout-feature-flags/SKILL.md"
            },
            {
              "name": "signals-scout-general",
              "sourceUrl": "https://github.com/PostHog/ai-plugin/blob/19e4737aa8ab3db315e43f35f796976a1ac37787/skills/signals-scout-general/SKILL.md"
            },
            {
              "name": "signals-scout-health-checks",
              "sourceUrl": "https://github.com/PostHog/ai-plugin/blob/19e4737aa8ab3db315e43f35f796976a1ac37787/skills/signals-scout-health-checks/SKILL.md"
            },
            {
              "name": "signals-scout-inbox-validation",
              "sourceUrl": "https://github.com/PostHog/ai-plugin/blob/19e4737aa8ab3db315e43f35f796976a1ac37787/skills/signals-scout-inbox-validation/SKILL.md"
            },
            {
              "name": "signals-scout-insight-alerts",
              "sourceUrl": "https://github.com/PostHog/ai-plugin/blob/19e4737aa8ab3db315e43f35f796976a1ac37787/skills/signals-scout-insight-alerts/SKILL.md"
            },
            {
              "name": "signals-scout-logs",
              "sourceUrl": "https://github.com/PostHog/ai-plugin/blob/19e4737aa8ab3db315e43f35f796976a1ac37787/skills/signals-scout-logs/SKILL.md"
            },
            {
              "name": "signals-scout-mcp-tool-calls",
              "sourceUrl": "https://github.com/PostHog/ai-plugin/blob/19e4737aa8ab3db315e43f35f796976a1ac37787/skills/signals-scout-mcp-tool-calls/SKILL.md"
            },
            {
              "name": "signals-scout-observability-gaps",
              "sourceUrl": "https://github.com/PostHog/ai-plugin/blob/19e4737aa8ab3db315e43f35f796976a1ac37787/skills/signals-scout-observability-gaps/SKILL.md"
            },
            {
              "name": "signals-scout-product-analytics",
              "sourceUrl": "https://github.com/PostHog/ai-plugin/blob/19e4737aa8ab3db315e43f35f796976a1ac37787/skills/signals-scout-product-analytics/SKILL.md"
            },
            {
              "name": "signals-scout-replay-vision",
              "sourceUrl": "https://github.com/PostHog/ai-plugin/blob/19e4737aa8ab3db315e43f35f796976a1ac37787/skills/signals-scout-replay-vision/SKILL.md"
            },
            {
              "name": "signals-scout-revenue-analytics",
              "sourceUrl": "https://github.com/PostHog/ai-plugin/blob/19e4737aa8ab3db315e43f35f796976a1ac37787/skills/signals-scout-revenue-analytics/SKILL.md"
            },
            {
              "name": "signals-scout-session-replay",
              "sourceUrl": "https://github.com/PostHog/ai-plugin/blob/19e4737aa8ab3db315e43f35f796976a1ac37787/skills/signals-scout-session-replay/SKILL.md"
            },
            {
              "name": "signals-scout-skills-store",
              "sourceUrl": "https://github.com/PostHog/ai-plugin/blob/19e4737aa8ab3db315e43f35f796976a1ac37787/skills/signals-scout-skills-store/SKILL.md"
            },
            {
              "name": "signals-scout-surveys",
              "sourceUrl": "https://github.com/PostHog/ai-plugin/blob/19e4737aa8ab3db315e43f35f796976a1ac37787/skills/signals-scout-surveys/SKILL.md"
            },
            {
              "name": "signals-scout-tasks",
              "sourceUrl": "https://github.com/PostHog/ai-plugin/blob/19e4737aa8ab3db315e43f35f796976a1ac37787/skills/signals-scout-tasks/SKILL.md"
            },
            {
              "name": "signals-scout-web-analytics",
              "sourceUrl": "https://github.com/PostHog/ai-plugin/blob/19e4737aa8ab3db315e43f35f796976a1ac37787/skills/signals-scout-web-analytics/SKILL.md"
            },
            {
              "name": "signals-scout-web-vitals",
              "sourceUrl": "https://github.com/PostHog/ai-plugin/blob/19e4737aa8ab3db315e43f35f796976a1ac37787/skills/signals-scout-web-vitals/SKILL.md"
            },
            {
              "name": "signals",
              "sourceUrl": "https://github.com/PostHog/ai-plugin/blob/19e4737aa8ab3db315e43f35f796976a1ac37787/skills/signals/SKILL.md"
            },
            {
              "name": "skills-store",
              "sourceUrl": "https://github.com/PostHog/ai-plugin/blob/19e4737aa8ab3db315e43f35f796976a1ac37787/skills/skills-store/SKILL.md"
            },
            {
              "name": "suggesting-data-imports",
              "sourceUrl": "https://github.com/PostHog/ai-plugin/blob/19e4737aa8ab3db315e43f35f796976a1ac37787/skills/suggesting-data-imports/SKILL.md"
            },
            {
              "name": "suggesting-path-cleaning-rules",
              "sourceUrl": "https://github.com/PostHog/ai-plugin/blob/19e4737aa8ab3db315e43f35f796976a1ac37787/skills/suggesting-path-cleaning-rules/SKILL.md"
            },
            {
              "name": "suppressing-noisy-errors",
              "sourceUrl": "https://github.com/PostHog/ai-plugin/blob/19e4737aa8ab3db315e43f35f796976a1ac37787/skills/suppressing-noisy-errors/SKILL.md"
            },
            {
              "name": "testing-mcp-tools-locally",
              "sourceUrl": "https://github.com/PostHog/ai-plugin/blob/19e4737aa8ab3db315e43f35f796976a1ac37787/skills/testing-mcp-tools-locally/SKILL.md"
            },
            {
              "name": "triaging-error-issues",
              "sourceUrl": "https://github.com/PostHog/ai-plugin/blob/19e4737aa8ab3db315e43f35f796976a1ac37787/skills/triaging-error-issues/SKILL.md"
            },
            {
              "name": "triaging-visual-review-runs",
              "sourceUrl": "https://github.com/PostHog/ai-plugin/blob/19e4737aa8ab3db315e43f35f796976a1ac37787/skills/triaging-visual-review-runs/SKILL.md"
            },
            {
              "name": "tuning-incremental-sync-config",
              "sourceUrl": "https://github.com/PostHog/ai-plugin/blob/19e4737aa8ab3db315e43f35f796976a1ac37787/skills/tuning-incremental-sync-config/SKILL.md"
            },
            {
              "name": "turning-engineering-analytics-into-insights",
              "sourceUrl": "https://github.com/PostHog/ai-plugin/blob/19e4737aa8ab3db315e43f35f796976a1ac37787/skills/turning-engineering-analytics-into-insights/SKILL.md"
            },
            {
              "name": "understanding-billing-usage",
              "sourceUrl": "https://github.com/PostHog/ai-plugin/blob/19e4737aa8ab3db315e43f35f796976a1ac37787/skills/understanding-billing-usage/SKILL.md"
            },
            {
              "name": "validating-and-publishing-canvases",
              "sourceUrl": "https://github.com/PostHog/ai-plugin/blob/19e4737aa8ab3db315e43f35f796976a1ac37787/skills/validating-and-publishing-canvases/SKILL.md"
            },
            {
              "name": "working-with-scouts",
              "sourceUrl": "https://github.com/PostHog/ai-plugin/blob/19e4737aa8ab3db315e43f35f796976a1ac37787/skills/working-with-scouts/SKILL.md"
            },
            {
              "name": "working-with-skills",
              "sourceUrl": "https://github.com/PostHog/ai-plugin/blob/19e4737aa8ab3db315e43f35f796976a1ac37787/skills/working-with-skills/SKILL.md"
            },
            {
              "name": "working-with-task-comments",
              "sourceUrl": "https://github.com/PostHog/ai-plugin/blob/19e4737aa8ab3db315e43f35f796976a1ac37787/skills/working-with-task-comments/SKILL.md"
            },
            {
              "name": "writing-simplified-technical-english",
              "sourceUrl": "https://github.com/PostHog/ai-plugin/blob/19e4737aa8ab3db315e43f35f796976a1ac37787/skills/writing-simplified-technical-english/SKILL.md"
            },
            {
              "name": "writing-streamlit-apps",
              "sourceUrl": "https://github.com/PostHog/ai-plugin/blob/19e4737aa8ab3db315e43f35f796976a1ac37787/skills/writing-streamlit-apps/SKILL.md"
            }
          ],
          "mcpServers": [
            {
              "requiresConfiguration": true,
              "name": "posthog",
              "transport": "http",
              "endpoint": "https://mcp.posthog.com/mcp"
            }
          ],
          "components": ["skills", "mcp", "hooks", "agents", "commands"],
          "componentInspection": "repository",
          "inspectionError": null,
          "installation": "requires_adapter",
          "upstream": {
            "source": {
              "source": "url",
              "url": "https://github.com/PostHog/ai-plugin.git",
              "sha": "19e4737aa8ab3db315e43f35f796976a1ac37787"
            },
            "policy": null
          }
        },
        {
          "id": "anthropic:postiz",
          "name": "postiz",
          "displayName": "postiz",
          "description": "Social media automation CLI for scheduling posts, managing integrations, uploading media, and tracking analytics across 28+ platforms including X, LinkedIn, Reddit, YouTube, TikTok, Instagram, and more",
          "longDescription": "Social media automation CLI for scheduling posts, managing integrations, uploading media, and tracking analytics across 28+ platforms including X, LinkedIn, Reddit, YouTube, TikTok, Instagram, and more",
          "category": null,
          "keywords": [
            "postiz",
            "social-media",
            "scheduling",
            "automation",
            "ai-agent",
            "twitter",
            "linkedin",
            "facebook",
            "instagram",
            "tiktok",
            "youtube",
            "reddit"
          ],
          "author": {
            "name": "Nevo David",
            "email": "nevo@postiz.com",
            "url": "https://github.com/nevo-david"
          },
          "version": "2.0.17",
          "license": "AGPL-3.0",
          "logoUrl": null,
          "darkLogoUrl": null,
          "homepage": "https://docs.postiz.com/public-api/introduction",
          "sourceUrl": "https://github.com/gitroomhq/postiz-agent/tree/6d3be9c0aec768075e91b4a29b04fb624d72d942/",
          "skills": [
            {
              "name": "postiz",
              "sourceUrl": "https://github.com/gitroomhq/postiz-agent/blob/6d3be9c0aec768075e91b4a29b04fb624d72d942/SKILL.md"
            },
            {
              "name": "postiz",
              "sourceUrl": "https://github.com/gitroomhq/postiz-agent/blob/6d3be9c0aec768075e91b4a29b04fb624d72d942/skills/postiz/SKILL.md"
            }
          ],
          "mcpServers": [],
          "components": ["skills"],
          "componentInspection": "repository",
          "inspectionError": null,
          "installation": "requires_adapter",
          "upstream": {
            "source": {
              "source": "url",
              "url": "https://github.com/gitroomhq/postiz-agent.git",
              "sha": "6d3be9c0aec768075e91b4a29b04fb624d72d942"
            },
            "policy": null
          }
        },
        {
          "id": "anthropic:postman",
          "name": "postman",
          "displayName": "postman",
          "description": "Full API lifecycle management for Claude Code. Sync collections, generate client code, discover APIs, run tests, create mocks, publish docs, and audit security. Powered by the Postman MCP Server.",
          "longDescription": "Full API lifecycle management for Claude Code. Sync collections, generate client code, discover APIs, run tests, create mocks, publish docs, and audit security. Powered by the Postman MCP Server.",
          "category": "development",
          "keywords": [
            "postman",
            "api",
            "collections",
            "testing",
            "mcp",
            "mocks",
            "documentation",
            "security",
            "openapi",
            "agent-ready"
          ],
          "author": {
            "name": "Postman",
            "url": "https://www.postman.com"
          },
          "version": "1.3.1",
          "license": "Apache-2.0",
          "logoUrl": null,
          "darkLogoUrl": null,
          "homepage": "https://learning.postman.com/docs/developer/postman-mcp-server/",
          "sourceUrl": "https://github.com/Postman-Devrel/postman-claude-code-plugin/tree/27f652ea98d9ae0cec0ccc9f2b46128239a36a8f/",
          "skills": [
            {
              "name": "agent-ready-apis",
              "sourceUrl": "https://github.com/Postman-Devrel/postman-claude-code-plugin/blob/27f652ea98d9ae0cec0ccc9f2b46128239a36a8f/skills/agent-ready-apis/SKILL.md"
            },
            {
              "name": "deploy-flow",
              "sourceUrl": "https://github.com/Postman-Devrel/postman-claude-code-plugin/blob/27f652ea98d9ae0cec0ccc9f2b46128239a36a8f/skills/deploy-flow/SKILL.md"
            },
            {
              "name": "generate-spec",
              "sourceUrl": "https://github.com/Postman-Devrel/postman-claude-code-plugin/blob/27f652ea98d9ae0cec0ccc9f2b46128239a36a8f/skills/generate-spec/SKILL.md"
            },
            {
              "name": "get-flow-run",
              "sourceUrl": "https://github.com/Postman-Devrel/postman-claude-code-plugin/blob/27f652ea98d9ae0cec0ccc9f2b46128239a36a8f/skills/get-flow-run/SKILL.md"
            },
            {
              "name": "list-flows",
              "sourceUrl": "https://github.com/Postman-Devrel/postman-claude-code-plugin/blob/27f652ea98d9ae0cec0ccc9f2b46128239a36a8f/skills/list-flows/SKILL.md"
            },
            {
              "name": "postman-cli",
              "sourceUrl": "https://github.com/Postman-Devrel/postman-claude-code-plugin/blob/27f652ea98d9ae0cec0ccc9f2b46128239a36a8f/skills/postman-cli/SKILL.md"
            },
            {
              "name": "postman-context",
              "sourceUrl": "https://github.com/Postman-Devrel/postman-claude-code-plugin/blob/27f652ea98d9ae0cec0ccc9f2b46128239a36a8f/skills/postman-context/SKILL.md"
            },
            {
              "name": "postman-knowledge",
              "sourceUrl": "https://github.com/Postman-Devrel/postman-claude-code-plugin/blob/27f652ea98d9ae0cec0ccc9f2b46128239a36a8f/skills/postman-knowledge/SKILL.md"
            },
            {
              "name": "run-collection",
              "sourceUrl": "https://github.com/Postman-Devrel/postman-claude-code-plugin/blob/27f652ea98d9ae0cec0ccc9f2b46128239a36a8f/skills/run-collection/SKILL.md"
            },
            {
              "name": "send-request",
              "sourceUrl": "https://github.com/Postman-Devrel/postman-claude-code-plugin/blob/27f652ea98d9ae0cec0ccc9f2b46128239a36a8f/skills/send-request/SKILL.md"
            },
            {
              "name": "trigger-flow",
              "sourceUrl": "https://github.com/Postman-Devrel/postman-claude-code-plugin/blob/27f652ea98d9ae0cec0ccc9f2b46128239a36a8f/skills/trigger-flow/SKILL.md"
            }
          ],
          "mcpServers": [
            {
              "requiresConfiguration": true,
              "name": "postman",
              "transport": "http",
              "endpoint": "https://mcp.postman.com/${POSTMAN_MCP_MODE:-mcp}"
            }
          ],
          "components": ["skills", "mcp", "agents", "commands"],
          "componentInspection": "repository",
          "inspectionError": null,
          "installation": "requires_adapter",
          "upstream": {
            "source": {
              "source": "url",
              "url": "https://github.com/Postman-Devrel/postman-claude-code-plugin.git",
              "sha": "27f652ea98d9ae0cec0ccc9f2b46128239a36a8f"
            },
            "policy": null
          }
        },
        {
          "id": "anthropic:pr-review-toolkit",
          "name": "pr-review-toolkit",
          "displayName": "pr-review-toolkit",
          "description": "Comprehensive PR review agents specializing in comments, tests, error handling, type design, code quality, and code simplification",
          "longDescription": "Comprehensive PR review agents specializing in comments, tests, error handling, type design, code quality, and code simplification",
          "category": "productivity",
          "keywords": [],
          "author": {
            "name": "Anthropic",
            "email": "support@anthropic.com"
          },
          "version": null,
          "license": null,
          "logoUrl": null,
          "darkLogoUrl": null,
          "homepage": "https://github.com/anthropics/claude-plugins-public/tree/main/plugins/pr-review-toolkit",
          "sourceUrl": "https://github.com/anthropics/claude-plugins-official/tree/3b600518a637492d37c9877aeb49c2a55d939c04/plugins/pr-review-toolkit",
          "skills": [],
          "mcpServers": [],
          "components": ["agents", "commands"],
          "componentInspection": "repository",
          "inspectionError": null,
          "installation": "requires_adapter",
          "upstream": {
            "source": "./plugins/pr-review-toolkit",
            "policy": null
          }
        },
        {
          "id": "anthropic:preset-cli-skills",
          "name": "preset-cli-skills",
          "displayName": "preset-cli-skills",
          "description": "Preset CLI skills for explicit shell, scripting, and CI/CD workflows driven by the `sup` CLI (PyPI package `superset-sup`). Use only for CLI workflows; do not use for MCP-only work or as a substitute for direct API calls when the user wants HTTP/SDK code.",
          "longDescription": "Preset CLI skills for explicit shell, scripting, and CI/CD workflows driven by the `sup` CLI (PyPI package `superset-sup`). Use only for CLI workflows; do not use for MCP-only work or as a substitute for direct API calls when the user wants HTTP/SDK code.",
          "category": "development",
          "keywords": [
            "preset",
            "superset",
            "sup",
            "cli",
            "shell",
            "scripting",
            "ci-cd",
            "automation"
          ],
          "author": {
            "name": "Preset",
            "url": "https://preset.io/"
          },
          "version": "0.4.3",
          "license": "Apache-2.0",
          "logoUrl": null,
          "darkLogoUrl": null,
          "homepage": "https://github.com/preset-io/agent-skills",
          "sourceUrl": "https://github.com/preset-io/agent-skills/tree/8387ac0f0538271c79a2e227c7ddec084e8a5da3/plugins/preset-cli-skills",
          "skills": [
            {
              "name": "preset-cli-mutations",
              "sourceUrl": "https://github.com/preset-io/agent-skills/blob/8387ac0f0538271c79a2e227c7ddec084e8a5da3/plugins/preset-cli-skills/skills/preset-cli-mutations/SKILL.md"
            },
            {
              "name": "preset-cli",
              "sourceUrl": "https://github.com/preset-io/agent-skills/blob/8387ac0f0538271c79a2e227c7ddec084e8a5da3/plugins/preset-cli-skills/skills/preset-cli/SKILL.md"
            }
          ],
          "mcpServers": [],
          "components": ["skills"],
          "componentInspection": "repository",
          "inspectionError": null,
          "installation": "requires_adapter",
          "upstream": {
            "source": {
              "source": "git-subdir",
              "url": "https://github.com/preset-io/agent-skills.git",
              "path": "plugins/preset-cli-skills",
              "ref": "master",
              "sha": "8387ac0f0538271c79a2e227c7ddec084e8a5da3"
            },
            "policy": null
          }
        },
        {
          "id": "anthropic:prisma",
          "name": "prisma",
          "displayName": "prisma",
          "description": "Prisma MCP integration for Postgres database management, schema migrations, SQL queries, and connection string management. Provision Prisma Postgres databases, run migrations, and interact with your data directly.",
          "longDescription": "Prisma MCP integration for Postgres database management, schema migrations, SQL queries, and connection string management. Provision Prisma Postgres databases, run migrations, and interact with your data directly.",
          "category": null,
          "keywords": [],
          "author": {
            "name": "Prisma"
          },
          "version": null,
          "license": null,
          "logoUrl": null,
          "darkLogoUrl": null,
          "homepage": "https://prisma.io",
          "sourceUrl": "https://github.com/prisma/claude-plugin/tree/815dbc4a045a29e3b81510ba0e3ab806f1baaf0e/",
          "skills": [],
          "mcpServers": [
            {
              "requiresConfiguration": false,
              "name": "Prisma-Local",
              "transport": "stdio",
              "endpoint": null
            },
            {
              "requiresConfiguration": false,
              "name": "Prisma-Remote",
              "transport": "http",
              "endpoint": "https://mcp.prisma.io/mcp"
            }
          ],
          "components": ["mcp"],
          "componentInspection": "repository",
          "inspectionError": null,
          "installation": "requires_adapter",
          "upstream": {
            "source": {
              "source": "url",
              "url": "https://github.com/prisma/claude-plugin.git",
              "sha": "815dbc4a045a29e3b81510ba0e3ab806f1baaf0e"
            },
            "policy": null
          }
        },
        {
          "id": "anthropic:project-artifact",
          "name": "project-artifact",
          "displayName": "project-artifact",
          "description": "Generate and publish a project status artifact — an opinionated, tabbed status page (overview & success criteria, the workstream sequence, next steps, plus background / plan / risks & open questions / decisions-FAQ when they earn a tab) published via the built-in Artifact tool to a default-private claude.ai page the user can share with teammates. Each artifact is backed by a per-project config, so 'refresh the artifact' re-gathers live state, redeploys the same URL, and reports only the delta. Domain-neutral, with a software specialization for projects whose workstreams are pull requests. Needs the built-in Artifact tool (claude.ai login).",
          "longDescription": "Generate and publish a project status artifact — an opinionated, tabbed status page (overview & success criteria, the workstream sequence, next steps, plus background / plan / risks & open questions / decisions-FAQ when they earn a tab) published via the built-in Artifact tool to a default-private claude.ai page the user can share with teammates. Each artifact is backed by a per-project config, so 'refresh the artifact' re-gathers live state, redeploys the same URL, and reports only the delta. Domain-neutral, with a software specialization for projects whose workstreams are pull requests. Needs the built-in Artifact tool (claude.ai login).",
          "category": "productivity",
          "keywords": [],
          "author": {
            "name": "Anthropic",
            "email": "support@anthropic.com"
          },
          "version": null,
          "license": null,
          "logoUrl": null,
          "darkLogoUrl": null,
          "homepage": "https://github.com/anthropics/claude-plugins-public/tree/main/plugins/project-artifact",
          "sourceUrl": "https://github.com/anthropics/claude-plugins-official/tree/3b600518a637492d37c9877aeb49c2a55d939c04/plugins/project-artifact",
          "skills": [
            {
              "name": "project-artifact",
              "sourceUrl": "https://github.com/anthropics/claude-plugins-official/blob/3b600518a637492d37c9877aeb49c2a55d939c04/plugins/project-artifact/skills/project-artifact/SKILL.md"
            }
          ],
          "mcpServers": [],
          "components": ["skills"],
          "componentInspection": "repository",
          "inspectionError": null,
          "installation": "requires_adapter",
          "upstream": {
            "source": "./plugins/project-artifact",
            "policy": null
          }
        },
        {
          "id": "anthropic:pydantic-ai",
          "name": "pydantic-ai",
          "displayName": "ai",
          "description": "Build production-grade AI agents with Pydantic AI — tools, capabilities, structured output, streaming, and testing patterns",
          "longDescription": "Build production-grade AI agents with Pydantic AI — tools, capabilities, structured output, streaming, and testing patterns",
          "category": "development",
          "keywords": [],
          "author": {
            "name": "Pydantic",
            "email": "support@pydantic.dev"
          },
          "version": "0.1.0",
          "license": null,
          "logoUrl": null,
          "darkLogoUrl": null,
          "homepage": "https://github.com/pydantic/skills/tree/main/plugins/ai",
          "sourceUrl": "https://github.com/pydantic/skills/tree/e5f7cb13d01561fe3735040ed37596abd9b83976/plugins/ai",
          "skills": [
            {
              "name": "building-pydantic-ai-agents",
              "sourceUrl": "https://github.com/pydantic/skills/blob/e5f7cb13d01561fe3735040ed37596abd9b83976/plugins/ai/skills/building-pydantic-ai-agents/SKILL.md"
            }
          ],
          "mcpServers": [],
          "components": ["skills"],
          "componentInspection": "repository",
          "inspectionError": null,
          "installation": "requires_adapter",
          "upstream": {
            "source": {
              "source": "git-subdir",
              "url": "https://github.com/pydantic/skills.git",
              "path": "plugins/ai",
              "ref": "main",
              "sha": "e5f7cb13d01561fe3735040ed37596abd9b83976"
            },
            "policy": null
          }
        },
        {
          "id": "anthropic:pyright-lsp",
          "name": "pyright-lsp",
          "displayName": "pyright-lsp",
          "description": "Python language server (Pyright) for type checking and code intelligence",
          "longDescription": "Python language server (Pyright) for type checking and code intelligence",
          "category": "development",
          "keywords": [],
          "author": {
            "name": "Anthropic",
            "email": "support@anthropic.com"
          },
          "version": "1.0.0",
          "license": null,
          "logoUrl": null,
          "darkLogoUrl": null,
          "homepage": null,
          "sourceUrl": "https://github.com/anthropics/claude-plugins-official/tree/3b600518a637492d37c9877aeb49c2a55d939c04/plugins/pyright-lsp",
          "skills": [],
          "mcpServers": [],
          "components": [],
          "componentInspection": "repository",
          "inspectionError": null,
          "installation": "requires_adapter",
          "upstream": {
            "source": "./plugins/pyright-lsp",
            "policy": null
          }
        },
        {
          "id": "anthropic:qdrant-skills",
          "name": "qdrant-skills",
          "displayName": "qdrant",
          "description": "Agent skills for Qdrant vector search: scaling, performance optimization, search quality, monitoring, deployment, edge, model migration, multitenancy, version upgrades, and SDK usage",
          "longDescription": "Agent skills for Qdrant vector search: scaling, performance optimization, search quality, monitoring, deployment, edge, model migration, multitenancy, version upgrades, and SDK usage",
          "category": "database",
          "keywords": [],
          "author": {
            "name": "Qdrant"
          },
          "version": "1.0.0",
          "license": null,
          "logoUrl": null,
          "darkLogoUrl": null,
          "homepage": "https://skills.qdrant.tech",
          "sourceUrl": "https://github.com/qdrant/skills/tree/3ca3d5659279256124ceda2bcb864255938185a5/",
          "skills": [
            {
              "name": "qdrant-advisor",
              "sourceUrl": "https://github.com/qdrant/skills/blob/3ca3d5659279256124ceda2bcb864255938185a5/meta/qdrant-advisor/SKILL.md"
            },
            {
              "name": "qdrant-clients-sdk",
              "sourceUrl": "https://github.com/qdrant/skills/blob/3ca3d5659279256124ceda2bcb864255938185a5/skills/qdrant-clients-sdk/SKILL.md"
            },
            {
              "name": "qdrant-deployment-options",
              "sourceUrl": "https://github.com/qdrant/skills/blob/3ca3d5659279256124ceda2bcb864255938185a5/skills/qdrant-deployment-options/SKILL.md"
            },
            {
              "name": "qdrant-edge",
              "sourceUrl": "https://github.com/qdrant/skills/blob/3ca3d5659279256124ceda2bcb864255938185a5/skills/qdrant-edge/SKILL.md"
            },
            {
              "name": "qdrant-model-migration",
              "sourceUrl": "https://github.com/qdrant/skills/blob/3ca3d5659279256124ceda2bcb864255938185a5/skills/qdrant-model-migration/SKILL.md"
            },
            {
              "name": "qdrant-monitoring",
              "sourceUrl": "https://github.com/qdrant/skills/blob/3ca3d5659279256124ceda2bcb864255938185a5/skills/qdrant-monitoring/SKILL.md"
            },
            {
              "name": "debugging",
              "sourceUrl": "https://github.com/qdrant/skills/blob/3ca3d5659279256124ceda2bcb864255938185a5/skills/qdrant-monitoring/debugging/SKILL.md"
            },
            {
              "name": "setup",
              "sourceUrl": "https://github.com/qdrant/skills/blob/3ca3d5659279256124ceda2bcb864255938185a5/skills/qdrant-monitoring/setup/SKILL.md"
            },
            {
              "name": "qdrant-multitenancy",
              "sourceUrl": "https://github.com/qdrant/skills/blob/3ca3d5659279256124ceda2bcb864255938185a5/skills/qdrant-multitenancy/SKILL.md"
            },
            {
              "name": "qdrant-performance-optimization",
              "sourceUrl": "https://github.com/qdrant/skills/blob/3ca3d5659279256124ceda2bcb864255938185a5/skills/qdrant-performance-optimization/SKILL.md"
            },
            {
              "name": "indexing-performance-optimization",
              "sourceUrl": "https://github.com/qdrant/skills/blob/3ca3d5659279256124ceda2bcb864255938185a5/skills/qdrant-performance-optimization/indexing-performance-optimization/SKILL.md"
            },
            {
              "name": "memory-usage-optimization",
              "sourceUrl": "https://github.com/qdrant/skills/blob/3ca3d5659279256124ceda2bcb864255938185a5/skills/qdrant-performance-optimization/memory-usage-optimization/SKILL.md"
            },
            {
              "name": "search-speed-optimization",
              "sourceUrl": "https://github.com/qdrant/skills/blob/3ca3d5659279256124ceda2bcb864255938185a5/skills/qdrant-performance-optimization/search-speed-optimization/SKILL.md"
            },
            {
              "name": "qdrant-scaling",
              "sourceUrl": "https://github.com/qdrant/skills/blob/3ca3d5659279256124ceda2bcb864255938185a5/skills/qdrant-scaling/SKILL.md"
            },
            {
              "name": "minimize-latency",
              "sourceUrl": "https://github.com/qdrant/skills/blob/3ca3d5659279256124ceda2bcb864255938185a5/skills/qdrant-scaling/minimize-latency/SKILL.md"
            },
            {
              "name": "scaling-data-volume",
              "sourceUrl": "https://github.com/qdrant/skills/blob/3ca3d5659279256124ceda2bcb864255938185a5/skills/qdrant-scaling/scaling-data-volume/SKILL.md"
            },
            {
              "name": "horizontal-scaling",
              "sourceUrl": "https://github.com/qdrant/skills/blob/3ca3d5659279256124ceda2bcb864255938185a5/skills/qdrant-scaling/scaling-data-volume/horizontal-scaling/SKILL.md"
            },
            {
              "name": "sliding-time-window",
              "sourceUrl": "https://github.com/qdrant/skills/blob/3ca3d5659279256124ceda2bcb864255938185a5/skills/qdrant-scaling/scaling-data-volume/sliding-time-window/SKILL.md"
            },
            {
              "name": "tenant-scaling",
              "sourceUrl": "https://github.com/qdrant/skills/blob/3ca3d5659279256124ceda2bcb864255938185a5/skills/qdrant-scaling/scaling-data-volume/tenant-scaling/SKILL.md"
            },
            {
              "name": "vertical-scaling",
              "sourceUrl": "https://github.com/qdrant/skills/blob/3ca3d5659279256124ceda2bcb864255938185a5/skills/qdrant-scaling/scaling-data-volume/vertical-scaling/SKILL.md"
            },
            {
              "name": "scaling-qps",
              "sourceUrl": "https://github.com/qdrant/skills/blob/3ca3d5659279256124ceda2bcb864255938185a5/skills/qdrant-scaling/scaling-qps/SKILL.md"
            },
            {
              "name": "scaling-query-volume",
              "sourceUrl": "https://github.com/qdrant/skills/blob/3ca3d5659279256124ceda2bcb864255938185a5/skills/qdrant-scaling/scaling-query-volume/SKILL.md"
            },
            {
              "name": "qdrant-search-quality",
              "sourceUrl": "https://github.com/qdrant/skills/blob/3ca3d5659279256124ceda2bcb864255938185a5/skills/qdrant-search-quality/SKILL.md"
            },
            {
              "name": "diagnosis",
              "sourceUrl": "https://github.com/qdrant/skills/blob/3ca3d5659279256124ceda2bcb864255938185a5/skills/qdrant-search-quality/diagnosis/SKILL.md"
            },
            {
              "name": "search-strategies",
              "sourceUrl": "https://github.com/qdrant/skills/blob/3ca3d5659279256124ceda2bcb864255938185a5/skills/qdrant-search-quality/search-strategies/SKILL.md"
            },
            {
              "name": "hybrid-search",
              "sourceUrl": "https://github.com/qdrant/skills/blob/3ca3d5659279256124ceda2bcb864255938185a5/skills/qdrant-search-quality/search-strategies/hybrid-search/SKILL.md"
            },
            {
              "name": "combining-searches",
              "sourceUrl": "https://github.com/qdrant/skills/blob/3ca3d5659279256124ceda2bcb864255938185a5/skills/qdrant-search-quality/search-strategies/hybrid-search/combining-searches/SKILL.md"
            },
            {
              "name": "search-types",
              "sourceUrl": "https://github.com/qdrant/skills/blob/3ca3d5659279256124ceda2bcb864255938185a5/skills/qdrant-search-quality/search-strategies/hybrid-search/search-types/SKILL.md"
            },
            {
              "name": "relevance-feedback",
              "sourceUrl": "https://github.com/qdrant/skills/blob/3ca3d5659279256124ceda2bcb864255938185a5/skills/qdrant-search-quality/search-strategies/relevance-feedback/SKILL.md"
            },
            {
              "name": "qdrant-sizing",
              "sourceUrl": "https://github.com/qdrant/skills/blob/3ca3d5659279256124ceda2bcb864255938185a5/skills/qdrant-sizing/SKILL.md"
            },
            {
              "name": "qdrant-version-upgrade",
              "sourceUrl": "https://github.com/qdrant/skills/blob/3ca3d5659279256124ceda2bcb864255938185a5/skills/qdrant-version-upgrade/SKILL.md"
            }
          ],
          "mcpServers": [],
          "components": ["skills"],
          "componentInspection": "repository",
          "inspectionError": null,
          "installation": "requires_adapter",
          "upstream": {
            "source": {
              "source": "url",
              "url": "https://github.com/qdrant/skills.git",
              "sha": "3ca3d5659279256124ceda2bcb864255938185a5"
            },
            "policy": null
          }
        },
        {
          "id": "anthropic:qodo",
          "name": "qodo",
          "displayName": "qodo",
          "description": "Qodo setup, code intelligence, and review workflows.",
          "longDescription": "Qodo setup, code intelligence, and review workflows.",
          "category": "development",
          "keywords": ["qodo", "code-review", "code-intelligence", "standards", "coding-agents"],
          "author": {
            "name": "Qodo",
            "email": "support@qodo.ai",
            "url": "https://www.qodo.ai"
          },
          "version": "1.0.10",
          "license": "MIT",
          "logoUrl": null,
          "darkLogoUrl": null,
          "homepage": "https://www.qodo.ai",
          "sourceUrl": "https://github.com/qodo-ai/qodo-skills/tree/3f017b1f2e13dbf9feb532143dc39fa4eea12479/packages/qodo",
          "skills": [
            {
              "name": "qodo-codebase-wisdom",
              "sourceUrl": "https://github.com/qodo-ai/qodo-skills/blob/3f017b1f2e13dbf9feb532143dc39fa4eea12479/packages/qodo/skills/qodo-codebase-wisdom/SKILL.md"
            },
            {
              "name": "qodo-pr-resolver",
              "sourceUrl": "https://github.com/qodo-ai/qodo-skills/blob/3f017b1f2e13dbf9feb532143dc39fa4eea12479/packages/qodo/skills/qodo-pr-resolver/SKILL.md"
            },
            {
              "name": "qodo-review-resolver",
              "sourceUrl": "https://github.com/qodo-ai/qodo-skills/blob/3f017b1f2e13dbf9feb532143dc39fa4eea12479/packages/qodo/skills/qodo-review-resolver/SKILL.md"
            },
            {
              "name": "qodo-review",
              "sourceUrl": "https://github.com/qodo-ai/qodo-skills/blob/3f017b1f2e13dbf9feb532143dc39fa4eea12479/packages/qodo/skills/qodo-review/SKILL.md"
            },
            {
              "name": "qodo-setup",
              "sourceUrl": "https://github.com/qodo-ai/qodo-skills/blob/3f017b1f2e13dbf9feb532143dc39fa4eea12479/packages/qodo/skills/qodo-setup/SKILL.md"
            }
          ],
          "mcpServers": [],
          "components": ["skills"],
          "componentInspection": "repository",
          "inspectionError": null,
          "installation": "requires_adapter",
          "upstream": {
            "source": {
              "source": "git-subdir",
              "url": "https://github.com/qodo-ai/qodo-skills.git",
              "path": "packages/qodo",
              "ref": "main",
              "sha": "3f017b1f2e13dbf9feb532143dc39fa4eea12479"
            },
            "policy": null
          }
        },
        {
          "id": "anthropic:qodo-standards",
          "name": "qodo-standards",
          "displayName": "qodo-standards",
          "description": "Optional Qodo rules discovery and standards administration workflows.",
          "longDescription": "Optional Qodo rules discovery and standards administration workflows.",
          "category": "development",
          "keywords": ["qodo", "code-review", "code-intelligence", "standards", "coding-agents"],
          "author": {
            "name": "Qodo",
            "email": "support@qodo.ai",
            "url": "https://www.qodo.ai"
          },
          "version": "1.0.10",
          "license": "MIT",
          "logoUrl": null,
          "darkLogoUrl": null,
          "homepage": "https://www.qodo.ai",
          "sourceUrl": "https://github.com/qodo-ai/qodo-skills/tree/3f017b1f2e13dbf9feb532143dc39fa4eea12479/packages/qodo-standards",
          "skills": [
            {
              "name": "qodo-get-rules",
              "sourceUrl": "https://github.com/qodo-ai/qodo-skills/blob/3f017b1f2e13dbf9feb532143dc39fa4eea12479/packages/qodo-standards/skills/qodo-get-rules/SKILL.md"
            },
            {
              "name": "qodo-manage-standards",
              "sourceUrl": "https://github.com/qodo-ai/qodo-skills/blob/3f017b1f2e13dbf9feb532143dc39fa4eea12479/packages/qodo-standards/skills/qodo-manage-standards/SKILL.md"
            }
          ],
          "mcpServers": [],
          "components": ["skills"],
          "componentInspection": "repository",
          "inspectionError": null,
          "installation": "requires_adapter",
          "upstream": {
            "source": {
              "source": "git-subdir",
              "url": "https://github.com/qodo-ai/qodo-skills.git",
              "path": "packages/qodo-standards",
              "ref": "main",
              "sha": "3f017b1f2e13dbf9feb532143dc39fa4eea12479"
            },
            "policy": null
          }
        },
        {
          "id": "anthropic:qt-development-skills",
          "name": "qt-development-skills",
          "displayName": "qt-development-skills",
          "description": "Agentic engineering skills for Qt software development, including Qt C++/QML code review, QML coding, and Qt C++/QML code documentation. Bundles the hosted Qt Documentation MCP server for live Qt API lookups. These skills use AI and can make mistakes. Always double-check the output carefully.",
          "longDescription": "Agentic engineering skills for Qt software development, including Qt C++/QML code review, QML coding, and Qt C++/QML code documentation. Bundles the hosted Qt Documentation MCP server for live Qt API lookups. These skills use AI and can make mistakes. Always double-check the output carefully.",
          "category": "development",
          "keywords": [],
          "author": {
            "name": "Qt Group"
          },
          "version": "1.6.1",
          "license": null,
          "logoUrl": null,
          "darkLogoUrl": null,
          "homepage": "https://www.qt.io/",
          "sourceUrl": "https://github.com/TheQtCompanyRnD/agent-skills/tree/71d6c10da78b9a764468ae11c86ab3bc4ca4921f/",
          "skills": [
            {
              "name": "qt-cmake-project",
              "sourceUrl": "https://github.com/TheQtCompanyRnD/agent-skills/blob/71d6c10da78b9a764468ae11c86ab3bc4ca4921f/skills/qt-cmake-project/SKILL.md"
            },
            {
              "name": "qt-cpp-docs",
              "sourceUrl": "https://github.com/TheQtCompanyRnD/agent-skills/blob/71d6c10da78b9a764468ae11c86ab3bc4ca4921f/skills/qt-cpp-docs/SKILL.md"
            },
            {
              "name": "qt-cpp-review",
              "sourceUrl": "https://github.com/TheQtCompanyRnD/agent-skills/blob/71d6c10da78b9a764468ae11c86ab3bc4ca4921f/skills/qt-cpp-review/SKILL.md"
            },
            {
              "name": "qt-figma-component-generation",
              "sourceUrl": "https://github.com/TheQtCompanyRnD/agent-skills/blob/71d6c10da78b9a764468ae11c86ab3bc4ca4921f/skills/qt-figma-component-generation/SKILL.md"
            },
            {
              "name": "qt-figma-token-extraction",
              "sourceUrl": "https://github.com/TheQtCompanyRnD/agent-skills/blob/71d6c10da78b9a764468ae11c86ab3bc4ca4921f/skills/qt-figma-token-extraction/SKILL.md"
            },
            {
              "name": "qt-qml-docs",
              "sourceUrl": "https://github.com/TheQtCompanyRnD/agent-skills/blob/71d6c10da78b9a764468ae11c86ab3bc4ca4921f/skills/qt-qml-docs/SKILL.md"
            },
            {
              "name": "qt-qml-profiler",
              "sourceUrl": "https://github.com/TheQtCompanyRnD/agent-skills/blob/71d6c10da78b9a764468ae11c86ab3bc4ca4921f/skills/qt-qml-profiler/SKILL.md"
            },
            {
              "name": "qt-qml-review",
              "sourceUrl": "https://github.com/TheQtCompanyRnD/agent-skills/blob/71d6c10da78b9a764468ae11c86ab3bc4ca4921f/skills/qt-qml-review/SKILL.md"
            },
            {
              "name": "qt-qml-test-run",
              "sourceUrl": "https://github.com/TheQtCompanyRnD/agent-skills/blob/71d6c10da78b9a764468ae11c86ab3bc4ca4921f/skills/qt-qml-test-run/SKILL.md"
            },
            {
              "name": "qt-qml-test",
              "sourceUrl": "https://github.com/TheQtCompanyRnD/agent-skills/blob/71d6c10da78b9a764468ae11c86ab3bc4ca4921f/skills/qt-qml-test/SKILL.md"
            },
            {
              "name": "qt-qml",
              "sourceUrl": "https://github.com/TheQtCompanyRnD/agent-skills/blob/71d6c10da78b9a764468ae11c86ab3bc4ca4921f/skills/qt-qml/SKILL.md"
            },
            {
              "name": "qt-ui-design",
              "sourceUrl": "https://github.com/TheQtCompanyRnD/agent-skills/blob/71d6c10da78b9a764468ae11c86ab3bc4ca4921f/skills/qt-ui-design/SKILL.md"
            }
          ],
          "mcpServers": [
            {
              "requiresConfiguration": false,
              "name": "qt-docs",
              "transport": "http",
              "endpoint": "https://qt-docs-mcp.qt.io/mcp"
            }
          ],
          "components": ["skills", "mcp"],
          "componentInspection": "repository",
          "inspectionError": null,
          "installation": "requires_adapter",
          "upstream": {
            "source": {
              "source": "url",
              "url": "https://github.com/TheQtCompanyRnD/agent-skills.git",
              "sha": "71d6c10da78b9a764468ae11c86ab3bc4ca4921f"
            },
            "policy": null
          }
        },
        {
          "id": "anthropic:quarkus-agent",
          "name": "quarkus-agent",
          "displayName": "quarkus-agent",
          "description": "MCP server for AI coding agents to create, manage, and interact with Quarkus applications. Provides tools for project scaffolding, dev mode lifecycle, extension skills, Dev MCP proxy, and documentation search.",
          "longDescription": "MCP server for AI coding agents to create, manage, and interact with Quarkus applications. Provides tools for project scaffolding, dev mode lifecycle, extension skills, Dev MCP proxy, and documentation search.",
          "category": "development",
          "keywords": ["quarkus", "java", "mcp", "dev-mode", "scaffolding"],
          "author": {
            "name": "Quarkus",
            "url": "https://quarkus.io"
          },
          "version": "1.2.6",
          "license": "Apache-2.0",
          "logoUrl": null,
          "darkLogoUrl": null,
          "homepage": "https://github.com/quarkusio/quarkus-agent-mcp",
          "sourceUrl": "https://github.com/quarkusio/quarkus-agent-mcp/tree/4cddd1ff2d49dc04a99b677614ba33014111afb5/",
          "skills": [],
          "mcpServers": [
            {
              "requiresConfiguration": false,
              "name": "quarkus-agent",
              "transport": "stdio",
              "endpoint": null
            }
          ],
          "components": ["mcp"],
          "componentInspection": "repository",
          "inspectionError": null,
          "installation": "requires_adapter",
          "upstream": {
            "source": {
              "source": "url",
              "url": "https://github.com/quarkusio/quarkus-agent-mcp.git",
              "sha": "4cddd1ff2d49dc04a99b677614ba33014111afb5"
            },
            "policy": null
          }
        },
        {
          "id": "anthropic:railway",
          "name": "railway",
          "displayName": "railway",
          "description": "Railway agent skills and hosted MCP server for deploying, configuring, monitoring, and troubleshooting apps and infrastructure on Railway from Claude Code. Manage services, environments, deployments, databases, object storage, networking, and observability.",
          "longDescription": "Railway agent skills and hosted MCP server for deploying, configuring, monitoring, and troubleshooting apps and infrastructure on Railway from Claude Code. Manage services, environments, deployments, databases, object storage, networking, and observability.",
          "category": "deployment",
          "keywords": [],
          "author": {
            "name": "Railway",
            "email": "contact@railway.com"
          },
          "version": "1.4.0",
          "license": "MIT",
          "logoUrl": null,
          "darkLogoUrl": null,
          "homepage": "https://docs.railway.com/agents",
          "sourceUrl": "https://github.com/railwayapp/railway-skills/tree/950acebcef3445f3915ea0709876c3ba9c237a7f/plugins/railway",
          "skills": [
            {
              "name": "use-railway",
              "sourceUrl": "https://github.com/railwayapp/railway-skills/blob/950acebcef3445f3915ea0709876c3ba9c237a7f/plugins/railway/skills/use-railway/SKILL.md"
            }
          ],
          "mcpServers": [
            {
              "requiresConfiguration": false,
              "name": "railway",
              "transport": "http",
              "endpoint": "https://mcp.railway.com"
            }
          ],
          "components": ["skills", "mcp", "hooks"],
          "componentInspection": "repository",
          "inspectionError": null,
          "installation": "requires_adapter",
          "upstream": {
            "source": {
              "source": "git-subdir",
              "url": "https://github.com/railwayapp/railway-skills.git",
              "path": "plugins/railway",
              "ref": "main",
              "sha": "950acebcef3445f3915ea0709876c3ba9c237a7f"
            },
            "policy": null
          }
        },
        {
          "id": "anthropic:ralph-loop",
          "name": "ralph-loop",
          "displayName": "ralph-loop",
          "description": "Continuous self-referential AI loops for interactive iterative development, implementing the Ralph Wiggum technique. Run Claude in a while-true loop with the same prompt until task completion.",
          "longDescription": "Continuous self-referential AI loops for interactive iterative development, implementing the Ralph Wiggum technique. Run Claude in a while-true loop with the same prompt until task completion.",
          "category": "development",
          "keywords": [],
          "author": {
            "name": "Anthropic",
            "email": "support@anthropic.com"
          },
          "version": "1.0.0",
          "license": null,
          "logoUrl": null,
          "darkLogoUrl": null,
          "homepage": "https://github.com/anthropics/claude-plugins-public/tree/main/plugins/ralph-loop",
          "sourceUrl": "https://github.com/anthropics/claude-plugins-official/tree/3b600518a637492d37c9877aeb49c2a55d939c04/plugins/ralph-loop",
          "skills": [],
          "mcpServers": [],
          "components": ["hooks", "commands"],
          "componentInspection": "repository",
          "inspectionError": null,
          "installation": "requires_adapter",
          "upstream": {
            "source": "./plugins/ralph-loop",
            "policy": null
          }
        },
        {
          "id": "anthropic:rc",
          "name": "rc",
          "displayName": "revenuecat",
          "description": "Set up RevenueCat, integrate it, and access data.",
          "longDescription": "Set up RevenueCat, integrate it, and access data.",
          "category": "development",
          "keywords": [
            "revenuecat",
            "in-app-purchases",
            "subscriptions",
            "monetization",
            "iap",
            "mcp"
          ],
          "author": {
            "name": "RevenueCat",
            "url": "https://www.revenuecat.com",
            "email": "support@revenuecat.com"
          },
          "version": "2.2.0",
          "license": "MIT",
          "logoUrl": null,
          "darkLogoUrl": null,
          "homepage": "https://www.revenuecat.com",
          "sourceUrl": "https://github.com/RevenueCat/rc-claude-code-plugin/tree/b9b77b12da33213c9c2e750b06cd6270c1d8ed65/revenuecat",
          "skills": [
            {
              "name": "create-revenuecat-project",
              "sourceUrl": "https://github.com/RevenueCat/rc-claude-code-plugin/blob/b9b77b12da33213c9c2e750b06cd6270c1d8ed65/revenuecat/skills/create-revenuecat-project/SKILL.md"
            },
            {
              "name": "integrate-revenuecat",
              "sourceUrl": "https://github.com/RevenueCat/rc-claude-code-plugin/blob/b9b77b12da33213c9c2e750b06cd6270c1d8ed65/revenuecat/skills/integrate-revenuecat/SKILL.md"
            },
            {
              "name": "revenuecat-charts",
              "sourceUrl": "https://github.com/RevenueCat/rc-claude-code-plugin/blob/b9b77b12da33213c9c2e750b06cd6270c1d8ed65/revenuecat/skills/revenuecat-charts/SKILL.md"
            },
            {
              "name": "revenuecat-cli",
              "sourceUrl": "https://github.com/RevenueCat/rc-claude-code-plugin/blob/b9b77b12da33213c9c2e750b06cd6270c1d8ed65/revenuecat/skills/revenuecat-cli/SKILL.md"
            },
            {
              "name": "revenuecat-customer-center",
              "sourceUrl": "https://github.com/RevenueCat/rc-claude-code-plugin/blob/b9b77b12da33213c9c2e750b06cd6270c1d8ed65/revenuecat/skills/revenuecat-customer-center/SKILL.md"
            },
            {
              "name": "revenuecat-entitlements-gate",
              "sourceUrl": "https://github.com/RevenueCat/rc-claude-code-plugin/blob/b9b77b12da33213c9c2e750b06cd6270c1d8ed65/revenuecat/skills/revenuecat-entitlements-gate/SKILL.md"
            },
            {
              "name": "revenuecat-experiment-analysis",
              "sourceUrl": "https://github.com/RevenueCat/rc-claude-code-plugin/blob/b9b77b12da33213c9c2e750b06cd6270c1d8ed65/revenuecat/skills/revenuecat-experiment-analysis/SKILL.md"
            },
            {
              "name": "revenuecat-experiments",
              "sourceUrl": "https://github.com/RevenueCat/rc-claude-code-plugin/blob/b9b77b12da33213c9c2e750b06cd6270c1d8ed65/revenuecat/skills/revenuecat-experiments/SKILL.md"
            },
            {
              "name": "revenuecat-identify-user",
              "sourceUrl": "https://github.com/RevenueCat/rc-claude-code-plugin/blob/b9b77b12da33213c9c2e750b06cd6270c1d8ed65/revenuecat/skills/revenuecat-identify-user/SKILL.md"
            },
            {
              "name": "revenuecat-migrate",
              "sourceUrl": "https://github.com/RevenueCat/rc-claude-code-plugin/blob/b9b77b12da33213c9c2e750b06cd6270c1d8ed65/revenuecat/skills/revenuecat-migrate/SKILL.md"
            },
            {
              "name": "revenuecat-paywall",
              "sourceUrl": "https://github.com/RevenueCat/rc-claude-code-plugin/blob/b9b77b12da33213c9c2e750b06cd6270c1d8ed65/revenuecat/skills/revenuecat-paywall/SKILL.md"
            },
            {
              "name": "revenuecat-purchase-flow",
              "sourceUrl": "https://github.com/RevenueCat/rc-claude-code-plugin/blob/b9b77b12da33213c9c2e750b06cd6270c1d8ed65/revenuecat/skills/revenuecat-purchase-flow/SKILL.md"
            },
            {
              "name": "revenuecat-sdk-compatibility",
              "sourceUrl": "https://github.com/RevenueCat/rc-claude-code-plugin/blob/b9b77b12da33213c9c2e750b06cd6270c1d8ed65/revenuecat/skills/revenuecat-sdk-compatibility/SKILL.md"
            },
            {
              "name": "revenuecat-status",
              "sourceUrl": "https://github.com/RevenueCat/rc-claude-code-plugin/blob/b9b77b12da33213c9c2e750b06cd6270c1d8ed65/revenuecat/skills/revenuecat-status/SKILL.md"
            },
            {
              "name": "revenuecat-store-state",
              "sourceUrl": "https://github.com/RevenueCat/rc-claude-code-plugin/blob/b9b77b12da33213c9c2e750b06cd6270c1d8ed65/revenuecat/skills/revenuecat-store-state/SKILL.md"
            },
            {
              "name": "revenuecat-testing-setup",
              "sourceUrl": "https://github.com/RevenueCat/rc-claude-code-plugin/blob/b9b77b12da33213c9c2e750b06cd6270c1d8ed65/revenuecat/skills/revenuecat-testing-setup/SKILL.md"
            },
            {
              "name": "revenuecat-troubleshoot",
              "sourceUrl": "https://github.com/RevenueCat/rc-claude-code-plugin/blob/b9b77b12da33213c9c2e750b06cd6270c1d8ed65/revenuecat/skills/revenuecat-troubleshoot/SKILL.md"
            },
            {
              "name": "revenuecat",
              "sourceUrl": "https://github.com/RevenueCat/rc-claude-code-plugin/blob/b9b77b12da33213c9c2e750b06cd6270c1d8ed65/revenuecat/skills/revenuecat/SKILL.md"
            }
          ],
          "mcpServers": [
            {
              "requiresConfiguration": false,
              "name": "RevenueCat",
              "transport": "http",
              "endpoint": "https://mcp.revenuecat.ai/mcp"
            }
          ],
          "components": ["skills", "mcp"],
          "componentInspection": "repository",
          "inspectionError": null,
          "installation": "requires_adapter",
          "upstream": {
            "source": {
              "source": "url",
              "url": "https://github.com/RevenueCat/rc-claude-code-plugin.git",
              "path": "revenuecat",
              "sha": "b9b77b12da33213c9c2e750b06cd6270c1d8ed65"
            },
            "policy": null
          }
        },
        {
          "id": "anthropic:receipts",
          "name": "receipts",
          "displayName": "receipts",
          "description": "A personal Claude Code impact report for justifying your usage to a manager or a self-review: what you shipped, which projects it went to, and each project's share of your usage. Reads your ~/.claude/projects transcripts and runs read-only git locally; only counts and project names are sent to write it up, and the report stays on your machine.",
          "longDescription": "A personal Claude Code impact report for justifying your usage to a manager or a self-review: what you shipped, which projects it went to, and each project's share of your usage. Reads your ~/.claude/projects transcripts and runs read-only git locally; only counts and project names are sent to write it up, and the report stays on your machine.",
          "category": "productivity",
          "keywords": [],
          "author": {
            "name": "Anthropic",
            "email": "support@anthropic.com"
          },
          "version": null,
          "license": null,
          "logoUrl": null,
          "darkLogoUrl": null,
          "homepage": "https://github.com/anthropics/claude-plugins-official/tree/main/plugins/receipts",
          "sourceUrl": "https://github.com/anthropics/claude-plugins-official/tree/3b600518a637492d37c9877aeb49c2a55d939c04/plugins/receipts",
          "skills": [
            {
              "name": "receipts",
              "sourceUrl": "https://github.com/anthropics/claude-plugins-official/blob/3b600518a637492d37c9877aeb49c2a55d939c04/plugins/receipts/skills/receipts/SKILL.md"
            }
          ],
          "mcpServers": [],
          "components": ["skills"],
          "componentInspection": "repository",
          "inspectionError": null,
          "installation": "requires_adapter",
          "upstream": {
            "source": "./plugins/receipts",
            "policy": null
          }
        },
        {
          "id": "anthropic:redis-development",
          "name": "redis-development",
          "displayName": "redis-development",
          "description": "Redis development best practices — data structures, query engine, vector search, caching, and performance optimization",
          "longDescription": "Redis development best practices — data structures, query engine, vector search, caching, and performance optimization",
          "category": "database",
          "keywords": [
            "redis",
            "database",
            "caching",
            "vector-search",
            "performance",
            "best-practices"
          ],
          "author": {
            "name": "Redis",
            "url": "https://redis.io"
          },
          "version": "1.4.0",
          "license": "MIT",
          "logoUrl": null,
          "darkLogoUrl": null,
          "homepage": "https://redis.io",
          "sourceUrl": "https://github.com/redis/agent-skills/tree/172fb9effa139cd7432ac29a9ee81c45943e5a28/plugins/redis-development",
          "skills": [
            {
              "name": "iris-development",
              "sourceUrl": "https://github.com/redis/agent-skills/blob/172fb9effa139cd7432ac29a9ee81c45943e5a28/plugins/redis-development/skills/iris-development/SKILL.md"
            },
            {
              "name": "redis-clustering",
              "sourceUrl": "https://github.com/redis/agent-skills/blob/172fb9effa139cd7432ac29a9ee81c45943e5a28/plugins/redis-development/skills/redis-clustering/SKILL.md"
            },
            {
              "name": "redis-connections",
              "sourceUrl": "https://github.com/redis/agent-skills/blob/172fb9effa139cd7432ac29a9ee81c45943e5a28/plugins/redis-development/skills/redis-connections/SKILL.md"
            },
            {
              "name": "redis-core",
              "sourceUrl": "https://github.com/redis/agent-skills/blob/172fb9effa139cd7432ac29a9ee81c45943e5a28/plugins/redis-development/skills/redis-core/SKILL.md"
            },
            {
              "name": "redis-observability",
              "sourceUrl": "https://github.com/redis/agent-skills/blob/172fb9effa139cd7432ac29a9ee81c45943e5a28/plugins/redis-development/skills/redis-observability/SKILL.md"
            },
            {
              "name": "redis-search",
              "sourceUrl": "https://github.com/redis/agent-skills/blob/172fb9effa139cd7432ac29a9ee81c45943e5a28/plugins/redis-development/skills/redis-search/SKILL.md"
            },
            {
              "name": "redis-security",
              "sourceUrl": "https://github.com/redis/agent-skills/blob/172fb9effa139cd7432ac29a9ee81c45943e5a28/plugins/redis-development/skills/redis-security/SKILL.md"
            },
            {
              "name": "redis-semantic-cache",
              "sourceUrl": "https://github.com/redis/agent-skills/blob/172fb9effa139cd7432ac29a9ee81c45943e5a28/plugins/redis-development/skills/redis-semantic-cache/SKILL.md"
            }
          ],
          "mcpServers": [],
          "components": ["skills"],
          "componentInspection": "repository",
          "inspectionError": null,
          "installation": "requires_adapter",
          "upstream": {
            "source": {
              "source": "git-subdir",
              "url": "https://github.com/redis/agent-skills.git",
              "path": "plugins/redis-development",
              "ref": "main",
              "sha": "172fb9effa139cd7432ac29a9ee81c45943e5a28"
            },
            "policy": null
          }
        },
        {
          "id": "anthropic:remember",
          "name": "remember",
          "displayName": "remember",
          "description": "Continuous memory for Claude Code. Extracts, summarizes, and compresses conversations into tiered daily logs. Claude remembers what you did yesterday.",
          "longDescription": "Continuous memory for Claude Code. Extracts, summarizes, and compresses conversations into tiered daily logs. Claude remembers what you did yesterday.",
          "category": null,
          "keywords": ["memory", "context", "persistence", "session"],
          "author": {
            "name": "Digital Process Tools"
          },
          "version": "0.29.1",
          "license": "Community License",
          "logoUrl": null,
          "darkLogoUrl": null,
          "homepage": "https://github.com/Digital-Process-Tools/claude-remember",
          "sourceUrl": "https://github.com/Digital-Process-Tools/claude-remember/tree/1f5d3f99983097e08f75d709fef8108d62ca97c6/",
          "skills": [
            {
              "name": "remember",
              "sourceUrl": "https://github.com/Digital-Process-Tools/claude-remember/blob/1f5d3f99983097e08f75d709fef8108d62ca97c6/skills/remember/SKILL.md"
            }
          ],
          "mcpServers": [],
          "components": ["skills", "hooks", "commands"],
          "componentInspection": "repository",
          "inspectionError": null,
          "installation": "requires_adapter",
          "upstream": {
            "source": {
              "source": "url",
              "url": "https://github.com/Digital-Process-Tools/claude-remember.git",
              "sha": "1f5d3f99983097e08f75d709fef8108d62ca97c6"
            },
            "policy": null
          }
        },
        {
          "id": "anthropic:render",
          "name": "render",
          "displayName": "render",
          "description": "Deploy, debug, and monitor applications on Render. Includes skills, an agent, slash commands, a render.yaml validation hook, and the Render MCP server preconfigured over OAuth.",
          "longDescription": "Deploy, debug, and monitor applications on Render. Includes skills, an agent, slash commands, a render.yaml validation hook, and the Render MCP server preconfigured over OAuth.",
          "category": "deployment",
          "keywords": ["render", "deploy", "cloud", "blueprint", "monitoring", "debugging"],
          "author": {
            "name": "Render",
            "email": "support@render.com",
            "url": "https://render.com"
          },
          "version": "0.2.2",
          "license": "MIT",
          "logoUrl": null,
          "darkLogoUrl": null,
          "homepage": "https://github.com/render-oss/render-plugin-claude-code",
          "sourceUrl": "https://github.com/render-oss/render-plugin-claude-code/tree/e8f889396634dbc8c368448a7f3de993ed4a5ac1/",
          "skills": [
            {
              "name": "render-background-workers",
              "sourceUrl": "https://github.com/render-oss/render-plugin-claude-code/blob/e8f889396634dbc8c368448a7f3de993ed4a5ac1/skills/render-background-workers/SKILL.md"
            },
            {
              "name": "render-blueprints",
              "sourceUrl": "https://github.com/render-oss/render-plugin-claude-code/blob/e8f889396634dbc8c368448a7f3de993ed4a5ac1/skills/render-blueprints/SKILL.md"
            },
            {
              "name": "render-cli",
              "sourceUrl": "https://github.com/render-oss/render-plugin-claude-code/blob/e8f889396634dbc8c368448a7f3de993ed4a5ac1/skills/render-cli/SKILL.md"
            },
            {
              "name": "render-cron-jobs",
              "sourceUrl": "https://github.com/render-oss/render-plugin-claude-code/blob/e8f889396634dbc8c368448a7f3de993ed4a5ac1/skills/render-cron-jobs/SKILL.md"
            },
            {
              "name": "render-debug",
              "sourceUrl": "https://github.com/render-oss/render-plugin-claude-code/blob/e8f889396634dbc8c368448a7f3de993ed4a5ac1/skills/render-debug/SKILL.md"
            },
            {
              "name": "render-deploy",
              "sourceUrl": "https://github.com/render-oss/render-plugin-claude-code/blob/e8f889396634dbc8c368448a7f3de993ed4a5ac1/skills/render-deploy/SKILL.md"
            },
            {
              "name": "render-disks",
              "sourceUrl": "https://github.com/render-oss/render-plugin-claude-code/blob/e8f889396634dbc8c368448a7f3de993ed4a5ac1/skills/render-disks/SKILL.md"
            },
            {
              "name": "render-docker",
              "sourceUrl": "https://github.com/render-oss/render-plugin-claude-code/blob/e8f889396634dbc8c368448a7f3de993ed4a5ac1/skills/render-docker/SKILL.md"
            },
            {
              "name": "render-domains",
              "sourceUrl": "https://github.com/render-oss/render-plugin-claude-code/blob/e8f889396634dbc8c368448a7f3de993ed4a5ac1/skills/render-domains/SKILL.md"
            },
            {
              "name": "render-env-vars",
              "sourceUrl": "https://github.com/render-oss/render-plugin-claude-code/blob/e8f889396634dbc8c368448a7f3de993ed4a5ac1/skills/render-env-vars/SKILL.md"
            },
            {
              "name": "render-keyvalue",
              "sourceUrl": "https://github.com/render-oss/render-plugin-claude-code/blob/e8f889396634dbc8c368448a7f3de993ed4a5ac1/skills/render-keyvalue/SKILL.md"
            },
            {
              "name": "render-mcp",
              "sourceUrl": "https://github.com/render-oss/render-plugin-claude-code/blob/e8f889396634dbc8c368448a7f3de993ed4a5ac1/skills/render-mcp/SKILL.md"
            },
            {
              "name": "render-migrate-from-heroku",
              "sourceUrl": "https://github.com/render-oss/render-plugin-claude-code/blob/e8f889396634dbc8c368448a7f3de993ed4a5ac1/skills/render-migrate-from-heroku/SKILL.md"
            },
            {
              "name": "render-monitor",
              "sourceUrl": "https://github.com/render-oss/render-plugin-claude-code/blob/e8f889396634dbc8c368448a7f3de993ed4a5ac1/skills/render-monitor/SKILL.md"
            },
            {
              "name": "render-networking",
              "sourceUrl": "https://github.com/render-oss/render-plugin-claude-code/blob/e8f889396634dbc8c368448a7f3de993ed4a5ac1/skills/render-networking/SKILL.md"
            },
            {
              "name": "render-postgres",
              "sourceUrl": "https://github.com/render-oss/render-plugin-claude-code/blob/e8f889396634dbc8c368448a7f3de993ed4a5ac1/skills/render-postgres/SKILL.md"
            },
            {
              "name": "render-private-services",
              "sourceUrl": "https://github.com/render-oss/render-plugin-claude-code/blob/e8f889396634dbc8c368448a7f3de993ed4a5ac1/skills/render-private-services/SKILL.md"
            },
            {
              "name": "render-scaling",
              "sourceUrl": "https://github.com/render-oss/render-plugin-claude-code/blob/e8f889396634dbc8c368448a7f3de993ed4a5ac1/skills/render-scaling/SKILL.md"
            },
            {
              "name": "render-static-sites",
              "sourceUrl": "https://github.com/render-oss/render-plugin-claude-code/blob/e8f889396634dbc8c368448a7f3de993ed4a5ac1/skills/render-static-sites/SKILL.md"
            },
            {
              "name": "render-web-services",
              "sourceUrl": "https://github.com/render-oss/render-plugin-claude-code/blob/e8f889396634dbc8c368448a7f3de993ed4a5ac1/skills/render-web-services/SKILL.md"
            },
            {
              "name": "render-workflows",
              "sourceUrl": "https://github.com/render-oss/render-plugin-claude-code/blob/e8f889396634dbc8c368448a7f3de993ed4a5ac1/skills/render-workflows/SKILL.md"
            }
          ],
          "mcpServers": [
            {
              "requiresConfiguration": false,
              "name": "render",
              "transport": "http",
              "endpoint": "https://mcp.render.com/mcp"
            }
          ],
          "components": ["skills", "mcp", "hooks", "agents", "commands"],
          "componentInspection": "repository",
          "inspectionError": null,
          "installation": "requires_adapter",
          "upstream": {
            "source": {
              "source": "url",
              "url": "https://github.com/render-oss/render-plugin-claude-code.git",
              "sha": "e8f889396634dbc8c368448a7f3de993ed4a5ac1"
            },
            "policy": null
          }
        },
        {
          "id": "anthropic:resend",
          "name": "resend",
          "displayName": "resend",
          "description": "Send and receive emails, build with React Email, follow deliverability best practices",
          "longDescription": "Send and receive emails, build with React Email, follow deliverability best practices",
          "category": "development",
          "keywords": ["email", "resend", "smtp", "notifications", "agent-inbox"],
          "author": {
            "name": "Resend",
            "email": "support@resend.com",
            "url": "https://resend.com"
          },
          "version": "1.0.5",
          "license": "MIT",
          "logoUrl": null,
          "darkLogoUrl": null,
          "homepage": "https://resend.com",
          "sourceUrl": "https://github.com/resend/resend-skills/tree/865a368601c4c88847f0d414f2656b2546cae461/",
          "skills": [
            {
              "name": "agent-email-inbox",
              "sourceUrl": "https://github.com/resend/resend-skills/blob/865a368601c4c88847f0d414f2656b2546cae461/skills/agent-email-inbox/SKILL.md"
            },
            {
              "name": "email-best-practices",
              "sourceUrl": "https://github.com/resend/resend-skills/blob/865a368601c4c88847f0d414f2656b2546cae461/skills/email-best-practices/SKILL.md"
            },
            {
              "name": "react-email",
              "sourceUrl": "https://github.com/resend/resend-skills/blob/865a368601c4c88847f0d414f2656b2546cae461/skills/react-email/SKILL.md"
            },
            {
              "name": "resend-cli",
              "sourceUrl": "https://github.com/resend/resend-skills/blob/865a368601c4c88847f0d414f2656b2546cae461/skills/resend-cli/SKILL.md"
            },
            {
              "name": "resend",
              "sourceUrl": "https://github.com/resend/resend-skills/blob/865a368601c4c88847f0d414f2656b2546cae461/skills/resend/SKILL.md"
            }
          ],
          "mcpServers": [
            {
              "requiresConfiguration": false,
              "name": "resend",
              "transport": "http",
              "endpoint": "https://mcp.resend.com/mcp"
            }
          ],
          "components": ["skills", "mcp"],
          "componentInspection": "repository",
          "inspectionError": null,
          "installation": "requires_adapter",
          "upstream": {
            "source": {
              "source": "url",
              "url": "https://github.com/resend/resend-skills.git",
              "sha": "865a368601c4c88847f0d414f2656b2546cae461"
            },
            "policy": null
          }
        },
        {
          "id": "anthropic:revenuecat",
          "name": "revenuecat",
          "displayName": "revenuecat",
          "description": "Set up RevenueCat, integrate it, and access data.",
          "longDescription": "Set up RevenueCat, integrate it, and access data.",
          "category": "development",
          "keywords": [
            "revenuecat",
            "in-app-purchases",
            "subscriptions",
            "monetization",
            "iap",
            "mcp"
          ],
          "author": {
            "name": "RevenueCat",
            "url": "https://www.revenuecat.com",
            "email": "support@revenuecat.com"
          },
          "version": "2.2.0",
          "license": "MIT",
          "logoUrl": null,
          "darkLogoUrl": null,
          "homepage": "https://www.revenuecat.com",
          "sourceUrl": "https://github.com/RevenueCat/rc-claude-code-plugin/tree/b9b77b12da33213c9c2e750b06cd6270c1d8ed65/revenuecat",
          "skills": [
            {
              "name": "create-revenuecat-project",
              "sourceUrl": "https://github.com/RevenueCat/rc-claude-code-plugin/blob/b9b77b12da33213c9c2e750b06cd6270c1d8ed65/revenuecat/skills/create-revenuecat-project/SKILL.md"
            },
            {
              "name": "integrate-revenuecat",
              "sourceUrl": "https://github.com/RevenueCat/rc-claude-code-plugin/blob/b9b77b12da33213c9c2e750b06cd6270c1d8ed65/revenuecat/skills/integrate-revenuecat/SKILL.md"
            },
            {
              "name": "revenuecat-charts",
              "sourceUrl": "https://github.com/RevenueCat/rc-claude-code-plugin/blob/b9b77b12da33213c9c2e750b06cd6270c1d8ed65/revenuecat/skills/revenuecat-charts/SKILL.md"
            },
            {
              "name": "revenuecat-cli",
              "sourceUrl": "https://github.com/RevenueCat/rc-claude-code-plugin/blob/b9b77b12da33213c9c2e750b06cd6270c1d8ed65/revenuecat/skills/revenuecat-cli/SKILL.md"
            },
            {
              "name": "revenuecat-customer-center",
              "sourceUrl": "https://github.com/RevenueCat/rc-claude-code-plugin/blob/b9b77b12da33213c9c2e750b06cd6270c1d8ed65/revenuecat/skills/revenuecat-customer-center/SKILL.md"
            },
            {
              "name": "revenuecat-entitlements-gate",
              "sourceUrl": "https://github.com/RevenueCat/rc-claude-code-plugin/blob/b9b77b12da33213c9c2e750b06cd6270c1d8ed65/revenuecat/skills/revenuecat-entitlements-gate/SKILL.md"
            },
            {
              "name": "revenuecat-experiment-analysis",
              "sourceUrl": "https://github.com/RevenueCat/rc-claude-code-plugin/blob/b9b77b12da33213c9c2e750b06cd6270c1d8ed65/revenuecat/skills/revenuecat-experiment-analysis/SKILL.md"
            },
            {
              "name": "revenuecat-experiments",
              "sourceUrl": "https://github.com/RevenueCat/rc-claude-code-plugin/blob/b9b77b12da33213c9c2e750b06cd6270c1d8ed65/revenuecat/skills/revenuecat-experiments/SKILL.md"
            },
            {
              "name": "revenuecat-identify-user",
              "sourceUrl": "https://github.com/RevenueCat/rc-claude-code-plugin/blob/b9b77b12da33213c9c2e750b06cd6270c1d8ed65/revenuecat/skills/revenuecat-identify-user/SKILL.md"
            },
            {
              "name": "revenuecat-migrate",
              "sourceUrl": "https://github.com/RevenueCat/rc-claude-code-plugin/blob/b9b77b12da33213c9c2e750b06cd6270c1d8ed65/revenuecat/skills/revenuecat-migrate/SKILL.md"
            },
            {
              "name": "revenuecat-paywall",
              "sourceUrl": "https://github.com/RevenueCat/rc-claude-code-plugin/blob/b9b77b12da33213c9c2e750b06cd6270c1d8ed65/revenuecat/skills/revenuecat-paywall/SKILL.md"
            },
            {
              "name": "revenuecat-purchase-flow",
              "sourceUrl": "https://github.com/RevenueCat/rc-claude-code-plugin/blob/b9b77b12da33213c9c2e750b06cd6270c1d8ed65/revenuecat/skills/revenuecat-purchase-flow/SKILL.md"
            },
            {
              "name": "revenuecat-sdk-compatibility",
              "sourceUrl": "https://github.com/RevenueCat/rc-claude-code-plugin/blob/b9b77b12da33213c9c2e750b06cd6270c1d8ed65/revenuecat/skills/revenuecat-sdk-compatibility/SKILL.md"
            },
            {
              "name": "revenuecat-status",
              "sourceUrl": "https://github.com/RevenueCat/rc-claude-code-plugin/blob/b9b77b12da33213c9c2e750b06cd6270c1d8ed65/revenuecat/skills/revenuecat-status/SKILL.md"
            },
            {
              "name": "revenuecat-store-state",
              "sourceUrl": "https://github.com/RevenueCat/rc-claude-code-plugin/blob/b9b77b12da33213c9c2e750b06cd6270c1d8ed65/revenuecat/skills/revenuecat-store-state/SKILL.md"
            },
            {
              "name": "revenuecat-testing-setup",
              "sourceUrl": "https://github.com/RevenueCat/rc-claude-code-plugin/blob/b9b77b12da33213c9c2e750b06cd6270c1d8ed65/revenuecat/skills/revenuecat-testing-setup/SKILL.md"
            },
            {
              "name": "revenuecat-troubleshoot",
              "sourceUrl": "https://github.com/RevenueCat/rc-claude-code-plugin/blob/b9b77b12da33213c9c2e750b06cd6270c1d8ed65/revenuecat/skills/revenuecat-troubleshoot/SKILL.md"
            },
            {
              "name": "revenuecat",
              "sourceUrl": "https://github.com/RevenueCat/rc-claude-code-plugin/blob/b9b77b12da33213c9c2e750b06cd6270c1d8ed65/revenuecat/skills/revenuecat/SKILL.md"
            }
          ],
          "mcpServers": [
            {
              "requiresConfiguration": false,
              "name": "RevenueCat",
              "transport": "http",
              "endpoint": "https://mcp.revenuecat.ai/mcp"
            }
          ],
          "components": ["skills", "mcp"],
          "componentInspection": "repository",
          "inspectionError": null,
          "installation": "requires_adapter",
          "upstream": {
            "source": {
              "source": "url",
              "url": "https://github.com/RevenueCat/rc-claude-code-plugin.git",
              "path": "revenuecat",
              "sha": "b9b77b12da33213c9c2e750b06cd6270c1d8ed65"
            },
            "policy": null
          }
        },
        {
          "id": "anthropic:rill",
          "name": "rill",
          "displayName": "rill",
          "description": "Skills for developing and querying projects in the Rill business intelligence platform",
          "longDescription": "Skills for developing and querying projects in the Rill business intelligence platform",
          "category": "development",
          "keywords": [],
          "author": {
            "name": "Rill Data"
          },
          "version": "1.0.0",
          "license": null,
          "logoUrl": null,
          "darkLogoUrl": null,
          "homepage": "https://docs.rilldata.com/developers/build/ai-configuration",
          "sourceUrl": "https://github.com/rilldata/agent-skills/tree/3ad909da945bb29ad738a8bb7e48dabc3ee6816a/",
          "skills": [
            {
              "name": "rill-analysis",
              "sourceUrl": "https://github.com/rilldata/agent-skills/blob/3ad909da945bb29ad738a8bb7e48dabc3ee6816a/skills/rill-analysis/SKILL.md"
            },
            {
              "name": "rill-canvas",
              "sourceUrl": "https://github.com/rilldata/agent-skills/blob/3ad909da945bb29ad738a8bb7e48dabc3ee6816a/skills/rill-canvas/SKILL.md"
            },
            {
              "name": "rill-connector",
              "sourceUrl": "https://github.com/rilldata/agent-skills/blob/3ad909da945bb29ad738a8bb7e48dabc3ee6816a/skills/rill-connector/SKILL.md"
            },
            {
              "name": "rill-development",
              "sourceUrl": "https://github.com/rilldata/agent-skills/blob/3ad909da945bb29ad738a8bb7e48dabc3ee6816a/skills/rill-development/SKILL.md"
            },
            {
              "name": "rill-explore",
              "sourceUrl": "https://github.com/rilldata/agent-skills/blob/3ad909da945bb29ad738a8bb7e48dabc3ee6816a/skills/rill-explore/SKILL.md"
            },
            {
              "name": "rill-metrics-view",
              "sourceUrl": "https://github.com/rilldata/agent-skills/blob/3ad909da945bb29ad738a8bb7e48dabc3ee6816a/skills/rill-metrics-view/SKILL.md"
            },
            {
              "name": "rill-model",
              "sourceUrl": "https://github.com/rilldata/agent-skills/blob/3ad909da945bb29ad738a8bb7e48dabc3ee6816a/skills/rill-model/SKILL.md"
            },
            {
              "name": "rill-rillyaml",
              "sourceUrl": "https://github.com/rilldata/agent-skills/blob/3ad909da945bb29ad738a8bb7e48dabc3ee6816a/skills/rill-rillyaml/SKILL.md"
            },
            {
              "name": "rill-theme",
              "sourceUrl": "https://github.com/rilldata/agent-skills/blob/3ad909da945bb29ad738a8bb7e48dabc3ee6816a/skills/rill-theme/SKILL.md"
            }
          ],
          "mcpServers": [
            {
              "requiresConfiguration": false,
              "name": "rill-developer",
              "transport": "http",
              "endpoint": "http://localhost:9009/mcp"
            }
          ],
          "components": ["skills", "mcp"],
          "componentInspection": "repository",
          "inspectionError": null,
          "installation": "requires_adapter",
          "upstream": {
            "source": {
              "source": "url",
              "url": "https://github.com/rilldata/agent-skills.git",
              "sha": "3ad909da945bb29ad738a8bb7e48dabc3ee6816a"
            },
            "policy": null
          }
        },
        {
          "id": "anthropic:rootly",
          "name": "rootly",
          "displayName": "rootly",
          "description": "Full-lifecycle incident management from your IDE. Prevent incidents before deploy, respond in real-time, and learn from post-mortems -- powered by Rootly.",
          "longDescription": "Full-lifecycle incident management from your IDE. Prevent incidents before deploy, respond in real-time, and learn from post-mortems -- powered by Rootly.",
          "category": "monitoring",
          "keywords": [
            "incident-management",
            "on-call",
            "sre",
            "devops",
            "deploy-safety",
            "retrospectives",
            "rootly"
          ],
          "author": {
            "name": "Rootly AI Labs",
            "email": "support@rootly.com",
            "url": "https://rootly.com"
          },
          "version": "2.2.0",
          "license": "Apache-2.0",
          "logoUrl": null,
          "darkLogoUrl": null,
          "homepage": "https://rootly.com/integrations/claude",
          "sourceUrl": "https://github.com/Rootly-AI-Labs/rootly-claude-plugin/tree/65832aa6ff7a7b39c6bd64899a7a64646e3948ed/",
          "skills": [
            {
              "name": "action",
              "sourceUrl": "https://github.com/Rootly-AI-Labs/rootly-claude-plugin/blob/65832aa6ff7a7b39c6bd64899a7a64646e3948ed/skills/action/SKILL.md"
            },
            {
              "name": "alert",
              "sourceUrl": "https://github.com/Rootly-AI-Labs/rootly-claude-plugin/blob/65832aa6ff7a7b39c6bd64899a7a64646e3948ed/skills/alert/SKILL.md"
            },
            {
              "name": "announce",
              "sourceUrl": "https://github.com/Rootly-AI-Labs/rootly-claude-plugin/blob/65832aa6ff7a7b39c6bd64899a7a64646e3948ed/skills/announce/SKILL.md"
            },
            {
              "name": "ask",
              "sourceUrl": "https://github.com/Rootly-AI-Labs/rootly-claude-plugin/blob/65832aa6ff7a7b39c6bd64899a7a64646e3948ed/skills/ask/SKILL.md"
            },
            {
              "name": "brief",
              "sourceUrl": "https://github.com/Rootly-AI-Labs/rootly-claude-plugin/blob/65832aa6ff7a7b39c6bd64899a7a64646e3948ed/skills/brief/SKILL.md"
            },
            {
              "name": "cover",
              "sourceUrl": "https://github.com/Rootly-AI-Labs/rootly-claude-plugin/blob/65832aa6ff7a7b39c6bd64899a7a64646e3948ed/skills/cover/SKILL.md"
            },
            {
              "name": "deploy-check",
              "sourceUrl": "https://github.com/Rootly-AI-Labs/rootly-claude-plugin/blob/65832aa6ff7a7b39c6bd64899a7a64646e3948ed/skills/deploy-check/SKILL.md"
            },
            {
              "name": "handoff",
              "sourceUrl": "https://github.com/Rootly-AI-Labs/rootly-claude-plugin/blob/65832aa6ff7a7b39c6bd64899a7a64646e3948ed/skills/handoff/SKILL.md"
            },
            {
              "name": "lookup",
              "sourceUrl": "https://github.com/Rootly-AI-Labs/rootly-claude-plugin/blob/65832aa6ff7a7b39c6bd64899a7a64646e3948ed/skills/lookup/SKILL.md"
            },
            {
              "name": "my",
              "sourceUrl": "https://github.com/Rootly-AI-Labs/rootly-claude-plugin/blob/65832aa6ff7a7b39c6bd64899a7a64646e3948ed/skills/my/SKILL.md"
            },
            {
              "name": "oncall",
              "sourceUrl": "https://github.com/Rootly-AI-Labs/rootly-claude-plugin/blob/65832aa6ff7a7b39c6bd64899a7a64646e3948ed/skills/oncall/SKILL.md"
            },
            {
              "name": "respond",
              "sourceUrl": "https://github.com/Rootly-AI-Labs/rootly-claude-plugin/blob/65832aa6ff7a7b39c6bd64899a7a64646e3948ed/skills/respond/SKILL.md"
            },
            {
              "name": "retro",
              "sourceUrl": "https://github.com/Rootly-AI-Labs/rootly-claude-plugin/blob/65832aa6ff7a7b39c6bd64899a7a64646e3948ed/skills/retro/SKILL.md"
            },
            {
              "name": "setup",
              "sourceUrl": "https://github.com/Rootly-AI-Labs/rootly-claude-plugin/blob/65832aa6ff7a7b39c6bd64899a7a64646e3948ed/skills/setup/SKILL.md"
            },
            {
              "name": "status",
              "sourceUrl": "https://github.com/Rootly-AI-Labs/rootly-claude-plugin/blob/65832aa6ff7a7b39c6bd64899a7a64646e3948ed/skills/status/SKILL.md"
            },
            {
              "name": "swap",
              "sourceUrl": "https://github.com/Rootly-AI-Labs/rootly-claude-plugin/blob/65832aa6ff7a7b39c6bd64899a7a64646e3948ed/skills/swap/SKILL.md"
            },
            {
              "name": "test",
              "sourceUrl": "https://github.com/Rootly-AI-Labs/rootly-claude-plugin/blob/65832aa6ff7a7b39c6bd64899a7a64646e3948ed/skills/test/SKILL.md"
            },
            {
              "name": "trend",
              "sourceUrl": "https://github.com/Rootly-AI-Labs/rootly-claude-plugin/blob/65832aa6ff7a7b39c6bd64899a7a64646e3948ed/skills/trend/SKILL.md"
            }
          ],
          "mcpServers": [
            {
              "requiresConfiguration": false,
              "name": "rootly",
              "transport": "http",
              "endpoint": "https://mcp.rootly.com/mcp"
            }
          ],
          "components": ["skills", "mcp", "hooks", "agents"],
          "componentInspection": "repository",
          "inspectionError": null,
          "installation": "requires_adapter",
          "upstream": {
            "source": {
              "source": "url",
              "url": "https://github.com/Rootly-AI-Labs/rootly-claude-plugin.git",
              "sha": "65832aa6ff7a7b39c6bd64899a7a64646e3948ed"
            },
            "policy": null
          }
        },
        {
          "id": "anthropic:ruby-lsp",
          "name": "ruby-lsp",
          "displayName": "ruby-lsp",
          "description": "Ruby language server for code intelligence and analysis",
          "longDescription": "Ruby language server for code intelligence and analysis",
          "category": "development",
          "keywords": [],
          "author": {
            "name": "Anthropic",
            "email": "support@anthropic.com"
          },
          "version": "1.0.0",
          "license": null,
          "logoUrl": null,
          "darkLogoUrl": null,
          "homepage": null,
          "sourceUrl": "https://github.com/anthropics/claude-plugins-official/tree/3b600518a637492d37c9877aeb49c2a55d939c04/plugins/ruby-lsp",
          "skills": [],
          "mcpServers": [],
          "components": [],
          "componentInspection": "repository",
          "inspectionError": null,
          "installation": "requires_adapter",
          "upstream": {
            "source": "./plugins/ruby-lsp",
            "policy": null
          }
        },
        {
          "id": "anthropic:runway-api",
          "name": "runway-api",
          "displayName": "runway-api",
          "description": "Build Runway models, Model Routers, Characters, recipes, and workflows into applications with Dev MCP and the official SDK, or generate media directly.",
          "longDescription": "Build Runway models, Model Routers, Characters, recipes, and workflows into applications with Dev MCP and the official SDK, or generate media directly.",
          "category": "design",
          "keywords": [
            "runway",
            "runwayml",
            "video-generation",
            "image-generation",
            "audio-generation",
            "ai-api",
            "seedance2",
            "gen4",
            "veo3",
            "media-generation",
            "batch",
            "runway-api"
          ],
          "author": {
            "name": "Runway",
            "email": "ops@runwayml.com"
          },
          "version": "3.0.0",
          "license": null,
          "logoUrl": null,
          "darkLogoUrl": null,
          "homepage": "https://runwayml.com",
          "sourceUrl": "https://github.com/runwayml/skills/tree/e3dffc15498e9588e7815f37b9ecf10e8bc2c902/",
          "skills": [
            {
              "name": "runway-dev-characters",
              "sourceUrl": "https://github.com/runwayml/skills/blob/e3dffc15498e9588e7815f37b9ecf10e8bc2c902/skills/runway-dev-characters/SKILL.md"
            },
            {
              "name": "runway-dev-model-routers",
              "sourceUrl": "https://github.com/runwayml/skills/blob/e3dffc15498e9588e7815f37b9ecf10e8bc2c902/skills/runway-dev-model-routers/SKILL.md"
            },
            {
              "name": "runway-dev-models",
              "sourceUrl": "https://github.com/runwayml/skills/blob/e3dffc15498e9588e7815f37b9ecf10e8bc2c902/skills/runway-dev-models/SKILL.md"
            },
            {
              "name": "runway-dev-recipes",
              "sourceUrl": "https://github.com/runwayml/skills/blob/e3dffc15498e9588e7815f37b9ecf10e8bc2c902/skills/runway-dev-recipes/SKILL.md"
            },
            {
              "name": "runway-dev-workflows",
              "sourceUrl": "https://github.com/runwayml/skills/blob/e3dffc15498e9588e7815f37b9ecf10e8bc2c902/skills/runway-dev-workflows/SKILL.md"
            },
            {
              "name": "runway-dev",
              "sourceUrl": "https://github.com/runwayml/skills/blob/e3dffc15498e9588e7815f37b9ecf10e8bc2c902/skills/runway-dev/SKILL.md"
            },
            {
              "name": "rw-check-org-details",
              "sourceUrl": "https://github.com/runwayml/skills/blob/e3dffc15498e9588e7815f37b9ecf10e8bc2c902/skills/rw-check-org-details/SKILL.md"
            },
            {
              "name": "rw-generate-audio",
              "sourceUrl": "https://github.com/runwayml/skills/blob/e3dffc15498e9588e7815f37b9ecf10e8bc2c902/skills/rw-generate-audio/SKILL.md"
            },
            {
              "name": "rw-generate-image",
              "sourceUrl": "https://github.com/runwayml/skills/blob/e3dffc15498e9588e7815f37b9ecf10e8bc2c902/skills/rw-generate-image/SKILL.md"
            },
            {
              "name": "rw-generate-video",
              "sourceUrl": "https://github.com/runwayml/skills/blob/e3dffc15498e9588e7815f37b9ecf10e8bc2c902/skills/rw-generate-video/SKILL.md"
            },
            {
              "name": "use-runway-api",
              "sourceUrl": "https://github.com/runwayml/skills/blob/e3dffc15498e9588e7815f37b9ecf10e8bc2c902/skills/use-runway-api/SKILL.md"
            }
          ],
          "mcpServers": [],
          "components": ["skills"],
          "componentInspection": "repository",
          "inspectionError": null,
          "installation": "requires_adapter",
          "upstream": {
            "source": {
              "source": "url",
              "url": "https://github.com/runwayml/skills.git",
              "sha": "e3dffc15498e9588e7815f37b9ecf10e8bc2c902"
            },
            "policy": null
          }
        },
        {
          "id": "anthropic:rust-analyzer-lsp",
          "name": "rust-analyzer-lsp",
          "displayName": "rust-analyzer-lsp",
          "description": "Rust language server for code intelligence and analysis",
          "longDescription": "Rust language server for code intelligence and analysis",
          "category": "development",
          "keywords": [],
          "author": {
            "name": "Anthropic",
            "email": "support@anthropic.com"
          },
          "version": "1.0.0",
          "license": null,
          "logoUrl": null,
          "darkLogoUrl": null,
          "homepage": null,
          "sourceUrl": "https://github.com/anthropics/claude-plugins-official/tree/3b600518a637492d37c9877aeb49c2a55d939c04/plugins/rust-analyzer-lsp",
          "skills": [],
          "mcpServers": [],
          "components": [],
          "componentInspection": "repository",
          "inspectionError": null,
          "installation": "requires_adapter",
          "upstream": {
            "source": "./plugins/rust-analyzer-lsp",
            "policy": null
          }
        },
        {
          "id": "anthropic:sagemaker-ai",
          "name": "sagemaker-ai",
          "displayName": "sagemaker-ai",
          "description": "Build, train, and deploy AI models with deep AWS AI/ML expertise brought directly into your coding assistants, covering the surface area of Amazon SageMaker AI.",
          "longDescription": "Build, train, and deploy AI models with deep AWS AI/ML expertise brought directly into your coding assistants, covering the surface area of Amazon SageMaker AI.",
          "category": "development",
          "keywords": [
            "sagemaker",
            "machine-learning",
            "generative-ai",
            "fine-tuning",
            "training",
            "deployment",
            "inference",
            "mlops",
            "aws"
          ],
          "author": {
            "name": "Amazon Web Services"
          },
          "version": "1.3.0",
          "license": "Apache-2.0",
          "logoUrl": null,
          "darkLogoUrl": null,
          "homepage": "https://github.com/awslabs/agent-plugins",
          "sourceUrl": "https://github.com/awslabs/agent-plugins/tree/bab56a3b9991aa0c6857b05198a61ba14a60bce4/plugins/sagemaker-ai",
          "skills": [
            {
              "name": "dataset-evaluation",
              "sourceUrl": "https://github.com/awslabs/agent-plugins/blob/bab56a3b9991aa0c6857b05198a61ba14a60bce4/plugins/sagemaker-ai/skills/dataset-evaluation/SKILL.md"
            },
            {
              "name": "dataset-transformation",
              "sourceUrl": "https://github.com/awslabs/agent-plugins/blob/bab56a3b9991aa0c6857b05198a61ba14a60bce4/plugins/sagemaker-ai/skills/dataset-transformation/SKILL.md"
            },
            {
              "name": "directory-management",
              "sourceUrl": "https://github.com/awslabs/agent-plugins/blob/bab56a3b9991aa0c6857b05198a61ba14a60bce4/plugins/sagemaker-ai/skills/directory-management/SKILL.md"
            },
            {
              "name": "finetuning-technique",
              "sourceUrl": "https://github.com/awslabs/agent-plugins/blob/bab56a3b9991aa0c6857b05198a61ba14a60bce4/plugins/sagemaker-ai/skills/finetuning-technique/SKILL.md"
            },
            {
              "name": "finetuning",
              "sourceUrl": "https://github.com/awslabs/agent-plugins/blob/bab56a3b9991aa0c6857b05198a61ba14a60bce4/plugins/sagemaker-ai/skills/finetuning/SKILL.md"
            },
            {
              "name": "hyperpod-cluster-debugger",
              "sourceUrl": "https://github.com/awslabs/agent-plugins/blob/bab56a3b9991aa0c6857b05198a61ba14a60bce4/plugins/sagemaker-ai/skills/hyperpod-cluster-debugger/SKILL.md"
            },
            {
              "name": "hyperpod-issue-report",
              "sourceUrl": "https://github.com/awslabs/agent-plugins/blob/bab56a3b9991aa0c6857b05198a61ba14a60bce4/plugins/sagemaker-ai/skills/hyperpod-issue-report/SKILL.md"
            },
            {
              "name": "hyperpod-nccl",
              "sourceUrl": "https://github.com/awslabs/agent-plugins/blob/bab56a3b9991aa0c6857b05198a61ba14a60bce4/plugins/sagemaker-ai/skills/hyperpod-nccl/SKILL.md"
            },
            {
              "name": "hyperpod-node-debugger",
              "sourceUrl": "https://github.com/awslabs/agent-plugins/blob/bab56a3b9991aa0c6857b05198a61ba14a60bce4/plugins/sagemaker-ai/skills/hyperpod-node-debugger/SKILL.md"
            },
            {
              "name": "hyperpod-performance-debugger",
              "sourceUrl": "https://github.com/awslabs/agent-plugins/blob/bab56a3b9991aa0c6857b05198a61ba14a60bce4/plugins/sagemaker-ai/skills/hyperpod-performance-debugger/SKILL.md"
            },
            {
              "name": "hyperpod-slurm-debugger",
              "sourceUrl": "https://github.com/awslabs/agent-plugins/blob/bab56a3b9991aa0c6857b05198a61ba14a60bce4/plugins/sagemaker-ai/skills/hyperpod-slurm-debugger/SKILL.md"
            },
            {
              "name": "hyperpod-ssm",
              "sourceUrl": "https://github.com/awslabs/agent-plugins/blob/bab56a3b9991aa0c6857b05198a61ba14a60bce4/plugins/sagemaker-ai/skills/hyperpod-ssm/SKILL.md"
            },
            {
              "name": "hyperpod-version-checker",
              "sourceUrl": "https://github.com/awslabs/agent-plugins/blob/bab56a3b9991aa0c6857b05198a61ba14a60bce4/plugins/sagemaker-ai/skills/hyperpod-version-checker/SKILL.md"
            },
            {
              "name": "model-deployment",
              "sourceUrl": "https://github.com/awslabs/agent-plugins/blob/bab56a3b9991aa0c6857b05198a61ba14a60bce4/plugins/sagemaker-ai/skills/model-deployment/SKILL.md"
            },
            {
              "name": "model-evaluation",
              "sourceUrl": "https://github.com/awslabs/agent-plugins/blob/bab56a3b9991aa0c6857b05198a61ba14a60bce4/plugins/sagemaker-ai/skills/model-evaluation/SKILL.md"
            },
            {
              "name": "model-selection",
              "sourceUrl": "https://github.com/awslabs/agent-plugins/blob/bab56a3b9991aa0c6857b05198a61ba14a60bce4/plugins/sagemaker-ai/skills/model-selection/SKILL.md"
            },
            {
              "name": "planning",
              "sourceUrl": "https://github.com/awslabs/agent-plugins/blob/bab56a3b9991aa0c6857b05198a61ba14a60bce4/plugins/sagemaker-ai/skills/planning/SKILL.md"
            },
            {
              "name": "sdk-getting-started",
              "sourceUrl": "https://github.com/awslabs/agent-plugins/blob/bab56a3b9991aa0c6857b05198a61ba14a60bce4/plugins/sagemaker-ai/skills/sdk-getting-started/SKILL.md"
            },
            {
              "name": "use-case-specification",
              "sourceUrl": "https://github.com/awslabs/agent-plugins/blob/bab56a3b9991aa0c6857b05198a61ba14a60bce4/plugins/sagemaker-ai/skills/use-case-specification/SKILL.md"
            }
          ],
          "mcpServers": [
            {
              "requiresConfiguration": false,
              "name": "aws-mcp",
              "transport": "stdio",
              "endpoint": null
            }
          ],
          "components": ["skills", "mcp"],
          "componentInspection": "repository",
          "inspectionError": null,
          "installation": "requires_adapter",
          "upstream": {
            "source": {
              "source": "git-subdir",
              "url": "https://github.com/awslabs/agent-plugins.git",
              "path": "plugins/sagemaker-ai",
              "ref": "main",
              "sha": "bab56a3b9991aa0c6857b05198a61ba14a60bce4"
            },
            "policy": null
          }
        },
        {
          "id": "anthropic:salesforce-development",
          "name": "salesforce-development",
          "displayName": "salesforce-development",
          "description": "Build Salesforce apps and agents using these core building blocks: metadata, Apex, deploy/retrieve, security, reporting, and generated installed-versus-available capability discovery.",
          "longDescription": "Build Salesforce apps and agents using these core building blocks: metadata, Apex, deploy/retrieve, security, reporting, and generated installed-versus-available capability discovery.",
          "category": "development",
          "keywords": ["salesforce", "apex", "flow", "soql", "metadata", "deploy"],
          "author": {
            "name": "Salesforce",
            "url": "https://github.com/forcedotcom/sf-skills"
          },
          "version": "2.1.1",
          "license": "Apache-2.0",
          "logoUrl": null,
          "darkLogoUrl": null,
          "homepage": "https://github.com/forcedotcom/sf-skills/tree/main/plugins/builder/salesforce-development",
          "sourceUrl": "https://github.com/forcedotcom/sf-skills/tree/7e04d4744792ae2defb7f4da24fe85cbdf6f6e5a/plugins/builder/salesforce-development",
          "skills": [
            {
              "name": "automation-flow-generate",
              "sourceUrl": "https://github.com/forcedotcom/sf-skills/blob/7e04d4744792ae2defb7f4da24fe85cbdf6f6e5a/plugins/builder/salesforce-development/skills/automation-flow-generate/SKILL.md"
            },
            {
              "name": "dx-code-analyzer-configure",
              "sourceUrl": "https://github.com/forcedotcom/sf-skills/blob/7e04d4744792ae2defb7f4da24fe85cbdf6f6e5a/plugins/builder/salesforce-development/skills/dx-code-analyzer-configure/SKILL.md"
            },
            {
              "name": "dx-code-analyzer-custom-rule-create",
              "sourceUrl": "https://github.com/forcedotcom/sf-skills/blob/7e04d4744792ae2defb7f4da24fe85cbdf6f6e5a/plugins/builder/salesforce-development/skills/dx-code-analyzer-custom-rule-create/SKILL.md"
            },
            {
              "name": "dx-code-analyzer-run",
              "sourceUrl": "https://github.com/forcedotcom/sf-skills/blob/7e04d4744792ae2defb7f4da24fe85cbdf6f6e5a/plugins/builder/salesforce-development/skills/dx-code-analyzer-run/SKILL.md"
            },
            {
              "name": "dx-org-manage",
              "sourceUrl": "https://github.com/forcedotcom/sf-skills/blob/7e04d4744792ae2defb7f4da24fe85cbdf6f6e5a/plugins/builder/salesforce-development/skills/dx-org-manage/SKILL.md"
            },
            {
              "name": "dx-project-create",
              "sourceUrl": "https://github.com/forcedotcom/sf-skills/blob/7e04d4744792ae2defb7f4da24fe85cbdf6f6e5a/plugins/builder/salesforce-development/skills/dx-project-create/SKILL.md"
            },
            {
              "name": "platform-apex-anonymous-run",
              "sourceUrl": "https://github.com/forcedotcom/sf-skills/blob/7e04d4744792ae2defb7f4da24fe85cbdf6f6e5a/plugins/builder/salesforce-development/skills/platform-apex-anonymous-run/SKILL.md"
            },
            {
              "name": "platform-apex-generate",
              "sourceUrl": "https://github.com/forcedotcom/sf-skills/blob/7e04d4744792ae2defb7f4da24fe85cbdf6f6e5a/plugins/builder/salesforce-development/skills/platform-apex-generate/SKILL.md"
            },
            {
              "name": "platform-apex-logs-debug",
              "sourceUrl": "https://github.com/forcedotcom/sf-skills/blob/7e04d4744792ae2defb7f4da24fe85cbdf6f6e5a/plugins/builder/salesforce-development/skills/platform-apex-logs-debug/SKILL.md"
            },
            {
              "name": "platform-apex-test-generate",
              "sourceUrl": "https://github.com/forcedotcom/sf-skills/blob/7e04d4744792ae2defb7f4da24fe85cbdf6f6e5a/plugins/builder/salesforce-development/skills/platform-apex-test-generate/SKILL.md"
            },
            {
              "name": "platform-apex-test-run",
              "sourceUrl": "https://github.com/forcedotcom/sf-skills/blob/7e04d4744792ae2defb7f4da24fe85cbdf6f6e5a/plugins/builder/salesforce-development/skills/platform-apex-test-run/SKILL.md"
            },
            {
              "name": "platform-architecture-analyze",
              "sourceUrl": "https://github.com/forcedotcom/sf-skills/blob/7e04d4744792ae2defb7f4da24fe85cbdf6f6e5a/plugins/builder/salesforce-development/skills/platform-architecture-analyze/SKILL.md"
            },
            {
              "name": "platform-capability-search",
              "sourceUrl": "https://github.com/forcedotcom/sf-skills/blob/7e04d4744792ae2defb7f4da24fe85cbdf6f6e5a/plugins/builder/salesforce-development/skills/platform-capability-search/SKILL.md"
            },
            {
              "name": "platform-custom-application-generate",
              "sourceUrl": "https://github.com/forcedotcom/sf-skills/blob/7e04d4744792ae2defb7f4da24fe85cbdf6f6e5a/plugins/builder/salesforce-development/skills/platform-custom-application-generate/SKILL.md"
            },
            {
              "name": "platform-custom-field-generate",
              "sourceUrl": "https://github.com/forcedotcom/sf-skills/blob/7e04d4744792ae2defb7f4da24fe85cbdf6f6e5a/plugins/builder/salesforce-development/skills/platform-custom-field-generate/SKILL.md"
            },
            {
              "name": "platform-custom-object-generate",
              "sourceUrl": "https://github.com/forcedotcom/sf-skills/blob/7e04d4744792ae2defb7f4da24fe85cbdf6f6e5a/plugins/builder/salesforce-development/skills/platform-custom-object-generate/SKILL.md"
            },
            {
              "name": "platform-custom-report-type-generate",
              "sourceUrl": "https://github.com/forcedotcom/sf-skills/blob/7e04d4744792ae2defb7f4da24fe85cbdf6f6e5a/plugins/builder/salesforce-development/skills/platform-custom-report-type-generate/SKILL.md"
            },
            {
              "name": "platform-custom-tab-generate",
              "sourceUrl": "https://github.com/forcedotcom/sf-skills/blob/7e04d4744792ae2defb7f4da24fe85cbdf6f6e5a/plugins/builder/salesforce-development/skills/platform-custom-tab-generate/SKILL.md"
            },
            {
              "name": "platform-deploy-validate",
              "sourceUrl": "https://github.com/forcedotcom/sf-skills/blob/7e04d4744792ae2defb7f4da24fe85cbdf6f6e5a/plugins/builder/salesforce-development/skills/platform-deploy-validate/SKILL.md"
            },
            {
              "name": "platform-destructive-deploy",
              "sourceUrl": "https://github.com/forcedotcom/sf-skills/blob/7e04d4744792ae2defb7f4da24fe85cbdf6f6e5a/plugins/builder/salesforce-development/skills/platform-destructive-deploy/SKILL.md"
            },
            {
              "name": "platform-environment-validate",
              "sourceUrl": "https://github.com/forcedotcom/sf-skills/blob/7e04d4744792ae2defb7f4da24fe85cbdf6f6e5a/plugins/builder/salesforce-development/skills/platform-environment-validate/SKILL.md"
            },
            {
              "name": "platform-flexipage-generate",
              "sourceUrl": "https://github.com/forcedotcom/sf-skills/blob/7e04d4744792ae2defb7f4da24fe85cbdf6f6e5a/plugins/builder/salesforce-development/skills/platform-flexipage-generate/SKILL.md"
            },
            {
              "name": "platform-lightning-app-coordinate",
              "sourceUrl": "https://github.com/forcedotcom/sf-skills/blob/7e04d4744792ae2defb7f4da24fe85cbdf6f6e5a/plugins/builder/salesforce-development/skills/platform-lightning-app-coordinate/SKILL.md"
            },
            {
              "name": "platform-list-view-generate",
              "sourceUrl": "https://github.com/forcedotcom/sf-skills/blob/7e04d4744792ae2defb7f4da24fe85cbdf6f6e5a/plugins/builder/salesforce-development/skills/platform-list-view-generate/SKILL.md"
            },
            {
              "name": "platform-lsp-integrate",
              "sourceUrl": "https://github.com/forcedotcom/sf-skills/blob/7e04d4744792ae2defb7f4da24fe85cbdf6f6e5a/plugins/builder/salesforce-development/skills/platform-lsp-integrate/SKILL.md"
            },
            {
              "name": "platform-manifest-generate",
              "sourceUrl": "https://github.com/forcedotcom/sf-skills/blob/7e04d4744792ae2defb7f4da24fe85cbdf6f6e5a/plugins/builder/salesforce-development/skills/platform-manifest-generate/SKILL.md"
            },
            {
              "name": "platform-metadata-api-context-get",
              "sourceUrl": "https://github.com/forcedotcom/sf-skills/blob/7e04d4744792ae2defb7f4da24fe85cbdf6f6e5a/plugins/builder/salesforce-development/skills/platform-metadata-api-context-get/SKILL.md"
            },
            {
              "name": "platform-metadata-deploy",
              "sourceUrl": "https://github.com/forcedotcom/sf-skills/blob/7e04d4744792ae2defb7f4da24fe85cbdf6f6e5a/plugins/builder/salesforce-development/skills/platform-metadata-deploy/SKILL.md"
            },
            {
              "name": "platform-metadata-retrieve",
              "sourceUrl": "https://github.com/forcedotcom/sf-skills/blob/7e04d4744792ae2defb7f4da24fe85cbdf6f6e5a/plugins/builder/salesforce-development/skills/platform-metadata-retrieve/SKILL.md"
            },
            {
              "name": "platform-permission-set-generate",
              "sourceUrl": "https://github.com/forcedotcom/sf-skills/blob/7e04d4744792ae2defb7f4da24fe85cbdf6f6e5a/plugins/builder/salesforce-development/skills/platform-permission-set-generate/SKILL.md"
            },
            {
              "name": "platform-quick-deploy",
              "sourceUrl": "https://github.com/forcedotcom/sf-skills/blob/7e04d4744792ae2defb7f4da24fe85cbdf6f6e5a/plugins/builder/salesforce-development/skills/platform-quick-deploy/SKILL.md"
            },
            {
              "name": "platform-report-generate",
              "sourceUrl": "https://github.com/forcedotcom/sf-skills/blob/7e04d4744792ae2defb7f4da24fe85cbdf6f6e5a/plugins/builder/salesforce-development/skills/platform-report-generate/SKILL.md"
            },
            {
              "name": "platform-sharing-owd-configure",
              "sourceUrl": "https://github.com/forcedotcom/sf-skills/blob/7e04d4744792ae2defb7f4da24fe85cbdf6f6e5a/plugins/builder/salesforce-development/skills/platform-sharing-owd-configure/SKILL.md"
            },
            {
              "name": "platform-sharing-rules-generate",
              "sourceUrl": "https://github.com/forcedotcom/sf-skills/blob/7e04d4744792ae2defb7f4da24fe85cbdf6f6e5a/plugins/builder/salesforce-development/skills/platform-sharing-rules-generate/SKILL.md"
            },
            {
              "name": "platform-soql-query",
              "sourceUrl": "https://github.com/forcedotcom/sf-skills/blob/7e04d4744792ae2defb7f4da24fe85cbdf6f6e5a/plugins/builder/salesforce-development/skills/platform-soql-query/SKILL.md"
            },
            {
              "name": "platform-validation-rule-generate",
              "sourceUrl": "https://github.com/forcedotcom/sf-skills/blob/7e04d4744792ae2defb7f4da24fe85cbdf6f6e5a/plugins/builder/salesforce-development/skills/platform-validation-rule-generate/SKILL.md"
            },
            {
              "name": "platform-value-set-generate",
              "sourceUrl": "https://github.com/forcedotcom/sf-skills/blob/7e04d4744792ae2defb7f4da24fe85cbdf6f6e5a/plugins/builder/salesforce-development/skills/platform-value-set-generate/SKILL.md"
            }
          ],
          "mcpServers": [
            {
              "requiresConfiguration": false,
              "name": "salesforce-api-context",
              "transport": "stdio",
              "endpoint": null
            },
            {
              "requiresConfiguration": false,
              "name": "salesforce-metadata-experts",
              "transport": "stdio",
              "endpoint": null
            },
            {
              "requiresConfiguration": false,
              "name": "salesforce-lsp",
              "transport": "stdio",
              "endpoint": null
            }
          ],
          "components": ["skills", "mcp", "agents", "commands"],
          "componentInspection": "repository",
          "inspectionError": null,
          "installation": "requires_adapter",
          "upstream": {
            "source": {
              "source": "git-subdir",
              "url": "https://github.com/forcedotcom/sf-skills.git",
              "path": "plugins/builder/salesforce-development",
              "ref": "main",
              "sha": "7e04d4744792ae2defb7f4da24fe85cbdf6f6e5a"
            },
            "policy": null
          }
        },
        {
          "id": "anthropic:sanity",
          "name": "sanity",
          "displayName": "sanity",
          "description": "Sanity plugin for Claude Code with MCP server, agent skills, agent rules, and slash commands.",
          "longDescription": "Sanity plugin for Claude Code with MCP server, agent skills, agent rules, and slash commands.",
          "category": "development",
          "keywords": [
            "sanity",
            "cms",
            "content-lake",
            "groq",
            "content",
            "structured-content",
            "visual-editing"
          ],
          "author": {
            "name": "Sanity",
            "email": "support@sanity.io",
            "url": "https://www.sanity.io"
          },
          "version": "1.0.0",
          "license": "MIT",
          "logoUrl": null,
          "darkLogoUrl": null,
          "homepage": "https://github.com/sanity-io/agent-toolkit",
          "sourceUrl": "https://github.com/sanity-io/agent-toolkit/tree/e447ef10e09f14e245fa787d59157c7ae3576744/",
          "skills": [
            {
              "name": "content-experimentation-best-practices",
              "sourceUrl": "https://github.com/sanity-io/agent-toolkit/blob/e447ef10e09f14e245fa787d59157c7ae3576744/skills/content-experimentation-best-practices/SKILL.md"
            },
            {
              "name": "content-modeling-best-practices",
              "sourceUrl": "https://github.com/sanity-io/agent-toolkit/blob/e447ef10e09f14e245fa787d59157c7ae3576744/skills/content-modeling-best-practices/SKILL.md"
            },
            {
              "name": "portable-text-conversion",
              "sourceUrl": "https://github.com/sanity-io/agent-toolkit/blob/e447ef10e09f14e245fa787d59157c7ae3576744/skills/portable-text-conversion/SKILL.md"
            },
            {
              "name": "portable-text-serialization",
              "sourceUrl": "https://github.com/sanity-io/agent-toolkit/blob/e447ef10e09f14e245fa787d59157c7ae3576744/skills/portable-text-serialization/SKILL.md"
            },
            {
              "name": "sanity-best-practices",
              "sourceUrl": "https://github.com/sanity-io/agent-toolkit/blob/e447ef10e09f14e245fa787d59157c7ae3576744/skills/sanity-best-practices/SKILL.md"
            },
            {
              "name": "sanity-migration",
              "sourceUrl": "https://github.com/sanity-io/agent-toolkit/blob/e447ef10e09f14e245fa787d59157c7ae3576744/skills/sanity-migration/SKILL.md"
            },
            {
              "name": "seo-aeo-best-practices",
              "sourceUrl": "https://github.com/sanity-io/agent-toolkit/blob/e447ef10e09f14e245fa787d59157c7ae3576744/skills/seo-aeo-best-practices/SKILL.md"
            }
          ],
          "mcpServers": [
            {
              "requiresConfiguration": false,
              "name": "Sanity",
              "transport": "http",
              "endpoint": "https://mcp.sanity.io"
            }
          ],
          "components": ["skills", "mcp", "commands"],
          "componentInspection": "repository",
          "inspectionError": null,
          "installation": "requires_adapter",
          "upstream": {
            "source": {
              "source": "url",
              "url": "https://github.com/sanity-io/agent-toolkit.git",
              "sha": "e447ef10e09f14e245fa787d59157c7ae3576744"
            },
            "policy": null
          }
        },
        {
          "id": "anthropic:sap-cds-mcp",
          "name": "sap-cds-mcp",
          "displayName": "cds-mcp",
          "description": "Model Context Protocol (MCP) server for AI-assisted development of CAP applications.",
          "longDescription": "Model Context Protocol (MCP) server for AI-assisted development of CAP applications.",
          "category": "development",
          "keywords": ["sap", "cap", "cds", "mcp"],
          "author": {
            "name": "SAP SE"
          },
          "version": "0.0.5",
          "license": "Apache-2.0",
          "logoUrl": null,
          "darkLogoUrl": null,
          "homepage": "https://cap.cloud.sap/",
          "sourceUrl": "https://github.com/cap-js/mcp-server/tree/644bf4a132313cf506b2ae11ac51db9123198af3/",
          "skills": [],
          "mcpServers": [
            {
              "requiresConfiguration": false,
              "name": "cds-mcp",
              "transport": "stdio",
              "endpoint": null
            }
          ],
          "components": ["mcp"],
          "componentInspection": "repository",
          "inspectionError": null,
          "installation": "requires_adapter",
          "upstream": {
            "source": {
              "source": "url",
              "url": "https://github.com/cap-js/mcp-server.git",
              "sha": "644bf4a132313cf506b2ae11ac51db9123198af3"
            },
            "policy": null
          }
        },
        {
          "id": "anthropic:sap-fiori-mcp-server",
          "name": "sap-fiori-mcp-server",
          "displayName": "sap-fiori-mcp-server",
          "description": "MCP server for SAP Fiori development tools for Claude Code. Build and modify SAP Fiori applications with AI assistance.",
          "longDescription": "MCP server for SAP Fiori development tools for Claude Code. Build and modify SAP Fiori applications with AI assistance.",
          "category": "development",
          "keywords": ["sap", "fiori", "ui5", "cap", "mcp", "fiori-elements"],
          "author": {
            "name": "SAP SE",
            "email": "ospo@sap.com",
            "url": "https://www.sap.com"
          },
          "version": "1.12.2",
          "license": "Apache-2.0",
          "logoUrl": null,
          "darkLogoUrl": null,
          "homepage": "https://github.com/SAP/open-ux-tools/tree/main/packages/fiori-mcp-server",
          "sourceUrl": "https://github.com/SAP/open-ux-tools/tree/831854d266fa83cace4f714a8aabf6fd3c3e91ca/packages/fiori-mcp-server",
          "skills": [
            {
              "name": "sap-fiori-add-visual-filter",
              "sourceUrl": "https://github.com/SAP/open-ux-tools/blob/831854d266fa83cace4f714a8aabf6fd3c3e91ca/packages/fiori-mcp-server/skills/sap-fiori-add-visual-filter/SKILL.md"
            },
            {
              "name": "sap-fiori-analytical-chart",
              "sourceUrl": "https://github.com/SAP/open-ux-tools/blob/831854d266fa83cace4f714a8aabf6fd3c3e91ca/packages/fiori-mcp-server/skills/sap-fiori-analytical-chart/SKILL.md"
            },
            {
              "name": "sap-fiori-app-development",
              "sourceUrl": "https://github.com/SAP/open-ux-tools/blob/831854d266fa83cace4f714a8aabf6fd3c3e91ca/packages/fiori-mcp-server/skills/sap-fiori-app-development/SKILL.md"
            },
            {
              "name": "sap-fiori-create-cli",
              "sourceUrl": "https://github.com/SAP/open-ux-tools/blob/831854d266fa83cace4f714a8aabf6fd3c3e91ca/packages/fiori-mcp-server/skills/sap-fiori-create-cli/SKILL.md"
            },
            {
              "name": "sap-fiori-eslint-plugin",
              "sourceUrl": "https://github.com/SAP/open-ux-tools/blob/831854d266fa83cace4f714a8aabf6fd3c3e91ca/packages/fiori-mcp-server/skills/sap-fiori-eslint-plugin/SKILL.md"
            },
            {
              "name": "sap-fiori-opa5-test-development",
              "sourceUrl": "https://github.com/SAP/open-ux-tools/blob/831854d266fa83cace4f714a8aabf6fd3c3e91ca/packages/fiori-mcp-server/skills/sap-fiori-opa5-test-development/SKILL.md"
            },
            {
              "name": "sap-fiori-tree-table",
              "sourceUrl": "https://github.com/SAP/open-ux-tools/blob/831854d266fa83cace4f714a8aabf6fd3c3e91ca/packages/fiori-mcp-server/skills/sap-fiori-tree-table/SKILL.md"
            }
          ],
          "mcpServers": [
            {
              "requiresConfiguration": false,
              "name": "fiori-mcp",
              "transport": "stdio",
              "endpoint": null
            }
          ],
          "components": ["skills", "mcp"],
          "componentInspection": "repository",
          "inspectionError": null,
          "installation": "requires_adapter",
          "upstream": {
            "source": {
              "source": "git-subdir",
              "url": "https://github.com/SAP/open-ux-tools.git",
              "path": "packages/fiori-mcp-server",
              "ref": "main",
              "sha": "831854d266fa83cace4f714a8aabf6fd3c3e91ca"
            },
            "policy": null
          }
        },
        {
          "id": "anthropic:sap-hana-cli",
          "name": "sap-hana-cli",
          "displayName": "hana-cli",
          "description": "150+ SAP HANA database tools for AI assistants. Query tables, import/export data, profile data quality, compare schemas, manage backups, monitor performance, and more. Connects to SAP HANA Cloud and on-premise databases.",
          "longDescription": "150+ SAP HANA database tools for AI assistants. Query tables, import/export data, profile data quality, compare schemas, manage backups, monitor performance, and more. Connects to SAP HANA Cloud and on-premise databases.",
          "category": "database",
          "keywords": [
            "sap",
            "hana",
            "database",
            "sql",
            "data-tools",
            "schema",
            "import",
            "export",
            "monitoring",
            "performance",
            "backup",
            "security"
          ],
          "author": {
            "name": "SAP",
            "url": "https://github.com/SAP-samples"
          },
          "version": "1.0.0",
          "license": "Apache-2.0",
          "logoUrl": null,
          "darkLogoUrl": null,
          "homepage": "https://github.com/SAP-samples/hana-developer-cli-tool-example",
          "sourceUrl": "https://github.com/SAP-samples/hana-cli-claude-plugin/tree/abadd0aba32792b6378ed784e9f6d3e5b25dfc2a/",
          "skills": [],
          "mcpServers": [
            {
              "requiresConfiguration": false,
              "name": "hana-cli",
              "transport": "stdio",
              "endpoint": null
            }
          ],
          "components": ["mcp"],
          "componentInspection": "repository",
          "inspectionError": null,
          "installation": "requires_adapter",
          "upstream": {
            "source": {
              "source": "url",
              "url": "https://github.com/SAP-samples/hana-cli-claude-plugin.git",
              "sha": "abadd0aba32792b6378ed784e9f6d3e5b25dfc2a"
            },
            "policy": null
          }
        },
        {
          "id": "anthropic:sap-mdk-server",
          "name": "sap-mdk-server",
          "displayName": "sap-mdk-server",
          "description": "MCP server for SAP Mobile Development Kit (MDK). Build and modify MDK applications with AI assistance — schema lookups, action validation, rule editing, and project scaffolding.",
          "longDescription": "MCP server for SAP Mobile Development Kit (MDK). Build and modify MDK applications with AI assistance — schema lookups, action validation, rule editing, and project scaffolding.",
          "category": "development",
          "keywords": [],
          "author": {
            "name": "SAP SE",
            "email": "ospo@sap.com",
            "url": "https://www.sap.com"
          },
          "version": null,
          "license": null,
          "logoUrl": null,
          "darkLogoUrl": null,
          "homepage": "https://help.sap.com/docs/MDK",
          "sourceUrl": "https://github.com/SAP/mdk-mcp-server.git",
          "skills": null,
          "mcpServers": null,
          "components": null,
          "componentInspection": "not_inspected",
          "inspectionError": "Archive exceeds 32 MiB",
          "installation": "requires_adapter",
          "upstream": {
            "source": {
              "source": "url",
              "url": "https://github.com/SAP/mdk-mcp-server.git",
              "sha": "a6ab81de5c7a16a33845507ac96febd6923b6173"
            },
            "policy": null
          }
        },
        {
          "id": "anthropic:save-to-spotify",
          "name": "save-to-spotify",
          "displayName": "save-to-spotify",
          "description": "Create polished audio episodes with TTS narration, rich timelines, cover images, and save them to Spotify via the save-to-spotify CLI.",
          "longDescription": "Create polished audio episodes with TTS narration, rich timelines, cover images, and save them to Spotify via the save-to-spotify CLI.",
          "category": "productivity",
          "keywords": ["spotify", "audio", "podcast", "tts", "timeline", "save-to-spotify"],
          "author": {
            "name": "Spotify",
            "url": "https://github.com/spotify"
          },
          "version": "0.2.0",
          "license": "Apache-2.0",
          "logoUrl": null,
          "darkLogoUrl": null,
          "homepage": "https://github.com/spotify/save-to-spotify",
          "sourceUrl": "https://github.com/spotify/save-to-spotify/tree/9d05c8cd8c8559552f84e27fe30f46b7693ce69a/plugin",
          "skills": [
            {
              "name": "configure-chapter-skip",
              "sourceUrl": "https://github.com/spotify/save-to-spotify/blob/9d05c8cd8c8559552f84e27fe30f46b7693ce69a/plugin/skills/configure-chapter-skip/SKILL.md"
            },
            {
              "name": "save-to-spotify",
              "sourceUrl": "https://github.com/spotify/save-to-spotify/blob/9d05c8cd8c8559552f84e27fe30f46b7693ce69a/plugin/skills/save-to-spotify/SKILL.md"
            }
          ],
          "mcpServers": [],
          "components": ["skills"],
          "componentInspection": "repository",
          "inspectionError": null,
          "installation": "requires_adapter",
          "upstream": {
            "source": {
              "source": "git-subdir",
              "url": "https://github.com/spotify/save-to-spotify.git",
              "path": "plugin",
              "ref": "main",
              "sha": "9d05c8cd8c8559552f84e27fe30f46b7693ce69a"
            },
            "policy": null
          }
        },
        {
          "id": "anthropic:scandit-sdk",
          "name": "scandit-sdk",
          "displayName": "scandit-sdk",
          "description": "AI agent skills for integrating the Scandit Data Capture SDK — product selection, documentation, and implementation guides for barcode scanning, ID capture, and smart label capture.",
          "longDescription": "AI agent skills for integrating the Scandit Data Capture SDK — product selection, documentation, and implementation guides for barcode scanning, ID capture, and smart label capture.",
          "category": "development",
          "keywords": [
            "scandit",
            "barcode",
            "scanning",
            "barcode-scanning",
            "barcode-capture",
            "sparkscan",
            "matrixscan",
            "matrixscan-ar",
            "matrixscan-count",
            "matrixscan-batch",
            "label-capture",
            "smart-label-capture",
            "data-capture",
            "ios",
            "web",
            "react-native",
            "flutter",
            "capacitor",
            "cordova",
            "dotnet",
            "net",
            "net-android",
            "net-ios",
            "maui",
            "xamarin",
            "sdk",
            "smart-data-capture"
          ],
          "author": {
            "name": "Scandit",
            "url": "https://www.scandit.com/"
          },
          "version": null,
          "license": "Apache-2.0",
          "logoUrl": null,
          "darkLogoUrl": null,
          "homepage": "https://docs.scandit.com",
          "sourceUrl": "https://github.com/Scandit/skills/tree/2f0731a090eb9c23a64b6dcd9559cf113df3313f/",
          "skills": [
            {
              "name": "audit-common-skill-rules",
              "sourceUrl": "https://github.com/Scandit/skills/blob/2f0731a090eb9c23a64b6dcd9559cf113df3313f/internal/audit-common-skill-rules/SKILL.md"
            },
            {
              "name": "skill-auditor",
              "sourceUrl": "https://github.com/Scandit/skills/blob/2f0731a090eb9c23a64b6dcd9559cf113df3313f/internal/skill-auditor/SKILL.md"
            },
            {
              "name": "barcode-capture-android",
              "sourceUrl": "https://github.com/Scandit/skills/blob/2f0731a090eb9c23a64b6dcd9559cf113df3313f/skills/barcode-capture-android/SKILL.md"
            },
            {
              "name": "barcode-capture-capacitor",
              "sourceUrl": "https://github.com/Scandit/skills/blob/2f0731a090eb9c23a64b6dcd9559cf113df3313f/skills/barcode-capture-capacitor/SKILL.md"
            },
            {
              "name": "barcode-capture-cordova",
              "sourceUrl": "https://github.com/Scandit/skills/blob/2f0731a090eb9c23a64b6dcd9559cf113df3313f/skills/barcode-capture-cordova/SKILL.md"
            },
            {
              "name": "barcode-capture-flutter",
              "sourceUrl": "https://github.com/Scandit/skills/blob/2f0731a090eb9c23a64b6dcd9559cf113df3313f/skills/barcode-capture-flutter/SKILL.md"
            },
            {
              "name": "barcode-capture-ios",
              "sourceUrl": "https://github.com/Scandit/skills/blob/2f0731a090eb9c23a64b6dcd9559cf113df3313f/skills/barcode-capture-ios/SKILL.md"
            },
            {
              "name": "barcode-capture-kmp",
              "sourceUrl": "https://github.com/Scandit/skills/blob/2f0731a090eb9c23a64b6dcd9559cf113df3313f/skills/barcode-capture-kmp/SKILL.md"
            },
            {
              "name": "barcode-capture-net-android",
              "sourceUrl": "https://github.com/Scandit/skills/blob/2f0731a090eb9c23a64b6dcd9559cf113df3313f/skills/barcode-capture-net-android/SKILL.md"
            },
            {
              "name": "barcode-capture-net-ios",
              "sourceUrl": "https://github.com/Scandit/skills/blob/2f0731a090eb9c23a64b6dcd9559cf113df3313f/skills/barcode-capture-net-ios/SKILL.md"
            },
            {
              "name": "barcode-capture-net-maui",
              "sourceUrl": "https://github.com/Scandit/skills/blob/2f0731a090eb9c23a64b6dcd9559cf113df3313f/skills/barcode-capture-net-maui/SKILL.md"
            },
            {
              "name": "barcode-capture-rn",
              "sourceUrl": "https://github.com/Scandit/skills/blob/2f0731a090eb9c23a64b6dcd9559cf113df3313f/skills/barcode-capture-rn/SKILL.md"
            },
            {
              "name": "barcode-capture-web",
              "sourceUrl": "https://github.com/Scandit/skills/blob/2f0731a090eb9c23a64b6dcd9559cf113df3313f/skills/barcode-capture-web/SKILL.md"
            },
            {
              "name": "barcode-selection-kmp",
              "sourceUrl": "https://github.com/Scandit/skills/blob/2f0731a090eb9c23a64b6dcd9559cf113df3313f/skills/barcode-selection-kmp/SKILL.md"
            },
            {
              "name": "data-capture-sdk",
              "sourceUrl": "https://github.com/Scandit/skills/blob/2f0731a090eb9c23a64b6dcd9559cf113df3313f/skills/data-capture-sdk/SKILL.md"
            },
            {
              "name": "id-bolt",
              "sourceUrl": "https://github.com/Scandit/skills/blob/2f0731a090eb9c23a64b6dcd9559cf113df3313f/skills/id-bolt/SKILL.md"
            },
            {
              "name": "id-capture-android",
              "sourceUrl": "https://github.com/Scandit/skills/blob/2f0731a090eb9c23a64b6dcd9559cf113df3313f/skills/id-capture-android/SKILL.md"
            },
            {
              "name": "id-capture-capacitor",
              "sourceUrl": "https://github.com/Scandit/skills/blob/2f0731a090eb9c23a64b6dcd9559cf113df3313f/skills/id-capture-capacitor/SKILL.md"
            },
            {
              "name": "id-capture-cordova",
              "sourceUrl": "https://github.com/Scandit/skills/blob/2f0731a090eb9c23a64b6dcd9559cf113df3313f/skills/id-capture-cordova/SKILL.md"
            },
            {
              "name": "id-capture-flutter",
              "sourceUrl": "https://github.com/Scandit/skills/blob/2f0731a090eb9c23a64b6dcd9559cf113df3313f/skills/id-capture-flutter/SKILL.md"
            },
            {
              "name": "id-capture-ios",
              "sourceUrl": "https://github.com/Scandit/skills/blob/2f0731a090eb9c23a64b6dcd9559cf113df3313f/skills/id-capture-ios/SKILL.md"
            },
            {
              "name": "id-capture-kmp",
              "sourceUrl": "https://github.com/Scandit/skills/blob/2f0731a090eb9c23a64b6dcd9559cf113df3313f/skills/id-capture-kmp/SKILL.md"
            },
            {
              "name": "id-capture-net-android",
              "sourceUrl": "https://github.com/Scandit/skills/blob/2f0731a090eb9c23a64b6dcd9559cf113df3313f/skills/id-capture-net-android/SKILL.md"
            },
            {
              "name": "id-capture-net-ios",
              "sourceUrl": "https://github.com/Scandit/skills/blob/2f0731a090eb9c23a64b6dcd9559cf113df3313f/skills/id-capture-net-ios/SKILL.md"
            },
            {
              "name": "id-capture-net-maui",
              "sourceUrl": "https://github.com/Scandit/skills/blob/2f0731a090eb9c23a64b6dcd9559cf113df3313f/skills/id-capture-net-maui/SKILL.md"
            },
            {
              "name": "id-capture-rn",
              "sourceUrl": "https://github.com/Scandit/skills/blob/2f0731a090eb9c23a64b6dcd9559cf113df3313f/skills/id-capture-rn/SKILL.md"
            },
            {
              "name": "id-capture-web",
              "sourceUrl": "https://github.com/Scandit/skills/blob/2f0731a090eb9c23a64b6dcd9559cf113df3313f/skills/id-capture-web/SKILL.md"
            },
            {
              "name": "label-capture-android",
              "sourceUrl": "https://github.com/Scandit/skills/blob/2f0731a090eb9c23a64b6dcd9559cf113df3313f/skills/label-capture-android/SKILL.md"
            },
            {
              "name": "label-capture-capacitor",
              "sourceUrl": "https://github.com/Scandit/skills/blob/2f0731a090eb9c23a64b6dcd9559cf113df3313f/skills/label-capture-capacitor/SKILL.md"
            },
            {
              "name": "label-capture-cordova",
              "sourceUrl": "https://github.com/Scandit/skills/blob/2f0731a090eb9c23a64b6dcd9559cf113df3313f/skills/label-capture-cordova/SKILL.md"
            },
            {
              "name": "label-capture-flutter",
              "sourceUrl": "https://github.com/Scandit/skills/blob/2f0731a090eb9c23a64b6dcd9559cf113df3313f/skills/label-capture-flutter/SKILL.md"
            },
            {
              "name": "label-capture-ios",
              "sourceUrl": "https://github.com/Scandit/skills/blob/2f0731a090eb9c23a64b6dcd9559cf113df3313f/skills/label-capture-ios/SKILL.md"
            },
            {
              "name": "label-capture-kmp",
              "sourceUrl": "https://github.com/Scandit/skills/blob/2f0731a090eb9c23a64b6dcd9559cf113df3313f/skills/label-capture-kmp/SKILL.md"
            },
            {
              "name": "label-capture-net-android",
              "sourceUrl": "https://github.com/Scandit/skills/blob/2f0731a090eb9c23a64b6dcd9559cf113df3313f/skills/label-capture-net-android/SKILL.md"
            },
            {
              "name": "label-capture-net-ios",
              "sourceUrl": "https://github.com/Scandit/skills/blob/2f0731a090eb9c23a64b6dcd9559cf113df3313f/skills/label-capture-net-ios/SKILL.md"
            },
            {
              "name": "label-capture-net-maui",
              "sourceUrl": "https://github.com/Scandit/skills/blob/2f0731a090eb9c23a64b6dcd9559cf113df3313f/skills/label-capture-net-maui/SKILL.md"
            },
            {
              "name": "label-capture-rn",
              "sourceUrl": "https://github.com/Scandit/skills/blob/2f0731a090eb9c23a64b6dcd9559cf113df3313f/skills/label-capture-rn/SKILL.md"
            },
            {
              "name": "label-capture-web",
              "sourceUrl": "https://github.com/Scandit/skills/blob/2f0731a090eb9c23a64b6dcd9559cf113df3313f/skills/label-capture-web/SKILL.md"
            },
            {
              "name": "matrixscan-ar-android",
              "sourceUrl": "https://github.com/Scandit/skills/blob/2f0731a090eb9c23a64b6dcd9559cf113df3313f/skills/matrixscan-ar-android/SKILL.md"
            },
            {
              "name": "matrixscan-ar-annotation-ios",
              "sourceUrl": "https://github.com/Scandit/skills/blob/2f0731a090eb9c23a64b6dcd9559cf113df3313f/skills/matrixscan-ar-annotation-ios/SKILL.md"
            },
            {
              "name": "matrixscan-ar-capacitor",
              "sourceUrl": "https://github.com/Scandit/skills/blob/2f0731a090eb9c23a64b6dcd9559cf113df3313f/skills/matrixscan-ar-capacitor/SKILL.md"
            },
            {
              "name": "matrixscan-ar-cordova",
              "sourceUrl": "https://github.com/Scandit/skills/blob/2f0731a090eb9c23a64b6dcd9559cf113df3313f/skills/matrixscan-ar-cordova/SKILL.md"
            },
            {
              "name": "matrixscan-ar-flutter",
              "sourceUrl": "https://github.com/Scandit/skills/blob/2f0731a090eb9c23a64b6dcd9559cf113df3313f/skills/matrixscan-ar-flutter/SKILL.md"
            },
            {
              "name": "matrixscan-ar-highlight-ios",
              "sourceUrl": "https://github.com/Scandit/skills/blob/2f0731a090eb9c23a64b6dcd9559cf113df3313f/skills/matrixscan-ar-highlight-ios/SKILL.md"
            },
            {
              "name": "matrixscan-ar-ios",
              "sourceUrl": "https://github.com/Scandit/skills/blob/2f0731a090eb9c23a64b6dcd9559cf113df3313f/skills/matrixscan-ar-ios/SKILL.md"
            },
            {
              "name": "matrixscan-ar-kmp",
              "sourceUrl": "https://github.com/Scandit/skills/blob/2f0731a090eb9c23a64b6dcd9559cf113df3313f/skills/matrixscan-ar-kmp/SKILL.md"
            },
            {
              "name": "matrixscan-ar-net-android",
              "sourceUrl": "https://github.com/Scandit/skills/blob/2f0731a090eb9c23a64b6dcd9559cf113df3313f/skills/matrixscan-ar-net-android/SKILL.md"
            },
            {
              "name": "matrixscan-ar-net-ios",
              "sourceUrl": "https://github.com/Scandit/skills/blob/2f0731a090eb9c23a64b6dcd9559cf113df3313f/skills/matrixscan-ar-net-ios/SKILL.md"
            },
            {
              "name": "matrixscan-ar-net-maui",
              "sourceUrl": "https://github.com/Scandit/skills/blob/2f0731a090eb9c23a64b6dcd9559cf113df3313f/skills/matrixscan-ar-net-maui/SKILL.md"
            },
            {
              "name": "matrixscan-ar-rn",
              "sourceUrl": "https://github.com/Scandit/skills/blob/2f0731a090eb9c23a64b6dcd9559cf113df3313f/skills/matrixscan-ar-rn/SKILL.md"
            },
            {
              "name": "matrixscan-ar-web",
              "sourceUrl": "https://github.com/Scandit/skills/blob/2f0731a090eb9c23a64b6dcd9559cf113df3313f/skills/matrixscan-ar-web/SKILL.md"
            },
            {
              "name": "matrixscan-batch-android",
              "sourceUrl": "https://github.com/Scandit/skills/blob/2f0731a090eb9c23a64b6dcd9559cf113df3313f/skills/matrixscan-batch-android/SKILL.md"
            },
            {
              "name": "matrixscan-batch-capacitor",
              "sourceUrl": "https://github.com/Scandit/skills/blob/2f0731a090eb9c23a64b6dcd9559cf113df3313f/skills/matrixscan-batch-capacitor/SKILL.md"
            },
            {
              "name": "matrixscan-batch-cordova",
              "sourceUrl": "https://github.com/Scandit/skills/blob/2f0731a090eb9c23a64b6dcd9559cf113df3313f/skills/matrixscan-batch-cordova/SKILL.md"
            },
            {
              "name": "matrixscan-batch-flutter",
              "sourceUrl": "https://github.com/Scandit/skills/blob/2f0731a090eb9c23a64b6dcd9559cf113df3313f/skills/matrixscan-batch-flutter/SKILL.md"
            },
            {
              "name": "matrixscan-batch-ios",
              "sourceUrl": "https://github.com/Scandit/skills/blob/2f0731a090eb9c23a64b6dcd9559cf113df3313f/skills/matrixscan-batch-ios/SKILL.md"
            },
            {
              "name": "matrixscan-batch-kmp",
              "sourceUrl": "https://github.com/Scandit/skills/blob/2f0731a090eb9c23a64b6dcd9559cf113df3313f/skills/matrixscan-batch-kmp/SKILL.md"
            },
            {
              "name": "matrixscan-batch-net-android",
              "sourceUrl": "https://github.com/Scandit/skills/blob/2f0731a090eb9c23a64b6dcd9559cf113df3313f/skills/matrixscan-batch-net-android/SKILL.md"
            },
            {
              "name": "matrixscan-batch-net-ios",
              "sourceUrl": "https://github.com/Scandit/skills/blob/2f0731a090eb9c23a64b6dcd9559cf113df3313f/skills/matrixscan-batch-net-ios/SKILL.md"
            },
            {
              "name": "matrixscan-batch-net-maui",
              "sourceUrl": "https://github.com/Scandit/skills/blob/2f0731a090eb9c23a64b6dcd9559cf113df3313f/skills/matrixscan-batch-net-maui/SKILL.md"
            },
            {
              "name": "matrixscan-batch-rn",
              "sourceUrl": "https://github.com/Scandit/skills/blob/2f0731a090eb9c23a64b6dcd9559cf113df3313f/skills/matrixscan-batch-rn/SKILL.md"
            },
            {
              "name": "matrixscan-batch-web",
              "sourceUrl": "https://github.com/Scandit/skills/blob/2f0731a090eb9c23a64b6dcd9559cf113df3313f/skills/matrixscan-batch-web/SKILL.md"
            },
            {
              "name": "matrixscan-count-android",
              "sourceUrl": "https://github.com/Scandit/skills/blob/2f0731a090eb9c23a64b6dcd9559cf113df3313f/skills/matrixscan-count-android/SKILL.md"
            },
            {
              "name": "matrixscan-count-capacitor",
              "sourceUrl": "https://github.com/Scandit/skills/blob/2f0731a090eb9c23a64b6dcd9559cf113df3313f/skills/matrixscan-count-capacitor/SKILL.md"
            },
            {
              "name": "matrixscan-count-cordova",
              "sourceUrl": "https://github.com/Scandit/skills/blob/2f0731a090eb9c23a64b6dcd9559cf113df3313f/skills/matrixscan-count-cordova/SKILL.md"
            },
            {
              "name": "matrixscan-count-flutter",
              "sourceUrl": "https://github.com/Scandit/skills/blob/2f0731a090eb9c23a64b6dcd9559cf113df3313f/skills/matrixscan-count-flutter/SKILL.md"
            },
            {
              "name": "matrixscan-count-ios",
              "sourceUrl": "https://github.com/Scandit/skills/blob/2f0731a090eb9c23a64b6dcd9559cf113df3313f/skills/matrixscan-count-ios/SKILL.md"
            },
            {
              "name": "matrixscan-count-kmp",
              "sourceUrl": "https://github.com/Scandit/skills/blob/2f0731a090eb9c23a64b6dcd9559cf113df3313f/skills/matrixscan-count-kmp/SKILL.md"
            },
            {
              "name": "matrixscan-count-net-android",
              "sourceUrl": "https://github.com/Scandit/skills/blob/2f0731a090eb9c23a64b6dcd9559cf113df3313f/skills/matrixscan-count-net-android/SKILL.md"
            },
            {
              "name": "matrixscan-count-net-ios",
              "sourceUrl": "https://github.com/Scandit/skills/blob/2f0731a090eb9c23a64b6dcd9559cf113df3313f/skills/matrixscan-count-net-ios/SKILL.md"
            },
            {
              "name": "matrixscan-count-net-maui",
              "sourceUrl": "https://github.com/Scandit/skills/blob/2f0731a090eb9c23a64b6dcd9559cf113df3313f/skills/matrixscan-count-net-maui/SKILL.md"
            },
            {
              "name": "matrixscan-count-rn",
              "sourceUrl": "https://github.com/Scandit/skills/blob/2f0731a090eb9c23a64b6dcd9559cf113df3313f/skills/matrixscan-count-rn/SKILL.md"
            },
            {
              "name": "matrixscan-find-kmp",
              "sourceUrl": "https://github.com/Scandit/skills/blob/2f0731a090eb9c23a64b6dcd9559cf113df3313f/skills/matrixscan-find-kmp/SKILL.md"
            },
            {
              "name": "matrixscan-pick-ios",
              "sourceUrl": "https://github.com/Scandit/skills/blob/2f0731a090eb9c23a64b6dcd9559cf113df3313f/skills/matrixscan-pick-ios/SKILL.md"
            },
            {
              "name": "matrixscan-pick-kmp",
              "sourceUrl": "https://github.com/Scandit/skills/blob/2f0731a090eb9c23a64b6dcd9559cf113df3313f/skills/matrixscan-pick-kmp/SKILL.md"
            },
            {
              "name": "parser-kmp",
              "sourceUrl": "https://github.com/Scandit/skills/blob/2f0731a090eb9c23a64b6dcd9559cf113df3313f/skills/parser-kmp/SKILL.md"
            },
            {
              "name": "scandit-xamarin-to-net-migration",
              "sourceUrl": "https://github.com/Scandit/skills/blob/2f0731a090eb9c23a64b6dcd9559cf113df3313f/skills/scandit-xamarin-to-net-migration/SKILL.md"
            },
            {
              "name": "sparkscan-android",
              "sourceUrl": "https://github.com/Scandit/skills/blob/2f0731a090eb9c23a64b6dcd9559cf113df3313f/skills/sparkscan-android/SKILL.md"
            },
            {
              "name": "sparkscan-capacitor",
              "sourceUrl": "https://github.com/Scandit/skills/blob/2f0731a090eb9c23a64b6dcd9559cf113df3313f/skills/sparkscan-capacitor/SKILL.md"
            },
            {
              "name": "sparkscan-cordova",
              "sourceUrl": "https://github.com/Scandit/skills/blob/2f0731a090eb9c23a64b6dcd9559cf113df3313f/skills/sparkscan-cordova/SKILL.md"
            },
            {
              "name": "sparkscan-flutter",
              "sourceUrl": "https://github.com/Scandit/skills/blob/2f0731a090eb9c23a64b6dcd9559cf113df3313f/skills/sparkscan-flutter/SKILL.md"
            },
            {
              "name": "sparkscan-ios",
              "sourceUrl": "https://github.com/Scandit/skills/blob/2f0731a090eb9c23a64b6dcd9559cf113df3313f/skills/sparkscan-ios/SKILL.md"
            },
            {
              "name": "sparkscan-kmp",
              "sourceUrl": "https://github.com/Scandit/skills/blob/2f0731a090eb9c23a64b6dcd9559cf113df3313f/skills/sparkscan-kmp/SKILL.md"
            },
            {
              "name": "sparkscan-net-android",
              "sourceUrl": "https://github.com/Scandit/skills/blob/2f0731a090eb9c23a64b6dcd9559cf113df3313f/skills/sparkscan-net-android/SKILL.md"
            },
            {
              "name": "sparkscan-net-ios",
              "sourceUrl": "https://github.com/Scandit/skills/blob/2f0731a090eb9c23a64b6dcd9559cf113df3313f/skills/sparkscan-net-ios/SKILL.md"
            },
            {
              "name": "sparkscan-net-maui",
              "sourceUrl": "https://github.com/Scandit/skills/blob/2f0731a090eb9c23a64b6dcd9559cf113df3313f/skills/sparkscan-net-maui/SKILL.md"
            },
            {
              "name": "sparkscan-rn",
              "sourceUrl": "https://github.com/Scandit/skills/blob/2f0731a090eb9c23a64b6dcd9559cf113df3313f/skills/sparkscan-rn/SKILL.md"
            },
            {
              "name": "sparkscan-web",
              "sourceUrl": "https://github.com/Scandit/skills/blob/2f0731a090eb9c23a64b6dcd9559cf113df3313f/skills/sparkscan-web/SKILL.md"
            }
          ],
          "mcpServers": [],
          "components": ["skills"],
          "componentInspection": "repository",
          "inspectionError": null,
          "installation": "requires_adapter",
          "upstream": {
            "source": {
              "source": "url",
              "url": "https://github.com/Scandit/skills.git",
              "sha": "2f0731a090eb9c23a64b6dcd9559cf113df3313f"
            },
            "policy": null
          }
        },
        {
          "id": "anthropic:security-guidance",
          "name": "security-guidance",
          "displayName": "security-guidance",
          "description": "Security review for Claude-generated code. Pattern-based warnings on edits, LLM-powered diff review on Stop, and an agentic commit reviewer that catches injection, XSS, SSRF, hardcoded secrets, and 25+ other vulnerability classes.",
          "longDescription": "Security review for Claude-generated code. Pattern-based warnings on edits, LLM-powered diff review on Stop, and an agentic commit reviewer that catches injection, XSS, SSRF, hardcoded secrets, and 25+ other vulnerability classes.",
          "category": "security",
          "keywords": [],
          "author": {
            "name": "David Dworken",
            "email": "dworken@anthropic.com"
          },
          "version": "2.0.8",
          "license": null,
          "logoUrl": null,
          "darkLogoUrl": null,
          "homepage": "https://github.com/anthropics/claude-plugins-official/tree/main/plugins/security-guidance",
          "sourceUrl": "https://github.com/anthropics/claude-plugins-official/tree/3b600518a637492d37c9877aeb49c2a55d939c04/plugins/security-guidance",
          "skills": [],
          "mcpServers": [],
          "components": ["hooks"],
          "componentInspection": "repository",
          "inspectionError": null,
          "installation": "requires_adapter",
          "upstream": {
            "source": "./plugins/security-guidance",
            "policy": null
          }
        },
        {
          "id": "anthropic:semgrep",
          "name": "semgrep",
          "displayName": "semgrep",
          "description": "Semgrep catches security vulnerabilities in real-time and guides Claude to write secure code from the start.",
          "longDescription": "Semgrep catches security vulnerabilities in real-time and guides Claude to write secure code from the start.",
          "category": "security",
          "keywords": [],
          "author": null,
          "version": null,
          "license": null,
          "logoUrl": null,
          "darkLogoUrl": null,
          "homepage": "https://github.com/semgrep/mcp-marketplace.git",
          "sourceUrl": "https://github.com/semgrep/mcp-marketplace.git",
          "skills": null,
          "mcpServers": null,
          "components": null,
          "componentInspection": "not_inspected",
          "inspectionError": "Archive exceeds 32 MiB",
          "installation": "requires_adapter",
          "upstream": {
            "source": {
              "source": "git-subdir",
              "url": "https://github.com/semgrep/mcp-marketplace.git",
              "path": "plugin",
              "sha": "55b1f8d97a2571c7f27f15beb3080df3b536bd78"
            },
            "policy": null
          }
        },
        {
          "id": "anthropic:sentry",
          "name": "sentry",
          "displayName": "sentry",
          "description": "Sentry Plugin for Claude Code to help with debugging including MCP and skill capabilities.",
          "longDescription": "Sentry Plugin for Claude Code to help with debugging including MCP and skill capabilities.",
          "category": "monitoring",
          "keywords": ["sentry", "debugging", "monitoring", "error-tracking"],
          "author": {
            "name": "Sentry"
          },
          "version": "1.4.0",
          "license": "MIT",
          "logoUrl": null,
          "darkLogoUrl": null,
          "homepage": "https://github.com/getsentry/plugin-claude",
          "sourceUrl": "https://github.com/getsentry/plugin-claude/tree/73e53541d7af21672e27428c7067f4264b8a3d65/",
          "skills": [
            {
              "name": "sentry-create-alert",
              "sourceUrl": "https://github.com/getsentry/plugin-claude/blob/73e53541d7af21672e27428c7067f4264b8a3d65/skills/sentry-create-alert/SKILL.md"
            },
            {
              "name": "sentry-debug-issue",
              "sourceUrl": "https://github.com/getsentry/plugin-claude/blob/73e53541d7af21672e27428c7067f4264b8a3d65/skills/sentry-debug-issue/SKILL.md"
            },
            {
              "name": "sentry-fix-stack-traces",
              "sourceUrl": "https://github.com/getsentry/plugin-claude/blob/73e53541d7af21672e27428c7067f4264b8a3d65/skills/sentry-fix-stack-traces/SKILL.md"
            },
            {
              "name": "sentry-get-started",
              "sourceUrl": "https://github.com/getsentry/plugin-claude/blob/73e53541d7af21672e27428c7067f4264b8a3d65/skills/sentry-get-started/SKILL.md"
            },
            {
              "name": "sentry-instrument",
              "sourceUrl": "https://github.com/getsentry/plugin-claude/blob/73e53541d7af21672e27428c7067f4264b8a3d65/skills/sentry-instrument/SKILL.md"
            },
            {
              "name": "sentry-otel-exporter-setup",
              "sourceUrl": "https://github.com/getsentry/plugin-claude/blob/73e53541d7af21672e27428c7067f4264b8a3d65/skills/sentry-otel-exporter-setup/SKILL.md"
            },
            {
              "name": "sentry-setup-releases",
              "sourceUrl": "https://github.com/getsentry/plugin-claude/blob/73e53541d7af21672e27428c7067f4264b8a3d65/skills/sentry-setup-releases/SKILL.md"
            },
            {
              "name": "sentry-snapshots-cocoa",
              "sourceUrl": "https://github.com/getsentry/plugin-claude/blob/73e53541d7af21672e27428c7067f4264b8a3d65/skills/sentry-snapshots-cocoa/SKILL.md"
            }
          ],
          "mcpServers": [
            {
              "requiresConfiguration": false,
              "name": "sentry",
              "transport": "http",
              "endpoint": "https://mcp.sentry.dev/mcp?utm_source=plugin"
            }
          ],
          "components": ["skills", "mcp"],
          "componentInspection": "repository",
          "inspectionError": null,
          "installation": "requires_adapter",
          "upstream": {
            "source": {
              "source": "url",
              "url": "https://github.com/getsentry/plugin-claude.git",
              "sha": "73e53541d7af21672e27428c7067f4264b8a3d65"
            },
            "policy": null
          }
        },
        {
          "id": "anthropic:sentry-cli",
          "name": "sentry-cli",
          "displayName": "sentry-cli",
          "description": "Skills for using the Sentry CLI to interact with Sentry from the command line",
          "longDescription": "Skills for using the Sentry CLI to interact with Sentry from the command line",
          "category": "monitoring",
          "keywords": [],
          "author": {
            "name": "Sentry"
          },
          "version": "0.45.0",
          "license": null,
          "logoUrl": null,
          "darkLogoUrl": null,
          "homepage": "https://sentry.io",
          "sourceUrl": "https://github.com/getsentry/cli/tree/2d2fbffb6a697b0f5bdb323de48902312fc156ab/packages/cli/plugins/sentry-cli",
          "skills": [
            {
              "name": "sentry-cli",
              "sourceUrl": "https://github.com/getsentry/cli/blob/2d2fbffb6a697b0f5bdb323de48902312fc156ab/packages/cli/plugins/sentry-cli/skills/sentry-cli/SKILL.md"
            }
          ],
          "mcpServers": [],
          "components": ["skills"],
          "componentInspection": "repository",
          "inspectionError": null,
          "installation": "requires_adapter",
          "upstream": {
            "source": {
              "source": "git-subdir",
              "url": "https://github.com/getsentry/cli.git",
              "path": "packages/cli/plugins/sentry-cli",
              "ref": "main",
              "sha": "2d2fbffb6a697b0f5bdb323de48902312fc156ab"
            },
            "policy": null
          }
        },
        {
          "id": "anthropic:serena",
          "name": "serena",
          "displayName": "serena",
          "description": "Semantic code analysis MCP server providing intelligent code understanding, refactoring suggestions, and codebase navigation through language server protocol integration.",
          "longDescription": "Semantic code analysis MCP server providing intelligent code understanding, refactoring suggestions, and codebase navigation through language server protocol integration.",
          "category": "development",
          "keywords": [],
          "author": {
            "name": "Oraios"
          },
          "version": null,
          "license": null,
          "logoUrl": null,
          "darkLogoUrl": null,
          "homepage": "https://github.com/anthropics/claude-plugins-public/tree/main/external_plugins/serena",
          "sourceUrl": "https://github.com/anthropics/claude-plugins-official/tree/3b600518a637492d37c9877aeb49c2a55d939c04/external_plugins/serena",
          "skills": [],
          "mcpServers": [
            {
              "requiresConfiguration": false,
              "name": "serena",
              "transport": "stdio",
              "endpoint": null
            }
          ],
          "components": ["mcp"],
          "componentInspection": "repository",
          "inspectionError": null,
          "installation": "requires_adapter",
          "upstream": {
            "source": "./external_plugins/serena",
            "policy": null
          }
        },
        {
          "id": "anthropic:servicenow-sdk",
          "name": "servicenow-sdk",
          "displayName": "servicenow-sdk",
          "description": "Create, edit, and deploy ServiceNow applications with the Fluent SDK effortlessly through Claude AI",
          "longDescription": "Create, edit, and deploy ServiceNow applications with the Fluent SDK effortlessly through Claude AI",
          "category": "development",
          "keywords": ["servicenow", "fluent", "now-sdk", "platform"],
          "author": {
            "name": "ServiceNow",
            "url": "https://www.servicenow.com"
          },
          "version": "1.2.0",
          "license": null,
          "logoUrl": null,
          "darkLogoUrl": null,
          "homepage": "https://servicenow.github.io/sdk/",
          "sourceUrl": "https://github.com/ServiceNow/sdk/tree/f3e0379242b29e0039e1625d637aa1c246acbe12/providers/claude/plugin",
          "skills": [
            {
              "name": "now-sdk",
              "sourceUrl": "https://github.com/ServiceNow/sdk/blob/f3e0379242b29e0039e1625d637aa1c246acbe12/providers/claude/plugin/skills/now-sdk/SKILL.md"
            }
          ],
          "mcpServers": [],
          "components": ["skills"],
          "componentInspection": "repository",
          "inspectionError": null,
          "installation": "requires_adapter",
          "upstream": {
            "source": {
              "source": "git-subdir",
              "url": "https://github.com/ServiceNow/sdk.git",
              "path": "providers/claude/plugin",
              "ref": "master",
              "sha": "f3e0379242b29e0039e1625d637aa1c246acbe12"
            },
            "policy": null
          }
        },
        {
          "id": "anthropic:session-report",
          "name": "session-report",
          "displayName": "session-report",
          "description": "Generate an explorable HTML report of Claude Code session usage — tokens, cache efficiency, subagents, skills, and the most expensive prompts — from local ~/.claude/projects transcripts.",
          "longDescription": "Generate an explorable HTML report of Claude Code session usage — tokens, cache efficiency, subagents, skills, and the most expensive prompts — from local ~/.claude/projects transcripts.",
          "category": "productivity",
          "keywords": [],
          "author": {
            "name": "Anthropic",
            "email": "support@anthropic.com"
          },
          "version": null,
          "license": null,
          "logoUrl": null,
          "darkLogoUrl": null,
          "homepage": "https://github.com/anthropics/claude-plugins-official/tree/main/plugins/session-report",
          "sourceUrl": "https://github.com/anthropics/claude-plugins-official/tree/3b600518a637492d37c9877aeb49c2a55d939c04/plugins/session-report",
          "skills": [
            {
              "name": "session-report",
              "sourceUrl": "https://github.com/anthropics/claude-plugins-official/blob/3b600518a637492d37c9877aeb49c2a55d939c04/plugins/session-report/skills/session-report/SKILL.md"
            }
          ],
          "mcpServers": [],
          "components": ["skills"],
          "componentInspection": "repository",
          "inspectionError": null,
          "installation": "requires_adapter",
          "upstream": {
            "source": "./plugins/session-report",
            "policy": null
          }
        },
        {
          "id": "anthropic:shippo",
          "name": "shippo",
          "displayName": "shippo",
          "description": "Shippo connects you to USPS, UPS, FedEx, DHL, and 40+ carriers, so you can handle a shipment end to end right inside Claude. Compare live rates and pick the cheapest or best option, buy and print labels (domestic and international, with customs declarations), validate and standardize addresses, and track packages across carriers. Just ask in plain language: rate-shop a parcel, buy the right label, check a delivery status, or confirm an address before you ship. Whether you run a store or just need to send a package, Shippo turns a pile of carrier accounts into one simple conversation.",
          "longDescription": "Shippo connects you to USPS, UPS, FedEx, DHL, and 40+ carriers, so you can handle a shipment end to end right inside Claude. Compare live rates and pick the cheapest or best option, buy and print labels (domestic and international, with customs declarations), validate and standardize addresses, and track packages across carriers. Just ask in plain language: rate-shop a parcel, buy the right label, check a delivery status, or confirm an address before you ship. Whether you run a store or just need to send a package, Shippo turns a pile of carrier accounts into one simple conversation.",
          "category": "productivity",
          "keywords": [
            "shipping",
            "labels",
            "tracking",
            "rates",
            "shippo",
            "logistics",
            "customs",
            "batch",
            "address-validation"
          ],
          "author": {
            "name": "Shippo",
            "url": "https://goshippo.com"
          },
          "version": "1.5.4",
          "license": "MIT",
          "logoUrl": null,
          "darkLogoUrl": null,
          "homepage": "https://docs.goshippo.com",
          "sourceUrl": "https://github.com/goshippo/ai/tree/15cbb6364fbcfd465a134f5972da9179436d0787/providers/claude/plugin",
          "skills": [
            {
              "name": "address-validation",
              "sourceUrl": "https://github.com/goshippo/ai/blob/15cbb6364fbcfd465a134f5972da9179436d0787/providers/claude/plugin/skills/address-validation/SKILL.md"
            },
            {
              "name": "batch-shipping",
              "sourceUrl": "https://github.com/goshippo/ai/blob/15cbb6364fbcfd465a134f5972da9179436d0787/providers/claude/plugin/skills/batch-shipping/SKILL.md"
            },
            {
              "name": "label-purchase",
              "sourceUrl": "https://github.com/goshippo/ai/blob/15cbb6364fbcfd465a134f5972da9179436d0787/providers/claude/plugin/skills/label-purchase/SKILL.md"
            },
            {
              "name": "rate-shopping",
              "sourceUrl": "https://github.com/goshippo/ai/blob/15cbb6364fbcfd465a134f5972da9179436d0787/providers/claude/plugin/skills/rate-shopping/SKILL.md"
            },
            {
              "name": "shipping-analysis",
              "sourceUrl": "https://github.com/goshippo/ai/blob/15cbb6364fbcfd465a134f5972da9179436d0787/providers/claude/plugin/skills/shipping-analysis/SKILL.md"
            },
            {
              "name": "shippo-best-practices",
              "sourceUrl": "https://github.com/goshippo/ai/blob/15cbb6364fbcfd465a134f5972da9179436d0787/providers/claude/plugin/skills/shippo-best-practices/SKILL.md"
            },
            {
              "name": "shippo-support-ticket",
              "sourceUrl": "https://github.com/goshippo/ai/blob/15cbb6364fbcfd465a134f5972da9179436d0787/providers/claude/plugin/skills/shippo-support-ticket/SKILL.md"
            },
            {
              "name": "tracking",
              "sourceUrl": "https://github.com/goshippo/ai/blob/15cbb6364fbcfd465a134f5972da9179436d0787/providers/claude/plugin/skills/tracking/SKILL.md"
            },
            {
              "name": "upgrade-shippo",
              "sourceUrl": "https://github.com/goshippo/ai/blob/15cbb6364fbcfd465a134f5972da9179436d0787/providers/claude/plugin/skills/upgrade-shippo/SKILL.md"
            }
          ],
          "mcpServers": [
            {
              "requiresConfiguration": false,
              "name": "shippo-mcp",
              "transport": "http",
              "endpoint": "https://mcp.shippo.com"
            }
          ],
          "components": ["skills", "mcp"],
          "componentInspection": "repository",
          "inspectionError": null,
          "installation": "requires_adapter",
          "upstream": {
            "source": {
              "source": "git-subdir",
              "url": "https://github.com/goshippo/ai.git",
              "path": "providers/claude/plugin",
              "ref": "main",
              "sha": "15cbb6364fbcfd465a134f5972da9179436d0787"
            },
            "policy": null
          }
        },
        {
          "id": "anthropic:shopify-ai-toolkit",
          "name": "shopify-ai-toolkit",
          "displayName": "shopify-plugin",
          "description": "Shopify developer tools for Claude Code — search Shopify docs, generate and validate GraphQL, Liquid, and UI extension code. Skill scripts send usage telemetry (queries, code, model/client identifiers) to shopify.dev by default; set OPT_OUT_INSTRUMENTATION=true, or create an empty file at ~/.config/shopify-ai-toolkit/opt-out, to disable.",
          "longDescription": "Shopify developer tools for Claude Code — search Shopify docs, generate and validate GraphQL, Liquid, and UI extension code. Skill scripts send usage telemetry (queries, code, model/client identifiers) to shopify.dev by default; set OPT_OUT_INSTRUMENTATION=true, or create an empty file at ~/.config/shopify-ai-toolkit/opt-out, to disable.",
          "category": "development",
          "keywords": ["shopify", "mcp", "graphql", "liquid", "storefront", "admin-api"],
          "author": {
            "name": "Shopify"
          },
          "version": "1.8.0",
          "license": "MIT",
          "logoUrl": null,
          "darkLogoUrl": null,
          "homepage": "https://shopify.dev",
          "sourceUrl": "https://github.com/Shopify/Shopify-AI-Toolkit/tree/2619755e4f4e908fb205e889bac769de1767d40f/",
          "skills": [
            {
              "name": "shopify-admin",
              "sourceUrl": "https://github.com/Shopify/Shopify-AI-Toolkit/blob/2619755e4f4e908fb205e889bac769de1767d40f/skills/shopify-admin/SKILL.md"
            },
            {
              "name": "shopify-app-pricing",
              "sourceUrl": "https://github.com/Shopify/Shopify-AI-Toolkit/blob/2619755e4f4e908fb205e889bac769de1767d40f/skills/shopify-app-pricing/SKILL.md"
            },
            {
              "name": "shopify-app-store-review",
              "sourceUrl": "https://github.com/Shopify/Shopify-AI-Toolkit/blob/2619755e4f4e908fb205e889bac769de1767d40f/skills/shopify-app-store-review/SKILL.md"
            },
            {
              "name": "shopify-custom-data",
              "sourceUrl": "https://github.com/Shopify/Shopify-AI-Toolkit/blob/2619755e4f4e908fb205e889bac769de1767d40f/skills/shopify-custom-data/SKILL.md"
            },
            {
              "name": "shopify-customer",
              "sourceUrl": "https://github.com/Shopify/Shopify-AI-Toolkit/blob/2619755e4f4e908fb205e889bac769de1767d40f/skills/shopify-customer/SKILL.md"
            },
            {
              "name": "shopify-dev",
              "sourceUrl": "https://github.com/Shopify/Shopify-AI-Toolkit/blob/2619755e4f4e908fb205e889bac769de1767d40f/skills/shopify-dev/SKILL.md"
            },
            {
              "name": "shopify-functions",
              "sourceUrl": "https://github.com/Shopify/Shopify-AI-Toolkit/blob/2619755e4f4e908fb205e889bac769de1767d40f/skills/shopify-functions/SKILL.md"
            },
            {
              "name": "shopify-hydrogen",
              "sourceUrl": "https://github.com/Shopify/Shopify-AI-Toolkit/blob/2619755e4f4e908fb205e889bac769de1767d40f/skills/shopify-hydrogen/SKILL.md"
            },
            {
              "name": "shopify-liquid",
              "sourceUrl": "https://github.com/Shopify/Shopify-AI-Toolkit/blob/2619755e4f4e908fb205e889bac769de1767d40f/skills/shopify-liquid/SKILL.md"
            },
            {
              "name": "shopify-onboarding-dev",
              "sourceUrl": "https://github.com/Shopify/Shopify-AI-Toolkit/blob/2619755e4f4e908fb205e889bac769de1767d40f/skills/shopify-onboarding-dev/SKILL.md"
            },
            {
              "name": "shopify-onboarding-merchant",
              "sourceUrl": "https://github.com/Shopify/Shopify-AI-Toolkit/blob/2619755e4f4e908fb205e889bac769de1767d40f/skills/shopify-onboarding-merchant/SKILL.md"
            },
            {
              "name": "shopify-partner",
              "sourceUrl": "https://github.com/Shopify/Shopify-AI-Toolkit/blob/2619755e4f4e908fb205e889bac769de1767d40f/skills/shopify-partner/SKILL.md"
            },
            {
              "name": "shopify-payments-apps",
              "sourceUrl": "https://github.com/Shopify/Shopify-AI-Toolkit/blob/2619755e4f4e908fb205e889bac769de1767d40f/skills/shopify-payments-apps/SKILL.md"
            },
            {
              "name": "shopify-polaris-admin-extensions",
              "sourceUrl": "https://github.com/Shopify/Shopify-AI-Toolkit/blob/2619755e4f4e908fb205e889bac769de1767d40f/skills/shopify-polaris-admin-extensions/SKILL.md"
            },
            {
              "name": "shopify-polaris-app-home",
              "sourceUrl": "https://github.com/Shopify/Shopify-AI-Toolkit/blob/2619755e4f4e908fb205e889bac769de1767d40f/skills/shopify-polaris-app-home/SKILL.md"
            },
            {
              "name": "shopify-polaris-checkout-extensions",
              "sourceUrl": "https://github.com/Shopify/Shopify-AI-Toolkit/blob/2619755e4f4e908fb205e889bac769de1767d40f/skills/shopify-polaris-checkout-extensions/SKILL.md"
            },
            {
              "name": "shopify-polaris-customer-account-extensions",
              "sourceUrl": "https://github.com/Shopify/Shopify-AI-Toolkit/blob/2619755e4f4e908fb205e889bac769de1767d40f/skills/shopify-polaris-customer-account-extensions/SKILL.md"
            },
            {
              "name": "shopify-pos-ui",
              "sourceUrl": "https://github.com/Shopify/Shopify-AI-Toolkit/blob/2619755e4f4e908fb205e889bac769de1767d40f/skills/shopify-pos-ui/SKILL.md"
            },
            {
              "name": "shopify-shopifyql",
              "sourceUrl": "https://github.com/Shopify/Shopify-AI-Toolkit/blob/2619755e4f4e908fb205e889bac769de1767d40f/skills/shopify-shopifyql/SKILL.md"
            },
            {
              "name": "shopify-storefront-graphql",
              "sourceUrl": "https://github.com/Shopify/Shopify-AI-Toolkit/blob/2619755e4f4e908fb205e889bac769de1767d40f/skills/shopify-storefront-graphql/SKILL.md"
            },
            {
              "name": "shopify-use-shopify-cli",
              "sourceUrl": "https://github.com/Shopify/Shopify-AI-Toolkit/blob/2619755e4f4e908fb205e889bac769de1767d40f/skills/shopify-use-shopify-cli/SKILL.md"
            },
            {
              "name": "ucp",
              "sourceUrl": "https://github.com/Shopify/Shopify-AI-Toolkit/blob/2619755e4f4e908fb205e889bac769de1767d40f/skills/ucp/SKILL.md"
            }
          ],
          "mcpServers": [],
          "components": ["skills", "mcp", "hooks"],
          "componentInspection": "repository",
          "inspectionError": null,
          "installation": "requires_adapter",
          "upstream": {
            "source": {
              "source": "url",
              "url": "https://github.com/Shopify/Shopify-AI-Toolkit.git",
              "sha": "2619755e4f4e908fb205e889bac769de1767d40f"
            },
            "policy": null
          }
        },
        {
          "id": "anthropic:skill-creator",
          "name": "skill-creator",
          "displayName": "skill-creator",
          "description": "Create new skills, improve existing skills, and measure skill performance. Use when users want to create a skill from scratch, update or optimize an existing skill, run evals to test a skill, or benchmark skill performance with variance analysis.",
          "longDescription": "Create new skills, improve existing skills, and measure skill performance. Use when users want to create a skill from scratch, update or optimize an existing skill, run evals to test a skill, or benchmark skill performance with variance analysis.",
          "category": "development",
          "keywords": [],
          "author": {
            "name": "Anthropic",
            "email": "support@anthropic.com"
          },
          "version": null,
          "license": null,
          "logoUrl": null,
          "darkLogoUrl": null,
          "homepage": "https://github.com/anthropics/claude-plugins-official/tree/main/plugins/skill-creator",
          "sourceUrl": "https://github.com/anthropics/claude-plugins-official/tree/3b600518a637492d37c9877aeb49c2a55d939c04/plugins/skill-creator",
          "skills": [
            {
              "name": "skill-creator",
              "sourceUrl": "https://github.com/anthropics/claude-plugins-official/blob/3b600518a637492d37c9877aeb49c2a55d939c04/plugins/skill-creator/skills/skill-creator/SKILL.md"
            }
          ],
          "mcpServers": [],
          "components": ["skills"],
          "componentInspection": "repository",
          "inspectionError": null,
          "installation": "requires_adapter",
          "upstream": {
            "source": "./plugins/skill-creator",
            "policy": null
          }
        },
        {
          "id": "anthropic:slack",
          "name": "slack",
          "displayName": "slack",
          "description": "Slack AI tools for users and developers: interact with your workspace via the Slack MCP server and use skills to develop Slack apps.",
          "longDescription": "Slack AI tools for users and developers: interact with your workspace via the Slack MCP server and use skills to develop Slack apps.",
          "category": "productivity",
          "keywords": [],
          "author": {
            "name": "Slack",
            "url": "https://slack.com"
          },
          "version": "1.3.0",
          "license": "MIT",
          "logoUrl": null,
          "darkLogoUrl": null,
          "homepage": "https://docs.slack.dev/ai/slack-skills-plugin",
          "sourceUrl": "https://github.com/slackapi/slack-mcp-plugin/tree/3d847b94e05a03bf370c3949307cd8d85ca9e56d/",
          "skills": [
            {
              "name": "block-kit",
              "sourceUrl": "https://github.com/slackapi/slack-mcp-plugin/blob/3d847b94e05a03bf370c3949307cd8d85ca9e56d/skills/block-kit/SKILL.md"
            },
            {
              "name": "create-slack-app",
              "sourceUrl": "https://github.com/slackapi/slack-mcp-plugin/blob/3d847b94e05a03bf370c3949307cd8d85ca9e56d/skills/create-slack-app/SKILL.md"
            },
            {
              "name": "slack-api",
              "sourceUrl": "https://github.com/slackapi/slack-mcp-plugin/blob/3d847b94e05a03bf370c3949307cd8d85ca9e56d/skills/slack-api/SKILL.md"
            },
            {
              "name": "slack-cli",
              "sourceUrl": "https://github.com/slackapi/slack-mcp-plugin/blob/3d847b94e05a03bf370c3949307cd8d85ca9e56d/skills/slack-cli/SKILL.md"
            },
            {
              "name": "slack-docs",
              "sourceUrl": "https://github.com/slackapi/slack-mcp-plugin/blob/3d847b94e05a03bf370c3949307cd8d85ca9e56d/skills/slack-docs/SKILL.md"
            },
            {
              "name": "slack-messaging",
              "sourceUrl": "https://github.com/slackapi/slack-mcp-plugin/blob/3d847b94e05a03bf370c3949307cd8d85ca9e56d/skills/slack-messaging/SKILL.md"
            },
            {
              "name": "slack-search",
              "sourceUrl": "https://github.com/slackapi/slack-mcp-plugin/blob/3d847b94e05a03bf370c3949307cd8d85ca9e56d/skills/slack-search/SKILL.md"
            },
            {
              "name": "test-slack-app",
              "sourceUrl": "https://github.com/slackapi/slack-mcp-plugin/blob/3d847b94e05a03bf370c3949307cd8d85ca9e56d/skills/test-slack-app/SKILL.md"
            }
          ],
          "mcpServers": [
            {
              "requiresConfiguration": false,
              "name": "slack",
              "transport": "http",
              "endpoint": "https://mcp.slack.com/mcp"
            }
          ],
          "components": ["skills", "mcp", "commands"],
          "componentInspection": "repository",
          "inspectionError": null,
          "installation": "requires_adapter",
          "upstream": {
            "source": {
              "source": "url",
              "url": "https://github.com/slackapi/slack-mcp-plugin.git",
              "sha": "3d847b94e05a03bf370c3949307cd8d85ca9e56d"
            },
            "policy": null
          }
        },
        {
          "id": "anthropic:snowflake-cortex-code",
          "name": "snowflake-cortex-code",
          "displayName": "snowflake-cortex-code",
          "description": "Automatically route Snowflake prompts from Claude Code to Cortex Code for execution.",
          "longDescription": "Automatically route Snowflake prompts from Claude Code to Cortex Code for execution.",
          "category": "development",
          "keywords": ["snowflake", "cortex-code", "auto-routing", "sql", "data"],
          "author": {
            "name": "Snowflake"
          },
          "version": "3.3.1",
          "license": "Apache-2.0",
          "logoUrl": null,
          "darkLogoUrl": null,
          "homepage": "https://docs.snowflake.com/en/user-guide/cortex-code/cortex-code",
          "sourceUrl": "https://github.com/Snowflake-Labs/snowflake-ai-kit/tree/0c54225ea50b44c2ae07e1f378bf401e88b33c33/plugins/cortex-code",
          "skills": [
            {
              "name": "cortex-router",
              "sourceUrl": "https://github.com/Snowflake-Labs/snowflake-ai-kit/blob/0c54225ea50b44c2ae07e1f378bf401e88b33c33/plugins/cortex-code/skills/cortex-router/SKILL.md"
            },
            {
              "name": "cortex-run",
              "sourceUrl": "https://github.com/Snowflake-Labs/snowflake-ai-kit/blob/0c54225ea50b44c2ae07e1f378bf401e88b33c33/plugins/cortex-code/skills/cortex-run/SKILL.md"
            },
            {
              "name": "cortex-setup",
              "sourceUrl": "https://github.com/Snowflake-Labs/snowflake-ai-kit/blob/0c54225ea50b44c2ae07e1f378bf401e88b33c33/plugins/cortex-code/skills/cortex-setup/SKILL.md"
            }
          ],
          "mcpServers": [],
          "components": ["skills", "hooks"],
          "componentInspection": "repository",
          "inspectionError": null,
          "installation": "requires_adapter",
          "upstream": {
            "source": {
              "source": "git-subdir",
              "url": "https://github.com/Snowflake-Labs/snowflake-ai-kit.git",
              "path": "plugins/cortex-code",
              "ref": "main",
              "sha": "0c54225ea50b44c2ae07e1f378bf401e88b33c33"
            },
            "policy": null
          }
        },
        {
          "id": "anthropic:sonarqube",
          "name": "sonarqube",
          "displayName": "sonarqube",
          "description": "SonarQube is the AI code quality and security verification platform used by millions of developers to catch bugs, vulnerabilities, and leaked secrets. This plugin enforces those standards in the agent coding loop: 7,500+ distinct issue types, secrets scanning, agentic analysis, and quality gates across 40+ languages.",
          "longDescription": "SonarQube is the AI code quality and security verification platform used by millions of developers to catch bugs, vulnerabilities, and leaked secrets. This plugin enforces those standards in the agent coding loop: 7,500+ distinct issue types, secrets scanning, agentic analysis, and quality gates across 40+ languages.",
          "category": "security",
          "keywords": ["sonarqube", "code-quality", "static-analysis", "security", "secrets"],
          "author": {
            "name": "Sonar",
            "url": "https://www.sonarsource.com/"
          },
          "version": "2.5.0",
          "license": "SSAL-1.0",
          "logoUrl": null,
          "darkLogoUrl": null,
          "homepage": "https://www.sonarsource.com",
          "sourceUrl": "https://github.com/SonarSource/sonarqube-agent-plugins/tree/e596969a083cf27bfe439ee2e9459f7ef4124a70/",
          "skills": [
            {
              "name": "sonar-analyze",
              "sourceUrl": "https://github.com/SonarSource/sonarqube-agent-plugins/blob/e596969a083cf27bfe439ee2e9459f7ef4124a70/skills/sonar-analyze/SKILL.md"
            },
            {
              "name": "sonar-coverage",
              "sourceUrl": "https://github.com/SonarSource/sonarqube-agent-plugins/blob/e596969a083cf27bfe439ee2e9459f7ef4124a70/skills/sonar-coverage/SKILL.md"
            },
            {
              "name": "sonar-dependency-risks",
              "sourceUrl": "https://github.com/SonarSource/sonarqube-agent-plugins/blob/e596969a083cf27bfe439ee2e9459f7ef4124a70/skills/sonar-dependency-risks/SKILL.md"
            },
            {
              "name": "sonar-duplication",
              "sourceUrl": "https://github.com/SonarSource/sonarqube-agent-plugins/blob/e596969a083cf27bfe439ee2e9459f7ef4124a70/skills/sonar-duplication/SKILL.md"
            },
            {
              "name": "sonar-fix-issue",
              "sourceUrl": "https://github.com/SonarSource/sonarqube-agent-plugins/blob/e596969a083cf27bfe439ee2e9459f7ef4124a70/skills/sonar-fix-issue/SKILL.md"
            },
            {
              "name": "sonar-integrate",
              "sourceUrl": "https://github.com/SonarSource/sonarqube-agent-plugins/blob/e596969a083cf27bfe439ee2e9459f7ef4124a70/skills/sonar-integrate/SKILL.md"
            },
            {
              "name": "sonar-list-issues",
              "sourceUrl": "https://github.com/SonarSource/sonarqube-agent-plugins/blob/e596969a083cf27bfe439ee2e9459f7ef4124a70/skills/sonar-list-issues/SKILL.md"
            },
            {
              "name": "sonar-list-projects",
              "sourceUrl": "https://github.com/SonarSource/sonarqube-agent-plugins/blob/e596969a083cf27bfe439ee2e9459f7ef4124a70/skills/sonar-list-projects/SKILL.md"
            },
            {
              "name": "sonar-quality-gate",
              "sourceUrl": "https://github.com/SonarSource/sonarqube-agent-plugins/blob/e596969a083cf27bfe439ee2e9459f7ef4124a70/skills/sonar-quality-gate/SKILL.md"
            }
          ],
          "mcpServers": [],
          "components": ["skills", "agents"],
          "componentInspection": "repository",
          "inspectionError": null,
          "installation": "requires_adapter",
          "upstream": {
            "source": {
              "source": "url",
              "url": "https://github.com/SonarSource/sonarqube-agent-plugins.git",
              "sha": "e596969a083cf27bfe439ee2e9459f7ef4124a70"
            },
            "policy": null
          }
        },
        {
          "id": "anthropic:sonatype-guide",
          "name": "sonatype-guide",
          "displayName": "sonatype-guide",
          "description": "Sonatype Guide MCP server for software supply chain intelligence and dependency security analysis. Scan dependencies for vulnerabilities, get version recommendations, and check component quality metrics.",
          "longDescription": "Sonatype Guide MCP server for software supply chain intelligence and dependency security analysis. Scan dependencies for vulnerabilities, get version recommendations, and check component quality metrics.",
          "category": "security",
          "keywords": [],
          "author": {
            "name": "Sonatype"
          },
          "version": "1.0.0",
          "license": null,
          "logoUrl": null,
          "darkLogoUrl": null,
          "homepage": "https://guide.sonatype.com",
          "sourceUrl": "https://github.com/sonatype/sonatype-guide-claude-plugin/tree/1dae73980f591d3196f5532ac72186513563d028/",
          "skills": [
            {
              "name": "sonatype-guide",
              "sourceUrl": "https://github.com/sonatype/sonatype-guide-claude-plugin/blob/1dae73980f591d3196f5532ac72186513563d028/skills/sonatype-guide/SKILL.md"
            }
          ],
          "mcpServers": [
            {
              "requiresConfiguration": true,
              "name": "sonatype-guide",
              "transport": "http",
              "endpoint": "https://mcp.guide.sonatype.com/mcp"
            }
          ],
          "components": ["skills", "mcp"],
          "componentInspection": "repository",
          "inspectionError": null,
          "installation": "requires_adapter",
          "upstream": {
            "source": {
              "source": "url",
              "url": "https://github.com/sonatype/sonatype-guide-claude-plugin.git",
              "sha": "1dae73980f591d3196f5532ac72186513563d028"
            },
            "policy": null
          }
        },
        {
          "id": "anthropic:sourcegraph",
          "name": "sourcegraph",
          "displayName": "sourcegraph",
          "description": "Use Sourcegraph MCP from Claude Code for code search, navigation, history, and Deep Search.",
          "longDescription": "Use Sourcegraph MCP from Claude Code for code search, navigation, history, and Deep Search.",
          "category": "development",
          "keywords": [],
          "author": {
            "name": "Sourcegraph Community"
          },
          "version": "0.1.0",
          "license": "MIT",
          "logoUrl": null,
          "darkLogoUrl": null,
          "homepage": "https://github.com/sourcegraph-community/sourcegraph-claudecode-plugin",
          "sourceUrl": "https://github.com/sourcegraph-community/sourcegraph-claudecode-plugin/tree/332ee0ca9a409ccd791abee43c7abf2606469017/",
          "skills": [
            {
              "name": "searching-sourcegraph",
              "sourceUrl": "https://github.com/sourcegraph-community/sourcegraph-claudecode-plugin/blob/332ee0ca9a409ccd791abee43c7abf2606469017/skills/searching-sourcegraph/SKILL.md"
            }
          ],
          "mcpServers": [
            {
              "requiresConfiguration": true,
              "name": "sourcegraph",
              "transport": "http",
              "endpoint": "${SOURCEGRAPH_ENDPOINT}/.api/mcp"
            }
          ],
          "components": ["skills", "mcp"],
          "componentInspection": "repository",
          "inspectionError": null,
          "installation": "requires_adapter",
          "upstream": {
            "source": {
              "source": "url",
              "url": "https://github.com/sourcegraph-community/sourcegraph-claudecode-plugin.git",
              "sha": "332ee0ca9a409ccd791abee43c7abf2606469017"
            },
            "policy": null
          }
        },
        {
          "id": "anthropic:spanner",
          "name": "spanner",
          "displayName": "spanner",
          "description": "Connect and interact with Spanner data using natural language.",
          "longDescription": "Connect and interact with Spanner data using natural language.",
          "category": "database",
          "keywords": [],
          "author": {
            "name": "Google LLC",
            "email": "data-cloud-ai-integrations@google.com"
          },
          "version": "0.3.5",
          "license": "Apache-2.0",
          "logoUrl": null,
          "darkLogoUrl": null,
          "homepage": "https://cloud.google.com/spanner",
          "sourceUrl": "https://github.com/gemini-cli-extensions/spanner/tree/285083230eb7747f7cc512a75c22e05f8cc87eeb/",
          "skills": [],
          "mcpServers": [
            {
              "requiresConfiguration": false,
              "name": "spanner",
              "transport": "stdio",
              "endpoint": null
            }
          ],
          "components": ["mcp"],
          "componentInspection": "repository",
          "inspectionError": null,
          "installation": "requires_adapter",
          "upstream": {
            "source": {
              "source": "url",
              "url": "https://github.com/gemini-cli-extensions/spanner.git",
              "sha": "285083230eb7747f7cc512a75c22e05f8cc87eeb"
            },
            "policy": null
          }
        },
        {
          "id": "anthropic:spotify-ads-api",
          "name": "spotify-ads-api",
          "displayName": "spotify-ads-api",
          "description": "Manage Spotify ad campaigns, audiences, measurement, account access, assets, and reporting with natural language and OAuth.",
          "longDescription": "Manage Spotify ad campaigns, audiences, measurement, account access, assets, and reporting with natural language and OAuth.",
          "category": "productivity",
          "keywords": ["spotify", "ads", "api", "campaigns", "advertising", "oauth", "reporting"],
          "author": {
            "name": "Alex Murphy"
          },
          "version": "1.8.0",
          "license": "Apache-2.0",
          "logoUrl": null,
          "darkLogoUrl": null,
          "homepage": "https://github.com/spotify/ads-agentic-tools",
          "sourceUrl": "https://github.com/spotify/ads-claude-plugin/tree/40df1de363c3d614f5f9274aa29535b301fff885/",
          "skills": [
            {
              "name": "account-admin",
              "sourceUrl": "https://github.com/spotify/ads-claude-plugin/blob/40df1de363c3d614f5f9274aa29535b301fff885/skills/account-admin/SKILL.md"
            },
            {
              "name": "ads",
              "sourceUrl": "https://github.com/spotify/ads-claude-plugin/blob/40df1de363c3d614f5f9274aa29535b301fff885/skills/ads/SKILL.md"
            },
            {
              "name": "api-reference",
              "sourceUrl": "https://github.com/spotify/ads-claude-plugin/blob/40df1de363c3d614f5f9274aa29535b301fff885/skills/api-reference/SKILL.md"
            },
            {
              "name": "assets",
              "sourceUrl": "https://github.com/spotify/ads-claude-plugin/blob/40df1de363c3d614f5f9274aa29535b301fff885/skills/assets/SKILL.md"
            },
            {
              "name": "audiences",
              "sourceUrl": "https://github.com/spotify/ads-claude-plugin/blob/40df1de363c3d614f5f9274aa29535b301fff885/skills/audiences/SKILL.md"
            },
            {
              "name": "build-campaign",
              "sourceUrl": "https://github.com/spotify/ads-claude-plugin/blob/40df1de363c3d614f5f9274aa29535b301fff885/skills/build-campaign/SKILL.md"
            },
            {
              "name": "bulk",
              "sourceUrl": "https://github.com/spotify/ads-claude-plugin/blob/40df1de363c3d614f5f9274aa29535b301fff885/skills/bulk/SKILL.md"
            },
            {
              "name": "campaign-strategy",
              "sourceUrl": "https://github.com/spotify/ads-claude-plugin/blob/40df1de363c3d614f5f9274aa29535b301fff885/skills/campaign-strategy/SKILL.md"
            },
            {
              "name": "campaigns",
              "sourceUrl": "https://github.com/spotify/ads-claude-plugin/blob/40df1de363c3d614f5f9274aa29535b301fff885/skills/campaigns/SKILL.md"
            },
            {
              "name": "change-history",
              "sourceUrl": "https://github.com/spotify/ads-claude-plugin/blob/40df1de363c3d614f5f9274aa29535b301fff885/skills/change-history/SKILL.md"
            },
            {
              "name": "clone",
              "sourceUrl": "https://github.com/spotify/ads-claude-plugin/blob/40df1de363c3d614f5f9274aa29535b301fff885/skills/clone/SKILL.md"
            },
            {
              "name": "configure",
              "sourceUrl": "https://github.com/spotify/ads-claude-plugin/blob/40df1de363c3d614f5f9274aa29535b301fff885/skills/configure/SKILL.md"
            },
            {
              "name": "dashboard",
              "sourceUrl": "https://github.com/spotify/ads-claude-plugin/blob/40df1de363c3d614f5f9274aa29535b301fff885/skills/dashboard/SKILL.md"
            },
            {
              "name": "drafts",
              "sourceUrl": "https://github.com/spotify/ads-claude-plugin/blob/40df1de363c3d614f5f9274aa29535b301fff885/skills/drafts/SKILL.md"
            },
            {
              "name": "export",
              "sourceUrl": "https://github.com/spotify/ads-claude-plugin/blob/40df1de363c3d614f5f9274aa29535b301fff885/skills/export/SKILL.md"
            },
            {
              "name": "measurement-debug",
              "sourceUrl": "https://github.com/spotify/ads-claude-plugin/blob/40df1de363c3d614f5f9274aa29535b301fff885/skills/measurement-debug/SKILL.md"
            },
            {
              "name": "measurement-setup",
              "sourceUrl": "https://github.com/spotify/ads-claude-plugin/blob/40df1de363c3d614f5f9274aa29535b301fff885/skills/measurement-setup/SKILL.md"
            },
            {
              "name": "monitor",
              "sourceUrl": "https://github.com/spotify/ads-claude-plugin/blob/40df1de363c3d614f5f9274aa29535b301fff885/skills/monitor/SKILL.md"
            },
            {
              "name": "report",
              "sourceUrl": "https://github.com/spotify/ads-claude-plugin/blob/40df1de363c3d614f5f9274aa29535b301fff885/skills/report/SKILL.md"
            }
          ],
          "mcpServers": [],
          "components": ["skills", "hooks", "agents", "commands"],
          "componentInspection": "repository",
          "inspectionError": null,
          "installation": "requires_adapter",
          "upstream": {
            "source": {
              "source": "url",
              "url": "https://github.com/spotify/ads-claude-plugin.git",
              "sha": "40df1de363c3d614f5f9274aa29535b301fff885"
            },
            "policy": null
          }
        },
        {
          "id": "anthropic:stackhawk-hawkscan",
          "name": "stackhawk-hawkscan",
          "displayName": "hawkscan",
          "description": "Configure, run, and interpret HawkScan DAST results inside Claude Code. Generates stackhawk.yml configs, runs scans via CLI or Docker, and transforms security findings into prioritized fix tasks for your coding agent.",
          "longDescription": "Configure, run, and interpret HawkScan DAST results inside Claude Code. Generates stackhawk.yml configs, runs scans via CLI or Docker, and transforms security findings into prioritized fix tasks for your coding agent.",
          "category": "security",
          "keywords": [
            "security",
            "dast",
            "appsec",
            "hawkscan",
            "stackhawk",
            "api-security",
            "vulnerability-scanning"
          ],
          "author": {
            "name": "StackHawk",
            "email": "support@stackhawk.com",
            "url": "https://www.stackhawk.com"
          },
          "version": "2.5.0",
          "license": "MIT",
          "logoUrl": null,
          "darkLogoUrl": null,
          "homepage": "https://docs.stackhawk.com",
          "sourceUrl": "https://github.com/stackhawk/agent-skills/tree/19c14577b7e0360262d02f7a232055c67e9c46a6/plugins/hawkscan",
          "skills": [
            {
              "name": "hawkscan",
              "sourceUrl": "https://github.com/stackhawk/agent-skills/blob/19c14577b7e0360262d02f7a232055c67e9c46a6/plugins/hawkscan/skills/hawkscan/SKILL.md"
            }
          ],
          "mcpServers": [],
          "components": ["skills", "hooks"],
          "componentInspection": "repository",
          "inspectionError": null,
          "installation": "requires_adapter",
          "upstream": {
            "source": {
              "source": "git-subdir",
              "url": "https://github.com/stackhawk/agent-skills.git",
              "path": "plugins/hawkscan",
              "ref": "main",
              "sha": "19c14577b7e0360262d02f7a232055c67e9c46a6"
            },
            "policy": null
          }
        },
        {
          "id": "anthropic:stackhawk-api",
          "name": "stackhawk-api",
          "displayName": "stackhawk-api",
          "description": "Query the StackHawk platform API for security posture reporting, findings analysis, and app management. Uses the combined hawk CLI (hawk op …) for all platform queries.",
          "longDescription": "Query the StackHawk platform API for security posture reporting, findings analysis, and app management. Uses the combined hawk CLI (hawk op …) for all platform queries.",
          "category": "security",
          "keywords": [
            "security",
            "appsec",
            "stackhawk",
            "api",
            "reporting",
            "findings",
            "posture",
            "triage"
          ],
          "author": {
            "name": "StackHawk",
            "email": "support@stackhawk.com",
            "url": "https://www.stackhawk.com"
          },
          "version": "2.5.0",
          "license": "MIT",
          "logoUrl": null,
          "darkLogoUrl": null,
          "homepage": "https://docs.stackhawk.com",
          "sourceUrl": "https://github.com/stackhawk/agent-skills/tree/19c14577b7e0360262d02f7a232055c67e9c46a6/plugins/api",
          "skills": [
            {
              "name": "api",
              "sourceUrl": "https://github.com/stackhawk/agent-skills/blob/19c14577b7e0360262d02f7a232055c67e9c46a6/plugins/api/skills/api/SKILL.md"
            }
          ],
          "mcpServers": [],
          "components": ["skills"],
          "componentInspection": "repository",
          "inspectionError": null,
          "installation": "requires_adapter",
          "upstream": {
            "source": {
              "source": "git-subdir",
              "url": "https://github.com/stackhawk/agent-skills.git",
              "path": "plugins/api",
              "ref": "main",
              "sha": "19c14577b7e0360262d02f7a232055c67e9c46a6"
            },
            "policy": null
          }
        },
        {
          "id": "anthropic:streaming-skills-plugin",
          "name": "streaming-skills-plugin",
          "displayName": "streaming-skills-plugin",
          "description": "Skills for streaming application developers, covering Kafka and Flink client libraries and Schema Registry",
          "longDescription": "Skills for streaming application developers, covering Kafka and Flink client libraries and Schema Registry",
          "category": "development",
          "keywords": [],
          "author": {
            "name": "Confluent"
          },
          "version": "1.3.0",
          "license": null,
          "logoUrl": null,
          "darkLogoUrl": null,
          "homepage": "https://www.confluent.io",
          "sourceUrl": "https://github.com/confluentinc/agent-skills/tree/914d95eff7ff50513b34bfb9ac97eda7c7fce899/",
          "skills": [
            {
              "name": "confluent-cloud-cdc-tableflow",
              "sourceUrl": "https://github.com/confluentinc/agent-skills/blob/914d95eff7ff50513b34bfb9ac97eda7c7fce899/skills/confluent-cloud-cdc-tableflow/SKILL.md"
            },
            {
              "name": "confluent-cloud-flink-sql",
              "sourceUrl": "https://github.com/confluentinc/agent-skills/blob/914d95eff7ff50513b34bfb9ac97eda7c7fce899/skills/confluent-cloud-flink-sql/SKILL.md"
            },
            {
              "name": "confluent-skill-creator",
              "sourceUrl": "https://github.com/confluentinc/agent-skills/blob/914d95eff7ff50513b34bfb9ac97eda7c7fce899/skills/confluent-skill-creator/SKILL.md"
            },
            {
              "name": "confluent-skill-reviewer",
              "sourceUrl": "https://github.com/confluentinc/agent-skills/blob/914d95eff7ff50513b34bfb9ac97eda7c7fce899/skills/confluent-skill-reviewer/SKILL.md"
            },
            {
              "name": "bad-frontmatter",
              "sourceUrl": "https://github.com/confluentinc/agent-skills/blob/914d95eff7ff50513b34bfb9ac97eda7c7fce899/skills/confluent-skill-reviewer/evals/mock-skills/bad-frontmatter/SKILL.md"
            },
            {
              "name": "good-skill",
              "sourceUrl": "https://github.com/confluentinc/agent-skills/blob/914d95eff7ff50513b34bfb9ac97eda7c7fce899/skills/confluent-skill-reviewer/evals/mock-skills/good-skill/SKILL.md"
            },
            {
              "name": "inlined-refs",
              "sourceUrl": "https://github.com/confluentinc/agent-skills/blob/914d95eff7ff50513b34bfb9ac97eda7c7fce899/skills/confluent-skill-reviewer/evals/mock-skills/inlined-refs/SKILL.md"
            },
            {
              "name": "leaky-data",
              "sourceUrl": "https://github.com/confluentinc/agent-skills/blob/914d95eff7ff50513b34bfb9ac97eda7c7fce899/skills/confluent-skill-reviewer/evals/mock-skills/leaky-data/SKILL.md"
            },
            {
              "name": "stale-expectations",
              "sourceUrl": "https://github.com/confluentinc/agent-skills/blob/914d95eff7ff50513b34bfb9ac97eda7c7fce899/skills/confluent-skill-reviewer/evals/mock-skills/stale-expectations/SKILL.md"
            },
            {
              "name": "trigger-overlap",
              "sourceUrl": "https://github.com/confluentinc/agent-skills/blob/914d95eff7ff50513b34bfb9ac97eda7c7fce899/skills/confluent-skill-reviewer/evals/mock-skills/trigger-overlap/SKILL.md"
            },
            {
              "name": "developing-kafka-java-client",
              "sourceUrl": "https://github.com/confluentinc/agent-skills/blob/914d95eff7ff50513b34bfb9ac97eda7c7fce899/skills/developing-kafka-java-client/SKILL.md"
            },
            {
              "name": "developing-kafka-python-client",
              "sourceUrl": "https://github.com/confluentinc/agent-skills/blob/914d95eff7ff50513b34bfb9ac97eda7c7fce899/skills/developing-kafka-python-client/SKILL.md"
            },
            {
              "name": "flink-udf",
              "sourceUrl": "https://github.com/confluentinc/agent-skills/blob/914d95eff7ff50513b34bfb9ac97eda7c7fce899/skills/flink-udf/SKILL.md"
            },
            {
              "name": "kafka-schema-registry",
              "sourceUrl": "https://github.com/confluentinc/agent-skills/blob/914d95eff7ff50513b34bfb9ac97eda7c7fce899/skills/kafka-schema-registry/SKILL.md"
            },
            {
              "name": "kafka-streams-programming",
              "sourceUrl": "https://github.com/confluentinc/agent-skills/blob/914d95eff7ff50513b34bfb9ac97eda7c7fce899/skills/kafka-streams-programming/SKILL.md"
            },
            {
              "name": "msk-migration",
              "sourceUrl": "https://github.com/confluentinc/agent-skills/blob/914d95eff7ff50513b34bfb9ac97eda7c7fce899/skills/msk-migration/SKILL.md"
            }
          ],
          "mcpServers": [],
          "components": ["skills"],
          "componentInspection": "repository",
          "inspectionError": null,
          "installation": "requires_adapter",
          "upstream": {
            "source": {
              "source": "url",
              "url": "https://github.com/confluentinc/agent-skills.git",
              "sha": "914d95eff7ff50513b34bfb9ac97eda7c7fce899"
            },
            "policy": null
          }
        },
        {
          "id": "anthropic:stripe",
          "name": "stripe",
          "displayName": "stripe",
          "description": "Stripe development plugin for Claude",
          "longDescription": "Stripe development plugin for Claude",
          "category": "development",
          "keywords": ["stripe", "payments", "webhooks", "api", "security"],
          "author": {
            "name": "Stripe",
            "url": "https://stripe.com"
          },
          "version": "0.7.4",
          "license": "MIT",
          "logoUrl": null,
          "darkLogoUrl": null,
          "homepage": "https://docs.stripe.com",
          "sourceUrl": "https://github.com/stripe/ai/tree/68382523846ea5bfad75ba1ef58dc5db031d0a5a/providers/claude/plugin",
          "skills": [
            {
              "name": "connect-recommend",
              "sourceUrl": "https://github.com/stripe/ai/blob/68382523846ea5bfad75ba1ef58dc5db031d0a5a/providers/claude/plugin/skills/connect-recommend/SKILL.md"
            },
            {
              "name": "connect-required-verification-information",
              "sourceUrl": "https://github.com/stripe/ai/blob/68382523846ea5bfad75ba1ef58dc5db031d0a5a/providers/claude/plugin/skills/connect-required-verification-information/SKILL.md"
            },
            {
              "name": "stripe-apps",
              "sourceUrl": "https://github.com/stripe/ai/blob/68382523846ea5bfad75ba1ef58dc5db031d0a5a/providers/claude/plugin/skills/stripe-apps/SKILL.md"
            },
            {
              "name": "stripe-best-practices",
              "sourceUrl": "https://github.com/stripe/ai/blob/68382523846ea5bfad75ba1ef58dc5db031d0a5a/providers/claude/plugin/skills/stripe-best-practices/SKILL.md"
            },
            {
              "name": "stripe-directory",
              "sourceUrl": "https://github.com/stripe/ai/blob/68382523846ea5bfad75ba1ef58dc5db031d0a5a/providers/claude/plugin/skills/stripe-directory/SKILL.md"
            },
            {
              "name": "stripe-docs",
              "sourceUrl": "https://github.com/stripe/ai/blob/68382523846ea5bfad75ba1ef58dc5db031d0a5a/providers/claude/plugin/skills/stripe-docs/SKILL.md"
            },
            {
              "name": "stripe-projects",
              "sourceUrl": "https://github.com/stripe/ai/blob/68382523846ea5bfad75ba1ef58dc5db031d0a5a/providers/claude/plugin/skills/stripe-projects/SKILL.md"
            },
            {
              "name": "upgrade-stripe",
              "sourceUrl": "https://github.com/stripe/ai/blob/68382523846ea5bfad75ba1ef58dc5db031d0a5a/providers/claude/plugin/skills/upgrade-stripe/SKILL.md"
            }
          ],
          "mcpServers": [
            {
              "requiresConfiguration": false,
              "name": "stripe",
              "transport": "http",
              "endpoint": "https://mcp.stripe.com"
            }
          ],
          "components": ["skills", "mcp", "agents", "commands"],
          "componentInspection": "repository",
          "inspectionError": null,
          "installation": "requires_adapter",
          "upstream": {
            "source": {
              "source": "git-subdir",
              "url": "https://github.com/stripe/ai.git",
              "path": "providers/claude/plugin",
              "ref": "main",
              "sha": "68382523846ea5bfad75ba1ef58dc5db031d0a5a"
            },
            "policy": null
          }
        },
        {
          "id": "anthropic:sumup",
          "name": "sumup",
          "displayName": "sumup",
          "description": "Skills for SumUp payment integrations across terminal and online checkout flows",
          "longDescription": "Skills for SumUp payment integrations across terminal and online checkout flows",
          "category": "development",
          "keywords": [],
          "author": {
            "name": "SumUp"
          },
          "version": "1.0.0",
          "license": null,
          "logoUrl": null,
          "darkLogoUrl": null,
          "homepage": "https://www.sumup.com/",
          "sourceUrl": "https://github.com/sumup/sumup-skills/tree/cb72003b417cec5e717c6b788d63394b7e921938/",
          "skills": [
            {
              "name": "sumup-best-practices",
              "sourceUrl": "https://github.com/sumup/sumup-skills/blob/cb72003b417cec5e717c6b788d63394b7e921938/skills/sumup-best-practices/SKILL.md"
            },
            {
              "name": "sumup-debug",
              "sourceUrl": "https://github.com/sumup/sumup-skills/blob/cb72003b417cec5e717c6b788d63394b7e921938/skills/sumup-debug/SKILL.md"
            },
            {
              "name": "sumup-mcp",
              "sourceUrl": "https://github.com/sumup/sumup-skills/blob/cb72003b417cec5e717c6b788d63394b7e921938/skills/sumup-mcp/SKILL.md"
            },
            {
              "name": "sumup-testing",
              "sourceUrl": "https://github.com/sumup/sumup-skills/blob/cb72003b417cec5e717c6b788d63394b7e921938/skills/sumup-testing/SKILL.md"
            },
            {
              "name": "sumup",
              "sourceUrl": "https://github.com/sumup/sumup-skills/blob/cb72003b417cec5e717c6b788d63394b7e921938/skills/sumup/SKILL.md"
            },
            {
              "name": "upgrade-sumup",
              "sourceUrl": "https://github.com/sumup/sumup-skills/blob/cb72003b417cec5e717c6b788d63394b7e921938/skills/upgrade-sumup/SKILL.md"
            }
          ],
          "mcpServers": [
            {
              "requiresConfiguration": false,
              "name": "sumup",
              "transport": "http",
              "endpoint": "https://mcp.sumup.com/mcp"
            }
          ],
          "components": ["skills", "mcp"],
          "componentInspection": "repository",
          "inspectionError": null,
          "installation": "requires_adapter",
          "upstream": {
            "source": {
              "source": "url",
              "url": "https://github.com/sumup/sumup-skills.git",
              "sha": "cb72003b417cec5e717c6b788d63394b7e921938"
            },
            "policy": null
          }
        },
        {
          "id": "anthropic:supabase",
          "name": "supabase",
          "displayName": "supabase",
          "description": "Official Supabase plugin for Claude Code with bundled Supabase skills and MCP access for project management, database work, auth, storage, and Postgres best practices.",
          "longDescription": "Official Supabase plugin for Claude Code with bundled Supabase skills and MCP access for project management, database work, auth, storage, and Postgres best practices.",
          "category": "database",
          "keywords": [
            "supabase",
            "postgres",
            "database",
            "backend",
            "mcp",
            "auth",
            "storage",
            "realtime",
            "edge-functions",
            "migrations",
            "rls"
          ],
          "author": {
            "name": "Supabase",
            "url": "https://supabase.com"
          },
          "version": "0.1.15",
          "license": "MIT",
          "logoUrl": null,
          "darkLogoUrl": null,
          "homepage": "https://github.com/supabase-community/supabase-plugin",
          "sourceUrl": "https://github.com/supabase-community/supabase-plugin/tree/f3f332e0164c34a8392772811737fda0cb972d06/",
          "skills": [
            {
              "name": "supabase-postgres-best-practices",
              "sourceUrl": "https://github.com/supabase-community/supabase-plugin/blob/f3f332e0164c34a8392772811737fda0cb972d06/skills/supabase-postgres-best-practices/SKILL.md"
            },
            {
              "name": "supabase",
              "sourceUrl": "https://github.com/supabase-community/supabase-plugin/blob/f3f332e0164c34a8392772811737fda0cb972d06/skills/supabase/SKILL.md"
            }
          ],
          "mcpServers": [
            {
              "requiresConfiguration": true,
              "name": "supabase",
              "transport": "http",
              "endpoint": "https://mcp.supabase.com/mcp"
            }
          ],
          "components": ["skills", "mcp", "agents"],
          "componentInspection": "repository",
          "inspectionError": null,
          "installation": "requires_adapter",
          "upstream": {
            "source": {
              "source": "url",
              "url": "https://github.com/supabase-community/supabase-plugin.git",
              "sha": "f3f332e0164c34a8392772811737fda0cb972d06"
            },
            "policy": null
          }
        },
        {
          "id": "anthropic:superdesign",
          "name": "superdesign",
          "displayName": "superdesign",
          "description": "Design or redesign frontend UI, presentations, and marketing graphics on the Superdesign infinite canvas. Uses approved slide outlines, project context, and branchable drafts you refine.",
          "longDescription": "Design or redesign frontend UI, presentations, and marketing graphics on the Superdesign infinite canvas. Uses approved slide outlines, project context, and branchable drafts you refine.",
          "category": "design",
          "keywords": [
            "design",
            "ui-design",
            "web-design",
            "landing-pages",
            "dashboards",
            "wireframes",
            "mockups",
            "prototyping",
            "design-systems",
            "branding",
            "graphics",
            "posters",
            "presentations",
            "slide-decks",
            "image-generation",
            "infinite-canvas",
            "design-drafts"
          ],
          "author": {
            "name": "Superdesign dev, Inc.",
            "email": "support@superdesign.dev",
            "url": "https://superdesign.dev"
          },
          "version": "0.6.0",
          "license": "MIT",
          "logoUrl": null,
          "darkLogoUrl": null,
          "homepage": "https://superdesign.dev",
          "sourceUrl": "https://github.com/superdesigndev/superdesign-skill/tree/f9f05cd988c247dce6c072eaf9ac6b162f2ffc4b/",
          "skills": [
            {
              "name": "superdesign",
              "sourceUrl": "https://github.com/superdesigndev/superdesign-skill/blob/f9f05cd988c247dce6c072eaf9ac6b162f2ffc4b/skills/superdesign/SKILL.md"
            }
          ],
          "mcpServers": [],
          "components": ["skills"],
          "componentInspection": "repository",
          "inspectionError": null,
          "installation": "requires_adapter",
          "upstream": {
            "source": {
              "source": "url",
              "url": "https://github.com/superdesigndev/superdesign-skill.git",
              "sha": "f9f05cd988c247dce6c072eaf9ac6b162f2ffc4b"
            },
            "policy": null
          }
        },
        {
          "id": "anthropic:superpowers",
          "name": "superpowers",
          "displayName": "superpowers",
          "description": "Core skills library for Claude Code: TDD, debugging, collaboration patterns, and proven techniques",
          "longDescription": "Core skills library for Claude Code: TDD, debugging, collaboration patterns, and proven techniques",
          "category": "development",
          "keywords": [
            "skills",
            "tdd",
            "debugging",
            "collaboration",
            "best-practices",
            "workflows"
          ],
          "author": {
            "name": "Jesse Vincent",
            "email": "jesse@fsck.com"
          },
          "version": "6.3.0",
          "license": "MIT",
          "logoUrl": null,
          "darkLogoUrl": null,
          "homepage": "https://github.com/obra/superpowers",
          "sourceUrl": "https://github.com/obra/superpowers/tree/b36e0829c6d0140e93cfef2ca599b1b07d4a7797/",
          "skills": [
            {
              "name": "brainstorming",
              "sourceUrl": "https://github.com/obra/superpowers/blob/b36e0829c6d0140e93cfef2ca599b1b07d4a7797/skills/brainstorming/SKILL.md"
            },
            {
              "name": "dispatching-parallel-agents",
              "sourceUrl": "https://github.com/obra/superpowers/blob/b36e0829c6d0140e93cfef2ca599b1b07d4a7797/skills/dispatching-parallel-agents/SKILL.md"
            },
            {
              "name": "executing-plans",
              "sourceUrl": "https://github.com/obra/superpowers/blob/b36e0829c6d0140e93cfef2ca599b1b07d4a7797/skills/executing-plans/SKILL.md"
            },
            {
              "name": "finishing-a-development-branch",
              "sourceUrl": "https://github.com/obra/superpowers/blob/b36e0829c6d0140e93cfef2ca599b1b07d4a7797/skills/finishing-a-development-branch/SKILL.md"
            },
            {
              "name": "receiving-code-review",
              "sourceUrl": "https://github.com/obra/superpowers/blob/b36e0829c6d0140e93cfef2ca599b1b07d4a7797/skills/receiving-code-review/SKILL.md"
            },
            {
              "name": "requesting-code-review",
              "sourceUrl": "https://github.com/obra/superpowers/blob/b36e0829c6d0140e93cfef2ca599b1b07d4a7797/skills/requesting-code-review/SKILL.md"
            },
            {
              "name": "subagent-driven-development",
              "sourceUrl": "https://github.com/obra/superpowers/blob/b36e0829c6d0140e93cfef2ca599b1b07d4a7797/skills/subagent-driven-development/SKILL.md"
            },
            {
              "name": "systematic-debugging",
              "sourceUrl": "https://github.com/obra/superpowers/blob/b36e0829c6d0140e93cfef2ca599b1b07d4a7797/skills/systematic-debugging/SKILL.md"
            },
            {
              "name": "test-driven-development",
              "sourceUrl": "https://github.com/obra/superpowers/blob/b36e0829c6d0140e93cfef2ca599b1b07d4a7797/skills/test-driven-development/SKILL.md"
            },
            {
              "name": "using-git-worktrees",
              "sourceUrl": "https://github.com/obra/superpowers/blob/b36e0829c6d0140e93cfef2ca599b1b07d4a7797/skills/using-git-worktrees/SKILL.md"
            },
            {
              "name": "using-superpowers",
              "sourceUrl": "https://github.com/obra/superpowers/blob/b36e0829c6d0140e93cfef2ca599b1b07d4a7797/skills/using-superpowers/SKILL.md"
            },
            {
              "name": "verification-before-completion",
              "sourceUrl": "https://github.com/obra/superpowers/blob/b36e0829c6d0140e93cfef2ca599b1b07d4a7797/skills/verification-before-completion/SKILL.md"
            },
            {
              "name": "writing-plans",
              "sourceUrl": "https://github.com/obra/superpowers/blob/b36e0829c6d0140e93cfef2ca599b1b07d4a7797/skills/writing-plans/SKILL.md"
            },
            {
              "name": "writing-skills",
              "sourceUrl": "https://github.com/obra/superpowers/blob/b36e0829c6d0140e93cfef2ca599b1b07d4a7797/skills/writing-skills/SKILL.md"
            }
          ],
          "mcpServers": [],
          "components": ["skills", "hooks"],
          "componentInspection": "repository",
          "inspectionError": null,
          "installation": "requires_adapter",
          "upstream": {
            "source": {
              "source": "url",
              "url": "https://github.com/obra/superpowers.git",
              "sha": "b36e0829c6d0140e93cfef2ca599b1b07d4a7797"
            },
            "policy": null
          }
        },
        {
          "id": "anthropic:swift-lsp",
          "name": "swift-lsp",
          "displayName": "swift-lsp",
          "description": "Swift language server (SourceKit-LSP) for code intelligence",
          "longDescription": "Swift language server (SourceKit-LSP) for code intelligence",
          "category": "development",
          "keywords": [],
          "author": {
            "name": "Anthropic",
            "email": "support@anthropic.com"
          },
          "version": "1.0.0",
          "license": null,
          "logoUrl": null,
          "darkLogoUrl": null,
          "homepage": null,
          "sourceUrl": "https://github.com/anthropics/claude-plugins-official/tree/3b600518a637492d37c9877aeb49c2a55d939c04/plugins/swift-lsp",
          "skills": [],
          "mcpServers": [],
          "components": [],
          "componentInspection": "repository",
          "inspectionError": null,
          "installation": "requires_adapter",
          "upstream": {
            "source": "./plugins/swift-lsp",
            "policy": null
          }
        },
        {
          "id": "anthropic:synthflow",
          "name": "synthflow",
          "displayName": "synthflow",
          "description": "Connects Claude Code to the Synthflow AI voice-agent platform through its hosted MCP server, with skills for reviewing calls and auditing agent prompts, plus a docs-search connector.",
          "longDescription": "Connects Claude Code to the Synthflow AI voice-agent platform through its hosted MCP server, with skills for reviewing calls and auditing agent prompts, plus a docs-search connector.",
          "category": "automation",
          "keywords": ["synthflow", "mcp", "voice", "ai-agents", "telephony", "integration"],
          "author": {
            "name": "Synthflow",
            "email": "fionn@synthflow.ai"
          },
          "version": "1.3.0",
          "license": "MIT",
          "logoUrl": null,
          "darkLogoUrl": null,
          "homepage": "https://docs.synthflow.ai/anthropic",
          "sourceUrl": "https://github.com/SynthFlowAI/AnthropicPlugin/tree/205871ee83508502d2c982ee1bb7e65a2a29190b/plugins/synthflow",
          "skills": [
            {
              "name": "call-review",
              "sourceUrl": "https://github.com/SynthFlowAI/AnthropicPlugin/blob/205871ee83508502d2c982ee1bb7e65a2a29190b/plugins/synthflow/skills/call-review/SKILL.md"
            },
            {
              "name": "prompt-review",
              "sourceUrl": "https://github.com/SynthFlowAI/AnthropicPlugin/blob/205871ee83508502d2c982ee1bb7e65a2a29190b/plugins/synthflow/skills/prompt-review/SKILL.md"
            }
          ],
          "mcpServers": [
            {
              "requiresConfiguration": false,
              "name": "synthflow",
              "transport": "http",
              "endpoint": "https://mcp.synthflow.ai/mcp"
            },
            {
              "requiresConfiguration": false,
              "name": "synthflow-docs",
              "transport": "http",
              "endpoint": "https://docs.synthflow.ai/_mcp/server"
            }
          ],
          "components": ["skills", "mcp"],
          "componentInspection": "repository",
          "inspectionError": null,
          "installation": "requires_adapter",
          "upstream": {
            "source": {
              "source": "git-subdir",
              "url": "https://github.com/SynthFlowAI/AnthropicPlugin.git",
              "path": "plugins/synthflow",
              "ref": "main",
              "sha": "205871ee83508502d2c982ee1bb7e65a2a29190b"
            },
            "policy": null
          }
        },
        {
          "id": "anthropic:tavily",
          "name": "tavily",
          "displayName": "tavily",
          "description": "Build AI applications with real-time web data using Tavily's search, extract, crawl, and research APIs.",
          "longDescription": "Build AI applications with real-time web data using Tavily's search, extract, crawl, and research APIs.",
          "category": "development",
          "keywords": [
            "search",
            "web-search",
            "rag",
            "agents",
            "llm",
            "research",
            "crawl",
            "extract"
          ],
          "author": {
            "name": "Tavily Team",
            "email": "dean.sacoransky@tavily.com",
            "url": "https://www.tavily.com/"
          },
          "version": "1.0.0",
          "license": "MIT",
          "logoUrl": null,
          "darkLogoUrl": null,
          "homepage": "https://docs.tavily.com",
          "sourceUrl": "https://github.com/tavily-ai/skills/tree/778122e5f9c680f541eeceda5a5b36405eb7980c/",
          "skills": [
            {
              "name": "tavily-best-practices",
              "sourceUrl": "https://github.com/tavily-ai/skills/blob/778122e5f9c680f541eeceda5a5b36405eb7980c/skills/tavily-best-practices/SKILL.md"
            },
            {
              "name": "tavily-cli",
              "sourceUrl": "https://github.com/tavily-ai/skills/blob/778122e5f9c680f541eeceda5a5b36405eb7980c/skills/tavily-cli/SKILL.md"
            },
            {
              "name": "tavily-crawl",
              "sourceUrl": "https://github.com/tavily-ai/skills/blob/778122e5f9c680f541eeceda5a5b36405eb7980c/skills/tavily-crawl/SKILL.md"
            },
            {
              "name": "tavily-dynamic-search",
              "sourceUrl": "https://github.com/tavily-ai/skills/blob/778122e5f9c680f541eeceda5a5b36405eb7980c/skills/tavily-dynamic-search/SKILL.md"
            },
            {
              "name": "tavily-extract",
              "sourceUrl": "https://github.com/tavily-ai/skills/blob/778122e5f9c680f541eeceda5a5b36405eb7980c/skills/tavily-extract/SKILL.md"
            },
            {
              "name": "tavily-map",
              "sourceUrl": "https://github.com/tavily-ai/skills/blob/778122e5f9c680f541eeceda5a5b36405eb7980c/skills/tavily-map/SKILL.md"
            },
            {
              "name": "tavily-research",
              "sourceUrl": "https://github.com/tavily-ai/skills/blob/778122e5f9c680f541eeceda5a5b36405eb7980c/skills/tavily-research/SKILL.md"
            },
            {
              "name": "tavily-search",
              "sourceUrl": "https://github.com/tavily-ai/skills/blob/778122e5f9c680f541eeceda5a5b36405eb7980c/skills/tavily-search/SKILL.md"
            }
          ],
          "mcpServers": [],
          "components": ["skills"],
          "componentInspection": "repository",
          "inspectionError": null,
          "installation": "requires_adapter",
          "upstream": {
            "source": {
              "source": "url",
              "url": "https://github.com/tavily-ai/skills.git",
              "sha": "778122e5f9c680f541eeceda5a5b36405eb7980c"
            },
            "policy": null
          }
        },
        {
          "id": "anthropic:teamcity-cli",
          "name": "teamcity-cli",
          "displayName": "teamcity-cli",
          "description": "Agent skill for interacting with TeamCity CI/CD using the teamcity CLI. Enables Claude to explore builds, view logs, start jobs, manage queues, agents, and more.",
          "longDescription": "Agent skill for interacting with TeamCity CI/CD using the teamcity CLI. Enables Claude to explore builds, view logs, start jobs, manage queues, agents, and more.",
          "category": "development",
          "keywords": [],
          "author": {
            "name": "JetBrains"
          },
          "version": "1.3.0",
          "license": null,
          "logoUrl": null,
          "darkLogoUrl": null,
          "homepage": "https://www.jetbrains.com/teamcity/",
          "sourceUrl": "https://github.com/JetBrains/teamcity-cli/tree/0af59a58b17b5cec3750467ac588dd642c8f5e4c/",
          "skills": [
            {
              "name": "migrate-to-teamcity",
              "sourceUrl": "https://github.com/JetBrains/teamcity-cli/blob/0af59a58b17b5cec3750467ac588dd642c8f5e4c/skills/migrate-to-teamcity/SKILL.md"
            },
            {
              "name": "teamcity-cli",
              "sourceUrl": "https://github.com/JetBrains/teamcity-cli/blob/0af59a58b17b5cec3750467ac588dd642c8f5e4c/skills/teamcity-cli/SKILL.md"
            }
          ],
          "mcpServers": [],
          "components": ["skills"],
          "componentInspection": "repository",
          "inspectionError": null,
          "installation": "requires_adapter",
          "upstream": {
            "source": {
              "source": "url",
              "url": "https://github.com/JetBrains/teamcity-cli.git",
              "sha": "0af59a58b17b5cec3750467ac588dd642c8f5e4c"
            },
            "policy": null
          }
        },
        {
          "id": "anthropic:telegram",
          "name": "telegram",
          "displayName": "telegram",
          "description": "Telegram channel for Claude Code — messaging bridge with built-in access control. Manage pairing, allowlists, and policy via /telegram:access.",
          "longDescription": "Telegram channel for Claude Code — messaging bridge with built-in access control. Manage pairing, allowlists, and policy via /telegram:access.",
          "category": "productivity",
          "keywords": ["telegram", "messaging", "channel", "mcp"],
          "author": null,
          "version": "0.0.7",
          "license": null,
          "logoUrl": null,
          "darkLogoUrl": null,
          "homepage": null,
          "sourceUrl": "https://github.com/anthropics/claude-plugins-official/tree/3b600518a637492d37c9877aeb49c2a55d939c04/external_plugins/telegram",
          "skills": [
            {
              "name": "access",
              "sourceUrl": "https://github.com/anthropics/claude-plugins-official/blob/3b600518a637492d37c9877aeb49c2a55d939c04/external_plugins/telegram/skills/access/SKILL.md"
            },
            {
              "name": "configure",
              "sourceUrl": "https://github.com/anthropics/claude-plugins-official/blob/3b600518a637492d37c9877aeb49c2a55d939c04/external_plugins/telegram/skills/configure/SKILL.md"
            }
          ],
          "mcpServers": [
            {
              "requiresConfiguration": false,
              "name": "telegram",
              "transport": "stdio",
              "endpoint": null
            }
          ],
          "components": ["skills", "mcp"],
          "componentInspection": "repository",
          "inspectionError": null,
          "installation": "requires_adapter",
          "upstream": {
            "source": "./external_plugins/telegram",
            "policy": null
          }
        },
        {
          "id": "anthropic:terraform",
          "name": "terraform",
          "displayName": "terraform",
          "description": "The Terraform MCP Server provides seamless integration with Terraform ecosystem, enabling advanced automation and interaction capabilities for Infrastructure as Code (IaC) development.",
          "longDescription": "The Terraform MCP Server provides seamless integration with Terraform ecosystem, enabling advanced automation and interaction capabilities for Infrastructure as Code (IaC) development.",
          "category": "development",
          "keywords": [],
          "author": {
            "name": "HashiCorp"
          },
          "version": null,
          "license": null,
          "logoUrl": null,
          "darkLogoUrl": null,
          "homepage": "https://github.com/anthropics/claude-plugins-public/tree/main/external_plugins/terraform",
          "sourceUrl": "https://github.com/anthropics/claude-plugins-official/tree/3b600518a637492d37c9877aeb49c2a55d939c04/external_plugins/terraform",
          "skills": [],
          "mcpServers": [
            {
              "requiresConfiguration": false,
              "name": "terraform",
              "transport": "stdio",
              "endpoint": null
            }
          ],
          "components": ["mcp"],
          "componentInspection": "repository",
          "inspectionError": null,
          "installation": "requires_adapter",
          "upstream": {
            "source": "./external_plugins/terraform",
            "policy": null
          }
        },
        {
          "id": "anthropic:togetherai-skills",
          "name": "togetherai-skills",
          "displayName": "togetherai-skills",
          "description": "Agent Skills for Together AI platform — inference, training, embeddings, audio, video, images, function calling, and infrastructure",
          "longDescription": "Agent Skills for Together AI platform — inference, training, embeddings, audio, video, images, function calling, and infrastructure",
          "category": "development",
          "keywords": [
            "together-ai",
            "inference",
            "fine-tuning",
            "gpu",
            "llm",
            "embeddings",
            "images",
            "video",
            "audio"
          ],
          "author": {
            "name": "Together AI"
          },
          "version": "1.0.0",
          "license": "MIT",
          "logoUrl": null,
          "darkLogoUrl": null,
          "homepage": "https://github.com/togethercomputer/skills",
          "sourceUrl": "https://github.com/togethercomputer/skills/tree/644d38225bbdef0318462fe222f6f9883c8addcd/",
          "skills": [
            {
              "name": "together-audio",
              "sourceUrl": "https://github.com/togethercomputer/skills/blob/644d38225bbdef0318462fe222f6f9883c8addcd/skills/together-audio/SKILL.md"
            },
            {
              "name": "together-batch-inference",
              "sourceUrl": "https://github.com/togethercomputer/skills/blob/644d38225bbdef0318462fe222f6f9883c8addcd/skills/together-batch-inference/SKILL.md"
            },
            {
              "name": "together-chat-completions",
              "sourceUrl": "https://github.com/togethercomputer/skills/blob/644d38225bbdef0318462fe222f6f9883c8addcd/skills/together-chat-completions/SKILL.md"
            },
            {
              "name": "together-dedicated-containers",
              "sourceUrl": "https://github.com/togethercomputer/skills/blob/644d38225bbdef0318462fe222f6f9883c8addcd/skills/together-dedicated-containers/SKILL.md"
            },
            {
              "name": "together-dedicated-model-inference",
              "sourceUrl": "https://github.com/togethercomputer/skills/blob/644d38225bbdef0318462fe222f6f9883c8addcd/skills/together-dedicated-model-inference/SKILL.md"
            },
            {
              "name": "together-embeddings",
              "sourceUrl": "https://github.com/togethercomputer/skills/blob/644d38225bbdef0318462fe222f6f9883c8addcd/skills/together-embeddings/SKILL.md"
            },
            {
              "name": "together-evaluations",
              "sourceUrl": "https://github.com/togethercomputer/skills/blob/644d38225bbdef0318462fe222f6f9883c8addcd/skills/together-evaluations/SKILL.md"
            },
            {
              "name": "together-fine-tuning",
              "sourceUrl": "https://github.com/togethercomputer/skills/blob/644d38225bbdef0318462fe222f6f9883c8addcd/skills/together-fine-tuning/SKILL.md"
            },
            {
              "name": "together-gpu-clusters",
              "sourceUrl": "https://github.com/togethercomputer/skills/blob/644d38225bbdef0318462fe222f6f9883c8addcd/skills/together-gpu-clusters/SKILL.md"
            },
            {
              "name": "together-images",
              "sourceUrl": "https://github.com/togethercomputer/skills/blob/644d38225bbdef0318462fe222f6f9883c8addcd/skills/together-images/SKILL.md"
            },
            {
              "name": "together-kueue",
              "sourceUrl": "https://github.com/togethercomputer/skills/blob/644d38225bbdef0318462fe222f6f9883c8addcd/skills/together-kueue/SKILL.md"
            },
            {
              "name": "together-sandboxes",
              "sourceUrl": "https://github.com/togethercomputer/skills/blob/644d38225bbdef0318462fe222f6f9883c8addcd/skills/together-sandboxes/SKILL.md"
            },
            {
              "name": "together-video",
              "sourceUrl": "https://github.com/togethercomputer/skills/blob/644d38225bbdef0318462fe222f6f9883c8addcd/skills/together-video/SKILL.md"
            },
            {
              "name": "together-volcano",
              "sourceUrl": "https://github.com/togethercomputer/skills/blob/644d38225bbdef0318462fe222f6f9883c8addcd/skills/together-volcano/SKILL.md"
            }
          ],
          "mcpServers": [],
          "components": ["skills"],
          "componentInspection": "repository",
          "inspectionError": null,
          "installation": "requires_adapter",
          "upstream": {
            "source": {
              "source": "url",
              "url": "https://github.com/togethercomputer/skills.git",
              "sha": "644d38225bbdef0318462fe222f6f9883c8addcd"
            },
            "policy": null
          }
        },
        {
          "id": "anthropic:twilio-developer-kit",
          "name": "twilio-developer-kit",
          "displayName": "twilio-developer-kit",
          "description": "Complete set of Twilio skills. Covers Setup, Planner, Product, and Guardrail skills across SMS, Voice, WhatsApp, AI agents, Conversation Orchestrator, and 30+ products.",
          "longDescription": "Complete set of Twilio skills. Covers Setup, Planner, Product, and Guardrail skills across SMS, Voice, WhatsApp, AI agents, Conversation Orchestrator, and 30+ products.",
          "category": "development",
          "keywords": [],
          "author": {
            "name": "Twilio"
          },
          "version": "0.3.2",
          "license": null,
          "logoUrl": null,
          "darkLogoUrl": null,
          "homepage": "https://www.twilio.com",
          "sourceUrl": "https://github.com/twilio/ai/tree/8aba46fb65dc8d9a20f4b301a68352064b4159a5/",
          "skills": [
            {
              "name": "twilio-sendgrid-account-setup",
              "sourceUrl": "https://github.com/twilio/ai/blob/8aba46fb65dc8d9a20f4b301a68352064b4159a5/skills/sendgrid/twilio-sendgrid-account-setup/SKILL.md"
            },
            {
              "name": "twilio-sendgrid-deliverability-advisor",
              "sourceUrl": "https://github.com/twilio/ai/blob/8aba46fb65dc8d9a20f4b301a68352064b4159a5/skills/sendgrid/twilio-sendgrid-deliverability-advisor/SKILL.md"
            },
            {
              "name": "twilio-sendgrid-email-send",
              "sourceUrl": "https://github.com/twilio/ai/blob/8aba46fb65dc8d9a20f4b301a68352064b4159a5/skills/sendgrid/twilio-sendgrid-email-send/SKILL.md"
            },
            {
              "name": "twilio-sendgrid-email-settings",
              "sourceUrl": "https://github.com/twilio/ai/blob/8aba46fb65dc8d9a20f4b301a68352064b4159a5/skills/sendgrid/twilio-sendgrid-email-settings/SKILL.md"
            },
            {
              "name": "twilio-sendgrid-engagement-quality",
              "sourceUrl": "https://github.com/twilio/ai/blob/8aba46fb65dc8d9a20f4b301a68352064b4159a5/skills/sendgrid/twilio-sendgrid-engagement-quality/SKILL.md"
            },
            {
              "name": "twilio-sendgrid-inbound-parse",
              "sourceUrl": "https://github.com/twilio/ai/blob/8aba46fb65dc8d9a20f4b301a68352064b4159a5/skills/sendgrid/twilio-sendgrid-inbound-parse/SKILL.md"
            },
            {
              "name": "twilio-sendgrid-suppressions",
              "sourceUrl": "https://github.com/twilio/ai/blob/8aba46fb65dc8d9a20f4b301a68352064b4159a5/skills/sendgrid/twilio-sendgrid-suppressions/SKILL.md"
            },
            {
              "name": "twilio-sendgrid-webhooks",
              "sourceUrl": "https://github.com/twilio/ai/blob/8aba46fb65dc8d9a20f4b301a68352064b4159a5/skills/sendgrid/twilio-sendgrid-webhooks/SKILL.md"
            },
            {
              "name": "twilio-account-setup",
              "sourceUrl": "https://github.com/twilio/ai/blob/8aba46fb65dc8d9a20f4b301a68352064b4159a5/skills/twilio/twilio-account-setup/SKILL.md"
            },
            {
              "name": "twilio-agent-augmentation-architect",
              "sourceUrl": "https://github.com/twilio/ai/blob/8aba46fb65dc8d9a20f4b301a68352064b4159a5/skills/twilio/twilio-agent-augmentation-architect/SKILL.md"
            },
            {
              "name": "twilio-agent-connect",
              "sourceUrl": "https://github.com/twilio/ai/blob/8aba46fb65dc8d9a20f4b301a68352064b4159a5/skills/twilio/twilio-agent-connect/SKILL.md"
            },
            {
              "name": "twilio-ai-agent-architect",
              "sourceUrl": "https://github.com/twilio/ai/blob/8aba46fb65dc8d9a20f4b301a68352064b4159a5/skills/twilio/twilio-ai-agent-architect/SKILL.md"
            },
            {
              "name": "twilio-call-recordings",
              "sourceUrl": "https://github.com/twilio/ai/blob/8aba46fb65dc8d9a20f4b301a68352064b4159a5/skills/twilio/twilio-call-recordings/SKILL.md"
            },
            {
              "name": "twilio-cli-reference",
              "sourceUrl": "https://github.com/twilio/ai/blob/8aba46fb65dc8d9a20f4b301a68352064b4159a5/skills/twilio/twilio-cli-reference/SKILL.md"
            },
            {
              "name": "twilio-compliance-onboarding",
              "sourceUrl": "https://github.com/twilio/ai/blob/8aba46fb65dc8d9a20f4b301a68352064b4159a5/skills/twilio/twilio-compliance-onboarding/SKILL.md"
            },
            {
              "name": "twilio-compliance-traffic",
              "sourceUrl": "https://github.com/twilio/ai/blob/8aba46fb65dc8d9a20f4b301a68352064b4159a5/skills/twilio/twilio-compliance-traffic/SKILL.md"
            },
            {
              "name": "twilio-conference-calls",
              "sourceUrl": "https://github.com/twilio/ai/blob/8aba46fb65dc8d9a20f4b301a68352064b4159a5/skills/twilio/twilio-conference-calls/SKILL.md"
            },
            {
              "name": "twilio-content-template-builder",
              "sourceUrl": "https://github.com/twilio/ai/blob/8aba46fb65dc8d9a20f4b301a68352064b4159a5/skills/twilio/twilio-content-template-builder/SKILL.md"
            },
            {
              "name": "twilio-conversation-intelligence",
              "sourceUrl": "https://github.com/twilio/ai/blob/8aba46fb65dc8d9a20f4b301a68352064b4159a5/skills/twilio/twilio-conversation-intelligence/SKILL.md"
            },
            {
              "name": "twilio-conversation-memory",
              "sourceUrl": "https://github.com/twilio/ai/blob/8aba46fb65dc8d9a20f4b301a68352064b4159a5/skills/twilio/twilio-conversation-memory/SKILL.md"
            },
            {
              "name": "twilio-conversation-orchestrator",
              "sourceUrl": "https://github.com/twilio/ai/blob/8aba46fb65dc8d9a20f4b301a68352064b4159a5/skills/twilio/twilio-conversation-orchestrator/SKILL.md"
            },
            {
              "name": "twilio-conversations-classic-api",
              "sourceUrl": "https://github.com/twilio/ai/blob/8aba46fb65dc8d9a20f4b301a68352064b4159a5/skills/twilio/twilio-conversations-classic-api/SKILL.md"
            },
            {
              "name": "twilio-customer-support-architect",
              "sourceUrl": "https://github.com/twilio/ai/blob/8aba46fb65dc8d9a20f4b301a68352064b4159a5/skills/twilio/twilio-customer-support-architect/SKILL.md"
            },
            {
              "name": "twilio-debugging-observability",
              "sourceUrl": "https://github.com/twilio/ai/blob/8aba46fb65dc8d9a20f4b301a68352064b4159a5/skills/twilio/twilio-debugging-observability/SKILL.md"
            },
            {
              "name": "twilio-email-deliverability-advisor",
              "sourceUrl": "https://github.com/twilio/ai/blob/8aba46fb65dc8d9a20f4b301a68352064b4159a5/skills/twilio/twilio-email-deliverability-advisor/SKILL.md"
            },
            {
              "name": "twilio-email-send",
              "sourceUrl": "https://github.com/twilio/ai/blob/8aba46fb65dc8d9a20f4b301a68352064b4159a5/skills/twilio/twilio-email-send/SKILL.md"
            },
            {
              "name": "twilio-enterprise-knowledge",
              "sourceUrl": "https://github.com/twilio/ai/blob/8aba46fb65dc8d9a20f4b301a68352064b4159a5/skills/twilio/twilio-enterprise-knowledge/SKILL.md"
            },
            {
              "name": "twilio-iam-auth-setup",
              "sourceUrl": "https://github.com/twilio/ai/blob/8aba46fb65dc8d9a20f4b301a68352064b4159a5/skills/twilio/twilio-iam-auth-setup/SKILL.md"
            },
            {
              "name": "twilio-identity-verification-advisor",
              "sourceUrl": "https://github.com/twilio/ai/blob/8aba46fb65dc8d9a20f4b301a68352064b4159a5/skills/twilio/twilio-identity-verification-advisor/SKILL.md"
            },
            {
              "name": "twilio-lookup-phone-intelligence",
              "sourceUrl": "https://github.com/twilio/ai/blob/8aba46fb65dc8d9a20f4b301a68352064b4159a5/skills/twilio/twilio-lookup-phone-intelligence/SKILL.md"
            },
            {
              "name": "twilio-marketing-promotions-advisor",
              "sourceUrl": "https://github.com/twilio/ai/blob/8aba46fb65dc8d9a20f4b301a68352064b4159a5/skills/twilio/twilio-marketing-promotions-advisor/SKILL.md"
            },
            {
              "name": "twilio-messaging-channel-advisor",
              "sourceUrl": "https://github.com/twilio/ai/blob/8aba46fb65dc8d9a20f4b301a68352064b4159a5/skills/twilio/twilio-messaging-channel-advisor/SKILL.md"
            },
            {
              "name": "twilio-messaging-overview",
              "sourceUrl": "https://github.com/twilio/ai/blob/8aba46fb65dc8d9a20f4b301a68352064b4159a5/skills/twilio/twilio-messaging-overview/SKILL.md"
            },
            {
              "name": "twilio-messaging-services",
              "sourceUrl": "https://github.com/twilio/ai/blob/8aba46fb65dc8d9a20f4b301a68352064b4159a5/skills/twilio/twilio-messaging-services/SKILL.md"
            },
            {
              "name": "twilio-messaging-webhooks",
              "sourceUrl": "https://github.com/twilio/ai/blob/8aba46fb65dc8d9a20f4b301a68352064b4159a5/skills/twilio/twilio-messaging-webhooks/SKILL.md"
            },
            {
              "name": "twilio-migrate-messaging-to-verify",
              "sourceUrl": "https://github.com/twilio/ai/blob/8aba46fb65dc8d9a20f4b301a68352064b4159a5/skills/twilio/twilio-migrate-messaging-to-verify/SKILL.md"
            },
            {
              "name": "twilio-notifications-alerts-advisor",
              "sourceUrl": "https://github.com/twilio/ai/blob/8aba46fb65dc8d9a20f4b301a68352064b4159a5/skills/twilio/twilio-notifications-alerts-advisor/SKILL.md"
            },
            {
              "name": "twilio-numbers-senders",
              "sourceUrl": "https://github.com/twilio/ai/blob/8aba46fb65dc8d9a20f4b301a68352064b4159a5/skills/twilio/twilio-numbers-senders/SKILL.md"
            },
            {
              "name": "twilio-organizations-setup",
              "sourceUrl": "https://github.com/twilio/ai/blob/8aba46fb65dc8d9a20f4b301a68352064b4159a5/skills/twilio/twilio-organizations-setup/SKILL.md"
            },
            {
              "name": "twilio-rcs-messaging",
              "sourceUrl": "https://github.com/twilio/ai/blob/8aba46fb65dc8d9a20f4b301a68352064b4159a5/skills/twilio/twilio-rcs-messaging/SKILL.md"
            },
            {
              "name": "twilio-regulatory-compliance-bundles",
              "sourceUrl": "https://github.com/twilio/ai/blob/8aba46fb65dc8d9a20f4b301a68352064b4159a5/skills/twilio/twilio-regulatory-compliance-bundles/SKILL.md"
            },
            {
              "name": "twilio-reliability-patterns",
              "sourceUrl": "https://github.com/twilio/ai/blob/8aba46fb65dc8d9a20f4b301a68352064b4159a5/skills/twilio/twilio-reliability-patterns/SKILL.md"
            },
            {
              "name": "twilio-security-api-auth",
              "sourceUrl": "https://github.com/twilio/ai/blob/8aba46fb65dc8d9a20f4b301a68352064b4159a5/skills/twilio/twilio-security-api-auth/SKILL.md"
            },
            {
              "name": "twilio-security-compliance-hipaa",
              "sourceUrl": "https://github.com/twilio/ai/blob/8aba46fb65dc8d9a20f4b301a68352064b4159a5/skills/twilio/twilio-security-compliance-hipaa/SKILL.md"
            },
            {
              "name": "twilio-security-hardening",
              "sourceUrl": "https://github.com/twilio/ai/blob/8aba46fb65dc8d9a20f4b301a68352064b4159a5/skills/twilio/twilio-security-hardening/SKILL.md"
            },
            {
              "name": "twilio-send-message",
              "sourceUrl": "https://github.com/twilio/ai/blob/8aba46fb65dc8d9a20f4b301a68352064b4159a5/skills/twilio/twilio-send-message/SKILL.md"
            },
            {
              "name": "twilio-sms-isv-setup",
              "sourceUrl": "https://github.com/twilio/ai/blob/8aba46fb65dc8d9a20f4b301a68352064b4159a5/skills/twilio/twilio-sms-isv-setup/SKILL.md"
            },
            {
              "name": "twilio-sms-send-message",
              "sourceUrl": "https://github.com/twilio/ai/blob/8aba46fb65dc8d9a20f4b301a68352064b4159a5/skills/twilio/twilio-sms-send-message/SKILL.md"
            },
            {
              "name": "twilio-studio-flows",
              "sourceUrl": "https://github.com/twilio/ai/blob/8aba46fb65dc8d9a20f4b301a68352064b4159a5/skills/twilio/twilio-studio-flows/SKILL.md"
            },
            {
              "name": "twilio-taskrouter-routing",
              "sourceUrl": "https://github.com/twilio/ai/blob/8aba46fb65dc8d9a20f4b301a68352064b4159a5/skills/twilio/twilio-taskrouter-routing/SKILL.md"
            },
            {
              "name": "twilio-verify-send-otp",
              "sourceUrl": "https://github.com/twilio/ai/blob/8aba46fb65dc8d9a20f4b301a68352064b4159a5/skills/twilio/twilio-verify-send-otp/SKILL.md"
            },
            {
              "name": "twilio-voice-conversation-relay",
              "sourceUrl": "https://github.com/twilio/ai/blob/8aba46fb65dc8d9a20f4b301a68352064b4159a5/skills/twilio/twilio-voice-conversation-relay/SKILL.md"
            },
            {
              "name": "twilio-voice-outbound-calls",
              "sourceUrl": "https://github.com/twilio/ai/blob/8aba46fb65dc8d9a20f4b301a68352064b4159a5/skills/twilio/twilio-voice-outbound-calls/SKILL.md"
            },
            {
              "name": "twilio-voice-twiml",
              "sourceUrl": "https://github.com/twilio/ai/blob/8aba46fb65dc8d9a20f4b301a68352064b4159a5/skills/twilio/twilio-voice-twiml/SKILL.md"
            },
            {
              "name": "twilio-webhook-architecture",
              "sourceUrl": "https://github.com/twilio/ai/blob/8aba46fb65dc8d9a20f4b301a68352064b4159a5/skills/twilio/twilio-webhook-architecture/SKILL.md"
            },
            {
              "name": "twilio-whatsapp-manage-senders",
              "sourceUrl": "https://github.com/twilio/ai/blob/8aba46fb65dc8d9a20f4b301a68352064b4159a5/skills/twilio/twilio-whatsapp-manage-senders/SKILL.md"
            },
            {
              "name": "twilio-whatsapp-send-message",
              "sourceUrl": "https://github.com/twilio/ai/blob/8aba46fb65dc8d9a20f4b301a68352064b4159a5/skills/twilio/twilio-whatsapp-send-message/SKILL.md"
            }
          ],
          "mcpServers": [
            {
              "requiresConfiguration": false,
              "name": "twilio-docs",
              "transport": "http",
              "endpoint": "https://mcp.twilio.com/docs"
            }
          ],
          "components": ["skills", "mcp"],
          "componentInspection": "repository",
          "inspectionError": null,
          "installation": "requires_adapter",
          "upstream": {
            "source": {
              "source": "url",
              "url": "https://github.com/twilio/ai.git",
              "sha": "8aba46fb65dc8d9a20f4b301a68352064b4159a5"
            },
            "policy": null
          }
        },
        {
          "id": "anthropic:typescript-lsp",
          "name": "typescript-lsp",
          "displayName": "typescript-lsp",
          "description": "TypeScript/JavaScript language server for enhanced code intelligence",
          "longDescription": "TypeScript/JavaScript language server for enhanced code intelligence",
          "category": "development",
          "keywords": [],
          "author": {
            "name": "Anthropic",
            "email": "support@anthropic.com"
          },
          "version": "1.0.0",
          "license": null,
          "logoUrl": null,
          "darkLogoUrl": null,
          "homepage": null,
          "sourceUrl": "https://github.com/anthropics/claude-plugins-official/tree/3b600518a637492d37c9877aeb49c2a55d939c04/plugins/typescript-lsp",
          "skills": [],
          "mcpServers": [],
          "components": [],
          "componentInspection": "repository",
          "inspectionError": null,
          "installation": "requires_adapter",
          "upstream": {
            "source": "./plugins/typescript-lsp",
            "policy": null
          }
        },
        {
          "id": "anthropic:ui-theme-designer",
          "name": "ui-theme-designer",
          "displayName": "ui-theme-designer",
          "description": "Plugin for coding agents working with UI theme designer. Bundles two skills: how-to and conceptual answers about UI theme designer on BTP, and questions about the SAP Design System and SAP Fiori design tokens — theme parameters and component-level parameter usage in UI5, UI5 Web Components, and Fundamental Styles.",
          "longDescription": "Plugin for coding agents working with UI theme designer. Bundles two skills: how-to and conceptual answers about UI theme designer on BTP, and questions about the SAP Design System and SAP Fiori design tokens — theme parameters and component-level parameter usage in UI5, UI5 Web Components, and Fundamental Styles.",
          "category": "design",
          "keywords": [],
          "author": {
            "name": "SAP SE"
          },
          "version": null,
          "license": null,
          "logoUrl": null,
          "darkLogoUrl": null,
          "homepage": "https://github.com/SAP/ui-theme-designer-plugins-for-coding-agents",
          "sourceUrl": "https://github.com/SAP/ui-theme-designer-plugins-for-coding-agents/tree/4e30f5750f760cca24a898c3a6daa8eebfa060a0/plugins/ui-theme-designer",
          "skills": [
            {
              "name": "ui-theme-designer-design-tokens",
              "sourceUrl": "https://github.com/SAP/ui-theme-designer-plugins-for-coding-agents/blob/4e30f5750f760cca24a898c3a6daa8eebfa060a0/plugins/ui-theme-designer/skills/ui-theme-designer-design-tokens/SKILL.md"
            },
            {
              "name": "ui-theme-designer-help",
              "sourceUrl": "https://github.com/SAP/ui-theme-designer-plugins-for-coding-agents/blob/4e30f5750f760cca24a898c3a6daa8eebfa060a0/plugins/ui-theme-designer/skills/ui-theme-designer-help/SKILL.md"
            }
          ],
          "mcpServers": [],
          "components": ["skills"],
          "componentInspection": "repository",
          "inspectionError": null,
          "installation": "requires_adapter",
          "upstream": {
            "source": {
              "source": "git-subdir",
              "url": "https://github.com/SAP/ui-theme-designer-plugins-for-coding-agents.git",
              "path": "plugins/ui-theme-designer",
              "ref": "main",
              "sha": "4e30f5750f760cca24a898c3a6daa8eebfa060a0"
            },
            "policy": null
          }
        },
        {
          "id": "anthropic:ui5",
          "name": "ui5",
          "displayName": "ui5",
          "description": "SAPUI5 / OpenUI5 plugin for coding agents. Create and validate UI5 projects, access API documentation, run UI5 linter, get development guidelines and best practices for UI5 development.",
          "longDescription": "SAPUI5 / OpenUI5 plugin for coding agents. Create and validate UI5 projects, access API documentation, run UI5 linter, get development guidelines and best practices for UI5 development.",
          "category": "development",
          "keywords": [],
          "author": {
            "name": "SAP SE",
            "email": "openui5@sap.com",
            "url": "https://www.sap.com"
          },
          "version": null,
          "license": null,
          "logoUrl": null,
          "darkLogoUrl": null,
          "homepage": "https://github.com/UI5/plugins-coding-agents",
          "sourceUrl": "https://github.com/UI5/plugins-coding-agents/tree/a99b882ce364ef4b9f52fb4054f5f410c1636563/plugins/ui5",
          "skills": [
            {
              "name": "ui5-best-practices-accessibility",
              "sourceUrl": "https://github.com/UI5/plugins-coding-agents/blob/a99b882ce364ef4b9f52fb4054f5f410c1636563/plugins/ui5/skills/ui5-best-practices-accessibility/SKILL.md"
            },
            {
              "name": "ui5-best-practices-integration-cards",
              "sourceUrl": "https://github.com/UI5/plugins-coding-agents/blob/a99b882ce364ef4b9f52fb4054f5f410c1636563/plugins/ui5/skills/ui5-best-practices-integration-cards/SKILL.md"
            },
            {
              "name": "ui5-best-practices-mdc",
              "sourceUrl": "https://github.com/UI5/plugins-coding-agents/blob/a99b882ce364ef4b9f52fb4054f5f410c1636563/plugins/ui5/skills/ui5-best-practices-mdc/SKILL.md"
            },
            {
              "name": "ui5-best-practices-opa5",
              "sourceUrl": "https://github.com/UI5/plugins-coding-agents/blob/a99b882ce364ef4b9f52fb4054f5f410c1636563/plugins/ui5/skills/ui5-best-practices-opa5/SKILL.md"
            },
            {
              "name": "ui5-best-practices-qunit",
              "sourceUrl": "https://github.com/UI5/plugins-coding-agents/blob/a99b882ce364ef4b9f52fb4054f5f410c1636563/plugins/ui5/skills/ui5-best-practices-qunit/SKILL.md"
            },
            {
              "name": "ui5-best-practices-smart-controls",
              "sourceUrl": "https://github.com/UI5/plugins-coding-agents/blob/a99b882ce364ef4b9f52fb4054f5f410c1636563/plugins/ui5/skills/ui5-best-practices-smart-controls/SKILL.md"
            },
            {
              "name": "ui5-best-practices-tables",
              "sourceUrl": "https://github.com/UI5/plugins-coding-agents/blob/a99b882ce364ef4b9f52fb4054f5f410c1636563/plugins/ui5/skills/ui5-best-practices-tables/SKILL.md"
            },
            {
              "name": "ui5-best-practices",
              "sourceUrl": "https://github.com/UI5/plugins-coding-agents/blob/a99b882ce364ef4b9f52fb4054f5f410c1636563/plugins/ui5/skills/ui5-best-practices/SKILL.md"
            }
          ],
          "mcpServers": [
            {
              "requiresConfiguration": false,
              "name": "ui5-mcp-server",
              "transport": "stdio",
              "endpoint": null
            }
          ],
          "components": ["skills", "mcp"],
          "componentInspection": "repository",
          "inspectionError": null,
          "installation": "requires_adapter",
          "upstream": {
            "source": {
              "source": "git-subdir",
              "url": "https://github.com/UI5/plugins-coding-agents.git",
              "path": "plugins/ui5",
              "ref": "main",
              "sha": "a99b882ce364ef4b9f52fb4054f5f410c1636563"
            },
            "policy": null
          }
        },
        {
          "id": "anthropic:ui5-modernization",
          "name": "ui5-modernization",
          "displayName": "ui5-modernization",
          "description": "Complete UI5 modernization toolkit with workflow and specialized fix patterns for modernizing SAPUI5/OpenUI5 applications.",
          "longDescription": "Complete UI5 modernization toolkit with workflow and specialized fix patterns for modernizing SAPUI5/OpenUI5 applications.",
          "category": "development",
          "keywords": [],
          "author": {
            "name": "SAP SE",
            "email": "openui5@sap.com",
            "url": "https://www.sap.com"
          },
          "version": null,
          "license": null,
          "logoUrl": null,
          "darkLogoUrl": null,
          "homepage": "https://github.com/UI5/plugins-coding-agents",
          "sourceUrl": "https://github.com/UI5/plugins-coding-agents/tree/2b8c4a944e39609214bce7aef3b05260985f0e91/plugins/ui5-modernization",
          "skills": [
            {
              "name": "fix-bootstrap-params",
              "sourceUrl": "https://github.com/UI5/plugins-coding-agents/blob/2b8c4a944e39609214bce7aef3b05260985f0e91/plugins/ui5-modernization/skills/fix-bootstrap-params/SKILL.md"
            },
            {
              "name": "fix-component-async",
              "sourceUrl": "https://github.com/UI5/plugins-coding-agents/blob/2b8c4a944e39609214bce7aef3b05260985f0e91/plugins/ui5-modernization/skills/fix-component-async/SKILL.md"
            },
            {
              "name": "fix-control-renderer",
              "sourceUrl": "https://github.com/UI5/plugins-coding-agents/blob/2b8c4a944e39609214bce7aef3b05260985f0e91/plugins/ui5-modernization/skills/fix-control-renderer/SKILL.md"
            },
            {
              "name": "fix-csp-compliance",
              "sourceUrl": "https://github.com/UI5/plugins-coding-agents/blob/2b8c4a944e39609214bce7aef3b05260985f0e91/plugins/ui5-modernization/skills/fix-csp-compliance/SKILL.md"
            },
            {
              "name": "fix-cyclic-deps",
              "sourceUrl": "https://github.com/UI5/plugins-coding-agents/blob/2b8c4a944e39609214bce7aef3b05260985f0e91/plugins/ui5-modernization/skills/fix-cyclic-deps/SKILL.md"
            },
            {
              "name": "fix-deprecated-controls",
              "sourceUrl": "https://github.com/UI5/plugins-coding-agents/blob/2b8c4a944e39609214bce7aef3b05260985f0e91/plugins/ui5-modernization/skills/fix-deprecated-controls/SKILL.md"
            },
            {
              "name": "fix-fiori-elements-extensions",
              "sourceUrl": "https://github.com/UI5/plugins-coding-agents/blob/2b8c4a944e39609214bce7aef3b05260985f0e91/plugins/ui5-modernization/skills/fix-fiori-elements-extensions/SKILL.md"
            },
            {
              "name": "fix-js-globals",
              "sourceUrl": "https://github.com/UI5/plugins-coding-agents/blob/2b8c4a944e39609214bce7aef3b05260985f0e91/plugins/ui5-modernization/skills/fix-js-globals/SKILL.md"
            },
            {
              "name": "fix-library-init",
              "sourceUrl": "https://github.com/UI5/plugins-coding-agents/blob/2b8c4a944e39609214bce7aef3b05260985f0e91/plugins/ui5-modernization/skills/fix-library-init/SKILL.md"
            },
            {
              "name": "fix-linter-blind-spots",
              "sourceUrl": "https://github.com/UI5/plugins-coding-agents/blob/2b8c4a944e39609214bce7aef3b05260985f0e91/plugins/ui5-modernization/skills/fix-linter-blind-spots/SKILL.md"
            },
            {
              "name": "fix-manifest-json",
              "sourceUrl": "https://github.com/UI5/plugins-coding-agents/blob/2b8c4a944e39609214bce7aef3b05260985f0e91/plugins/ui5-modernization/skills/fix-manifest-json/SKILL.md"
            },
            {
              "name": "fix-partially-deprecated-apis",
              "sourceUrl": "https://github.com/UI5/plugins-coding-agents/blob/2b8c4a944e39609214bce7aef3b05260985f0e91/plugins/ui5-modernization/skills/fix-partially-deprecated-apis/SKILL.md"
            },
            {
              "name": "fix-pseudo-modules",
              "sourceUrl": "https://github.com/UI5/plugins-coding-agents/blob/2b8c4a944e39609214bce7aef3b05260985f0e91/plugins/ui5-modernization/skills/fix-pseudo-modules/SKILL.md"
            },
            {
              "name": "fix-table-row-mode",
              "sourceUrl": "https://github.com/UI5/plugins-coding-agents/blob/2b8c4a944e39609214bce7aef3b05260985f0e91/plugins/ui5-modernization/skills/fix-table-row-mode/SKILL.md"
            },
            {
              "name": "fix-xml-globals",
              "sourceUrl": "https://github.com/UI5/plugins-coding-agents/blob/2b8c4a944e39609214bce7aef3b05260985f0e91/plugins/ui5-modernization/skills/fix-xml-globals/SKILL.md"
            },
            {
              "name": "fix-xml-native-html",
              "sourceUrl": "https://github.com/UI5/plugins-coding-agents/blob/2b8c4a944e39609214bce7aef3b05260985f0e91/plugins/ui5-modernization/skills/fix-xml-native-html/SKILL.md"
            },
            {
              "name": "modernize-flp-sandbox",
              "sourceUrl": "https://github.com/UI5/plugins-coding-agents/blob/2b8c4a944e39609214bce7aef3b05260985f0e91/plugins/ui5-modernization/skills/modernize-flp-sandbox/SKILL.md"
            },
            {
              "name": "modernize-test-starter",
              "sourceUrl": "https://github.com/UI5/plugins-coding-agents/blob/2b8c4a944e39609214bce7aef3b05260985f0e91/plugins/ui5-modernization/skills/modernize-test-starter/SKILL.md"
            },
            {
              "name": "modernize-ui5-app",
              "sourceUrl": "https://github.com/UI5/plugins-coding-agents/blob/2b8c4a944e39609214bce7aef3b05260985f0e91/plugins/ui5-modernization/skills/modernize-ui5-app/SKILL.md"
            }
          ],
          "mcpServers": [
            {
              "requiresConfiguration": false,
              "name": "chrome-devtools",
              "transport": "stdio",
              "endpoint": null
            }
          ],
          "components": ["skills", "mcp"],
          "componentInspection": "repository",
          "inspectionError": null,
          "installation": "requires_adapter",
          "upstream": {
            "source": {
              "source": "git-subdir",
              "url": "https://github.com/UI5/plugins-coding-agents.git",
              "path": "plugins/ui5-modernization",
              "ref": "main",
              "sha": "2b8c4a944e39609214bce7aef3b05260985f0e91"
            },
            "policy": null
          }
        },
        {
          "id": "anthropic:ui5-typescript-conversion",
          "name": "ui5-typescript-conversion",
          "displayName": "ui5-typescript-conversion",
          "description": "SAPUI5 / OpenUI5 plugin for coding agents. Convert JavaScript based UI5 projects to TypeScript.",
          "longDescription": "SAPUI5 / OpenUI5 plugin for coding agents. Convert JavaScript based UI5 projects to TypeScript.",
          "category": "development",
          "keywords": [],
          "author": {
            "name": "SAP SE",
            "email": "openui5@sap.com",
            "url": "https://www.sap.com"
          },
          "version": null,
          "license": null,
          "logoUrl": null,
          "darkLogoUrl": null,
          "homepage": "https://github.com/UI5/plugins-coding-agents",
          "sourceUrl": "https://github.com/UI5/plugins-coding-agents/tree/2b8c4a944e39609214bce7aef3b05260985f0e91/plugins/ui5-typescript-conversion",
          "skills": [
            {
              "name": "ui5-typescript-conversion",
              "sourceUrl": "https://github.com/UI5/plugins-coding-agents/blob/2b8c4a944e39609214bce7aef3b05260985f0e91/plugins/ui5-typescript-conversion/skills/ui5-typescript-conversion/SKILL.md"
            }
          ],
          "mcpServers": [],
          "components": ["skills", "mcp"],
          "componentInspection": "repository",
          "inspectionError": null,
          "installation": "requires_adapter",
          "upstream": {
            "source": {
              "source": "git-subdir",
              "url": "https://github.com/UI5/plugins-coding-agents.git",
              "path": "plugins/ui5-typescript-conversion",
              "ref": "main",
              "sha": "2b8c4a944e39609214bce7aef3b05260985f0e91"
            },
            "policy": null
          }
        },
        {
          "id": "anthropic:unity",
          "name": "unity",
          "displayName": "unity",
          "description": "Unity's official plugin for coding agents, with curated skills for game development, monetization, and performance optimization.",
          "longDescription": "Unity's official plugin for coding agents, with curated skills for game development, monetization, and performance optimization.",
          "category": "development",
          "keywords": [
            "unity",
            "gamedev",
            "game-development",
            "ui-toolkit",
            "ugui",
            "2d",
            "tilemap",
            "in-app-purchases",
            "monetization",
            "localization",
            "multiplayer",
            "shader-graph"
          ],
          "author": {
            "name": "Unity Technologies",
            "url": "https://unity.com"
          },
          "version": "0.1.2-beta",
          "license": "LicenseRef-Unity-Companion-License",
          "logoUrl": null,
          "darkLogoUrl": null,
          "homepage": "https://unity.com",
          "sourceUrl": "https://github.com/Unity-Technologies/unity-agent-plugin/tree/1aefde12b046a37b735a856d228eb6d427e3d31e/",
          "skills": [
            {
              "name": "2d-pixel-perfect",
              "sourceUrl": "https://github.com/Unity-Technologies/unity-agent-plugin/blob/1aefde12b046a37b735a856d228eb6d427e3d31e/skills/2d-pixel-perfect/SKILL.md"
            },
            {
              "name": "audio-setup-mixers",
              "sourceUrl": "https://github.com/Unity-Technologies/unity-agent-plugin/blob/1aefde12b046a37b735a856d228eb6d427e3d31e/skills/audio-setup-mixers/SKILL.md"
            },
            {
              "name": "build-live-game",
              "sourceUrl": "https://github.com/Unity-Technologies/unity-agent-plugin/blob/1aefde12b046a37b735a856d228eb6d427e3d31e/skills/build-live-game/SKILL.md"
            },
            {
              "name": "implement-in-app-purchases",
              "sourceUrl": "https://github.com/Unity-Technologies/unity-agent-plugin/blob/1aefde12b046a37b735a856d228eb6d427e3d31e/skills/implement-in-app-purchases/SKILL.md"
            },
            {
              "name": "initialize-ai-navigation",
              "sourceUrl": "https://github.com/Unity-Technologies/unity-agent-plugin/blob/1aefde12b046a37b735a856d228eb6d427e3d31e/skills/initialize-ai-navigation/SKILL.md"
            },
            {
              "name": "levelplay-unity-integration",
              "sourceUrl": "https://github.com/Unity-Technologies/unity-agent-plugin/blob/1aefde12b046a37b735a856d228eb6d427e3d31e/skills/levelplay-unity-integration/SKILL.md"
            },
            {
              "name": "localization",
              "sourceUrl": "https://github.com/Unity-Technologies/unity-agent-plugin/blob/1aefde12b046a37b735a856d228eb6d427e3d31e/skills/localization/SKILL.md"
            },
            {
              "name": "manage-sprite-atlas",
              "sourceUrl": "https://github.com/Unity-Technologies/unity-agent-plugin/blob/1aefde12b046a37b735a856d228eb6d427e3d31e/skills/manage-sprite-atlas/SKILL.md"
            },
            {
              "name": "new-unity-project",
              "sourceUrl": "https://github.com/Unity-Technologies/unity-agent-plugin/blob/1aefde12b046a37b735a856d228eb6d427e3d31e/skills/new-unity-project/SKILL.md"
            },
            {
              "name": "optimize-audio",
              "sourceUrl": "https://github.com/Unity-Technologies/unity-agent-plugin/blob/1aefde12b046a37b735a856d228eb6d427e3d31e/skills/optimize-audio/SKILL.md"
            },
            {
              "name": "optimize-text-mesh-pro",
              "sourceUrl": "https://github.com/Unity-Technologies/unity-agent-plugin/blob/1aefde12b046a37b735a856d228eb6d427e3d31e/skills/optimize-text-mesh-pro/SKILL.md"
            },
            {
              "name": "optimize-web",
              "sourceUrl": "https://github.com/Unity-Technologies/unity-agent-plugin/blob/1aefde12b046a37b735a856d228eb6d427e3d31e/skills/optimize-web/SKILL.md"
            },
            {
              "name": "physics-3d-collision",
              "sourceUrl": "https://github.com/Unity-Technologies/unity-agent-plugin/blob/1aefde12b046a37b735a856d228eb6d427e3d31e/skills/physics-3d-collision/SKILL.md"
            },
            {
              "name": "setup-multiplayer-services",
              "sourceUrl": "https://github.com/Unity-Technologies/unity-agent-plugin/blob/1aefde12b046a37b735a856d228eb6d427e3d31e/skills/setup-multiplayer-services/SKILL.md"
            },
            {
              "name": "setup-vivox-voice-chat",
              "sourceUrl": "https://github.com/Unity-Technologies/unity-agent-plugin/blob/1aefde12b046a37b735a856d228eb6d427e3d31e/skills/setup-vivox-voice-chat/SKILL.md"
            },
            {
              "name": "shader-graph-create-custom-node",
              "sourceUrl": "https://github.com/Unity-Technologies/unity-agent-plugin/blob/1aefde12b046a37b735a856d228eb6d427e3d31e/skills/shader-graph-create-custom-node/SKILL.md"
            },
            {
              "name": "sprite-editor",
              "sourceUrl": "https://github.com/Unity-Technologies/unity-agent-plugin/blob/1aefde12b046a37b735a856d228eb6d427e3d31e/skills/sprite-editor/SKILL.md"
            },
            {
              "name": "sprite-segment-3x3grid",
              "sourceUrl": "https://github.com/Unity-Technologies/unity-agent-plugin/blob/1aefde12b046a37b735a856d228eb6d427e3d31e/skills/sprite-segment-3x3grid/SKILL.md"
            },
            {
              "name": "tilemap-palette-create",
              "sourceUrl": "https://github.com/Unity-Technologies/unity-agent-plugin/blob/1aefde12b046a37b735a856d228eb6d427e3d31e/skills/tilemap-palette-create/SKILL.md"
            },
            {
              "name": "tilemap-ruletile-createempty",
              "sourceUrl": "https://github.com/Unity-Technologies/unity-agent-plugin/blob/1aefde12b046a37b735a856d228eb6d427e3d31e/skills/tilemap-ruletile-createempty/SKILL.md"
            },
            {
              "name": "tilemap-ruletile-createfromsegment",
              "sourceUrl": "https://github.com/Unity-Technologies/unity-agent-plugin/blob/1aefde12b046a37b735a856d228eb6d427e3d31e/skills/tilemap-ruletile-createfromsegment/SKILL.md"
            },
            {
              "name": "ui-imgui",
              "sourceUrl": "https://github.com/Unity-Technologies/unity-agent-plugin/blob/1aefde12b046a37b735a856d228eb6d427e3d31e/skills/ui-imgui/SKILL.md"
            },
            {
              "name": "ui-ugui",
              "sourceUrl": "https://github.com/Unity-Technologies/unity-agent-plugin/blob/1aefde12b046a37b735a856d228eb6d427e3d31e/skills/ui-ugui/SKILL.md"
            },
            {
              "name": "ui-uitk",
              "sourceUrl": "https://github.com/Unity-Technologies/unity-agent-plugin/blob/1aefde12b046a37b735a856d228eb6d427e3d31e/skills/ui-uitk/SKILL.md"
            },
            {
              "name": "ui",
              "sourceUrl": "https://github.com/Unity-Technologies/unity-agent-plugin/blob/1aefde12b046a37b735a856d228eb6d427e3d31e/skills/ui/SKILL.md"
            },
            {
              "name": "unity-cli",
              "sourceUrl": "https://github.com/Unity-Technologies/unity-agent-plugin/blob/1aefde12b046a37b735a856d228eb6d427e3d31e/skills/unity-cli/SKILL.md"
            },
            {
              "name": "unity-package-management",
              "sourceUrl": "https://github.com/Unity-Technologies/unity-agent-plugin/blob/1aefde12b046a37b735a856d228eb6d427e3d31e/skills/unity-package-management/SKILL.md"
            },
            {
              "name": "urp-postprocessing",
              "sourceUrl": "https://github.com/Unity-Technologies/unity-agent-plugin/blob/1aefde12b046a37b735a856d228eb6d427e3d31e/skills/urp-postprocessing/SKILL.md"
            },
            {
              "name": "validate-urp-render-graph-renderer-feature",
              "sourceUrl": "https://github.com/Unity-Technologies/unity-agent-plugin/blob/1aefde12b046a37b735a856d228eb6d427e3d31e/skills/validate-urp-render-graph-renderer-feature/SKILL.md"
            }
          ],
          "mcpServers": [],
          "components": ["skills"],
          "componentInspection": "repository",
          "inspectionError": null,
          "installation": "requires_adapter",
          "upstream": {
            "source": {
              "source": "url",
              "url": "https://github.com/Unity-Technologies/unity-agent-plugin.git",
              "sha": "1aefde12b046a37b735a856d228eb6d427e3d31e"
            },
            "policy": null
          }
        },
        {
          "id": "anthropic:unreal-engine-skills-for-claude-code",
          "name": "unreal-engine-skills-for-claude-code",
          "displayName": "unreal-engine-skills-for-claude-code",
          "description": "Control Unreal Editor directly from Claude Code via MCP. Hundreds of tools exposed via Unreal's ToolsetRegistry across 30+ toolsets: actors, blueprints, materials, Niagara, Control Rigs, Sequencer, State Trees, widgets, Gameplay Ability System, automation testing, and more.",
          "longDescription": "Control Unreal Editor directly from Claude Code via MCP. Hundreds of tools exposed via Unreal's ToolsetRegistry across 30+ toolsets: actors, blueprints, materials, Niagara, Control Rigs, Sequencer, State Trees, widgets, Gameplay Ability System, automation testing, and more.",
          "category": "development",
          "keywords": [],
          "author": {
            "name": "Thomas Mansencal",
            "email": "thomas.mansencal@epicgames.com"
          },
          "version": "3.0.4",
          "license": "MIT",
          "logoUrl": null,
          "darkLogoUrl": null,
          "homepage": "https://dev.epicgames.com/documentation/unreal-engine/unreal-mcp-in-unreal-editor",
          "sourceUrl": "https://github.com/EpicGames/unreal-engine-skills-for-claude-code-plugin/tree/7e3b09bbf6d2984c155233f9d3de5fcf523d2d42/",
          "skills": [
            {
              "name": "create-toolset",
              "sourceUrl": "https://github.com/EpicGames/unreal-engine-skills-for-claude-code-plugin/blob/7e3b09bbf6d2984c155233f9d3de5fcf523d2d42/skills/create-toolset/SKILL.md"
            },
            {
              "name": "unreal-mcp",
              "sourceUrl": "https://github.com/EpicGames/unreal-engine-skills-for-claude-code-plugin/blob/7e3b09bbf6d2984c155233f9d3de5fcf523d2d42/skills/unreal-mcp/SKILL.md"
            },
            {
              "name": "unreal-skill",
              "sourceUrl": "https://github.com/EpicGames/unreal-engine-skills-for-claude-code-plugin/blob/7e3b09bbf6d2984c155233f9d3de5fcf523d2d42/skills/unreal-skill/SKILL.md"
            }
          ],
          "mcpServers": [],
          "components": ["skills", "hooks"],
          "componentInspection": "repository",
          "inspectionError": null,
          "installation": "requires_adapter",
          "upstream": {
            "source": {
              "source": "url",
              "url": "https://github.com/EpicGames/unreal-engine-skills-for-claude-code-plugin.git",
              "sha": "7e3b09bbf6d2984c155233f9d3de5fcf523d2d42"
            },
            "policy": null
          }
        },
        {
          "id": "anthropic:valtown",
          "name": "valtown",
          "displayName": "valtown",
          "description": "Build and deploy on Val Town. Bundles the Val Town MCP server and platform skills (HTTP vals, cron/intervals, SQLite, email, OAuth, React UI, third-party integrations).",
          "longDescription": "Build and deploy on Val Town. Bundles the Val Town MCP server and platform skills (HTTP vals, cron/intervals, SQLite, email, OAuth, React UI, third-party integrations).",
          "category": "deployment",
          "keywords": ["val-town", "deno", "serverless", "typescript"],
          "author": {
            "name": "Val Town"
          },
          "version": "0.4.0",
          "license": "MIT",
          "logoUrl": null,
          "darkLogoUrl": null,
          "homepage": "https://val.town",
          "sourceUrl": "https://github.com/val-town/plugins/tree/2d3ec654b6a7d93e209afb8f2e8848eddcb9f17b/plugin",
          "skills": [
            {
              "name": "blob-storage",
              "sourceUrl": "https://github.com/val-town/plugins/blob/2d3ec654b6a7d93e209afb8f2e8848eddcb9f17b/plugin/skills/blob-storage/SKILL.md"
            },
            {
              "name": "client-side-js",
              "sourceUrl": "https://github.com/val-town/plugins/blob/2d3ec654b6a7d93e209afb8f2e8848eddcb9f17b/plugin/skills/client-side-js/SKILL.md"
            },
            {
              "name": "create-skill",
              "sourceUrl": "https://github.com/val-town/plugins/blob/2d3ec654b6a7d93e209afb8f2e8848eddcb9f17b/plugin/skills/create-skill/SKILL.md"
            },
            {
              "name": "cron-and-intervals",
              "sourceUrl": "https://github.com/val-town/plugins/blob/2d3ec654b6a7d93e209afb8f2e8848eddcb9f17b/plugin/skills/cron-and-intervals/SKILL.md"
            },
            {
              "name": "email",
              "sourceUrl": "https://github.com/val-town/plugins/blob/2d3ec654b6a7d93e209afb8f2e8848eddcb9f17b/plugin/skills/email/SKILL.md"
            },
            {
              "name": "http-endpoints",
              "sourceUrl": "https://github.com/val-town/plugins/blob/2d3ec654b6a7d93e209afb8f2e8848eddcb9f17b/plugin/skills/http-endpoints/SKILL.md"
            },
            {
              "name": "oauth",
              "sourceUrl": "https://github.com/val-town/plugins/blob/2d3ec654b6a7d93e209afb8f2e8848eddcb9f17b/plugin/skills/oauth/SKILL.md"
            },
            {
              "name": "react-ui",
              "sourceUrl": "https://github.com/val-town/plugins/blob/2d3ec654b6a7d93e209afb8f2e8848eddcb9f17b/plugin/skills/react-ui/SKILL.md"
            },
            {
              "name": "restricted-access",
              "sourceUrl": "https://github.com/val-town/plugins/blob/2d3ec654b6a7d93e209afb8f2e8848eddcb9f17b/plugin/skills/restricted-access/SKILL.md"
            },
            {
              "name": "sqlite-storage",
              "sourceUrl": "https://github.com/val-town/plugins/blob/2d3ec654b6a7d93e209afb8f2e8848eddcb9f17b/plugin/skills/sqlite-storage/SKILL.md"
            },
            {
              "name": "third-party-integrations",
              "sourceUrl": "https://github.com/val-town/plugins/blob/2d3ec654b6a7d93e209afb8f2e8848eddcb9f17b/plugin/skills/third-party-integrations/SKILL.md"
            }
          ],
          "mcpServers": [
            {
              "requiresConfiguration": false,
              "name": "valtown",
              "transport": "http",
              "endpoint": "https://api.val.town/v3/mcp"
            }
          ],
          "components": ["skills", "mcp"],
          "componentInspection": "repository",
          "inspectionError": null,
          "installation": "requires_adapter",
          "upstream": {
            "source": {
              "source": "git-subdir",
              "url": "https://github.com/val-town/plugins.git",
              "path": "plugin",
              "ref": "main",
              "sha": "2d3ec654b6a7d93e209afb8f2e8848eddcb9f17b"
            },
            "policy": null
          }
        },
        {
          "id": "anthropic:vanta",
          "name": "vanta",
          "displayName": "vanta",
          "description": "Vanta MCP server integration for Claude Code",
          "longDescription": "Vanta MCP server integration for Claude Code",
          "category": "security",
          "keywords": ["vanta", "security", "compliance", "mcp", "grc", "risk"],
          "author": {
            "name": "Vanta",
            "url": "https://www.vanta.com"
          },
          "version": "1.0.0",
          "license": "MIT",
          "logoUrl": null,
          "darkLogoUrl": null,
          "homepage": "https://github.com/VantaInc/vanta-mcp-plugin",
          "sourceUrl": "https://github.com/VantaInc/vanta-mcp-plugin/tree/345d86b55faa649e955b7ea5569cf52d8425c2d5/",
          "skills": [
            {
              "name": "fix-test",
              "sourceUrl": "https://github.com/VantaInc/vanta-mcp-plugin/blob/345d86b55faa649e955b7ea5569cf52d8425c2d5/skills/fix-test/SKILL.md"
            },
            {
              "name": "list-tests",
              "sourceUrl": "https://github.com/VantaInc/vanta-mcp-plugin/blob/345d86b55faa649e955b7ea5569cf52d8425c2d5/skills/list-tests/SKILL.md"
            },
            {
              "name": "test-remediation",
              "sourceUrl": "https://github.com/VantaInc/vanta-mcp-plugin/blob/345d86b55faa649e955b7ea5569cf52d8425c2d5/skills/test-remediation/SKILL.md"
            }
          ],
          "mcpServers": [
            {
              "requiresConfiguration": false,
              "name": "vanta-us",
              "transport": "http",
              "endpoint": "https://mcp.vanta.com/mcp"
            },
            {
              "requiresConfiguration": false,
              "name": "vanta-eu",
              "transport": "http",
              "endpoint": "https://mcp.eu.vanta.com/mcp"
            },
            {
              "requiresConfiguration": false,
              "name": "vanta-aus",
              "transport": "http",
              "endpoint": "https://mcp.aus.vanta.com/mcp"
            }
          ],
          "components": ["skills", "mcp"],
          "componentInspection": "repository",
          "inspectionError": null,
          "installation": "requires_adapter",
          "upstream": {
            "source": {
              "source": "url",
              "url": "https://github.com/VantaInc/vanta-mcp-plugin.git",
              "sha": "345d86b55faa649e955b7ea5569cf52d8425c2d5"
            },
            "policy": null
          }
        },
        {
          "id": "anthropic:vanta-mcp-plugin",
          "name": "vanta-mcp-plugin",
          "displayName": "vanta",
          "description": "Vanta MCP server integration for Claude Code",
          "longDescription": "Vanta MCP server integration for Claude Code",
          "category": "security",
          "keywords": ["vanta", "security", "compliance", "mcp", "grc", "risk"],
          "author": {
            "name": "Vanta",
            "url": "https://www.vanta.com"
          },
          "version": "1.0.0",
          "license": "MIT",
          "logoUrl": null,
          "darkLogoUrl": null,
          "homepage": "https://github.com/VantaInc/vanta-mcp-plugin",
          "sourceUrl": "https://github.com/VantaInc/vanta-mcp-plugin/tree/345d86b55faa649e955b7ea5569cf52d8425c2d5/",
          "skills": [
            {
              "name": "fix-test",
              "sourceUrl": "https://github.com/VantaInc/vanta-mcp-plugin/blob/345d86b55faa649e955b7ea5569cf52d8425c2d5/skills/fix-test/SKILL.md"
            },
            {
              "name": "list-tests",
              "sourceUrl": "https://github.com/VantaInc/vanta-mcp-plugin/blob/345d86b55faa649e955b7ea5569cf52d8425c2d5/skills/list-tests/SKILL.md"
            },
            {
              "name": "test-remediation",
              "sourceUrl": "https://github.com/VantaInc/vanta-mcp-plugin/blob/345d86b55faa649e955b7ea5569cf52d8425c2d5/skills/test-remediation/SKILL.md"
            }
          ],
          "mcpServers": [
            {
              "requiresConfiguration": false,
              "name": "vanta-us",
              "transport": "http",
              "endpoint": "https://mcp.vanta.com/mcp"
            },
            {
              "requiresConfiguration": false,
              "name": "vanta-eu",
              "transport": "http",
              "endpoint": "https://mcp.eu.vanta.com/mcp"
            },
            {
              "requiresConfiguration": false,
              "name": "vanta-aus",
              "transport": "http",
              "endpoint": "https://mcp.aus.vanta.com/mcp"
            }
          ],
          "components": ["skills", "mcp"],
          "componentInspection": "repository",
          "inspectionError": null,
          "installation": "requires_adapter",
          "upstream": {
            "source": {
              "source": "url",
              "url": "https://github.com/VantaInc/vanta-mcp-plugin.git",
              "sha": "345d86b55faa649e955b7ea5569cf52d8425c2d5"
            },
            "policy": null
          }
        },
        {
          "id": "anthropic:vercel",
          "name": "vercel",
          "displayName": "vercel",
          "description": "Build and deploy web apps and agents",
          "longDescription": "Build and deploy web apps and agents",
          "category": "deployment",
          "keywords": [
            "vercel",
            "nextjs",
            "ai-sdk",
            "turborepo",
            "turbopack",
            "workflow",
            "deployment",
            "serverless"
          ],
          "author": {
            "name": "Vercel",
            "url": "https://github.com/vercel"
          },
          "version": "0.48.0",
          "license": "Apache-2.0",
          "logoUrl": null,
          "darkLogoUrl": null,
          "homepage": "https://github.com/vercel/vercel-plugin",
          "sourceUrl": "https://github.com/vercel/vercel-plugin/tree/11c32588786a9d49791372657433b88d49561874/",
          "skills": [
            {
              "name": "benchmark-agents",
              "sourceUrl": "https://github.com/vercel/vercel-plugin/blob/11c32588786a9d49791372657433b88d49561874/.claude/skills/benchmark-agents/SKILL.md"
            },
            {
              "name": "benchmark-e2e",
              "sourceUrl": "https://github.com/vercel/vercel-plugin/blob/11c32588786a9d49791372657433b88d49561874/.claude/skills/benchmark-e2e/SKILL.md"
            },
            {
              "name": "benchmark-sandbox",
              "sourceUrl": "https://github.com/vercel/vercel-plugin/blob/11c32588786a9d49791372657433b88d49561874/.claude/skills/benchmark-sandbox/SKILL.md"
            },
            {
              "name": "benchmark-testing",
              "sourceUrl": "https://github.com/vercel/vercel-plugin/blob/11c32588786a9d49791372657433b88d49561874/.claude/skills/benchmark-testing/SKILL.md"
            },
            {
              "name": "plugin-audit",
              "sourceUrl": "https://github.com/vercel/vercel-plugin/blob/11c32588786a9d49791372657433b88d49561874/.claude/skills/plugin-audit/SKILL.md"
            },
            {
              "name": "release",
              "sourceUrl": "https://github.com/vercel/vercel-plugin/blob/11c32588786a9d49791372657433b88d49561874/.claude/skills/release/SKILL.md"
            },
            {
              "name": "vercel-plugin-eval",
              "sourceUrl": "https://github.com/vercel/vercel-plugin/blob/11c32588786a9d49791372657433b88d49561874/.claude/skills/vercel-plugin-eval/SKILL.md"
            },
            {
              "name": "access-protected-vercel-deployment",
              "sourceUrl": "https://github.com/vercel/vercel-plugin/blob/11c32588786a9d49791372657433b88d49561874/skills/access-protected-vercel-deployment/SKILL.md"
            },
            {
              "name": "ai-gateway",
              "sourceUrl": "https://github.com/vercel/vercel-plugin/blob/11c32588786a9d49791372657433b88d49561874/skills/ai-gateway/SKILL.md"
            },
            {
              "name": "ai-sdk",
              "sourceUrl": "https://github.com/vercel/vercel-plugin/blob/11c32588786a9d49791372657433b88d49561874/skills/ai-sdk/SKILL.md"
            },
            {
              "name": "upstream",
              "sourceUrl": "https://github.com/vercel/vercel-plugin/blob/11c32588786a9d49791372657433b88d49561874/skills/ai-sdk/upstream/SKILL.md"
            },
            {
              "name": "auth",
              "sourceUrl": "https://github.com/vercel/vercel-plugin/blob/11c32588786a9d49791372657433b88d49561874/skills/auth/SKILL.md"
            },
            {
              "name": "bootstrap",
              "sourceUrl": "https://github.com/vercel/vercel-plugin/blob/11c32588786a9d49791372657433b88d49561874/skills/bootstrap/SKILL.md"
            },
            {
              "name": "build-agents",
              "sourceUrl": "https://github.com/vercel/vercel-plugin/blob/11c32588786a9d49791372657433b88d49561874/skills/build-agents/SKILL.md"
            },
            {
              "name": "cdn-caching",
              "sourceUrl": "https://github.com/vercel/vercel-plugin/blob/11c32588786a9d49791372657433b88d49561874/skills/cdn-caching/SKILL.md"
            },
            {
              "name": "chat-sdk",
              "sourceUrl": "https://github.com/vercel/vercel-plugin/blob/11c32588786a9d49791372657433b88d49561874/skills/chat-sdk/SKILL.md"
            },
            {
              "name": "upstream",
              "sourceUrl": "https://github.com/vercel/vercel-plugin/blob/11c32588786a9d49791372657433b88d49561874/skills/chat-sdk/upstream/SKILL.md"
            },
            {
              "name": "deployments-cicd",
              "sourceUrl": "https://github.com/vercel/vercel-plugin/blob/11c32588786a9d49791372657433b88d49561874/skills/deployments-cicd/SKILL.md"
            },
            {
              "name": "env-vars",
              "sourceUrl": "https://github.com/vercel/vercel-plugin/blob/11c32588786a9d49791372657433b88d49561874/skills/env-vars/SKILL.md"
            },
            {
              "name": "eve",
              "sourceUrl": "https://github.com/vercel/vercel-plugin/blob/11c32588786a9d49791372657433b88d49561874/skills/eve/SKILL.md"
            },
            {
              "name": "upstream",
              "sourceUrl": "https://github.com/vercel/vercel-plugin/blob/11c32588786a9d49791372657433b88d49561874/skills/eve/upstream/SKILL.md"
            },
            {
              "name": "knowledge-update",
              "sourceUrl": "https://github.com/vercel/vercel-plugin/blob/11c32588786a9d49791372657433b88d49561874/skills/knowledge-update/SKILL.md"
            },
            {
              "name": "marketplace",
              "sourceUrl": "https://github.com/vercel/vercel-plugin/blob/11c32588786a9d49791372657433b88d49561874/skills/marketplace/SKILL.md"
            },
            {
              "name": "microfrontends",
              "sourceUrl": "https://github.com/vercel/vercel-plugin/blob/11c32588786a9d49791372657433b88d49561874/skills/microfrontends/SKILL.md"
            },
            {
              "name": "next-cache-components",
              "sourceUrl": "https://github.com/vercel/vercel-plugin/blob/11c32588786a9d49791372657433b88d49561874/skills/next-cache-components/SKILL.md"
            },
            {
              "name": "upstream",
              "sourceUrl": "https://github.com/vercel/vercel-plugin/blob/11c32588786a9d49791372657433b88d49561874/skills/next-cache-components/upstream/SKILL.md"
            },
            {
              "name": "next-forge",
              "sourceUrl": "https://github.com/vercel/vercel-plugin/blob/11c32588786a9d49791372657433b88d49561874/skills/next-forge/SKILL.md"
            },
            {
              "name": "upstream",
              "sourceUrl": "https://github.com/vercel/vercel-plugin/blob/11c32588786a9d49791372657433b88d49561874/skills/next-forge/upstream/SKILL.md"
            },
            {
              "name": "next-upgrade",
              "sourceUrl": "https://github.com/vercel/vercel-plugin/blob/11c32588786a9d49791372657433b88d49561874/skills/next-upgrade/SKILL.md"
            },
            {
              "name": "upstream",
              "sourceUrl": "https://github.com/vercel/vercel-plugin/blob/11c32588786a9d49791372657433b88d49561874/skills/next-upgrade/upstream/SKILL.md"
            },
            {
              "name": "nextjs",
              "sourceUrl": "https://github.com/vercel/vercel-plugin/blob/11c32588786a9d49791372657433b88d49561874/skills/nextjs/SKILL.md"
            },
            {
              "name": "upstream",
              "sourceUrl": "https://github.com/vercel/vercel-plugin/blob/11c32588786a9d49791372657433b88d49561874/skills/nextjs/upstream/SKILL.md"
            },
            {
              "name": "react-best-practices",
              "sourceUrl": "https://github.com/vercel/vercel-plugin/blob/11c32588786a9d49791372657433b88d49561874/skills/react-best-practices/SKILL.md"
            },
            {
              "name": "upstream",
              "sourceUrl": "https://github.com/vercel/vercel-plugin/blob/11c32588786a9d49791372657433b88d49561874/skills/react-best-practices/upstream/SKILL.md"
            },
            {
              "name": "routing-middleware",
              "sourceUrl": "https://github.com/vercel/vercel-plugin/blob/11c32588786a9d49791372657433b88d49561874/skills/routing-middleware/SKILL.md"
            },
            {
              "name": "runtime-cache",
              "sourceUrl": "https://github.com/vercel/vercel-plugin/blob/11c32588786a9d49791372657433b88d49561874/skills/runtime-cache/SKILL.md"
            },
            {
              "name": "shadcn",
              "sourceUrl": "https://github.com/vercel/vercel-plugin/blob/11c32588786a9d49791372657433b88d49561874/skills/shadcn/SKILL.md"
            },
            {
              "name": "turbopack",
              "sourceUrl": "https://github.com/vercel/vercel-plugin/blob/11c32588786a9d49791372657433b88d49561874/skills/turbopack/SKILL.md"
            },
            {
              "name": "vercel-agent",
              "sourceUrl": "https://github.com/vercel/vercel-plugin/blob/11c32588786a9d49791372657433b88d49561874/skills/vercel-agent/SKILL.md"
            },
            {
              "name": "vercel-cli",
              "sourceUrl": "https://github.com/vercel/vercel-plugin/blob/11c32588786a9d49791372657433b88d49561874/skills/vercel-cli/SKILL.md"
            },
            {
              "name": "upstream",
              "sourceUrl": "https://github.com/vercel/vercel-plugin/blob/11c32588786a9d49791372657433b88d49561874/skills/vercel-cli/upstream/SKILL.md"
            },
            {
              "name": "vercel-connect",
              "sourceUrl": "https://github.com/vercel/vercel-plugin/blob/11c32588786a9d49791372657433b88d49561874/skills/vercel-connect/SKILL.md"
            },
            {
              "name": "vercel-firewall",
              "sourceUrl": "https://github.com/vercel/vercel-plugin/blob/11c32588786a9d49791372657433b88d49561874/skills/vercel-firewall/SKILL.md"
            },
            {
              "name": "vercel-functions",
              "sourceUrl": "https://github.com/vercel/vercel-plugin/blob/11c32588786a9d49791372657433b88d49561874/skills/vercel-functions/SKILL.md"
            },
            {
              "name": "vercel-sandbox",
              "sourceUrl": "https://github.com/vercel/vercel-plugin/blob/11c32588786a9d49791372657433b88d49561874/skills/vercel-sandbox/SKILL.md"
            },
            {
              "name": "upstream",
              "sourceUrl": "https://github.com/vercel/vercel-plugin/blob/11c32588786a9d49791372657433b88d49561874/skills/vercel-sandbox/upstream/SKILL.md"
            },
            {
              "name": "vercel-services",
              "sourceUrl": "https://github.com/vercel/vercel-plugin/blob/11c32588786a9d49791372657433b88d49561874/skills/vercel-services/SKILL.md"
            },
            {
              "name": "vercel-storage",
              "sourceUrl": "https://github.com/vercel/vercel-plugin/blob/11c32588786a9d49791372657433b88d49561874/skills/vercel-storage/SKILL.md"
            },
            {
              "name": "verification",
              "sourceUrl": "https://github.com/vercel/vercel-plugin/blob/11c32588786a9d49791372657433b88d49561874/skills/verification/SKILL.md"
            },
            {
              "name": "workflow",
              "sourceUrl": "https://github.com/vercel/vercel-plugin/blob/11c32588786a9d49791372657433b88d49561874/skills/workflow/SKILL.md"
            },
            {
              "name": "upstream",
              "sourceUrl": "https://github.com/vercel/vercel-plugin/blob/11c32588786a9d49791372657433b88d49561874/skills/workflow/upstream/SKILL.md"
            }
          ],
          "mcpServers": [
            {
              "requiresConfiguration": false,
              "name": "vercel",
              "transport": "http",
              "endpoint": "https://mcp.vercel.com"
            }
          ],
          "components": ["skills", "mcp", "hooks", "agents", "commands"],
          "componentInspection": "repository",
          "inspectionError": null,
          "installation": "requires_adapter",
          "upstream": {
            "source": {
              "source": "url",
              "url": "https://github.com/vercel/vercel-plugin.git",
              "sha": "11c32588786a9d49791372657433b88d49561874"
            },
            "policy": null
          }
        },
        {
          "id": "anthropic:vibe-prospecting",
          "name": "vibe-prospecting",
          "displayName": "Vibe Prospecting",
          "description": "B2B company and contact intelligence for prospecting workflows.",
          "longDescription": "Power your chat with live B2B data to create lead lists, research companies, enrich contacts, personalize outreach, and inspect business signals, technology stacks, events, and website changes.",
          "category": "Productivity",
          "keywords": [
            "b2b",
            "prospecting",
            "leads",
            "sales",
            "enrichment",
            "companies",
            "contacts"
          ],
          "author": {
            "name": "vibeprospecting.ai",
            "email": "support@vibeprospecting.ai",
            "url": "https://vibeprospecting.ai"
          },
          "version": "0.1.107",
          "license": "MIT",
          "logoUrl": null,
          "darkLogoUrl": null,
          "homepage": "https://vibeprospecting.ai",
          "sourceUrl": "https://github.com/explorium-ai/vibeprospecting-plugin/tree/9b4067473305dbba80be0fa9a492be39b96f455e/",
          "skills": [
            {
              "name": "vibe-prospecting",
              "sourceUrl": "https://github.com/explorium-ai/vibeprospecting-plugin/blob/9b4067473305dbba80be0fa9a492be39b96f455e/skills/vibe-prospecting/SKILL.md"
            }
          ],
          "mcpServers": [],
          "components": ["skills", "commands"],
          "componentInspection": "repository",
          "inspectionError": null,
          "installation": "requires_adapter",
          "upstream": {
            "source": {
              "source": "url",
              "url": "https://github.com/explorium-ai/vibeprospecting-plugin.git",
              "sha": "9b4067473305dbba80be0fa9a492be39b96f455e"
            },
            "policy": null
          }
        },
        {
          "id": "anthropic:vsql-extension-builder",
          "name": "vsql-extension-builder",
          "displayName": "villagesql",
          "description": "Skills for VillageSQL (MySQL with extensions): build extensions end-to-end (including porting PostgreSQL extensions to MySQL) and install VillageSQL Server.",
          "longDescription": "Skills for VillageSQL (MySQL with extensions): build extensions end-to-end (including porting PostgreSQL extensions to MySQL) and install VillageSQL Server.",
          "category": "database",
          "keywords": [],
          "author": {
            "name": "VillageSQL"
          },
          "version": null,
          "license": null,
          "logoUrl": null,
          "darkLogoUrl": null,
          "homepage": "https://villagesql.com",
          "sourceUrl": "https://github.com/villagesql/villagesql-skills/tree/0e49c28794596936b562a7cd169a8c3854ddc10f/",
          "skills": [
            {
              "name": "vsql-extension-builder",
              "sourceUrl": "https://github.com/villagesql/villagesql-skills/blob/0e49c28794596936b562a7cd169a8c3854ddc10f/skills/vsql-extension-builder/SKILL.md"
            },
            {
              "name": "vsql-install-server",
              "sourceUrl": "https://github.com/villagesql/villagesql-skills/blob/0e49c28794596936b562a7cd169a8c3854ddc10f/skills/vsql-install-server/SKILL.md"
            }
          ],
          "mcpServers": [],
          "components": ["skills"],
          "componentInspection": "repository",
          "inspectionError": null,
          "installation": "requires_adapter",
          "upstream": {
            "source": {
              "source": "url",
              "url": "https://github.com/villagesql/villagesql-skills.git",
              "sha": "0e49c28794596936b562a7cd169a8c3854ddc10f"
            },
            "policy": null
          }
        },
        {
          "id": "anthropic:windsor-ai",
          "name": "windsor-ai",
          "displayName": "windsor-ai",
          "description": "Connect Claude Code to 350+ business data sources via Windsor.ai. Query marketing, sales, CRM, ecommerce, finance, and analytics data from Google Ads, Meta, HubSpot, Salesforce, Shopify, Stripe, and hundreds more — directly from your terminal.",
          "longDescription": "Connect Claude Code to 350+ business data sources via Windsor.ai. Query marketing, sales, CRM, ecommerce, finance, and analytics data from Google Ads, Meta, HubSpot, Salesforce, Shopify, Stripe, and hundreds more — directly from your terminal.",
          "category": "productivity",
          "keywords": [
            "data",
            "analytics",
            "marketing",
            "sales",
            "crm",
            "ecommerce",
            "finance",
            "google-ads",
            "facebook-ads",
            "hubspot",
            "salesforce",
            "shopify",
            "stripe",
            "business-intelligence"
          ],
          "author": {
            "name": "Windsor.ai",
            "email": "support@windsor.ai",
            "url": "https://windsor.ai"
          },
          "version": "1.0.0",
          "license": "MIT",
          "logoUrl": null,
          "darkLogoUrl": null,
          "homepage": "https://windsor.ai",
          "sourceUrl": "https://github.com/windsor-ai/claude-windsor-ai-plugin/tree/d7ba1cb036c7ca765536355fb85f13a3237ea3f9/",
          "skills": [
            {
              "name": "business-data",
              "sourceUrl": "https://github.com/windsor-ai/claude-windsor-ai-plugin/blob/d7ba1cb036c7ca765536355fb85f13a3237ea3f9/skills/business-data/SKILL.md"
            }
          ],
          "mcpServers": [
            {
              "requiresConfiguration": false,
              "name": "windsor-ai",
              "transport": "url",
              "endpoint": "https://mcp.windsor.ai"
            }
          ],
          "components": ["skills", "mcp", "agents", "commands"],
          "componentInspection": "repository",
          "inspectionError": null,
          "installation": "requires_adapter",
          "upstream": {
            "source": {
              "source": "url",
              "url": "https://github.com/windsor-ai/claude-windsor-ai-plugin.git",
              "sha": "d7ba1cb036c7ca765536355fb85f13a3237ea3f9"
            },
            "policy": null
          }
        },
        {
          "id": "anthropic:wix",
          "name": "wix",
          "displayName": "wix",
          "description": "Build, manage, and deploy Wix sites and apps. Includes CLI development skills and Wix MCP server for site management, eCommerce, CMS, dashboard extensions, and more.",
          "longDescription": "Build, manage, and deploy Wix sites and apps. Includes CLI development skills and Wix MCP server for site management, eCommerce, CMS, dashboard extensions, and more.",
          "category": "development",
          "keywords": ["wix", "wix-cli", "wix-mcp", "ecommerce", "cms", "wix-apps"],
          "author": {
            "name": "Wix",
            "url": "https://dev.wix.com"
          },
          "version": "1.18.1",
          "license": "MIT",
          "logoUrl": null,
          "darkLogoUrl": null,
          "homepage": "https://dev.wix.com/docs/api-reference/articles/ai-tools/about-wix-skills",
          "sourceUrl": "https://github.com/wix/skills/tree/572357b791a91a5138c050e08eb718b150be21cb/",
          "skills": [
            {
              "name": "writing-great-skills",
              "sourceUrl": "https://github.com/wix/skills/blob/572357b791a91a5138c050e08eb718b150be21cb/.claude/skills/writing-great-skills/SKILL.md"
            },
            {
              "name": "wix-app",
              "sourceUrl": "https://github.com/wix/skills/blob/572357b791a91a5138c050e08eb718b150be21cb/skills/wix-app/SKILL.md"
            },
            {
              "name": "wix-auth",
              "sourceUrl": "https://github.com/wix/skills/blob/572357b791a91a5138c050e08eb718b150be21cb/skills/wix-auth/SKILL.md"
            },
            {
              "name": "wix-base44-connector",
              "sourceUrl": "https://github.com/wix/skills/blob/572357b791a91a5138c050e08eb718b150be21cb/skills/wix-base44-connector/SKILL.md"
            },
            {
              "name": "wix-design-system",
              "sourceUrl": "https://github.com/wix/skills/blob/572357b791a91a5138c050e08eb718b150be21cb/skills/wix-design-system/SKILL.md"
            },
            {
              "name": "wix-docs",
              "sourceUrl": "https://github.com/wix/skills/blob/572357b791a91a5138c050e08eb718b150be21cb/skills/wix-docs/SKILL.md"
            },
            {
              "name": "wix-headless-fast",
              "sourceUrl": "https://github.com/wix/skills/blob/572357b791a91a5138c050e08eb718b150be21cb/skills/wix-headless-fast/SKILL.md"
            },
            {
              "name": "wix-headless",
              "sourceUrl": "https://github.com/wix/skills/blob/572357b791a91a5138c050e08eb718b150be21cb/skills/wix-headless/SKILL.md"
            },
            {
              "name": "wix-manage",
              "sourceUrl": "https://github.com/wix/skills/blob/572357b791a91a5138c050e08eb718b150be21cb/skills/wix-manage/SKILL.md"
            },
            {
              "name": "wix-replatform",
              "sourceUrl": "https://github.com/wix/skills/blob/572357b791a91a5138c050e08eb718b150be21cb/skills/wix-replatform/SKILL.md"
            },
            {
              "name": "rp-discovery",
              "sourceUrl": "https://github.com/wix/skills/blob/572357b791a91a5138c050e08eb718b150be21cb/skills/wix-replatform/resources/rp-discovery/SKILL.md"
            },
            {
              "name": "rp-execute-import",
              "sourceUrl": "https://github.com/wix/skills/blob/572357b791a91a5138c050e08eb718b150be21cb/skills/wix-replatform/resources/rp-execute-import/SKILL.md"
            },
            {
              "name": "rp-execute-setup",
              "sourceUrl": "https://github.com/wix/skills/blob/572357b791a91a5138c050e08eb718b150be21cb/skills/wix-replatform/resources/rp-execute-setup/SKILL.md"
            },
            {
              "name": "rp-import-codegen",
              "sourceUrl": "https://github.com/wix/skills/blob/572357b791a91a5138c050e08eb718b150be21cb/skills/wix-replatform/resources/rp-import-codegen/SKILL.md"
            },
            {
              "name": "rp-mapper",
              "sourceUrl": "https://github.com/wix/skills/blob/572357b791a91a5138c050e08eb718b150be21cb/skills/wix-replatform/resources/rp-mapper/SKILL.md"
            },
            {
              "name": "rp-setup-discovery",
              "sourceUrl": "https://github.com/wix/skills/blob/572357b791a91a5138c050e08eb718b150be21cb/skills/wix-replatform/resources/rp-setup-discovery/SKILL.md"
            },
            {
              "name": "rp-source-csv",
              "sourceUrl": "https://github.com/wix/skills/blob/572357b791a91a5138c050e08eb718b150be21cb/skills/wix-replatform/resources/rp-source-csv/SKILL.md"
            },
            {
              "name": "rp-source-wordpress",
              "sourceUrl": "https://github.com/wix/skills/blob/572357b791a91a5138c050e08eb718b150be21cb/skills/wix-replatform/resources/rp-source-wordpress/SKILL.md"
            },
            {
              "name": "rp-target-wix",
              "sourceUrl": "https://github.com/wix/skills/blob/572357b791a91a5138c050e08eb718b150be21cb/skills/wix-replatform/resources/rp-target-wix/SKILL.md"
            },
            {
              "name": "rp-telemetry",
              "sourceUrl": "https://github.com/wix/skills/blob/572357b791a91a5138c050e08eb718b150be21cb/skills/wix-replatform/resources/rp-telemetry/SKILL.md"
            },
            {
              "name": "wix-vibe-headless",
              "sourceUrl": "https://github.com/wix/skills/blob/572357b791a91a5138c050e08eb718b150be21cb/skills/wix-vibe-headless/SKILL.md"
            },
            {
              "name": "wix-headless-replatform",
              "sourceUrl": "https://github.com/wix/skills/blob/572357b791a91a5138c050e08eb718b150be21cb/wix-headless-replatform/SKILL.md"
            },
            {
              "name": "rp-facelift",
              "sourceUrl": "https://github.com/wix/skills/blob/572357b791a91a5138c050e08eb718b150be21cb/wix-headless-replatform/resources/rp-facelift/SKILL.md"
            },
            {
              "name": "rp-project-context",
              "sourceUrl": "https://github.com/wix/skills/blob/572357b791a91a5138c050e08eb718b150be21cb/wix-headless-replatform/resources/rp-project-context/SKILL.md"
            },
            {
              "name": "rp-qa-gap-loop",
              "sourceUrl": "https://github.com/wix/skills/blob/572357b791a91a5138c050e08eb718b150be21cb/wix-headless-replatform/resources/rp-qa-gap-loop/SKILL.md"
            },
            {
              "name": "rp-source-evidence",
              "sourceUrl": "https://github.com/wix/skills/blob/572357b791a91a5138c050e08eb718b150be21cb/wix-headless-replatform/resources/rp-source-evidence/SKILL.md"
            },
            {
              "name": "rp-ui-implementation",
              "sourceUrl": "https://github.com/wix/skills/blob/572357b791a91a5138c050e08eb718b150be21cb/wix-headless-replatform/resources/rp-ui-implementation/SKILL.md"
            },
            {
              "name": "wix-replatform",
              "sourceUrl": "https://github.com/wix/skills/blob/572357b791a91a5138c050e08eb718b150be21cb/wix-replatform/SKILL.md"
            },
            {
              "name": "rp-destination",
              "sourceUrl": "https://github.com/wix/skills/blob/572357b791a91a5138c050e08eb718b150be21cb/wix-replatform/resources/rp-destination/SKILL.md"
            },
            {
              "name": "rp-discovery",
              "sourceUrl": "https://github.com/wix/skills/blob/572357b791a91a5138c050e08eb718b150be21cb/wix-replatform/resources/rp-discovery/SKILL.md"
            },
            {
              "name": "rp-execute-import",
              "sourceUrl": "https://github.com/wix/skills/blob/572357b791a91a5138c050e08eb718b150be21cb/wix-replatform/resources/rp-execute-import/SKILL.md"
            },
            {
              "name": "rp-execute-setup",
              "sourceUrl": "https://github.com/wix/skills/blob/572357b791a91a5138c050e08eb718b150be21cb/wix-replatform/resources/rp-execute-setup/SKILL.md"
            },
            {
              "name": "rp-execution-policy",
              "sourceUrl": "https://github.com/wix/skills/blob/572357b791a91a5138c050e08eb718b150be21cb/wix-replatform/resources/rp-execution-policy/SKILL.md"
            },
            {
              "name": "rp-import-codegen",
              "sourceUrl": "https://github.com/wix/skills/blob/572357b791a91a5138c050e08eb718b150be21cb/wix-replatform/resources/rp-import-codegen/SKILL.md"
            },
            {
              "name": "rp-mapper",
              "sourceUrl": "https://github.com/wix/skills/blob/572357b791a91a5138c050e08eb718b150be21cb/wix-replatform/resources/rp-mapper/SKILL.md"
            },
            {
              "name": "rp-preflight",
              "sourceUrl": "https://github.com/wix/skills/blob/572357b791a91a5138c050e08eb718b150be21cb/wix-replatform/resources/rp-preflight/SKILL.md"
            },
            {
              "name": "rp-project-intake",
              "sourceUrl": "https://github.com/wix/skills/blob/572357b791a91a5138c050e08eb718b150be21cb/wix-replatform/resources/rp-project-intake/SKILL.md"
            },
            {
              "name": "rp-quick-runtime",
              "sourceUrl": "https://github.com/wix/skills/blob/572357b791a91a5138c050e08eb718b150be21cb/wix-replatform/resources/rp-quick-runtime/SKILL.md"
            },
            {
              "name": "rp-quick-shopify",
              "sourceUrl": "https://github.com/wix/skills/blob/572357b791a91a5138c050e08eb718b150be21cb/wix-replatform/resources/rp-quick-shopify/SKILL.md"
            },
            {
              "name": "rp-quick-woocommerce",
              "sourceUrl": "https://github.com/wix/skills/blob/572357b791a91a5138c050e08eb718b150be21cb/wix-replatform/resources/rp-quick-woocommerce/SKILL.md"
            },
            {
              "name": "rp-setup-discovery",
              "sourceUrl": "https://github.com/wix/skills/blob/572357b791a91a5138c050e08eb718b150be21cb/wix-replatform/resources/rp-setup-discovery/SKILL.md"
            },
            {
              "name": "rp-source-csv",
              "sourceUrl": "https://github.com/wix/skills/blob/572357b791a91a5138c050e08eb718b150be21cb/wix-replatform/resources/rp-source-csv/SKILL.md"
            },
            {
              "name": "rp-source-inputs",
              "sourceUrl": "https://github.com/wix/skills/blob/572357b791a91a5138c050e08eb718b150be21cb/wix-replatform/resources/rp-source-inputs/SKILL.md"
            },
            {
              "name": "rp-source-wordpress",
              "sourceUrl": "https://github.com/wix/skills/blob/572357b791a91a5138c050e08eb718b150be21cb/wix-replatform/resources/rp-source-wordpress/SKILL.md"
            },
            {
              "name": "rp-target-wix",
              "sourceUrl": "https://github.com/wix/skills/blob/572357b791a91a5138c050e08eb718b150be21cb/wix-replatform/resources/rp-target-wix/SKILL.md"
            },
            {
              "name": "rp-telemetry",
              "sourceUrl": "https://github.com/wix/skills/blob/572357b791a91a5138c050e08eb718b150be21cb/wix-replatform/resources/rp-telemetry/SKILL.md"
            },
            {
              "name": "rp-website-continuation",
              "sourceUrl": "https://github.com/wix/skills/blob/572357b791a91a5138c050e08eb718b150be21cb/wix-replatform/resources/rp-website-continuation/SKILL.md"
            }
          ],
          "mcpServers": [
            {
              "requiresConfiguration": false,
              "name": "wix-mcp",
              "transport": "http",
              "endpoint": "https://mcp.wix.com/mcp"
            }
          ],
          "components": ["skills", "mcp"],
          "componentInspection": "repository",
          "inspectionError": null,
          "installation": "requires_adapter",
          "upstream": {
            "source": {
              "source": "url",
              "url": "https://github.com/wix/skills.git",
              "sha": "572357b791a91a5138c050e08eb718b150be21cb"
            },
            "policy": null
          }
        },
        {
          "id": "anthropic:build-with-wordpress",
          "name": "build-with-wordpress",
          "displayName": "build-with-wordpress",
          "description": "Craft production-grade WordPress sites and applications. Everything from themes and plugins to commerce and deployment.",
          "longDescription": "Craft production-grade WordPress sites and applications. Everything from themes and plugins to commerce and deployment.",
          "category": null,
          "keywords": [],
          "author": {
            "name": "Automattic"
          },
          "version": "0.0.2",
          "license": null,
          "logoUrl": null,
          "darkLogoUrl": null,
          "homepage": "https://developer.wordpress.com/wordpress-com-claude-code-plugin/",
          "sourceUrl": "https://github.com/Automattic/claude-code-wordpress.com/tree/052ca970df2c577d7c651e784935186ff93e6779/",
          "skills": [
            {
              "name": "site-specification",
              "sourceUrl": "https://github.com/Automattic/claude-code-wordpress.com/blob/052ca970df2c577d7c651e784935186ff93e6779/skills/site-specification/SKILL.md"
            }
          ],
          "mcpServers": [],
          "components": ["skills", "commands"],
          "componentInspection": "repository",
          "inspectionError": null,
          "installation": "requires_adapter",
          "upstream": {
            "source": {
              "source": "url",
              "url": "https://github.com/Automattic/claude-code-wordpress.com.git",
              "sha": "052ca970df2c577d7c651e784935186ff93e6779"
            },
            "policy": null
          }
        },
        {
          "id": "anthropic:workos",
          "name": "workos",
          "displayName": "workos",
          "description": "WorkOS integration skills for AuthKit, SSO, Directory Sync, RBAC, Vault, Audit Logs, migrations, and API references.",
          "longDescription": "WorkOS integration skills for AuthKit, SSO, Directory Sync, RBAC, Vault, Audit Logs, migrations, and API references.",
          "category": "security",
          "keywords": [],
          "author": {
            "name": "WorkOS",
            "email": "support@workos.com"
          },
          "version": "0.7.1",
          "license": "MIT",
          "logoUrl": null,
          "darkLogoUrl": null,
          "homepage": "https://workos.com",
          "sourceUrl": "https://github.com/workos/skills/tree/de1ed17cf03fce2b53973247361a1a47719b528c/plugins/workos",
          "skills": [
            {
              "name": "workos-widgets",
              "sourceUrl": "https://github.com/workos/skills/blob/de1ed17cf03fce2b53973247361a1a47719b528c/plugins/workos/skills/workos-widgets/SKILL.md"
            },
            {
              "name": "workos",
              "sourceUrl": "https://github.com/workos/skills/blob/de1ed17cf03fce2b53973247361a1a47719b528c/plugins/workos/skills/workos/SKILL.md"
            }
          ],
          "mcpServers": [],
          "components": ["skills"],
          "componentInspection": "repository",
          "inspectionError": null,
          "installation": "requires_adapter",
          "upstream": {
            "source": {
              "source": "git-subdir",
              "url": "https://github.com/workos/skills.git",
              "path": "plugins/workos",
              "ref": "main",
              "sha": "de1ed17cf03fce2b53973247361a1a47719b528c"
            },
            "policy": null
          }
        },
        {
          "id": "anthropic:youdotcom-agent-skills",
          "name": "youdotcom-agent-skills",
          "displayName": "you",
          "description": "You.com skills for search, contents, research, finance, and integration discovery with MCP, ARD, API-key, OAuth, and MPP/x402 payment guidance.",
          "longDescription": "You.com skills for search, contents, research, finance, and integration discovery with MCP, ARD, API-key, OAuth, and MPP/x402 payment guidance.",
          "category": "productivity",
          "keywords": [
            "you.com",
            "claude-code",
            "agent-skills",
            "mcp",
            "web-search",
            "content-extraction",
            "research",
            "finance",
            "citations",
            "ard",
            "ai-catalog",
            "x402",
            "mpp"
          ],
          "author": {
            "name": "You.com",
            "email": "support@you.com",
            "url": "https://you.com"
          },
          "version": "0.5.0",
          "license": "MIT",
          "logoUrl": null,
          "darkLogoUrl": null,
          "homepage": "https://docs.you.com",
          "sourceUrl": "https://github.com/youdotcom-oss/agent-skills/tree/78e20fd40bfdccbf91a5aaa67c2e46ba4ed2bbaa/",
          "skills": [
            {
              "name": "grill-me",
              "sourceUrl": "https://github.com/youdotcom-oss/agent-skills/blob/78e20fd40bfdccbf91a5aaa67c2e46ba4ed2bbaa/.agents/skills/grill-me/SKILL.md"
            },
            {
              "name": "karpathy-guidelines",
              "sourceUrl": "https://github.com/youdotcom-oss/agent-skills/blob/78e20fd40bfdccbf91a5aaa67c2e46ba4ed2bbaa/.agents/skills/karpathy-guidelines/SKILL.md"
            },
            {
              "name": "tdd",
              "sourceUrl": "https://github.com/youdotcom-oss/agent-skills/blob/78e20fd40bfdccbf91a5aaa67c2e46ba4ed2bbaa/.agents/skills/tdd/SKILL.md"
            },
            {
              "name": "you-discover",
              "sourceUrl": "https://github.com/youdotcom-oss/agent-skills/blob/78e20fd40bfdccbf91a5aaa67c2e46ba4ed2bbaa/skills/you-discover/SKILL.md"
            },
            {
              "name": "you-finance",
              "sourceUrl": "https://github.com/youdotcom-oss/agent-skills/blob/78e20fd40bfdccbf91a5aaa67c2e46ba4ed2bbaa/skills/you-finance/SKILL.md"
            },
            {
              "name": "you-free",
              "sourceUrl": "https://github.com/youdotcom-oss/agent-skills/blob/78e20fd40bfdccbf91a5aaa67c2e46ba4ed2bbaa/skills/you-free/SKILL.md"
            },
            {
              "name": "you-research",
              "sourceUrl": "https://github.com/youdotcom-oss/agent-skills/blob/78e20fd40bfdccbf91a5aaa67c2e46ba4ed2bbaa/skills/you-research/SKILL.md"
            },
            {
              "name": "you-web",
              "sourceUrl": "https://github.com/youdotcom-oss/agent-skills/blob/78e20fd40bfdccbf91a5aaa67c2e46ba4ed2bbaa/skills/you-web/SKILL.md"
            }
          ],
          "mcpServers": [],
          "components": ["skills"],
          "componentInspection": "repository",
          "inspectionError": null,
          "installation": "requires_adapter",
          "upstream": {
            "source": {
              "source": "url",
              "url": "https://github.com/youdotcom-oss/agent-skills.git",
              "sha": "78e20fd40bfdccbf91a5aaa67c2e46ba4ed2bbaa"
            },
            "policy": null
          }
        },
        {
          "id": "anthropic:zapier",
          "name": "zapier",
          "displayName": "zapier",
          "description": "Connect 9,000+ apps to your AI workflow. Discover, enable, and execute Zapier actions directly from your client.",
          "longDescription": "Connect 9,000+ apps to your AI workflow. Discover, enable, and execute Zapier actions directly from your client.",
          "category": "productivity",
          "keywords": [
            "zapier",
            "mcp",
            "model-context-protocol",
            "automation",
            "integrations",
            "workflow",
            "ai-actions",
            "api",
            "no-code",
            "ai-tools",
            "productivity"
          ],
          "author": {
            "name": "Zapier",
            "email": "support@zapier.com"
          },
          "version": "1.0.0",
          "license": null,
          "logoUrl": null,
          "darkLogoUrl": null,
          "homepage": "https://github.com/zapier/zapier-mcp",
          "sourceUrl": "https://github.com/zapier/zapier-mcp/tree/217d65a980f9b75536babf89ba64bf03ad95beea/plugins/zapier",
          "skills": [
            {
              "name": "zapier-demo",
              "sourceUrl": "https://github.com/zapier/zapier-mcp/blob/217d65a980f9b75536babf89ba64bf03ad95beea/plugins/zapier/skills/zapier-demo/SKILL.md"
            },
            {
              "name": "zapier-explore",
              "sourceUrl": "https://github.com/zapier/zapier-mcp/blob/217d65a980f9b75536babf89ba64bf03ad95beea/plugins/zapier/skills/zapier-explore/SKILL.md"
            },
            {
              "name": "zapier-onboard",
              "sourceUrl": "https://github.com/zapier/zapier-mcp/blob/217d65a980f9b75536babf89ba64bf03ad95beea/plugins/zapier/skills/zapier-onboard/SKILL.md"
            },
            {
              "name": "zapier-status",
              "sourceUrl": "https://github.com/zapier/zapier-mcp/blob/217d65a980f9b75536babf89ba64bf03ad95beea/plugins/zapier/skills/zapier-status/SKILL.md"
            }
          ],
          "mcpServers": [
            {
              "requiresConfiguration": false,
              "name": "zapier",
              "transport": "http",
              "endpoint": "https://mcp.zapier.com/api/v1/connect"
            }
          ],
          "components": ["skills", "mcp", "agents"],
          "componentInspection": "repository",
          "inspectionError": null,
          "installation": "requires_adapter",
          "upstream": {
            "source": {
              "source": "git-subdir",
              "url": "https://github.com/zapier/zapier-mcp.git",
              "path": "plugins/zapier",
              "ref": "main",
              "sha": "217d65a980f9b75536babf89ba64bf03ad95beea"
            },
            "policy": null
          }
        },
        {
          "id": "anthropic:zilliz",
          "name": "zilliz",
          "displayName": "zilliz",
          "description": "Manage Zilliz Cloud clusters and Milvus vector databases from Claude Code using the zilliz-cli.",
          "longDescription": "Manage Zilliz Cloud clusters and Milvus vector databases from Claude Code using the zilliz-cli.",
          "category": "database",
          "keywords": ["zilliz", "milvus", "vector-database", "semantic-search", "rag"],
          "author": {
            "name": "Zilliz",
            "email": "support@zilliz.com"
          },
          "version": "1.5.0",
          "license": "Apache-2.0",
          "logoUrl": null,
          "darkLogoUrl": null,
          "homepage": "https://github.com/zilliztech/zilliz-plugin",
          "sourceUrl": "https://github.com/zilliztech/zilliz-plugin/tree/35c86c000c91abb35f3eeed5cca15ebd69cba4d5/plugins/zilliz",
          "skills": [
            {
              "name": "acl",
              "sourceUrl": "https://github.com/zilliztech/zilliz-plugin/blob/35c86c000c91abb35f3eeed5cca15ebd69cba4d5/plugins/zilliz/skills/acl/SKILL.md"
            },
            {
              "name": "ask-zilliz",
              "sourceUrl": "https://github.com/zilliztech/zilliz-plugin/blob/35c86c000c91abb35f3eeed5cca15ebd69cba4d5/plugins/zilliz/skills/ask-zilliz/SKILL.md"
            },
            {
              "name": "backup",
              "sourceUrl": "https://github.com/zilliztech/zilliz-plugin/blob/35c86c000c91abb35f3eeed5cca15ebd69cba4d5/plugins/zilliz/skills/backup/SKILL.md"
            },
            {
              "name": "billing",
              "sourceUrl": "https://github.com/zilliztech/zilliz-plugin/blob/35c86c000c91abb35f3eeed5cca15ebd69cba4d5/plugins/zilliz/skills/billing/SKILL.md"
            },
            {
              "name": "cluster",
              "sourceUrl": "https://github.com/zilliztech/zilliz-plugin/blob/35c86c000c91abb35f3eeed5cca15ebd69cba4d5/plugins/zilliz/skills/cluster/SKILL.md"
            },
            {
              "name": "collection",
              "sourceUrl": "https://github.com/zilliztech/zilliz-plugin/blob/35c86c000c91abb35f3eeed5cca15ebd69cba4d5/plugins/zilliz/skills/collection/SKILL.md"
            },
            {
              "name": "database",
              "sourceUrl": "https://github.com/zilliztech/zilliz-plugin/blob/35c86c000c91abb35f3eeed5cca15ebd69cba4d5/plugins/zilliz/skills/database/SKILL.md"
            },
            {
              "name": "diagnose",
              "sourceUrl": "https://github.com/zilliztech/zilliz-plugin/blob/35c86c000c91abb35f3eeed5cca15ebd69cba4d5/plugins/zilliz/skills/diagnose/SKILL.md"
            },
            {
              "name": "external-collection",
              "sourceUrl": "https://github.com/zilliztech/zilliz-plugin/blob/35c86c000c91abb35f3eeed5cca15ebd69cba4d5/plugins/zilliz/skills/external-collection/SKILL.md"
            },
            {
              "name": "import",
              "sourceUrl": "https://github.com/zilliztech/zilliz-plugin/blob/35c86c000c91abb35f3eeed5cca15ebd69cba4d5/plugins/zilliz/skills/import/SKILL.md"
            },
            {
              "name": "index",
              "sourceUrl": "https://github.com/zilliztech/zilliz-plugin/blob/35c86c000c91abb35f3eeed5cca15ebd69cba4d5/plugins/zilliz/skills/index/SKILL.md"
            },
            {
              "name": "job",
              "sourceUrl": "https://github.com/zilliztech/zilliz-plugin/blob/35c86c000c91abb35f3eeed5cca15ebd69cba4d5/plugins/zilliz/skills/job/SKILL.md"
            },
            {
              "name": "monitoring",
              "sourceUrl": "https://github.com/zilliztech/zilliz-plugin/blob/35c86c000c91abb35f3eeed5cca15ebd69cba4d5/plugins/zilliz/skills/monitoring/SKILL.md"
            },
            {
              "name": "on-demand-cluster",
              "sourceUrl": "https://github.com/zilliztech/zilliz-plugin/blob/35c86c000c91abb35f3eeed5cca15ebd69cba4d5/plugins/zilliz/skills/on-demand-cluster/SKILL.md"
            },
            {
              "name": "partition",
              "sourceUrl": "https://github.com/zilliztech/zilliz-plugin/blob/35c86c000c91abb35f3eeed5cca15ebd69cba4d5/plugins/zilliz/skills/partition/SKILL.md"
            },
            {
              "name": "privatelink",
              "sourceUrl": "https://github.com/zilliztech/zilliz-plugin/blob/35c86c000c91abb35f3eeed5cca15ebd69cba4d5/plugins/zilliz/skills/privatelink/SKILL.md"
            },
            {
              "name": "project-region",
              "sourceUrl": "https://github.com/zilliztech/zilliz-plugin/blob/35c86c000c91abb35f3eeed5cca15ebd69cba4d5/plugins/zilliz/skills/project-region/SKILL.md"
            },
            {
              "name": "quickstart",
              "sourceUrl": "https://github.com/zilliztech/zilliz-plugin/blob/35c86c000c91abb35f3eeed5cca15ebd69cba4d5/plugins/zilliz/skills/quickstart/SKILL.md"
            },
            {
              "name": "setup",
              "sourceUrl": "https://github.com/zilliztech/zilliz-plugin/blob/35c86c000c91abb35f3eeed5cca15ebd69cba4d5/plugins/zilliz/skills/setup/SKILL.md"
            },
            {
              "name": "status",
              "sourceUrl": "https://github.com/zilliztech/zilliz-plugin/blob/35c86c000c91abb35f3eeed5cca15ebd69cba4d5/plugins/zilliz/skills/status/SKILL.md"
            },
            {
              "name": "user-role",
              "sourceUrl": "https://github.com/zilliztech/zilliz-plugin/blob/35c86c000c91abb35f3eeed5cca15ebd69cba4d5/plugins/zilliz/skills/user-role/SKILL.md"
            },
            {
              "name": "vector",
              "sourceUrl": "https://github.com/zilliztech/zilliz-plugin/blob/35c86c000c91abb35f3eeed5cca15ebd69cba4d5/plugins/zilliz/skills/vector/SKILL.md"
            }
          ],
          "mcpServers": [],
          "components": ["skills", "commands"],
          "componentInspection": "repository",
          "inspectionError": null,
          "installation": "requires_adapter",
          "upstream": {
            "source": {
              "source": "url",
              "url": "https://github.com/zilliztech/zilliz-plugin.git",
              "path": "plugins/zilliz",
              "sha": "35c86c000c91abb35f3eeed5cca15ebd69cba4d5"
            },
            "policy": null
          }
        },
        {
          "id": "anthropic:zoom-plugin",
          "name": "zoom-plugin",
          "displayName": "zoom-plugin",
          "description": "Claude plugin for planning, registering, building, and debugging Zoom integrations across Marketplace apps, REST APIs, SDKs, webhooks, bots, and MCP workflows",
          "longDescription": "Claude plugin for planning, registering, building, and debugging Zoom integrations across Marketplace apps, REST APIs, SDKs, webhooks, bots, and MCP workflows",
          "category": "development",
          "keywords": [
            "zoom",
            "claude-plugin",
            "rest-api",
            "meeting-sdk",
            "video-sdk",
            "webhooks",
            "oauth",
            "marketplace",
            "app-manifest",
            "ai-services",
            "summarizer",
            "translator",
            "team-chat",
            "mcp"
          ],
          "author": {
            "name": "Zoom",
            "url": "https://github.com/zoom/zoom-plugin-claude"
          },
          "version": "1.2.0",
          "license": "MIT",
          "logoUrl": null,
          "darkLogoUrl": null,
          "homepage": "https://developers.zoom.us/",
          "sourceUrl": "https://github.com/zoom/zoom-plugin/tree/9311dd4b31e8e55c27b95479a84601576e449e97/",
          "skills": [
            {
              "name": "build-zoom-bot",
              "sourceUrl": "https://github.com/zoom/zoom-plugin/blob/9311dd4b31e8e55c27b95479a84601576e449e97/skills/build-zoom-bot/SKILL.md"
            },
            {
              "name": "build-zoom-meeting-app",
              "sourceUrl": "https://github.com/zoom/zoom-plugin/blob/9311dd4b31e8e55c27b95479a84601576e449e97/skills/build-zoom-meeting-app/SKILL.md"
            },
            {
              "name": "choose-zoom-approach",
              "sourceUrl": "https://github.com/zoom/zoom-plugin/blob/9311dd4b31e8e55c27b95479a84601576e449e97/skills/choose-zoom-approach/SKILL.md"
            },
            {
              "name": "cobrowse-sdk",
              "sourceUrl": "https://github.com/zoom/zoom-plugin/blob/9311dd4b31e8e55c27b95479a84601576e449e97/skills/cobrowse-sdk/SKILL.md"
            },
            {
              "name": "contact-center",
              "sourceUrl": "https://github.com/zoom/zoom-plugin/blob/9311dd4b31e8e55c27b95479a84601576e449e97/skills/contact-center/SKILL.md"
            },
            {
              "name": "android",
              "sourceUrl": "https://github.com/zoom/zoom-plugin/blob/9311dd4b31e8e55c27b95479a84601576e449e97/skills/contact-center/android/SKILL.md"
            },
            {
              "name": "ios",
              "sourceUrl": "https://github.com/zoom/zoom-plugin/blob/9311dd4b31e8e55c27b95479a84601576e449e97/skills/contact-center/ios/SKILL.md"
            },
            {
              "name": "web",
              "sourceUrl": "https://github.com/zoom/zoom-plugin/blob/9311dd4b31e8e55c27b95479a84601576e449e97/skills/contact-center/web/SKILL.md"
            },
            {
              "name": "debug-zoom-integration",
              "sourceUrl": "https://github.com/zoom/zoom-plugin/blob/9311dd4b31e8e55c27b95479a84601576e449e97/skills/debug-zoom-integration/SKILL.md"
            },
            {
              "name": "debug-zoom",
              "sourceUrl": "https://github.com/zoom/zoom-plugin/blob/9311dd4b31e8e55c27b95479a84601576e449e97/skills/debug-zoom/SKILL.md"
            },
            {
              "name": "design-mcp-workflow",
              "sourceUrl": "https://github.com/zoom/zoom-plugin/blob/9311dd4b31e8e55c27b95479a84601576e449e97/skills/design-mcp-workflow/SKILL.md"
            },
            {
              "name": "general",
              "sourceUrl": "https://github.com/zoom/zoom-plugin/blob/9311dd4b31e8e55c27b95479a84601576e449e97/skills/general/SKILL.md"
            },
            {
              "name": "meeting-sdk",
              "sourceUrl": "https://github.com/zoom/zoom-plugin/blob/9311dd4b31e8e55c27b95479a84601576e449e97/skills/meeting-sdk/SKILL.md"
            },
            {
              "name": "android",
              "sourceUrl": "https://github.com/zoom/zoom-plugin/blob/9311dd4b31e8e55c27b95479a84601576e449e97/skills/meeting-sdk/android/SKILL.md"
            },
            {
              "name": "electron",
              "sourceUrl": "https://github.com/zoom/zoom-plugin/blob/9311dd4b31e8e55c27b95479a84601576e449e97/skills/meeting-sdk/electron/SKILL.md"
            },
            {
              "name": "ios",
              "sourceUrl": "https://github.com/zoom/zoom-plugin/blob/9311dd4b31e8e55c27b95479a84601576e449e97/skills/meeting-sdk/ios/SKILL.md"
            },
            {
              "name": "linux",
              "sourceUrl": "https://github.com/zoom/zoom-plugin/blob/9311dd4b31e8e55c27b95479a84601576e449e97/skills/meeting-sdk/linux/SKILL.md"
            },
            {
              "name": "macos",
              "sourceUrl": "https://github.com/zoom/zoom-plugin/blob/9311dd4b31e8e55c27b95479a84601576e449e97/skills/meeting-sdk/macos/SKILL.md"
            },
            {
              "name": "react-native",
              "sourceUrl": "https://github.com/zoom/zoom-plugin/blob/9311dd4b31e8e55c27b95479a84601576e449e97/skills/meeting-sdk/react-native/SKILL.md"
            },
            {
              "name": "unreal",
              "sourceUrl": "https://github.com/zoom/zoom-plugin/blob/9311dd4b31e8e55c27b95479a84601576e449e97/skills/meeting-sdk/unreal/SKILL.md"
            },
            {
              "name": "web",
              "sourceUrl": "https://github.com/zoom/zoom-plugin/blob/9311dd4b31e8e55c27b95479a84601576e449e97/skills/meeting-sdk/web/SKILL.md"
            },
            {
              "name": "client-view",
              "sourceUrl": "https://github.com/zoom/zoom-plugin/blob/9311dd4b31e8e55c27b95479a84601576e449e97/skills/meeting-sdk/web/client-view/SKILL.md"
            },
            {
              "name": "component-view",
              "sourceUrl": "https://github.com/zoom/zoom-plugin/blob/9311dd4b31e8e55c27b95479a84601576e449e97/skills/meeting-sdk/web/component-view/SKILL.md"
            },
            {
              "name": "windows",
              "sourceUrl": "https://github.com/zoom/zoom-plugin/blob/9311dd4b31e8e55c27b95479a84601576e449e97/skills/meeting-sdk/windows/SKILL.md"
            },
            {
              "name": "oauth",
              "sourceUrl": "https://github.com/zoom/zoom-plugin/blob/9311dd4b31e8e55c27b95479a84601576e449e97/skills/oauth/SKILL.md"
            },
            {
              "name": "phone",
              "sourceUrl": "https://github.com/zoom/zoom-plugin/blob/9311dd4b31e8e55c27b95479a84601576e449e97/skills/phone/SKILL.md"
            },
            {
              "name": "plan-zoom-integration",
              "sourceUrl": "https://github.com/zoom/zoom-plugin/blob/9311dd4b31e8e55c27b95479a84601576e449e97/skills/plan-zoom-integration/SKILL.md"
            },
            {
              "name": "plan-zoom-product",
              "sourceUrl": "https://github.com/zoom/zoom-plugin/blob/9311dd4b31e8e55c27b95479a84601576e449e97/skills/plan-zoom-product/SKILL.md"
            },
            {
              "name": "probe-sdk",
              "sourceUrl": "https://github.com/zoom/zoom-plugin/blob/9311dd4b31e8e55c27b95479a84601576e449e97/skills/probe-sdk/SKILL.md"
            },
            {
              "name": "rest-api",
              "sourceUrl": "https://github.com/zoom/zoom-plugin/blob/9311dd4b31e8e55c27b95479a84601576e449e97/skills/rest-api/SKILL.md"
            },
            {
              "name": "rivet-sdk",
              "sourceUrl": "https://github.com/zoom/zoom-plugin/blob/9311dd4b31e8e55c27b95479a84601576e449e97/skills/rivet-sdk/SKILL.md"
            },
            {
              "name": "rtms",
              "sourceUrl": "https://github.com/zoom/zoom-plugin/blob/9311dd4b31e8e55c27b95479a84601576e449e97/skills/rtms/SKILL.md"
            },
            {
              "name": "scribe",
              "sourceUrl": "https://github.com/zoom/zoom-plugin/blob/9311dd4b31e8e55c27b95479a84601576e449e97/skills/scribe/SKILL.md"
            },
            {
              "name": "setup-zoom-marketplace-app",
              "sourceUrl": "https://github.com/zoom/zoom-plugin/blob/9311dd4b31e8e55c27b95479a84601576e449e97/skills/setup-zoom-marketplace-app/SKILL.md"
            },
            {
              "name": "setup-zoom-mcp",
              "sourceUrl": "https://github.com/zoom/zoom-plugin/blob/9311dd4b31e8e55c27b95479a84601576e449e97/skills/setup-zoom-mcp/SKILL.md"
            },
            {
              "name": "setup-zoom-oauth",
              "sourceUrl": "https://github.com/zoom/zoom-plugin/blob/9311dd4b31e8e55c27b95479a84601576e449e97/skills/setup-zoom-oauth/SKILL.md"
            },
            {
              "name": "start",
              "sourceUrl": "https://github.com/zoom/zoom-plugin/blob/9311dd4b31e8e55c27b95479a84601576e449e97/skills/start/SKILL.md"
            },
            {
              "name": "summarizer",
              "sourceUrl": "https://github.com/zoom/zoom-plugin/blob/9311dd4b31e8e55c27b95479a84601576e449e97/skills/summarizer/SKILL.md"
            },
            {
              "name": "team-chat",
              "sourceUrl": "https://github.com/zoom/zoom-plugin/blob/9311dd4b31e8e55c27b95479a84601576e449e97/skills/team-chat/SKILL.md"
            },
            {
              "name": "translator",
              "sourceUrl": "https://github.com/zoom/zoom-plugin/blob/9311dd4b31e8e55c27b95479a84601576e449e97/skills/translator/SKILL.md"
            },
            {
              "name": "ui-toolkit",
              "sourceUrl": "https://github.com/zoom/zoom-plugin/blob/9311dd4b31e8e55c27b95479a84601576e449e97/skills/ui-toolkit/SKILL.md"
            },
            {
              "name": "video-sdk",
              "sourceUrl": "https://github.com/zoom/zoom-plugin/blob/9311dd4b31e8e55c27b95479a84601576e449e97/skills/video-sdk/SKILL.md"
            },
            {
              "name": "android",
              "sourceUrl": "https://github.com/zoom/zoom-plugin/blob/9311dd4b31e8e55c27b95479a84601576e449e97/skills/video-sdk/android/SKILL.md"
            },
            {
              "name": "flutter",
              "sourceUrl": "https://github.com/zoom/zoom-plugin/blob/9311dd4b31e8e55c27b95479a84601576e449e97/skills/video-sdk/flutter/SKILL.md"
            },
            {
              "name": "ios",
              "sourceUrl": "https://github.com/zoom/zoom-plugin/blob/9311dd4b31e8e55c27b95479a84601576e449e97/skills/video-sdk/ios/SKILL.md"
            },
            {
              "name": "linux",
              "sourceUrl": "https://github.com/zoom/zoom-plugin/blob/9311dd4b31e8e55c27b95479a84601576e449e97/skills/video-sdk/linux/SKILL.md"
            },
            {
              "name": "macos",
              "sourceUrl": "https://github.com/zoom/zoom-plugin/blob/9311dd4b31e8e55c27b95479a84601576e449e97/skills/video-sdk/macos/SKILL.md"
            },
            {
              "name": "react-native",
              "sourceUrl": "https://github.com/zoom/zoom-plugin/blob/9311dd4b31e8e55c27b95479a84601576e449e97/skills/video-sdk/react-native/SKILL.md"
            },
            {
              "name": "unity",
              "sourceUrl": "https://github.com/zoom/zoom-plugin/blob/9311dd4b31e8e55c27b95479a84601576e449e97/skills/video-sdk/unity/SKILL.md"
            },
            {
              "name": "web",
              "sourceUrl": "https://github.com/zoom/zoom-plugin/blob/9311dd4b31e8e55c27b95479a84601576e449e97/skills/video-sdk/web/SKILL.md"
            },
            {
              "name": "windows",
              "sourceUrl": "https://github.com/zoom/zoom-plugin/blob/9311dd4b31e8e55c27b95479a84601576e449e97/skills/video-sdk/windows/SKILL.md"
            },
            {
              "name": "virtual-agent",
              "sourceUrl": "https://github.com/zoom/zoom-plugin/blob/9311dd4b31e8e55c27b95479a84601576e449e97/skills/virtual-agent/SKILL.md"
            },
            {
              "name": "android",
              "sourceUrl": "https://github.com/zoom/zoom-plugin/blob/9311dd4b31e8e55c27b95479a84601576e449e97/skills/virtual-agent/android/SKILL.md"
            },
            {
              "name": "ios",
              "sourceUrl": "https://github.com/zoom/zoom-plugin/blob/9311dd4b31e8e55c27b95479a84601576e449e97/skills/virtual-agent/ios/SKILL.md"
            },
            {
              "name": "web",
              "sourceUrl": "https://github.com/zoom/zoom-plugin/blob/9311dd4b31e8e55c27b95479a84601576e449e97/skills/virtual-agent/web/SKILL.md"
            },
            {
              "name": "webhooks",
              "sourceUrl": "https://github.com/zoom/zoom-plugin/blob/9311dd4b31e8e55c27b95479a84601576e449e97/skills/webhooks/SKILL.md"
            },
            {
              "name": "websockets",
              "sourceUrl": "https://github.com/zoom/zoom-plugin/blob/9311dd4b31e8e55c27b95479a84601576e449e97/skills/websockets/SKILL.md"
            },
            {
              "name": "zoom-apps-sdk",
              "sourceUrl": "https://github.com/zoom/zoom-plugin/blob/9311dd4b31e8e55c27b95479a84601576e449e97/skills/zoom-apps-sdk/SKILL.md"
            },
            {
              "name": "zoom-mcp",
              "sourceUrl": "https://github.com/zoom/zoom-plugin/blob/9311dd4b31e8e55c27b95479a84601576e449e97/skills/zoom-mcp/SKILL.md"
            },
            {
              "name": "team-chat",
              "sourceUrl": "https://github.com/zoom/zoom-plugin/blob/9311dd4b31e8e55c27b95479a84601576e449e97/skills/zoom-mcp/team-chat/SKILL.md"
            },
            {
              "name": "whiteboard",
              "sourceUrl": "https://github.com/zoom/zoom-plugin/blob/9311dd4b31e8e55c27b95479a84601576e449e97/skills/zoom-mcp/whiteboard/SKILL.md"
            }
          ],
          "mcpServers": [
            {
              "requiresConfiguration": true,
              "name": "zoom-mcp",
              "transport": "http",
              "endpoint": "https://mcp.zoom.us/mcp/zoom/streamable"
            },
            {
              "requiresConfiguration": true,
              "name": "zoom-meetings-mcp",
              "transport": "http",
              "endpoint": "https://mcp.zoom.us/mcp/meeting/streamable"
            },
            {
              "requiresConfiguration": true,
              "name": "zoom-canvas-mcp",
              "transport": "http",
              "endpoint": "https://mcp.zoom.us/mcp/canvas/streamable"
            },
            {
              "requiresConfiguration": true,
              "name": "zoom-chat-mcp",
              "transport": "http",
              "endpoint": "https://mcp.zoom.us/mcp/chat/streamable"
            },
            {
              "requiresConfiguration": true,
              "name": "zoom-tasks-mcp",
              "transport": "http",
              "endpoint": "https://mcp.zoom.us/mcp/tasks/streamable"
            },
            {
              "requiresConfiguration": true,
              "name": "zoom-revenue-accelerator-mcp",
              "transport": "http",
              "endpoint": "https://mcp.zoom.us/mcp/revenue_accelerator/streamable"
            },
            {
              "requiresConfiguration": true,
              "name": "zoom-whiteboard-mcp",
              "transport": "http",
              "endpoint": "https://mcp.zoom.us/mcp/whiteboard/streamable"
            }
          ],
          "components": ["skills", "mcp"],
          "componentInspection": "repository",
          "inspectionError": null,
          "installation": "requires_adapter",
          "upstream": {
            "source": {
              "source": "url",
              "url": "https://github.com/zoom/zoom-plugin.git",
              "sha": "9311dd4b31e8e55c27b95479a84601576e449e97"
            },
            "policy": null
          }
        },
        {
          "id": "anthropic:zoominfo",
          "name": "zoominfo",
          "displayName": "zoominfo",
          "description": "Connect AI agents to ZoomInfo's verified GTM context graph: 100M companies, 300M professional contacts, buyer intent signals, and real-time scoops. Build prospect lists, enrich records, deep research key organizations, find decision-makers, and prioritize accounts by intent. The B2B sales intelligence layer for Claude and any MCP-compatible agent.",
          "longDescription": "Connect AI agents to ZoomInfo's verified GTM context graph: 100M companies, 300M professional contacts, buyer intent signals, and real-time scoops. Build prospect lists, enrich records, deep research key organizations, find decision-makers, and prioritize accounts by intent. The B2B sales intelligence layer for Claude and any MCP-compatible agent.",
          "category": "productivity",
          "keywords": [
            "zoominfo",
            "gtm",
            "go-to-market",
            "gtm context graph",
            "b2b",
            "sales",
            "sales intelligence",
            "sales prospecting",
            "b2b prospecting",
            "prospecting",
            "lead generation",
            "b2b lead generation",
            "find contacts",
            "contact search",
            "contact information",
            "contacts",
            "decision-makers",
            "find accounts",
            "account search",
            "account research",
            "business information",
            "companies",
            "company data",
            "build a list",
            "lead lists",
            "account lists",
            "target account list",
            "enrich records",
            "lead enrichment",
            "contact enrichment",
            "account enrichment",
            "crm data enrichment",
            "salesforce data enrichment",
            "firmographics",
            "technographics",
            "buyer intent",
            "buyer intent data",
            "intent data",
            "intent signals",
            "buying signals",
            "buying committee",
            "meeting prep",
            "recommended contacts",
            "lookalikes",
            "lookalike accounts",
            "similar companies",
            "similar contacts",
            "market intelligence",
            "competitive intelligence",
            "conversation intelligence",
            "tam analysis",
            "total addressable market",
            "territory planning",
            "account-based selling",
            "abm",
            "sales pipeline",
            "icp",
            "ideal customer profile",
            "scoops",
            "direct dial",
            "verified email",
            "mobile numbers",
            "website visitor identification",
            "mcp"
          ],
          "author": {
            "name": "ZoomInfo",
            "email": "integrationsupport@zoominfo.com",
            "url": "https://www.zoominfo.com"
          },
          "version": "1.0.1",
          "license": "MIT",
          "logoUrl": null,
          "darkLogoUrl": null,
          "homepage": "https://www.zoominfo.com",
          "sourceUrl": "https://github.com/Zoominfo/zoominfo-mcp-plugin/tree/d07402feb2b9967ccc118f55bacd41a79c822d6a/",
          "skills": [
            {
              "name": "account-health",
              "sourceUrl": "https://github.com/Zoominfo/zoominfo-mcp-plugin/blob/d07402feb2b9967ccc118f55bacd41a79c822d6a/skills/account-health/SKILL.md"
            },
            {
              "name": "account-relationship-recap",
              "sourceUrl": "https://github.com/Zoominfo/zoominfo-mcp-plugin/blob/d07402feb2b9967ccc118f55bacd41a79c822d6a/skills/account-relationship-recap/SKILL.md"
            },
            {
              "name": "account-research",
              "sourceUrl": "https://github.com/Zoominfo/zoominfo-mcp-plugin/blob/d07402feb2b9967ccc118f55bacd41a79c822d6a/skills/account-research/SKILL.md"
            },
            {
              "name": "ae-cs-handoff",
              "sourceUrl": "https://github.com/Zoominfo/zoominfo-mcp-plugin/blob/d07402feb2b9967ccc118f55bacd41a79c822d6a/skills/ae-cs-handoff/SKILL.md"
            },
            {
              "name": "build-list",
              "sourceUrl": "https://github.com/Zoominfo/zoominfo-mcp-plugin/blob/d07402feb2b9967ccc118f55bacd41a79c822d6a/skills/build-list/SKILL.md"
            },
            {
              "name": "buying-committee",
              "sourceUrl": "https://github.com/Zoominfo/zoominfo-mcp-plugin/blob/d07402feb2b9967ccc118f55bacd41a79c822d6a/skills/buying-committee/SKILL.md"
            },
            {
              "name": "call-coaching",
              "sourceUrl": "https://github.com/Zoominfo/zoominfo-mcp-plugin/blob/d07402feb2b9967ccc118f55bacd41a79c822d6a/skills/call-coaching/SKILL.md"
            },
            {
              "name": "call-recap",
              "sourceUrl": "https://github.com/Zoominfo/zoominfo-mcp-plugin/blob/d07402feb2b9967ccc118f55bacd41a79c822d6a/skills/call-recap/SKILL.md"
            },
            {
              "name": "commitment-ledger",
              "sourceUrl": "https://github.com/Zoominfo/zoominfo-mcp-plugin/blob/d07402feb2b9967ccc118f55bacd41a79c822d6a/skills/commitment-ledger/SKILL.md"
            },
            {
              "name": "company-intent-monitor",
              "sourceUrl": "https://github.com/Zoominfo/zoominfo-mcp-plugin/blob/d07402feb2b9967ccc118f55bacd41a79c822d6a/skills/company-intent-monitor/SKILL.md"
            },
            {
              "name": "company-news-monitor",
              "sourceUrl": "https://github.com/Zoominfo/zoominfo-mcp-plugin/blob/d07402feb2b9967ccc118f55bacd41a79c822d6a/skills/company-news-monitor/SKILL.md"
            },
            {
              "name": "competitor-analysis",
              "sourceUrl": "https://github.com/Zoominfo/zoominfo-mcp-plugin/blob/d07402feb2b9967ccc118f55bacd41a79c822d6a/skills/competitor-analysis/SKILL.md"
            },
            {
              "name": "contact-relationship-recap",
              "sourceUrl": "https://github.com/Zoominfo/zoominfo-mcp-plugin/blob/d07402feb2b9967ccc118f55bacd41a79c822d6a/skills/contact-relationship-recap/SKILL.md"
            },
            {
              "name": "daily-brief",
              "sourceUrl": "https://github.com/Zoominfo/zoominfo-mcp-plugin/blob/d07402feb2b9967ccc118f55bacd41a79c822d6a/skills/daily-brief/SKILL.md"
            },
            {
              "name": "decision-process-mapper",
              "sourceUrl": "https://github.com/Zoominfo/zoominfo-mcp-plugin/blob/d07402feb2b9967ccc118f55bacd41a79c822d6a/skills/decision-process-mapper/SKILL.md"
            },
            {
              "name": "draft-follow-up",
              "sourceUrl": "https://github.com/Zoominfo/zoominfo-mcp-plugin/blob/d07402feb2b9967ccc118f55bacd41a79c822d6a/skills/draft-follow-up/SKILL.md"
            },
            {
              "name": "email-thread-summarizer",
              "sourceUrl": "https://github.com/Zoominfo/zoominfo-mcp-plugin/blob/d07402feb2b9967ccc118f55bacd41a79c822d6a/skills/email-thread-summarizer/SKILL.md"
            },
            {
              "name": "engagement-timeline",
              "sourceUrl": "https://github.com/Zoominfo/zoominfo-mcp-plugin/blob/d07402feb2b9967ccc118f55bacd41a79c822d6a/skills/engagement-timeline/SKILL.md"
            },
            {
              "name": "enrich-company",
              "sourceUrl": "https://github.com/Zoominfo/zoominfo-mcp-plugin/blob/d07402feb2b9967ccc118f55bacd41a79c822d6a/skills/enrich-company/SKILL.md"
            },
            {
              "name": "enrich-contact",
              "sourceUrl": "https://github.com/Zoominfo/zoominfo-mcp-plugin/blob/d07402feb2b9967ccc118f55bacd41a79c822d6a/skills/enrich-contact/SKILL.md"
            },
            {
              "name": "exec-brief",
              "sourceUrl": "https://github.com/Zoominfo/zoominfo-mcp-plugin/blob/d07402feb2b9967ccc118f55bacd41a79c822d6a/skills/exec-brief/SKILL.md"
            },
            {
              "name": "find-similar",
              "sourceUrl": "https://github.com/Zoominfo/zoominfo-mcp-plugin/blob/d07402feb2b9967ccc118f55bacd41a79c822d6a/skills/find-similar/SKILL.md"
            },
            {
              "name": "meeting-prep",
              "sourceUrl": "https://github.com/Zoominfo/zoominfo-mcp-plugin/blob/d07402feb2b9967ccc118f55bacd41a79c822d6a/skills/meeting-prep/SKILL.md"
            },
            {
              "name": "mutual-action-plan",
              "sourceUrl": "https://github.com/Zoominfo/zoominfo-mcp-plugin/blob/d07402feb2b9967ccc118f55bacd41a79c822d6a/skills/mutual-action-plan/SKILL.md"
            },
            {
              "name": "next-best-action",
              "sourceUrl": "https://github.com/Zoominfo/zoominfo-mcp-plugin/blob/d07402feb2b9967ccc118f55bacd41a79c822d6a/skills/next-best-action/SKILL.md"
            },
            {
              "name": "objection-blocker-tracker",
              "sourceUrl": "https://github.com/Zoominfo/zoominfo-mcp-plugin/blob/d07402feb2b9967ccc118f55bacd41a79c822d6a/skills/objection-blocker-tracker/SKILL.md"
            },
            {
              "name": "personalize-email",
              "sourceUrl": "https://github.com/Zoominfo/zoominfo-mcp-plugin/blob/d07402feb2b9967ccc118f55bacd41a79c822d6a/skills/personalize-email/SKILL.md"
            },
            {
              "name": "qbr-prep",
              "sourceUrl": "https://github.com/Zoominfo/zoominfo-mcp-plugin/blob/d07402feb2b9967ccc118f55bacd41a79c822d6a/skills/qbr-prep/SKILL.md"
            },
            {
              "name": "recommend-contacts",
              "sourceUrl": "https://github.com/Zoominfo/zoominfo-mcp-plugin/blob/d07402feb2b9967ccc118f55bacd41a79c822d6a/skills/recommend-contacts/SKILL.md"
            },
            {
              "name": "renewal-prep",
              "sourceUrl": "https://github.com/Zoominfo/zoominfo-mcp-plugin/blob/d07402feb2b9967ccc118f55bacd41a79c822d6a/skills/renewal-prep/SKILL.md"
            },
            {
              "name": "score-accounts",
              "sourceUrl": "https://github.com/Zoominfo/zoominfo-mcp-plugin/blob/d07402feb2b9967ccc118f55bacd41a79c822d6a/skills/score-accounts/SKILL.md"
            },
            {
              "name": "score-leads",
              "sourceUrl": "https://github.com/Zoominfo/zoominfo-mcp-plugin/blob/d07402feb2b9967ccc118f55bacd41a79c822d6a/skills/score-leads/SKILL.md"
            },
            {
              "name": "tam-sizer",
              "sourceUrl": "https://github.com/Zoominfo/zoominfo-mcp-plugin/blob/d07402feb2b9967ccc118f55bacd41a79c822d6a/skills/tam-sizer/SKILL.md"
            },
            {
              "name": "tech-stack-snapshot",
              "sourceUrl": "https://github.com/Zoominfo/zoominfo-mcp-plugin/blob/d07402feb2b9967ccc118f55bacd41a79c822d6a/skills/tech-stack-snapshot/SKILL.md"
            },
            {
              "name": "why-now",
              "sourceUrl": "https://github.com/Zoominfo/zoominfo-mcp-plugin/blob/d07402feb2b9967ccc118f55bacd41a79c822d6a/skills/why-now/SKILL.md"
            }
          ],
          "mcpServers": [
            {
              "requiresConfiguration": false,
              "name": "zoominfo",
              "transport": "http",
              "endpoint": "https://mcp.zoominfo.com/mcp"
            }
          ],
          "components": ["skills", "mcp"],
          "componentInspection": "repository",
          "inspectionError": null,
          "installation": "requires_adapter",
          "upstream": {
            "source": {
              "source": "url",
              "url": "https://github.com/Zoominfo/zoominfo-mcp-plugin.git",
              "sha": "d07402feb2b9967ccc118f55bacd41a79c822d6a"
            },
            "policy": null
          }
        },
        {
          "id": "anthropic:zscaler",
          "name": "zscaler",
          "displayName": "zscaler",
          "description": "Manage Zscaler cloud security platform including ZPA (private access), ZIA (internet access), ZDX (digital experience), ZCC (client connector), EASM (attack surface), and Z-Insights (analytics). Create and manage policies, troubleshoot connectivity, audit security configurations, and investigate incidents across the full Zscaler ecosystem.",
          "longDescription": "Manage Zscaler cloud security platform including ZPA (private access), ZIA (internet access), ZDX (digital experience), ZCC (client connector), EASM (attack surface), and Z-Insights (analytics). Create and manage policies, troubleshoot connectivity, audit security configurations, and investigate incidents across the full Zscaler ecosystem.",
          "category": "security",
          "keywords": [],
          "author": {
            "name": "Zscaler"
          },
          "version": "0.15.4",
          "license": null,
          "logoUrl": null,
          "darkLogoUrl": null,
          "homepage": "https://github.com/zscaler/zscaler-mcp-server",
          "sourceUrl": "https://github.com/zscaler/zscaler-mcp-server/tree/809f68d6c921e0829fb2e07e9b797e7e70cf720b/",
          "skills": [
            {
              "name": "troubleshoot-user-connectivity",
              "sourceUrl": "https://github.com/zscaler/zscaler-mcp-server/blob/809f68d6c921e0829fb2e07e9b797e7e70cf720b/skills/cross-product/troubleshoot-user-connectivity/SKILL.md"
            },
            {
              "name": "review-attack-surface",
              "sourceUrl": "https://github.com/zscaler/zscaler-mcp-server/blob/809f68d6c921e0829fb2e07e9b797e7e70cf720b/skills/easm/review-attack-surface/SKILL.md"
            },
            {
              "name": "generate-logout-otp",
              "sourceUrl": "https://github.com/zscaler/zscaler-mcp-server/blob/809f68d6c921e0829fb2e07e9b797e7e70cf720b/skills/zcc/generate-logout-otp/SKILL.md"
            },
            {
              "name": "analyze-application-health",
              "sourceUrl": "https://github.com/zscaler/zscaler-mcp-server/blob/809f68d6c921e0829fb2e07e9b797e7e70cf720b/skills/zdx/analyze-application-health/SKILL.md"
            },
            {
              "name": "audit-software-inventory",
              "sourceUrl": "https://github.com/zscaler/zscaler-mcp-server/blob/809f68d6c921e0829fb2e07e9b797e7e70cf720b/skills/zdx/audit-software-inventory/SKILL.md"
            },
            {
              "name": "compare-location-experience",
              "sourceUrl": "https://github.com/zscaler/zscaler-mcp-server/blob/809f68d6c921e0829fb2e07e9b797e7e70cf720b/skills/zdx/compare-location-experience/SKILL.md"
            },
            {
              "name": "diagnose-deeptrace",
              "sourceUrl": "https://github.com/zscaler/zscaler-mcp-server/blob/809f68d6c921e0829fb2e07e9b797e7e70cf720b/skills/zdx/diagnose-deeptrace/SKILL.md"
            },
            {
              "name": "investigate-alerts",
              "sourceUrl": "https://github.com/zscaler/zscaler-mcp-server/blob/809f68d6c921e0829fb2e07e9b797e7e70cf720b/skills/zdx/investigate-alerts/SKILL.md"
            },
            {
              "name": "investigate-multi-app-outage",
              "sourceUrl": "https://github.com/zscaler/zscaler-mcp-server/blob/809f68d6c921e0829fb2e07e9b797e7e70cf720b/skills/zdx/investigate-multi-app-outage/SKILL.md"
            },
            {
              "name": "troubleshoot-user-experience",
              "sourceUrl": "https://github.com/zscaler/zscaler-mcp-server/blob/809f68d6c921e0829fb2e07e9b797e7e70cf720b/skills/zdx/troubleshoot-user-experience/SKILL.md"
            },
            {
              "name": "audit-ssl-inspection-bypass",
              "sourceUrl": "https://github.com/zscaler/zscaler-mcp-server/blob/809f68d6c921e0829fb2e07e9b797e7e70cf720b/skills/zia/audit-ssl-inspection-bypass/SKILL.md"
            },
            {
              "name": "check-user-url-access",
              "sourceUrl": "https://github.com/zscaler/zscaler-mcp-server/blob/809f68d6c921e0829fb2e07e9b797e7e70cf720b/skills/zia/check-user-url-access/SKILL.md"
            },
            {
              "name": "create-cloud-app-control-rule",
              "sourceUrl": "https://github.com/zscaler/zscaler-mcp-server/blob/809f68d6c921e0829fb2e07e9b797e7e70cf720b/skills/zia/create-cloud-app-control-rule/SKILL.md"
            },
            {
              "name": "create-firewall-filtering-rule",
              "sourceUrl": "https://github.com/zscaler/zscaler-mcp-server/blob/809f68d6c921e0829fb2e07e9b797e7e70cf720b/skills/zia/create-firewall-filtering-rule/SKILL.md"
            },
            {
              "name": "create-ssl-inspection-rule",
              "sourceUrl": "https://github.com/zscaler/zscaler-mcp-server/blob/809f68d6c921e0829fb2e07e9b797e7e70cf720b/skills/zia/create-ssl-inspection-rule/SKILL.md"
            },
            {
              "name": "create-url-filtering-rule",
              "sourceUrl": "https://github.com/zscaler/zscaler-mcp-server/blob/809f68d6c921e0829fb2e07e9b797e7e70cf720b/skills/zia/create-url-filtering-rule/SKILL.md"
            },
            {
              "name": "investigate-sandbox",
              "sourceUrl": "https://github.com/zscaler/zscaler-mcp-server/blob/809f68d6c921e0829fb2e07e9b797e7e70cf720b/skills/zia/investigate-sandbox/SKILL.md"
            },
            {
              "name": "investigate-url-category",
              "sourceUrl": "https://github.com/zscaler/zscaler-mcp-server/blob/809f68d6c921e0829fb2e07e9b797e7e70cf720b/skills/zia/investigate-url-category/SKILL.md"
            },
            {
              "name": "look-up-cloud-app-name",
              "sourceUrl": "https://github.com/zscaler/zscaler-mcp-server/blob/809f68d6c921e0829fb2e07e9b797e7e70cf720b/skills/zia/look-up-cloud-app-name/SKILL.md"
            },
            {
              "name": "look-up-rule-targets",
              "sourceUrl": "https://github.com/zscaler/zscaler-mcp-server/blob/809f68d6c921e0829fb2e07e9b797e7e70cf720b/skills/zia/look-up-rule-targets/SKILL.md"
            },
            {
              "name": "manage-time-interval",
              "sourceUrl": "https://github.com/zscaler/zscaler-mcp-server/blob/809f68d6c921e0829fb2e07e9b797e7e70cf720b/skills/zia/manage-time-interval/SKILL.md"
            },
            {
              "name": "onboard-location",
              "sourceUrl": "https://github.com/zscaler/zscaler-mcp-server/blob/809f68d6c921e0829fb2e07e9b797e7e70cf720b/skills/zia/onboard-location/SKILL.md"
            },
            {
              "name": "analyze-web-traffic",
              "sourceUrl": "https://github.com/zscaler/zscaler-mcp-server/blob/809f68d6c921e0829fb2e07e9b797e7e70cf720b/skills/zins/analyze-web-traffic/SKILL.md"
            },
            {
              "name": "assess-network-security",
              "sourceUrl": "https://github.com/zscaler/zscaler-mcp-server/blob/809f68d6c921e0829fb2e07e9b797e7e70cf720b/skills/zins/assess-network-security/SKILL.md"
            },
            {
              "name": "audit-shadow-it",
              "sourceUrl": "https://github.com/zscaler/zscaler-mcp-server/blob/809f68d6c921e0829fb2e07e9b797e7e70cf720b/skills/zins/audit-shadow-it/SKILL.md"
            },
            {
              "name": "investigate-security-incident",
              "sourceUrl": "https://github.com/zscaler/zscaler-mcp-server/blob/809f68d6c921e0829fb2e07e9b797e7e70cf720b/skills/zins/investigate-security-incident/SKILL.md"
            },
            {
              "name": "analyze-policy-rules",
              "sourceUrl": "https://github.com/zscaler/zscaler-mcp-server/blob/809f68d6c921e0829fb2e07e9b797e7e70cf720b/skills/zms/analyze-policy-rules/SKILL.md"
            },
            {
              "name": "assess-workload-protection",
              "sourceUrl": "https://github.com/zscaler/zscaler-mcp-server/blob/809f68d6c921e0829fb2e07e9b797e7e70cf720b/skills/zms/assess-workload-protection/SKILL.md"
            },
            {
              "name": "audit-microsegmentation-posture",
              "sourceUrl": "https://github.com/zscaler/zscaler-mcp-server/blob/809f68d6c921e0829fb2e07e9b797e7e70cf720b/skills/zms/audit-microsegmentation-posture/SKILL.md"
            },
            {
              "name": "review-tag-classification",
              "sourceUrl": "https://github.com/zscaler/zscaler-mcp-server/blob/809f68d6c921e0829fb2e07e9b797e7e70cf720b/skills/zms/review-tag-classification/SKILL.md"
            },
            {
              "name": "troubleshoot-agent-deployment",
              "sourceUrl": "https://github.com/zscaler/zscaler-mcp-server/blob/809f68d6c921e0829fb2e07e9b797e7e70cf720b/skills/zms/troubleshoot-agent-deployment/SKILL.md"
            },
            {
              "name": "application_segment-ba-onboard",
              "sourceUrl": "https://github.com/zscaler/zscaler-mcp-server/blob/809f68d6c921e0829fb2e07e9b797e7e70cf720b/skills/zpa/application_segment-ba-onboard/SKILL.md"
            },
            {
              "name": "application_segment-onboard",
              "sourceUrl": "https://github.com/zscaler/zscaler-mcp-server/blob/809f68d6c921e0829fb2e07e9b797e7e70cf720b/skills/zpa/application_segment-onboard/SKILL.md"
            },
            {
              "name": "application_segment-pra-onboard",
              "sourceUrl": "https://github.com/zscaler/zscaler-mcp-server/blob/809f68d6c921e0829fb2e07e9b797e7e70cf720b/skills/zpa/application_segment-pra-onboard/SKILL.md"
            },
            {
              "name": "audit-baseline-compliance",
              "sourceUrl": "https://github.com/zscaler/zscaler-mcp-server/blob/809f68d6c921e0829fb2e07e9b797e7e70cf720b/skills/zpa/audit-baseline-compliance/SKILL.md"
            },
            {
              "name": "create-access-policy-rule",
              "sourceUrl": "https://github.com/zscaler/zscaler-mcp-server/blob/809f68d6c921e0829fb2e07e9b797e7e70cf720b/skills/zpa/create-access-policy-rule/SKILL.md"
            },
            {
              "name": "create-conditional-access-rule",
              "sourceUrl": "https://github.com/zscaler/zscaler-mcp-server/blob/809f68d6c921e0829fb2e07e9b797e7e70cf720b/skills/zpa/create-conditional-access-rule/SKILL.md"
            },
            {
              "name": "create-forwarding-policy-rule",
              "sourceUrl": "https://github.com/zscaler/zscaler-mcp-server/blob/809f68d6c921e0829fb2e07e9b797e7e70cf720b/skills/zpa/create-forwarding-policy-rule/SKILL.md"
            },
            {
              "name": "create-server-group",
              "sourceUrl": "https://github.com/zscaler/zscaler-mcp-server/blob/809f68d6c921e0829fb2e07e9b797e7e70cf720b/skills/zpa/create-server-group/SKILL.md"
            },
            {
              "name": "create-session-duration-rule",
              "sourceUrl": "https://github.com/zscaler/zscaler-mcp-server/blob/809f68d6c921e0829fb2e07e9b797e7e70cf720b/skills/zpa/create-session-duration-rule/SKILL.md"
            },
            {
              "name": "create-timeout-policy-rule",
              "sourceUrl": "https://github.com/zscaler/zscaler-mcp-server/blob/809f68d6c921e0829fb2e07e9b797e7e70cf720b/skills/zpa/create-timeout-policy-rule/SKILL.md"
            },
            {
              "name": "troubleshoot-app-connector",
              "sourceUrl": "https://github.com/zscaler/zscaler-mcp-server/blob/809f68d6c921e0829fb2e07e9b797e7e70cf720b/skills/zpa/troubleshoot-app-connector/SKILL.md"
            }
          ],
          "mcpServers": [
            {
              "requiresConfiguration": false,
              "name": "zscaler-mcp-server",
              "transport": "stdio",
              "endpoint": null
            }
          ],
          "components": ["skills", "mcp", "commands"],
          "componentInspection": "repository",
          "inspectionError": null,
          "installation": "requires_adapter",
          "upstream": {
            "source": {
              "source": "url",
              "url": "https://github.com/zscaler/zscaler-mcp-server.git",
              "sha": "809f68d6c921e0829fb2e07e9b797e7e70cf720b"
            },
            "policy": null
          }
        },
        {
          "id": "anthropic:langfuse",
          "name": "langfuse",
          "displayName": "langfuse",
          "description": "Skills for working with Langfuse, the open-source LLM engineering platform for tracing, prompt management, and evaluation.",
          "longDescription": "Skills for working with Langfuse, the open-source LLM engineering platform for tracing, prompt management, and evaluation.",
          "category": "monitoring",
          "keywords": [
            "langfuse",
            "llm",
            "observability",
            "tracing",
            "prompt-management",
            "evaluation"
          ],
          "author": {
            "name": "Langfuse",
            "email": "support@langfuse.com"
          },
          "version": "1.7.2",
          "license": "MIT",
          "logoUrl": null,
          "darkLogoUrl": null,
          "homepage": "https://langfuse.com",
          "sourceUrl": "https://github.com/langfuse/skills/tree/fc574260e5530b217d94e06465a4da0c7d846888/",
          "skills": [
            {
              "name": "skill-creator",
              "sourceUrl": "https://github.com/langfuse/skills/blob/fc574260e5530b217d94e06465a4da0c7d846888/.cursor/skills/skill-creator/SKILL.md"
            },
            {
              "name": "langfuse",
              "sourceUrl": "https://github.com/langfuse/skills/blob/fc574260e5530b217d94e06465a4da0c7d846888/skills/langfuse/SKILL.md"
            }
          ],
          "mcpServers": [],
          "components": ["skills"],
          "componentInspection": "repository",
          "inspectionError": null,
          "installation": "requires_adapter",
          "upstream": {
            "source": {
              "source": "url",
              "url": "https://github.com/langfuse/skills.git",
              "sha": "fc574260e5530b217d94e06465a4da0c7d846888"
            },
            "policy": null
          }
        },
        {
          "id": "anthropic:zyte-web-data",
          "name": "zyte-web-data",
          "displayName": "zyte-web-data",
          "description": "Zyte Web Data for Claude Code",
          "longDescription": "Zyte Web Data for Claude Code",
          "category": "automation",
          "keywords": [],
          "author": {
            "name": "Zyte"
          },
          "version": "0.2.3",
          "license": null,
          "logoUrl": null,
          "darkLogoUrl": null,
          "homepage": "https://github.com/zytedata/claude-skills",
          "sourceUrl": "https://github.com/zytedata/claude-skills/tree/8b2d640fe82fadcb69c12af26e4e38ab8ab61ed1/",
          "skills": [
            {
              "name": "scrape-add-page-object",
              "sourceUrl": "https://github.com/zytedata/claude-skills/blob/8b2d640fe82fadcb69c12af26e4e38ab8ab61ed1/skills/scrape-add-page-object/SKILL.md"
            },
            {
              "name": "scrape-analyze-page",
              "sourceUrl": "https://github.com/zytedata/claude-skills/blob/8b2d640fe82fadcb69c12af26e4e38ab8ab61ed1/skills/scrape-analyze-page/SKILL.md"
            },
            {
              "name": "scrape-codegen-analyze",
              "sourceUrl": "https://github.com/zytedata/claude-skills/blob/8b2d640fe82fadcb69c12af26e4e38ab8ab61ed1/skills/scrape-codegen-analyze/SKILL.md"
            },
            {
              "name": "scrape-codegen-generate",
              "sourceUrl": "https://github.com/zytedata/claude-skills/blob/8b2d640fe82fadcb69c12af26e4e38ab8ab61ed1/skills/scrape-codegen-generate/SKILL.md"
            },
            {
              "name": "scrape-codegen",
              "sourceUrl": "https://github.com/zytedata/claude-skills/blob/8b2d640fe82fadcb69c12af26e4e38ab8ab61ed1/skills/scrape-codegen/SKILL.md"
            },
            {
              "name": "scrape-create-spider",
              "sourceUrl": "https://github.com/zytedata/claude-skills/blob/8b2d640fe82fadcb69c12af26e4e38ab8ab61ed1/skills/scrape-create-spider/SKILL.md"
            },
            {
              "name": "scrape-define",
              "sourceUrl": "https://github.com/zytedata/claude-skills/blob/8b2d640fe82fadcb69c12af26e4e38ab8ab61ed1/skills/scrape-define/SKILL.md"
            },
            {
              "name": "scrape-ensure-project",
              "sourceUrl": "https://github.com/zytedata/claude-skills/blob/8b2d640fe82fadcb69c12af26e4e38ab8ab61ed1/skills/scrape-ensure-project/SKILL.md"
            },
            {
              "name": "scrape-explore-site",
              "sourceUrl": "https://github.com/zytedata/claude-skills/blob/8b2d640fe82fadcb69c12af26e4e38ab8ab61ed1/skills/scrape-explore-site/SKILL.md"
            },
            {
              "name": "scrape-review-schema",
              "sourceUrl": "https://github.com/zytedata/claude-skills/blob/8b2d640fe82fadcb69c12af26e4e38ab8ab61ed1/skills/scrape-review-schema/SKILL.md"
            },
            {
              "name": "scrape-scrapy-cloud",
              "sourceUrl": "https://github.com/zytedata/claude-skills/blob/8b2d640fe82fadcb69c12af26e4e38ab8ab61ed1/skills/scrape-scrapy-cloud/SKILL.md"
            },
            {
              "name": "scrape-spec",
              "sourceUrl": "https://github.com/zytedata/claude-skills/blob/8b2d640fe82fadcb69c12af26e4e38ab8ab61ed1/skills/scrape-spec/SKILL.md"
            },
            {
              "name": "scrape-zyte-api-stats",
              "sourceUrl": "https://github.com/zytedata/claude-skills/blob/8b2d640fe82fadcb69c12af26e4e38ab8ab61ed1/skills/scrape-zyte-api-stats/SKILL.md"
            },
            {
              "name": "scrape-zyte-login",
              "sourceUrl": "https://github.com/zytedata/claude-skills/blob/8b2d640fe82fadcb69c12af26e4e38ab8ab61ed1/skills/scrape-zyte-login/SKILL.md"
            },
            {
              "name": "scrape",
              "sourceUrl": "https://github.com/zytedata/claude-skills/blob/8b2d640fe82fadcb69c12af26e4e38ab8ab61ed1/skills/scrape/SKILL.md"
            }
          ],
          "mcpServers": [],
          "components": ["skills"],
          "componentInspection": "repository",
          "inspectionError": null,
          "installation": "requires_adapter",
          "upstream": {
            "source": {
              "source": "url",
              "url": "https://github.com/zytedata/claude-skills.git",
              "sha": "8b2d640fe82fadcb69c12af26e4e38ab8ab61ed1"
            },
            "policy": null
          }
        },
        {
          "id": "anthropic:activecampaign",
          "name": "activecampaign",
          "displayName": "activecampaign",
          "description": "Marketing automation, CRM, and email marketing powered by ActiveCampaign. Manage contacts, campaigns, automations, deals, and get AI-powered marketing insights — all from Claude.",
          "longDescription": "Marketing automation, CRM, and email marketing powered by ActiveCampaign. Manage contacts, campaigns, automations, deals, and get AI-powered marketing insights — all from Claude.",
          "category": "productivity",
          "keywords": ["marketing", "automation", "crm", "email", "campaigns", "deals", "contacts"],
          "author": {
            "name": "ActiveCampaign",
            "email": "amurrey@activecampaign.com",
            "url": "https://www.activecampaign.com"
          },
          "version": "0.3.1",
          "license": "MIT",
          "logoUrl": null,
          "darkLogoUrl": null,
          "homepage": "https://www.activecampaign.com",
          "sourceUrl": "https://github.com/ActiveCampaign/activecampaign-plugin/tree/0ff858728bc52aee335d5475b0d4eb5f3a9589b0/",
          "skills": [
            {
              "name": "automation-builder",
              "sourceUrl": "https://github.com/ActiveCampaign/activecampaign-plugin/blob/0ff858728bc52aee335d5475b0d4eb5f3a9589b0/skills/automation-builder/SKILL.md"
            },
            {
              "name": "campaign-strategist",
              "sourceUrl": "https://github.com/ActiveCampaign/activecampaign-plugin/blob/0ff858728bc52aee335d5475b0d4eb5f3a9589b0/skills/campaign-strategist/SKILL.md"
            },
            {
              "name": "contact-operations",
              "sourceUrl": "https://github.com/ActiveCampaign/activecampaign-plugin/blob/0ff858728bc52aee335d5475b0d4eb5f3a9589b0/skills/contact-operations/SKILL.md"
            },
            {
              "name": "deals-crm",
              "sourceUrl": "https://github.com/ActiveCampaign/activecampaign-plugin/blob/0ff858728bc52aee335d5475b0d4eb5f3a9589b0/skills/deals-crm/SKILL.md"
            },
            {
              "name": "deliverability-advisor",
              "sourceUrl": "https://github.com/ActiveCampaign/activecampaign-plugin/blob/0ff858728bc52aee335d5475b0d4eb5f3a9589b0/skills/deliverability-advisor/SKILL.md"
            },
            {
              "name": "reporting-analyst",
              "sourceUrl": "https://github.com/ActiveCampaign/activecampaign-plugin/blob/0ff858728bc52aee335d5475b0d4eb5f3a9589b0/skills/reporting-analyst/SKILL.md"
            }
          ],
          "mcpServers": [
            {
              "requiresConfiguration": false,
              "name": "activecampaign",
              "transport": "http",
              "endpoint": "${user_config.server_url}"
            }
          ],
          "components": ["skills", "mcp", "agents", "commands"],
          "componentInspection": "repository",
          "inspectionError": null,
          "installation": "requires_adapter",
          "upstream": {
            "source": {
              "source": "url",
              "url": "https://github.com/ActiveCampaign/activecampaign-plugin.git",
              "sha": "0ff858728bc52aee335d5475b0d4eb5f3a9589b0"
            },
            "policy": null
          }
        },
        {
          "id": "anthropic:hubspot-sales",
          "name": "hubspot-sales",
          "displayName": "hubspot-sales",
          "description": "HubSpot sales workflows: contact import, call prep, daily brief, follow-up drafting, call logging, contact lookup, and pipeline overview",
          "longDescription": "HubSpot sales workflows: contact import, call prep, daily brief, follow-up drafting, call logging, contact lookup, and pipeline overview",
          "category": "productivity",
          "keywords": [
            "hubspot",
            "sales",
            "crm",
            "outreach",
            "call-prep",
            "daily-brief",
            "log-call",
            "contact-lookup",
            "pipeline-pulse"
          ],
          "author": {
            "name": "HubSpot"
          },
          "version": "2.2.0",
          "license": null,
          "logoUrl": null,
          "darkLogoUrl": null,
          "homepage": "https://www.hubspot.com",
          "sourceUrl": "https://github.com/HubSpot/hubspot-mcp-plugins/tree/843d5a38f82cdc1b275baf4953a659be0ad41247/HubSpot-Sales",
          "skills": [
            {
              "name": "call-prep",
              "sourceUrl": "https://github.com/HubSpot/hubspot-mcp-plugins/blob/843d5a38f82cdc1b275baf4953a659be0ad41247/HubSpot-Sales/skills/call-prep/SKILL.md"
            },
            {
              "name": "contact-lookup",
              "sourceUrl": "https://github.com/HubSpot/hubspot-mcp-plugins/blob/843d5a38f82cdc1b275baf4953a659be0ad41247/HubSpot-Sales/skills/contact-lookup/SKILL.md"
            },
            {
              "name": "daily-brief",
              "sourceUrl": "https://github.com/HubSpot/hubspot-mcp-plugins/blob/843d5a38f82cdc1b275baf4953a659be0ad41247/HubSpot-Sales/skills/daily-brief/SKILL.md"
            },
            {
              "name": "follow-up",
              "sourceUrl": "https://github.com/HubSpot/hubspot-mcp-plugins/blob/843d5a38f82cdc1b275baf4953a659be0ad41247/HubSpot-Sales/skills/follow-up/SKILL.md"
            },
            {
              "name": "hubspot",
              "sourceUrl": "https://github.com/HubSpot/hubspot-mcp-plugins/blob/843d5a38f82cdc1b275baf4953a659be0ad41247/HubSpot-Sales/skills/hubspot/SKILL.md"
            },
            {
              "name": "import-contacts",
              "sourceUrl": "https://github.com/HubSpot/hubspot-mcp-plugins/blob/843d5a38f82cdc1b275baf4953a659be0ad41247/HubSpot-Sales/skills/import-contacts/SKILL.md"
            },
            {
              "name": "log-call",
              "sourceUrl": "https://github.com/HubSpot/hubspot-mcp-plugins/blob/843d5a38f82cdc1b275baf4953a659be0ad41247/HubSpot-Sales/skills/log-call/SKILL.md"
            },
            {
              "name": "onboarding",
              "sourceUrl": "https://github.com/HubSpot/hubspot-mcp-plugins/blob/843d5a38f82cdc1b275baf4953a659be0ad41247/HubSpot-Sales/skills/onboarding/SKILL.md"
            },
            {
              "name": "pipeline-pulse",
              "sourceUrl": "https://github.com/HubSpot/hubspot-mcp-plugins/blob/843d5a38f82cdc1b275baf4953a659be0ad41247/HubSpot-Sales/skills/pipeline-pulse/SKILL.md"
            }
          ],
          "mcpServers": [
            {
              "requiresConfiguration": false,
              "name": "hubspot",
              "transport": "http",
              "endpoint": "https://mcp.hubspot.com/anthropic"
            }
          ],
          "components": ["skills", "mcp", "agents"],
          "componentInspection": "repository",
          "inspectionError": null,
          "installation": "requires_adapter",
          "upstream": {
            "source": {
              "source": "git-subdir",
              "url": "https://github.com/HubSpot/hubspot-mcp-plugins.git",
              "path": "HubSpot-Sales",
              "ref": "main",
              "sha": "843d5a38f82cdc1b275baf4953a659be0ad41247"
            },
            "policy": null
          }
        }
      ]
    }
  ]
}
